/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',

    'BlurAdmin.pages.enterprise',
    'BlurAdmin.pages.QD1450',
    'BlurAdmin.pages.electricInvoice',
    'BlurAdmin.pages.reports',
    'BlurAdmin.pages.lists',
    'BlurAdmin.pages.systemManagement',
    'BlurAdmin.pages.dashboard',

    'BlurAdmin.pages.services',
    'BlurAdmin.pages.config',
    'BlurAdmin.pages.main',
    'BlurAdmin.pages.form',
    'BlurAdmin.pages.tables',
    'BlurAdmin.pages.charts',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.authSignIn',
    'BlurAdmin.pages.messageLicense',
    'BlurAdmin.pages.ND70',

  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/authSignIn');
  }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignUp', {
        url: '/authSignUp',
        templateUrl: 'app/pages/authSignUp/authSignUp.html',
        title: 'My Page',
        controller: 'authSignUpCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignIn', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignIn', {
        url: '/authSignIn',
        templateUrl: 'app/pages/authSignIn/authSignIn.html',
        title: 'My Page',
        controller: 'authSignInCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      })
  }

})();
(function() {
    'use strict';
  
    angular.module('BlurAdmin.pages.messageLicense', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('messageLicense', {
                url: '/messageLicense',
                templateUrl: 'app/pages/authSignIn/messageLicense.html',
                controller: 'MessageLicensePageCtrl',
                sidebarMeta: {
                    order: 900,
                },
                authenticate: false
            })
    }
  
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        //title: 'Charts',
        // sidebarMeta: {
        //   icon: 'ion-stats-bars',
        //   order: 150,
        // },
        authenticate: true
      });
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author Nguyen Huu Tuan
 * created on 13.08.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.enterprise', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.enterprise', {
            url: '/enterprise',
            template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            controller: 'EnterprisePageCtrl',
            title: 'Doanh nghiệp',
            sidebarMeta: {
              icon: 'ion-bookmark',
              order: 10,
            },
            authenticate: true
          })
          .state('main.enterprise.Message100', {
            url: '^/Message100',
            templateUrl: 'app/pages/QD1450/Message100/Message100.html',
            title: 'Đăng ký TT sử dụng HĐĐT',
            controller: 'Message100Ctrl',
            sidebarMeta: {
              order: 11,
            },
            authenticate: true
          })
          .state('main.enterprise.registerInformation', {
            url: '^/registerInformation',
            templateUrl: 'app/pages/enterprise/registerInformation/registerInformation.html',
            title: 'Thông tin doanh nghiệp',
            controller: 'RegisterInformationPageCtrl',
            sidebarMeta: {
              order: 12,
            },
            authenticate: true
          })
          .state('main.enterprise.invoiceTemplate', {
            url: '^/invoiceTemplate',
            templateUrl: 'app/pages/enterprise/invoiceTemplate/invoiceTemplate.html',
            title: 'Mẫu hóa đơn điện tử',
            controller: 'InvoiceTemplatePageCtrl',
            sidebarMeta: {
              order: 12,
            },
            authenticate: true
          })
          // .state('main.enterprise.branch',
          // {
          //   url: '^/branch',
          //   templateUrl: 'app/pages/enterprise/branch/branch.html',
          //   title: 'Chi nhánh',
          //   sidebarMeta: {
          //     order: 13,
          //   },
          //   authenticate: true
          // })
          // .state('main.enterprise.branchInvoice',
          // {
          //   url: '^/branchInvoice',
          //   templateUrl: 'app/pages/enterprise/branchInvoice/branchInvoice.html',
          //   title: 'Hóa đơn chi nhánh',
          //   sidebarMeta: {
          //     order: 14,
          //   },
          //   authenticate: true
          // })
          .state('main.enterprise.createInvoiceTemplate',
          {
            url: '^/createInvoiceTemplate',
            templateUrl: 'app/pages/enterprise/invoiceTemplate/createInvoiceTemplate.html',
            controller: 'UpdateInvoiceTemplatePageCtrl',
            title: 'Mẫu hóa đơn điện tử',
            authenticate: true
          })
          ;
          // .state('main.enterprise.createBranch',
          // {
          //   url: '^/createBranch',
          //   templateUrl: 'app/pages/enterprise/branch/createBranch.html',
          //   title: 'Chi nhánh',
          //   authenticate: true
          // })
          // .state('main.enterprise.createBranchInvoice',
          // {
          //   url: '^/createBranchInvoice',
          //   templateUrl: 'app/pages/enterprise/branchInvoice/createBranchInvoice.html',
          //   title: 'Hóa đơn chi nhánh',
          //   authenticate: true
          // });
    }
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 13.08.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.electricInvoice', ['ui.select', 'ngSanitize'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.electricInvoice', {
                url: '/electricInvoice',
                template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'Hóa đơn điện tử',
                sidebarMeta: {
                    icon: 'ion-compose',
                    order: 20,
                },
                authenticate: true
            })
            /**
             .state('main.electricInvoice.invoiceQueue', {
                url: '^/invoiceQueue',
                templateUrl: 'app/pages/electricInvoice/invoiceQueue/invoiceQueue.html',
                title: 'Tạo lập hóa đơn',
                controller: 'InvoiceQueuePageCtrl',
                sidebarMeta: {
                    order: 21,
                },
                authenticate: true
            })
            */
            /**
             .state('main.electricInvoice.checkInvoiceBook', {
                url: '^/checkInvoiceBook',
                templateUrl: 'app/pages/electricInvoice/checkInvoiceBook/checkInvoiceBook.html',
                title: 'Kiểm tra bảng kê',
                controller: 'CheckInvoiceBookPageCtrl',
                sidebarMeta: {
                    order: 22,
                },
                authenticate: true
            })
            .state('main.electricInvoice.invoiceWait4Approve', {
                url: '^/invoiceWait4Approve',
                templateUrl: 'app/pages/electricInvoice/invoiceWait4Approve/invoiceWait4Approve.html',
                title: 'Hóa đơn chờ duyệt',
                controller: 'InvoiceWait4ApprovePageCtrl',
                sidebarMeta: {
                    order: 23,
                },
                authenticate: true
            }) */
            .state('main.electricInvoice.invoiceApproved', {
                url: '^/invoiceApproved',
                templateUrl: 'app/pages/electricInvoice/invoiceApproved/invoiceApproved.html',
                title: 'Danh sách hóa đơn',
                controller: 'InvoiceApprovedPageCtrl',
                sidebarMeta: {
                    order: 24,
                },
                authenticate: true
            })
            .state('main.electricInvoice.editInvoiceMain',
                {
                    url: '^/editInvoiceMain',
                    templateUrl: 'app/pages/electricInvoice/invoiceMain/editInvoiceMain.html',
                    controller: 'EditInvoiceMainPageCtrl',
                    title: 'Xử lý hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.createInvoice',
                {
                    url: '^/createInvoice',
                    templateUrl: 'app/pages/electricInvoice/invoiceQueue/createInvoice.html',
                    controller: 'CreateInvoicePageCtrl',
                    title: 'Hóa đơn điện tử',
                    authenticate: true
                })
            .state('main.electricInvoice.adjustInvoice',
                {
                    url: '^/adjustInvoice',
                    templateUrl: 'app/pages/electricInvoice/adjustInvoice/adjustInvoice.html',
                    controller: 'AdjustInvoicePageCtrl',
                    title: 'Lập mới hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.adjustBusinessInvoice',
                {
                    url: '^/adjustBusinessInvoice',
                    templateUrl: 'app/pages/electricInvoice/businessInvoice/adjustBusinessInvoice.html',
                    controller: 'AdjustBusinessInvoicePageCtrl',
                    title: 'Lập mới hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.businessInvoice', {
                url: '^/businessInvoice',
                templateUrl: 'app/pages/electricInvoice/businessInvoice/businessInvoice.html',
                title: 'Danh sách',
                controller: 'BusinessInvoicePageCtrl',
                sidebarMeta: {
                    order: 25,
                },
                authenticate: true
            })
            .state('main.electricInvoice.createBusinessInvoice',
                {
                    url: '^/createBusinessInvoice',
                    templateUrl: 'app/pages/electricInvoice/businessInvoice/createBusinessInvoice.html',
                    controller: 'CreateBusinessInvoicePageCtrl',
                    title: 'Hóa đơn điện tử',
                    authenticate: true
                })
            .state('main.electricInvoice.editBusinessInvoice',
                {
                    url: '^/editBusinessInvoice',
                    templateUrl: 'app/pages/electricInvoice/businessInvoice/editBusinessInvoice.html',
                    controller: 'EditBusinessInvoicePageCtrl',
                    title: 'Hóa đơn điện tử',
                    authenticate: true
                })
            //QD 1450 TCT
            .state('main.electricInvoice.Invoice1450', {
                url: '^/Invoice1450',
                templateUrl: 'app/pages/electricInvoice/Invoice1450/Invoice1450.html',
                title: 'Hóa đơn TT78',
                controller: 'Invoice1450Ctrl',
                sidebarMeta: {
                    order: 25,
                },
                authenticate: true
            })
            .state('main.electricInvoice.NewInvoice1450',
                {
                    url: '^/NewInvoice1450',
                    templateUrl: 'app/pages/electricInvoice/Invoice1450/NewInvoice1450.html',
                    controller: 'NewInvoice1450Ctrl',
                    title: 'Hóa đơn điện tử -> Thông tin hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.EditInvoice1450',
                {
                    url: '^/EditInvoice1450',
                    templateUrl: 'app/pages/electricInvoice/Invoice1450/EditInvoice1450.html',
                    controller: 'EditInvoice1450Ctrl',
                    title: 'Hóa đơn điện tử -> Thông tin hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.AdjustInvoice1450',
                {
                    url: '^/AdjustInvoice1450',
                    templateUrl: 'app/pages/electricInvoice/Invoice1450/AdjustInvoice1450.html',
                    controller: 'AdjustInvoice1450Ctrl',
                    title: 'Hóa đơn điện tử -> Xử lý hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.ReferenceInvoice',
                {
                    url: '^/ReferenceInvoice',
                    templateUrl: 'app/pages/electricInvoice/Invoice1450/ReferenceInvoice.html',
                    controller: 'ReferenceInvoiceCtrl',
                    title: 'Hóa đơn điện tử -> Hóa đơn điều chỉnh / TT',
                    authenticate: true
                })

            /* THIENVM ADD 03/10/2022 */
            //Hủy hóa đơn TT78
            .state('main.electricInvoice.HuyHoaDon', {
                url: '^/HuyHoaDon',
                templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/HuyHoaDon.html',
                title: 'Hóa đơn Hủy',
                controller: 'HuyHoaDonCtrl',
                sidebarMeta: {
                    order: 30,
                },
                authenticate: true
            })
            //Hóa đơn điều chỉnh
            .state('main.electricInvoice.HoaDonADJUST', {
                url: '^/HoaDonDieuChinh',
                params: { "Module": "ADJUST" },
                templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/HoaDonDieuChinh.html',
                title: 'Hóa đơn Điều Chỉnh',
                controller: 'HoaDonDieuChinhCtrl',
                sidebarMeta: {
                    order: 31,
                },
                authenticate: true
            })
            //Hóa đơn thay thế
            .state('main.electricInvoice.HoaDonREPLACE', {
                url: '^/HoaDonThayThe',
                params: { "Module": "REPLACE" },
                templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/HoaDonThayThe.html',
                title: 'Hóa đơn Thay thế',
                controller: 'HoaDonThayTheCtrl',
                sidebarMeta: {
                    order: 32,
                },
                authenticate: true
            })
            //Hủy hóa đơn TT78
            .state('main.electricInvoice.DanhSachSaiSot', {
                url: '^/DanhSachSaiSot',
                templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/DanhSachSaiSot.html',
                title: 'Gửi danh sách hóa đơn sai sót',
                controller: 'DanhSachSaiSotCtrl',
                sidebarMeta: {
                    order: 33,
                },
                authenticate: true
            })
            .state('main.electricInvoice.CreateDanhSachSaiSot',
                {
                    url: '^/CreateDanhSachSaiSot',
                    templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/CreateDanhSachSaiSot.html',
                    controller: 'CreateDanhSachSaiSotCtrl',
                    title: 'Gửi danh sách hóa đơn sai sót',
                    authenticate: true
                })
            .state('main.electricInvoice.BienLai', {
                url: '^/BienLai',
                templateUrl: 'app/pages/electricInvoice/BienLaiToKhai/BienLai.html',
                title: 'Biên lai phí, lệ phí',
                controller: 'BienLaiCtrl',
                sidebarMeta: {
                    order: 34,
                },
                authenticate: true
            })
            .state('main.electricInvoice.CreateBienLai',
                {
                    url: '^/CreateBienLai',
                    templateUrl: 'app/pages/electricInvoice/BienLaiToKhai/CreateBienLai.html',
                    controller: 'CreateBienLaiCtrl',
                    title: 'Biên lai phí, lệ phí',
                    authenticate: true
                })
            .state('main.electricInvoice.ToKhaiThueTNCN', {
                url: '^/ToKhaiThueTNCN',
                templateUrl: 'app/pages/electricInvoice/BienLaiToKhai/ToKhaiThueTNCN.html',
                title: 'Tờ khai thuế TNCN',
                controller: 'ToKhaiThueTNCNCtrl',
                sidebarMeta: {
                    order: 35,
                },
                authenticate: true
            })
            .state('main.electricInvoice.CreateToKhaiThueTNCN',
                {
                    url: '^/CreateToKhaiThueTNCN',
                    templateUrl: 'app/pages/electricInvoice/BienLaiToKhai/CreateToKhaiThueTNCN.html',
                    controller: 'CreateToKhaiThueTNCNCtrl',
                    title: 'Tờ khai thuế TNCN',
                    authenticate: true
                })
            .state('main.electricInvoice.CreateHuyHoaDon',
                {
                    url: '^/CreateHuyHoaDon',
                    templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/CreateHuyHoaDon.html',
                    controller: 'CreateHuyHoaDonCtrl',
                    title: 'Hủy hóa đơn',
                    authenticate: true
                })
            .state('main.electricInvoice.SearchHoaDon',
                {
                    url: '^/SearchHoaDon',
                    templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/SearchHoaDon.html',
                    controller: 'SearchHoaDonCtrl',
                    title: 'Tìm hóa đơn để thay đổi',
                    authenticate: true
                })

            .state('main.electricInvoice.CreateHoaDonADJUST',
                {
                    url: '^/CreateHoaDonDieuChinh/:Module',
                    params: { "Module": "ADJUST" },
                    templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/CreateHoaDonDieuChinh.html',
                    controller: 'CreateHoaDonDieuChinhCtrl',
                    title: 'Hóa đơn Sai sót TT78',
                    authenticate: true
                })
            .state('main.electricInvoice.CreateHoaDonREPLACE',
                {
                    url: '^/CreateHoaDonDieuChinh/:Module',
                    params: { "Module": "REPLACE" },
                    templateUrl: 'app/pages/electricInvoice/HoaDonThayDoi/CreateHoaDonDieuChinh.html',
                    controller: 'CreateHoaDonDieuChinhCtrl',
                    title: 'Hóa đơn thay thế TT78',
                    authenticate: true
                })

            /*   TÀI SẢN CÔNG */
            //QD 1450 TCT
            .state('main.electricInvoice.Invoice1450_TSCONG', {
                url: '^/Invoice1450_TSCONG',
                templateUrl: 'app/pages/electricInvoice/Invoice1450_TSCONG/Invoice1450_TSCONG.html',
                title: 'Hóa đơn bán TS Công',
                controller: 'Invoice1450_TSCONGCtrl',
                sidebarMeta: {
                    order: 36,
                },
                authenticate: true
            })
            .state('main.electricInvoice.NewInvoice1450_TSCONG',
                {
                    url: '^/NewInvoice1450_TSCONG',
                    params: { "Module": "TSCONG" },
                    templateUrl: 'app/pages/electricInvoice/Invoice1450_TSCONG/NewInvoice1450_TSCONG.html',
                    controller: 'NewInvoice1450_TSCONGCtrl',
                    title: 'Hóa đơn điện tử -> Thông tin hóa đơn bán tài sản công',
                    authenticate: true
                })
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.form', {
        url: '/form',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Form Elements',
        // sidebarMeta: {
        //   icon: 'ion-compose',
        //   order: 250,
        // },
        authenticate: true
      })
      .state('main.form.inputs', {
        url: '/inputs',
        templateUrl: 'app/pages/form/inputs/inputs.html',
        title: 'Form Inputs',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      })
      .state('main.form.layouts', {
        url: '/layouts',
        templateUrl: 'app/pages/form/layouts/layouts.html',
        title: 'Form Layouts',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      })
      .state('main.form.wizard', {
        url: '/wizard',
        templateUrl: 'app/pages/form/wizard/wizard.html',
        controller: 'WizardCtrl',
        controllerAs: 'vm',
        title: 'Form Wizard',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 13.08.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.lists', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.lists', {
                url: '/lists',
                templateUrl: 'app/pages/lists/lists.html',
                /*
                template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,*/
                title: 'Danh mục',
                sidebarMeta: {
                    icon: 'fa fa-book',
                    order: 40,
                },
                authenticate: true
            })
    
            //CATEGORY
            .state('main.category',
            {
                url: '^/category',
                templateUrl: 'app/pages/lists/category/category.html',
                controller: 'CategoryPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            .state('main.createCategory',
            {
                url: '^/createCategory',
                templateUrl: 'app/pages/lists/category/createCategory.html',
                controller: 'UpdateCategoryPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //GOOD AND SERVICE
            .state('main.goodAndService',
            {
                url: '^/goodAndService',
                templateUrl: 'app/pages/lists/goodAndService/goodAndService.html',
                controller: 'GoodAndServicePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createGoodAndService',
            {
                url: '^/createGoodAndService',
                templateUrl: 'app/pages/lists/goodAndService/createGoodAndService.html',
                controller: 'UpdateGoodAndServicePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //TYPE OF INVOICE
            .state('main.typeOfInvoice',
            {
                url: '^/typeOfInvoice',
                templateUrl: 'app/pages/lists/typeOfInvoice/typeOfInvoice.html',
                controller: 'TypeOfInvoicePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            .state('main.createTypeOfInvoice',
            {
                url: '^/createTypeOfInvoice',
                templateUrl: 'app/pages/lists/typeOfInvoice/createTypeOfInvoice.html',
                controller: 'UpdateTypeOfInvoicePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //TEMPLATE
            .state('main.template',
            {
                url: '^/template',
                templateUrl: 'app/pages/lists/template/template.html',
                controller: 'TemplatePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            .state('main.createTemplate',
            {
                url: '^/createTemplate',
                templateUrl: 'app/pages/lists/template/createTemplate.html',
                controller: 'UpdateTemplatePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //CUSTOMER
            .state('main.customer',
            {
                url: '^/customer',
                templateUrl: 'app/pages/lists/customer/customer.html',
                controller: 'CustomerPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            .state('main.createCustomer',
            {
                url: '^/createCustomer',
                templateUrl: 'app/pages/lists/customer/createCustomer.html',
                controller: 'UpdateCustomerPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //SUPPLIER
            .state('main.supplier',
            {
                url: '^/supplier',
                templateUrl: 'app/pages/lists/supplier/supplier.html',
                controller: 'SupplierPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            .state('main.createSupplier',
            {
                url: '^/createSupplier',
                templateUrl: 'app/pages/lists/supplier/createSupplier.html',
                controller: 'UpdateSupplierPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //UNIT
            .state('main.unit',
            {
                url: '^/unit',
                templateUrl: 'app/pages/lists/unit/unit.html',
                controller: 'UnitPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createUnit',
            {
                url: '^/createUnit',
                templateUrl: 'app/pages/lists/Unit/createUnit.html',
                controller: 'UpdateUnitPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //TYPE OF PAYMENT
            .state('main.typeOfPayment',
            {
                url: '^/typeOfPayment',
                templateUrl: 'app/pages/lists/typeOfPayment/typeOfPayment.html',
                controller: 'TypeOfPaymentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createTypeOfPayment',
            {
                url: '^/createTypeOfPayment',
                templateUrl: 'app/pages/lists/typeOfPayment/createTypeOfPayment.html',
                controller: 'UpdateTypeOfPaymentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //CURRENCY OF PAYMENT
            .state('main.currencyOfPayment',
            {
                url: '^/currencyOfPayment',
                templateUrl: 'app/pages/lists/currencyOfPayment/currencyOfPayment.html',
                controller: 'CurrencyOfPaymentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createCurrencyOfPayment',
            {
                url: '^/createCurrencyOfPayment',
                templateUrl: 'app/pages/lists/currencyOfPayment/createCurrencyOfPayment.html',
                controller: 'UpdateCurrencyOfPaymentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            //TAX AUTHORITY
            .state('main.taxAuthority',
            {
                url: '^/taxAuthority',
                templateUrl: 'app/pages/lists/taxAuthority/taxAuthority.html',
                controller: 'TaxAuthorityPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createTaxAuthority',
            {
                url: '^/createTaxAuthority',
                templateUrl: 'app/pages/lists/taxAuthority/createTaxAuthority.html',
                controller: 'UpdateTaxAuthorityPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            
            //DOCUMENT
            .state('main.document',
            {
                url: '^/document',
                templateUrl: 'app/pages/lists/document/document.html',
                controller: 'DocumentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.updateDocument',
            {
                url: '^/updateDocument',
                templateUrl: 'app/pages/lists/document/updateDocument.html',
                controller: 'UpdateDocumentPageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
            
            //TYPE OF REVENUE
            .state('main.typeOfRevenue',
            {
                url: '^/typeOfRevenue',
                templateUrl: 'app/pages/lists/typeOfRevenue/typeOfRevenue.html',
                controller: 'TypeOfRevenuePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })
    
            .state('main.createTypeOfRevenue',
            {
                url: '^/createTypeOfRevenue',
                templateUrl: 'app/pages/lists/typeOfRevenue/createTypeOfRevenue.html',
                controller: 'UpdateTypeOfRevenuePageCtrl',
                title: 'Danh mục',
                authenticate: true
            })

            //DEPARTMENT
            .state('main.department',
            {
                url: '^/department',
                templateUrl: 'app/pages/lists/department/department.html',
                controller: 'DepartmentCtrl',
                title: 'Phòng ban',
                authenticate: true
            })
    
            .state('main.updateDepartment',
            {
                url: '^/updateDepartment',
                templateUrl: 'app/pages/lists/department/updateDepartment.html',
                controller: 'UpdateDepartmentCtrl',
                title: 'Phòng ban',
                authenticate: true
            })
            
            .state('main.manageUserDepartment',
            {
                url: '^/manageUserDepartment',
                templateUrl: 'app/pages/lists/department/manageUserDepartment.html',
                controller: 'ManageUserDepartmentCtrl',
                title: 'Phòng ban',
                authenticate: true
            });
            
    }
})();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.dashboard', {
        url: '^/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Dashboard',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        authenticate: true
      })
      .state('main.detailStep1',
      {
          url: '^/detailStep1',
          templateUrl: 'app/pages/dashboard/am4Chart/detailStep1.html',
          authenticate: true
      })
      .state('main.detailStep2',
      {
          url: '^/detailStep2',
          templateUrl: 'app/pages/dashboard/am4Chart/detailStep2.html',
          authenticate: true
      });
  }

})();
/**
 * @author l.azevedo
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboard',
        authenticate: true


      });
  }

})();
/**
 * @author THIEN VM
 * created on 2025-05-07
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ND70', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ND70', {
        url: '/ND70',
        template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'ND70Ctrl',
        title: 'Chứng từ điện tử',
        sidebarMeta: {
          icon: 'ion-document',
          order: 10,
        },
        authenticate: true
      })
      .state('main.ND70.Message109',
        {
          url: '^/Message109',
          templateUrl: 'app/pages/QD1450/Message109/Message109.html',
          controller: 'Message109Ctrl',
          title: 'Đăng ký TT sử dụng CTĐT',
          sidebarMeta: {
            order: 14,
          },
          authenticate: true
        })
      .state('main.ND70.RegisterInvoice109',
        {
          url: '^/RegisterInvoice109',
          templateUrl: 'app/pages/QD1450/Message109/RegisterInvoice109.html',
          controller: 'RegisterInvoice109Ctrl',
          title: 'Đăng ký/thay đổi thông tin sử dụng Chứng từ điện tử',
          authenticate: true
        })
      .state('main.ND70.CHUNGTU_TNCN',
        {
          url: '^/CHUNGTU_TNCN',
          templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_TNCN.html',
          controller: 'CHUNGTU_TNCNCtrl',
          title: 'Chứng từ khấu trừ thuế TNCN điện tử',
          sidebarMeta: {
            order: 14,
          },
          authenticate: true
        })
      .state('main.ND70.CreateCHUNGTU_TNCN',
        {
          url: '^/CreateCHUNGTU_TNCN',
          templateUrl: 'app/pages/ND70/CHUNGTU/CreateCHUNGTU_TNCN.html',
          controller: 'CreateCHUNGTU_TNCNCtr',
          title: 'Thông tin Chứng từ khấu trừ thuế TNCN điện tử',
          authenticate: true
        })

      //Chứng từ điều chỉnh
      .state('main.ND70.CHUNGTU_DIEUCHINH', {
        url: '^/ChungTuDieuChinh',
        params: { "Module": "ADJUST" },
        templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_DIEUCHINH.html',
        title: 'Chứng từ Điều chỉnh',
        controller: 'CHUNGTU_DIEUCHINHCtrl',
        sidebarMeta: {
          order: 15,
        },
        authenticate: true
      })
      //Chứng từ thay thế
      .state('main.ND70.CHUNGTU_THAYTHE', {
        url: '^/ChungTuThayThe',
        params: { "Module": "REPLACE" },
        templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_THAYTHE.html',
        title: 'Chứng từ Thay thế',
        controller: 'CHUNGTU_DIEUCHINHCtrl',
        sidebarMeta: {
          order: 16,
        },
        authenticate: true
      })
      .state('main.ND70.SearchCHUNGTU_THAYDOI', {
        url: '^/SEARCH_CHUNGTU_THAYDOI',
        // params: { "Module": "REPLACE" },
        templateUrl: 'app/pages/ND70/CHUNGTU/SearchCHUNGTU_THAYDOI.html',
        title: 'Tìm chứng từ cần thay đổi',
        controller: 'SearchCHUNGTU_THAYDOICtrl',
        // sidebarMeta: {
        //   order: 16,
        // },
        authenticate: true
      })
      .state('main.ND70.CreateCHUNGTU_TNCN_THAYDOI', {
        url: '^/CreateCHUNGTU_TNCN_THAYDOI',
        // params: { "Module": "REPLACE" },
        templateUrl: 'app/pages/ND70/CHUNGTU/CreateCHUNGTU_TNCN_THAYDOI.html',
        title: 'Tạo chứng từ cần thay đổi',
        controller: 'CreateCHUNGTU_TNCN_THAYDOICtrl',
        // sidebarMeta: {
        //   order: 16,
        // },
        authenticate: true
      })
      .state('main.ND70.CHUNGTU_DS04', {
        url: '^/DanhSachChungTuSai',
        templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_DANHSACH_04.html',
        title: 'Danh sách 04/SS-CTĐT',
        controller: 'CHUNGTU_DANHSACH_04Ctrl',
        sidebarMeta: {
          order: 20,
        },
        authenticate: true
      })
      .state('main.ND70.CreateCHUNGTU_DS04', {
        url: '^/CreateDanhSachChungTuSai',
        templateUrl: 'app/pages/ND70/CHUNGTU/CreateCHUNGTU_DANHSACH_04.html',
        title: 'Tạo danh sách 04/SS-CTĐT',
        controller: 'CreateCHUNGTU_DANHSACH_04Ctr',
        authenticate: true
      })
      .state('main.ND70.CHUNGTU_GUI_CQT', {
        url: '^/CHUNGTU_GUI_CQT',
        templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_GUI_CQT.html',
        title: 'Gửi CT đến CQT',
        controller: 'CHUNGTU_GUI_CQTCtrl',
        sidebarMeta: {
          order: 17,
        },
        authenticate: true
      })
      .state('main.ND70.CHUNGTU_NHANKQ_TCT', {
        url: '^/CHUNGTU_NHANKQ',
        templateUrl: 'app/pages/ND70/CHUNGTU/CHUNGTU_NHANKQ_TCT.html',
        title: 'Nhận KQ từ CQT',
        controller: 'CHUNGTU_NHANKQ_TCTCtrl',
        sidebarMeta: {
          order: 18,
        },
        authenticate: true
      })

  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        authenticate: true
      });
  }

})();
/**
 * @author Nguyen Huu Tuan
 * created on 03.12.2021
 */
 (function () {
    'use strict';

    angular.module('BlurAdmin.pages.QD1450', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            // .state('main.QD1450', {
            //     url: '/QD1450',
            //     templateUrl: 'app/pages/QD1450/QD1450.html',
            //     title: 'Đăng ký HĐĐT',
            //     sidebarMeta: {
            //         icon: 'fa fa-archive',
            //         order: 1,
            //     },
            //     authenticate: true
            // })
            .state('main.Message100',
            {
                url: '^/Message100',
                templateUrl: 'app/pages/QD1450/Message100/Message100.html',
                controller: 'Message100Ctrl',
                title: 'Đăng ký/thay đổi thông tin sử dụng HĐĐT',
                authenticate: true
            })
            .state('main.RegisterInvoice',
            {
                url: '^/RegisterInvoice',
                templateUrl: 'app/pages/QD1450/Message100/RegisterInvoice.html',
                controller: 'RegisterInvoiceCtrl',
                title: 'Đăng ký/thay đổi thông tin sử dụng HĐĐT',
                authenticate: true
            })
            .state('main.Message106',
            {
                url: '^/Message106',
                templateUrl: 'app/pages/QD1450/Message106/Message106.html',
                controller: 'Message106Ctrl',
                title: 'Đề nghị cấp hóa đơn điện tử có mã của Cơ quan Thuế',
                authenticate: true
            })
            .state('main.Receive102103',
            {
                url: '^/Receive102103',
                templateUrl: 'app/pages/QD1450/Receive102103/Receive102103.html',
                controller: 'Receive102103Ctrl',
                title: 'Kết quả từ Cơ quan Thuế',
                authenticate: true
            })
            .state('main.SendReceiveLog',
            {
                url: '^/SendReceiveLog',
                templateUrl: 'app/pages/QD1450/SendReceiveLog/SendReceiveLog.html',
                controller: 'SendReceiveLogCtrl',
                title: 'Nhật ký truyền nhận',
                authenticate: true
            })
            ;
    }

})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 15.08.2018
 */

(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.reports', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.reports', {
                url: '/reports',
                templateUrl: 'app/pages/reports/reports.html',
                title: 'Báo cáo thống kê',
                sidebarMeta: {
                    icon: 'fa fa-bar-chart',
                    order: 30,
                },
                authenticate: true
            })
            .state('main.reportInvoiceDetail',
            {
                url: '^/reportInvoiceDetail',
                templateUrl: 'app/pages/reports/reportInvoiceDetail/reportInvoiceDetail.html',
                controller: 'ReportInvoiceDetailPageCtrl',
                title: 'Thống Kê Chi tiết Hoá đơn',
                authenticate: true
            })
            .state('main.reportMain',
            {
                url: '^/reportMain',
                templateUrl: 'app/pages/reports/reportMain/reportMain.html',
                controller: 'ReportMainPageCtrl',
                title: 'Báo cáo tình hình sử dụng hóa đơn',
                authenticate: true
            })
            .state('main.createReportMain',
            {
                url: '^/createReportMain',
                templateUrl: 'app/pages/reports/reportMain/createReportMain.html',
                controller: 'ReportMainPageCtrl',
                title: 'Báo cáo tình hình sử dụng hóa đơn',
                authenticate: true
            })
            .state('main.statementOfInvoice',
            {
                url: '^/statementOfInvoice',
                templateUrl: 'app/pages/reports/statementOfInvoice/statementOfInvoice.html',
                controller: 'StatementOfInvoicePageCtrl',
                title: 'Bảng kê hóa đơn bán ra',
                authenticate: true
            })
            .state('main.inventoryInvoice',
            {
                url: '^/inventoryInvoice',
                templateUrl: 'app/pages/reports/inventoryInvoice/inventoryInvoice.html',
                controller: 'InventoryInvoicePageCtrl',
                title: 'Quản lý kho hóa đơn',
                authenticate: true
            })
            .state('main.statisticChart',
            {
                url: '^/statisticChart',
                templateUrl: 'app/pages/reports/statisticChart/statisticChart.html',
                controller: 'StatisticChartPageCtrl',
                title: 'Biểu đồ theo Hóa đơn và Doanh thu',
                authenticate: true
            })
            .state('main.typeOfInvoiceChart',
            {
                url: '^/typeOfInvoiceChart',
                templateUrl: 'app/pages/reports/typeOfInvoiceChart/typeOfInvoiceChart.html',
                //controller: 'TypeOfInvoiceChartPageCtrl',
                title: 'Biểu đồ theo Loại hóa đơn',
                authenticate: true
            });
    }
  
})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        /*sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },*/
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();
/**
 * @author Nguyen Huu Tuan
 * created on 15.08.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.systemManagement', ['ui.select', 'ngSanitize'])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.systemManagement', {
            url: '/systemManagement',
            template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Quản trị hệ thống',
            sidebarMeta: {
              icon: 'ion-settings',
              order: 50,
            },
            authenticate: true,
            //role: 2
          })
          .state('main.systemManagement.users', {
            url: '^/users',
            templateUrl: 'app/pages/systemManagement/users/users.html',
            title: 'Người dùng',
            sidebarMeta: {
              order: 51,
            },
            authenticate: true
          })
          .state('main.systemManagement.createUser', {
            url: '^/createUser',
            templateUrl: 'app/pages/systemManagement/users/createUser.html',
            title: 'Người dùng',
            controller: 'UpdateUserPageCtrl',
            authenticate: true
          })
          .state('main.systemManagement.manageRole', {
            url: '^/manageRole',
            templateUrl: 'app/pages/systemManagement/roles/manageRole.html',
            title: 'Người dùng',
            controller: 'ManageRolePageCtrl',
            authenticate: true
          })
          .state('main.systemManagement.manageUser', {
            url: '^/manageUser',
            templateUrl: 'app/pages/systemManagement/users/manageUser.html',
            title: 'Nhóm người dùng',
            controller: 'ManageUserPageCtrl',
            authenticate: true
          })
          .state('main.systemManagement.roles', {
            url: '^/roles',
            templateUrl: 'app/pages/systemManagement/roles/roles.html',
            title: 'Nhóm người dùng',
            controller: 'RolePageCtrl',
            sidebarMeta: {
              order: 52,
            },
            authenticate: true
          })
          .state('main.systemManagement.createRole', {
            url: '^/createRole',
            templateUrl: 'app/pages/systemManagement/roles/createRole.html',
            title: 'Nhóm người dùng',
            controller: 'UpdateRolePageCtrl',
            authenticate: true
          })
          .state('main.systemManagement.grantPermission',
          {
            url: '^/grantPermission',
            templateUrl: 'app/pages/systemManagement/grantPermission/grantPermission.html',
            title: 'Phân quyền chức năng',
            controller: 'GrantPermissionPageCtrl',
            sidebarMeta: {
              order: 53,
            },
            authenticate: true
          })
          .state('main.systemManagement.organization',
          {
            url: '^/organization',
            templateUrl: 'app/pages/systemManagement/organization/organization.html',
            title: 'Quản lý đơn vị',
            sidebarMeta: {
              order: 0,
            },
            authenticate: true
          })
          .state('main.systemManagement.createOrganization',
          {
            url: '^/createOrganization',
            templateUrl: 'app/pages/systemManagement/organization/createOrganization.html',
            title: 'Quản lý đơn vị',
            controller: 'UpdateOrganizationPageCtrl',
            authenticate: true
          })
          .state('main.systemManagement.manageLicense',
          {
            url: '^/manageLicense',
            templateUrl: 'app/pages/systemManagement/organization/manageLicense.html',
            title: 'Quản lý bản quyền',
            controller: 'ManageLicensePageCtrl',
            authenticate: true
          })
          
          .state('main.systemManagement.configSystem',
          {
            url: '^/configSystem',
            templateUrl: 'app/pages/systemManagement/configSystem/configSystem.html',
            title: 'Cấu hình hệ thống',
            controller: 'ConfigSystemCtrl',
            sidebarMeta: {
              order: 54,
            },
            authenticate: true
          })

          //NHAT KY TRUYEN NHAN
          .state('main.systemManagement.SendReceiveLog',
          {
            url: '^/SendReceiveLog',
            templateUrl: 'app/pages/QD1450/SendReceiveLog/SendReceiveLog.html',
            title: 'Nhật ký truyền nhận',
            controller: 'SendReceiveLogCtrl',
            sidebarMeta: {
              order: 55,
            },
            authenticate: true
          })
          
          ;
    }
})();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'BlurAdmin.theme',
  'BlurAdmin.pages'
]);
;(function (root, factory) {
	if (typeof exports === "object") {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS;

}));
/**
@fileOverview

@toc

*/

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof define === 'function' && define.amd) {
		define(['angular', 'sweetalert'], factory);  // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('angular'), require('sweetalert')); // Node
	} else {
		factory(root.angular, root.swal);					// Browser
	}

}(this, function (angular, swal) {
	"use strict";

	angular.module('oitozero.ngSweetAlert', [])
		.factory('SweetAlert', [ '$rootScope', function ( $rootScope ) {
			//public methods
			var self = {

				swal: function ( arg1, arg2, arg3 ) {
					$rootScope.$evalAsync(function(){
						if( typeof(arg2) === 'function' ) {
							swal( arg1, function(isConfirm){
								$rootScope.$evalAsync( function(){
									arg2(isConfirm);
								});
							}, arg3 );
						} else {
							swal( arg1, arg2, arg3 );
						}
					});
				},
				success: function(title, message) {
					$rootScope.$evalAsync(function(){
						swal( title, message, 'success' );
					});
				},
				error: function(title, message) {
					$rootScope.$evalAsync(function(){
						swal( title, message, 'error' );
					});
				},
				warning: function(title, message) {
					$rootScope.$evalAsync(function(){
						swal( title, message, 'warning' );
					});
				},
				info: function(title, message) {
					$rootScope.$evalAsync(function(){
						swal( title, message, 'info' );
					});
				},
				showInputError: function(message) {
					$rootScope.$evalAsync(function(){
						swal.showInputError( message );
					});
				},
				close: function() {
					$rootScope.$evalAsync(function(){
						swal.close();
					});
				}
			};

			return self;
		}]);
}));




!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button[not:disabled]:hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel[not:disabled]:hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger[not:disabled]:hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    baConfigProvider.changeTheme({blur: true});
    
    baConfigProvider.changeColors({
     default: 'rgba(#000000, 0.2)',
     defaultText: '#ffffff',
     dashboard: {
       white: '#ffffff',
     },
    });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('hostName', {
      // url: 'http://localhost/core.api/',

      // url: 'http://localhost:53336/',
      url: 'https://hoadondientu.vietinfo.tech/',
      DEBUG_MODE: false
    })

    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })

    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        logo: IMAGES_ROOT + 'app/logo/',
        template: IMAGES_ROOT + 'app/template/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function (color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function (color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for (var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();


/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
        // whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blue-bg.jpg'));
        // whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'transblue-bg.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.authSignUp')
    .controller('authSignUpCtrl', authSignUpCtrl);

  /** @ngInject */
  function authSignUpCtrl($scope) {
    var vm = this;

  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.authSignIn')
        .controller('authSignInCtrl', authSignInCtrl);

    /** @ngInject */
    function authSignInCtrl(localStorage, $state, $http, hostName, $scope) {
        var vm = this;
        vm.logar = logar;
    
        init();
    
        function init() {
            localStorage.clear();
        }

        //+++   HIDE / SHOW PASSWORD
        $scope.inputType = 'password';
        $scope.showHideClass = 'glyphicon glyphicon-eye-open';
        $scope.showPassword = function(){
            var _password = angular.element(document).find('#inputPassword')[0];
            if(_password.value != null)
            {
                if($scope.inputType == 'password')
                {
                    $scope.inputType = 'text';
                    $scope.showHideClass = 'glyphicon glyphicon-eye-close';
                }
                else
                {
                    $scope.inputType = 'password';
                    $scope.showHideClass = 'glyphicon glyphicon-eye-open';
                }
            }
        };
        //###   END HIDE / SHOW PASSWORD
    
        function logar() {

            //GET INPUT DATA
            var inputData = {
                'Email': vm.user, 
                'Password': vm.passWord, 
            }

            //CHECK AUTHENTICATION FOR USERS
            $http.post(hostName.url + "api/User/CheckUserAuthentication", inputData )
            .then(function(data) {
                var dadosUser = data.data;

                //CANNOT FOUND USER
                if (dadosUser == null) {  
                    swal({
                        title: "Không tìm thấy người dùng này trong hệ thống, vui lòng kiểm tra lại!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){});
                }

                else { //FOUND USER

                    //IF PASSWORD WRONG
                    if (dadosUser.Password == null) {
                        swal({
                            title: "Mật khẩu không chính xác, vui lòng thử lại, tài khoản sẽ bị khóa nếu sai quá 5 lần!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){});
                    }
                    //CORRECT PASSWORD
                    else {
                        sessionStorage.enterpriseId = dadosUser.enterpriseId;
                        localStorage.setObject('dataUser', dadosUser);

                        //GET LIST USER ROLE OF USER
                        $http({
                            method: "GET",
                            url: hostName.url + "api/UserRole/ListUserRoleByUserId?userId=" + dadosUser.ID
                        }).then(function(data) {
                            localStorage.setObject('dataUserRole', data.data);

                            //GET LIST MENU OF USER WHICH WAS GRANT PEMISSION
                            $http({
                                method: "GET",
                                url: hostName.url + "api/GrantPermission/GetGrantPermission?enterpriseId=" + dadosUser.enterpriseId
                            }).then(function(data) {
                                localStorage.setObject('grantPermission', data.data);

                                //GO TO MAIN PAGE OF SYSTEM
                                $state.go('main.dashboard');
                            }, function(error) {
                                console.log(error);
                                
                            });//#GET LIST MENU OF USER WHICH WAS GRANT PEMISSION

                        }, function(error) {
                            console.log(error);

                        }); //#GET LIST USER ROLE OF USER
                    
                    } //#CHECK PASSWORD
                
                } //#CHECK USER

            }, function(error) {
                console.log(error)

            }); //#CHECK AUTHENTICATION

        } //#logar() function
  
    } //#authSignInCtrl
  
})();
(function() {
    'use strict';
  
    angular.module('BlurAdmin.pages.messageLicense')
        .controller('MessageLicensePageCtrl', MessageLicensePageCtrl);
  
    /** @ngInject */
    function MessageLicensePageCtrl($scope) {

        $scope.messageLicense = sessionStorage.messageLicense;
        console.log(sessionStorage.volumnID);
  
    }
  
  })();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.config')
    .run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart($rootScope, $state, localStorage) {
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      var login = localStorage.getObject('dataUser');
      if (toState.authenticate && _.isEmpty(login)) {
        // User isn’t authenticated
        $state.transitionTo("authSignIn");
        event.preventDefault();
      }
    });
  }

})();
/**
 * @author Nguyen Huu Tuan
 * created on 14.08.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.enterprise')
        .controller('EnterprisePageCtrl', EnterprisePageCtrl);

    angular.module('BlurAdmin.pages.enterprise')
        .controller('SelectEnterprisePageCtrl', SelectEnterprisePageCtrl);
  
    /** @ngInject */
    function EnterprisePageCtrl($scope) {

      $scope.open = function(url) {
          location.href = url;
      };

    }


    //******controller for Select Enterprise******
    function SelectEnterprisePageCtrl($scope, $http, hostName) {
        $scope.Enterprise = [];
  
        var successCallBack = function (response) {
          $scope.Enterprise = response.data;
        };
  
        var errorCallBack = function (reason) {
          $scope.error = reason.data;
          
          console.log(reason);
        }
  
        $http({
          method: "GET",
          url: hostName.url + "api/Enterprise/GetAllEnterprise"
        }).then(successCallBack, errorCallBack);
      }
      //******End controller for Select Enterprise******

  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 14.08.2018
 */
(function () {
    'use strict';

    //declare controller for Lists
    angular.module('BlurAdmin.pages.lists')
        .controller('ListsPageCtrl', ListsPageCtrl);

    //Select City
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectCityPageCtrl', SelectCityPageCtrl);

    //Select Customer
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectCustomerPageCtrl', SelectCustomerPageCtrl);

    //Select Type Of Invoice
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectTypeOfInvoicePageCtrl', SelectTypeOfInvoicePageCtrl);

    //Select Type Of Revenue
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectTypeOfRevenuePageCtrl', SelectTypeOfRevenuePageCtrl);

    //Select Status
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectStatusPageCtrl', SelectStatusPageCtrl);

    //Select Status by Approved
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectStatusByApprovedPageCtrl', SelectStatusByApprovedPageCtrl);

    //Select Invoice Template
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectInvoiceTemplatePageCtrl', SelectInvoiceTemplatePageCtrl);

    //Select Currency Of Payment
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectCurrencyOfPaymentPageCtrl', SelectCurrencyOfPaymentPageCtrl);

    //Select Type Of Payment
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectTypeOfPaymentPageCtrl', SelectTypeOfPaymentPageCtrl);

    //Select Template
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectTemplatePageCtrl', SelectTemplatePageCtrl);

    //Select Category
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectCategoryPageCtrl', SelectCategoryPageCtrl);

    //Select Unit
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectUnitPageCtrl', SelectUnitPageCtrl);

    //Select Good And Service
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectGoodAndServicePageCtrl', SelectGoodAndServicePageCtrl);

    //Select TaxAuthority
    angular.module('BlurAdmin.pages.lists')
        .controller('SelectTaxAuthorityPageCtrl', SelectTaxAuthorityPageCtrl);

    /** @ngInject */
    function ListsPageCtrl($scope) {
        $scope.open = function (url) {
            window.location.href = url;
        };

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) {
                if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
                    $scope.isShow = true;
            };
        }

        if (sessionStorage.enterpriseId == '1644a09a-e9b6-49da-8826-f57d5143bbff') {
            $scope.isShow = true;
        }

    };


    //******controller for Select City******
    function SelectCityPageCtrl($scope, $http, hostName) {
        $scope.City = {};
        $scope.Cities = [];

        var successCallBack = function (response) {
            $scope.Cities = response.data;
            //console.log(response);
        };

        var errorCallBack = function (reason) {
            console.log(reason);

            if ($scope.Cities.length == 0) {
                $scope.Cities = [
                    { cityName: "Hà Nội", cityId: "01" },
                    { cityName: "Hồ Chí Minh", cityId: "79" }
                ];
            };
        }

        $http({
            method: "GET",
            url: hostName.url + "api/City/GetAllCity"
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select City******


    //******controller for Select Customer******
    function SelectCustomerPageCtrl($scope, $http, hostName) {
        $scope.Customers = [];

        var successCallBack = function (response) {
            $scope.Customers = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Customer/ListCustomer?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Customer******


    //******controller for Select TypeOfInvoice******
    function SelectTypeOfInvoicePageCtrl($scope, $http, hostName) {
        $scope.TypeOfInvoices = [];

        var successCallBack = function (response) {
            $scope.TypeOfInvoices = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/TypeOfInvoice/ListTypeOfInvoice?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select TypeOfInvoice******


    //******controller for Select TypeOfRevenue******
    function SelectTypeOfRevenuePageCtrl($scope, $http, hostName) {
        $scope.TypeOfRevenues = [];

        var successCallBack = function (response) {
            $scope.TypeOfRevenues = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?typeOfInvoiceId=0&enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select TypeOfRevenue******


    /******************************************/
    //******controller for Select Status******/
    /******************************************/
    function SelectStatusPageCtrl($scope, $http, hostName) {
        $scope.Statuses = [];

        var successCallBack = function (response) {
            $scope.Statuses = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Status/GetAllStatus?enterpriseId=" + sessionStorage.enterpriseId + "&typeName=ElectricInvoices"
        }).then(successCallBack, errorCallBack);
    }
    function SelectStatusByApprovedPageCtrl($scope, $http, hostName) {
        $scope.Statuses = [];

        var successCallBack = function (response) {
            $scope.Statuses = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Status/GetAllStatusByApproved?enterpriseId=" + sessionStorage.enterpriseId + "&typeName=ElectricInvoices"
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Status******

    /******************************************/
    //******controller for Select InvoiceTemplate******/
    /******************************************/
    function SelectInvoiceTemplatePageCtrl($scope, $http, hostName) {
        $scope.InvoiceTemplates = [];

        var successCallBack = function (response) {
            $scope.InvoiceTemplates = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select InvoiceTemplate******

    /******************************************/
    //******controller for Select CurrencyOfPayment******/
    /******************************************/
    function SelectCurrencyOfPaymentPageCtrl($scope, $http, hostName) {
        $scope.CurrencyOfPayments = [];

        var successCallBack = function (response) {
            $scope.CurrencyOfPayments = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/CurrencyOfPayment/GetAllCurrencyOfPayment?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select CurrencyOfPayment******

    /******************************************/
    //******controller for Select TypeOfPayment******/
    /******************************************/
    function SelectTypeOfPaymentPageCtrl($scope, $http, hostName) {
        $scope.TypeOfPayments = [];

        var successCallBack = function (response) {
            $scope.TypeOfPayments = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/TypeOfPayment/GetAllTypeOfPayment?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select TypeOfPayment******

    //******controller for Select Template******
    function SelectTemplatePageCtrl($scope, $http, hostName) {
        $scope.Templates = [];

        var successCallBack = function (response) {
            $scope.Templates = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Template/GetAllTemplate?isActive=1&enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Template******

    /******************************************/
    //******controller for Category******/
    /******************************************/
    function SelectCategoryPageCtrl($scope, $http, hostName) {
        $scope.Categories = [];

        var successCallBack = function (response) {
            $scope.Categories = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Category/GetAllCategory?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Category******

    /******************************************/
    //******controller for Unit******/
    /******************************************/
    function SelectUnitPageCtrl($scope, $http, hostName) {
        $scope.Units = [];

        var successCallBack = function (response) {
            $scope.Units = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Unit/GetAllUnit?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Unit******

    /******************************************/
    //******controller for GoodAndService******/
    /******************************************/
    function SelectGoodAndServicePageCtrl($scope, $http, hostName) {
        $scope.GoodAndServices = [];

        var successCallBack = function (response) {
            $scope.GoodAndServices = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/GoodAndService/GetAllGoodAndService?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select GoodAndService******

    /******************************************/
    //******controller for TaxAuthority******/
    /******************************************/
    function SelectTaxAuthorityPageCtrl($scope, $http, hostName) {
        $scope.TaxAuthorities = [];

        var successCallBack = function (response) {
            $scope.TaxAuthorities = response.data;
        };

        var errorCallBack = function (reason) {
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthority"
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select TaxAuthority******

})();

/**
 * @author Nguyen Huu Tuan
 * created on 13/06/2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .controller('dashboardCtrl', dashboardCtrl);
  
    /** @ngInject */
    function dashboardCtrl($scope) {

        if (sessionStorage.enterpriseId == undefined || sessionStorage.enterpriseId == "undefined" ) {
            location.href = "/authSignIn";
        }

        var NowADay = new Date();
        $scope.thisYear = NowADay.getFullYear();

    }
  
  })();
/**
 * @author Nguyen Huu Tuan
 * created on 14.08.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ND70')
    .controller('ND70Ctrl', ND70Ctrl);

  // angular.module('BlurAdmin.pages.enterprise')
  //     .controller('SelectEnterprisePageCtrl', SelectEnterprisePageCtrl);

  /** @ngInject */
  function ND70Ctrl($scope) {

    $scope.open = function (url) {
      location.href = url;
    };

  }


  // //******controller for Select Enterprise******
  // function SelectEnterprisePageCtrl($scope, $http, hostName) {
  //     $scope.Enterprise = [];

  //     var successCallBack = function (response) {
  //       $scope.Enterprise = response.data;
  //     };

  //     var errorCallBack = function (reason) {
  //       $scope.error = reason.data;

  //       console.log(reason);
  //     }

  //     $http({
  //       method: "GET",
  //       url: hostName.url + "api/Enterprise/GetAllEnterprise"
  //     }).then(successCallBack, errorCallBack);
  //   }
  //   //******End controller for Select Enterprise******


})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($state, localStorage, $scope, fileReader, $filter, $http, hostName, $rootScope, layoutPaths) {
    //get data of user who authenticated
    var user = localStorage.getObject("dataUser");
    $rootScope.imageFile = undefined;

    if (user.ProfilePicture == null || user.ProfilePicture == '') {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      //console.log($scope.picture);
    }
    else {
      $scope.picture = $filter('profilePicture')(user.ProfilePicture);
    }

    //console.log(user.ProfilePicture);
    //$scope.picture = $filter('profilePicture')(user.ProfilePicture);
    $scope.inputFullName = user.FullName;
    if (user.Birthday != null) {
      var BirthDay = new Date(user.Birthday);
      $scope.inputDateOfBirth = new Date(BirthDay.getFullYear(), BirthDay.getMonth(), BirthDay.getDate());
    }
    $scope.inputPassword = user.Password;
    $scope.inputEmail = user.Email;
    $scope.inputPhone = user.Phone;

    // $scope.removePicture = function () {
    //   $scope.picture = $filter('appImage')('theme/no-photo.png');
    //   $scope.noPicture = true;
    // };

    /** Manage upload File **/
    // $scope.uploadPicture = function () {
    //   var fileInput = document.getElementById('uploadFile');
    //   fileInput.click();
    // };
    // $scope.getFile = function ($scope) {
    //     fileReader.readAsDataUrl($scope.file, $scope).then(function (result) {
    //         var fileName = $scope.file.name;
    //         if ( fileName.indexOf(".jpg") <= 0 && fileName.indexOf(".png") <= 0 
    //                 && fileName.indexOf(".gif") <= 0 ) {
    //             swal({
    //                 title: "Please, choose file image (.jpg, .png, .gif)!",
    //                 icon: "warning",
    //                 button: "Close"
    //             }).then(function(){
    //                 return;
    //             });
    //         }
    //         else {
    //             $scope.picture = result;

    //             var data = new FormData();
    //             data.append("filename", $scope.file.name);
    //             data.append("storagePath", layoutPaths.images.profile);
    //             data.append("file", $scope.file);

    //             $rootScope.imageFileData = data;
    //         }
    //     });
    // };
    /** End Manage upload Picture **/

    //function save User's profile
    $scope.save = function() {

        var FullName = angular.element(document).find('#inputFullName')[0];
        var Email = angular.element(document).find('#inputEmail')[0];
        var Password = angular.element(document).find('#inputPassword')[0];
        var ConfirmPassword = angular.element(document).find('#inputConfirmPassword')[0];
        var DateOfBirth = angular.element(document).find('#inputDateOfBirth')[0];
        var DOB = DateOfBirth.value != '' ? new Date(reConvertJSONDate(DateOfBirth.value)) : '';
        var today = new Date();
        var Phone = angular.element(document).find('#inputPhone')[0];
        
        var flag = true;

        //check empty FullName
        if (FullName.value == '') {
          swal({
            title: "Tên đầy đủ không thể để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            FullName.focus();
          });
          flag = false;
          return;
        }

        //check valid DateOfBirth can not less than 12 years old!
        if (DOB != '' && DOB.getFullYear() > (today.getFullYear() - 18)) {
            swal({
              title: "Năm sinh không hợp lệ!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                DateOfBirth.focus();
            });
            flag = false;
            return;
        }

        //check empty Email
        if (Email.value == '') {
            swal({
              title: "Địa chỉ email không thể để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                Email.focus();
            });
            flag = false;
            return;
        }

        //check valid Email
        if (Email.value.indexOf("@") < 1) {
            swal({
              title: "Địa chỉ email không hợp lệ!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                Email.focus();
            });
            flag = false;
            return;
        }

        //check Password must equal ConfirmPassword
        if ( ConfirmPassword.value != '' && !angular.equals(Password.value, ConfirmPassword.value) ) {
            swal({
                title: "Mật khẩu không đúng với mật khẩu lặp lại!",
                icon: "warning",
                button: "Đóng"
            }).then(function(){
              ConfirmPassword.focus();
            });
            flag = false;
            return;
        }

        //function call when success
        function successCallBack(data) {

          //get user data and reset to user object
          $http({
            method: "GET",
            url: hostName.url + "api/User/GetUser?ID=" + user.ID,
          }).then(function(response) {
            var dataUser = response.data;
            //console.log(dataUser);
            if (dataUser != undefined) {
              localStorage.setObject("dataUser", dataUser);
            }
          }, function(error) {
            console.log(error);
          });

          swal({
            title: "Thông báo",
            text: "Đã lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            $state.go('main.dashboard');
          });
        }

        //function call when error
        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            $state.go('main.dashboard');
          });
          console.log(data);
        }

        //Update User's Profile
        if (flag == true) {
            //update User's data which doesn't update File Image
            if ($rootScope.imageFileData == undefined) {
                var inputData = {
                    'ID': user.ID,
                    'FullName': FullName.value, 
                    'Email': Email.value,
                    'Password': ConfirmPassword.value != '' ? Password.value : '',
                    'Birthday': DateOfBirth.value != '' ? reConvertJSONDate(DateOfBirth.value) : '',
                    'Phone': Phone.value, 
                    'ProfilePicture': user.ProfilePicture != null ? user.ProfilePicture : '',
                    'enterpriseId': sessionStorage.enterpriseId
                };
                $http.post(hostName.url + "api/User/UpdateUserClient", inputData)
                    .then(successCallBack, errorCallBack);
            }
            //update User's data which has update File Image
            else {
                // //Upload file Image
                // var data = new FormData();
                // data = $rootScope.imageFileData;
                // var reg = {
                //     url: hostName.url + 'api/Enterprise/UploadFileToLibrary',
                //     method: 'POST',
                //     data: data,
                //     transformRequest: angular.identity,
                //     headers: {
                //         'Content-Type': undefined
                //     },
                // }

                // $http(reg).then(function(response){
                //     var fileName = data.getAll("filename")[0];

                //     var inputData = {
                //       'ID': user.ID,
                //       'FullName': FullName.value, 
                //       'Email': Email.value,
                //       'Password': ConfirmPassword.value != '' ? Password.value : '',
                //       'Birthday': DateOfBirth.value != '' ? reConvertJSONDate(DateOfBirth.value) : '',
                //       'Phone': Phone.value, 
                //       'ProfilePicture': fileName,
                //       'enterpriseId': sessionStorage.enterpriseId
                //     };
                //     $http.post(hostName.url + "api/User/UpdateUserClient", inputData)
                //         .then(successCallBack, errorCallBack);
                // }, function(reason){
                //     swal({
                //         title: "Thông báo",
                //         text: "Không thể tải file lên server, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                //         icon: "error",
                //         dangerMode:true,
                //         button: "Đóng",
                //     }).then(function(){
                //         console.log(data);
                //     });
                // });
            }; //end of update User's data which has update File Image
        } //end of Update User
    }
    //end function save User's profile into Database via REST API

  }

  function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
          return "";
      else return date;
  }

})();

/**
 * @author l.azevedo
 * created on 29/06/2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.services')
    .service('localStorage', localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('format', function ($filter) {
            'use strict';

            return {
                require: '?ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    if (!ctrl) {
                        return;
                    }

                    ctrl.$formatters.unshift(function () {
                        return $filter('number')(ctrl.$modelValue);
                    });

                    ctrl.$parsers.unshift(function (viewValue) {
                        var plainNumber = viewValue.replace(/[\,\.]/g, ''),
                            b = $filter('number')(plainNumber);

                        elem.val(b);

                        return plainNumber;
                    });
                }
            };
    });    //end Directive



  })();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile($scope);
        })
      }
    }
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('numberInput', numberInput);
  
    //+++ START FUNCTION
    function numberInput($filter) {

        return { //+++ START RETURN
            require: 'ngModel',
            link: function(scope, elem, attrs, ngModelCtrl) {
        
                ngModelCtrl.$formatters.push(function(modelValue) {
                    return setDisplayNumber(modelValue, true);
                });
        
                // it's best to change the displayed text using elem.val() rather than
                // ngModelCtrl.$setViewValue because the latter will re-trigger the parser
                // and not necessarily in the correct order with the changed value last.
                // see http://radify.io/blog/understanding-ngmodelcontroller-by-example-part-1/
                // for an explanation of how ngModelCtrl works.
                ngModelCtrl.$parsers.push(function(viewValue) {
                    setDisplayNumber(viewValue);
                    return setModelNumber(viewValue);
                });
        
                // occasionally the parser chain doesn't run (when the user repeatedly 
                // types the same non-numeric character)
                // for these cases, clean up again half a second later using "keyup"
                // (the parser runs much sooner than keyup, so it's better UX to also do it within parser
                // to give the feeling that the comma is added as they type)
                elem.bind('keyup focus', function() {
                    setDisplayNumber(elem.val());
                });
        
                function setDisplayNumber(val, formatter) {
                    var valStr, displayValue;
            
                    if (typeof val === 'undefined') {
                        //return 0;
                        return '';
                    }
            
                    valStr = val.toString();
                    displayValue = valStr.replace(/,/g, '').replace(/[A-Za-z]/g, '');
                    displayValue = parseFloat(displayValue);
                    displayValue = (!isNaN(displayValue)) ? displayValue.toString() : '';
            
                    // handle leading character -/0
                    if (valStr.length === 1 && valStr[0] === '-') {
                        displayValue = valStr[0];
                    } else if (valStr.length === 1 && valStr[0] === '0') {
                        displayValue = '';
                    } else {
                        displayValue = $filter('number')(displayValue);
                    }
            
                    // handle decimal
                    if (!attrs.integer) {
                        if (displayValue.indexOf('.') === -1) {
                            if (valStr.slice(-1) === '.') {
                                displayValue += '.';
                            } else if (valStr.slice(-2) === '.0') {
                                displayValue += '.0';
                            } else if (valStr.slice(-3) === '.00') {
                                displayValue += '.00';
                            }
                        } // handle last character 0 after decimal and another number
                        else {
                            if (valStr.slice(-1) === '0') {
                                displayValue += '0';
                            }
                        }
                    }
            
                    if (attrs.positive && displayValue[0] === '-') {
                        displayValue = displayValue.substring(1);
                    }
            
                    if (typeof formatter !== 'undefined') {
                        return (displayValue === '') ? 0 : displayValue;
                    } else {
                        elem.val((displayValue === '0') ? '' : displayValue);
                    }
                }
            
                function setModelNumber(val) {
                    var modelNum = val.toString().replace(/,/g, '').replace(/[A-Za-z]/g, '');
                    modelNum = parseFloat(modelNum);
                    modelNum = (!isNaN(modelNum)) ? modelNum : 0;
                    if (modelNum.toString().indexOf('.') !== -1) {
                        modelNum = Math.round((modelNum + 0.00001) * 100) / 100;
                    }
                    if (attrs.positive) {
                        modelNum = Math.abs(modelNum);
                    }
                    return modelNum;
                }
            }

        }; //### END RETURN

    }; //### END FUNCTION
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('allowOnlyNumbers', allowOnlyNumbers);
  
    /** @ngInject */
    function allowOnlyNumbers($filter) {
        'use strict';

        // return {
        //     require: '?ngModel',
        //     link: function (scope, elem, attrs, ctrl) {
        //         if (!ctrl) {
        //             return;
        //         }

        //         ctrl.$formatters.unshift(function () {
        //             return $filter('number')(ctrl.$modelValue);
        //         });

        //         ctrl.$parsers.unshift(function (viewValue) {
        //             var plainNumber = viewValue.replace(/[\,\.]/g, ''),
        //                 b = $filter('number')(plainNumber);

        //             elem.val(b);

        //             return plainNumber;
        //         });
        //     }
        // };
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^-0-9]/g, '');
    
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        // transformedInput = $filter('currency')(transformedInput, '', 0);
                        // console.log(transformedInput);
                        return transformedInput;
                    }
                    return undefined;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }
  
  })();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author Nguyen Huu Tuan
 * created on 14.09.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.enterprise')
        .controller('InvoiceTemplatePageCtrl', InvoiceTemplatePageCtrl);
  
    /** @ngInject */
    function InvoiceTemplatePageCtrl($scope, $http, $state, hostName, baSidebarService) {

        // //HIDE LEFT MENU
        // baSidebarService.setMenuCollapsed(true);

        //Declare global variable of business that are using this system
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }

        //function then call Webservice get InvoiceTemplate's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n < vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateInit = convertJSONDate(vm.rowCollection[n].dateInit);
            }

            //display message into Console
            //console.log(response);
        };

        //function then call Webservice get InvoiceTemplate's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call Webservice to get InvoiceTemplate's data
        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetAllInvoiceTemplate?statusCode=&enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);

        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        //filter InvoiceTemplate's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var symbol = "";
            symbol = angular.element(document).find('#inputSymbol')[0];
            var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
            var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
            var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
            if (isActiveAll.checked == true) {
                isActive = "";
            }
            else if (isActiveTrue.checked == true) {
                isActive = true;
            }
            else {
                isActive = false;
            }
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&symbol=" + symbol.value + "&isActive=" + isActive ;
            }
            else {
                var date = new Date();
                var nowYear = date.getFullYear();
                var nowMonth = date.getMonth();
                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&symbol=&isActive=";
            }

            //call Webservice to get InvoiceTemplate's data
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/SearchInvoiceTemplate?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter InvoiceTemplate's data

        //approve InvoiceTemplate
        $scope.approveInvoiceTemplate = function(itemId) {
            swal({
                title: "Bạn muốn duyệt mẫu hóa đơn điện tử này?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            })
            .then(function(willDelete) {
                if (willDelete) {
                    var inputData = {
                        'ID': itemId,
                        'userUpdated': user.ID
                    };
                    $http.post(hostName.url + "api/InvoiceTemplate/UpdateInvoiceTemplateApprove", inputData).then(function(data){
                        swal("Duyệt mẫu hóa đơn điện tử thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                    });
                };
            });
        }

        //update Status of InvoiceTemplate
        $scope.updateStatus = function(flag, itemId) {
            if (flag == true) {
                //Stop
                swal({
                    title: "Bạn muốn kích hoạt thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': true,
                            'userUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/InvoiceTemplate/UpdateInvoiceTemplateActive", inputData).then(function(data){
                            swal("Kích hoạt thành công!", {
                            icon: "success",
                            button: "Đóng"
                            }).then(function(){
                            $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            }
            else {
                //Active
                swal({
                    title: "Bạn muốn ngừng sử dụng thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                    var inputData = {
                        'ID': itemId,
                        'isActive': false,
                        'userUpdated': user.ID
                    };
                    $http.post(hostName.url + "api/InvoiceTemplate/UpdateInvoiceTemplateActive", inputData).then(function(data){
                        swal("Ngừng sử dụng thành công!", {
                        icon: "success",
                        button: "Đóng"
                        }).then(function(){
                        $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                        icon: "error",
                        button: "Đóng"
                        });
                    });
                    } else {
                    //no action;
                    }
                });
            }
        }

    } //end function Controller

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
      }
  
})(); //end function all
  
/**
 * @author Nguyen Huu Tuan
 * created on 14.09.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.enterprise')
        .controller('UpdateInvoiceTemplatePageCtrl', UpdateInvoiceTemplatePageCtrl);
  
    /******************************************/
    /******controller for Update InvoiceTemplate******/
    /******************************************/
    function UpdateInvoiceTemplatePageCtrl($scope, $filter, $http, $state, $uibModal, hostName, baSidebarService) {

        // //HIDE LEFT MENU
        // baSidebarService.setMenuCollapsed(true);

        //Declare global variable of business that are using this system
        sessionStorage.templateId = undefined;
        $scope.PageTitle = "Tạo mới thông tin mẫu hóa đơn điện tử";
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.TypeOfInvoice = {};
        
        var vm = this;
        $scope.isPublic = false;
        

        //call Webservice to get Enterprise's data by Id
        $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetEnterprise/" + sessionStorage.enterpriseId,
        })
        .then(function(response) {
            //$scope.Enterprise = [];
            $scope.Enterprise = response.data;
            
            if ($scope.Enterprise != undefined) {
                //put Enterprise's data into Form's controls
                $scope.inputTaxCode = $scope.Enterprise.taxCode;
                $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;
                $scope.inputPhone = $scope.Enterprise.phone;
                $scope.inputFax = $scope.Enterprise.fax;
                $scope.inputAddressVN = $scope.Enterprise.addressVN;
                $scope.inputBankAccount = $scope.Enterprise.bankAccount;
                $scope.inputBankName = $scope.Enterprise.bankName;
            }
        }, function(reason) {
            console.log(reason);
        });

        //Refresh page
        $scope.refreshPage = function() {
            swal({
                title: "Bạn muốn dừng việc thay đổi dữ liệu?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            })
            .then(function(willDelete)  {
                if (willDelete) {
                    swal("Dữ liệu đã được làm mới lại từ đầu!", {
                        icon: "success",
                        button: "Đóng"
                    }).then(function(){
                        $state.reload();
                    });
                } else {
                  //no action;
                }
            });
        }

        /** Set default view for template **/
        vm.picture = $scope.picture = hostName.url + "Templates/" + "noimage.png";
        /** End Set default view for template **/

        //change template
        $scope.selectChanged = function(Template) {
            $scope.itemSelect = Template;
            //call web api to get fileImage of Template
            vm.picture = $scope.picture = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/" + Template.templateImage;
        }

        $scope.changeTypeOfInvoice = function(objectSelect) {
            $scope.TypeOfInvoice = {};
            $scope.TypeOfInvoice.selected = objectSelect;
          }

        //load InvoiceTemplate's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            //show button Public Invoice
            $scope.isPublic = true;
            // Decrypt
            //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
            //var itemId = bytes.toString(CryptoJS.enc.Utf8);
            var itemId = sessionStorage.itemId.toString();
            
            //Update Page Title
            $scope.PageTitle = "Cập nhật thông tin mẫu hóa đơn điện tử";

            //call Webservice to get InvoiceTemplate's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + itemId,
            }).then(function(response) {
                //$scope.InvoiceTemplate = [];
                $scope.InvoiceTemplate = response.data;
                $scope.Template = {};
                //console.log($scope.InvoiceTemplate);
                
                if ($scope.InvoiceTemplate != undefined) {
                    //put InvoiceTemplate's data into Form's controls
                    $scope.itemSelect = $scope.Template.selected = {ID: $scope.InvoiceTemplate.templateId, templateName: $scope.InvoiceTemplate.templateName};
                    $scope.TypeOfInvoice.selected = {typeOfInvoiceName: $scope.InvoiceTemplate.typeOfInvoiceName, ID: $scope.InvoiceTemplate.typeOfInvoiceId};
                    $scope.inputInvoiceTemplateName = $scope.InvoiceTemplate.invoiceTemplateName;
                    $scope.inputInvoiceTemplateCode = $scope.InvoiceTemplate.invoiceTemplateCode;
                    var dateCreated = new Date($scope.InvoiceTemplate.dateInit);
                    $scope.inputDateCreated = new Date(dateCreated.getFullYear(), dateCreated.getMonth(), dateCreated.getDate());
                    $scope.inputSymbol = $scope.InvoiceTemplate.symbol;
                    $scope.inputFromNumber = $scope.InvoiceTemplate.fromNumber;
                    $scope.inputToNumber = $scope.InvoiceTemplate.toNumber;
                    $scope.inputDescription = $scope.InvoiceTemplate.description;
                    vm.picture = $scope.picture = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/" + $scope.InvoiceTemplate.templateImage;

                    if ($scope.InvoiceTemplate.statusId == 2) {
                        $scope.isPublic = false;
                    }
                }
            }, function(reason) {
                //$scope.error = reason.data;
                console.log(reason);
            });
        }
        else {
            $scope.isPublic = false;
            $scope.inputDateCreated = new Date();
        }

        $scope.viewFullImage = function(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                controller: ['picture', ViewImageModalCtrl],
                controllerAs: 'vm',
                resolve: {
                  picture: function () {
                      return vm.picture;
                    }
                }
            });
        }

        // $scope.selectChanged = function(objectSelect) {
        //     $scope.Template = objectSelect;
        // }

        $scope.DownloadXml = function (filename, data) {
            // Set up the link
            // var link = document.createElement("a");
            // link.setAttribute("target", "_blank");
            // if (Blob !== undefined) {
            //     var blob = new Blob([data], { type: "text/xml;charset=utf-8" });
            //     link.setAttribute("href", URL.createObjectURL(blob));
            // } else {
            //     link.setAttribute("href", "data:text/xml," + encodeURIComponent(data));
            // }
            // link.setAttribute("download", filename);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);

            var pathTemp = hostName.url + 'Temp/' + sessionStorage.enterpriseId + "/";
            //var pathSigned = hostName.url + 'Invoices/' + sessionStorage.enterpriseId + "/";
            var dateOfInvoice;
            var date = new Date();
            dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

            var req = {
                method: 'POST',
                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                headers: {
                    'Content-Type': "application/json"
                },
                data: JSON.stringify({ 
                    'file': filename,
                    'urlDownload':  pathTemp,
                    'urlUpload': hostName.url + "api/invoiceTemplate/UploadFileToServer",
                    'id': sessionStorage.itemId,
                    'dateOfInvoice': dateOfInvoice,
                    'enterpriseId': sessionStorage.enterpriseId
                })
              };
              
              $http(req).then(function(response){
                $http({
                    method: 'GET',
                    url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + sessionStorage.itemId,
                    //params: inputData
                }).success(function (response) {
                    //console.log(response);
                    var link = document.createElement("a");
                    var pathSigned = hostName.url + 'Invoices/' + sessionStorage.enterpriseId + "/";
                    link.setAttribute("target", "_blank");
                    link.setAttribute("href", pathSigned + response.filePublic);
                    link.setAttribute("download", "ThongBaoPhatHanh.xml");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).error(function (message) {
                    console.log(message);
                });
              }, function(error) {
                console.log(error);
                swal({
                    title: "Thông báo",
                    text: "Không thể phát hành mẫu hóa đơn, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/invoiceTemplate";
                });
              });
        };

        $scope.publish = function() {

            $http({
                traditional: true,
                url: hostName.url + 'api/InvoiceTemplate/WriteXML?templateId=' + sessionStorage.itemId + "&userUpdated=" + user.ID,
                method: 'POST',
                contentType: "application/json",
                dataType: "json"
            }).success(function (data) {
                //console.log(data);
                $scope.DownloadXml(data.Data.fileName, data.Data.xmlData);
            }).error(function (data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể phát hành mẫu hóa đơn, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/invoiceTemplate";
                });
                console.log(data);
            });

            // $http({
            //     method: 'GET',
            //     url: hostName.url + 'api/InvoiceTemplate/UpdateInvoiceTemplatePublish?templateId=' + sessionStorage.itemId + "&userUpdated=" + user.ID,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "ThongBaoPhatHanh.docx"; //you may assign this value from header as well 
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     console.log(contentType);
            // }).error(function (message) {
            //     console.log(message);
            // });

        }

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            //var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var invoiceTemplateName = angular.element(document).find('#inputInvoiceTemplateName')[0];
            var invoiceTemplateCode = angular.element(document).find('#inputInvoiceTemplateCode')[0];
            var dateInit = angular.element(document).find('#inputDateCreated')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var fromNumber = angular.element(document).find('#inputFromNumber')[0];
            var toNumber = angular.element(document).find('#inputToNumber')[0];
            var description = angular.element(document).find('#inputDescription')[0];
            var templateId = $scope.itemSelect != undefined ? $scope.itemSelect.ID : 0;
            var typeOfInvoiceId = $scope.TypeOfInvoice.selected != undefined ? $scope.TypeOfInvoice.selected.ID : 0;
            var flag = true;

            //check empty taxAuthority
            if (templateId == 0) {
                swal({
                    title: "Vui lòng lựa chọn Hóa đơn mẫu",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty invoiceTemplateName
            if (invoiceTemplateName.value == '') {
                swal({
                    title: "Thông tin Tên mẫu hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    invoiceTemplateName.focus();
                });
                flag = false;
                return;
            }

            //check empty invoiceTemplateCode
            if (invoiceTemplateCode.value == '') {
                swal({
                    title: "Thông tin Mã mẫu hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    invoiceTemplateCode.focus();
                });
                flag = false;
                return;
            }

            //check empty typeOfInvoiceId
            if (typeOfInvoiceId == 0) {
                swal({
                    title: "Thông tin Loại hóa đơn",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty symbol
            if (symbol.value == '') {
                swal({
                    title: "Thông tin Ký hiệu mẫu hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    symbol.focus();
                });
                flag = false;
                return;
            }

            //check empty fromNumber
            if (fromNumber.value == '') {
                swal({
                    title: "Thông tin Số hóa đơn từ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    fromNumber.focus();
                });
                flag = false;
                return;
            }

            //check empty toNumber
            if (toNumber.value == '') {
                swal({
                    title: "Thông tin Số hóa đơn đến",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    toNumber.focus();
                });
                flag = false;
                return;
            }

            // if (toNumber.value < fromNumber.value) {
            //     swal({
            //         title: "Số hóa đơn đầu không thể lớn hơn số hóa đơn cuối!",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         fromNumber.focus();
            //     });
            //     flag = false;
            //     return;
            // }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    if (sessionStorage.itemId == 'undefined') {
                        sessionStorage.itemId = data.data;
                    }
                    $state.reload();
                });
                
            }
            //error function
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/invoiceTemplate";
                });
                console.log(data);
            }

            //if not empty with data which must to have
            if (flag == true) {

                //Update InvoiceTemplate's data
                if (sessionStorage.itemId != 'undefined') {
                    var dateInit = reConvertJSONDate(dateInit.value);
                    var data = {
                        'ID': sessionStorage.itemId,
                        'templateId': templateId,
                        'typeOfInvoiceId': typeOfInvoiceId, 
                        'invoiceTemplateName': invoiceTemplateName.value,
                        'invoiceTemplateCode': invoiceTemplateCode.value,
                        'symbol': symbol.value,
                        'dateInit': dateInit,
                        'fromNumber': $filter('replace')(fromNumber.value, ',', ''),
                        'toNumber': $filter('replace')(toNumber.value, ',', ''),
                        'description': description.value,
                        'userUpdated': user.ID
                    };
                    $http.post(hostName.url + "api/InvoiceTemplate/UpdateInvoiceTemplate", data)
                        .then(successCallBack, errorCallBack);
                }
                //Add new InvoiceTemplate's data
                else {
                    var dateInit = reConvertJSONDate(dateInit.value);
                    var data = {
                        'templateId': templateId,
                        'typeOfInvoiceId': typeOfInvoiceId, 
                        'invoiceTemplateName': invoiceTemplateName.value,
                        'invoiceTemplateCode': invoiceTemplateCode.value,
                        'symbol': symbol.value,
                        'dateInit': dateInit,
                        'fromNumber': $filter('replace')(fromNumber.value, ',', ''),
                        'toNumber': $filter('replace')(toNumber.value, ',', ''),
                        'description': description.value,
                        'enterpriseId': sessionStorage.enterpriseId,
                        'userCreated': user.ID
                    };
                    $http.post(hostName.url + "api/InvoiceTemplate/AddInvoiceTemplate", data)
                        .then(successCallBack, errorCallBack);
                }
            }

        }
        /** End Check data and call api to save data to database **/

    } //end function controller
    /******************************************/
    /******End controller for Update InvoiceTemplate******/
    /******************************************/

    function ViewImageModalCtrl(picture) {
        var vm = this;
        
        vm.picture = picture;
      }
  
    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})(); //end function all
  
/**
 * @author Nguyen Huu Tuan
 * created on 13.09.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.enterprise')
        .controller('RegisterInformationPageCtrl', RegisterInformationPageCtrl);
  
    /** @ngInject */
    function RegisterInformationPageCtrl($scope, fileReader, $filter, $http, $state, layoutPaths, $rootScope, hostName, baSidebarService) {

        // //HIDE LEFT MENU
        // baSidebarService.setMenuCollapsed(true);

        //Declare global variable of business that are using this system
        //sessionStorage.taxAuthorityId = undefined;
        $scope.TaxAuthority = {};
        $scope.ChildTaxAuthority = {};
        var user = JSON.parse(localStorage.getItem("dataUser"));

        // $http({
        //     method: "GET",
        //     url: hostName.url + "api/Enterprise/GetVolumnID",
        // })
        // .then(function(response) {
        //     console.log(response.data);
        // }, function(error) {
        //     console.log(error);
        // });

        //call REST API to get Enterprise's data by Id
        $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetEnterprise?ID=" + sessionStorage.enterpriseId,
        })
        .then(function(response) {
            //$scope.Enterprise = [];
            $scope.Enterprise = response.data;
            //console.log($scope.Enterprise);
            if ($scope.Enterprise != undefined) {
                //put Enterprise's data into Form's controls
                $scope.inputTaxCode = $scope.Enterprise.taxCode;
                $scope.ChildTaxAuthority.selected = {ID: $scope.Enterprise.taxAuthorityId, taxAuthorityName: $scope.Enterprise.taxAuthorityName};
                //sessionStorage.taxAuthorityId = $scope.Enterprise.taxAuthorityId;
                $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;
                $scope.inputBusinessNameEN = $scope.Enterprise.enterpriseNameEN;
                $scope.inputPhone = $scope.Enterprise.phone;
                $scope.inputFax = $scope.Enterprise.fax;
                $scope.inputAddressVN = $scope.Enterprise.addressVN;
                $scope.inputAddressEN = $scope.Enterprise.addressEN;
                $scope.inputEmail = $scope.Enterprise.email;
                $scope.inputContactPerson = $scope.Enterprise.contactPerson;
                $scope.inputOwner = $scope.Enterprise.owner;
                $scope.inputBankAccount = $scope.Enterprise.bankAccount;
                //$scope.inputAccountName = $scope.Enterprise.accountHolder;
                $scope.inputBankName = $scope.Enterprise.bankName;
                $scope.checkStatus = $scope.Enterprise.isLogo == true?'Y':'N';
                //sessionStorage.logo = $scope.Enterprise.logoFileName;
                $rootScope.logo = $scope.Enterprise.logoFileName;
                $scope.picture = $filter('logoPicture')($rootScope.logo);
                //console.log($scope.picture);
                
                //get list Child of TaxAuthorities
                $http({
                    method: "GET",
                    url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + $scope.Enterprise.taxParentID,
                }).then(function(response) {
                    $scope.ChildTaxAuthorities = response.data;
                }, function(reason) {
                    $scope.error = reason.data;
                    console.log(reason);
                });

                //get Child of TaxAuthorites selected
                $http({
                    method: "GET",
                    url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + $scope.Enterprise.taxParentID,
                }).then(function(response) {
                    var taxParent = response.data;
                    $scope.TaxAuthority.selected = {ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode};
                }, function(reason) {
                    $scope.error = reason.data;
                    console.log(reason);
                });
            }
        }, function(reason) {
            $scope.error = reason.data;
            console.log(reason);
        });

        //Refresh page
        $scope.refreshPage = function() {
            swal({
                title: "Bạn muốn dừng việc thay đổi dữ liệu?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            })
            .then(function(willDelete) {
                if (willDelete) {
                    swal("Dữ liệu đã được làm mới lại từ đầu!", {
                        icon: "success",
                        button: "Đóng"
                    }).then(function(){
                        $state.reload();
                    });
                } else {
                  //no action;
                }
            });
        }

        /** Manage upload Picture **/
        //$scope.picture = $filter('logoPicture')($rootScope.logo);
        //console.log($scope.picture);
        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };
        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    //check only Image can use logo
                    if (fileName.indexOf(".jpg") <= 0 && fileName.indexOf(".png") <= 0 
                            && fileName.indexOf(".gif") <= 0) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng hình ảnh (.jpg, .png, .gif)!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function(){
                            return;
                        });
                    }
                    else {
                        $scope.picture = result;

                        var min=10000; 
                        var max=100000;  
                        var random = Math.floor(Math.random() * (+max - +min)) + +min; 
                        var fileName = random + "_" + $scope.file.name;

                        var data = new FormData();
                        data.append("filename", fileName);
                        data.append("storagePath", layoutPaths.images.logo);
                        data.append("file", $scope.file);
                        //console.log(data);
                        //console.log($scope.file);
                        
                        // var ext = fileName.substr(fileName.indexOf(".") + 1, 3);
                        // fileName = fileName.substr(0, fileName.indexOf("."));
                        $rootScope.logo = fileName;
                        $rootScope.FileTemplateData = data;
                    }
                });
        };
        /** End Manage upload Picture **/

        //change taxAuthority
        $scope.selectChanged = function(taxAuthority) {
            $scope.TaxAuthority.selected = taxAuthority;
            $scope.ChildTaxAuthority.selected = undefined;

            //get list Child of TaxAuthorities
            $http({
                method: "GET",
                url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + taxAuthority.taxAuthorityCode,
            }).then(function(response) {
                $scope.ChildTaxAuthorities = response.data;
            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        }

        $scope.selectChangedChild = function(taxAuthority) {
            $scope.ChildTaxAuthority.selected = taxAuthority;
        }

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseNameVN = angular.element(document).find('#inputBusinessNameVN')[0];
            var enterpriseNameEN = angular.element(document).find('#inputBusinessNameEN')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var fax = angular.element(document).find('#inputFax')[0];
            var addressVN = angular.element(document).find('#inputAddressVN')[0];
            var addressEN = angular.element(document).find('#inputAddressEN')[0];
            var email = angular.element(document).find('#inputEmail')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var owner = angular.element(document).find('#inputOwner')[0];
            var bankAccount = angular.element(document).find('#inputBankAccount')[0];
            //var accountHolder = '';//angular.element(document).find('#inputAccountName')[0];
            var bankName = angular.element(document).find('#inputBankName')[0];
            var isLogo = angular.element(document).find('#inputIsActiveLogo')[0];
            var logoFileName = $rootScope.logo//sessionStorage.logo;
            var isActive = angular.element(document).find('#inputIsActive')[0];
            var taxAuthorityId = $scope.ChildTaxAuthority.selected != undefined ? $scope.ChildTaxAuthority.selected.ID : 0;
            var flag = true;

            //console.log(sessionStorage.logo);
    
            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Thông tin Mã số thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    taxCode.focus();
                });
                flag = false;
                return;
            }

            //check empty taxAuthority
            if (taxAuthorityId == 0) {
                swal({
                    title: "Thông tin Cơ quan Thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty enterpriseName
            if (enterpriseNameVN.value == '') {
                swal({
                    title: "Thông tin Tên đơn vị",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    enterpriseNameVN.focus();
                });
                flag = false;
                return;
            }

            //check empty address
            if (addressVN.value == '') {
                swal({
                    title: "Thông tin Địa chỉ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    addressVN.focus();
                });
                flag = false;
                return;
            }

            //check empty email
            if (email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    email.focus();
                });
                flag = false;
                return;
            }

            //check empty contactPerson
            if (contactPerson.value == '') {
                swal({
                    title: "Thông tin Người liên hệ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    contactPerson.focus();
                });
                flag = false;
                return;
            }

            //check empty owner
            if (owner.value == '') {
                swal({
                    title: "Thông tin Người đại diện",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    owner.focus();
                });
                flag = false;
                return;
            }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                //console.log(data);
            }
            //error function
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                console.log(data);
            }

            //if not empty with data which must to have
            if (flag == true) {

                //upload Logo to Server
                var data = new FormData();
                data = $rootScope.FileTemplateData;
                //console.log(data);
                var reg = {
                    url: hostName.url + 'api/Enterprise/UploadFileToDocmentLibrary',
                    method: 'POST',
                    data: data,
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    },
                };

                //check if user change Logo
                if (data != undefined) {
                    $http(reg).then(function(response){
                    
                    }, function(reason){
                        swal({
                            title: "Thông báo",
                            text: "Không thể upload được Logo, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            console.log(reason.data);
                        });
                    });
                }

                //add new enterprise
                if (sessionStorage.enterpriseId == undefined) {
                    var enterpriseData = {
                        'taxCode': taxCode.value, 
                        'taxAuthorityId': taxAuthorityId, 
                        'enterpriseNameVN': enterpriseNameVN.value, 
                        'enterpriseNameEN': enterpriseNameEN.value, 
                        'phone': phone.value, 
                        'fax': fax.value, 
                        'addressVN': addressVN.value, 
                        'addressEN': addressEN.value, 
                        'email': email.value, 
                        'contactPerson': contactPerson.value, 
                        'owner': owner.value,
                        'bankAccount': bankAccount.value,
                        'accountHolder': '',//accountHolder.value,
                        'bankName': bankName.value,
                        'isLogo': isLogo.checked,
                        'logoFileName': logoFileName,
                        'description': '',
                        'isActive': true,
                        'userCreated': user.ID
                    };
                    $http.post(hostName.url + "api/Enterprise/AddEnterprise", enterpriseData)
                        .then(successCallBack, errorCallBack);
                }
                //update enterprise
                else {
                    var enterpriseData = {
                        'ID': sessionStorage.enterpriseId,
                        'taxCode': taxCode.value, 
                        'taxAuthorityId': taxAuthorityId, 
                        'enterpriseNameVN': enterpriseNameVN.value, 
                        'enterpriseNameEN': enterpriseNameEN.value, 
                        'phone': phone.value, 
                        'fax': fax.value, 
                        'addressVN': addressVN.value, 
                        'addressEN': addressEN.value, 
                        'email': email.value, 
                        'contactPerson': contactPerson.value, 
                        'owner': owner.value,
                        'bankAccount': bankAccount.value,
                        'accountHolder': '',//accountHolder.value,
                        'bankName': bankName.value,
                        'isLogo': isLogo.checked,
                        'logoFileName': logoFileName,
                        'description': '',
                        'isActive': true,
                        'userUpdated': user.ID
                    };
                    $http.post(hostName.url + "api/Enterprise/UpdateEnterprise", enterpriseData)
                        .then(successCallBack, errorCallBack);
                }
            }

        }
        /** End Check data and call api to save data to database **/
    } //end function controller
  
  })(); //end function all
  
/**
 * @author Nguyen Huu Tuan
 * created on 08.01.2019
 */
(function () {
    'use strict';

    //declare controller for Adjust Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('AdjustInvoicePageCtrl', AdjustInvoicePageCtrl);

    /******************************************/
    /*******controller for Adjust Invoice*******/
    /******************************************/
    function AdjustInvoicePageCtrl($scope, $http, hostName, $filter, $state) {

        var n = 0;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();
        $scope.InvoiceTemplate = {};
        $scope.isPublic = false;
        $scope.IsDisabled = false;

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        if (sessionStorage.itemId != 'undefined' && sessionStorage.editId == "undefined") {
            var itemId = sessionStorage.itemId;

            //call Webservice to get ElectricInvoice's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/ElectricInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    $scope.inputCompanyName = $scope.ElectricInvoice.companyName;
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;
                    $scope.inputMedicalCode = $scope.ElectricInvoice.medicalCode;
                    $scope.inputHealthInsuranceCardNumber = $scope.ElectricInvoice.healthInsuranceCardNumber;
                    $scope.inputHospitalizationNumber = $scope.ElectricInvoice.hospitalizationNumber;

                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDescription1 = "Thay thế cho hóa đơn ký hiệu mẫu số, " 
                                                + "ký hiệu hóa đơn " + $scope.ElectricInvoice.symbol
                                                + " số hóa đơn " + ("0000000" + $scope.ElectricInvoice.billNumber).slice(-7) 
                                                + ", ngày " + dateOfInvoice.getDate()
                                                + " tháng " + (dateOfInvoice.getMonth() + 1)
                                                + " năm " + dateOfInvoice.getFullYear();
                }
            }, function(reason) {
                console.log(reason);
            });
        }

        if (sessionStorage.editId != 'undefined') {
            $scope.isPublic = true;
            var itemId = sessionStorage.editId;

            //call Webservice to get ElectricInvoice's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/ElectricInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode};
                    $scope.inputSymbol = $scope.ElectricInvoice.symbol;
                   // $scope.inputBillNumber = $scope.ElectricInvoice.billNumber;

                    $scope.inputCompanyName = $scope.ElectricInvoice.companyName;
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;
                    $scope.inputMedicalCode = $scope.ElectricInvoice.medicalCode;
                    $scope.inputHealthInsuranceCardNumber = $scope.ElectricInvoice.healthInsuranceCardNumber;
                    $scope.inputHospitalizationNumber = $scope.ElectricInvoice.hospitalizationNumber;

                    $scope.inputNotes = $scope.ElectricInvoice.description;
        
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ElectricInvoiceDetail/GetElectricInvoiceDetail?electricInvoiceId=" + $scope.ElectricInvoice.ID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) {
                        $scope.Products = response.data;

                        if ($scope.Products.length > 0) {
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $filter('number')($scope.Products[0].price, 0);
                            $scope.inputVAT1 = $scope.Products[0].VAT;

                            if ($scope.Products.length > 1) {
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $filter('number')($scope.Products[1].price, 0);
                                $scope.inputVAT2 = $scope.Products[1].VAT;
        
                                if ($scope.Products.length > 2) {
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $filter('number')($scope.Products[2].price, 0);
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                }
                            }
                        }
                    }, function(reason) {
                        console.log(reason);
                    });
                }
            }, function(reason) {
                console.log(reason);
            });
        }
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode};
                $scope.inputSymbol = response.data[0].symbol;
            }, function(error){ //ERROR
                console.log(error);
            });
        }

        //save data to local variable when change Select's control
        $scope.changeInvoiceTemplate = function(objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
            //call Webservice to get InvoiceTemplate's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function(response) {
                var invoiceTemplate = response.data;
                
                if (invoiceTemplate.ID > 0) {
                    //put InvoiceTemplate's data into Form's controls
                    $scope.inputSymbol = invoiceTemplate.symbol;
                   // $scope.inputBillNumber = invoiceTemplate.currentNumber;
                }
            }, function(reason) {
                //$scope.error = reason.data;
                console.log(reason);
            });
        };

        //event onBlur of Price 1 of Description 1
        $scope.endPrice1 = function(price) {
            var price1 = angular.element(document).find('#inputPrice1')[0];
            if (price != undefined)
                price1.value = $filter('number')(price, 0);
        };

        //event onBlur of Price 2 of Description 2
        $scope.endPrice2 = function(price) {
            var price2 = angular.element(document).find('#inputPrice2')[0];
            if (price != undefined)
                price2.value = $filter('number')(price, 0);
        };

        //event onBlur of Price 3 of Description 3
        $scope.endPrice3 = function(price) {
            var price3 = angular.element(document).find('#inputPrice3')[0];
            if (price != undefined)
                price3.value = $filter('number')(price, 0);
        };

        //Save input data to database
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - MaYTe & CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            //var billNumber = angular.element(document).find('#inputBillNumber')[0];

            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var healthInsuranceCardNumber = angular.element(document).find('#inputHealthInsuranceCardNumber')[0];
            var hospitalizationNumber = angular.element(document).find('#inputHospitalizationNumber')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var flag = true;
            
            //check empty customerName
            if ($scope.InvoiceTemplate.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Mẫu hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusInvoiceTemplate');
                });
                flag = false;
                return;
            };

            //check empty customerName
            if (customerName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    customerName.focus();
                });
                flag = false;
                return;
            };

            //check empty medicalCode
            if (medicalCode.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mã y tế\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    medicalCode.focus();
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' && description2.value == '' && price2.value == '' && description3.value == '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            // //check empty price 1
            // if (description1.value != '' && price1.value == '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         price1.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            // //check empty description 1
            // if (description1.value == '' && price1.value != '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         description1.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            // //check empty price 2
            // if (description2.value != '' && price2.value == '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         price2.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            // //check empty description 2
            // if (description2.value == '' && price2.value != '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         description2.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            // //check empty price 3
            // if (description3.value != '' && price3.value == '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         price3.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            // //check empty description 3
            // if (description3.value == '' && price3.value != '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function(){
            //         description3.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            //if all ok then save data to database
            if (flag == true) {
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;

                $scope.IsDisabled = true;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = amountNotVAT1 + parseInt(quantity1.value!=''?quantity1.value:1) * parseInt(val1);
                    amount1 = amount1 + amountNotVAT1 + ((amountNotVAT1 * parseInt(vat1.value!=''?vat1.value:0))/100);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = amountNotVAT2 + parseInt(quantity2.value!=''?quantity2.value:1) * parseInt(val2);
                    amount2 = amount2 + amountNotVAT2 + ((amountNotVAT2 * parseInt(vat2.value!=''?vat2.value:0))/100);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = amountNotVAT3 + parseInt(quantity3.value!=''?quantity3.value:1) * parseInt(val3);
                    amount3 = amount3 + amountNotVAT3 + ((amountNotVAT3 * parseInt(vat3.value!=''?vat3.value:0))/100);
                }
                totalAmount = amount1 + amount2 + amount3;
                totalAmountNotVAT = amountNotVAT1 + amountNotVAT2 + amountNotVAT3;

                //Update data
                if (sessionStorage.editId != 'undefined') {
                    var inputData = {
                        'electricInvoiceId': sessionStorage.editId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        //'billNumber': billNumber.value,
                        'customerName': customerName.value,
                        'companyName': companyName.value,
                        'taxCode': taxCode.value,
                        'medicalCode': medicalCode.value,
                        'healthInsuranceCardNumber': healthInsuranceCardNumber.value,
                        'hospitalizationNumber': hospitalizationNumber.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                        'enterpriseId': sessionStorage.enterpriseId
                    };
    
                    $http.post(hostName.url + "api/HIS/HIS_ElectricInvoice_Update", inputData)
                    .then(function(response) {
                        
                        var objResult = response.data;

                        //Check License
                        if (objResult.ResultCode != "0") {
                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
    
                    }, function(reason) {
                        var objResult = reason.data;

                        swal({
                            title: "Thông báo",
                            text: objResult.Message,
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceApproved";
                        });
                    });
                }
                //Add new data
                else {
                    var inputData = {
                        'enterpriseId': sessionStorage.enterpriseId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        //'billNumber': billNumber.value,
                        'customerName': customerName.value,
                        'companyName': companyName.value,
                        'taxCode': taxCode.value,
                        'medicalCode': medicalCode.value,
                        'healthInsuranceCardNumber': healthInsuranceCardNumber.value,
                        'hospitalizationNumber': hospitalizationNumber.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                    };
    
                    $http.post(hostName.url + "api/HIS/HIS_ElectricInvoice_Create", inputData)
                    .then(function(response) {

                        var objResult = response.data;

                        //Check License
                        if (objResult.ResultCode != "0") {
                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                        else {
                            var invoiceId = objResult.Data;
                            sessionStorage.editId = invoiceId;
                            var flagDetail = true;
        
                            //detail 1
                            if (description1.value != '') {
                                var amountNotVAT = parseInt(quantity1.value!=''?quantity1.value:1) * parseInt(val1);
                                var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat1.value!=''?vat1.value:0))/100);
                                var data = {
                                    'electricInvoiceId': invoiceId,
                                    'goodAndServiceName': description1.value,
                                    'unitName': unitName1.value,
                                    'quantity': quantity1.value!=''?quantity1.value:1,
                                    'price': val1,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat1.value!=''?vat1.value:0,
                                    'amountVAT': amountVAT,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
        
                            //detail 2
                            if (description2.value != '') {
                                var amountNotVAT = parseInt(quantity2.value!=''?quantity2.value:1) * parseInt(val2);
                                var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat2.value!=''?vat2.value:0))/100);
                                var data = {
                                    'electricInvoiceId': invoiceId,
                                    'goodAndServiceName': description2.value,
                                    'unitName': unitName2.value,
                                    'quantity': quantity2.value!=''?quantity2.value:1,
                                    'price': val2,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat2.value!=''?vat2.value:0,
                                    'amountVAT': amountVAT,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
        
                            //detail 3
                            if (description3.value != '') {
                                var amountNotVAT = parseInt(quantity3.value!=''?quantity3.value:1) * parseInt(val3);
                                var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat3.value!=''?vat3.value:0))/100);
                                var data = {
                                    'electricInvoiceId': invoiceId,
                                    'goodAndServiceName': description3.value,
                                    'unitName': unitName3.value,
                                    'quantity': quantity3.value!=''?quantity3.value:1,
                                    'price': val3,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat3.value!=''?vat3.value:0,
                                    'amountVAT': amountVAT,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
                            
                            if (flagDetail == true) {
                                var data = {
                                    'electricInvoiceId': sessionStorage.itemId,
                                    'newElectricInvoiceId': invoiceId,
                                    'enterpriseId': sessionStorage.enterpriseId
                                }
                                $http.post(hostName.url + "api/ElectricInvoices_Adjust/ElectricInvoices_Adjust_UpdateInfor", data)
                                    .then(function(success){}, function(error){
                                        console.log(error);
                                });

                                swal({
                                    title: "Thông báo",
                                    text: "Lưu dữ liệu thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                        }
                    }, function(reason) {
                        var objResult = reason.data;

                        swal({
                            title: "Thông báo",
                            text: objResult.Message,
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceApproved";
                        });
                    });
                }
            }
        };

        //publish Invoice
        $scope.publishInvoice = function() {
            $scope.IsDisabled = true;
            var itemId = sessionStorage.editId.toString();
            $http({
                method: 'POST',
                url: hostName.url + "api/HIS/HIS_PublishInvoice?electricInvoiceId=" + itemId + "&Username=" + user.Username + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).success(function (data) {
                //console.log(data);
                swal("Hóa đơn đã xuất thành công!", {
                    icon: "success",
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/invoiceApproved";
                });
            }).error(function (message) {
                console.log(message);
                swal("Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/invoiceApproved";
                });
            });
        }
        
    };
    /******End controller for Adjust Invoice******/

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 13.09.2019
 */
(function () {
    'use strict';

    //declare controller for Adjust Business Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('AdjustBusinessInvoicePageCtrl', AdjustBusinessInvoicePageCtrl);

    /******************************************/
    /*******controller for Adjust Business Invoice*******/
    /******************************************/
    function AdjustBusinessInvoicePageCtrl($scope, $http, hostName, $filter, $state, fileReader, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();
        $scope.InvoiceTemplate = {};
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.isHasFile = false;
        $rootScope.fileTemplate = undefined;
        $rootScope.FileTemplateData = undefined;
        $scope.FileMauChiTiet = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/ChiTietHoaDon.xlsx";

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function(url) {
            location.href = url;
        };

        //GET EXISTED DATA WHEN EDIT
        if (sessionStorage.itemId != 'undefined' && sessionStorage.editId == "undefined") {
            var itemId = sessionStorage.itemId;

            //CALL API GET ELECTRICINVOICE
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) { //SUCCESS
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode, invoiceTemplateName: $scope.ElectricInvoice.invoiceTemplateName};
                    $scope.inputSymbol = $scope.ElectricInvoice.symbol;
                    
                    $scope.Customer.selected = {ID: $scope.ElectricInvoice.companyId, customerName: $scope.ElectricInvoice.companyName};
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;

                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDescription1 = "Thay thế cho hóa đơn ký hiệu mẫu số, " 
                                                + "ký hiệu hóa đơn " + $scope.ElectricInvoice.symbol
                                                + " số hóa đơn " + ("0000000" + $scope.ElectricInvoice.billNumber).slice(-7) 
                                                + ", ngày " + dateOfInvoice.getDate()
                                                + " tháng " + (dateOfInvoice.getMonth() + 1)
                                                + " năm " + dateOfInvoice.getFullYear();
                }
            }, function(reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE

        } //#GET EXISTED DATA WHEN EDIT
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName};
                $scope.inputSymbol = response.data[0].symbol;
            }, function(error){ //ERROR
                console.log(error);
            });
        }


        //GET EXISTED DATA WHEN EDIT
        if (sessionStorage.editId != 'undefined') {
            $scope.isPublic = true;
            var itemId = sessionStorage.editId;

            //CALL API GET ELECTRICINVOICE
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) { //SUCCESS
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode, invoiceTemplateName: $scope.ElectricInvoice.invoiceTemplateName};
                    $scope.inputSymbol = $scope.ElectricInvoice.symbol;
                    
                    $scope.Customer.selected = {ID: $scope.ElectricInvoice.companyId, customerName: $scope.ElectricInvoice.companyName};
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;

                    $scope.inputNotes = $scope.ElectricInvoice.description;
        
                    //CALL API GET ELECTRICINVOICE DETAIL
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ElectronicInvoiceDetail/GetElectricInvoiceDetail?electronicInvoiceId=" + $scope.ElectricInvoice.ID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VATAmount;
        
                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VATAmount;
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function(reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function(reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE

        } //#GET EXISTED DATA WHEN EDIT
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName};
                $scope.inputSymbol = response.data[0].symbol;
            }, function(error){ //ERROR
                console.log(error);
            });
        }

        //CHANGE INVOICE TEMPLATE
        $scope.changeInvoiceTemplate = function(objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
            
            //GET INVOICE TEMPLATE's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function(response) {
                var invoiceTemplate = response.data;
                
                if (invoiceTemplate.ID > 0) {
                    $scope.inputSymbol = invoiceTemplate.symbol;
                }
            }, function(reason) {
                console.log(reason);
            }); //#GET INVOICE TEMPLATE's DATA FROM DATABASE

        }; //#CHANGE INVOICE TEMPLATE

        //CHANGE CUSTOMER
        $scope.changeCustomer = function(obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function(response) {
                var customer = response.data;
                
                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                }
            }, function(reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE
            
        } //#CHANGE CUSTOMER

        /** Manage upload File **/
        $scope.removeFileInvoiceDetail = function() {
            $rootScope.fileTemplate = undefined;
            $rootScope.FileTemplateData = undefined;
            this.isHasFile = false;
            this.checkEdit = false;
        }
        
        $scope.uploadFileInvoiceDetail = function () {
            angular.element("input[type='file']").val(null);
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);
                    
                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx") ) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function(){
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;

                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", sessionStorage.enterpriseId);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;

                        //SET READONLY FOR DETAIL'S CONTROLS
                        $scope.checkEdit = true;
                        $scope.isHasFile = true;
                    }
                });
        };
        /** End Manage upload Picture **/

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //FUNCTION SAVE DATA
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            //var companyName = $scope.Customer.selected != undefined ? $scope.Customer.selected.ID : "";
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 =  angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 =  angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 =  angular.element(document).find('#inputVATAmount3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var flag = true;
            
            //check empty InvoiceTemplate
            if ($scope.InvoiceTemplate.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Mẫu hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusInvoiceTemplate');
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty Customer
            if ($scope.Customer.selected == undefined || $scope.Customer.selected.ID == 0) {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusCustomer');
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' && description2.value == '' && price2.value == '' && description3.value == '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = ( parseFloat(quan1) * parseFloat(val1) );
                    var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                    amount1 = amountNotVAT1 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = ( parseFloat(quan2) * parseFloat(val2) );
                    var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                    amount2 = amountNotVAT2 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = ( parseFloat(quan3) * parseFloat(val3) );
                    var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                    amount3 = amountNotVAT3 + parseFloat(vatAmount);
                }
                totalAmount = parseFloat(amount1 + amount2 + amount3);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);
                
                totalAmount = isNaN(totalAmount) ? 0 : totalAmount;
                totalAmountNotVAT = isNaN(totalAmount) ? 0 : totalAmountNotVAT;

                //CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL
                if ($rootScope.FileTemplateData != undefined) {
                    var inputData = {
                        'enterpriseId': sessionStorage.enterpriseId,
                        'electronicInvoiceId': sessionStorage.itemId == 'undefined' || sessionStorage.itemId == undefined ? 0 : sessionStorage.itemId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        'customerName': customerName.value,
                        'companyId':$scope.Customer.selected.ID,
                        'companyName': $scope.Customer.selected.customerName,
                        'taxCode': taxCode.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                    };

                    var data = new FormData();
                    data = $rootScope.FileTemplateData;
                    data.append("model", JSON.stringify(inputData));

                    //Upload file Template
                    var reg = {
                        url: hostName.url + 'api/BUS/BUS_CreateInvoiceWithExcelDetail',
                        method: 'POST',
                        data: data,
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                    };

                    $http(reg).then(function(response) { //SUCCESS
                        var result = response.data;
                        
                        if (result.ResultCode == 0) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu thông tin hóa đơn thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                var invoiceId = result.Data;
                                sessionStorage.itemId = invoiceId;
                                $state.reload();
                            });
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: result.Message,
                                icon: "error",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                    }, //#SUCCESS
                    function(error) { //ERROR
                        swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                        $state.reload();
                        console.log(error);
                    }); //#ERROR

                } //#CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL

                //CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                else {

                    //UPDATE INVOICE'S DATA
                    if (sessionStorage.editId != 'undefined') {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'electronicInvoiceId': sessionStorage.editId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Update", inputData)
                        .then(function(response) { //UPDATE SUCCESS
                            
                            var objResult = response.data;

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.itemId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value!=''?price1.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                   
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value!=''?price2.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value!=''?price3.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    swal({
                                        title: "Thông báo",
                                        text: "Lưu dữ liệu thành công!",
                                        icon: "success",
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            }
                        //#UPDATE SUCCESS
                        }, 
                        function(reason) { //UPDATE ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#UPDATE ERRORS

                    } //#UPDATE INVOICE'S DATA

                    //ADD NEW INVOICE'S DATA
                    else {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Create", inputData)
                        .then(function(response) { //ADD NEW SUCCESS
                            var objResult = response.data;
                            

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.editId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quantity1.value!=''?quantity1.value:1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value!=''?price1.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quantity2.value!=''?quantity2.value:1) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value!=''?price2.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quantity3.value!=''?quantity3.value:1) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    if (isNaN(amountNotVAT) || amountNotVAT == '') amountNotVAT = 0;
                                    if (isNaN(vatAmount) || vatAmount == '') vatAmount = 0;

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value!=''?price3.value:0,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    var data = {
                                        'electronicInvoiceId': sessionStorage.itemId,
                                        'newElectronicInvoiceId': invoiceId,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    }
                                    $http.post(hostName.url + "api/ElectronicInvoices_Adjust/ElectricInvoices_Adjust_UpdateInfor", data)
                                        .then(function(success){}, function(error){
                                            console.log(error);
                                    });

                                    swal({
                                        title: "Thông báo",
                                        text: "Lưu dữ liệu thành công!",
                                        icon: "success",
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            } 
                        //#ADD NEW SUCCESS
                        }, 
                        function(reason) { //ADD NEW ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#ADD NEW ERRORS

                    } //#ADD NEW INVOICE'S DATA

                } //#CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                
            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA

        //publish Invoice
        $scope.publishInvoice = function() {
            $scope.IsDisabled = true;
            var itemId = sessionStorage.editId.toString();
            $http({
                method: 'POST',
                url: hostName.url + "api/BUS/BUS_PublishInvoice?electronicInvoiceId=" + itemId + "&Username=" + user.Username + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).success(function (data) {
                //console.log(data);
                var pathTemp = hostName.url + 'temp/' + sessionStorage.enterpriseId + '/';
                var fileInvoice = data;
                var dateOfInvoice;
                var date = new Date();
                dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');
                
                //Day file hoa don qua Service KY SO
                var req = {
                    method: 'POST',
                    url: 'http://localhost:7001/PdfSignService/SignInvoice',
                    headers: {
                        'Content-Type': "application/json"
                    },
                    data: JSON.stringify({ 
                        'file': fileInvoice,
                        'urlDownload':  pathTemp,
                        'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                        'id': itemId,
                        'dateOfInvoice': dateOfInvoice,
                        'enterpriseId': sessionStorage.enterpriseId
                    })
                };
                
                $http(req).then(function() {
                    swal({
                        title: "Thông báo",
                        text: "Đã xuất hóa đơn thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                }, function(error) {
                    swal({
                        title: "Thông báo",
                        text: "Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                    console.log(error);
                }); //#http SignInvoice
            }).error(function (message) {
                console.log(message);
                swal("Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/businessInvoice";
                });
            });
        }
        
    };
    /******End controller for Create Invoice******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 13.09.2019
 */
(function () {
    'use strict';

    //declare controller for Business Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('BusinessInvoicePageCtrl', BusinessInvoicePageCtrl);

    /******************************************/
    /*******controller for Business Invoice List*******/
    /******************************************/
    function BusinessInvoicePageCtrl($scope, $http, $state, hostName, $filter, fileReader, $window) {

        $scope.smartTablePageSize = 10;
        $scope.TotalAmount = 0;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        vm.TotalAmount = 0;
        vm.TotalInvoice = 0;
        vm.isXML = 0;
        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        sessionStorage.editId = undefined;
        sessionStorage.editable = false;
        $scope.checkDate = convertJSONDate(new Date());
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathFileInvoice = hostName.url;

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) {
                if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
                    $scope.isShow = true;
            };
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            //console.log(response.data);
            vm.rowCollection = response.data[0];
            vm.TotalAmount = 0;
            var total = response.data[1][0].totalAmount;

            if (total != undefined) {
                vm.TotalAmount = total; //.replace(/,/g,".");
            }

            vm.TotalInvoice = response.data[1][0].totalInvoice;
            vm.isXML = response.data[1][0].isXML;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        toDate = new Date();
        fromDate = new Date(nowYear, nowMonth, 1);
        // toDate = new Date("2022-03-31");
        // fromDate = new Date("2022-01-01");
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&taxCode=";
        $http({
            method: "GET",
            url: hostName.url + "api/ElectronicInvoice/BUS_SearchElectricInvoice_Approved?" + queryString
        }).then(successCallBack, errorCallBack);

        //select Status
        $scope.selectChangedStatus = function (objSelect) {
            $scope.Status = objSelect;
        }

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function (objSelect) {
            $scope.InvoiceTemplate = objSelect;
        }

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function (obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //redirect to other pages
        $scope.open = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.urlReturn = '#/businessInvoice';
            location.href = url;
        };

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/open?id=1SLpUulz9ozFu6VnUKeqE1mDpOZ64dkSU");
        }

        //edit invoice's general information
        $scope.editInvoice = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.editable = true;
            sessionStorage.urlReturn = '#/businessInvoice';
            location.href = url;
        };

        $scope.importDataFromExcel = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        }

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    //console.log(sessionStorage.invoiceId);
                    if (fileName.indexOf(".xls") <= 0 && fileName.indexOf(".xlsx") <= 0) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function () {
                            return;
                        });
                    }
                    else {
                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        //Upload file Template
                        var reg = {
                            url: hostName.url + 'api/BUS/ImportDataFromExcel',
                            method: 'POST',
                            data: data,
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            },
                        };

                        $http(reg).then(function (response) {
                            var result = response.data;
                            if (result.ResultCode == 0) {
                                swal({
                                    title: "Thông báo",
                                    text: "Xuất hóa đơn từ file Excel thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: result.Message,
                                    icon: "error",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }
                        }, function (error) {
                            swal("Không thể xuất hóa đơn từ file Excel, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                            console.log(error);
                        })
                    }
                });
        };

        //Create new Invoice
        $scope.createInvoice = function () {
            location.href = '#/createBusinessInvoice';
            // var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            // $http({
            //     method: "GET",
            //     url: hostName.url + "api/Enterprise/CheckLicenseOfEnterprise?enterpriseCode=" + enterpriseId,
            // }).then(function(response) {
            //     var objResult = response.data;

            //     if (objResult.ResultCode == "0") {

            //     }
            //     else {
            //         swal({
            //             title: "Thông báo",
            //             text: "Bản quyền hệ thống không hợp lệ hoặc đã hết hạn, vui lòng liên hệ nhà cung cấp để được hỗ trợ!",
            //             icon: "error",
            //             dangerMode:true,
            //             button: "Đóng",
            //         }).then(function() {
            //             console.clear();
            //         });
            //     }

            // }, function(reason) {
            //     var objResult = reason.data;

            //     swal({
            //         title: "Thông báo",
            //         text: "Bản quyền hệ thống không hợp lệ hoặc đã hết hạn, vui lòng liên hệ nhà cung cấp để được hỗ trợ!",
            //         icon: "error",
            //         dangerMode:true,
            //         button: "Đóng",
            //     }).then(function() {
            //         console.clear();
            //     });
            // });
        }

        //create file convert
        $scope.createFileConvert = function (ID, fileInvoice) {
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            swal({
                title: "Bạn muốn tạo Bản chuyển đổi cho Hóa đơn này không?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            }).then(function (willDelete) {
                if (willDelete) {
                    var queryString = 'electronicInvoiceId=' + ID + '&fileInvoice=' + fileInvoice + "&Username=" + user.Username + "&enterpriseId=" + enterpriseId;
                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoiceConvert?" + queryString).then(
                        function (data) {
                            //console.log(data);
                            var pathTemp = hostName.url + 'temp/' + enterpriseId + '/';
                            var fileConvert = data.data;
                            var date = new Date();
                            var dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

                            //Day file hoa don qua Service KY SO
                            var req = {
                                method: 'POST',
                                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                                headers: {
                                    'Content-Type': "application/json"
                                },
                                data: JSON.stringify({
                                    'file': fileConvert,
                                    'urlDownload': pathTemp,
                                    'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                                    'id': ID,
                                    'dateOfInvoice': dateOfInvoice,
                                    'enterpriseId': enterpriseId
                                })
                            };

                            $http(req).then(function () {
                                swal({
                                    title: "Thông báo",
                                    text: "Đã xuất hóa đơn chuyển đổi thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }, function (error) {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể xuất được hóa đơn chuyển đổi, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                    icon: "error",
                                    dangerMode: true,
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                                console.log(error);
                            }); //#http SignInvoice
                        }, function (data) {
                            swal("Không thể xuất được Hóa đơn chuyển đổi, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            }).then(function () {
                                $state.reload();
                            });
                        });
                } else {
                    //no action;
                }
            });
        }//end create file convert

        //+++CREATE FILE INVOICE XML
        $scope.createFileInvoiceXML = function (ID) {

            // var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            // var queryString = 'electronicInvoiceId=' + ID + "&enterpriseId=" + enterpriseId;
            // $http.post(hostName.url + "api/BUS/PublishXML635?" + queryString).then(
            //     function(data){
            //         console.log(data);
            //     },

            //     function(error) {
            //         console.log(error);
            //     }
            // );

            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            swal({
                title: "Bạn muốn tạo File hóa đơn XML cho hóa đơn này không?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            }).then(function (willDelete) {
                if (willDelete) {
                    var queryString = 'electronicInvoiceId=' + ID + "&Username=" + user.Username + "&enterpriseId=" + enterpriseId;
                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoiceXML?" + queryString).then(
                        function (data) {
                            //console.log(data);
                            var pathTemp = hostName.url + 'temp/' + enterpriseId + '/';
                            var fileInvoice = data.data;
                            var date = new Date();
                            var dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

                            //Day file hoa don qua Service KY SO
                            var req = {
                                method: 'POST',
                                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                                headers: {
                                    'Content-Type': "application/json"
                                },
                                data: JSON.stringify({
                                    'file': fileInvoice,
                                    'urlDownload': pathTemp,
                                    'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                                    'id': ID,
                                    'dateOfInvoice': dateOfInvoice,
                                    'enterpriseId': enterpriseId
                                })
                            };

                            $http(req).then(function () {
                                swal({
                                    title: "Thông báo",
                                    text: "Đã xuất Hóa đơn XML thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }, function (error) {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể xuất được Hóa đơn XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                    icon: "error",
                                    dangerMode: true,
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                                console.log(error);
                            }); //#http SignInvoice
                        }, function (data) {
                            swal("Không thể xuất được Hóa đơn XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            }).then(function () {
                                $state.reload();
                            });
                        });
                } else {
                    //no action;
                }
            });
        }//###CREATE FILE INVOICE XML

        //filter ElectronicInvoice's data
        $scope.findData = function () {
            vm.rowCollection = [];
            vm.TotalAmount = 0;
            $scope.TotalAmount = 0;
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&taxCode=" + taxCode.value + "&billNumber=" + billNumber.value + "&symbol=" + symbol.value + "&customerName=" + customerName.value + "&statusId=" + statusId + "&invoiceTemplateId=" + invoiceTemplateId;
                //console.log(queryString);
            }
            else {
                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&taxCode=";
                //console.log(queryString);
            }

            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/BUS_SearchElectricInvoice_Approved?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data

    };
    /******End controller for Business Invoice List******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 13.09.2019
 */
(function () {
    'use strict';

    //declare controller for Create Business Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateBusinessInvoicePageCtrl', CreateBusinessInvoicePageCtrl);

    /******************************************/
    /*******controller for Create Business Invoice*******/
    /******************************************/
    function CreateBusinessInvoicePageCtrl($scope, $window, $http, hostName, $filter, $state, fileReader, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();
        $scope.InvoiceTemplate = {};
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.isHasFile = false;
        $rootScope.fileTemplate = undefined;
        $rootScope.FileTemplateData = undefined;
        $scope.FileMauChiTiet = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/ChiTietHoaDon.xlsx";
        $scope.HTTTs = [
            {ID: 1, Name: 'TM/CK'},
            {ID: 2, Name: 'Tiền mặt'},
            {ID: 3, Name: 'Chuyển khoản'},
        ];
        $scope.HTTT = {};
        $scope.HTTT.selected = {ID: 1, Name: 'TM/CK'};

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function(url) {
            location.href = url;
        };

        //GET EXISTED DATA WHEN EDIT
        if (sessionStorage.itemId != 'undefined') {
            $scope.isPublic = true;
            var itemId = sessionStorage.itemId;

            //CALL API GET ELECTRICINVOICE
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) { //SUCCESS
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode, invoiceTemplateName: $scope.ElectricInvoice.invoiceTemplateName};
                    $scope.inputSymbol = $scope.ElectricInvoice.symbol;
                    
                    $scope.Customer.selected = {ID: $scope.ElectricInvoice.companyId, customerName: $scope.ElectricInvoice.companyName};
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;

                    $scope.inputNotes = $scope.ElectricInvoice.description;

                    if ($scope.ElectricInvoice.fileInvoice != undefined && $scope.ElectricInvoice.fileInvoice != '')
                        $scope.FileHoaDon = hostName.url + "Temp/" + sessionStorage.enterpriseId + "/" + $scope.ElectricInvoice.fileInvoice;
        
                    //CALL API GET ELECTRICINVOICE DETAIL
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ElectronicInvoiceDetail/GetElectricInvoiceDetail?electronicInvoiceId=" + $scope.ElectricInvoice.ID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VATAmount;
        
                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VATAmount;
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function(reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function(reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE

        } //#GET EXISTED DATA WHEN EDIT
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName};
                $scope.inputSymbol = response.data[0].symbol;
            }, function(error){ //ERROR
                console.log(error);
            });
        }

        //CHANGE INVOICE TEMPLATE
        $scope.changeInvoiceTemplate = function(objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
            
            //GET INVOICE TEMPLATE's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function(response) {
                var invoiceTemplate = response.data;
                
                if (invoiceTemplate.ID > 0) {
                    $scope.inputSymbol = invoiceTemplate.symbol;
                }
            }, function(reason) {
                console.log(reason);
            }); //#GET INVOICE TEMPLATE's DATA FROM DATABASE

        }; //#CHANGE INVOICE TEMPLATE

        //CHANGE CUSTOMER
        $scope.changeCustomer = function(obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function(response) {
                var customer = response.data;
                
                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                }
            }, function(reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE
            
        } //#CHANGE CUSTOMER

        /** Manage upload File **/
        $scope.removeFileInvoiceDetail = function() {
            $rootScope.fileTemplate = undefined;
            $rootScope.FileTemplateData = undefined;
            this.isHasFile = false;
            this.checkEdit = false;
        }
        
        $scope.uploadFileInvoiceDetail = function () {
            angular.element("input[type='file']").val(null);
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);
                    
                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx") ) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function(){
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;

                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", sessionStorage.enterpriseId);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;

                        //SET READONLY FOR DETAIL'S CONTROLS
                        $scope.checkEdit = true;
                        $scope.isHasFile = true;
                    }
                });
        };
        /** End Manage upload Picture **/

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //FUNCTION SAVE DATA
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            //var companyName = $scope.Customer.selected != undefined ? $scope.Customer.selected.ID : "";
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 =  angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 =  angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 =  angular.element(document).find('#inputVATAmount3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var flag = true;
            
            //check empty InvoiceTemplate
            if ($scope.InvoiceTemplate.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Mẫu hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusInvoiceTemplate');
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty Customer
            if ($scope.Customer.selected == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusCustomer');
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' 
                && description2.value == '' && price2.value == '' 
                && description3.value == '' && price3.value == ''
                && $rootScope.FileTemplateData == undefined ) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description3.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = ( parseFloat(quan1) * parseFloat(val1) );
                    var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                    amount1 = amountNotVAT1 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = ( parseFloat(quan2) * parseFloat(val2) );
                    var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                    amount2 = amountNotVAT2 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = ( parseFloat(quan3) * parseFloat(val3) );
                    var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                    amount3 = amountNotVAT3 + parseFloat(vatAmount);
                }
                totalAmount = parseFloat(amount1 + amount2 + amount3);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);

                //CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL
                if ($rootScope.FileTemplateData != undefined) {
                    var inputData = {
                        'enterpriseId': sessionStorage.enterpriseId,
                        'electronicInvoiceId': sessionStorage.itemId == 'undefined' || sessionStorage.itemId == undefined ? 0 : sessionStorage.itemId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        'customerName': customerName.value,
                        'companyId':$scope.Customer.selected.ID,
                        'companyName': $scope.Customer.selected.customerName,
                        'taxCode': taxCode.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                    };

                    var data = new FormData();
                    data = $rootScope.FileTemplateData;
                    data.append("model", JSON.stringify(inputData));

                    //Upload file Template
                    var reg = {
                        url: hostName.url + 'api/BUS/BUS_CreateInvoiceWithExcelDetail',
                        method: 'POST',
                        data: data,
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                    };

                    $http(reg).then(function(response) { //SUCCESS
                        var result = response.data;
                        
                        if (result.ResultCode == 0) {
                            var invoiceId = result.Data;
                            sessionStorage.itemId = invoiceId;

                            //PUBLISH INVOICE TO REVIEW
                            $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                            .then(function(success){
                                swal({
                                    title: "Thông báo",
                                    text: "Lưu thông tin hóa đơn thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }, function(error){
                                swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                    icon: "error",
                                    button: "Đóng"
                                });
                                $state.reload();
                                console.log(error);
                            });

                            
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: result.Message,
                                icon: "error",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                    }, //#SUCCESS
                    function(error) { //ERROR
                        swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                        $state.reload();
                        console.log(error);
                    }); //#ERROR

                } //#CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL

                //CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                else {

                    //UPDATE INVOICE'S DATA
                    if (sessionStorage.itemId != 'undefined') {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'electronicInvoiceId': sessionStorage.itemId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Update", inputData)
                        .then(function(response) { //UPDATE SUCCESS
                            
                            var objResult = response.data;

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.itemId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    console.log(data);
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    //PUBLISH INVOICE TO REVIEW
                                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                                    .then(function(success){
                                        swal({
                                            title: "Thông báo",
                                            text: "Lưu dữ liệu thành công!",
                                            icon: "success",
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    }, function(error){
                                        
                                        console.log(error);
                                        swal({
                                            title: "Thông báo",
                                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                            icon: "error",
                                            dangerMode:true,
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    });

                                    
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            }
                        //#UPDATE SUCCESS
                        }, 
                        function(reason) { //UPDATE ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#UPDATE ERRORS

                    } //#UPDATE INVOICE'S DATA

                    //ADD NEW INVOICE'S DATA
                    else {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Create", inputData)
                        .then(function(response) { //ADD NEW SUCCESS
                            var objResult = response.data;

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.itemId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quantity1.value!=''?quantity1.value:1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quantity2.value!=''?quantity2.value:1) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quantity3.value!=''?quantity3.value:1) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    //PUBLISH INVOICE TO REVIEW
                                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                                    .then(function(success){
                                        swal({
                                            title: "Thông báo",
                                            text: "Lưu dữ liệu thành công!",
                                            icon: "success",
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    }, function(error){
                                        console.log(error);
                                        swal({
                                            title: "Thông báo",
                                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                            icon: "error",
                                            dangerMode:true,
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    });
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            } 
                        //#ADD NEW SUCCESS
                        }, 
                        function(reason) { //ADD NEW ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#ADD NEW ERRORS

                    } //#ADD NEW INVOICE'S DATA

                } //#CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                
            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        $scope.reviewInvoice = function() {
            if ($scope.FileHoaDon != undefined && $scope.FileHoaDon != '')
                $window.open($scope.FileHoaDon, '_blank');
        }


        //+++   PUBLISH INVOICE
        $scope.publishInvoice = function() {
            $scope.IsDisabled = true;
            var itemId = sessionStorage.itemId.toString();
            $http({
                method: 'POST',
                url: hostName.url + "api/BUS/BUS_PublishInvoice?electronicInvoiceId=" + itemId + "&Username=" + user.Username + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).success(function (data) {
                //console.log(data);
                var pathTemp = hostName.url + 'temp/' + sessionStorage.enterpriseId + '/';
                var fileInvoice = data;
                var dateOfInvoice;
                var date = new Date();
                dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');
                
                //Day file hoa don qua Service KY SO
                var req = {
                    method: 'POST',
                    url: 'http://localhost:7001/PdfSignService/SignInvoice',
                    headers: {
                        'Content-Type': "application/json"
                    },
                    data: JSON.stringify({ 
                        'file': fileInvoice,
                        'urlDownload':  pathTemp,
                        'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                        'id': itemId,
                        'dateOfInvoice': dateOfInvoice,
                        'enterpriseId': sessionStorage.enterpriseId
                    })
                };
                
                $http(req).then(function() {
                    swal({
                        title: "Thông báo",
                        text: "Đã xuất hóa đơn thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                }, function(error) {
                    swal({
                        title: "Thông báo",
                        text: "Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                    console.log(error);
                }); //#http SignInvoice
            }).error(function (message) {
                console.log(message);
                swal("Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/businessInvoice";
                });
            });

        }//###  END PUBLISH INVOICE
        
    };
    /******End controller for Create Invoice******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 13.09.2019
 */
 (function () {
    'use strict';

    //declare controller for Create Business Invoice Not Code
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateInvoiceNotCodeCtrl', CreateInvoiceNotCodeCtrl);

    /******************************************/
    /*******controller for Create Business Invoice Not Code*******/
    /******************************************/
    function CreateInvoiceNotCodeCtrl($scope, $window, $http, hostName, $filter, $state, fileReader, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();
        $scope.InvoiceTemplate = {};
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.isHasFile = false;
        $rootScope.fileTemplate = undefined;
        $rootScope.FileTemplateData = undefined;
        $scope.FileMauChiTiet = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/ChiTietHoaDon.xlsx";

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function(url) {
            location.href = url;
        };

        //GET EXISTED DATA WHEN EDIT
        if (sessionStorage.itemId != 'undefined') {
            $scope.isPublic = true;
            var itemId = sessionStorage.itemId;

            //CALL API GET ELECTRICINVOICE
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) { //SUCCESS
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode, invoiceTemplateName: $scope.ElectricInvoice.invoiceTemplateName};
                    $scope.inputSymbol = '1K21TVF' //$scope.ElectricInvoice.symbol;
                    
                    $scope.Customer.selected = {ID: $scope.ElectricInvoice.companyId, customerName: $scope.ElectricInvoice.companyName};
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;

                    $scope.inputNotes = $scope.ElectricInvoice.description;

                    if ($scope.ElectricInvoice.fileInvoice != undefined && $scope.ElectricInvoice.fileInvoice != '')
                        $scope.FileHoaDon = hostName.url + "Temp/" + sessionStorage.enterpriseId + "/" + $scope.ElectricInvoice.fileInvoice;
        
                    //CALL API GET ELECTRICINVOICE DETAIL
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ElectronicInvoiceDetail/GetElectricInvoiceDetail?electronicInvoiceId=" + $scope.ElectricInvoice.ID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VATAmount;
        
                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VATAmount;
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function(reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function(reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE

        } //#GET EXISTED DATA WHEN EDIT
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName};
                $scope.inputSymbol = '1K21TVF'; //response.data[0].symbol;
            }, function(error){ //ERROR
                console.log(error);
            });
        }

        //CHANGE INVOICE TEMPLATE
        $scope.changeInvoiceTemplate = function(objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
            
            //GET INVOICE TEMPLATE's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function(response) {
                var invoiceTemplate = response.data;
                
                if (invoiceTemplate.ID > 0) {
                    $scope.inputSymbol = invoiceTemplate.symbol;
                }
            }, function(reason) {
                console.log(reason);
            }); //#GET INVOICE TEMPLATE's DATA FROM DATABASE

        }; //#CHANGE INVOICE TEMPLATE

        //CHANGE CUSTOMER
        $scope.changeCustomer = function(obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function(response) {
                var customer = response.data;
                
                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                }
            }, function(reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE
            
        } //#CHANGE CUSTOMER

        /** Manage upload File **/
        $scope.removeFileInvoiceDetail = function() {
            $rootScope.fileTemplate = undefined;
            $rootScope.FileTemplateData = undefined;
            this.isHasFile = false;
            this.checkEdit = false;
        }
        
        $scope.uploadFileInvoiceDetail = function () {
            angular.element("input[type='file']").val(null);
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);
                    
                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx") ) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function(){
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;

                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", sessionStorage.enterpriseId);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;

                        //SET READONLY FOR DETAIL'S CONTROLS
                        $scope.checkEdit = true;
                        $scope.isHasFile = true;
                    }
                });
        };
        /** End Manage upload Picture **/

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //FUNCTION SAVE DATA
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            //var companyName = $scope.Customer.selected != undefined ? $scope.Customer.selected.ID : "";
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 =  angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 =  angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 =  angular.element(document).find('#inputVATAmount3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var flag = true;
            
            //check empty InvoiceTemplate
            if ($scope.InvoiceTemplate.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Mẫu hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusInvoiceTemplate');
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty Customer
            if ($scope.Customer.selected == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusCustomer');
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' 
                && description2.value == '' && price2.value == '' 
                && description3.value == '' && price3.value == ''
                && $rootScope.FileTemplateData == undefined ) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description3.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = ( parseFloat(quan1) * parseFloat(val1) );
                    var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                    amount1 = amountNotVAT1 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = ( parseFloat(quan2) * parseFloat(val2) );
                    var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                    amount2 = amountNotVAT2 + parseFloat(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = ( parseFloat(quan3) * parseFloat(val3) );
                    var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                    amount3 = amountNotVAT3 + parseFloat(vatAmount);
                }
                totalAmount = parseFloat(amount1 + amount2 + amount3);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);

                //CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL
                if ($rootScope.FileTemplateData != undefined) {
                    var inputData = {
                        'enterpriseId': sessionStorage.enterpriseId,
                        'electronicInvoiceId': sessionStorage.itemId == 'undefined' || sessionStorage.itemId == undefined ? 0 : sessionStorage.itemId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        'customerName': customerName.value,
                        'companyId':$scope.Customer.selected.ID,
                        'companyName': $scope.Customer.selected.customerName,
                        'taxCode': taxCode.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                    };

                    var data = new FormData();
                    data = $rootScope.FileTemplateData;
                    data.append("model", JSON.stringify(inputData));

                    //Upload file Template
                    var reg = {
                        url: hostName.url + 'api/BUS/BUS_CreateInvoiceWithExcelDetail',
                        method: 'POST',
                        data: data,
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                    };

                    $http(reg).then(function(response) { //SUCCESS
                        var result = response.data;
                        
                        if (result.ResultCode == 0) {
                            var invoiceId = result.Data;
                            sessionStorage.itemId = invoiceId;

                            //PUBLISH INVOICE TO REVIEW
                            $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                            .then(function(success){
                                swal({
                                    title: "Thông báo",
                                    text: "Lưu thông tin hóa đơn thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }, function(error){
                                swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                    icon: "error",
                                    button: "Đóng"
                                });
                                $state.reload();
                                console.log(error);
                            });

                            
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: result.Message,
                                icon: "error",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                    }, //#SUCCESS
                    function(error) { //ERROR
                        swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                        $state.reload();
                        console.log(error);
                    }); //#ERROR

                } //#CREATE NEW INVOICE WITH FILE INVOICE'S DETAIL

                //CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                else {

                    //UPDATE INVOICE'S DATA
                    if (sessionStorage.itemId != 'undefined') {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'electronicInvoiceId': sessionStorage.itemId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Update", inputData)
                        .then(function(response) { //UPDATE SUCCESS
                            
                            var objResult = response.data;

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.itemId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    console.log(data);
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    //PUBLISH INVOICE TO REVIEW
                                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                                    .then(function(success){
                                        swal({
                                            title: "Thông báo",
                                            text: "Lưu dữ liệu thành công!",
                                            icon: "success",
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    }, function(error){
                                        
                                        console.log(error);
                                        swal({
                                            title: "Thông báo",
                                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                            icon: "error",
                                            dangerMode:true,
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    });

                                    
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            }
                        //#UPDATE SUCCESS
                        }, 
                        function(reason) { //UPDATE ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#UPDATE ERRORS

                    } //#UPDATE INVOICE'S DATA

                    //ADD NEW INVOICE'S DATA
                    else {
                        var inputData = {
                            'enterpriseId': sessionStorage.enterpriseId,
                            'userCreated': user.ID,
                            'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                            'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                            'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                            'symbol': symbol.value,
                            'customerName': customerName.value,
                            'companyId':$scope.Customer.selected.ID,
                            'companyName': $scope.Customer.selected.customerName,
                            'taxCode': taxCode.value,
                            'address': address.value,
                            'description': notes.value,
                            'totalAmountNotVAT': totalAmountNotVAT,
                            'totalAmount': totalAmount,
                        };
        
                        $http.post(hostName.url + "api/BUS/BUS_ElectricInvoice_Create", inputData)
                        .then(function(response) { //ADD NEW SUCCESS
                            var objResult = response.data;

                            //Check License
                            if (objResult.ResultCode != "0") {
                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                var invoiceId = objResult.Data;
                                sessionStorage.itemId = invoiceId;
                                var flagDetail = true;
            
                                //detail 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quantity1.value!=''?quantity1.value:1) * parseFloat(val1);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));
                                    
                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value!=''?quantity1.value:1,
                                        'price': price1.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value!=''?vat1.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quantity2.value!=''?quantity2.value:1) * parseFloat(val2);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value!=''?quantity2.value:1,
                                        'price': price2.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value!=''?vat2.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
            
                                //detail 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quantity3.value!=''?quantity3.value:1) * parseFloat(val3);
                                    var vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    var data = {
                                        'electronicInvoiceId': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value!=''?quantity3.value:1,
                                        'price': price3.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value!=''?vat3.value:0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                        .then(function(success){}, function(error){
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                
                                if (flagDetail == true) {
                                    //PUBLISH INVOICE TO REVIEW
                                    $http.post(hostName.url + "api/BUS/BUS_PublishInvoice_Review?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId)
                                    .then(function(success){
                                        swal({
                                            title: "Thông báo",
                                            text: "Lưu dữ liệu thành công!",
                                            icon: "success",
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    }, function(error){
                                        console.log(error);
                                        swal({
                                            title: "Thông báo",
                                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                            icon: "error",
                                            dangerMode:true,
                                            button: "Đóng",
                                        }).then(function(){
                                            $state.reload();
                                        });
                                    });
                                }
                                else {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            } 
                        //#ADD NEW SUCCESS
                        }, 
                        function(reason) { //ADD NEW ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/businessInvoice";
                            });
                        }); //#ADD NEW ERRORS

                    } //#ADD NEW INVOICE'S DATA

                } //#CREATE NEW INVOICE WITHOUT FILE INVOICE'S DETAIL
                
            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        $scope.reviewInvoice = function() {
            if ($scope.FileHoaDon != undefined && $scope.FileHoaDon != '')
                $window.open($scope.FileHoaDon, '_blank');
        }


        //+++   PUBLISH INVOICE
        $scope.publishInvoice = function() {
            $scope.IsDisabled = true;
            var itemId = sessionStorage.itemId.toString();
            $http({
                method: 'POST',
                url: hostName.url + "api/BUS/BUS_PublishInvoice?electronicInvoiceId=" + itemId + "&Username=" + user.Username + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).success(function (data) {
                //console.log(data);
                var pathTemp = hostName.url + 'temp/' + sessionStorage.enterpriseId + '/';
                var fileInvoice = data;
                var dateOfInvoice;
                var date = new Date();
                dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');
                
                //Day file hoa don qua Service KY SO
                var req = {
                    method: 'POST',
                    url: 'http://localhost:7001/PdfSignService/SignInvoice',
                    headers: {
                        'Content-Type': "application/json"
                    },
                    data: JSON.stringify({ 
                        'file': fileInvoice,
                        'urlDownload':  pathTemp,
                        'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                        'id': itemId,
                        'dateOfInvoice': dateOfInvoice,
                        'enterpriseId': sessionStorage.enterpriseId
                    })
                };
                
                $http(req).then(function() {
                    swal({
                        title: "Thông báo",
                        text: "Đã xuất hóa đơn thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                }, function(error) {
                    swal({
                        title: "Thông báo",
                        text: "Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/businessInvoice";
                    });
                    console.log(error);
                }); //#http SignInvoice
            }).error(function (message) {
                console.log(message);
                swal("Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/businessInvoice";
                });
            });

        }//###  END PUBLISH INVOICE
        
    };
    /******End controller for Create Invoice NOT CODE******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 18.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Edit Business Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
      .controller('EditBusinessInvoicePageCtrl', EditBusinessInvoicePageCtrl);

    /******************************************/
    /*******controller for Edit Business Invoice*******/
    /******************************************/
    function EditBusinessInvoicePageCtrl($scope, $http, $filter, hostName, $state) {

        $scope.isPrint = false;
        $scope.isCreatInvoice = false;
        $scope.isSave = true;
        $scope.IsDisabled = false;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //load ElectricInvoice's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();

            //call Webservice to get ElectricInvoice's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    $scope.inputBillNumber = $scope.ElectricInvoice.billNumber;
                    $scope.inputInvoiceTemplate = $scope.ElectricInvoice.invoiceTemplateCode;
                    $scope.inputDateOfInvoice = convertJSONDate($scope.ElectricInvoice.dateOfInvoice);
                }
            }, function(reason) {
                console.log(reason);
            });

            //load ElectricInvoice_Adjust's data if it's existed
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoices_Adjust/GetElectricInvoices_Adjust?electronicInvoiceId=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.Adjust = response.data;
                
                if ($scope.Adjust.ID > 0) {
                    $scope.ID = $scope.Adjust.ID;
                    //put ElectricInvoice's data into Form's controls
                    if ($scope.Adjust.typeOfAction == 'DELETE') {
                        $scope.isPrint = true;
                        $scope.isSave = false;
                        $scope.isCreatInvoice = false;
                        $scope.typeOfAction = {
                            name: 'DELETE',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'ADJUST') {
                        $scope.isPrint = false;
                        $scope.isCreatInvoice = true;
                        $scope.isSave = false;
                        $scope.typeOfAction = {
                            name: 'ADJUST',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'REPLACE') {
                        $scope.isPrint = true;
                        $scope.typeOfAction = {
                            name: 'REPLACE',
                            disabled: true
                        };
                    }
                    var dateCreated = new Date($scope.Adjust.dateCreated);
                    $scope.inputDateCreated = new Date(dateCreated.getFullYear(), dateCreated.getMonth(), dateCreated.getDate());
                    $scope.inputDescription = $scope.Adjust.description;
                }
                else {
                    $scope.typeOfAction = {
                        name: 'DELETE',
                        disabled: false
                    };
                    $scope.isPrint = false;
                    $scope.isSave = true;
                    $scope.isCreatInvoice = false;
                    $scope.inputDateCreated = new Date();
                }
            }, function(reason) {
                console.log(reason);
            });
        };

        //redirect to other pages
        $scope.backPage = function() {
            location.href = sessionStorage.urlReturn;
        };

        //create new Adjusted Invoice
        $scope.changeInvoice = function() {
            $scope.IsDisabled = true;
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/CheckLicenseOfEnterprise?enterpriseCode=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                var objResult = response.data;

                if (objResult.ResultCode == "0") {
                    location.href = '#/adjustBusinessInvoice';
                }
                else {
                    swal({
                        title: "Thông báo",
                        text: objResult.Message,
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function() {
                        $scope.IsDisabled = false;
                        console.clear();
                    });
                }
                
            }, function(reason) {
                var objResult = reason.data;

                swal({
                    title: "Thông báo",
                    text: objResult.Message,
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function() {
                    $scope.IsDisabled = false;
                    console.clear();
                });
            });
        }

        //Print Notification
        $scope.printNotification = function() {
            $scope.IsDisabled = true;
            var typeOfAction = $scope.typeOfAction.name;
            if (typeOfAction == 'ADJUST') {
                 //Print modify invoice document
            }
            else if (typeOfAction == 'DELETE') {
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/ElectronicInvoices_Adjust/PrintNotification?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = "ThongBaoHuyHoaDon.docx"; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    //console.log(contentType);
                }).error(function (message) {
                    console.log(message);
                });
                $scope.IsDisabled = false;
            }
        }

        //Print Document
        $scope.printDocument = function() {
            $scope.IsDisabled = true;
            var typeOfAction = $scope.typeOfAction.name;
            if (typeOfAction == 'ADJUST') {
                 //Print modify invoice document
            }
            else if (typeOfAction == 'DELETE') {
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/ElectronicInvoices_Adjust/PrintDocument?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = "BienBanHuyHoaDon.docx"; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    //console.log(contentType);
                }).error(function (message) {
                    
                    console.log(message);
                });
                $scope.IsDisabled = false;
            }
        }

        $scope.save = function() {
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplate = angular.element(document).find('#inputInvoiceTemplate')[0];
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var dateCreated = angular.element(document).find('#inputDateCreated')[0];
            var typeOfAction = $scope.typeOfAction.name;
            var description = angular.element(document).find('#inputDescription')[0];
            var flag = true;

            //check empty billNumber
            if (billNumber.value == '') {
                swal({
                    title: "Thông tin Số hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    billNumber.focus();
                });
                flag = false;
                return;
            };

            //check empty invoiceTemplate
            if (invoiceTemplate.value == '') {
                swal({
                    title: "Thông tin Mẫu hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    invoiceTemplate.focus();
                });
                flag = false;
                return;
            };

            //check empty dateOfInvoice
            if (dateOfInvoice.value == '') {
                swal({
                    title: "Thông tin Ngày hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    dateOfInvoice.focus();
                });
                flag = false;
                return;
            };

            //check empty dateCreated
            if (dateCreated.value == '') {
                swal({
                    title: "Thông tin Ngày xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    dateCreated.focus();
                });
                flag = false;
                return;
            };

            //check empty typeOfAction
            if (typeOfAction == '') {
                swal({
                    title: "Thông tin Hình thức xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    typeOfAction.focus();
                });
                flag = false;
                return;
            };

            //check empty description
            if (description.value == '') {
                swal({
                    title: "Thông tin Lý do xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                $scope.IsDisabled = true;

                if ($scope.ID == undefined) { //ADD NEW
                    var statusCode = "";
                    if (typeOfAction == 'ADJUST') {
                        statusCode = 'MODIFY';
                    }
                    else if (typeOfAction == 'DELETE') {
                        statusCode = 'CANCEL';
                    }
                    else if (typeOfAction == 'REPLACE') {
                        statusCode = 'REPLACE';
                    }
                    var inputData = {
                        'electronicInvoiceId': itemId,
                        'dateCreated': reConvertJSONDate(dateCreated.value),
                        'typeOfAction': typeOfAction,
                        'description': description.value,
                        'userCreated': user.ID,
                        'enterpriseId': sessionStorage.enterpriseId
                    };

                    //HTTP ADD ADJUST INVOICE
                    $http.post(hostName.url + "api/ElectronicInvoices_Adjust/BUS_AddElectricInvoices_Adjust", inputData)
                    .then(function(data) {
                        //console.log(data.data);
                        var pathTemp = hostName.url + 'Temp/' + sessionStorage.enterpriseId + '/';
                        var fileInvoice = data.data;
                        var dateOfInvoice;
                        var date = new Date();
                        dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

                        // +++ DELETE INVOICE
                        if (statusCode == 'CANCEL') {

                            //Day file hoa don qua Service KY SO
                            var req = {
                                method: 'POST',
                                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                                headers: {
                                    'Content-Type': "application/json"
                                },
                                data: JSON.stringify({ 
                                    'file': fileInvoice,
                                    'urlDownload':  pathTemp,
                                    'urlUpload': hostName.url + "api/ElectronicInvoice/UploadFileToServer",
                                    'id': itemId,
                                    'dateOfInvoice': dateOfInvoice,
                                    'enterpriseId': sessionStorage.enterpriseId
                                })
                            };
                            
                            $http(req).then(function() {    //HTTP CALL API SIGN INVOICE
                                var inputData = {
                                    'ID': itemId,
                                    'statusCode': statusCode,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };

                                //HTTP CALL API TO UPDATE STATUS INVOICE AFTER SIGNED
                                $http.post(hostName.url + "api/ElectronicInvoice/UpdateElectricInvoiceStatus", inputData)
                                .then(function(data){
                                    swal({
                                        title: "Thông báo",
                                        text: "Đã hủy hóa đơn thành công!",
                                        icon: "success",
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }, function(error) {
                                    swal({
                                        title: "Thông báo",
                                        text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                        icon: "error",
                                        dangerMode:true,
                                        button: "Đóng",
                                    }).then(function(){
                                        console.log(error);
                                        location.href = "#/businessInvoice";
                                    });
                                });
                                //#HTTP CALL API TO UPDATE STATUS INVOICE AFTER SIGNED
                            }, function(error) {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    console.log(error);
                                    location.href = "#/businessInvoice";
                                });
                            }); //#HTTP CALL API SIGN INVOICE

                        } // ### END DELETE INVOICE

                        else { // +++ MODIFY INVOICE
                            var inputData = {
                                'ID': itemId,
                                'statusCode': statusCode,
                                'enterpriseId': sessionStorage.enterpriseId
                            };

                            //HTTP CALL API TO UPDATE STATUS INVOICE AFTER SIGNED
                            $http.post(hostName.url + "api/ElectronicInvoice/UpdateElectricInvoiceStatus", inputData)
                            .then(function(data){
                                swal({
                                    title: "Thông báo",
                                    text: "Đã điều chỉnh hóa đơn thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }, function(error) {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    console.log(error);
                                    location.href = "#/businessInvoice";
                                });
                            });
                            //#HTTP CALL API TO UPDATE STATUS INVOICE AFTER SIGNED

                        } // ### END MODIFY INVOICE
                        

                    }, function(error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            console.log(error);
                            location.href = "#/businessInvoice";
                        });
                    });
                    //#HTTP ADD ADJUST INVOICE

                }  //#ADD NEW
                
            } // end of if flag == true

        }; // end of function Save
      
    };
    /******End controller for Edit Business Invoice******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 14.01.2019
 */
(function () {
    'use strict';

    //declare controller for Check InvoiceBook
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CheckInvoiceBookPageCtrl', CheckInvoiceBookPageCtrl);

    /******************************************/
    /*******controller for Check InvoiceBook*******/
    /******************************************/
    function CheckInvoiceBookPageCtrl($scope, $http, $state, hostName, fileReader, $location, layoutPaths) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';
        $scope.pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';

        //function then call  WEB API get ElectricInvoice's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);

                //file detail of invoice
                if (vm.rowCollection[n].fileListDetail != '')
                    vm.rowCollection[n].fileListDetail = $scope.pathTemp + vm.rowCollection[n].fileListDetail;
            }

            //display message into Console
            //console.log(response.data);
        };

        //function then call WEB API get ElectricInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectricInvoice's data
        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/GetAllElectricInvoice?enterpriseId=" + sessionStorage.enterpriseId + "&statusCode=UNCHECKED"
        }).then(successCallBack, errorCallBack);

        //save data to local variable when change Select's control
        $scope.selectChanged = function(objectSelect) {
            $scope.InvoiceTemplate = objectSelect;
        }

        $scope.uploadInvoiceBook = function (invoiceId) {
            sessionStorage.invoiceId = invoiceId;
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                  var fileName = $scope.file.name;
                  //console.log(sessionStorage.invoiceId);
                  if (fileName.indexOf(".xls") <= 0 && fileName.indexOf(".xlsx") <= 0 ) {
                      swal({
                          title: "Vui lòng chọn đúng file định dạng Excel!",
                          icon: "warning",
                          button: "Đóng"
                      }).then(function(){
                          return;
                      });
                  }
                  else {
                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("storagePath", layoutPaths.images.template + 'temp/');
                        data.append("file", $scope.file);
                        //console.log(data.getAll("storagePath")[0]);
    
                        //Upload file Template
                        var reg = {
                            url: hostName.url + 'api/SalesVoucher/UploadFileToDocmentLibrary',
                            method: 'POST',
                            data: data,
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            },
                        };

                        $http(reg).then(function(response) {
                            var inputData = {
                                'ID': sessionStorage.invoiceId, 
                                'fileListDetail': fileName, 
                              };
                              //debugger;
                              $http.post(hostName.url + "api/ElectricInvoice/UpdateElectricInvoiceFileList", inputData)
                              .then(function(){
                                swal({
                                    title: "Thông báo",
                                    text: "Tải file bảng kê thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                              }, function(){
                                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                    icon: "error",
                                    button: "Đóng"
                                });
                                console.log(error);
                              });
                        }, function(error) {
                            console.log(error);
                        })
                  }
                });
        };

        //filter ElectricInvoice's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&billNumber=" + billNumber.value + "&symbol=" + symbol.value + "&companyName=" + companyName.value + "&statusCode=UNCHECKED";
                //console.log(queryString);
            }
            else {
                var date = new Date();
                var nowYear = date.getFullYear();
                var nowMonth = date.getMonth();
                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&billNumber=&symbol=&companyName=" + "&statusCode=UNCHECKED";
                //console.log(queryString);
            }
            
            //call Webservice to get ElectricInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ElectricInvoice/SearchElectricInvoice_FTC?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectricInvoice's data

        //send invoice to Approve
        $scope.sendToApprove = function(invoiceId) {
            swal({
                title: "Bạn muốn chuyển hóa đơn chờ Duyệt?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            })
            .then(function(willDelete)  {
                if (willDelete) {
                    var inputData = {
                        'ID': invoiceId,
                        'statusCode': 'NOTPUBLISH',
                    };
                    $http.post(hostName.url + "api/ElectricInvoice/UpdateElectricInvoiceStatus", inputData).then(function(data){
                        $http({
                            method: 'GET',
                            url: hostName.url + "api/ElectricInvoice/UpdateElectricInvoicePublish?ID=" + invoiceId + '|' + "&userUpdated=" + user.ID + "&statusCode=NOTPUBLISH",
                        }).then(function (data) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                            // var fileName = data.data.substr(0, data.data.length - 1);
                            // var fileData = {
                            //     'ID': invoiceId,
                            //     'fileInvoice': fileName,
                            // };
                            
                            // $http.post(hostName.url + "api/ElectricInvoice/UploadElectricInvoiceToWait", fileData).then(function() {
                                
                            // }, function(error) {
                            //     swal({
                            //         title: "Thông báo",
                            //         text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            //         icon: "error",
                            //         dangerMode:true,
                            //         button: "Đóng",
                            //     }).then(function(){
                            //         $state.reload();
                            //     });
                            //     console.log(error);
                            // });
                        }, function(error) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                            console.log(error);
                        });
                    }, function(error) {
                        swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                        console.log(error);
                    });
                } else {
                    //no action;
                }
            });
        }
        
    };
    /******End controller for Check InvoiceBook******/
    
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
        return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 11.01.2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('AdjustInvoice1450Ctrl', AdjustInvoice1450Ctrl);

    /*******    +++ START CONTROLLER    *******/
    function AdjustInvoice1450Ctrl($scope, $http, $filter, hostName, $state) {

        $scope.isPrint = false;
        $scope.isCreatInvoice = false;
        $scope.isSave = true;
        $scope.IsDisabled = false;
        $scope.isPublic = false;
        $scope.GUITHUE = false;
        $scope.VIETINFO = false;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        /* VIETINFO */
        if (user.enterpriseId === '1644a09a-e9b6-49da-8826-f57d5143bbff') {
            $scope.VIETINFO = true;
        }
        /* TEST */
        if (user.enterpriseId === 'a7827ccf-fa96-4faa-8234-96caab4813f9') {
            $scope.VIETINFO = true;
        }

        //GET EXISTED DATA
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();

            //LAY THONG TIN HOA DON
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.HoaDon = response.data[0];

                if ($scope.HoaDon != undefined) {
                    $scope.inputBillNumber = $scope.HoaDon.billNumber;
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    $scope.inputDateOfInvoice = convertJSONDate($scope.HoaDon.dateOfInvoice);
                }
            }, function (reason) {
                console.log(reason);
            });

            //LAY THONG TIN THAY DOI HOA DON
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_Get?QD1450_HOADON_Id=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.Adjust = response.data[0];

                if ($scope.Adjust != undefined) {

                    $scope.GUITHUE = $scope.Adjust.GUITHUE;
                    //$scope.isPrint = true;

                    $scope.isPublic = true;

                    // if ($scope.Adjust.MaTinhTrang == 'LAPMOI') {

                    // };

                    // if ($scope.Adjust.MaTinhTrang == 'DUYET') {
                    //     $scope.isPrint = true;
                    // };

                    $scope.AdjustID = $scope.Adjust.ID;
                    //put ElectricInvoice's data into Form's controls
                    if ($scope.Adjust.typeOfAction == 'DELETE') {
                        $scope.isPrint = true;
                        $scope.isSave = false;
                        $scope.isCreatInvoice = false;
                        $scope.typeOfAction = {
                            name: 'DELETE',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'ADJUST') {
                        $scope.isPrint = false;
                        $scope.isCreatInvoice = true;
                        $scope.isSave = false;
                        $scope.typeOfAction = {
                            name: 'ADJUST',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'REPLACE') {
                        //$scope.isPrint = true;
                        $scope.typeOfAction = {
                            name: 'REPLACE',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'TBSS') {
                        $scope.isPrint = true;
                        $scope.isSave = false;
                        $scope.typeOfAction = {
                            name: 'TBSS',
                            disabled: true
                        };
                    }
                    var dateCreated = new Date($scope.Adjust.dateCreated);
                    $scope.inputDateCreated = new Date(dateCreated.getFullYear(), dateCreated.getMonth(), dateCreated.getDate());
                    $scope.inputDescription = $scope.Adjust.description;

                }
                else {
                    $scope.typeOfAction = {
                        name: 'DELETE',
                        disabled: false
                    };
                    //$scope.isPrint = false;
                    $scope.isSave = true;
                    $scope.isCreatInvoice = false;
                    $scope.inputDateCreated = new Date();
                }
            }, function (reason) {
                console.log(reason);
            });
        };

        //BACK TO LAST PAGE
        $scope.backPage = function () {
            location.href = sessionStorage.urlReturn;
        };

        //SEND MESSAGE 2 CQT
        $scope.send2CQT = function () {

            //GUI THONG BAO TU SERVER DUNG CHO PHIEN BAN BENH VIEN
            //Send2CQTFromServer();

            //GUI THONG BAO TU CLIENT DUNG CHO PHIEN BAN CLOUD
            Send2CQTFromClient();

        };


        //GUI CO QUAN THUE TU SERVER
        function Send2CQTFromServer() {

            $scope.IsDisabled = true;

            var inputData = {
                'ID': $scope.AdjustID,
                'enterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        swal({
                            title: "Thông báo",
                            text: "Đã gửi thông báo đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                    },

                    //ERRORS
                    function (errs) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi thông báo đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                        console.log(errs);
                    });

        };
        //### END GUI CO QUAN THUE TU SERVER


        //GUI CO QUAN THUE TU CLIENT
        function Send2CQTFromClient() {

            $scope.IsDisabled = true;

            var inputData = {
                'ID': $scope.AdjustID,
                'enterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        /* main */    // var UrlDownload = hostName.url + 'temp/';   // + user.enterpriseId  + '/';
                        var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },
                            data: JSON.stringify({
                                'Id': $scope.AdjustID,
                                'MLTDiep': '300',
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).success(function (data) {
                            swal({
                                title: "Thông báo",
                                text: data.Message,
                                // text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                            console.log(error);
                        });
                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });

        };
        //### END GUI CO QUAN THUE TU CLIENT


        //PRINT DOCUMENT
        $scope.printDocument = function () {
            $scope.IsDisabled = true;
            var typeOfAction = $scope.typeOfAction.name;
            if (typeOfAction == 'ADJUST') {
                //Print modify invoice document

            }
            if (typeOfAction == 'TBSS') {
                var _fileName = $scope.inputSymbol + '_' + $scope.inputBillNumber + '_' + "BienBanHuyHoaDon.pdf";
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_BB_TBSS?HoaDonId=" + sessionStorage.itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = _fileName; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    $scope.IsDisabled = false;
                    //console.log(contentType);
                }).error(function (message) {

                    console.log(message);
                    $scope.IsDisabled = false;
                });

            }
            else if (typeOfAction == 'DELETE') {
                var _fileName = $scope.inputSymbol + '_' + $scope.inputBillNumber + '_' + "BienBanHuyHoaDon.docx";
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_BBHUY?HoaDonId=" + sessionStorage.itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = _fileName; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    $scope.IsDisabled = false;
                    //console.log(contentType);
                }).error(function (message) {

                    console.log(message);
                    $scope.IsDisabled = false;
                });

            }
        };



        //XEM TRUOC NOI DUNG THONG BAO SAI SOT
        $scope.printNotifycation = function () {
            $scope.IsDisabled = true;

            var _fileName = $scope.inputSymbol + '_' + $scope.inputBillNumber + '_' + "ThongBaoSaiSot.docx";

            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_TBSS?HoaDonId=" + sessionStorage.itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
                //console.log(contentType);
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };


        //SAVE DATA TO DATABASE
        $scope.save = function () {
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var dateCreated = angular.element(document).find('#inputDateCreated')[0];
            var typeOfAction = $scope.typeOfAction.name;
            var description = angular.element(document).find('#inputDescription')[0];
            var flag = true;

            //check empty billNumber
            if (billNumber.value == '') {
                swal({
                    title: "Thông tin Số hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    billNumber.focus();
                });
                flag = false;
                return;
            };

            //check empty symbol
            if (symbol.value == '') {
                swal({
                    title: "Thông tin Ký hiệu",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    symbol.focus();
                });
                flag = false;
                return;
            };

            //check empty dateOfInvoice
            if (dateOfInvoice.value == '') {
                swal({
                    title: "Thông tin Ngày hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    dateOfInvoice.focus();
                });
                flag = false;
                return;
            };

            //check empty dateCreated
            if (dateCreated.value == '') {
                swal({
                    title: "Thông tin Ngày xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    dateCreated.focus();
                });
                flag = false;
                return;
            };

            //check empty typeOfAction
            if (typeOfAction == '') {
                swal({
                    title: "Thông tin Hình thức xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    typeOfAction.focus();
                });
                flag = false;
                return;
            };

            //check empty description
            if (description.value == '') {
                swal({
                    title: "Thông tin Lý do xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                $scope.IsDisabled = true;

                if ($scope.ID == undefined) { //ADD NEW

                    var statusCode = "";
                    if (typeOfAction == 'ADJUST') {
                        statusCode = 'MODIFY';
                    }
                    else if (typeOfAction == 'DELETE') {
                        statusCode = 'CANCEL';
                    }
                    else if (typeOfAction == 'REPLACE') {
                        statusCode = 'REPLACE';
                    }

                    var inputData = {
                        'QD1450_HOADON_Id': itemId,
                        'dateAdjust': reConvertJSONDate(dateCreated.value),
                        'typeOfAction': typeOfAction,
                        'description': description.value,
                        'userCreated': user.ID,
                        'enterpriseId': sessionStorage.enterpriseId
                    };

                    //HTTP ADD ADJUST INVOICE
                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI", inputData)
                        .then(function (data) {

                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });

                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                console.log(error);
                                location.href = "#/Invoice1450";
                            });
                        });
                    //#HTTP ADD ADJUST INVOICE

                }  //#ADD NEW

            } // end of if flag == true

        }; // end of function Save

        /* SEND EMAIL ĐIỀU CHỈNH/HỦY CHO KH*/
        $scope.sendEmailTBSS = function () {
            /* GET THÔNG TIN EMAIL */
            $scope.IsDisabled = true;
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId="
                    + sessionStorage.enterpriseId
            }).success(function (data) {
                $scope.IsDisabled = false;
                var _email = data[0].email;
                var TaxCode = data[0].MaSoThueBan;
                var SoHoaDon = data[0].billNumber;
                var HoaDonId = data[0].ID;
                var TrangThai;

                if ($scope.typeOfAction.name === "DELETE") {
                    TrangThai = "HỦY";
                }
                if ($scope.typeOfAction.name === "TBSS") {
                    TrangThai = "TBSS";
                }
                if ($scope.typeOfAction.name === "ADJUST") {
                    TrangThai = "ĐIỀU CHỈNH";
                }

                var Lydo = $scope.inputDescription;
                var NgayDieuChinh = $scope.inputDateCreated.toJSON();

                if (data[0].email === undefined || data[0].email === '' || data[0].email === null) {
                    /*HÓA ĐƠN CHƯA CÓ EMAIL */
                    swal({
                        title: "HÓA ĐƠN CHƯA CÓ ĐỊA CHỈ E-MAIL !",
                        icon: "error",
                        // dangerMode: true,
                        buttons: ["Đóng", "Thêm E-mail"],

                    }).then(function (data) {
                        /* NHẬP EMAIL GỬI */
                        if (data === true) {
                            swal({
                                title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                content: "input",
                                buttons: ["Đóng", "Gửi"],
                            }).then(function (email) {
                                /* GỬI EMAIL VỪA NHẬP */
                                if (email === '' || email === undefined || email === null) {
                                    return;
                                }
                                else {
                                    send_email_tbss(sessionStorage.enterpriseId, email, TaxCode, SoHoaDon, HoaDonId, TrangThai, Lydo, NgayDieuChinh);
                                }
                            })
                        }
                    })
                }

                else {
                    $scope.IsDisabled = false;
                    /* HĐ ĐÃ CÓ EMAIL */
                    swal({
                        title: "Gửi email cho" + "\n " + _email + " ?",
                        icon: "warning",
                        buttons: {
                            cancel: "Đóng",
                            chooseEmail: "Chọn email khác!",
                            confirm: "Gửi"
                        },
                        // closeOnClickOutside: false
                    }).then(function (data) {
                        if (data === true) {
                            $scope.IsDisabled = true;
                            send_email_tbss(sessionStorage.enterpriseId, _email, TaxCode, SoHoaDon, HoaDonId, TrangThai, Lydo, NgayDieuChinh);
                        }
                        if (data === 'chooseEmail') {
                            swal({
                                title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                content: "input",
                                buttons: ["Đóng", "Gửi"],
                                // closeOnClickOutside: false
                            }).then(function (email) {
                                /* GỬI EMAIL VỪA NHẬP */
                                if (email === '' || email === undefined || email === null) {
                                    // swal("Email không được bỏ trống!!!");
                                }
                                else {
                                    $scope.IsDisabled = true;
                                    send_email_tbss(sessionStorage.enterpriseId, email, TaxCode, SoHoaDon, HoaDonId, TrangThai, Lydo, NgayDieuChinh);
                                }
                            })
                        }
                    })
                }
            })
        }

        //LAP HOA DON DIEU CHINH
        $scope.changeInvoice = function () {
            location.href = '#/EditInvoice1450';
        };

        /* SEND EMAIL TBSS */
        function send_email_tbss(enterpriseId, email, taxCcode, soHoadon, hoaDonid, trangThai, lyDo, ngayDieuchinh) {
            $http({
                method: "POST",
                url: hostName.url + "api/QD1450/SendEmail_TBSS?EnterpriseId=" + enterpriseId + "&EmailAddress="
                    + email + "&TaxCode=" + taxCcode + "&SoHoaDon=" + soHoadon +
                    "&HoaDonId=" + hoaDonid + "&TrangThai=" + trangThai + "&LyDo=" + lyDo + "&NgayDieuChinh=" + ngayDieuchinh,
                // responseType: 'blob',
            }).success(function (data) {
                SwalSendEmailSuccess();
                $scope.IsDisabled = false;
            }).error(function (erro) {
                SwalSendEmailError();
                $scope.IsDisabled = false;
                console.log(erro);
            })
        }

    };

    /******  ### END CONTROLLER  ******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }

    /* EMAIL RESPONE */
    function SwalSendEmailSuccess() {
        swal({
            title: "ĐÃ GỬI E-MAIL THÀNH CÔNG !",
            icon: "success",
            buttons: "Đóng",
        })
    }

    function SwalSendEmailError() {
        swal({
            title: "GỬI E-MAIL THẤT BẠI !",
            icon: "error",
            buttons: "Đóng",
        })
    }
})();

/**
 * @author Nguyen Huu Tuan
 * created on 27.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('EditInvoice1450Ctrl', EditInvoice1450Ctrl);

    /*******    +++ START CONTROLLER    *******/
    function EditInvoice1450Ctrl($scope, $http, hostName, $filter, $state, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;

        $scope.inputDateOfInvoice = new Date();
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.isReview = false;
        $scope.isSave = true;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.HTTTs = [
            { ID: 'TM/CK', Name: 'TM/CK' },
            { ID: 'TM', Name: 'Tiền mặt' },
            { ID: 'CK', Name: 'Chuyển khoản' },
        ];
        $scope.HTTT = {};
        $scope.LoaiHoaDons = [];
        $scope.LoaiHoaDon = {};
        $scope.HTHoaDons = [];
        $scope.HTHoaDon = {};

        //LAY THONG TIN LOAI HOA DON VA HINH THUC HOA DON DA DANG KY CUA DON VI
        GetHTHD();
        function GetHTHD() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (data) {
                var _data = data.data[0];

                //CO MA
                if (_data != undefined && _data.HaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'COMA', Name: 'Có mã' });
                    $scope.HTHoaDon.selected = { ID: 'COMA', Name: 'Có mã' };
                }

                //KHONG CO MA
                if (_data != undefined && _data.DontHaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'KHONGMA', Name: 'Không có mã' });

                    if (_data.HaveCode == false)
                        $scope.HTHoaDon.selected = { ID: 'KHONGMA', Name: 'Không có mã' };
                }

                //GTGT
                if (_data != undefined && _data.UseVATInvoice == true) {
                    $scope.LoaiHoaDons.push({ ID: 'GTGT', Name: 'GTGT' });
                    $scope.LoaiHoaDon.selected = { ID: 'GTGT', Name: 'GTGT' };
                }

                //BAN HANG
                if (_data != undefined && _data.UseBillOfSale == true) {
                    $scope.LoaiHoaDons.push({ ID: 'BANHANG', Name: 'Bán hàng' });

                    if (_data.UseVATInvoice == false)
                        $scope.LoaiHoaDon.selected = { ID: 'BANHANG', Name: 'Bán hàng' };
                }

                //TAI SAN CONG
                if (_data != undefined && _data.UsePublicProperty == true) {
                    $scope.LoaiHoaDons.push({ ID: 'TSCONG', Name: 'TS công' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false)
                        $scope.LoaiHoaDon.selected = { ID: 'TSCONG', Name: 'TS công' };
                }

                //DU TRU QUOC GIA
                if (_data != undefined && _data.UseNationalReserve == true) {
                    $scope.LoaiHoaDons.push({ ID: 'DTQGIA', Name: 'DT Quốc Gia' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false)
                        $scope.LoaiHoaDon.selected = { ID: 'DTQGIA', Name: 'DT Quốc Gia' };
                }

                //KHAC
                if (_data != undefined && _data.UseOther == true) {
                    $scope.LoaiHoaDons.push({ ID: 'KHAC', Name: 'Khác' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false)
                        $scope.LoaiHoaDon.selected = { ID: 'KHAC', Name: 'Khác' };
                }

                //CHUNG TU
                if (_data != undefined && _data.UseDocument == true) {
                    $scope.LoaiHoaDons.push({ ID: 'CHUNGTU', Name: 'Chứng từ' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false
                        && _data.UseOther == false)
                        $scope.LoaiHoaDon.selected = { ID: 'CHUNGTU', Name: 'Chứng từ' };
                }

                $scope.HTTT.selected = { ID: 'TM/CK', Name: 'TM/CK' };
            }, function (error) {
                console.log(error);
            });
        };

        //+++   LAP MOI HOA DON DIEU CHINH
        if (sessionStorage.itemId != 'undefined'
            && sessionStorage.itemId != undefined
            && sessionStorage.editId == "undefined") {

            var itemId = sessionStorage.itemId;

            //GET EXISTED DATA
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) { //SUCCESS
                $scope.HoaDon = [];
                $scope.HoaDon = response.data[0];

                if ($scope.HoaDon != undefined) {
                    if ($scope.HoaDon.MaTinhTrang == 'CHOKETQUA'
                        || $scope.HoaDon.MaTinhTrang == '20002') {
                        $scope.isSave = false;
                        $scope.isPublic = false;
                    };

                    var dateOfInvoice = new Date($scope.HoaDon.dateOfInvoice);
                    // $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    // $scope.inputBillNumber = $scope.HoaDon.billNumber;

                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.Customer.selected = { ID: $scope.HoaDon.companyId, customerName: $scope.HoaDon.companyName };
                    $scope.inputPhone = $scope.HoaDon.phone;
                    $scope.inputEmail = $scope.HoaDon.email;
                    $scope.inputTaxCode = $scope.HoaDon.taxCode;
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.inputAddress = $scope.HoaDon.address;

                    $scope.inputNotes = $scope.HoaDon.description;

                    //SET SELECTED LIST
                    $scope.HTTT.selected = { ID: $scope.HoaDon.currencyOfPaymentName, Name: $scope.HoaDon.currencyOfPaymentName };
                    $scope.HTHoaDon.selected = { ID: $scope.HoaDon.HinhThucHoaDon, Name: $scope.HoaDon.HinhThucHoaDonName };
                    $scope.LoaiHoaDon.selected = { ID: $scope.HoaDon.LoaiHoaDonCQT, Name: $scope.HoaDon.LoaiHoaDonCQTName };

                    $scope.inputDescription1 = "Điều chỉnh cho hóa đơn, "
                        + "ký hiệu hóa đơn " + $scope.HoaDon.symbol
                        + " số hóa đơn " + ("0000000" + $scope.HoaDon.billNumber).slice(-7)
                        + ", ngày " + dateOfInvoice.getDate()
                        + " tháng " + (dateOfInvoice.getMonth() + 1)
                        + " năm " + dateOfInvoice.getFullYear();
                }
            }, function (reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE
        }

        //+++   NEW MODE
        else {

        };

        //THAY DOI THONG TIN HOA DON DIEU CHINH
        if (sessionStorage.editId != 'undefined') {

            $scope.isPublic = true;
            $scope.isReview = true;
            var itemId = sessionStorage.editId;

            //GET EXISTED DATA
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) { //SUCCESS
                $scope.HoaDon = [];
                $scope.HoaDon = response.data[0];

                if ($scope.HoaDon != undefined) {
                    if ($scope.HoaDon.MaTinhTrang == 'CHOKETQUA'
                        || $scope.HoaDon.MaTinhTrang == '20002') {
                        $scope.isSave = false;
                        $scope.isPublic = false;
                    };

                    var dateOfInvoice = new Date($scope.HoaDon.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    $scope.inputBillNumber = $scope.HoaDon.billNumber;

                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.Customer.selected = { ID: $scope.HoaDon.companyId, customerName: $scope.HoaDon.companyName };
                    $scope.inputPhone = $scope.HoaDon.phone;
                    $scope.inputEmail = $scope.HoaDon.email;
                    $scope.inputTaxCode = $scope.HoaDon.taxCode;
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.inputAddress = $scope.HoaDon.address;

                    $scope.inputNotes = $scope.HoaDon.description;

                    //SET SELECTED LIST
                    $scope.HTTT.selected = { ID: $scope.HoaDon.currencyOfPaymentName, Name: $scope.HoaDon.currencyOfPaymentName };
                    $scope.HTHoaDon.selected = { ID: $scope.HoaDon.HinhThucHoaDon, Name: $scope.HoaDon.HinhThucHoaDonName };
                    $scope.LoaiHoaDon.selected = { ID: $scope.HoaDon.LoaiHoaDonCQT, Name: $scope.HoaDon.LoaiHoaDonCQTName };

                    //CALL API GET HOA DON CHI TIET
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_GetById?QD1450_HOADON_Id=" + $scope.HoaDon.ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputID1 = $scope.Products[0].ID;
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VAT == '-' ? '-' :
                                $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputID2 = $scope.Products[1].ID;
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VAT == '-' ? '-' :
                                    $scope.Products[1].VATAmount;

                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputID3 = $scope.Products[2].ID;
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VAT == '-' ? '-' :
                                        $scope.Products[2].VATAmount;
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function (reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function (reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE

        };

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function (url) {
            location.href = url;
        };

        //CHANGE CUSTOMER
        $scope.changeCustomer = function (obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function (response) {
                var customer = response.data;

                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                }
            }, function (reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE

        } //#CHANGE CUSTOMER

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //FUNCTION SAVE DATA
        $scope.save = function () {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/

            //THONG TIN HOA DON
            var _dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var _LoaiHoaDon = $scope.LoaiHoaDon.selected == undefined
                ? -1 : $scope.LoaiHoaDon.selected.ID;
            var _HTHoaDon = $scope.HTHoaDon.selected == undefined
                ? -1 : $scope.HTHoaDon.selected.ID;

            //THONG TIN NGUOI MUA
            var _customerName = angular.element(document).find('#inputCustomerName')[0];
            var _taxCode = angular.element(document).find('#inputTaxCode')[0];
            var _phone = angular.element(document).find('#inputPhone')[0];
            var _email = angular.element(document).find('#inputEmail')[0];
            var _companyId = $scope.Customer.selected != undefined
                ? $scope.Customer.selected.ID : -1;
            var _companyName = $scope.Customer.selected != undefined
                ? $scope.Customer.selected.customerName : -1;

            var _address = angular.element(document).find('#inputAddress')[0];
            var _HTTTCode = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.ID : '';
            var _HTTTName = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.Name : '';
            var _notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 = angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 = angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 = angular.element(document).find('#inputVATAmount3')[0];

            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var flag = true;

            //check empty LoaiHoaDon
            if ($scope.LoaiHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusLoaiHoaDon');
                });
                flag = false;
                return;
            };

            //check empty HTHoaDon
            if ($scope.HTHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Hình thức hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusHTHoaDon');
                });
                flag = false;
                return;
            };

            //check empty Customer
            if ($scope.Customer.selected == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusCustomer');
                });
                flag = false;
                return;
            };

            //check empty address
            if (_address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' && description2.value == '' && price2.value == '' && description3.value == '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description1.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = (parseFloat(quan1) * parseFloat(val1));

                    if (vatAmount1.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                        amount1 = amountNotVAT1 + parseFloat(vatAmount);
                    }
                    else amount1 = amountNotVAT1;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = (parseFloat(quan2) * parseFloat(val2));

                    if (vatAmount2.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                        amount2 = amountNotVAT2 + parseFloat(vatAmount);
                    }
                    else amount2 = amountNotVAT2;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = (parseFloat(quan3) * parseFloat(val3));

                    if (vatAmount3.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                        amount3 = amountNotVAT3 + parseFloat(vatAmount);
                    }
                    else amount3 = amountNotVAT3;

                }

                totalAmount = parseFloat(isNaN(amount1) ? 0 : amount1
                    + isNaN(amount2) ? 0 : amount2
                        + isNaN(amount3) ? 0 : amount3);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);


                var inputData = {
                    'ID': sessionStorage.editId != 'undefined' ? sessionStorage.editId : -1,
                    'dateOfInvoice': reConvertJSONDate(_dateOfInvoice.value),
                    'LoaiHoaDon': '',
                    'LoaiDoanhThu': '',
                    'SoPhieu': '',
                    'MaHoSo': '',
                    'HinhThucHoaDon': _HTHoaDon,
                    'MaCoQuanThue': '',
                    'LoaiHoaDonCQT': _LoaiHoaDon,

                    'typeOfPaymentCode': _HTTTCode,
                    'typeOfPaymentName': _HTTTName,

                    'taxCode': _taxCode.value,
                    'customerName': _customerName.value,
                    'companyId': _companyId,
                    'companyName': _companyName,
                    'phone': _phone.value,
                    'email': _email.value,
                    'address': _address.value,
                    'accountNumber': '',
                    'medicalCode': '',
                    'hospitalizationNumber': '',
                    'healthInsuranceCardNumber': '',

                    'totalAmountNotVAT': totalAmountNotVAT,
                    'totalAmount': totalAmount,

                    'description': _notes.value,
                    'userCreated': user.ID,
                    'userUpdated': user.ID,
                    'EnterpriseId': sessionStorage.enterpriseId,
                };

                $http.post(hostName.url + "api/QD1450/QD1450_HOADON", inputData)
                    .then(function (response) { //UPDATE SUCCESS

                        var objResult = response.data;

                        var invoiceId = objResult.Data;
                        sessionStorage.editId = invoiceId;
                        //sessionStorage.itemId = invoiceId;
                        var flagDetail = true;

                        //KIEM TRA NEU CO HOA DON
                        if (invoiceId > 0) {

                            //UPDATE HOA DON THAY DOI CHO ID MOI
                            var _adjustData = {
                                'QD1450_HOADON_Id': sessionStorage.itemId,
                                'QD1450_HOADON_NewId': invoiceId,
                                'enterpriseId': sessionStorage.enterpriseId,
                            };
                            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_THAYDOI_ADJUST", _adjustData)
                                .then(function (success) { }, function (error) {
                                    flagDetail = false;
                                    console.log(error);
                                });

                            var _STT = 0;

                            //ADD DETAIL 1
                            if (description1.value != '') {
                                var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                                var vatAmount = 0;
                                if (vatAmount1.value != '-')
                                    vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID1 == undefined ? -1 : $scope.inputID1,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description1.value,
                                    'unitName': unitName1.value,
                                    'quantity': quantity1.value != '' ? quantity1.value : 1,
                                    'price': val1,
                                    'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                    'VAT': vat1.value != '' ? vat1.value : 0,
                                    'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                    'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 2
                            if (description2.value != '') {
                                var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                                var vatAmount = 0;
                                if (vatAmount2.value != '-')
                                    vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID2 == undefined ? -1 : $scope.inputID2,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description2.value,
                                    'unitName': unitName2.value,
                                    'quantity': quantity2.value != '' ? quantity2.value : 1,
                                    'price': price2.value,
                                    'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                    'VAT': vat2.value != '' ? vat2.value : 0,
                                    'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                    'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 3
                            if (description3.value != '') {
                                var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                                var vatAmount = 0;
                                if (vatAmount3.value != '-')
                                    vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID3 == undefined ? -1 : $scope.inputID3,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description3.value,
                                    'unitName': unitName3.value,
                                    'quantity': quantity3.value != '' ? quantity3.value : 1,
                                    'price': price3.value,
                                    'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                    'VAT': vat3.value != '' ? vat3.value : 0,
                                    'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                    'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            if (flagDetail == true) {
                                swal({
                                    title: "Thông báo",
                                    text: "Lưu dữ liệu thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                    icon: "error",
                                    dangerMode: true,
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            };

                        };
                        //### END KIEM TRA NEU CO HOA DON

                        //#UPDATE SUCCESS
                    },
                        function (reason) { //UPDATE ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                        }); //#UPDATE ERRORS


            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        //XEM TRUOC HOA DON
        $scope.reviewInvoice = function () {

            $scope.IsDisabled = true;

            var inputData = {
                'ID': sessionStorage.editId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            //===   REVIEW BY XML   ===
            // $http({
            //     method: 'POST',
            //     url: hostName.url + "api/QD1450/QD1450_HOADON_Review",
            //     data: inputData,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     //var _disposition = headers["content-disposition"];
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "HoaDon_" + _fileName + ".xml";  
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     //console.log(contentType);

            //     $scope.IsDisabled = false;

            // }).error(function (message) {
            //     $scope.IsDisabled = false;
            //     //console.log(message);
            // });


            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_ReviewPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "HoaDon_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.IsDisabled = false;

            }).error(function (message) {
                $scope.IsDisabled = false;
                //console.log(message);
            });

        };

        //PHAT HANH HOA DON GUI CO QUAN THUE
        $scope.publishInvoice = function () {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.editId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },
                            data: JSON.stringify({
                                'Id': sessionStorage.itemId,
                                'MLTDiep': $scope.LoaiThongDiep,
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                            console.log(error);
                        });

                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });

        };

    };
    /******  ### END CONTROLLER  ******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 27.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('Invoice1450Ctrl', Invoice1450Ctrl);

    /*******    +++ START CONTROLLER    *******/
    function Invoice1450Ctrl($scope, $http, $state, hostName, $filter, fileReader, $window) {

        //GENERAL VARIABLES 
        $scope.smartTablePageSize = 10;
        $scope.TotalAmount = 0;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        vm.TotalAmount = 0;
        vm.TotalInvoice = 0;
        vm.isXML = 0;
        $scope.Statuses = [];
        $scope.Status = {};
        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        sessionStorage.editId = undefined;
        sessionStorage.editable = false;
        $scope.checkDate = convertJSONDate(new Date());
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathFileInvoice = hostName.url;
        var mutiEnterprise = ''
        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;

        //INIT FORM
        ngInit();
        function ngInit() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                    + "LoaiTinhTrang=200&EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (response) {
                $scope.Statuses = response.data;
            }, function (error) {
                //NA
            });
            //
            // $http({
            //     method: "GET",
            //     url: hostName.url + "api/Enterprise/ListEnterprise"
            // }).then(function (response) {
            //     console.log(response);
            //     $scope.EnterPrises = response.data;
            // }, function (error) {
            //     //NA
            // });

        };

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) {
                if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
                    $scope.isShow = true;
            };
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data[0];
            vm.TotalAmount = 0;
            var total = response.data[1][0].totalAmount;

            if (total != undefined) {
                vm.TotalAmount = total; //.replace(/,/g,".");
            }

            vm.TotalInvoice = response.data[1][0].totalInvoice;
            vm.isXML = response.data[1][0].isXML;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        toDate = new Date();
        fromDate = new Date(nowYear, nowMonth, 1);
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=0&customerName=&billNumber=&symbol=&taxCode=";
        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_HOADON_Search?" + queryString
        }).then(successCallBack, errorCallBack);

        //redirect to other pages
        $scope.open = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.urlReturn = '#/Invoice1450';
            location.href = url;
        };

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/file/d/1zx23jdvYJrb0IeLjeL-PLPucKpK0EBTk/view?usp=sharing");
        }

        //edit invoice's general information
        $scope.editInvoice = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.editable = true;
            sessionStorage.urlReturn = '#/Invoice1450';
            location.href = url;
        };

        //Create new Invoice
        $scope.createInvoice = function () {
            location.href = '#/NewInvoice1450';
        };

        //CREATE REFERENCE INVOICE
        $scope.referenceInvoice = function () {
            location.href = '#/ReferenceInvoice';
        };

        //filter ElectronicInvoice's data

        $scope.findData = function () {
            searchData();
        };

        //admin chon don vi
        $scope.changeOrganization = function changeOrganization(enterpriseId) {
            mutiEnterprise = enterpriseId.ID;
        }
        function searchData() {

            vm.rowCollection = [];
            vm.TotalAmount = 0;
            $scope.TotalAmount = 0;
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : '';
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            // var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            var enterpriseId = ''
            if (mutiEnterprise === '') {
                enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            }
            else {
                enterpriseId = mutiEnterprise;
                console.log(sessionStorage.enterpriseId);
                sessionStorage.enterpriseId = enterpriseId
            }
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&taxCode=" + taxCode.value + "&billNumber=" + billNumber.value + "&symbol=" + symbol.value + "&customerName=" + customerName.value + "&statusId=" + statusId + "&invoiceTemplateId=" + invoiceTemplateId;
                //console.log(queryString);
            }

            else {
                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&taxCode=";
                //console.log(queryString);
            }

            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data

        //+++   LAY KET QUA PHAN HOI TU CO QUAN THUE THEO MA THONG DIEP
        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo",
                        text: "Đã có kết quả phản hồi từ Cơ quan Thuế!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo",
                        text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning",
                        dangerMode: true,
                        button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileHoaDon = function (FileHoaDon, MaSoThueBan, KyHieu, SoHoaDon) {

            $scope.OpenFile = true;

            // var inputData = {
            //     'FileHoaDon': FileHoaDon,
            //     'EnterpriseId': sessionStorage.enterpriseId
            // };

            var _today = new Date();
            var _fileName = MaSoThueBan + '_' + KyHieu + '_' + SoHoaDon;

            $http({
                method: 'GET',
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetFile?"
                    + "FileHoaDon=" + FileHoaDon + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };


        //+++   GET BAN THE HIEN CUA HOA DON
        $scope.GetBanTheHien = function (HoaDonID, MaSoThueBan, KyHieu, SoHoaDon) {
            $scope.OpenFile = true;

            var inputData = {
                'ID': HoaDonID,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            var _fileName = MaSoThueBan + '_' + KyHieu + '_' + SoHoaDon;

            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_PublishPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData 
            }).success(function (data, status, headers) {
                headers = headers();
                // var _disposition = headers["content-disposition"];
                // var contentType = headers["content-type"] || "application/octet-stream";
                // var blob = new Blob([data], { type: contentType });
                // var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                // var url = urlCreator.createObjectURL(blob);
                // var a = document.createElement("a");
                // document.body.appendChild(a);
                // a.style = "display: none";
                // a.href = url;
                //// a.target = "_blank";/* MỞ RA 1 TAB MỚI */
                // a.download = _fileName + ".pdf";/* DOWN LOAD FILE  */
                // a.click();
                // window.URL.revokeObjectURL(url);

                /* CLICK BUTTON CREATE NEW TAB 26-05-2022 */
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                console.log(a);
                a.style = "display: none";
                a.href = url;
                a.target = "_blank", /* MỞ RA 1 TAB MỚI */
                    a.click();

                // a.download = _fileName + ".pdf";/* DOWN LOAD FILE  */
                // a.click();

                // window.URL.revokeObjectURL(url);

                /* 26-05-2022 */
                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });
        };


        //+++   GET BAN CHUYEN DOI CUA HOA DON DIEN TU
        $scope.GetChuyenDoi = function (HoaDonID, MaSoThueBan, KyHieu, SoHoaDon) {
            $scope.OpenFile = true;

            var inputData = {
                'ID': HoaDonID,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            //var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');
            var _fileName = MaSoThueBan + '_' + KyHieu + '_' + SoHoaDon;

            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_PublishPDF_CD",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.target = "_blank";/* MỞ RA 1 TAB MỚI */
                // a.download = _fileName + "_CD.pdf";
                a.click();
                // window.URL.revokeObjectURL(url);
                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });
        };

        /* GỬI EMAIL */
        $scope.GuiEmail = function (HoaDonID, FileHoaDon, MaSoThueBan, KyHieu, SoHoaDon) {
            $scope.OpenFile = true;
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + HoaDonID + "&EnterpriseId="
                    + sessionStorage.enterpriseId
            }).success(function (data) {
                $scope.IsDisabled = false;
                var fileHD = data[0].FileHoaDonXML.replace("-Signed", "-TCT");
                var FileHD = sessionStorage.enterpriseId + "/202/" + fileHD;
                var _email = data[0].email;
                if (data[0].email === undefined || data[0].email === '' || data[0].email === null) {
                    /*HÓA ĐƠN CHƯA CÓ EMAIL => NHẬP EMAIL => GỬI*/
                    swal({
                        title: "HÓA ĐƠN CHƯA CÓ ĐỊA CHỈ E-MAIL !",
                        icon: "error",
                        buttons: ["Đóng", "Thêm E-mail"],
                    }).then(function (data) {
                        if (data === true) {
                            swal({
                                title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                content: "input",
                                buttons: ["Đóng", "Gửi"],
                                // closeOnClickOutside: false
                            }).then(function (email) {
                                /* GỬI EMAIL VỪA NHẬP */
                                if (email === '' || email === undefined || email === null) {
                                    // swal("Email không được bỏ trống!!!");
                                }
                                else {
                                    $scope.OpenFile = true;
                                    send_mail(FileHD, email, MaSoThueBan, SoHoaDon, HoaDonID);

                                }
                            })
                        }
                        else {
                            console.log("KH lựa chọn không thêm địa chỉ email!");
                        }
                    })
                    $scope.OpenFile = false;
                }
                else {
                    /* HÓA ĐƠN ĐÃ CÓ EMAIL => GỬI*/
                    $scope.OpenFile = false;
                    swal({
                        title: "Gửi email cho" + "\n " + _email + " ?",
                        icon: "warning",
                        // buttons: ["Chọn email khác!", "Gửi"],
                        buttons: {
                            cancel: "Đóng",
                            chooseEmail: "Chọn email khác!",
                            confirm: "Gửi"
                        },
                        // closeOnClickOutside: false
                    }).then(function (data) {
                        /* GỬI EMAIL TRONG HÓA ĐƠN => GỬI */
                        if (data === true) {
                            $scope.OpenFile = true;
                            send_mail(FileHD, _email, MaSoThueBan, SoHoaDon, HoaDonID);
                        }
                        /* NHẬP EMAIL KHÁC => GỬI */
                        if (data === 'chooseEmail') {
                            swal({
                                title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                content: "input",
                                buttons: ["Đóng", "Gửi"],
                                // closeOnClickOutside: false
                            }).then(function (email) {
                                /* GỬI EMAIL VỪA NHẬP */
                                if (email === '' || email === undefined || email === null) {
                                    // swal("Email không được bỏ trống!!!");
                                }
                                else {
                                    $scope.OpenFile = true;
                                    send_mail(FileHD, email, MaSoThueBan, SoHoaDon, HoaDonID);
                                }
                            })
                        }
                    })
                }
            })
        }

        /* SEND EMAIL TO CUSTOMER */
        function send_mail(fileHD, email, masoThueBan, soHoaDon, hoadonID) {
            $http({
                method: "POST",
                url: hostName.url + "api/QD1450/SendEmail?FileHoaDon=" + fileHD + "&EmailAddress="
                    + email + "&TaxCode=" + masoThueBan + "&SoHoaDon=" + soHoaDon + "&HoaDonId=" + hoadonID,
                // responseType: 'blob',    

            }).success(function (data) {
                $scope.OpenFile = false;
                SwalSendEmailSuccess();
            }
            ).error(function (erro) {
                SwalSendEmailError();
                $scope.OpenFile = false;
                console.log(erro);
            })
        }
    };


    function SwalSendEmailSuccess() {
        swal({
            title: "ĐÃ GỬI E-MAIL THÀNH CÔNG !",
            icon: "success",
            buttons: "Đóng",
        })
        // $scope.OpenFile = true;
    }
    function SwalSendEmailError() {
        swal({
            title: "GỬI E-MAIL THẤT BẠI !",
            icon: "error",
            buttons: "Đóng",
        })
        // $scope.OpenFile = true;
    }
    /******  ### END CONTROLLER  ******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 27.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('NewInvoice1450Ctrl', NewInvoice1450Ctrl);

    /*******    +++ START CONTROLLER    *******/
    function NewInvoice1450Ctrl($scope, $window, $http, hostName, $filter, $state, fileReader, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;

        $scope.inputDateOfInvoice = new Date();
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.isReview = false;
        $scope.isSave = true;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.HTTTs = [
            { ID: 'TM/CK', Name: 'TM/CK' },
            { ID: 'TM', Name: 'Tiền mặt' },
            { ID: 'CK', Name: 'Chuyển khoản' },
            { ID: 'THE', Name: 'Thẻ' },
        ];
        $scope.HTTT = {};
        $scope.LoaiHoaDons = [];
        $scope.LoaiHoaDon = {};
        $scope.HTHoaDons = [];
        $scope.HTHoaDon = {};

        //LAY THONG TIN LOAI HOA DON VA HINH THUC HOA DON DA DANG KY CUA DON VI
        GetHTHD();
        function GetHTHD() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (data) {
                var _data = data.data[0];

                //CO MA
                if (_data != undefined && _data.HaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'COMA', Name: 'Có mã' });
                    $scope.HTHoaDon.selected = { ID: 'COMA', Name: 'Có mã' };
                }

                //KHONG CO MA
                if (_data != undefined && _data.DontHaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'KHONGMA', Name: 'Không có mã' });

                    if (_data.HaveCode == false)
                        $scope.HTHoaDon.selected = { ID: 'KHONGMA', Name: 'Không có mã' };
                }

                //GTGT
                if (_data != undefined && _data.UseVATInvoice == true) {
                    $scope.LoaiHoaDons.push({ ID: 'GTGT', Name: 'GTGT' });
                    $scope.LoaiHoaDon.selected = { ID: 'GTGT', Name: 'GTGT' };
                }

                //BAN HANG
                if (_data != undefined && _data.UseBillOfSale == true) {
                    $scope.LoaiHoaDons.push({ ID: 'BANHANG', Name: 'Bán hàng' });

                    if (_data.UseVATInvoice == false)
                        $scope.LoaiHoaDon.selected = { ID: 'BANHANG', Name: 'Bán hàng' };
                }

                // //TAI SAN CONG
                // if (_data != undefined && _data.UsePublicProperty == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'TSCONG', Name: 'TS công' });

                //     if (_data.UseVATInvoice == false
                //         && _data.UseBillOfSale == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'TSCONG', Name: 'TS công' };
                // }

                //DU TRU QUOC GIA
                if (_data != undefined && _data.UseNationalReserve == true) {
                    $scope.LoaiHoaDons.push({ ID: 'DTQGIA', Name: 'DT Quốc Gia' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false)
                        $scope.LoaiHoaDon.selected = { ID: 'DTQGIA', Name: 'DT Quốc Gia' };
                }

                //KHAC
                if (_data != undefined && _data.UseOther == true) {
                    $scope.LoaiHoaDons.push({ ID: 'KHAC', Name: 'Khác' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false)
                        $scope.LoaiHoaDon.selected = { ID: 'KHAC', Name: 'Khác' };
                }

                //CHUNG TU
                if (_data != undefined && _data.UseDocument == true) {
                    $scope.LoaiHoaDons.push({ ID: 'CHUNGTU', Name: 'Chứng từ' });

                    if (_data.UseVATInvoice == false
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false
                        && _data.UseOther == false)
                        $scope.LoaiHoaDon.selected = { ID: 'CHUNGTU', Name: 'Chứng từ' };
                }

                $scope.HTTT.selected = { ID: 'TM/CK', Name: 'TM/CK' };
            }, function (error) {
                console.log(error);
            });
        };

        //+++   EDIT MODE
        if (sessionStorage.itemId != 'undefined' && sessionStorage.itemId != undefined) {

            $scope.isPublic = true;
            $scope.isReview = true;
            var itemId = sessionStorage.itemId;

            //GET EXISTED DATA
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) { //SUCCESS
                $scope.HoaDon = [];
                $scope.HoaDon = response.data[0];

                if ($scope.HoaDon != undefined) {
                    if ($scope.HoaDon.MaTinhTrang == 'CHOKETQUA'
                        || $scope.HoaDon.MaTinhTrang == '20002') {
                        $scope.isSave = false;
                        $scope.isPublic = false;
                    };

                    var dateOfInvoice = new Date($scope.HoaDon.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    $scope.inputBillNumber = $scope.HoaDon.billNumber;

                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.Customer.selected = { ID: $scope.HoaDon.companyId, customerName: $scope.HoaDon.companyName };
                    $scope.inputPhone = $scope.HoaDon.phone;
                    $scope.inputEmail = $scope.HoaDon.email;
                    $scope.inputTaxCode = $scope.HoaDon.taxCode;
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.inputAddress = $scope.HoaDon.address;

                    $scope.inputNotes = $scope.HoaDon.description;

                    $scope.CCCDan = $scope.HoaDon.CCCDan;
                    $scope.SHChieu = $scope.HoaDon.SHChieu;
                    $scope.MDVQHNSach = $scope.HoaDon.MDVQHNSach;
                    //SET SELECTED LIST 
                    $scope.HTTT.selected = { ID: $scope.HoaDon.typeOfPaymentCode, Name: $scope.HoaDon.typeOfPaymentName };
                    $scope.HTHoaDon.selected = { ID: $scope.HoaDon.HinhThucHoaDon, Name: $scope.HoaDon.HinhThucHoaDonName };
                    $scope.LoaiHoaDon.selected = { ID: $scope.HoaDon.LoaiHoaDonCQT, Name: $scope.HoaDon.LoaiHoaDonCQTName };

                    //CALL API GET HOA DON CHI TIET
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_GetById?QD1450_HOADON_Id=" + $scope.HoaDon.ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) { //SUCCESS
                        $scope.Products = response.data;
                        console.log($scope.Products);
                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputID1 = $scope.Products[0].ID;
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VAT == '-' ? '-' :
                                $scope.Products[0].VATAmount;

                            //DETAIL 2  
                            if ($scope.Products.length > 1) {
                                $scope.inputID2 = $scope.Products[1].ID;
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VAT == '-' ? '-' :
                                    $scope.Products[1].VATAmount;

                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputID3 = $scope.Products[2].ID;
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VAT == '-' ? '-' :
                                        $scope.Products[2].VATAmount;
                                    //DETAIL 4
                                    if ($scope.Products.length > 3) {
                                        $scope.inputID4 = $scope.Products[3].ID;
                                        $scope.inputDescription4 = $scope.Products[3].goodAndServiceName;
                                        $scope.inputUnitName4 = $scope.Products[3].unitName;
                                        $scope.inputQuantity4 = $scope.Products[3].quantity;
                                        $scope.inputPrice4 = $scope.Products[3].price;
                                        $scope.inputVAT4 = $scope.Products[3].VAT;
                                        $scope.inputVATAmount4 = $scope.Products[3].VAT == '-' ? '-' :
                                            $scope.Products[3].VATAmount;
                                        //DETAIL 5
                                        if ($scope.Products.length > 4) {
                                            $scope.inputID5 = $scope.Products[4].ID;
                                            $scope.inputDescription5 = $scope.Products[4].goodAndServiceName;
                                            $scope.inputUnitName5 = $scope.Products[4].unitName;
                                            $scope.inputQuantity5 = $scope.Products[4].quantity;
                                            $scope.inputPrice5 = $scope.Products[4].price;
                                            $scope.inputVAT5 = $scope.Products[4].VAT;
                                            $scope.inputVATAmount5 = $scope.Products[4].VAT == '-' ? '-' :
                                                $scope.Products[4].VATAmount;
                                            //DETAIL 6
                                            if ($scope.Products.length > 5) {
                                                $scope.inputID6 = $scope.Products[5].ID;
                                                $scope.inputDescription6 = $scope.Products[5].goodAndServiceName;
                                                $scope.inputUnitName6 = $scope.Products[5].unitName;
                                                $scope.inputQuantity6 = $scope.Products[5].quantity;
                                                $scope.inputPrice6 = $scope.Products[5].price;
                                                $scope.inputVAT6 = $scope.Products[5].VAT;
                                                $scope.inputVATAmount6 = $scope.Products[5].VAT == '-' ? '-' :
                                                    $scope.Products[5].VATAmount;
                                                //DETAIL 7
                                                if ($scope.Products.length > 6) {
                                                    $scope.inputID7 = $scope.Products[6].ID;
                                                    $scope.inputDescription7 = $scope.Products[6].goodAndServiceName;
                                                    $scope.inputUnitName7 = $scope.Products[6].unitName;
                                                    $scope.inputQuantity7 = $scope.Products[6].quantity;
                                                    $scope.inputPrice7 = $scope.Products[6].price;
                                                    $scope.inputVAT7 = $scope.Products[6].VAT;
                                                    $scope.inputVATAmount7 = $scope.Products[6].VAT == '-' ? '-' :
                                                        $scope.Products[6].VATAmount;
                                                    //DETAIL 8
                                                    if ($scope.Products.length > 7) {
                                                        $scope.inputID8 = $scope.Products[7].ID;
                                                        $scope.inputDescription8 = $scope.Products[7].goodAndServiceName;
                                                        $scope.inputUnitName8 = $scope.Products[7].unitName;
                                                        $scope.inputQuantity8 = $scope.Products[7].quantity;
                                                        $scope.inputPrice8 = $scope.Products[7].price;
                                                        $scope.inputVAT8 = $scope.Products[7].VAT;
                                                        $scope.inputVATAmount8 = $scope.Products[7].VAT == '-' ? '-' :
                                                            $scope.Products[7].VATAmount;
                                                        //DETAIL 9
                                                        if ($scope.Products.length > 8) {
                                                            $scope.inputID9 = $scope.Products[8].ID;
                                                            $scope.inputDescription9 = $scope.Products[8].goodAndServiceName;
                                                            $scope.inputUnitName9 = $scope.Products[8].unitName;
                                                            $scope.inputQuantity9 = $scope.Products[8].quantity;
                                                            $scope.inputPrice9 = $scope.Products[8].price;
                                                            $scope.inputVAT9 = $scope.Products[8].VAT;
                                                            $scope.inputVATAmount9 = $scope.Products[8].VAT == '-' ? '-' :
                                                                $scope.Products[8].VATAmount;
                                                            //DETAIL 10
                                                            if ($scope.Products.length > 9) {
                                                                $scope.inputID10 = $scope.Products[9].ID;
                                                                $scope.inputDescription10 = $scope.Products[9].goodAndServiceName;
                                                                $scope.inputUnitName10 = $scope.Products[9].unitName;
                                                                $scope.inputQuantity10 = $scope.Products[9].quantity;
                                                                $scope.inputPrice10 = $scope.Products[9].price;
                                                                $scope.inputVAT10 = $scope.Products[9].VAT;
                                                                $scope.inputVATAmount10 = $scope.Products[9].VAT == '-' ? '-' :
                                                                    $scope.Products[9].VATAmount;

                                                            } //#DETAIL 10
                                                        } //#DETAIL 9
                                                    } //#DETAIL 8
                                                } //#DETAIL 7
                                            } //#DETAIL 6
                                        } //#DETAIL 5
                                    } //#DETAIL 4

                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function (reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function (reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE
        }

        //+++   NEW MODE
        else {
            //2025-10-16-
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
            }).then(function (response) { //SUCCESS     
                // $scope.InvoiceTemplate.selected = { ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName };
                $scope.invoiceTemplateId = response.data[0].ID;
                $scope.inputSymbol = response.data[0].symbol;

            }, function (error) { //ERROR
                //console.log(error);
            });
            //2025-10-16-
        };

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function (url) {
            location.href = url;
        };

        //CHANGE CUSTOMER
        $scope.changeCustomer = function (obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function (response) {
                var customer = response.data;
                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                    /* THÊM EMAIL + SDT KHI CHỌN TÊN ĐƠN VỊ */
                    $scope.inputEmail = customer.email === null || customer.email === undefined || customer.email === '' ? '' : customer.email;
                    // $scope.inputPhone = customer.phone === null || customer.phone === undefined || customer.phone === '' ? '' : customer.phone;
                }
            }, function (reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE

        } //#CHANGE CUSTOMER

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice1.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice2.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice3.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 4 of Description 4
        $scope.calVATAmount4 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice4.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount4')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 5 of Description 5
        $scope.calVATAmount5 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice5.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount5')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 6 of Description 6
        $scope.calVATAmount6 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice6.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount6')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 7 of Description 7
        $scope.calVATAmount7 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice7.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount7')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 8 of Description 8
        $scope.calVATAmount8 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice8.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount8')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 9 of Description 9
        $scope.calVATAmount9 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice9.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount9')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 10 of Description 10
        $scope.calVATAmount10 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice10.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount10')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //FUNCTION SAVE DATA
        $scope.save = function () {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/

            //THONG TIN HOA DON
            var _dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var _LoaiHoaDon = $scope.LoaiHoaDon.selected == undefined
                ? -1 : $scope.LoaiHoaDon.selected.ID;
            var _HTHoaDon = $scope.HTHoaDon.selected == undefined
                ? -1 : $scope.HTHoaDon.selected.ID;

            //THONG TIN NGUOI MUA
            var _customerName = angular.element(document).find('#inputCustomerName')[0];
            var _taxCode = angular.element(document).find('#inputTaxCode')[0];
            var _phone = angular.element(document).find('#inputPhone')[0];
            var _email = angular.element(document).find('#inputEmail')[0];
            var _companyId = $scope.Customer.selected != undefined
                ? $scope.Customer.selected.ID : -1;
            var _companyName = $scope.Customer.selected != undefined
                ? $scope.Customer.selected.customerName : '';

            var _address = angular.element(document).find('#inputAddress')[0];
            var _HTTTCode = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.ID : '';
            var _HTTTName = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.Name : '';
            var _notes = angular.element(document).find('#inputNotes')[0];

            var _CCCDan = angular.element(document).find("#CCCDan")[0];
            var _SHChieu = angular.element(document).find("#SHChieu")[0];

            var _MDVQHNSach = angular.element(document).find("#MDVQHNSach")[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 = angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 = angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 = angular.element(document).find('#inputVATAmount3')[0];

            //detail 4  
            var description4 = angular.element(document).find('#inputDescription4')[0];
            var price4 = angular.element(document).find('#inputPrice4')[0];
            var unitName4 = angular.element(document).find('#inputUnitName4')[0];
            var quantity4 = angular.element(document).find('#inputQuantity4')[0];
            var vat4 = angular.element(document).find('#inputVAT4')[0];
            var vatAmount4 = angular.element(document).find('#inputVATAmount4')[0];

            //detail 5  
            var description5 = angular.element(document).find('#inputDescription5')[0];
            var price5 = angular.element(document).find('#inputPrice5')[0];
            var unitName5 = angular.element(document).find('#inputUnitName5')[0];
            var quantity5 = angular.element(document).find('#inputQuantity5')[0];
            var vat5 = angular.element(document).find('#inputVAT5')[0];
            var vatAmount5 = angular.element(document).find('#inputVATAmount5')[0];

            //detail 6
            var description6 = angular.element(document).find('#inputDescription6')[0];
            var price6 = angular.element(document).find('#inputPrice6')[0];
            var unitName6 = angular.element(document).find('#inputUnitName6')[0];
            var quantity6 = angular.element(document).find('#inputQuantity6')[0];
            var vat6 = angular.element(document).find('#inputVAT6')[0];
            var vatAmount6 = angular.element(document).find('#inputVATAmount6')[0];

            //detail 7
            var description7 = angular.element(document).find('#inputDescription7')[0];
            var price7 = angular.element(document).find('#inputPrice7')[0];
            var unitName7 = angular.element(document).find('#inputUnitName7')[0];
            var quantity7 = angular.element(document).find('#inputQuantity7')[0];
            var vat7 = angular.element(document).find('#inputVAT7')[0];
            var vatAmount7 = angular.element(document).find('#inputVATAmount7')[0];

            //detail 8
            var description8 = angular.element(document).find('#inputDescription8')[0];
            var price8 = angular.element(document).find('#inputPrice8')[0];
            var unitName8 = angular.element(document).find('#inputUnitName8')[0];
            var quantity8 = angular.element(document).find('#inputQuantity8')[0];
            var vat8 = angular.element(document).find('#inputVAT8')[0];
            var vatAmount8 = angular.element(document).find('#inputVATAmount8')[0];

            //detail 9
            var description9 = angular.element(document).find('#inputDescription9')[0];
            var price9 = angular.element(document).find('#inputPrice9')[0];
            var unitName9 = angular.element(document).find('#inputUnitName9')[0];
            var quantity9 = angular.element(document).find('#inputQuantity9')[0];
            var vat9 = angular.element(document).find('#inputVAT9')[0];
            var vatAmount9 = angular.element(document).find('#inputVATAmount9')[0];

            //detail 10
            var description10 = angular.element(document).find('#inputDescription10')[0];
            var price10 = angular.element(document).find('#inputPrice10')[0];
            var unitName10 = angular.element(document).find('#inputUnitName10')[0];
            var quantity10 = angular.element(document).find('#inputQuantity10')[0];
            var vat10 = angular.element(document).find('#inputVAT10')[0];
            var vatAmount10 = angular.element(document).find('#inputVATAmount10')[0];

            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var val4 = $filter('replace')(price4.value, ',', '');
            var val5 = $filter('replace')(price5.value, ',', '');
            var val6 = $filter('replace')(price6.value, ',', '');
            var val7 = $filter('replace')(price7.value, ',', '');
            var val8 = $filter('replace')(price8.value, ',', '');
            var val9 = $filter('replace')(price9.value, ',', '');
            var val10 = $filter('replace')(price10.value, ',', '');

            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var quan4 = $filter('replace')(quantity4.value, ',', '');
            var quan5 = $filter('replace')(quantity5.value, ',', '');
            var quan6 = $filter('replace')(quantity6.value, ',', '');
            var quan7 = $filter('replace')(quantity7.value, ',', '');
            var quan8 = $filter('replace')(quantity8.value, ',', '');
            var quan9 = $filter('replace')(quantity9.value, ',', '');
            var quan10 = $filter('replace')(quantity10.value, ',', '');
            var flag = true;

            //check empty LoaiHoaDon
            if ($scope.LoaiHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusLoaiHoaDon');
                });
                flag = false;
                return;
            };

            //check empty HTHoaDon
            if ($scope.HTHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Hình thức hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusHTHoaDon');
                });
                flag = false;
                return;
            };

            if (_customerName.value == '') {
                //check empty Customer
                if ($scope.Customer.selected == undefined) {
                    swal({
                        title: "Vui lòng nhập thông tin \"Đơn vị\"",
                        icon: "warning",
                        button: "Đóng"
                    }).then(function () {
                        $scope.$broadcast('SetFocusCustomer');
                    });
                    flag = false;
                    return;
                };
            }
            //check empty Customer
            // if ($scope.Customer.selected == undefined) {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Đơn vị\"",
            //         icon: "warning",
            //         button: "Đóng"
            //     }).then(function () {
            //         $scope.$broadcast('SetFocusCustomer');
            //     });
            //     flag = false;
            //     return;
            // };

            //check empty address
            if (_address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == ''
                && description2.value == '' && price2.value == ''
                && description3.value == '' && price3.value == ''
                && description4.value == '' && price4.value == ''
                && description5.value == '' && price5.value == ''
                && description6.value == '' && price6.value == ''
                && description7.value == '' && price7.value == ''
                && description8.value == '' && price8.value == ''
                && description9.value == '' && price9.value == ''
                && description10.value == '' && price10.value == ''
                && $rootScope.FileTemplateData == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description3.focus();
                });
                flag = false;
                return;
            };
            /* CÒN CHECK EMPTY 4 => 10 */

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;

                var amount4 = 0;
                var amountNotVAT4 = 0;
                var amount5 = 0;
                var amountNotVAT5 = 0;
                var amount6 = 0;
                var amountNotVAT6 = 0;
                var amount7 = 0;
                var amountNotVAT7 = 0;
                var amount8 = 0;
                var amountNotVAT8 = 0;
                var amount9 = 0;
                var amountNotVAT9 = 0;
                var amount10 = 0;
                var amountNotVAT10 = 0;


                var totalAmount = 0;
                var totalAmountNotVAT = 0;

                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                val4 = val4 != '' ? val4 : 0;
                val5 = val5 != '' ? val5 : 0;
                val6 = val6 != '' ? val6 : 0;
                val7 = val7 != '' ? val7 : 0;
                val8 = val8 != '' ? val8 : 0;
                val9 = val9 != '' ? val9 : 0;
                val10 = val10 != '' ? val10 : 0;

                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;
                quan4 = quan4 != '' ? quan4 : 1;
                quan4 = quan4 != '' ? quan4 : 1;
                quan5 = quan5 != '' ? quan5 : 1;
                quan6 = quan6 != '' ? quan6 : 1;
                quan7 = quan7 != '' ? quan7 : 1;
                quan8 = quan8 != '' ? quan8 : 1;
                quan9 = quan9 != '' ? quan9 : 1;
                quan10 = quan10 != '' ? quan10 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = (parseFloat(quan1) * parseFloat(val1));

                    if (vatAmount1.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                        amount1 = amountNotVAT1 + parseFloat(vatAmount);
                    }
                    else amount1 = amountNotVAT1;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = (parseFloat(quan2) * parseFloat(val2));

                    if (vatAmount2.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                        amount2 = amountNotVAT2 + parseFloat(vatAmount);
                    }
                    else amount2 = amountNotVAT2;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = (parseFloat(quan3) * parseFloat(val3));

                    if (vatAmount3.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                        amount3 = amountNotVAT3 + parseFloat(vatAmount);
                    }
                    else amount3 = amountNotVAT3;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 4
                if (description4.value != '') {
                    amountNotVAT4 = (parseFloat(quan4) * parseFloat(val4));

                    if (vatAmount4.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount4.value, ',', '');
                        amount4 = amountNotVAT4 + parseFloat(vatAmount);
                    }
                    else amount4 = amountNotVAT4;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 5
                if (description5.value != '') {
                    amountNotVAT5 = (parseFloat(quan5) * parseFloat(val5));

                    if (vatAmount5.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount5.value, ',', '');
                        amount5 = amountNotVAT5 + parseFloat(vatAmount);
                    }
                    else amount5 = amountNotVAT5;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 6
                if (description6.value != '') {
                    amountNotVAT6 = (parseFloat(quan6) * parseFloat(val6));

                    if (vatAmount6.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount6.value, ',', '');
                        amount6 = amountNotVAT6 + parseFloat(vatAmount);
                    }
                    else amount6 = amountNotVAT6;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 7
                if (description7.value != '') {
                    amountNotVAT7 = (parseFloat(quan7) * parseFloat(val7));

                    if (vatAmount7.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount7.value, ',', '');
                        amount7 = amountNotVAT7 + parseFloat(vatAmount);
                    }
                    else amount7 = amountNotVAT7;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 8
                if (description8.value != '') {
                    amountNotVAT8 = (parseFloat(quan8) * parseFloat(val8));

                    if (vatAmount8.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount8.value, ',', '');
                        amount8 = amountNotVAT8 + parseFloat(vatAmount);
                    }
                    else amount8 = amountNotVAT8;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 9
                if (description9.value != '') {
                    amountNotVAT9 = (parseFloat(quan9) * parseFloat(val9));

                    if (vatAmount9.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount9.value, ',', '');
                        amount9 = amountNotVAT9 + parseFloat(vatAmount);
                    }
                    else amount9 = amountNotVAT9;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 10
                if (description10.value != '') {
                    amountNotVAT10 = (parseFloat(quan10) * parseFloat(val10));

                    if (vatAmount5.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount10.value, ',', '');
                        amount10 = amountNotVAT10 + parseFloat(vatAmount);
                    }
                    else amount10 = amountNotVAT10;

                }
                // totalAmount = parseFloat(amount1 + amount2 + amount3);
                // totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);
                /*  */

                // totalAmount = parseFloat(amount1 + amount2 + amount3 + amount4 + amount5 + amount6 + amount7 + amount8 + amount9 + amount10);
                // totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3 + amountNotVAT4 + +amountNotVAT5
                //     + amountNotVAT6 + amountNotVAT7 + amountNotVAT8 + amountNotVAT9 + amountNotVAT10);

                totalAmount = Math.round(parseFloat(amount1 + amount2 + amount3 + amount4 + amount5 + amount6 + amount7 + amount8 + amount9 + amount10));
                totalAmountNotVAT = Math.round(parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3 + amountNotVAT4 + +amountNotVAT5
                    + amountNotVAT6 + amountNotVAT7 + amountNotVAT8 + amountNotVAT9 + amountNotVAT10));

                // console.log("totalAmount", totalAmount);
                // console.log("totalAmountNotVAT", totalAmountNotVAT);
                // return;

                var inputData = {
                    'ID': sessionStorage.itemId != 'undefined' ? sessionStorage.itemId : -1,
                    'dateOfInvoice': reConvertJSONDate(_dateOfInvoice.value),
                    'invoiceTemplateId': $scope.invoiceTemplateId,//$scope.InvoiceTemplate.selected.ID,//2025-10-16
                    'LoaiHoaDon': '',
                    'LoaiDoanhThu': '',
                    'SoPhieu': '',
                    'MaHoSo': '',
                    'HinhThucHoaDon': _HTHoaDon,
                    'MaCoQuanThue': '',
                    'LoaiHoaDonCQT': _LoaiHoaDon,

                    'typeOfPaymentCode': _HTTTCode,
                    'typeOfPaymentName': _HTTTName,

                    'taxCode': _taxCode.value,
                    'customerName': _customerName.value,
                    'companyId': _companyId,
                    'companyName': _companyName,
                    'phone': _phone.value,
                    'email': _email.value,
                    'address': _address.value,
                    'accountNumber': '',
                    'medicalCode': '',
                    'hospitalizationNumber': '',
                    'healthInsuranceCardNumber': '',

                    'totalAmountNotVAT': totalAmountNotVAT,
                    'totalAmount': totalAmount,

                    'description': _notes.value,
                    'userCreated': user.ID,
                    'userUpdated': user.ID,
                    'EnterpriseId': sessionStorage.enterpriseId,

                    'CCCDan': _CCCDan.value,
                    'SHChieu': _SHChieu.value,
                    'MDVQHNSach': _MDVQHNSach.value,
                };

                $http.post(hostName.url + "api/QD1450/QD1450_HOADON", inputData)
                    .then(function (response) { //UPDATE SUCCESS

                        var objResult = response.data;

                        var invoiceId = objResult.Data;
                        sessionStorage.itemId = invoiceId;
                        var flagDetail = true;

                        //EDIT ON DAY
                        if ($scope.checkNew == false) {

                            var _STT = 0;

                            //ADD DETAIL 1
                            if (description1.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan1) * parseFloat(val1));
                                var vatAmount = 0;
                                if (vatAmount1.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount1.value, ',', '')));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID1 == undefined ? -1 : $scope.inputID1,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description1.value,
                                    'unitName': unitName1.value,
                                    'quantity': quantity1.value != '' ? quantity1.value : 1,
                                    'price': price1.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat1.value != '' ? vat1.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 2
                            if (description2.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan2) * parseFloat(val2));
                                var vatAmount = 0;
                                if (vatAmount2.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount2.value, ',', '')));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID2 == undefined ? -1 : $scope.inputID2,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description2.value,
                                    'unitName': unitName2.value,
                                    'quantity': quantity2.value != '' ? quantity2.value : 1,
                                    'price': price2.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat2.value != '' ? vat2.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 3
                            if (description3.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan3) * parseFloat(val3));
                                var vatAmount = 0;
                                if (vatAmount3.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount3.value, ',', '')));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID3 == undefined ? -1 : $scope.inputID3,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description3.value,
                                    'unitName': unitName3.value,
                                    'quantity': quantity3.value != '' ? quantity3.value : 1,
                                    'price': price3.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat3.value != '' ? vat3.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 4
                            if (description4.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan4) * parseFloat(val4));
                                var vatAmount = 0;
                                if (vatAmount4.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount4.value, ',', '')));

                                _STT = _STT + 1;

                                var data = {
                                    'ID': $scope.inputID4 == undefined ? -1 : $scope.inputID4,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description4.value,
                                    'unitName': unitName4.value,
                                    'quantity': quantity4.value != '' ? quantity4.value : 1,
                                    'price': price4.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat4.value != '' ? vat4.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 5
                            if (description5.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan5) * parseFloat(val5));
                                var vatAmount = 0;
                                if (vatAmount5.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount5.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID5 == undefined ? -1 : $scope.inputID5,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description5.value,
                                    'unitName': unitName5.value,
                                    'quantity': quantity5.value != '' ? quantity5.value : 1,
                                    'price': price5.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat5.value != '' ? vat5.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 6
                            if (description6.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan6) * parseFloat(val6));
                                var vatAmount = 0;
                                if (vatAmount6.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount6.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID6 == undefined ? -1 : $scope.inputID6,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description6.value,
                                    'unitName': unitName6.value,
                                    'quantity': quantity6.value != '' ? quantity6.value : 1,
                                    'price': price6.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat6.value != '' ? vat6.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 7
                            if (description7.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan7) * parseFloat(val7));
                                var vatAmount = 0;
                                if (vatAmount7.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount7.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID7 == undefined ? -1 : $scope.inputID7,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description7.value,
                                    'unitName': unitName7.value,
                                    'quantity': quantity7.value != '' ? quantity7.value : 1,
                                    'price': price7.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat7.value != '' ? vat7.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 8
                            if (description8.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan8) * parseFloat(val8));
                                var vatAmount = 0;
                                if (vatAmount8.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount8.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID8 == undefined ? -1 : $scope.inputID8,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description8.value,
                                    'unitName': unitName8.value,
                                    'quantity': quantity8.value != '' ? quantity8.value : 1,
                                    'price': price8.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat8.value != '' ? vat8.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 9
                            if (description9.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan9) * parseFloat(val9));
                                var vatAmount = 0;
                                if (vatAmount9.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount9.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID9 == undefined ? -1 : $scope.inputID9,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description9.value,
                                    'unitName': unitName9.value,
                                    'quantity': quantity9.value != '' ? quantity9.value : 1,
                                    'price': price9.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat9.value != '' ? vat9.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                            //ADD DETAIL 10
                            if (description10.value != '') {
                                var amountNotVAT = Math.round(parseFloat(quan10) * parseFloat(val10));
                                var vatAmount = 0;
                                if (vatAmount10.value != '-')
                                    vatAmount = Math.round(parseFloat($filter('replace')(vatAmount10.value, ',', '')));
                                _STT = _STT + 1;
                                var data = {
                                    'ID': $scope.inputID10 == undefined ? -1 : $scope.inputID10,
                                    'QD1450_HOADON_Id': invoiceId,
                                    'goodAndServiceName': description10.value,
                                    'unitName': unitName10.value,
                                    'quantity': quantity10.value != '' ? quantity10.value : 1,
                                    'price': price10.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat10.value != '' ? vat10.value : 0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId,
                                    'STT': _STT
                                };
                                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                    .then(function (success) { }, function (error) {
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };

                        }
                        //### END EDIT ON DAY

                        if (flagDetail == true) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }

                        //#UPDATE SUCCESS
                    },
                        function (reason) { //UPDATE ERRORS
                            var objResult = reason.data;

                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                        }); //#UPDATE ERRORS


            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        //XEM TRUOC HOA DON
        $scope.reviewInvoice = function () {

            $scope.IsDisabled = true;

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            //===   REVIEW BY XML   ===
            // $http({
            //     method: 'POST',
            //     url: hostName.url + "api/QD1450/QD1450_HOADON_Review",
            //     data: inputData,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     //var _disposition = headers["content-disposition"];
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "HoaDon_" + _fileName + ".xml";  
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     //console.log(contentType);

            //     $scope.IsDisabled = false;

            // }).error(function (message) {
            //     $scope.IsDisabled = false;
            //     //console.log(message);
            // });


            //===   REVIEW BY PDF   ===
            // $http({
            //     method: 'POST',
            //     url: hostName.url + "api/QD1450/QD1450_HOADON_ReviewPDF",
            //     data: inputData,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     //var _disposition = headers["content-disposition"];
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "HoaDon_" + _fileName + ".pdf";
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     //console.log(contentType);

            //     $scope.IsDisabled = false;

            // }).error(function (message) {
            //     $scope.IsDisabled = false;
            //     //console.log(message);
            // });

            /*  */

            /* ===   REVIEW NEW TAB === */
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_ReviewPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;

                a.target = "_blank";
                // a.download = "HoaDon_" + _fileName + ".pdf";
                a.click();
                // window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;

            }).error(function (message) {
                $scope.IsDisabled = false;
            });

        };

        //PHAT HANH HOA DON GUI CO QUAN THUE
        $scope.publishInvoice = function () {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },

                            data: JSON.stringify({
                                'Id': sessionStorage.itemId,
                                'MLTDiep': $scope.LoaiThongDiep,
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                            console.log(error);
                        });

                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });

        };
        $scope.delete = function (id) {

            swal({
                title: "Bạn có muốn xóa dữ liệu?",
                icon: "warning",
                // buttons: ["Chọn email khác!", "Gửi"],
                buttons: {
                    cancel: "Đóng",
                    confirm: "Xóa"
                },
                // closeOnClickOutside: false
            }).then(function (data) {
                if (data === true) {
                    var inputData = {
                        'ID': id,
                        'EnterpriseId': sessionStorage.enterpriseId
                    };
                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_DELETE", inputData)
                        .then(function (success) {
                            swal({
                                title: success.data,
                                icon: "success",
                            })
                            $state.reload();
                        });
                }

            })
        }
    };
    /******  ### END CONTROLLER  ******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }


})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.04.2022
 */
 (function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('ReferenceInvoiceCtrl', ReferenceInvoiceCtrl);

    /*******    +++ START CONTROLLER    *******/
    function ReferenceInvoiceCtrl($scope, $window, $http, hostName, $filter, $state, fileReader, $rootScope) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;
        
        $scope.inputDateOfInvoice = new Date();
        $scope.Customer = {};
        $scope.isPublic = false;
        $scope.isReview = false;
        $scope.isSave = true;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.HTTTs = [
            {ID: 'TM/CK', Name: 'TM/CK'},
            {ID: 'TM', Name: 'Tiền mặt'},
            {ID: 'CK', Name: 'Chuyển khoản'}
        ];
        $scope.HTTT = {};
        $scope.LoaiHoaDons = [];
        $scope.LoaiHoaDon = {};
        $scope.HTHoaDons = [];
        $scope.HTHoaDon = {};

        $scope.TinhChats = [
            {ID: '1', Name: 'Thay thế'},
            {ID: '2', Name: 'Điều chỉnh'}
        ];
        $scope.TinhChat = {};
        $scope.TinhChat.selected = {ID: '2', Name: 'Điều chỉnh'};

        $scope.LoaiHoaDonLQs = [
            {ID: '1', Name: 'HĐĐT theo NĐ 123/2020/NĐ-CP'},
            {ID: '2', Name: 'HĐĐT có mã của CQT theo QĐ 1209/QĐ-BTC và QĐ 2660/QĐ-BTC'},
            {ID: '3', Name: 'Hóa đơn theo NĐ 51/2010/NĐ-CP và NĐ 04/2014/NĐ-CP'},
            {ID: '4', Name: 'Hóa đơn đặt in theo Nghị định 123/2020/NĐ-CP'}
        ];
        $scope.LoaiHoaDonLQ = {};
        $scope.LoaiHoaDonLQ.selected = {ID: '3', Name: 'Hóa đơn theo NĐ 51/2010/NĐ-CP và NĐ 04/2014/NĐ-CP'};

        //LAY THONG TIN LOAI HOA DON VA HINH THUC HOA DON DA DANG KY CUA DON VI
        GetHTHD();
        function GetHTHD() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function(data) {
                var _data = data.data[0];
                
                //CO MA
                if (_data != undefined && _data.HaveCode == true) {
                    $scope.HTHoaDons.push({ID: 'COMA', Name: 'Có mã'});
                    $scope.HTHoaDon.selected = {ID: 'COMA', Name: 'Có mã'};
                }

                //KHONG CO MA
                if (_data != undefined &&_data.DontHaveCode == true) {
                    $scope.HTHoaDons.push({ID: 'KHONGMA', Name: 'Không có mã'});

                    if (_data.HaveCode == false)
                        $scope.HTHoaDon.selected = {ID: 'KHONGMA', Name: 'Không có mã'};
                }

                //GTGT
                if (_data != undefined &&_data.UseVATInvoice == true) {
                    $scope.LoaiHoaDons.push({ID: 'GTGT', Name: 'GTGT'});
                    $scope.LoaiHoaDon.selected = {ID: 'GTGT', Name: 'GTGT'};
                }

                //BAN HANG
                if (_data != undefined &&_data.UseBillOfSale == true) {
                    $scope.LoaiHoaDons.push({ID: 'BANHANG', Name: 'Bán hàng'});

                    if (_data.UseVATInvoice == false)
                        $scope.LoaiHoaDon.selected = {ID: 'BANHANG', Name: 'Bán hàng'};
                }

                //TAI SAN CONG
                if (_data != undefined &&_data.UsePublicProperty == true) {
                    $scope.LoaiHoaDons.push({ID: 'TSCONG', Name: 'TS công'});

                    if (_data.UseVATInvoice == false 
                        && _data.UseBillOfSale == false)
                        $scope.LoaiHoaDon.selected = {ID: 'TSCONG', Name: 'TS công'};
                }

                //DU TRU QUOC GIA
                if (_data != undefined &&_data.UseNationalReserve == true) {
                    $scope.LoaiHoaDons.push({ID: 'DTQGIA', Name: 'DT Quốc Gia'});

                    if (_data.UseVATInvoice == false 
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false)
                        $scope.LoaiHoaDon.selected = {ID: 'DTQGIA', Name: 'DT Quốc Gia'};
                }

                //KHAC
                if (_data != undefined &&_data.UseOther == true) {
                    $scope.LoaiHoaDons.push({ID: 'KHAC', Name: 'Khác'});

                    if (_data.UseVATInvoice == false 
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false)
                        $scope.LoaiHoaDon.selected = {ID: 'KHAC', Name: 'Khác'};
                }

                //CHUNG TU
                if (_data != undefined &&_data.UseDocument == true) {
                    $scope.LoaiHoaDons.push({ID: 'CHUNGTU', Name: 'Chứng từ'});

                    if (_data.UseVATInvoice == false 
                        && _data.UseBillOfSale == false
                        && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false
                        && _data.UseOther == false)
                        $scope.LoaiHoaDon.selected = {ID: 'CHUNGTU', Name: 'Chứng từ'};
                }

                $scope.HTTT.selected = {ID: 'TM/CK', Name: 'TM/CK'};
            }, function(error) {
                console.log(error);
            });
        };

        //+++   EDIT MODE
        if (sessionStorage.itemId != 'undefined' && sessionStorage.itemId != undefined) {
            
            $scope.isPublic = true;
            $scope.isReview = true;
            var itemId = sessionStorage.itemId;

            //GET EXISTED DATA
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) { //SUCCESS
                $scope.HoaDon = [];
                $scope.HoaDon = response.data[0];
                
                if ($scope.HoaDon != undefined) {
                    if ($scope.HoaDon.MaTinhTrang == 'CHOKETQUA'
                        || $scope.HoaDon.MaTinhTrang == '20002') {
                        $scope.isSave = false;
                        $scope.isPublic = false;
                    };

                    var dateOfInvoice = new Date($scope.HoaDon.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    $scope.inputBillNumber = $scope.HoaDon.billNumber;
                    
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.Customer.selected = {ID: $scope.HoaDon.companyId, customerName: $scope.HoaDon.companyName};
                    $scope.inputPhone = $scope.HoaDon.phone;
                    $scope.inputEmail = $scope.HoaDon.email;
                    $scope.inputTaxCode = $scope.HoaDon.taxCode;
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.inputAddress = $scope.HoaDon.address;

                    $scope.inputNotes = $scope.HoaDon.description;

                    $scope.TinhChat.selected = {ID: $scope.HoaDon.TinhChatHoaDonLQ, 
                        Name: $scope.HoaDon.TinhChatHoaDonLQ == '1' ? 'Thay thế' : 'Điều chỉnh'};

                    var _nameLHDLQ = '';
                    if ($scope.HoaDon.LoaiHoaDonLQ == '1') _nameLHDLQ = 'HĐĐT theo NĐ 123/2020/NĐ-CP';
                    if ($scope.HoaDon.LoaiHoaDonLQ == '2') _nameLHDLQ = 'HĐĐT có mã của CQT theo QĐ 1209/QĐ-BTC và QĐ 2660/QĐ-BTC';
                    if ($scope.HoaDon.LoaiHoaDonLQ == '3') _nameLHDLQ = 'Hóa đơn theo NĐ 51/2010/NĐ-CP và NĐ 04/2014/NĐ-CP';
                    if ($scope.HoaDon.LoaiHoaDonLQ == '4') _nameLHDLQ = 'Hóa đơn đặt in theo Nghị định 123/2020/NĐ-CP';
                    $scope.LoaiHoaDonLQ.selected = {ID: $scope.HoaDon.LoaiHoaDonLQ, Name: _nameLHDLQ};
                    
                    $scope.inputInvoiceTemplateCodeLQ = $scope.HoaDon.MauSoHoaDonLQ;
                    $scope.inputSymbolLQ = $scope.HoaDon.KyHieuHoaDonLQ;
                    $scope.inputBillNumberLQ = $scope.HoaDon.SoHoaDonLQ;

                    var dateOfInvoiceLQ = new Date($scope.HoaDon.NgayHoaDonLQ);
                    $scope.inputDateOfInvoiceLQ = new Date(dateOfInvoiceLQ.getFullYear(), dateOfInvoiceLQ.getMonth(), dateOfInvoiceLQ.getDate());

                    //SET SELECTED LIST
                    $scope.HTTT.selected = {ID: $scope.HoaDon.currencyOfPaymentName, Name: $scope.HoaDon.currencyOfPaymentName};
                    $scope.HTHoaDon.selected = {ID: $scope.HoaDon.HinhThucHoaDon, Name: $scope.HoaDon.HinhThucHoaDonName};
                    $scope.LoaiHoaDon.selected = {ID: $scope.HoaDon.LoaiHoaDonCQT, Name: $scope.HoaDon.LoaiHoaDonCQTName};

                    //CALL API GET HOA DON CHI TIET
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_GetById?QD1450_HOADON_Id=" + $scope.HoaDon.ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputID1 = $scope.Products[0].ID;
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VAT == '-' ? '-' :
                                 $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputID2 = $scope.Products[1].ID;
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VAT == '-' ? '-' :
                                    $scope.Products[1].VATAmount;
        
                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputID3 = $scope.Products[2].ID;
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VAT == '-' ? '-' :
                                        $scope.Products[2].VATAmount;
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function(reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function(reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE
        }

        //+++   NEW MODE
        else {

        };

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function(url) {
            location.href = url;
        };

        //CHANGE CUSTOMER
        $scope.changeCustomer = function(obj) {
            $scope.Customer.selected = obj;

            //GET CUSTOMER's DATA FROM DATABASE
            $http({
                method: "GET",
                url: hostName.url + "api/Customer/GetCustomer/" + obj.ID,
            }).then(function(response) {
                var customer = response.data;
                
                if (customer.ID > 0) {
                    //$scope.inputCustomerName = customer.customerName;
                    $scope.inputTaxCode = customer.taxCode;
                    $scope.inputAddress = customer.address;
                }
            }, function(reason) {
                console.log(reason);
            }); // #GET CUSTOMER's DATA FROM DATABASE
            
        } //#CHANGE CUSTOMER

        //CHANGE TINH CHAT
        $scope.changeTinhChat = function(obj) {
            taoDienGiai(obj);
        };

        taoDienGiai(null);
        function taoDienGiai(obj) {
            obj = obj == null ? $scope.TinhChat.selected : obj;

            //HOADON LIEN QUAN
            var _MauSoHoaDonLQ = angular.element(document).find('#inputInvoiceTemplateCodeLQ')[0];
            var _KyHieuHoaDonLQ = angular.element(document).find('#inputSymbolLQ')[0];
            var _SoHoaDonLQ = angular.element(document).find('#inputBillNumberLQ')[0];
            var _NgayHoaDonLQ = angular.element(document).find('#inputDateOfInvoiceLQ')[0];

            var _mauso = '';
            var _kyhieu = '';
            var _sohoadon = '';
            var _ngayhoadon = '';

            if (_MauSoHoaDonLQ != undefined && _MauSoHoaDonLQ != 'undefined')
                _mauso = _MauSoHoaDonLQ.value;

            if (_KyHieuHoaDonLQ != undefined && _KyHieuHoaDonLQ != 'undefined')
                _kyhieu = _KyHieuHoaDonLQ.value;

            if (_SoHoaDonLQ != undefined && _SoHoaDonLQ != 'undefined')
                _sohoadon = _SoHoaDonLQ.value;

            if (_NgayHoaDonLQ != undefined && _NgayHoaDonLQ != 'undefined')
                _ngayhoadon = _NgayHoaDonLQ.value;

            $scope.inputDescription1 = obj.Name + " cho hóa đơn, " 
                + "mẫu số hóa đơn " + _mauso
                + ", ký hiệu hóa đơn " + _kyhieu
                + ", số hóa đơn " + ("0000000" + _sohoadon).slice(-7) 
                + ", ngày " + _ngayhoadon;
        };

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //FUNCTION SAVE DATA
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/

            //THONG TIN HOA DON
            var _dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var _LoaiHoaDon = $scope.LoaiHoaDon.selected == undefined 
                ? -1 : $scope.LoaiHoaDon.selected.ID;
            var _HTHoaDon = $scope.HTHoaDon.selected == undefined 
                ? -1 : $scope.HTHoaDon.selected.ID;

            //THONG TIN NGUOI MUA
            var _customerName = angular.element(document).find('#inputCustomerName')[0];
            var _taxCode = angular.element(document).find('#inputTaxCode')[0];
            var _phone = angular.element(document).find('#inputPhone')[0];
            var _email = angular.element(document).find('#inputEmail')[0];
            var _companyId = $scope.Customer.selected != undefined 
                ? $scope.Customer.selected.ID : -1;
            var _companyName = $scope.Customer.selected != undefined 
                ? $scope.Customer.selected.customerName : -1;
            
            var _address = angular.element(document).find('#inputAddress')[0];

            //HOADON LIEN QUAN
            var _MauSoHoaDonLQ = angular.element(document).find('#inputInvoiceTemplateCodeLQ')[0];
            var _KyHieuHoaDonLQ = angular.element(document).find('#inputSymbolLQ')[0];
            var _SoHoaDonLQ = angular.element(document).find('#inputBillNumberLQ')[0];
            var _NgayHoaDonLQ = angular.element(document).find('#inputDateOfInvoiceLQ')[0];

            var _HTTTCode = $scope.HTTT.selected != undefined 
                ? $scope.HTTT.selected.ID : '';
            var _HTTTName = $scope.HTTT.selected != undefined 
                ? $scope.HTTT.selected.Name : '';
            var _notes = angular.element(document).find('#inputNotes')[0];

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 =  angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 =  angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 =  angular.element(document).find('#inputVATAmount3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');
            var flag = true;
            
            //check empty LoaiHoaDon
            if ($scope.LoaiHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusLoaiHoaDon');
                });
                flag = false;
                return;
            };

            //check empty HTHoaDon
            if ($scope.HTHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Hình thức hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusHTHoaDon');
                });
                flag = false;
                return;
            };

            //check empty Customer
            if ($scope.Customer.selected == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusCustomer');
                });
                flag = false;
                return;
            };

            //check empty address
            if (_address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check TINH CHAT HOA DON LIEN QUAN
            if ($scope.TinhChat.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Tính chất hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusTinhChat');
                });
                flag = false;
                return;
            };

            //check LOAI HOA DON LIEN QUAN
            if ($scope.LoaiHoaDonLQ.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusLoaiHoaDonLQ');
                });
                flag = false;
                return;
            };

            //check MAU SO HOA DON LIEN QUAN
            if (_MauSoHoaDonLQ.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Ký hiệu mẫu số hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    _MauSoHoaDonLQ.focus();
                });
                flag = false;
                return;
            };

            //check KY HIEU HOA DON LIEN QUAN
            if (_KyHieuHoaDonLQ.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Ký hiệu hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    _KyHieuHoaDonLQ.focus();
                });
                flag = false;
                return;
            };

            //check SO HOA DON LIEN QUAN
            if (_SoHoaDonLQ.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Số hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    _SoHoaDonLQ.focus();
                });
                flag = false;
                return;
            };

            //check NGAY HOA DON LIEN QUAN
            if (_NgayHoaDonLQ.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Ngày hóa đơn có liên quan\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    _NgayHoaDonLQ.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' 
                && description2.value == '' && price2.value == '' 
                && description3.value == '' && price3.value == ''
                && $rootScope.FileTemplateData == undefined ) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = ( parseFloat(quan1) * parseFloat(val1) );

                    if (vatAmount1.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                        amount1 = amountNotVAT1 + parseFloat(vatAmount);
                    }
                    else amount1 = amountNotVAT1;
                    
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = ( parseFloat(quan2) * parseFloat(val2) );

                    if (vatAmount2.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                        amount2 = amountNotVAT2 + parseFloat(vatAmount);
                    }
                    else amount2 = amountNotVAT2;
                    
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = ( parseFloat(quan3) * parseFloat(val3) );

                    if (vatAmount3.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                        amount3 = amountNotVAT3 + parseFloat(vatAmount);
                    }
                    else amount3 = amountNotVAT3;
                    
                }
                totalAmount = parseFloat(isNaN(amount1) ? 0 : amount1 
                    + isNaN(amount2) ? 0 : amount2 
                    + isNaN(amount3) ? 0 : amount3);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);

                
                var inputData = {
                    'ID': sessionStorage.itemId != 'undefined' ? sessionStorage.itemId : -1,
                    'dateOfInvoice': reConvertJSONDate(_dateOfInvoice.value),
                    'LoaiHoaDon': '',
                    'LoaiDoanhThu': '',
                    'SoPhieu': '',
                    'MaHoSo': '',
                    'HinhThucHoaDon': _HTHoaDon,
                    'MaCoQuanThue': '',
                    'LoaiHoaDonCQT': _LoaiHoaDon,

                    'typeOfPaymentCode': _HTTTCode,
                    'typeOfPaymentName': _HTTTName,

                    'taxCode': _taxCode.value,
                    'customerName': _customerName.value,
                    'companyId': _companyId,
                    'companyName': _companyName,
                    'phone': _phone.value,
                    'email': _email.value,
                    'address': _address.value,
                    'accountNumber': '',
                    'medicalCode': '',
                    'hospitalizationNumber': '',
                    'healthInsuranceCardNumber': '',

                    'totalAmountNotVAT': totalAmountNotVAT,
                    'totalAmount': totalAmount,

                    'description': _notes.value,
                    'userCreated': user.ID,
                    'userUpdated': user.ID,
                    'EnterpriseId': sessionStorage.enterpriseId,

                    'TinhChatHoaDonLQ': $scope.TinhChat.selected.ID,
                    'LoaiHoaDonLQ': $scope.LoaiHoaDonLQ.selected.ID,
                    'MauSoHoaDonLQ': _MauSoHoaDonLQ.value,
                    'KyHieuHoaDonLQ': _KyHieuHoaDonLQ.value,
                    'SoHoaDonLQ': _SoHoaDonLQ.value,
                    'NgayHoaDonLQ': reConvertJSONDate(_NgayHoaDonLQ.value)
                };

                $http.post(hostName.url + "api/QD1450/QD1450_HOADON_REF", inputData)
                .then(function(response) { //UPDATE SUCCESS

                    var objResult = response.data;

                    var invoiceId = objResult.Data;
                    sessionStorage.itemId = invoiceId;
                    var flagDetail = true;

                    //EDIT ON DAY
                    if ($scope.checkNew == false) {

                        var _STT = 0;

                        //ADD DETAIL 1
                        if (description1.value != '') {
                            var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                            var vatAmount = 0;
                            if (vatAmount1.value != '-')
                                vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));

                            _STT = _STT + 1;

                            var data = {
                                'ID': $scope.inputID1 == undefined ? -1 : $scope.inputID1, 
                                'QD1450_HOADON_Id': invoiceId,
                                'goodAndServiceName': description1.value,
                                'unitName': unitName1.value,
                                'quantity': quantity1.value != '' ? quantity1.value : 1,
                                'price': val1,
                                'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                'VAT': vat1.value != '' ? vat1.value : 0,
                                'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                'enterpriseId': sessionStorage.enterpriseId,
                                'STT': _STT
                            };
                            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                .then(function(success){}, function(error){
                                    flagDetail = false;
                                    console.log(error);
                                });
                        };

                        //ADD DETAIL 2
                        if (description2.value != '') {
                            var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                            var vatAmount = 0;
                            if (vatAmount2.value != '-')
                                vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                            _STT = _STT + 1;

                            var data = {
                                'ID': $scope.inputID2 == undefined ? -1 : $scope.inputID2, 
                                'QD1450_HOADON_Id': invoiceId,
                                'goodAndServiceName': description2.value,
                                'unitName': unitName2.value,
                                'quantity': quantity2.value != '' ? quantity2.value : 1,
                                'price': price2.value,
                                'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                'VAT': vat2.value != '' ? vat2.value : 0,
                                'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                'enterpriseId': sessionStorage.enterpriseId,
                                'STT': _STT
                            };
                            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                .then(function(success){}, function(error){
                                    flagDetail = false;
                                    console.log(error);
                                });
                        };

                        //ADD DETAIL 3
                        if (description3.value != '') {
                            var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                            var vatAmount = 0;
                            if (vatAmount3.value != '-')
                                vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                            _STT = _STT + 1;

                            var data = {
                                'ID': $scope.inputID3 == undefined ? -1 : $scope.inputID3, 
                                'QD1450_HOADON_Id': invoiceId,
                                'goodAndServiceName': description3.value,
                                'unitName': unitName3.value,
                                'quantity': quantity3.value != '' ? quantity3.value : 1,
                                'price': price3.value,
                                'amountNotVAT': isNaN(amountNotVAT) ? 0 : amountNotVAT,
                                'VAT': vat3.value != '' ? vat3.value : 0,
                                'VATAmount': isNaN(vatAmount) ? 0 : vatAmount,
                                'amount': isNaN(amountNotVAT) ? 0 : amountNotVAT + isNaN(vatAmount) ? 0 : vatAmount,
                                'enterpriseId': sessionStorage.enterpriseId,
                                'STT': _STT
                            };
                            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                .then(function(success){}, function(error){
                                    flagDetail = false;
                                    console.log(error);
                                });
                        };

                    }
                    //### END EDIT ON DAY

                    if (flagDetail == true) {
                        swal({
                            title: "Thông báo",
                            text: "Lưu dữ liệu thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function(){
                            $state.reload();
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            $state.reload();
                        });
                    }

                //#UPDATE SUCCESS
                }, 
                function(reason) { //UPDATE ERRORS
                    var objResult = reason.data;
                    console.log(objResult);

                    swal({
                        title: "Thông báo",
                        text: objResult.Message,
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/Invoice1450";
                    });
                }); //#UPDATE ERRORS

                
            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        //XEM TRUOC HOA DON
        $scope.reviewInvoice = function() {
            
            $scope.IsDisabled = true;

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            //===   REVIEW BY XML   ===
            // $http({
            //     method: 'POST',
            //     url: hostName.url + "api/QD1450/QD1450_HOADON_Review",
            //     data: inputData,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     //var _disposition = headers["content-disposition"];
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "HoaDon_" + _fileName + ".xml";  
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     //console.log(contentType);

            //     $scope.IsDisabled = false;

            // }).error(function (message) {
            //     $scope.IsDisabled = false;
            //     //console.log(message);
            // });


            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_ReviewPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "HoaDon_" + _fileName + ".pdf";  
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.IsDisabled = false;

            }).error(function (message) {
                $scope.IsDisabled = false;
                //console.log(message);
            });

        };

        //PHAT HANH HOA DON GUI CO QUAN THUE
        $scope.publishInvoice = function() {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_REF_Publish", inputData)
                .then(
                //SUCCESS
                function(success) {
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId  + '/';
                    var fileName = success.data.Data;
                    
                    //Day file qua Service KY SO
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({ 
                            'Id': sessionStorage.itemId,
                            'MLTDiep':  $scope.LoaiThongDiep,
                            'FileName': fileName,
                            'EnterpriseId': user.enterpriseId,
                            'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                            'UrlDownload': UrlDownload,
                        })
                    };
                    
                    $http(req).then(function() {
                        swal({
                            title: "Thông báo",
                            text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/Invoice1450";
                        });
                    }, function(error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/Invoice1450";
                        });
                        console.log(error);
                    });
                    
                }, 

                //ERRORS
                function(errs) {
                    console.log(errs);
                });

        };
        
    };
    /******  ### END CONTROLLER  ******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('BienLaiCtrl', BienLaiCtrl);

    /*******    +++ START CONTROLLER    *******/
    function BienLaiCtrl($scope, $http, $stateParams, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.arrData = [];
        $scope.mModule = "BLP";
        $scope.mTotalAmount = 0;
        $scope.mTotalList = 0;
        $scope.smartTablePageSize = 10;

        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            $scope.arrStatus = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                + "&TypeOfInvoiceCode=" + $scope.mModule
        }).then(function (response) {
            $scope.arrInvoiceTemplate = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/Receipt/GetTypeOfRevenue_ByTypeOfInvoiceCode?TypeOfInvoiceCode=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
        }).then(function (response) {
            $scope.arrTypeOfRevenue = response.data;
        }, function (error) {
            console.log(error);
        });

        //call WEB API to get ElectronicInvoice's data
        var queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&RefNbr=&MaTinhTrang=&InvoiceTemplateID=&CustomerName=&InvNumber=&InvSerialNo=&TypeOfRevenueID=&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/Receipt/BIENLAITOKHAI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditBienLai = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/BienLai';
            location.href = '#/CreateBienLai';
        };

        $scope.CreateBienLai_ByCopy = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateBienLai';
        }

        $scope.CreateBienLai = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateBienLai';
        }

        $scope.FindData = function () {
            searchData();
        };

        function searchData() {
            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mInvNumber == undefined)
                $scope.mInvNumber = '';
            queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&RefNbr=" + $scope.mRefNbr + "&InvNumber=" + $scope.mInvNumber
                + "&InvSerialNo=" + $scope.mInvSerialNo + "&CustomerName=" + $scope.mCustomerName
                + "&MaTinhTrang=" + $scope.mMaTinhTrang + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&TypeOfRevenueID=" + $scope.mTypeOfRevenueID + "&UserID=" + UserId;
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileSigned = function (BienLaiToKhaiID, InvNumber, RefNbr) {
            InvNumber = ("0000000" + InvNumber).slice(-7);
            var _fileName = RefNbr + '_' + InvNumber + ".pdf";
            $http({
                method: 'GET',
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GetFileSigned?ID=" + BienLaiToKhaiID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo", text: "Đã có kết quả phản hồi từ Cơ quan Thuế!", icon: "success", button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo", text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo", text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error", dangerMode: true, button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total;

            total = response.data[1][0].TotalList;
            if (total != undefined)
                $scope.mTotalList = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateBienLaiCtrl', CreateBienLaiCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateBienLaiCtrl($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];

        $scope.mRefDate = new Date();
        $scope.IsPublic = false;
        $scope.IsUnlock = true;
        $scope.IsUpdate = false;
        $scope.Module = "BLP";
        $scope.disable_MauBienLai = false
        $scope.disable_MauToKhai = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.mBienLaiToKhai_ID = 0;

        GetTypeOfPayment();
        GetInvoiceTemplate();

        // Update
        if ($scope.IsUpdate == true) {
            $scope.mBienLaiToKhai_ID = sessionStorage.itemId;
            $scope.IsPublic = true;
            Paste($scope.mBienLaiToKhai_ID, false);
        }
        //Insert
        else {
            if (sessionStorage.itemId > 0)
                Paste(sessionStorage.itemId, true);
        };

        function Paste(BienLaiToKhai_ID, IsCopy) {
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GetByID?ID=" + BienLaiToKhai_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.BienLai = response.data[0];
                if ($scope.BienLai != undefined) {
                    if (IsCopy == false) {
                        if ($scope.BienLai.MaTinhTrang == 'DUYET') {
                            $scope.IsPublic = false;
                            $scope.IsUnlock = false;
                        };
                        $scope.disable_MauBienLai = true;

                        $scope.mRefDate = decryptDate($scope.BienLai.RefDate);
                        $scope.mRefNbr = $scope.BienLai.RefNbr;
                        $scope.mCustomerName = $scope.BienLai.CustomerName;
                        $scope.mCompanyName = $scope.BienLai.CompanyName;
                        $scope.mTaxCode = $scope.BienLai.TaxCode;
                        $scope.mAddress = $scope.BienLai.Address;
                        $scope.mInvNumber = $scope.BienLai.InvNumber;
                    }
                    else {
                        $scope.mRefDate = new Date();
                        $scope.mRefNbr = "";
                        $scope.mCustomerName = "";
                        $scope.mCompanyName = "";
                        $scope.mTaxCode = "";
                        $scope.mAddress = "";
                        $scope.mInvNumber = "";
                    }
                    $scope.mTypeOfPaymentID = $scope.BienLai.TypeOfPaymentID.toString();
                    $scope.mInvoiceTemplateID = $scope.BienLai.InvoiceTemplateID.toString();
                    $scope.mTotalAmount = $scope.BienLai.TotalAmount;
                    $scope.mInvFormNo = $scope.BienLai.InvFormNo;
                    $scope.mInvSerialNo = $scope.BienLai.InvSerialNo;
                    $scope.mDescr = $scope.BienLai.Descr;

                    $http({
                        method: "GET",
                        url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate?ID=" + $scope.mInvoiceTemplateID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                    }).then(function (response) {
                        var invoiceTemplate = response.data;
                        if (invoiceTemplate.ID > 0) {
                            GetTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                        }
                    }, function (reason) {
                    });
                    $scope.mTypeOfRevenueID = $scope.BienLai.TypeOfRevenueID.toString();
                }
                if ($scope.BienLai.FileHoaDon && $scope.IsUpdate === true) {

                    $scope.IsPublic = false;
                    $scope.IsUnlock = false;
                }
            }, function (reason) {
                console.log(reason);
            });
        }

        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtCustomerName = angular.element(document).find('#txtCustomerName')[0];
            var cboInvoiceTemplate = angular.element(document).find('#cboInvoiceTemplate')[0];
            var cboTypeOfPayment = angular.element(document).find('#cboTypeOfPayment')[0];
            var cboTypeOfRevenue = angular.element(document).find('#cboTypeOfRevenue')[0];
            var txtTotalAmount = angular.element(document).find('#txtTotalAmount')[0];
            var flag = true;
            //check empty 
            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày biên lai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mInvoiceTemplateID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mẫu biên lai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboInvoiceTemplate.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mCustomerName == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtCustomerName.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mTypeOfPaymentID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Hình thức thanh toán\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboTypeOfPayment.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mTypeOfRevenueID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Loại phí, lệ phí\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboTypeOfRevenue.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mTotalAmount == '' || $scope.mTotalAmount == '0') {
                swal({
                    title: "Vui lòng nhập thông tin \"Số tiền\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtTotalAmount.focus();
                });
                flag = false;
                return;
            };

            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mBienLaiToKhai_ID <= 0 ? -1 : $scope.mBienLaiToKhai_ID,
                    'RefDate': encryptDate($scope.mRefDate),
                    'RefNbr': "",
                    'Module': $scope.Module,
                    /*'FromDate': "",
                    'ToDate': "",*/
                    'CustomerName': $scope.mCustomerName,
                    'CompanyName': $scope.mCompanyName,
                    'TaxCode': $scope.mTaxCode,
                    'Address': $scope.mAddress,
                    /*'CodeToFind': "",
                    'Nationality': "",
                    'IsResident': false,
                    'PassportNumber': "",
                    'PlaceOfIssue': "",
                    'DateOfIssue': "", */
                    'TypeOfPaymentID': $scope.mTypeOfPaymentID,
                    'TypeOfRevenueID': $scope.mTypeOfRevenueID,
                    'InvoiceTemplateID': $scope.mInvoiceTemplateID,
                    /*
                    'InvFormNo': $scope.mInvFormNo,
                    'InvSerialNo': $scope.mInvSerialNo,
                    'InvNumber': $scope.mInvNumber,
                    'TotalInsuranceAmount':0,
                    'TotalBeforeReductIncomeAmount':0,
                    'TotalIncomeAmount':0,
                    'TotalTaxAmount':0,
                    'TotalRemainAmount':0,*/
                    'TotalAmount': $scope.mTotalAmount,
                    'Descr': $scope.mDescr,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                };

                $http.post(hostName.url + "api/Receipt/BIENLAITOKHAI_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mBienLaiToKhai_ID = objResult.Data;
                    sessionStorage.itemId = objResult.Data;
                    sessionStorage.IsUpdate = true;
                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $scope.BackPage();
                        });
                    });
            }
        };

        $scope.BackPage = function () {
            location.href = "#/BienLai";
        };

        //Phát hành biên lai gửi cơ quan thuế
        $scope.PublishInvoice = function () {
            $http.post(hostName.url + "api/Receipt/BIENLAITOKHAI_Publish?ID=" + $scope.mBienLaiToKhai_ID + "&IsSign=" + true + "&EnterpriseID=" + sessionStorage.enterpriseId)
                .then(function (success) {
                    var fileName = success.data.Data;
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({
                            'id': sessionStorage.itemId,
                            'PDF': 'TKTNCN',
                            'file': fileName,
                            'dateOfInvoice': encryptDate($scope.mRefDate),
                            'enterpriseId': user.enterpriseId,
                            'urlUpload': hostName.url + "api/QD1450/UploadFilePDF2Server",
                            'urlDownload': UrlDownload,
                        })
                    };
                    $http(req).then(function () {
                        swal({
                            title: "Thông báo",
                            text: "Ký biên lai thành công !",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/BienLai";
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thất bại !, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                        });
                        console.log(error);
                    });
                },
                    function (errs) {
                        console.log(errs);
                    });
        };

        $scope.Review = function () {
            var _fileName = $scope.mRefNbr + '_' + ("0000000" + $scope.mInvNumber).slice(-7) + ".pdf";
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GenFilePDF?ID=" + $scope.mBienLaiToKhai_ID + "&IsSign=false" + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };

        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate?ID=" + $scope.mInvoiceTemplateID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mInvFormNo = invoiceTemplate.invoiceTemplateCode;
                    $scope.mInvSerialNo = invoiceTemplate.symbol;
                    GetTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                }
            }, function (reason) {
            });
        };

        function GetInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                    + "&TypeOfInvoiceCode=" + $scope.Module
            }).then(function (response) {
                $scope.arrInvoiceTemplate = response.data;
                if ($scope.IsUpdate == false) {
                    $scope.mInvoiceTemplateID = String(response.data[0].ID);
                    $scope.mInvFormNo = response.data[0].invoiceTemplateCode;
                    $scope.mInvSerialNo = response.data[0].symbol;
                    GetTypeOfRevenue(response.data[0].typeOfInvoiceId);
                }
            }, function (error) {
                console.log(error);
            });
        }

        function GetTypeOfPayment() {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfPayment/List?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function (response) {
                $scope.arrTypeOfPayment = response.data;
                if ($scope.IsUpdate == false) {
                    $scope.mTypeOfPaymentID = String(response.data[0].ID);
                }
            }, function (error) {
            });
        };

        function GetTypeOfRevenue(TypeOfInvoiceID) {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId + "&typeOfInvoiceId=" + TypeOfInvoiceID
            }).then(function (response) {
                $scope.arrTypeOfRevenue = response.data;
            }, function (reason) {
                console.log(reason);
            });
        }
    };

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateToKhaiThueTNCNCtrl', CreateToKhaiThueTNCNCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateToKhaiThueTNCNCtrl($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.arrInvoiceTemplate = [];
        $scope.InvoiceTemplate = []
        $scope.mRefDate = new Date();
        $scope.IsPublic = false;
        $scope.IsUnlock = true;
        $scope.IsUpdate = false;
        $scope.Module = "TK";
        $scope.disable_MauToKhai = false;

        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.mBienLaiToKhai_ID = 0;

        GetInvoiceTemplate();

        // Update
        if ($scope.IsUpdate == true) {
            $scope.mBienLaiToKhai_ID = sessionStorage.itemId;
            $scope.IsPublic = true;
            Paste($scope.mBienLaiToKhai_ID, false);
        }
        //Insert
        else {
            if (sessionStorage.itemId > 0)
                Paste(sessionStorage.itemId, true);
        };

        function Paste(BienLaiToKhai_ID, IsCopy) {
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GetByID?ID=" + BienLaiToKhai_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.BienLai = response.data[0];
                if ($scope.BienLai != undefined) {

                    if (IsCopy == false) {
                        if ($scope.BienLai.MaTinhTrang == 'DUYET') {
                            $scope.IsPublic = false;
                            $scope.IsUnlock = false;
                        };
                        $scope.disable_MauToKhai = true;

                        $scope.mRefDate = decryptDate($scope.BienLai.RefDate);
                        $scope.mRefNbr = $scope.BienLai.RefNbr;
                        $scope.mCustomerName = $scope.BienLai.CustomerName;
                        $scope.mCompanyName = $scope.BienLai.CompanyName;
                        $scope.mTaxCode = $scope.BienLai.TaxCode;
                        $scope.mAddress = $scope.BienLai.Address;
                        $scope.mInvNumber = $scope.BienLai.InvNumber;

                        $scope.mFromDate = decryptDate($scope.BienLai.FromDate);
                        $scope.mToDate = decryptDate($scope.BienLai.ToDate);
                        $scope.mNationality = $scope.BienLai.Nationality;
                        //$scope.mIsResident = $scope.BienLai.IsResident;
                        var txtIsResident = angular.element(document).find('#txtIsResident')[0];
                        txtIsResident.checked = $scope.BienLai.IsResident;
                        $scope.mPassportNumber = $scope.BienLai.PassportNumber;
                        $scope.mPlaceOfIssue = $scope.BienLai.PlaceOfIssue;
                        $scope.mDateOfIssue = decryptDate($scope.BienLai.DateOfIssue);
                        $scope.mTotalIncomeAmount = $scope.BienLai.TotalIncomeAmount;
                        $scope.mTotalTaxAmount = $scope.BienLai.TotalTaxAmount;
                        $scope.mTotalAmount = $scope.BienLai.TotalAmount;
                    }
                    else {
                        $scope.mRefDate = new Date();
                        $scope.mRefNbr = "";
                        $scope.mCustomerName = "";
                        $scope.mCompanyName = "";
                        $scope.mTaxCode = "";
                        $scope.mAddress = "";
                        $scope.mInvNumber = "";
                    }
                    $scope.mInvoiceTemplateID = $scope.BienLai.InvoiceTemplateID.toString();
                    $scope.mInvFormNo = $scope.BienLai.InvFormNo;
                    $scope.mInvSerialNo = $scope.BienLai.InvSerialNo;
                    $scope.mDescr = $scope.BienLai.Descr;
                    /*  */
                    // console.log($scope.BienLai);
                    // $scope.InvoiceTemplate = { ID: $scope.BienLai.InvoiceTemplateID, invoiceTemplateName: $scope.BienLai.invoiceTemplateName };
                }

                /* THIENVM ADD ẩn đồng ý, xem trước, xuất tncn khi đã có filehoadon*/
                if ($scope.BienLai.FileHoaDon) {
                    $scope.IsPublic = false;
                    $scope.IsUnlock = false;
                }
            }, function (reason) {
                console.log(reason);
            });
        }

        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtCustomerName = angular.element(document).find('#txtCustomerName')[0];
            var cboInvoiceTemplate = angular.element(document).find('#cboInvoiceTemplate')[0];

            var txtTaxCode = angular.element(document).find('#txtTaxCode')[0];
            var txtAddress = angular.element(document).find('#txtAddress')[0];
            var txtNationality = angular.element(document).find('#txtNationality')[0];
            var txtIsResident = angular.element(document).find('#txtIsResident')[0];
            var txtPassportNumber = angular.element(document).find('#txtPassportNumber')[0];
            var txtPlaceOfIssue = angular.element(document).find('#txtPlaceOfIssue')[0];
            var txtDateOfIssue = angular.element(document).find('#txtDateOfIssue')[0];

            var txtDescr = angular.element(document).find('#txtDescr')[0];
            var txtFromDate = angular.element(document).find('#txtFromDate')[0];
            var txtToDate = angular.element(document).find('#txtToDate')[0];
            var txtTotalIncomeAmount = angular.element(document).find('#txtTotalIncomeAmount')[0];
            var txtTotalTaxAmount = angular.element(document).find('#txtTotalTaxAmount')[0];
            var txtTotalAmount = angular.element(document).find('#txtTotalAmount')[0];
            var flag = true;
            //check empty 
            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày tờ khai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mInvoiceTemplateID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mẫu tờ khai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboInvoiceTemplate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mCustomerName == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Họ và tên\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtCustomerName.focus();
                });
                flag = false;
                return;
            };
            /*if ($scope.mTaxCode == '') {
                swal({title: "Vui lòng nhập thông tin \"Mã số thuế\"", icon: "warning", button: "Đóng"
                }).then(function(){
                    txtTaxCode.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mAddress == '') {
                swal({title: "Vui lòng nhập thông tin \"Địa chỉ (điện thoại)\"", icon: "warning", button: "Đóng"
                }).then(function(){
                    txtAddress.focus();
                });
                flag = false;
                return;
            };*/
            if ($scope.mTaxCode == '') {
                if ($scope.mNationality == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"Quốc tịch\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtNationality.focus();
                    });
                    flag = false;
                    return;
                };
                if ($scope.mPassportNumber == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"CMND\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtPassportNumber.focus();
                    });
                    flag = false;
                    return;
                };
                if ($scope.mPlaceOfIssue == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"Nơi cấp\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtPlaceOfIssue.focus();
                    });
                    flag = false;
                    return;
                };
            }
            if ($scope.mDateOfIssue == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Ngày cấp\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDateOfIssue.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDescr == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khoản thu nhập\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mFromDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Từ ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtFromDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mToDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đến ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtToDate.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mTotalIncomeAmount == '' || $scope.mTotalIncomeAmount == '0') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thu nhập chịu thuế\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtTotalIncomeAmount.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mTotalAmount == '' || $scope.mTotalAmount == '0') {
                swal({
                    title: "Vui lòng nhập thông tin \"TNCN còn được nhận\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtTotalAmount.focus();
                });
                flag = false;
                return;
            };

            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mBienLaiToKhai_ID <= 0 ? -1 : $scope.mBienLaiToKhai_ID,
                    'RefDate': encryptDate($scope.mRefDate),
                    'RefNbr': "",
                    'Module': $scope.Module,
                    'FromDate': encryptDate($scope.mFromDate),
                    'ToDate': encryptDate($scope.mToDate),
                    'CustomerName': $scope.mCustomerName,
                    'CompanyName': $scope.mCompanyName,
                    'TaxCode': $scope.mTaxCode,
                    'Address': $scope.mAddress,
                    /*'CodeToFind': "",*/
                    'Nationality': $scope.mNationality,
                    'IsResident': txtIsResident.checked,
                    'PassportNumber': $scope.mPassportNumber,
                    'PlaceOfIssue': $scope.mPlaceOfIssue,
                    'DateOfIssue': encryptDate($scope.mDateOfIssue),
                    /*'TypeOfPaymentID': $scope.mTypeOfPaymentID,
                    'TypeOfRevenueID': $scope.mTypeOfRevenueID,*/
                    'InvoiceTemplateID': $scope.mInvoiceTemplateID,
                    /*
                    'InvFormNo': $scope.mInvFormNo,
                    'InvSerialNo': $scope.mInvSerialNo,
                    'InvNumber': $scope.mInvNumber,
                    'TotalInsuranceAmount':$scope.mTotalInsuranceAmount,
                    'TotalBeforeReductIncomeAmount':$scope.mTotalBeforeReductIncomeAmount,*/
                    'TotalIncomeAmount': $scope.mTotalIncomeAmount,
                    'TotalTaxAmount': $scope.mTotalTaxAmount,
                    'TotalRemainAmount': $scope.mTotalAmount,
                    'TotalAmount': $scope.mTotalAmount,
                    'Descr': $scope.mDescr,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                };
                $http.post(hostName.url + "api/Receipt/BIENLAITOKHAI_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mBienLaiToKhai_ID = objResult.Data;
                    sessionStorage.itemId = objResult.Data;
                    sessionStorage.IsUpdate = true;
                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $scope.BackPage();
                        });
                    });
            }
        };

        $scope.BackPage = function () {
            location.href = "#/ToKhaiThueTNCN";
        };

        //Phát hành tờ khai gửi cơ quan thuế
        $scope.PublishInvoice = function () {
            $http.post(hostName.url + "api/Receipt/BIENLAITOKHAI_Publish?ID=" + $scope.mBienLaiToKhai_ID + "&IsSign=" + true + "&EnterpriseID=" + sessionStorage.enterpriseId)
                .then(function (success) {
                    var fileName = success.data.Data;
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({
                            'id': sessionStorage.itemId,
                            'PDF': 'TKTNCN',
                            'file': fileName,
                            'dateOfInvoice': encryptDate($scope.mRefDate),
                            'enterpriseId': user.enterpriseId,
                            'urlUpload': hostName.url + "api/QD1450/UploadFilePDF2Server",
                            'urlDownload': UrlDownload,
                        })
                    };
                    $http(req).then(function () {
                        swal({
                            title: "Thông báo",
                            text: "Ký tờ khai thành công !",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/ToKhaiThueTNCN";
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thất bại !, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                        });
                        console.log(error);
                    });
                },
                    function (errs) {
                        console.log(errs);
                    });
        };
        // $scope.FileSigned = function () {
        //     var _fileName = $scope.mRefNbr + '_' + ("0000000" + $scope.mInvNumber).slice(-7) + ".pdf";
        //     $http({
        //         method: "GET",
        //         url: hostName.url + "api/Receipt/BIENLAITOKHAI_GenFilePDF?ID=" + $scope.mBienLaiToKhai_ID + "&IsSign=false" + "&EnterpriseID=" + sessionStorage.enterpriseId,
        //         responseType: 'arraybuffer',
        //     }).success(function (data, status, headers) {
        //         console.log(data);
        //     }).error(function (message) {

        //         console.log(message);
        //         $scope.IsDisabled = false;
        //     });
        // };


        $scope.Review = function () {
            var _fileName = $scope.mRefNbr + '_' + ("0000000" + $scope.mInvNumber).slice(-7) + ".pdf";
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GenFilePDF?ID=" + $scope.mBienLaiToKhai_ID + "&IsSign=false" + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };

        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            // $scope.mInvoiceTemplateID = $scope.InvoiceTemplate.selected != undefined ? $scope.InvoiceTemplate.selected.ID : ''
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate?ID=" + $scope.mInvoiceTemplateID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mInvFormNo = invoiceTemplate.invoiceTemplateCode;
                    $scope.mInvSerialNo = invoiceTemplate.symbol;
                }
            }, function (reason) {
            });
        };

        function GetInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                    + "&TypeOfInvoiceCode=" + $scope.Module
            }).then(function (response) {
                $scope.arrInvoiceTemplate = response.data;
                if ($scope.IsUpdate == false) {
                    // $scope.InvoiceTemplate.selected = { ID: response.data[0].ID, invoiceTemplateName: response.data[0].invoiceTemplateName };
                    $scope.mInvoiceTemplateID = String(response.data[0].ID);
                    $scope.mInvFormNo = response.data[0].invoiceTemplateCode;
                    $scope.mInvSerialNo = response.data[0].symbol;
                }
            }, function (error) {
                console.log(error);
            });
        }

        $scope.CalTotalAmount = function () {
            $scope.mTotalAmount = $scope.mTotalIncomeAmount - $scope.mTotalTaxAmount;
        };

    };

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('ToKhaiThueTNCNCtrl', ToKhaiThueTNCNCtrl);

    /*******    +++ START CONTROLLER    *******/
    function ToKhaiThueTNCNCtrl($scope, $http, $stateParams, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.arrData = [];
        $scope.mModule = "TK";
        $scope.mTotalAmount = 0;
        $scope.mTotalList = 0;
        $scope.smartTablePageSize = 10;
        $scope.Status = [];
        $scope.Templates = []

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/file/d/1zx23jdvYJrb0IeLjeL-PLPucKpK0EBTk/view?usp=sharing");
        }
        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            $scope.arrStatus = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                + "&TypeOfInvoiceCode=" + $scope.mModule
        }).then(function (response) {
            $scope.arrInvoiceTemplate = response.data;
        }, function (error) {
            console.log(error);
        });

        //call WEB API to get ElectronicInvoice's data
        var queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&RefNbr=&MaTinhTrang=&InvoiceTemplateID=&CustomerName=&InvNumber=&InvSerialNo=&TypeOfRevenueID=&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/Receipt/BIENLAITOKHAI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditToKhaiThueTNCN = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/ToKhaiThueTNCN';
            location.href = '#/CreateToKhaiThueTNCN';
        };

        $scope.CreateToKhaiThueTNCN_ByCopy = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateToKhaiThueTNCN';
        }

        $scope.CreateToKhaiThueTNCN = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateToKhaiThueTNCN';
        }

        $scope.FindData = function () {
            searchData();
        };

        function searchData() {
            $scope.mMaTinhTrang = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : ''
            $scope.mInvoiceTemplateID = $scope.Templates.selected != undefined ? $scope.Templates.selected.ID : ''

            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;
            var queryString = "";
            if ($scope.mInvNumber == undefined)
                $scope.mInvNumber = '';
            queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&RefNbr=" + $scope.mRefNbr + "&InvNumber=" + $scope.mInvNumber
                + "&InvSerialNo=" + $scope.mInvSerialNo + "&CustomerName=" + $scope.mCustomerName
                + "&MaTinhTrang=" + $scope.mMaTinhTrang + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&TypeOfRevenueID=&UserID=";
            $http({
                method: "GET",
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileSigned = function (BienLaiToKhaiID, InvNumber, RefNbr) {
            InvNumber = ("0000000" + InvNumber).slice(-7);
            var _fileName = RefNbr + '_' + InvNumber + ".pdf";
            $http({
                method: 'GET',
                url: hostName.url + "api/Receipt/BIENLAITOKHAI_GetFileSigned?ID=" + BienLaiToKhaiID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });
        };

        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo", text: "Đã có kết quả phản hồi từ Cơ quan Thuế!", icon: "success", button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo", text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo", text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error", dangerMode: true, button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total;

            total = response.data[1][0].TotalList;
            if (total != undefined)
                $scope.mTotalList = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateDanhSachSaiSotCtrl', CreateDanhSachSaiSotCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateDanhSachSaiSotCtrl($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mRefDate = new Date();
        $scope.mFromDate = $scope.mRefDate;
        $scope.mToDate = $scope.mRefDate;
        $scope.arrTypeOfAction = [];
        $scope.arrData = [];
        $scope.IsPublic = false;
        $scope.IsUnlock = true;
        $scope.XemTruoc = true;

        $scope.IsUpdate = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.mQD1450_SAISOT_ID = 0;

        GetTypeOfAction();
        // Update
        if ($scope.IsUpdate == true) {
            $scope.mQD1450_SAISOT_ID = sessionStorage.itemId;
            $scope.IsPublic = true;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_GetByID?ID=" + $scope.mQD1450_SAISOT_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.IsUnlock = false;
                $scope.SaiSot = response.data[0];
                if ($scope.SaiSot != undefined) {
                    if ($scope.SaiSot.MaTinhTrang == 'CHOKETQUA' || $scope.SaiSot.MaTinhTrang == 'DUYET'
                        || $scope.SaiSot.MaTinhTrang == '20002') {
                        $scope.IsPublic = false;
                    };
                    $scope.mQD1450_SAISOT_ID = $scope.SaiSot.ID;
                    $scope.mRefDate = decryptDate($scope.SaiSot.RefDate);
                    $scope.mRefNbr = $scope.SaiSot.RefNbr;
                    $scope.mFromDate = decryptDate($scope.SaiSot.FromDate);
                    $scope.mToDate = decryptDate($scope.SaiSot.ToDate);
                    $scope.mDescr = $scope.SaiSot.Descr;
                    $scope.mTypeOfAction = $scope.SaiSot.TypeOfAction;
                    $scope.mQuantityInvoice = $scope.SaiSot.QuantityInvoice;
                    $scope.mTotalInvoice = $scope.SaiSot.QuantityInvoice;
                    $scope.mTotalSearch = 0;
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_CHITIET_GetByMasterID?QD1450_SAISOT_ID=" + $scope.mQD1450_SAISOT_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                    }).then(function (response) { //SUCCESS
                        $scope.arrData = response.data;
                    }, function (reason) { //ERROR
                        console.log(reason);
                    });
                }
            }, function (reason) {
                console.log(reason);
            });
        }
        //Insert
        else {
        };

        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtDescr = angular.element(document).find('#txtDescr')[0];
            var flag = true;
            //check empty 
            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày báo cáo\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDescr == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ghi chú\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            //check empty details of invoice
            if ($scope.arrData === undefined || $scope.arrData.length == 0) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn sai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            $scope.mListID = "";
            for (var i = 0; i < $scope.arrData.length; i += 1) {
                $scope.mListID = $scope.mListID + $scope.arrData[i]['QD1450_HOADON_THAYDOI_ID'] + ';';
            }
            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mQD1450_SAISOT_ID <= 0 ? -1 : $scope.mQD1450_SAISOT_ID,
                    'RefDate': encryptDate($scope.mRefDate),
                    'FromDate': encryptDate($scope.mFromDate),
                    'ToDate': encryptDate($scope.mToDate),
                    'Descr': $scope.mDescr,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                    'ListID': $scope.mListID,
                };

                $http.post(hostName.url + "api/ModifyInvoice/QD1450_SAISOT_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mQD1450_SAISOT_ID = objResult.Data;
                    sessionStorage.itemId = objResult.Data;
                    sessionStorage.IsUpdate = true;
                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        $state.reload();
                        //location.href = "#/DanhSachSaiSot";
                    });
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            location.href = "#/DanhSachSaiSot";
                        });
                    });
            }
        };

        $scope.FindData = function () {

            $scope.arrData = [];
            $scope.mTotalInvoice = 0;
            $scope.mTotalSearch = 0;;
            var queryString = "";
            queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction=" + $scope.mTypeOfAction
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate);
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_SearchHoaDon?" + queryString,
            }).then(function (response) { //SUCCESS
                $scope.arrData = response.data[0];

                var total = response.data[1][0].TotalInvoice;
                if (total != undefined)
                    $scope.mTotalInvoice = total;
                total = response.data[1][0].TotalSearch;
                if (total != undefined)
                    $scope.mTotalSearch = total;
            }, function (reason) { //ERROR
                console.log(reason);
            });
        };

        $scope.BackPage = function () {
            location.href = "#/DanhSachSaiSot";
        };

        function GetTypeOfAction() {
            $scope.arrTypeOfAction.push({ ID: 'DELETE', Name: 'Hủy' });
            $scope.arrTypeOfAction.push({ ID: 'ADJUST', Name: 'Điều chỉnh' });
            $scope.arrTypeOfAction.push({ ID: 'REPLACE', Name: 'Thay thế' });
            $scope.arrTypeOfAction.push({ ID: 'ERROR', Name: 'DS sai sót Thuế không duyệt' });
        }

        //Phát hành hóa đơn gửi cơ quan thuế
        $scope.PublishInvoice = function () {
            $http.post(hostName.url + "api/ModifyInvoice/QD1450_SAISOT_Publish?ID=" + $scope.mQD1450_SAISOT_ID + "&EnterpriseID=" + sessionStorage.enterpriseId)
                .success(function (success) {
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/300/';
                    var fileName = success.Data;
                    //Day file qua Service KY SO
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({
                            'Id': $scope.mQD1450_SAISOT_ID,
                            'MLTDiep': '300',
                            'FileName': fileName,
                            'EnterpriseId': user.enterpriseId,
                            'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                            'UrlDownload': UrlDownload,
                        })
                    };

                    $http(req).success(function (data) {
                        swal({
                            title: "Thông báo",
                            text: data.Message,
                            // text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                        console.log(error);
                    });
                })
            // .then(
            //     //SUCCESS
            //     function (success) {
            //         swal({
            //             title: "Thông báo", text: "Đã gửi thông báo đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!", icon: "success", button: "Đóng",
            //         }).then(function () {
            //             $state.reload();
            //         });
            //     },
            //     //ERRORS
            //     function (errs) {
            //         swal({
            //             title: "Thông báo", text: "Không thể gửi thông báo đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", icon: "error", dangerMode: true, button: "Đóng",
            //         }).then(function () {
            //             $state.reload();
            //         });
            //         console.log(errs);
            //     });

        };

        $scope.PrintThongBaoSaiSot = function () {
            var _fileName = $scope.mRefNbr + '_' + "ThongBaoSaiSot.pdf";

            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_PrintThongBaoSaiSot?ID=" + $scope.mQD1450_SAISOT_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {
                console.log(message);
                $scope.IsDisabled = false;
            });
        };

    };

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateHoaDonDieuChinhCtrl', CreateHoaDonDieuChinhCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateHoaDonDieuChinhCtrl($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mDateOfInvoice = new Date();
        $scope.arrLoaiHoaDonCQT = [];
        $scope.arrHinhThucHoaDon = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.arrLoaiDieuChinh = [];
        $scope.mTypeOfPaymentName = "Tiền mặt";
        $scope.mLoaiDieuChinh = "THONGTIN";
        $scope.mModule = $stateParams.Module;
        if ($scope.mModule == "REPLACE")
            $scope.PageTitle = "Hóa đơn thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = "Hóa đơn Điều chỉnh";
        $scope.IsChinhThongTin = false;
        $scope.IsUnlock = true;
        $scope.IsPublic = false;
        $scope.IsUpdate = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.IsAdjust = true;
        if ($scope.mModule == "REPLACE")
            $scope.IsAdjust = false;
        console.log("$scope.mModule=" + $scope.mModule + "; $scope.IsAdjust=" + $scope.IsAdjust);

        $scope.mQD1450_HOADON_THAYDOI_ID = 0;
        $scope.mParentID = 0;

        $scope.mQD1450_HOADON_ID = 0;
        $scope.HTTTs = [
            { ID: 'TM/CK', Name: 'TM/CK' },
            { ID: 'TM', Name: 'Tiền mặt' },
            { ID: 'CK', Name: 'Chuyển khoản' },
            { ID: 'THE', Name: 'Thẻ' },
        ];
        /* THIENVM 1*/
        $scope.HTTT = {};
        $scope.LoaiDieuChinh = {};
        $scope.Customer = [];
        /* THIENVM 1*/

        // getTypeOfPayment();
        // getInvoiceTemplate();
        GetLoaiDieuChinh();
        GetHTHD();//Lấy thông tin loại hóa đơn, hình thức hóa đơn đã đăng ký của đơn vị

        // Update
        if ($scope.IsUpdate == true) {
            $scope.IsPublic = true;
            $scope.mQD1450_HOADON_THAYDOI_ID = sessionStorage.itemId;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetByID?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {

                $scope.Adjust = response.data[0];
                if ($scope.Adjust != undefined) {
                    $scope.mQD1450_HOADON_ID = $scope.Adjust.QD1450_HOADON_NewId;
                    $scope.ParentID = $scope.Adjust.QD1450_HOADON_Id;
                    if ($scope.Adjust.MaTinhTrang != 'LAPMOI')
                        $scope.IsUnlock = false;
                    if ($scope.Adjust.FileBienBan != '')
                        $scope.IsPublic = false;
                    Paste($scope.mQD1450_HOADON_ID, false);
                    // Lấy thông tin hóa đơn cũ  
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + $scope.ParentID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) {
                        $scope.HoaDon = response.data[0];
                        if ($scope.HoaDon != undefined) {
                            $scope.mOldDateOfInvoice = decryptDate($scope.HoaDon.dateOfInvoice);
                            $scope.mOldSymbol = $scope.HoaDon.symbol;
                            $scope.mOldBillNumber = $scope.HoaDon.billNumber;
                        }
                    }, function (reason) { //ERROR
                        console.log(reason);
                    });
                }
            }, function (reason) {
                console.log(reason);
            });


        }
        //Insert
        else {
            if (sessionStorage.itemId != undefined)
                $scope.mQD1450_HOADON_ID = sessionStorage.itemId;
            if ($scope.mQD1450_HOADON_ID != 0)
                Paste($scope.mQD1450_HOADON_ID, true);
        };
        function Paste(QD1450_HOADON_ID, IsCopy) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + QD1450_HOADON_ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.HoaDon = response.data[0];
                if ($scope.HoaDon != undefined) {
                    if (IsCopy == false) {
                        $scope.mDateOfInvoice = decryptDate($scope.HoaDon.dateOfInvoice);
                        $scope.mSymbol = $scope.HoaDon.symbol;
                        $scope.mBillNumber = $scope.HoaDon.billNumber;
                        $scope.mQD1450_HOADON_ID = $scope.HoaDon.ID;
                        $scope.mParentID = $scope.HoaDon.ParentID;
                        $scope.mSaiSot_LyDo = $scope.HoaDon.SaiSot_LyDo;
                        $scope.mLoaiDieuChinh = $scope.HoaDon.SaiSot_IsThongTin == true ? "THONGTIN" : "TIEN";
                        $scope.mSaiSot_ThongTinTruoc = $scope.HoaDon.SaiSot_ThongTinTruoc;
                        $scope.mSaiSot_ThongTinSau = $scope.HoaDon.SaiSot_ThongTinSau;
                        if ($scope.HoaDon.ID != undefined || $scope.HoaDon.MaTinhTrang != 'LAPMOI') {
                            $scope.IsUnlock = false;
                        }
                    }
                    else {
                        $scope.mOldDateOfInvoice = decryptDate($scope.HoaDon.dateOfInvoice);
                        $scope.mOldSymbol = $scope.HoaDon.symbol;
                        $scope.mOldBillNumber = $scope.HoaDon.billNumber;

                        $scope.mSymbol = $scope.HoaDon.symbol;
                        $scope.mDateOfInvoice = new Date();
                        $scope.mQD1450_HOADON_ID = -1;
                        $scope.mParentID = $scope.HoaDon.ID;
                        $scope.mSaiSot_LyDo = "";
                        $scope.mLoaiDieuChinh = "THONGTIN";
                        $scope.mSaiSot_ThongTinTruoc = "";
                        $scope.mSaiSot_ThongTinSau = "";
                        if ($scope.IsAdjust == true) {
                            $scope.mDescription = "Điều chỉnh cho hóa đơn, "
                                + "ký hiệu hóa đơn " + $scope.HoaDon.symbol
                                + " số hóa đơn " + ("00000000" + $scope.HoaDon.billNumber).slice(-8)
                                + ", ngày " + $scope.mOldDateOfInvoice.getDate()
                                + " tháng " + ($scope.mOldDateOfInvoice.getMonth() + 1)
                                + " năm " + $scope.mOldDateOfInvoice.getFullYear();
                            $scope.mDescription1 = $scope.mDescription;
                        }
                        else {
                            $scope.mDescription = "Thay thế cho hóa đơn, "
                                + "ký hiệu hóa đơn " + $scope.HoaDon.symbol
                                + " số hóa đơn " + ("00000000" + $scope.HoaDon.billNumber).slice(-8)
                                + ", ngày " + $scope.mOldDateOfInvoice.getDate()
                                + " tháng " + ($scope.mOldDateOfInvoice.getMonth() + 1)
                                + " năm " + $scope.mOldDateOfInvoice.getFullYear();
                            /* THAY THE HD */
                            $scope.mDescription1 = $scope.mDescription;
                            $scope.mID1 = -1;
                            $scope.mUnitName1 = "";
                            $scope.mQuantity1 = 1;
                            $scope.mPrice1 = 0;
                            $scope.mVAT1 = 0;
                            $scope.mVATAmount1 = 0;
                            $scope.IsThayThe = true;
                        }

                    }
                    // $scope.mInvoiceTemplateID = $scope.HoaDon.invoiceTemplateId.toString();
                    // console.log($scope.HoaDon);
                    $scope.mTypeOfRevenueID = $scope.HoaDon.typeOfRevenueId;
                    $scope.mCompanyName = $scope.HoaDon.companyName;
                    $scope.mTaxCode = $scope.HoaDon.taxCode;
                    $scope.mCustomerName = $scope.HoaDon.customerName;
                    $scope.mAddress = $scope.HoaDon.address;
                    $scope.mMedicalCode = $scope.HoaDon.medicalCode;
                    $scope.mHealthInsuranceCardNumber = $scope.HoaDon.healthInsuranceCardNumber;
                    $scope.mHospitalizationNumber = $scope.HoaDon.hospitalizationNumber;
                    $scope.mDiscount = $scope.HoaDon.Discount;
                    $scope.mDescription = $scope.HoaDon.description;
                    $scope.mTypeOfPaymentCode = $scope.HoaDon.typeOfPaymentCode;
                    $scope.mHinhThucHoaDon = $scope.HoaDon.HinhThucHoaDon;
                    $scope.mLoaiHoaDonCQT = $scope.HoaDon.LoaiHoaDonCQT;

                    $scope.HTTT.selected = { ID: $scope.HoaDon.typeOfPaymentCode, Name: $scope.HoaDon.typeOfPaymentName };

                    // if (IsCopy == false || (IsC  opy == true && $scope.IsAdjust == false)) {
                    if (IsCopy == false) {/* CHI TIẾT HÓA ĐƠN */
                        $http({
                            method: "GET",
                            url: hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_GetById?QD1450_HOADON_Id=" + QD1450_HOADON_ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                        }).then(function (response) { //SUCCESS
                            $scope.Products = response.data;
                            if ($scope.Products.length > 0) {
                                $scope.mID1 = IsCopy == true ? -1 : $scope.Products[0].ID;
                                $scope.mDescription1 = $scope.Products[0].goodAndServiceName;
                                $scope.mUnitName1 = $scope.Products[0].unitName;
                                $scope.mQuantity1 = $scope.Products[0].quantity;
                                $scope.mPrice1 = $scope.Products[0].price;
                                $scope.mVAT1 = $scope.Products[0].VAT;
                                $scope.mVATAmount1 = $scope.Products[0].VAT == '-' ? '-' : $scope.Products[0].VATAmount;
                            }
                            if ($scope.Products.length > 1) {
                                $scope.mID2 = IsCopy == true ? -1 : $scope.Products[1].ID;
                                $scope.mDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.mUnitName2 = $scope.Products[1].unitName;
                                $scope.mQuantity2 = $scope.Products[1].quantity;
                                $scope.mPrice2 = $scope.Products[1].price;
                                $scope.mVAT2 = $scope.Products[1].VAT;
                                $scope.mVATAmount2 = $scope.Products[1].VAT == '-' ? '-' : $scope.Products[1].VATAmount;
                            }
                            if ($scope.Products.length > 2) {
                                $scope.mID3 = IsCopy == true ? -1 : $scope.Products[2].ID;
                                $scope.mDescription3 = $scope.Products[2].goodAndServiceName;
                                $scope.mUnitName3 = $scope.Products[2].unitName;
                                $scope.mQuantity3 = $scope.Products[2].quantity;
                                $scope.mPrice3 = $scope.Products[2].price;
                                $scope.mVAT3 = $scope.Products[2].VAT;
                                $scope.mVATAmount3 = $scope.Products[2].VAT == '-' ? '-' : $scope.Products[2].VATAmount;
                            }
                        }, function (reason) { //ERROR
                            console.log(reason);
                        });
                    }
                }
            }, function (reason) { //ERROR
                console.log(reason);
            });
        }
        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtOldBillNumber = angular.element(document).find('#txtOldBillNumber')[0];
            var txtOldSymbol = angular.element(document).find('#txtOldSymbol')[0];
            var txtOldDateOfInvoice = angular.element(document).find('#txtOldDateOfInvoice')[0];

            var cboLoaiHoaDonCQT = angular.element(document).find('#cboLoaiHoaDonCQT')[0];
            var cboHinhThucHoaDon = angular.element(document).find('#cboHinhThucHoaDon')[0];
            var txtCustomerName = angular.element(document).find('#txtCustomerName')[0];
            var txtMedicalCode = angular.element(document).find('#txtMedicalCode')[0];
            var txtAddress = angular.element(document).find('#txtAddress')[0];
            var txtDescription1 = angular.element(document).find('#txtDescription1')[0];
            var txtSaiSot_LyDo = angular.element(document).find('#txtSaiSot_LyDo')[0];
            var txtSaiSot_ThongTinTruoc = angular.element(document).find('#txtSaiSot_ThongTinTruoc')[0];
            var txtSaiSot_ThongTinSau = angular.element(document).find('#txtSaiSot_ThongTinSau')[0];
            // $scope.mTypeOfPaymentName = document.querySelector('#cboTypeOfPayment [value="' + $scope.mTypeOfPaymentCode + '"]').text;

            var _HTTTCode = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.ID : '';
            var _HTTTName = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.Name : '';
            var flag = true;
            //check empty 

            if ($scope.mOldBillNumber == '') {
                swal({ title: "Thông tin Số hóa đơn cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldBillNumber.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mOldSymbol == '') {
                swal({ title: "Thông tin Ký hiệu hóa đơn cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldSymbol.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mOldDateOfInvoice == '') {
                swal({ title: "Thông tin Ngày hóa đơn cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldDateOfInvoice.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mLoaiHoaDonCQT == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboLoaiHoaDonCQT.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mHinhThucHoaDon = "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Hình thức hóa đơn\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboHinhThucHoaDon.focus();
                });
                flag = false;
                return;
            };
            // if ($scope.mCustomerName == '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Khách hàng\"", icon: "warning", button: "Đóng"
            //     }).then(function () {
            //         txtCustomerName.focus();
            //     });
            //     flag = false;
            //     return;
            // };
            if ($scope.mAddress == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtAddress.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mLoaiDieuChinh === '') {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại điều chỉnh\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    // txtAddress.focus();
                });
                flag = false;
                return;
            };
            // if ($scope.mMedicalCode == '') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"Mã y tế\"", icon: "warning", button: "Đóng"
            //     }).then(function () {
            //         txtMedicalCode.focus();
            //     });
            //     flag = false;
            //     return;
            // };
            if ($scope.mSaiSot_LyDo == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Lý do xử lý\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtSaiSot_LyDo.focus();
                });
                flag = false;
                return;
            };
            /*
            if($scope.IsAdjust==true && $scope.mLoaiDieuChinh=="THONGTIN"){
                if ($scope.mSaiSot_ThongTinTruoc == '') {
                    swal({title: "Vui lòng nhập thông tin \"Thông tin cũ\"", icon: "warning", button: "Đóng"
                    }).then(function(){
                        txtSaiSot_ThongTinTruoc.focus();
                    });
                    flag = false;
                    return;
                };
                if ($scope.mSaiSot_ThongTinSau == '') {
                    swal({title: "Vui lòng nhập thông tin \"Thông tin mới\"", icon: "warning", button: "Đóng"
                    }).then(function(){
                        txtSaiSot_ThongTinSau.focus();
                    });
                    flag = false;
                    return;
                };
            }     */
            //check empty details of invoice
            if ($scope.mLoaiDieuChinh !== "TBSS") {
                if ($scope.mDescription1 == '' && $scope.mDescription2 == '' && $scope.mDescription3 == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtDescription1.focus();
                    });
                    flag = false;
                    return;
                };
            }

            var vDate = new Date();
            // if ($scope.IsAdjust == false && ($scope.mOldDateOfInvoice.getMonth() != vDate.getMonth() ||
            //     $scope.mOldDateOfInvoice.getFullYear() != vDate.getFullYear())) {
            //     swal({ title: "Thông tin Ngày hóa đơn thay thế", text: 'Hóa đơn chỉ được thay thế trong tháng!', icon: "warning", button: "Đóng" }).then(function () {
            //         txtDateOfInvoice.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            var quan1 = $scope.mQuantity1 == undefined ? 1 : $scope.mQuantity1;
            var quan2 = $scope.mQuantity2 == undefined ? 1 : $scope.mQuantity2;
            var quan3 = $scope.mQuantity3 == undefined ? 1 : $scope.mQuantity3;
            var price1 = $scope.mPrice1 == undefined ? 0 : $scope.mPrice1;
            var price2 = $scope.mPrice2 == undefined ? 0 : $scope.mPrice2;
            var price3 = $scope.mPrice3 == undefined ? 0 : $scope.mPrice3;
            var VATAmount1 = $scope.mVATAmount1 == undefined ? 0 : $scope.mVATAmount1;
            var VATAmount2 = $scope.mVATAmount2 == undefined ? 0 : $scope.mVATAmount2;
            var VATAmount3 = $scope.mVATAmount3 == undefined ? 0 : $scope.mVATAmount3;
            var amountNotVAT1 = quan1 * price1;
            var amountNotVAT2 = quan2 * price2;
            var amountNotVAT3 = quan3 * price3;
            var amount1 = amountNotVAT1 + VATAmount1;
            var amount2 = amountNotVAT2 + VATAmount2;
            var amount3 = amountNotVAT3 + VATAmount3;
            var totalAmount = amount1 + amount2 + amount3;
            var totalAmountNotVAT = amountNotVAT1 + amountNotVAT2 + amountNotVAT3;
            /*
            console.log("price1="+price1+"; price2="+price2+"; price3="+price3);
            console.log("quan1="+quan1+"; quan2="+quan2+"; quan3="+quan3);
            console.log("VATAmount1="+VATAmount1+"; VATAmount2="+VATAmount2+"; VATAmount3="+VATAmount3);
            console.log("amountNotVAT1="+amountNotVAT1+"; amountNotVAT2="+amountNotVAT2+"; amountNotVAT3="+amountNotVAT3);
            console.log("amount1="+amount1+"; amount2="+amount2+"; amount3="+amount3);
            console.log("totalAmount="+totalAmount);
            console.log("totalAmountNotVAT="+totalAmountNotVAT);
            */
            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mQD1450_HOADON_THAYDOI_ID <= 0 ? -1 : $scope.mQD1450_HOADON_THAYDOI_ID,
                    'dateOfInvoice': encryptDate($scope.mDateOfInvoice),
                    'invoiceTemplateId': $scope.mInvoiceTemplateID,
                    'LoaiHoaDon': '',
                    'LoaiDoanhThu': $scope.mTypeOfRevenueID,
                    'SoPhieu': '',
                    'MaHoSo': '',
                    'HinhThucHoaDon': $scope.mHinhThucHoaDon,
                    'MaCoQuanThue': '',
                    'LoaiHoaDonCQT': $scope.mLoaiHoaDonCQT,
                    'typeOfPaymentCode': _HTTTCode,
                    'typeOfPaymentName': _HTTTName,

                    'taxCode': $scope.mTaxCode,
                    'customerName': $scope.mCustomerName,
                    'companyId': $scope.HoaDon.companyId,
                    'companyName': $scope.mCompanyName,
                    'phone': '',
                    'email': '',
                    'address': $scope.mAddress,
                    'accountNumber': '',
                    'medicalCode': $scope.mMedicalCode,
                    'hospitalizationNumber': $scope.mHospitalizationNumber,
                    'healthInsuranceCardNumber': $scope.mHealthInsuranceCardNumber,
                    'totalAmountNotVAT': totalAmountNotVAT,
                    'totalAmount': totalAmount,
                    'description': $scope.mSaiSot_LyDo,//$scope.mDescription,
                    'userCreated': user.ID,
                    'userUpdated': user.ID,
                    'EnterpriseId': sessionStorage.enterpriseId,

                    'ParentID': $scope.mParentID,
                    'SaiSot_Loai': $scope.mModule,
                    'SaiSot_IsThongTin': $scope.mLoaiDieuChinh == "THONGTIN" ? true : false,
                    'SaiSot_LyDo': $scope.mSaiSot_LyDo,
                    'SaiSot_ThongTinTruoc': $scope.mSaiSot_ThongTinTruoc,
                    'SaiSot_ThongTinSau': $scope.mSaiSot_ThongTinSau,
                    'IsTBSS': $scope.mLoaiDieuChinh == "TBSS" ? true : false

                };
                // console.log(inputData);
                // return;
                $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mQD1450_HOADON_ID = objResult.Data;
                    $scope.mQD1450_HOADON_THAYDOI_ID = objResult.ResultCode;
                    var flagDetail = true;
                    //ADD DETAIL 1
                    if ($scope.mDescription1 != '') {
                        var data = {
                            'ID': $scope.mID1 == undefined ? -1 : $scope.mID1,
                            'QD1450_HOADON_Id': $scope.mQD1450_HOADON_ID,
                            'goodAndServiceName': $scope.mDescription1,
                            'unitName': $scope.mUnitName1,
                            'quantity': quan1,
                            'price': price1,
                            'amountNotVAT': amountNotVAT1,
                            'VAT': $scope.mVAT1 != undefined ? $scope.mVAT1 : 0,
                            'VATAmount': VATAmount1,
                            'amount': amount1,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        // console.log(data);
                        $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                            .then(function (success) { }, function (error) {
                                flagDetail = false;
                                console.log(error);
                            });
                    };
                    //ADD DETAIL 2  
                    if ($scope.mDescription2 != '') {
                        var data = {
                            'ID': $scope.mID2 == undefined ? -1 : $scope.mID2,
                            'QD1450_HOADON_Id': $scope.mQD1450_HOADON_ID,
                            'goodAndServiceName': $scope.mDescription2,
                            'unitName': $scope.mUnitName2,
                            'quantity': quan2,
                            'price': price2,
                            'amountNotVAT': amountNotVAT2,
                            'VAT': $scope.mVAT2 != undefined ? $scope.mVAT2 : 0,
                            'VATAmount': VATAmount2,
                            'amount': amount2,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                            .then(function (success) { }, function (error) {
                                flagDetail = false;
                                console.log(error);
                            });
                    };

                    //ADD DETAIL 3
                    if ($scope.mDescription3 != '') {
                        var data = {
                            'ID': $scope.mID3 == undefined ? -1 : $scope.mID3,
                            'QD1450_HOADON_Id': $scope.mQD1450_HOADON_ID,
                            'goodAndServiceName': $scope.mDescription3,
                            'unitName': $scope.mUnitName3,
                            'quantity': quan3,
                            'price': price3,
                            'amountNotVAT': amountNotVAT3,
                            'VAT': $scope.mVAT3 != undefined ? $scope.mVAT3 : 0,
                            'VATAmount': VATAmount3,
                            'amount': amount3,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                            .then(function (success) { }, function (error) {
                                flagDetail = false;
                                console.log(error);
                            });
                    }

                    if (flagDetail == true) {
                        swal({
                            title: "Thông báo", text: "Lưu dữ liệu thành công!", icon: "success", button: "Đóng",
                        }).then(function () {
                            sessionStorage.itemId = $scope.mQD1450_HOADON_THAYDOI_ID;
                            sessionStorage.IsUpdate = true;
                            $state.reload();
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo", text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!", icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                    }
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            location.href = "#/HoaDon" + $scope.mModule;
                        });
                    });
            }
        };



        $scope.backPage = function () {
            location.href = "#/HoaDonDieuChinh/" + $scope.mModule;
        };

        $scope.ReviewBienBan = function () {
            var _fileName = $scope.mSymbol + '_' + ("00000000" + $scope.mBillNumber).slice(-8) + '_' + $scope.mQD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.PublishBienBan = function () {

            $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Publish?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId)
                .then(function (success) {
                    var fileName = success.data.Data;
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({
                            'id': sessionStorage.itemId,
                            'PDF': 'BB',
                            'file': fileName,
                            'dateOfInvoice': encryptDate($scope.mDateOfInvoice),
                            'enterpriseId': user.enterpriseId,
                            'urlUpload': hostName.url + "api/QD1450/UploadFilePDF2Server",
                            'urlDownload': UrlDownload,
                        })
                    };
                    $http(req).then(function () {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thành công !",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/HoaDonDieuChinh";
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thất bại !, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                        });
                        console.log(error);
                    });
                },
                    function (errs) {
                        console.log(errs);
                    });
        };
        $scope.FindData = function () {
            sessionStorage.Module = $scope.mModule;
            location.href = '#/SearchHoaDon';
        };

        $scope.calVATAmount1 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            if (price == undefined) price = 0;
            $scope.mVATAmount1 = roundNumber((price * quantity * vat) / 100);
        };

        $scope.calVATAmount2 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            if (price == undefined) price = 0;
            $scope.mVATAmount2 = roundNumber((price * quantity * vat) / 100);
        };

        $scope.calVATAmount3 = function (price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            if (price == undefined) price = 0;
            $scope.mVATAmount3 = roundNumber((price * quantity * vat) / 100);
        };

        $scope.txtTaxCode_TextChangeEvent = function () {
            if ($scope.mTaxCode != '' && $scope.mTaxCode != undefined) {
                $http({
                    method: "GET",
                    url: hostName.url + "api/Customer/CustomerByTaxCode?taxCode=" + $scope.mTaxCode,
                }).then(function (response) {
                    $scope.KhachHang = response.data;
                    $scope.mCustomerName = $scope.KhachHang.customerName;
                    $scope.mAddress = $scope.KhachHang.address;
                }, function (reason) { //ERROR
                    console.log(reason);
                });
            }
        };

        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + $scope.mInvoiceTemplateID,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mSymbol = invoiceTemplate.symbol;
                    getTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                }
            }, function (reason) {
            });
        };

        $scope.cboLoaiDieuChinh_SelectedChangeEvent = function (mDieuCHinh) {
            $scope.mLoaiDieuChinh = mDieuCHinh.ID;
            if ($scope.mLoaiDieuChinh == "THONGTIN") {
                $scope.IsChinhThongTin = true;
                $scope.mQuantity1 = undefined;
                $scope.mPrice1 = undefined;
                $scope.mVAT1 = 0;
                $scope.mVATAmount1 = undefined;
                $scope.mQuantity2 = undefined;
                $scope.mPrice2 = undefined;
                $scope.mVAT2 = undefined;
                $scope.mVATAmount2 = undefined;
                $scope.mQuantity3 = undefined;
                $scope.mPrice3 = undefined;
                $scope.mVAT3 = undefined;
                $scope.mVATAmount3 = undefined;
            }
            else
                $scope.IsChinhThongTin = false;
        };


        function getInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
            }).then(function (response) {
                $scope.arrInvoiceTemplate = response.data;
                if ($scope.IsUpdate == false) {
                    $scope.mInvoiceTemplateID = String(response.data[0].ID);
                    $scope.mSymbol = response.data[0].symbol;
                    $scope.mTypeOfPaymentCode = 'TM';
                    $scope.mLoaiDieuChinh = 'THONGTIN';
                    getTypeOfRevenue(response.data[0].typeOfInvoiceId);
                }
            }, function (error) {
                console.log(error);
            });
        }

        function getTypeOfPayment() {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfPayment/List?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function (response) { //SUCCESS
                $scope.arrTypeOfPayment = response.data;
                $scope.mTypeOfPaymentCode = 'TM';
            }, function (error) { //ERROR
            });
        };

        function GetLoaiDieuChinh() {
            $scope.arrLoaiDieuChinh.push({ ID: 'THONGTIN', Name: 'Thông tin' });
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/IsUserSupperModifyInvoice?UserID=" + user.ID + "&EnterpriseID=" + sessionStorage.enterpriseId
            }).then(function (response) {
                if (response.data == true)
                    $scope.arrLoaiDieuChinh.push({ ID: 'TIEN', Name: 'Chi tiết, số tiền' });
            }, function (error) {
                console.log(error);
            });
            // $scope.mLoaiDieuChinh = 'THONGTIN';
            // if ($scope.IsAdjust == true)
            //     $scope.IsChinhThongTin = true;
            $scope.mLoaiDieuChinh = 'THONGTIN';
            if ($scope.IsAdjust == true) {
                $scope.IsChinhThongTin = true;
                $scope.arrLoaiDieuChinh.push({ ID: 'TBSS', Name: 'TBSS Đ/C' });

            }
        }

        function GetHTHD() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (data) {
                var _data = data.data[0];
                //CO MA
                if (_data != undefined && _data.HaveCode == true) {
                    $scope.arrHinhThucHoaDon.push({ ID: 'COMA', Name: 'Có mã' });
                    $scope.mHinhThucHoaDon = 'COMA';
                    // $scope.mHinhThucHoaDon.selected = { ID: 'COMA', Name: 'Có mã' };
                }
                //KHONG CO MA
                if (_data != undefined && _data.DontHaveCode == true) {
                    $scope.arrHinhThucHoaDon.push({ ID: 'KHONGMA', Name: 'Không có mã' });
                    if (_data.HaveCode == false)
                        $scope.mHinhThucHoaDon = 'KHONGMA';

                }

                //GTGT
                if (_data != undefined && _data.UseVATInvoice == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'GTGT', Name: 'GTGT' });
                    $scope.mLoaiHoaDonCQT = 'GTGT'
                }
                //BAN HANG
                if (_data != undefined && _data.UseBillOfSale == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'BANHANG', Name: 'Bán hàng' });
                    if (_data.UseVATInvoice == false)
                        $scope.mLoaiHoaDonCQT = 'BANHANG';
                }
                //TAI SAN CONG
                if (_data != undefined && _data.UsePublicProperty == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'TSCONG', Name: 'TS công' });
                    if (_data.UseVATInvoice == false && _data.UseBillOfSale == false)
                        $scope.mLoaiHoaDonCQT = 'TSCONG';
                }
                //DU TRU QUOC GIA
                if (_data != undefined && _data.UseNationalReserve == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'DTQGIA', Name: 'DT Quốc Gia' });
                    if (_data.UseVATInvoice == false && _data.UseBillOfSale == false && _data.UsePublicProperty == false)
                        $scope.mLoaiHoaDonCQT = 'DTQGIA';
                }
                //KHAC
                if (_data != undefined && _data.UseOther == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'KHAC', Name: 'Khác' });
                    if (_data.UseVATInvoice == false && _data.UseBillOfSale == false && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false)
                        $scope.mLoaiHoaDonCQT = 'KHAC';
                }
                //CHUNG TU
                if (_data != undefined && _data.UseDocument == true) {
                    $scope.arrLoaiHoaDonCQT.push({ ID: 'CHUNGTU', Name: 'Chứng từ' });
                    if (_data.UseVATInvoice == false && _data.UseBillOfSale == false && _data.UsePublicProperty == false
                        && _data.UseNationalReserve == false && _data.UseOther == false)
                        $scope.mLoaiHoaDonCQT = 'CHUNGTU';
                }
                $scope.HTTT.selected = { ID: 'TM/CK', Name: 'TM/CK' };
                $scope.LoaiDieuChinh.selected = { ID: 'THONGTIN', Name: 'Thông tin' };
            }, function (error) {
                console.log(error);
            });
        };

        function getTypeOfRevenue(typeOfInvoiceId) {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId + "&typeOfInvoiceId=" + typeOfInvoiceId
            }).then(function (response) {
                $scope.arrTypeOfRevenue = response.data;
            }, function (reason) {
                console.log(reason);
            });
        }
    };

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateHuyHoaDonCtrl', CreateHuyHoaDonCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateHuyHoaDonCtrl($scope, $http, $stateParams, hostName, $state, $filter) {

        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mQD1450_HOADON_THAYDOI_ID = 0;
        $scope.mQD1450_HOADON_ID = 0;
        $scope.mBillNumber = "";
        $scope.mSymbol = "";
        $scope.mDateOfInvoice = "";
        $scope.mDateAdjust = "";
        $scope.mCustomerName = "";
        $scope.mTotalAmount = 0;
        $scope.IsUnlock = true;
        $scope.IsPublic = false;
        $scope.IsUpdate = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;

        if ($scope.IsUpdate == true) {
            $scope.IsPublic = true;
            $scope.mQD1450_HOADON_THAYDOI_ID = sessionStorage.itemId;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetByID?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.Adjust = response.data[0];
                if ($scope.Adjust != undefined) {
                    $scope.mQD1450_HOADON_ID = $scope.Adjust.QD1450_HOADON_Id;
                    $scope.mDateAdjust = decryptDate($scope.Adjust.dateAdjust);
                    $scope.mDescription = $scope.Adjust.description;
                    if ($scope.Adjust.MaTinhTrang != 'LAPMOI')
                        $scope.IsUnlock = false;
                    if ($scope.Adjust.FileBienBan != '')
                        $scope.IsPublic = false;

                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + $scope.mQD1450_HOADON_ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) {
                        $scope.HoaDon = response.data[0];
                        if ($scope.HoaDon != undefined) {
                            $scope.mBillNumber = $scope.HoaDon.billNumber;
                            $scope.mSymbol = $scope.HoaDon.symbol;
                            $scope.mDateOfInvoice = decryptDate($scope.HoaDon.dateOfInvoice);
                            $scope.mCustomerName = $scope.HoaDon.customerName;
                            $scope.mTotalAmount = $scope.HoaDon.totalAmount;
                        }
                    }, function (reason) {
                        console.log(reason);
                    });
                }
            }, function (reason) {
                console.log(reason);
            });

        }
        else {
            if (sessionStorage.itemId != undefined)
                $scope.mQD1450_HOADON_ID = sessionStorage.itemId;
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + $scope.mQD1450_HOADON_ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.HoaDon = response.data[0];
                if ($scope.HoaDon != undefined) {
                    $scope.mBillNumber = $scope.HoaDon.billNumber;
                    $scope.mSymbol = $scope.HoaDon.symbol;
                    $scope.mDateOfInvoice = decryptDate($scope.HoaDon.dateOfInvoice);
                    $scope.mCustomerName = $scope.HoaDon.customerName;
                    $scope.mTotalAmount = $scope.HoaDon.totalAmount;
                    // $scope.mDateAdjust = decryptDate($scope.HoaDon.dateOfInvoice);
                    $scope.mDateAdjust = decryptDate(new Date());

                }
            }, function (reason) {
                console.log(reason);
            });
        }

        //BACK TO LAST PAGE
        $scope.backPage = function () {
            location.href = "#/HuyHoaDon";
        };

        //SAVE DATA TO DATABASE
        $scope.save = function () {
            var txtBillNumber = angular.element(document).find('#txtBillNumber')[0];
            var txtSymbol = angular.element(document).find('#txtSymbol')[0];
            var txtDateOfInvoice = angular.element(document).find('#txtDateOfInvoice')[0];
            var txtDateAdjust = angular.element(document).find('#txtDateAdjust')[0];
            var txtDescription = angular.element(document).find('#txtDescription')[0];
            var flag = true;

            //check empty 
            if ($scope.mBillNumber == '') {
                swal({ title: "Thông tin Số hóa đơn", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtBillNumber.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mSymbol == '') {
                swal({ title: "Thông tin Ký hiệu", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtSymbol.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDateOfInvoice == '') {
                swal({ title: "Thông tin Ngày hóa đơn", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtDateOfInvoice.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDateAdjust == '') {
                swal({ title: "Thông tin Ngày Hủy", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtDateAdjust.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDescription == '') {
                swal({ title: "Thông tin Lý do Hủy", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtDescription.focus();
                });
                flag = false;
                return;
            };
            // if ($scope.mDateAdjust.getMonth() != $scope.mDateOfInvoice.getMonth() ||
            //     $scope.mDateAdjust.getFullYear() != $scope.mDateOfInvoice.getFullYear()) {
            //     swal({ title: "Thông tin Ngày hủy", text: 'Hóa đơn chỉ được hủy trong tháng!', icon: "warning", button: "Đóng" }).then(function () {
            //         txtDateAdjust.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mQD1450_HOADON_THAYDOI_ID,
                    'QD1450_HOADON_Id': $scope.mQD1450_HOADON_ID,
                    'dateAdjust': encryptDate($scope.mDateAdjust),
                    'typeOfAction': "DELETE",
                    'description': $scope.mDescription,
                    'userCreated': user.ID,
                    'enterpriseId': sessionStorage.enterpriseId
                };

                $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Insert", inputData)
                    .then(function (response) {
                        var objResult = response.data;
                        sessionStorage.itemId = objResult.Data;
                        sessionStorage.IsUpdate = true;
                        swal({
                            title: "Thông báo",
                            text: "Lưu dữ liệu thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                            //location.href = "#/HuyHoaDon";
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể xử lý được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            console.log(error);
                            location.href = "#/HuyHoaDon";
                        });
                    });
            }
        };

        $scope.FindData = function () {
            sessionStorage.Module = "DELETE";
            location.href = '#/SearchHoaDon';
        };

        $scope.ReviewBienBan = function () {
            var _fileName = $scope.mSymbol + '_' + ("00000000" + $scope.mBillNumber).slice(-8) + '_' + $scope.mQD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.PublishBienBan = function () {
            // alert("Đang phát triển !");
            // $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Publish?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID, $scope.mQD1450_HOADON_THAYDOI_ID)
            //     .then(function (success) {
            //         swal({
            //             title: "Thông báo",
            //             text: "Biên bản đã phát hành, vui lòng đợi ký số!",
            //             icon: "success", button: "Đóng",
            //         }).then(function () {
            //             $scope.backPage();
            //         });
            //     },
            //         function (errs) {
            //             swal({
            //                 title: "Thông báo",
            //                 text: "Không thể phát hành biên bản hóa đơn sai sót, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
            //                 icon: "error", dangerMode: true, button: "Đóng",
            //             }).then(function () {
            //                 $scope.backPage();
            //             });
            //             console.log(errs);
            //         });  
            $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Publish?ID=" + $scope.mQD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId)
                .then(function (success) {
                    var fileName = success.data.Data;
                    var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({
                            'id': sessionStorage.itemId,
                            'PDF': 'BB',
                            'file': fileName,
                            'dateOfInvoice': encryptDate($scope.mDateAdjust),
                            'enterpriseId': user.enterpriseId,
                            'urlUpload': hostName.url + "api/QD1450/UploadFilePDF2Server",
                            'urlDownload': UrlDownload,
                        })
                    };
                    $http(req).then(function () {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thành công !",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/HuyHoaDon";
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Ký file thất bại !, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                        });
                        console.log(error);
                    });
                },
                    function (errs) {
                        console.log(errs);
                    });

            /*  */

        };
    };
    /******  ### END CONTROLLER  ******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('DanhSachSaiSotCtrl', DanhSachSaiSotCtrl);

    /*******    +++ START CONTROLLER    *******/
    function DanhSachSaiSotCtrl($scope, $http, $state, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.arrData = [];
        $scope.arrTypeOfAction = [];

        $scope.mTotalInvoice = 0;
        $scope.mTotalList = 0;
        $scope.smartTablePageSize = 10;
        $scope.TypeOfAction = [];
        GetTypeOfAction();

        function GetTypeOfAction() {
            $scope.arrTypeOfAction.push({ ID: 'DELETE', Name: 'Hủy' });
            $scope.arrTypeOfAction.push({ ID: 'ADJUST', Name: 'Điều chỉnh' });
            $scope.arrTypeOfAction.push({ ID: 'REPLACE', Name: 'Thay thế' });
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalInvoice = 0;
            $scope.mTotalList = 0;
            // console.log(response.data[0]);
            var total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;

            total = response.data[1][0].TotalList;
            if (total != undefined)
                $scope.mTotalList = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction="
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&Descr=";
        $http({
            method: "GET",
            url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditDanhSachSaiSot = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/DanhSachSaiSot';
            location.href = '#/CreateDanhSachSaiSot';
        };

        $scope.CreateDanhSachSaiSot = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateDanhSachSaiSot';
        }


        $scope.FindData = function () {
            searchData();
        };

        function searchData() {
            $scope.mTypeOfAction = $scope.TypeOfAction.selected != undefined ? $scope.TypeOfAction.selected.ID : '';

            $scope.arrData = [];
            $scope.mTotalInvoice = 0;
            $scope.mTotalList = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            var queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction=" + $scope.mTypeOfAction
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&Descr=" + $scope.mDescr;
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }

        $scope.PrintThongBaoSaiSot = function (ID, RefNbr) {
            var _fileName = RefNbr + '_' + "ThongBaoSaiSot.pdf";

            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_PrintThongBaoSaiSot?ID=" + ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };

        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileSigned = function (FileXML, RefNbr, RefDate) {

            var _fileName = RefNbr + '_' + $filter('replace')(RefDate, '/', '-');
            $http({
                method: 'GET',
                url: hostName.url + "api/ModifyInvoice/QD1450_SAISOT_GetFileSigned?EnterpriseID=" + sessionStorage.enterpriseId + "&FileXML=" + FileXML,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
            });

        };

        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo", text: "Đã có kết quả phản hồi từ Cơ quan Thuế!", icon: "success", button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo", text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo", text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error", dangerMode: true, button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };



    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('HoaDonDieuChinhCtrl', HoaDonDieuChinhCtrl);

    /*******    +++ START CONTROLLER    *******/
    function HoaDonDieuChinhCtrl($scope, $http, $stateParams, hostName, $filter, $window) {
        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));

        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mTotalAmount = 0;
        $scope.mTotalInvoice = 0;
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        $scope.arrStatus = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.mModule = $stateParams.Module;
        console.log("$scope.mModule=" + $scope.mModule);


        if ($scope.mModule == "REPLACE")
            $scope.PageTitle = "Hóa đơn thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = "Hóa đơn Điều chỉnh";
        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
        //         + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        //     }).then(function(response) {
        //         $scope.arrStatus = response.data;
        //     }, function(error) {
        //         console.log(error);
        //     });

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId+"&TypeOfInvoiceCode=HD"
        //     }).then(function(response) {
        //         $scope.arrInvoiceTemplate = response.data;
        //     }, function(error) {
        //         console.log(error);
        //     });

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        //     }).then(function(response){
        //         $scope.arrTypeOfRevenue = response.data.Table1;
        //     }, function(error){
        //         console.log(error);
        //     });


        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/file/d/1zx23jdvYJrb0IeLjeL-PLPucKpK0EBTk/view?usp=sharing");
        }
        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total; //.replace(/,/g,".");

            total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=0&CustomerName=&BillNumber=&Symbol=&MedicalCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditHoaDonDieuChinh = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/HoaDonDieuChinh';
            location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        $scope.CreateHoaDonDieuChinh = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        }

        $scope.ReviewBienBan = function (QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + QD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetFileSigned = function (FileBienBan, QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'GET',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetFileSigned?ID=" + QD1450_HOADON_THAYDOI_ID + "&FileBienBan=" + FileBienBan + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };


        $scope.FindData = function () {
            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&MedicalCode=" + $scope.mMedicalCode + "&BillNumber=" + $scope.mBillNumber
                + "&Symbol=" + $scope.mSymbol + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + $scope.mStatusCode + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&LoaiThu=%" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


        $scope.sendEmailTBSS = function (Filehoadon, QD1450_HOADON_THAYDOI_ID) {
            /* GET THÔNG TIN EMAIL */
            $scope.IsDisabled = true;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetByID?ID=" + QD1450_HOADON_THAYDOI_ID + "&EnterpriseId="
                    + sessionStorage.enterpriseId
            }).success(function (respone) {
                var Idhoadon = respone[0].QD1450_HOADON_Id;
                $http({
                    method: "GET",
                    url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + Idhoadon + "&EnterpriseId="
                        + sessionStorage.enterpriseId
                }).success(function (data) {
                    $scope.IsDisabled = false;
                    console.log(data);
                    var _email = data[0].email;
                    var TaxCode = data[0].MaSoThueBan;
                    var HoaDonId = data[0].ID;
                    var Lydo = respone[0].description;
                    var NgayDieuChinh = respone[0].dateAdjust;
                    if (data[0].email === undefined || data[0].email === '' || data[0].email === null) {
                        /*HÓA ĐƠN CHƯA CÓ EMAIL */
                        swal({
                            title: "HÓA ĐƠN CHƯA CÓ ĐỊA CHỈ E-MAIL !",
                            icon: "error",
                            // dangerMode: true,
                            buttons: ["Đóng", "Thêm E-mail"],

                        }).then(function (data) {
                            /* NHẬP EMAIL GỬI */
                            if (data === true) {
                                swal({
                                    title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                    content: "input",
                                    buttons: ["Đóng", "Gửi"],
                                }).then(function (email) {
                                    /* GỬI EMAIL VỪA NHẬP */
                                    if (email === '' || email === undefined || email === null) {
                                        return;
                                    }
                                    else {
                                        send_email_tbss(Filehoadon, sessionStorage.enterpriseId, email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                                    }
                                })
                            }
                        })
                    }

                    else {
                        $scope.IsDisabled = false;
                        /* HĐ ĐÃ CÓ EMAIL */
                        swal({
                            title: "Gửi email cho" + "\n " + _email + " ?",
                            icon: "warning",
                            buttons: {
                                cancel: "Đóng",
                                chooseEmail: "Chọn email khác!",
                                confirm: "Gửi"
                            },
                            // closeOnClickOutside: false
                        }).then(function (data) {
                            if (data === true) {
                                $scope.IsDisabled = true;
                                send_email_tbss(Filehoadon, sessionStorage.enterpriseId, _email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                            }
                            if (data === 'chooseEmail') {
                                swal({
                                    title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                    content: "input",
                                    buttons: ["Đóng", "Gửi"],
                                    // closeOnClickOutside: false
                                }).then(function (email) {
                                    /* GỬI EMAIL VỪA NHẬP */
                                    if (email === '' || email === undefined || email === null) {
                                        // swal("Email không được bỏ trống!!!");
                                    }
                                    else {
                                        $scope.IsDisabled = true;
                                        send_email_tbss(Filehoadon, sessionStorage.enterpriseId, email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                                    }
                                })
                            }
                        })
                    }
                })
            })
        }

        /* send_email_tbss */
        function send_email_tbss(FileSigned, enterpriseId, email, taxCcode, hoaDonid, lyDo, ngayDieuchinh) {
            // console.log(enterpriseId, email, taxCcode, hoaDonid, trangThai, lyDo, ngayDieuchinh);
            // return;
            $http({
                method: "POST",
                url: hostName.url + "api/QD1450/SendEmail_TBSS?FileSigned=" + FileSigned + "&EnterpriseId=" + enterpriseId + "&EmailAddress="
                    + email + "&TaxCode=" + taxCcode +
                    "&HoaDonId=" + hoaDonid + "&LyDo=" + lyDo + "&NgayDieuChinh=" + ngayDieuchinh,
                // responseType: 'blob',
            }).success(function (data) {
                SwalSendEmailSuccess();
                $scope.IsDisabled = false;
            }).error(function (erro) {
                SwalSendEmailError();
                $scope.IsDisabled = false;
                console.log(erro);
            })
        }
        /* EMAIL RESPONE */
        function SwalSendEmailSuccess() {
            swal({
                title: "ĐÃ GỬI E-MAIL THÀNH CÔNG !",
                icon: "success",
                buttons: "Đóng",
            })
        }

        function SwalSendEmailError() {
            swal({
                title: "GỬI E-MAIL THẤT BẠI !",
                icon: "error",
                buttons: "Đóng",
            })
        }
    };

    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author thienvm
 * created on 20230303
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('HoaDonThayTheCtrl', HoaDonThayTheCtrl);

    /*******    +++ START CONTROLLER    *******/
    function HoaDonThayTheCtrl($scope, $http, $stateParams, hostName, $filter) {
        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));

        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mTotalAmount = 0;
        $scope.mTotalInvoice = 0;
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        $scope.arrStatus = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.mModule = $stateParams.Module;
        console.log("$scope.mModule=" + $scope.mModule);
        if ($scope.mModule == "REPLACE")
            $scope.PageTitle = "Hóa đơn thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = "Hóa đơn Điều chỉnh";
        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;

        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            $scope.arrStatus = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
        }).then(function (response) {
            $scope.arrInvoiceTemplate = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        }).then(function (response) {
            $scope.arrTypeOfRevenue = response.data.Table1;
        }, function (error) {
            console.log(error);
        });

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total; //.replace(/,/g,".");

            total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=&CustomerName=&BillNumber=&Symbol=&MedicalCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditHoaDonDieuChinh = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/HoaDonDieuChinh';
            location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        $scope.CreateHoaDonDieuChinh = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        }

        $scope.ReviewBienBan = function (QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + QD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetFileSigned = function (FileBienBan, QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'GET',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetFileSigned?ID=" + QD1450_HOADON_THAYDOI_ID + "&FileBienBan=" + FileBienBan + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };


        $scope.FindData = function () {
            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&MedicalCode=" + $scope.mMedicalCode + "&BillNumber=" + $scope.mBillNumber
                + "&Symbol=" + $scope.mSymbol + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + $scope.mStatusCode + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&LoaiThu=" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('HuyHoaDonCtrl', HuyHoaDonCtrl);

    /*******    +++ START CONTROLLER    *******/
    function HuyHoaDonCtrl($scope, $http, $state, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mTotalAmount = 0;
        $scope.mTotalInvoice = 0;
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        $scope.arrStatus = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];

        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/file/d/1zx23jdvYJrb0IeLjeL-PLPucKpK0EBTk/view?usp=sharing");
        }
        // $scope.getHuongDan = function () {
        //     $window.open("https://drive.google.com/file/d/1zx23jdvYJrb0IeLjeL-PLPucKpK0EBTk/view?usp=sharing");
        // }
        /* 1 thienvm đóng */
        // $http({
        //     method: "GET",
        //     url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
        //         + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        // }).then(function (response) {
        //     $scope.arrStatus = response.data;
        // }, function (error) {
        //     console.log(error);
        // });


        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId+"&TypeOfInvoiceCode=HD"
        //     }).then(function(response) {
        //         $scope.arrInvoiceTemplate = response.data;
        //     }, function(error) {
        //         console.log(error);
        //     });

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        //     }).then(function(response){
        //         $scope.arrTypeOfRevenue = response.data.Table1;
        //     }, function(error){
        //         console.log(error);
        //     });
        /* 1 */

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total; //.replace(/,/g,".");

            total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=DELETE&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=0&CustomerName=&BillNumber=&Symbol=&MedicalCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditHuyHoaDon = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/HuyHoaDon';
            location.href = '#/CreateHuyHoaDon';
        };

        //Create new Invoice
        $scope.CreateHuyHoaDon = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateHuyHoaDon';
        }

        $scope.ReviewBienBan = function (QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + QD1450_HOADON_THAYDOI_ID + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetFileSigned = function (FileBienBan, QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'GET',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetFileSigned?ID=" + QD1450_HOADON_THAYDOI_ID + "&FileBienBan=" + FileBienBan + "&EnterpriseID=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.FindData = function () {
            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            queryString = "TypeOfAction=DELETE&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&MedicalCode=" + $scope.mMedicalCode + "&BillNumber=" + $scope.mBillNumber
                + "&Symbol=" + $scope.mSymbol + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + $scope.mStatusCode + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&LoaiThu=%" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data
        $("input").on("change", function () {
            this.setAttribute(
                "data-date",
                moment(this.value, "YYYY-MM-DD")
                    .format(this.getAttribute("data-date-format"))
            )
        }).trigger("change")


        /* SEND MAIL HUY */
        $scope.sendEmailTBSS = function (Filehoadon, QD1450_HOADON_THAYDOI_ID, symbol, billNumber) {
            /* GET THÔNG TIN EMAIL */
            $scope.IsDisabled = true;
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_GetByID?ID=" + QD1450_HOADON_THAYDOI_ID + "&EnterpriseId="
                    + sessionStorage.enterpriseId
            }).success(function (respone) {
                var Idhoadon = respone[0].QD1450_HOADON_Id;
                $http({
                    method: "GET",
                    url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + Idhoadon + "&EnterpriseId="
                        + sessionStorage.enterpriseId
                }).success(function (data) {
                    $scope.IsDisabled = false;
                    console.log(data);
                    var _email = data[0].email;
                    var TaxCode = data[0].MaSoThueBan;
                    var HoaDonId = data[0].ID;
                    var Lydo = respone[0].description;
                    var NgayDieuChinh = respone[0].dateAdjust;
                    if (data[0].email === undefined || data[0].email === '' || data[0].email === null) {
                        /*HÓA ĐƠN CHƯA CÓ EMAIL */
                        swal({
                            title: "HÓA ĐƠN CHƯA CÓ ĐỊA CHỈ E-MAIL !",
                            icon: "error",
                            // dangerMode: true,
                            buttons: ["Đóng", "Thêm E-mail"],

                        }).then(function (data) {
                            /* NHẬP EMAIL GỬI */
                            if (data === true) {
                                swal({
                                    title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                    content: "input",
                                    buttons: ["Đóng", "Gửi"],
                                }).then(function (email) {
                                    /* GỬI EMAIL VỪA NHẬP */
                                    if (email === '' || email === undefined || email === null) {
                                        return;
                                    }
                                    else {
                                        send_email_tbss(Filehoadon, sessionStorage.enterpriseId, email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                                    }
                                })
                            }
                        })
                    }

                    else {
                        $scope.IsDisabled = false;
                        /* HĐ ĐÃ CÓ EMAIL */
                        swal({
                            title: "Gửi email cho" + "\n " + _email + " ?",
                            icon: "warning",
                            buttons: {
                                cancel: "Đóng",
                                chooseEmail: "Chọn email khác!",
                                confirm: "Gửi"
                            },
                            // closeOnClickOutside: false
                        }).then(function (data) {
                            if (data === true) {
                                $scope.IsDisabled = true;
                                send_email_tbss(Filehoadon, sessionStorage.enterpriseId, _email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                            }
                            if (data === 'chooseEmail') {
                                swal({
                                    title: "NHẬP ĐỊA CHỈ E-MAIL MUỐN GỬI!",
                                    content: "input",
                                    buttons: ["Đóng", "Gửi"],
                                    // closeOnClickOutside: false
                                }).then(function (email) {
                                    /* GỬI EMAIL VỪA NHẬP */
                                    if (email === '' || email === undefined || email === null) {
                                        // swal("Email không được bỏ trống!!!");
                                    }
                                    else {
                                        $scope.IsDisabled = true;
                                        send_email_tbss(Filehoadon, sessionStorage.enterpriseId, email, TaxCode, HoaDonId, Lydo, NgayDieuChinh);
                                    }
                                })
                            }
                        })
                    }
                })
            })
        }

        /* send_email_tbss */
        function send_email_tbss(FileSigned, enterpriseId, email, taxCcode, hoaDonid, lyDo, ngayDieuchinh) {
            // console.log(enterpriseId, email, taxCcode, hoaDonid, trangThai, lyDo, ngayDieuchinh);
            // return;
            $http({
                method: "POST",
                url: hostName.url + "api/QD1450/SendEmail_TBSS?FileSigned=" + FileSigned + "&EnterpriseId=" + enterpriseId + "&EmailAddress="
                    + email + "&TaxCode=" + taxCcode +
                    "&HoaDonId=" + hoaDonid + "&LyDo=" + lyDo + "&NgayDieuChinh=" + ngayDieuchinh,
                // responseType: 'blob',
            }).success(function (data) {
                SwalSendEmailSuccess();
                $scope.IsDisabled = false;
            }).error(function (erro) {
                SwalSendEmailError();
                $scope.IsDisabled = false;
                console.log(erro);
            })
        }
    };

    /* EMAIL RESPONE */
    function SwalSendEmailSuccess() {
        swal({
            title: "ĐÃ GỬI E-MAIL THÀNH CÔNG !",
            icon: "success",
            buttons: "Đóng",
        })
    }

    function SwalSendEmailError() {
        swal({
            title: "GỬI E-MAIL THẤT BẠI !",
            icon: "error",
            buttons: "Đóng",
        })
    }
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('SearchHoaDonCtrl', SearchHoaDonCtrl);

    /*******    +++ START CONTROLLER    *******/
    function SearchHoaDonCtrl($scope, $http, $stateParams, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        $scope.arrStatus = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];

        $scope.mModule = "DELETE";
        if (sessionStorage.Module != undefined)
            $scope.mModule = sessionStorage.Module;
        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;
        /* thienvm dong 1 */
        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
        //         + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        //     }).then(function(response) {
        //         $scope.arrStatus = response.data;
        //     }, function(error) {
        //         console.log(error);
        //     });

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId+"&TypeOfInvoiceCode=HD"
        //     }).then(function(response) {
        //         $scope.arrInvoiceTemplate = response.data;
        //     }, function(error) {
        //         console.log(error);
        //     });

        // $http({
        //         method: "GET",
        //         url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        //     }).then(function(response){
        //         $scope.arrTypeOfRevenue = response.data.Table1;
        //     }, function(error){
        //         console.log(error);
        //     });
        /* 1 */

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=&CustomerName=&BillNumber=&Symbol=&MedicalCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_SearchHoaDon?" + queryString
        }).then(successCallBack, errorCallBack);

        $scope.ReturnParent = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = false;
            if ($scope.mModule == "DELETE")
                location.href = '#/CreateHuyHoaDon';
            else
                location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        $scope.backPage = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            if ($scope.mModule == "DELETE")
                location.href = '#/CreateHuyHoaDon';
            else
                location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        //filter ElectronicInvoice's data

        $scope.FindData = function () {
            searchData();
        };

        function searchData() {
            $scope.arrData = [];
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&MedicalCode=" + $scope.mMedicalCode + "&BillNumber=" + $scope.mBillNumber
                + "&Symbol=" + $scope.mSymbol + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + $scope.mStatusCode + "&InvoiceTemplateID=" + $scope.mInvoiceTemplateID
                + "&LoaiThu=" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_SearchHoaDon?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author Nguyen Huu Tuan
 * created on 27.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('Invoice1450_TSCONGCtrl', Invoice1450_TSCONGCtrl);

    /*******    +++ START CONTROLLER    *******/
    function Invoice1450_TSCONGCtrl($scope, $http, $state, hostName, $filter, fileReader, $window, $stateParams) {

        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;
        $scope.mModule = $stateParams.Module;
        $scope.TotalAmount = 0;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        vm.TotalAmount = 0;
        vm.TotalInvoice = 0;
        vm.isXML = 0;
        $scope.Statuses = [];
        $scope.Status = {};

        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        sessionStorage.editId = undefined;
        sessionStorage.editable = false;

        $scope.checkDate = convertJSONDate(new Date());
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathFileInvoice = hostName.url;
        $scope.FileDanhSachHoaDon = hostName.url + "Templates/" + "DanhSachHoaDon.xlsx";

        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;


        $scope.TypeOfRevenue = {};
        // $http({
        //     method: "GET",
        //     url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        // }).then(function (response) {
        //     $scope.TypeOfRevenues = response.data.Table1;
        // }, function (error) {
        //     console.log(error);
        // });

        //INIT FORM
        ngInit();
        function ngInit() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                    + "LoaiTinhTrang=200&EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (response) {
                $scope.Statuses = response.data;
            }, function (error) {
                //NA
            });
        };

        //select Status
        $scope.selectChangedStatus = function (objSelect) {
            $scope.Status = objSelect;
        }

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //select TypeOfRevenue
        $scope.selectTypeOfRevenue = function (objSelect) {
            $scope.TypeOfRevenue.selected = objSelect;
        }

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function (objSelect) {
            $scope.InvoiceTemplate = objSelect;
        }

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) {
                if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
                    $scope.isShow = true;
            };
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {

            // console.log($filter('filter')(response.data[0], { 'IsTSCONG': '1' }));
            // vm.rowCollection = response.data[0];//main
            vm.rowCollection = $filter('filter')(response.data[0], { 'IsTSCONG': '1' }); /* TS-CONG filter */

            vm.TotalAmount = 0;
            var total = response.data[2][0].totalAmount;//main

            if (total != undefined) {
                vm.TotalAmount = total; //.replace(/,/g,"."); //main
            }

            vm.TotalInvoice = response.data[2][0].totalInvoice;//main
            vm.isXML = response.data[2][0].isXML;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        toDate = new Date();
        fromDate = new Date(nowYear, nowMonth, 1);
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=0&customerName=&billNumber=&symbol=&medicalCode=&IsTSCONG=true";
        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_HOADON_Search?" + queryString
        }).then(successCallBack, errorCallBack);

        //redirect to other pages
        $scope.open = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.urlReturn = '#/Invoice1450';
            location.href = url;
        };

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            $window.open("https://drive.google.com/open?id=1SLpUulz9ozFu6VnUKeqE1mDpOZ64dkSU");
        }

        //edit invoice's general information
        $scope.editInvoice = function (url, id) {
            sessionStorage.itemId = id;
            sessionStorage.editable = true;
            sessionStorage.urlReturn = '#/Invoice1450';
            location.href = url;
        };

        //Create new Invoice
        $scope.createInvoice = function () {
            location.href = '#/NewInvoice1450_TSCONG';
        }

        //filter ElectronicInvoice's data

        $scope.findData = function () {
            searchData();
        };

        function searchData() {
            vm.rowCollection = [];
            vm.TotalAmount = 0;
            $scope.TotalAmount = 0;
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : '';
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var LoaiThu = $scope.TypeOfRevenue.selected != undefined ? $scope.TypeOfRevenue.selected.LoaiThu : '';
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate="
                    + dateTo + "&medicalCode=" + medicalCode.value + "&billNumber=" + billNumber.value
                    + "&symbol=" + symbol.value + "&customerName=" + customerName.value + "&statusId="
                    + statusId + "&invoiceTemplateId=" + invoiceTemplateId + "&LoaiThu=" + LoaiThu + "&UserId=" + UserId + '&IsTSCONG=true';
                //console.log(queryString);
            }
            else {
                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate
                    + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&medicalCode=&LoaiThu=&UserId=&IsTSCONG=true";
                //console.log(queryString);
            }

            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data

        //+++   LAY KET QUA PHAN HOI TU CO QUAN THUE THEO MA THONG DIEP
        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;
                console.log('_resultCode=' + _resultCode);
                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo",
                        text: "Đã có kết quả phản hồi từ Cơ quan Thuế!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo",
                        text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning",
                        dangerMode: true,
                        button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //+++   LAY FILE KET QUA TRA LOI CUA THUE TU SERVER
        $scope.GetFileKetQua = function (FileHoaDon, KyHieu, SoHoaDon, NgayHoaDon) {

            $scope.OpenFile = true;

            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            FileHoaDon = $filter('replace')(FileHoaDon, '-Signed', '-TCT');
            NgayHoaDon = $filter('replace')(NgayHoaDon, '/', '-');
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + NgayHoaDon;

            //var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            $http({
                method: 'GET',
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetFile?"
                    + "FileHoaDon=" + FileHoaDon + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileHoaDon = function (FileHoaDon, KyHieu, SoHoaDon, NgayHoaDon) {

            $scope.OpenFile = true;

            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            NgayHoaDon = $filter('replace')(NgayHoaDon, '/', '-');
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + NgayHoaDon;

            // var _today = new Date();
            // var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            $http({
                method: 'GET',
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetFile?"
                    + "FileHoaDon=" + FileHoaDon + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };


        //+++   GET BAN THE HIEN CUA HOA DON
        $scope.GetBanTheHien = function (HoaDonID, KyHieu, SoHoaDon, NgayHoaDon) {
            $scope.OpenFile = true;

            var inputData = {
                'ID': HoaDonID,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            // var _today = new Date();
            // var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            NgayHoaDon = $filter('replace')(NgayHoaDon, '/', '-');
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + NgayHoaDon;

            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_PublishPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });
        };


        //+++   TAO BAN CHUYEN DOI CUA HOA DON DIEN TU
        $scope.TaoChuyenDoi = function (HoaDonID, KyHieu, SoHoaDon, NgayHoaDon) {
            $scope.TaoFileCD = true;

            var inputData = {
                'ID': HoaDonID,
                'EnterpriseId': sessionStorage.enterpriseId,
                'UserId': user.ID
            };

            // var _today = new Date();
            // var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            NgayHoaDon = $filter('replace')(NgayHoaDon, '/', '-');
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + NgayHoaDon;

            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_PublishPDF_CD",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + "_CD.pdf";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                searchData();
                $scope.TaoFileCD = false;

            }).error(function (message) {
                $scope.TaoFileCD = false;
                //console.log(message);
            });
        };


        $scope.getFileMauDSHoaDon = function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = $scope.FileDanhSachHoaDon;
            a.download = "DanhSachHoaDon.xlsx"; //you may assign this value from header as well 
            a.click();
        };

        /** MANAGE IMPORT INVOICE FROM FILE EXCEL OR XML **/
        $scope.importDataFromExcel = function () {
            if ($scope.PhongKham.selected == undefined
                || ($scope.PhongKham.selected != undefined && $scope.PhongKham.selected.MaPhongKham == '')) {
                swal({
                    title: "Vui lòng chọn thông tin \"Phòng khám\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusPhongKham');
                });
                return;
            };

            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);

                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx")) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function () {
                            $scope.file = "";
                            angular.element("input[type='file']").val(null);
                            return;
                        });
                    }
                    else {
                        var _MaPhongKham = $scope.PhongKham.selected != undefined ? $scope.PhongKham.selected.MaPhongKham : '';
                        var _TenPhongKham = $scope.PhongKham.selected != undefined ? $scope.PhongKham.selected.TenPhongKham : '---';
                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);
                        data.append("MaPhongKham", _MaPhongKham);
                        data.append("TenPhongKham", _TenPhongKham);

                        //Upload file Template
                        var reg = {
                            url: hostName.url + 'api/HIS/HIS_ImportDataFromExcel',
                            method: 'POST',
                            data: data,
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            },
                        };

                        $http(reg).then(function (response) {
                            var result = response.data;
                            if (result.ResultCode == 0) {
                                swal({
                                    title: "Thông báo",
                                    text: "Xuất hóa đơn từ file Excel thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: result.Message,
                                    icon: "error",
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }
                        }, function (error) {
                            swal("Không thể xuất hóa đơn từ file Excel, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            }).then(function () {
                                $state.reload();
                                console.log(error);
                            });
                        })
                    }
                });
        };
        /** END MANAGE IMPORT INVOICE FROM FILE EXCEL OR XML **/

    };
    /******  ### END CONTROLLER  ******/
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

})();


//Select InvoiceTemplate
angular.module('BlurAdmin.pages.lists')
    .controller('SelectInvoiceTemplate_TSCONGPageCtrl', SelectInvoiceTemplate_TSCONGPageCtrl);

function SelectInvoiceTemplate_TSCONGPageCtrl($scope, $http, hostName) {
    $scope.InvoiceTemplates = [];

    var successCallBack = function (response) {
        $scope.InvoiceTemplates = response.data;
    };

    var errorCallBack = function (reason) {
        console.log(reason);
    }

    $http({
        method: "GET",
        url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=TS"
    }).then(successCallBack, errorCallBack);
}
/**
 * @author Nguyen Huu Tuan
 * created on 27.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('NewInvoice1450_TSCONGCtrl', NewInvoice1450_TSCONGCtrl);

    /*******    +++ START CONTROLLER    *******/
    function NewInvoice1450_TSCONGCtrl($scope, $window, $http, hostName, $filter, $state, fileReader, $rootScope, $stateParams) {

        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        //SET DEBUG MODE
        $scope.DEBUG_MODE = (user.Email == "tuan@vietinfo.tech"
            || user.Email == "test1450@gmail.com") ? false : hostName.DEBUG_MODE;
        $scope.mModule = $stateParams.Module;
        $scope.inputDateOfInvoice = new Date();
        $scope.Customer = {};
        $scope.InvoiceTemplate = {};
        $scope.TypeOfRevenue = {};
        $scope.TypeOfPayment = {};
        $scope.isPublic = false;
        $scope.isReview = false;
        $scope.isSave = true;
        $scope.checkNew = $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;
        $scope.isHasFile = false;
        $rootScope.fileTemplate = undefined;
        $rootScope.FileTemplateData = undefined;
        $scope.IsImportN = false;

        $scope.vatTSFalse = true;
        //+++   BV PHCN IS EXCEPT
        $scope.isPHCN = sessionStorage.enterpriseId == '21f5a863-16af-4f56-81d3-fbf688d9bb6b' ? true : false; // PROD
        // $scope.isPHCN = sessionStorage.enterpriseId == '1e7d6dfe-f09e-4afa-ab1c-7f5003fefcfb' ? true : false; // TEST DKSG
        $scope.FileMauChiTiet = hostName.url + "Templates/" + "ChiTietHoaDon.xlsx";


        $scope.HTTTs = [
            { ID: 'TM/CK', Name: 'TM/CK' },
            { ID: 'TM', Name: 'Tiền mặt' },
            { ID: 'CK', Name: 'Chuyển khoản' },
        ];
        $scope.HTTT = {};
        $scope.LoaiHoaDons = [];
        $scope.LoaiHoaDon = {};
        $scope.HTHoaDons = [];
        $scope.HTHoaDon = {};

        getTypeOfPayment();
        function getTypeOfPayment() {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfPayment/List?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function (response) { //SUCCESS
                $scope.TypeOfPayments = response.data;
                $scope.TypeOfPayment.selected = { typeOfPaymentCode: 'TM/CK', typeOfPaymentName: 'Tiền mặt/Chuyển khoản' };
            }, function (error) { //ERROR
                //console.log(error);
            });
        };


        //LAY THONG TIN LOAI HOA DON VA HINH THUC HOA DON DA DANG KY CUA DON VI
        GetHTHD();
        function GetHTHD() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(function (data) {
                var _data = data.data[0];
                // console.log(_data);
                //CO MA
                if (_data != undefined && _data.HaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'COMA', Name: 'Có mã' });
                    $scope.HTHoaDon.selected = { ID: 'COMA', Name: 'Có mã' };
                }

                //KHONG CO MA
                if (_data != undefined && _data.DontHaveCode == true) {
                    $scope.HTHoaDons.push({ ID: 'KHONGMA', Name: 'Không có mã' });

                    if (_data.HaveCode == false)
                        $scope.HTHoaDon.selected = { ID: 'KHONGMA', Name: 'Không có mã' };
                }
                //TAI SAN CONG
                if (_data != undefined && _data.UsePublicProperty == true) {
                    $scope.LoaiHoaDons.push({ ID: 'TSCONG', Name: 'TS công' });

                    if (_data.UsePublicProperty == true)
                        $scope.LoaiHoaDon.selected = { ID: 'TSCONG', Name: 'TS công' };
                }


                // //GTGT
                // if (_data != undefined && _data.UseVATInvoice == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'GTGT', Name: 'GTGT' });
                //     $scope.LoaiHoaDon.selected = { ID: 'GTGT', Name: 'GTGT' };
                // }

                // //BAN HANG
                // if (_data != undefined && _data.UseBillOfSale == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'BANHANG', Name: 'Bán hàng' });

                //     if (_data.UseVATInvoice == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'BANHANG', Name: 'Bán hàng' };
                // }

                // //TAI SAN CONG
                // if (_data != undefined && _data.UsePublicProperty == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'TSCONG', Name: 'TS công' });

                //     if (_data.UseVATInvoice == false
                //         && _data.UseBillOfSale == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'TSCONG', Name: 'TS công' };
                // }

                // //DU TRU QUOC GIA
                // if (_data != undefined && _data.UseNationalReserve == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'DTQGIA', Name: 'DT Quốc Gia' });

                //     if (_data.UseVATInvoice == false
                //         && _data.UseBillOfSale == false
                //         && _data.UsePublicProperty == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'DTQGIA', Name: 'DT Quốc Gia' };
                // }

                // //KHAC
                // if (_data != undefined && _data.UseOther == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'KHAC', Name: 'Khác' });

                //     if (_data.UseVATInvoice == false
                //         && _data.UseBillOfSale == false
                //         && _data.UsePublicProperty == false
                //         && _data.UseNationalReserve == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'KHAC', Name: 'Khác' };
                // }

                // //CHUNG TU
                // if (_data != undefined && _data.UseDocument == true) {
                //     $scope.LoaiHoaDons.push({ ID: 'CHUNGTU', Name: 'Chứng từ' });

                //     if (_data.UseVATInvoice == false
                //         && _data.UseBillOfSale == false
                //         && _data.UsePublicProperty == false
                //         && _data.UseNationalReserve == false
                //         && _data.UseOther == false)
                //         $scope.LoaiHoaDon.selected = { ID: 'CHUNGTU', Name: 'Chứng từ' };
                // }

                $scope.HTTT.selected = { ID: 'TM/CK', Name: 'TM/CK' };
                // $scope.HTTT.selected = { ID: 'TM', Name: 'Tiền mặt' }; //PHCN
            }, function (error) {
                console.log(error);
            });
        };

        $scope.LoadKhachHang = function (taxCode) {

            // if (taxCode != '' && taxCode != undefined) {
            //     //CALL API GET HOA DON CHI TIET
            //     $http({
            //         method: "GET",
            //         url: hostName.url + "api/Customer/CustomerByTaxCode?taxCode=" + taxCode,
            //     }).then(function (response) { //SUCCESS
            //         $scope.KhachHang = response.data;

            //         $scope.inputCompanyName = $scope.KhachHang.customerName;
            //         $scope.inputAddress = $scope.KhachHang.address;
            //     }, function (reason) { //ERROR
            //         console.log(reason);
            //     });
            // }

        };

        //Change Type of Revenue
        $scope.changeTypeOfRevenue = function (obj) {
            $scope.TypeOfRevenue.selected = obj;
        };

        //Change Type of Payment
        $scope.changeTypeOfPayment = function (obj) {
            $scope.TypeOfPayment.selected = obj;
        };

        //save data to local variable when change Select's control
        $scope.changeInvoiceTemplate = function (objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
            //call Webservice to get InvoiceTemplate's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.inputSymbol = invoiceTemplate.symbol;
                    getTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                }
            }, function (reason) {
                //$scope.error = reason.data;
                //console.log(reason);
            });
        };

        //GET TypeOfRevenue's Information
        function getTypeOfRevenue(typeOfInvoiceId) {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId + "&typeOfInvoiceId=" + typeOfInvoiceId
            }).then(function (response) {
                $scope.TypeOfRevenues = response.data;
            }, function (reason) {
                console.log(reason);
            });
        }

        //+++   EDIT MODE
        if (sessionStorage.itemId != 'undefined' && sessionStorage.itemId != undefined) {

            $scope.isPublic = true;
            $scope.isReview = true;
            var itemId = sessionStorage.itemId;

            //GET EXISTED DATA
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetById?ID=" + itemId + "&EnterpriseId=" + sessionStorage.enterpriseId,
            }).then(function (response) { //SUCCESS
                $scope.HoaDon = [];
                $scope.HoaDon = response.data[0];

                console.log($scope.HoaDon);
                if ($scope.HoaDon != undefined) {
                    if ($scope.HoaDon.MaTinhTrang == 'CHOKETQUA'
                        || $scope.HoaDon.MaTinhTrang == '20002') {
                        $scope.isSave = false;
                        $scope.isPublic = false;
                    };

                    var dateOfInvoice = new Date($scope.HoaDon.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.inputSymbol = $scope.HoaDon.symbol;
                    $scope.inputBillNumber = $scope.HoaDon.billNumber;

                    $scope.InvoiceTemplate.selected = { ID: $scope.HoaDon.invoiceTemplateId, invoiceTemplateCode: $scope.HoaDon.invoiceTemplateCode, invoiceTemplateName: $scope.HoaDon.invoiceTemplateName };
                    $scope.TypeOfRevenue.selected = { ID: $scope.HoaDon.typeOfRevenueId, typeOfRevenueName: $scope.HoaDon.typeOfRevenueName };

                    $scope.inputCompanyName = $scope.HoaDon.companyName;
                    $scope.inputTaxCode = $scope.HoaDon.taxCode;
                    $scope.inputCustomerName = $scope.HoaDon.customerName;
                    $scope.inputAddress = $scope.HoaDon.address;
                    $scope.inputMedicalCode = $scope.HoaDon.medicalCode;
                    // $scope.inputHealthInsuranceCardNumber = $scope.HoaDon.healthInsuranceCardNumber;
                    $scope.NMuaSTKNHang = $scope.HoaDon.NMuaSTKNHang;
                    // $scope.inputHospitalizationNumber = $scope.HoaDon.hospitalizationNumber;
                    $scope.NMuaTNHang = $scope.HoaDon.NMuaTNHang;
                    $scope.inputDiscount = $scope.HoaDon.Discount;

                    $scope.inputNotes = $scope.HoaDon.description;

                    //SET SELECTED LIST
                    $scope.HTTT.selected = { ID: $scope.HoaDon.currencyOfPaymentName, Name: $scope.HoaDon.currencyOfPaymentName };
                    $scope.HTHoaDon.selected = { ID: $scope.HoaDon.HinhThucHoaDon, Name: $scope.HoaDon.HinhThucHoaDonName };
                    $scope.LoaiHoaDon.selected = { ID: $scope.HoaDon.LoaiHoaDonCQT, Name: $scope.HoaDon.LoaiHoaDonCQTName };
                    $scope.TypeOfPayment.selected = { typeOfPaymentCode: $scope.HoaDon.typeOfPaymentCode, typeOfPaymentName: $scope.HoaDon.typeOfPaymentName };

                    /* ++ TSCONG */
                    $scope.SQDinh = $scope.HoaDon.SQDinh;
                    if ($scope.HoaDon.NQDinh != null) {
                        var _NQDinh = new Date($scope.HoaDon.NQDinh);
                        $scope.NQDinh = new Date(_NQDinh.getFullYear(), _NQDinh.getMonth(), _NQDinh.getDate());
                    }

                    $scope.CQBHQDinh = $scope.HoaDon.CQBHQDinh;
                    $scope.HTBan = $scope.HoaDon.HTBan;

                    $scope.MUA_MDVQHNSach = $scope.HoaDon.MUA_MDVQHNSach;
                    $scope.DDVCHDen = $scope.HoaDon.DDVCHDen;

                    if ($scope.HoaDon.TGVCHDTu != null) {
                        var _TGVCHDTu = new Date($scope.HoaDon.TGVCHDTu);
                        $scope.TGVCHDTu = new Date(_TGVCHDTu.getFullYear(), _TGVCHDTu.getMonth(), _TGVCHDTu.getDate());
                    }

                    if ($scope.HoaDon.TGVCHDDen != null) {
                        var _TGVCHDDen = new Date($scope.HoaDon.TGVCHDDen);
                        $scope.TGVCHDDen = new Date(_TGVCHDDen.getFullYear(), _TGVCHDDen.getMonth(), _TGVCHDDen.getDate());
                    }
                    /* ## TSCONG */

                    //CALL API GET HOA DON CHI TIET
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_CHITIET_GetById?QD1450_HOADON_Id=" + $scope.HoaDon.ID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) { //SUCCESS
                        $scope.Products = response.data;

                        //DETAIL 1
                        if ($scope.Products.length > 0) {
                            $scope.inputID1 = $scope.Products[0].ID;
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VAT == '-' ? '-' :
                                $scope.Products[0].VATAmount;

                            //DETAIL 2
                            if ($scope.Products.length > 1) {
                                $scope.inputID2 = $scope.Products[1].ID;
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VAT == '-' ? '-' :
                                    $scope.Products[1].VATAmount;

                                //DETAIL 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputID3 = $scope.Products[2].ID;
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VAT == '-' ? '-' :
                                        $scope.Products[2].VATAmount;
                                    //DETAIL 4
                                    if ($scope.Products.length > 3) {
                                        $scope.inputID4 = $scope.Products[3].ID;
                                        $scope.inputDescription4 = $scope.Products[3].goodAndServiceName;
                                        $scope.inputUnitName4 = $scope.Products[3].unitName;
                                        $scope.inputQuantity4 = $scope.Products[3].quantity;
                                        $scope.inputPrice4 = $scope.Products[3].price;
                                        $scope.inputVAT4 = $scope.Products[3].VAT;
                                        $scope.inputVATAmount4 = $scope.Products[3].VAT == '-' ? '-' :
                                            $scope.Products[3].VATAmount;
                                        //DETAIL 5
                                        if ($scope.Products.length > 4) {
                                            $scope.inputID5 = $scope.Products[4].ID;
                                            $scope.inputDescription5 = $scope.Products[4].goodAndServiceName;
                                            $scope.inputUnitName5 = $scope.Products[4].unitName;
                                            $scope.inputQuantity5 = $scope.Products[4].quantity;
                                            $scope.inputPrice5 = $scope.Products[4].price;
                                            $scope.inputVAT5 = $scope.Products[4].VAT;
                                            $scope.inputVATAmount5 = $scope.Products[4].VAT == '-' ? '-' :
                                                $scope.Products[4].VATAmount;
                                            //DETAIL 6
                                            if ($scope.Products.length > 5) {
                                                $scope.inputID6 = $scope.Products[5].ID;
                                                $scope.inputDescription6 = $scope.Products[5].goodAndServiceName;
                                                $scope.inputUnitName6 = $scope.Products[5].unitName;
                                                $scope.inputQuantity6 = $scope.Products[5].quantity;
                                                $scope.inputPrice6 = $scope.Products[5].price;
                                                $scope.inputVAT6 = $scope.Products[5].VAT;
                                                $scope.inputVATAmount6 = $scope.Products[5].VAT == '-' ? '-' :
                                                    $scope.Products[5].VATAmount;
                                                //DETAIL 7
                                                if ($scope.Products.length > 6) {
                                                    $scope.inputID7 = $scope.Products[6].ID;
                                                    $scope.inputDescription7 = $scope.Products[6].goodAndServiceName;
                                                    $scope.inputUnitName7 = $scope.Products[6].unitName;
                                                    $scope.inputQuantity7 = $scope.Products[6].quantity;
                                                    $scope.inputPrice7 = $scope.Products[6].price;
                                                    $scope.inputVAT7 = $scope.Products[6].VAT;
                                                    $scope.inputVATAmount7 = $scope.Products[6].VAT == '-' ? '-' :
                                                        $scope.Products[6].VATAmount;
                                                    //DETAIL 8
                                                    if ($scope.Products.length > 7) {
                                                        $scope.inputID8 = $scope.Products[7].ID;
                                                        $scope.inputDescription8 = $scope.Products[7].goodAndServiceName;
                                                        $scope.inputUnitName8 = $scope.Products[7].unitName;
                                                        $scope.inputQuantity8 = $scope.Products[7].quantity;
                                                        $scope.inputPrice8 = $scope.Products[7].price;
                                                        $scope.inputVAT8 = $scope.Products[7].VAT;
                                                        $scope.inputVATAmount8 = $scope.Products[7].VAT == '-' ? '-' :
                                                            $scope.Products[7].VATAmount;
                                                        //DETAIL 9
                                                        if ($scope.Products.length > 8) {
                                                            $scope.inputID9 = $scope.Products[8].ID;
                                                            $scope.inputDescription9 = $scope.Products[8].goodAndServiceName;
                                                            $scope.inputUnitName9 = $scope.Products[8].unitName;
                                                            $scope.inputQuantity9 = $scope.Products[8].quantity;
                                                            $scope.inputPrice9 = $scope.Products[8].price;
                                                            $scope.inputVAT9 = $scope.Products[8].VAT;
                                                            $scope.inputVATAmount9 = $scope.Products[8].VAT == '-' ? '-' :
                                                                $scope.Products[8].VATAmount;
                                                            //DETAIL 10
                                                            if ($scope.Products.length > 9) {
                                                                $scope.inputID10 = $scope.Products[9].ID;
                                                                $scope.inputDescription10 = $scope.Products[9].goodAndServiceName;
                                                                $scope.inputUnitName10 = $scope.Products[9].unitName;
                                                                $scope.inputQuantity10 = $scope.Products[9].quantity;
                                                                $scope.inputPrice10 = $scope.Products[9].price;
                                                                $scope.inputVAT10 = $scope.Products[9].VAT;
                                                                $scope.inputVATAmount10 = $scope.Products[9].VAT == '-' ? '-' :
                                                                    $scope.Products[9].VATAmount;
                                                            } //#DETAIL 10
                                                        } //#DETAIL 9
                                                    } //#DETAIL 8
                                                } //#DETAIL 7
                                            } //#DETAIL 6
                                        } //#DETAIL 5
                                    } //#DETAIL 4
                                } //#DETAIL 3

                            } //#DETAIL 2

                        } //#DETAIL 1

                    }, function (reason) { //ERROR
                        console.log(reason);
                    }); //#CALL API GET ELECTRICINVOICE DETAIL
                }
            }, function (reason) { //ERROR
                console.log(reason);
            }); //#CALL API GET ELECTRICINVOICE
        }

        else { //ADD NEW DATA
            GetListInvoiceTemplate();
            // $http({
            //     method: "GET",
            //     url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=TS"
            // }).then(function (response) { //SUCCESS     
            //     $scope.InvoiceTemplate.selected = { ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName };
            //     $scope.inputSymbol = response.data[0].symbol;

            //     $scope.TypeOfPayment.selected = { typeOfPaymentCode: 'TM/CK', typeOfPaymentName: 'Tiền mặt/Chuyển khoản' };
            //     // $scope.TypeOfPayment.selected = { typeOfPaymentCode: 'TM', typeOfPaymentName: 'Tiền mặt' }; //PHCN

            //     getTypeOfRevenue(response.data[0].typeOfInvoiceId);
            // }, function (error) { //ERROR
            //     //console.log(error);
            // });
        }; //#ADD NEW DATA

        //FUNCTION TO REDIRECT OTHERS PAGE
        $scope.open = function (url) {
            location.href = url;
        };

        function GetListInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=TS"
            }).then(function (response) { //SUCCESS     
                $scope.InvoiceTemplate.selected = { ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName };
                $scope.inputSymbol = response.data[0].symbol;

                $scope.TypeOfPayment.selected = { typeOfPaymentCode: 'TM/CK', typeOfPaymentName: 'Tiền mặt/Chuyển khoản' };
                // $scope.TypeOfPayment.selected = { typeOfPaymentCode: 'TM', typeOfPaymentName: 'Tiền mặt' }; //PHCN

                getTypeOfRevenue(response.data[0].typeOfInvoiceId);
            }, function (error) { //ERROR
                //console.log(error);
            });
        }

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice1.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice2.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice3.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 4 of Description 4
        $scope.calVATAmount4 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice4.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount4')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 5 of Description 5
        $scope.calVATAmount5 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice5.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount5')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 6 of Description 6
        $scope.calVATAmount6 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice6.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount6')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 7 of Description 7
        $scope.calVATAmount7 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice7.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount7')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };

        //event onBlur of Price 8 of Description 8
        $scope.calVATAmount8 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice8.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount8')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 9 of Description 9
        $scope.calVATAmount9 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice9.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount9')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //event onBlur of Price 10 of Description 10
        $scope.calVATAmount10 = function (price, vat, quantity) {
            if (price == undefined || price == '' || price == 0) {
                inputPrice10.value = 0;
            }
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;

            var vatAmount = angular.element(document).find('#inputVATAmount10')[0];
            if (price != undefined) {
                if (vat == '-') vatAmount.value = '-';
                else vatAmount.value = $filter('currency')(roundNumber((price * quantity * vat) / 100), 0);
            }
        };
        //FUNCTION SAVE DATA
        $scope.save = function () {

            /**
             *  Requirement: 
             *      - CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/

            //THONG TIN HOA DON
            var _dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var _LoaiHoaDon = $scope.LoaiHoaDon.selected == undefined
                ? -1 : $scope.LoaiHoaDon.selected.ID;
            var _HTHoaDon = $scope.HTHoaDon.selected == undefined
                ? -1 : $scope.HTHoaDon.selected.ID;

            //THONG TIN NGUOI MUA
            var _customerName = angular.element(document).find('#inputCustomerName')[0];
            var _medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var _companyName = angular.element(document).find('#inputCompanyName')[0];
            var _taxCode = angular.element(document).find('#inputTaxCode')[0];
            // var _healthInsuranceCardNumber = angular.element(document).find('#inputHealthInsuranceCardNumber')[0];
            // var _hospitalizationNumber = angular.element(document).find('#inputHospitalizationNumber')[0];
            var _address = angular.element(document).find('#inputAddress')[0];
            var _notes = angular.element(document).find('#inputNotes')[0];
            //var _discount = angular.element(document).find('#inputDiscount')[0];
            var typeOfRevenueId = $scope.TypeOfRevenue.selected != undefined ? $scope.TypeOfRevenue.selected.ID : 0;
            var _NMuaSTKNHang = angular.element(document).find('#NMuaSTKNHang')[0];
            var _NMuaTNHang = angular.element(document).find('#NMuaTNHang')[0];


            var _HTTTCode = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.ID : '';
            var _HTTTName = $scope.HTTT.selected != undefined
                ? $scope.HTTT.selected.Name : '';

            // ++TSCONG
            var _SQDinh = angular.element(document).find('#SQDinh')[0];
            var _NQDinh = angular.element(document).find('#NQDinh')[0];
            var _CQBHQDinh = angular.element(document).find('#CQBHQDinh')[0];
            var _HTBan = angular.element(document).find('#HTBan')[0];

            var _MUA_MDVQHNSach = angular.element(document).find('#MUA_MDVQHNSach')[0];
            var _DDVCHDen = angular.element(document).find('#DDVCHDen')[0];
            var _TGVCHDTu = angular.element(document).find('#TGVCHDTu')[0];
            var _TGVCHDDen = angular.element(document).find('#TGVCHDDen')[0];

            // ##TSCONG

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 = angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 = angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 = angular.element(document).find('#inputVATAmount3')[0];

            //detail 4
            var description4 = angular.element(document).find('#inputDescription4')[0];
            var price4 = angular.element(document).find('#inputPrice4')[0];
            var unitName4 = angular.element(document).find('#inputUnitName4')[0];
            var quantity4 = angular.element(document).find('#inputQuantity4')[0];
            var vat4 = angular.element(document).find('#inputVAT4')[0];
            var vatAmount4 = angular.element(document).find('#inputVATAmount4')[0];

            //detail 5
            var description5 = angular.element(document).find('#inputDescription5')[0];
            var price5 = angular.element(document).find('#inputPrice5')[0];
            var unitName5 = angular.element(document).find('#inputUnitName5')[0];
            var quantity5 = angular.element(document).find('#inputQuantity5')[0];
            var vat5 = angular.element(document).find('#inputVAT5')[0];
            var vatAmount5 = angular.element(document).find('#inputVATAmount5')[0];

            //detail 6
            var description6 = angular.element(document).find('#inputDescription6')[0];
            var price6 = angular.element(document).find('#inputPrice6')[0];
            var unitName6 = angular.element(document).find('#inputUnitName6')[0];
            var quantity6 = angular.element(document).find('#inputQuantity6')[0];
            var vat6 = angular.element(document).find('#inputVAT6')[0];
            var vatAmount6 = angular.element(document).find('#inputVATAmount6')[0];

            //detail 7
            var description7 = angular.element(document).find('#inputDescription7')[0];
            var price7 = angular.element(document).find('#inputPrice7')[0];
            var unitName7 = angular.element(document).find('#inputUnitName7')[0];
            var quantity7 = angular.element(document).find('#inputQuantity7')[0];
            var vat7 = angular.element(document).find('#inputVAT7')[0];
            var vatAmount7 = angular.element(document).find('#inputVATAmount7')[0];

            //detail 8
            var description8 = angular.element(document).find('#inputDescription8')[0];
            var price8 = angular.element(document).find('#inputPrice8')[0];
            var unitName8 = angular.element(document).find('#inputUnitName8')[0];
            var quantity8 = angular.element(document).find('#inputQuantity8')[0];
            var vat8 = angular.element(document).find('#inputVAT8')[0];
            var vatAmount8 = angular.element(document).find('#inputVATAmount8')[0];

            //detail 9
            var description9 = angular.element(document).find('#inputDescription9')[0];
            var price9 = angular.element(document).find('#inputPrice9')[0];
            var unitName9 = angular.element(document).find('#inputUnitName9')[0];
            var quantity9 = angular.element(document).find('#inputQuantity9')[0];
            var vat9 = angular.element(document).find('#inputVAT9')[0];
            var vatAmount9 = angular.element(document).find('#inputVATAmount9')[0];


            //detail 10
            var description10 = angular.element(document).find('#inputDescription10')[0];
            var price10 = angular.element(document).find('#inputPrice10')[0];
            var unitName10 = angular.element(document).find('#inputUnitName10')[0];
            var quantity10 = angular.element(document).find('#inputQuantity10')[0];
            var vat10 = angular.element(document).find('#inputVAT10')[0];
            var vatAmount10 = angular.element(document).find('#inputVATAmount10')[0];

            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var quan1 = $filter('replace')(quantity1.value, ',', '');
            var quan2 = $filter('replace')(quantity2.value, ',', '');
            var quan3 = $filter('replace')(quantity3.value, ',', '');

            var val4 = $filter('replace')(price4.value, ',', '');
            var val5 = $filter('replace')(price5.value, ',', '');
            var val6 = $filter('replace')(price6.value, ',', '');
            var val7 = $filter('replace')(price7.value, ',', '');
            var val8 = $filter('replace')(price8.value, ',', '');
            var val9 = $filter('replace')(price9.value, ',', '');
            var val10 = $filter('replace')(price10.value, ',', '');

            var quan4 = $filter('replace')(quantity4.value, ',', '');
            var quan5 = $filter('replace')(quantity5.value, ',', '');
            var quan6 = $filter('replace')(quantity6.value, ',', '');
            var quan7 = $filter('replace')(quantity7.value, ',', '');
            var quan8 = $filter('replace')(quantity8.value, ',', '');
            var quan9 = $filter('replace')(quantity9.value, ',', '');
            var quan10 = $filter('replace')(quantity10.value, ',', '');

            var flag = true;

            //check empty LoaiHoaDon
            if ($scope.LoaiHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Loại hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusLoaiHoaDon');
                });
                flag = false;
                return;
            };

            //check empty HTHoaDon
            if ($scope.HTHoaDon.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Hình thức hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocusHTHoaDon');
                });
                flag = false;
                return;
            };

            if (_taxCode.value !== '' && _companyName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn vị\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    _companyName.focus();
                });
                flag = false;
                return;
            };


            //check empty customerName
            // if (_customerName.value == '') {
            if (_customerName.value == '' && _companyName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    _customerName.focus();
                });
                flag = false;
                return;
            };
            // return;

            //check empty address
            if (_address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    _address.focus();
                });
                flag = false;
                return;
            };


            //check empty medicalCode
            if (_medicalCode.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mã y tế\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    _medicalCode.focus();
                });
                flag = false;
                return;
            };

            //PHCN check loa5i doanh thu
            //check empty typeOfRevenueId
            if (typeOfRevenueId == 0 && $scope.isPHCN == true) {
                swal({
                    title: "Vui lòng nhập thông tin \"Loại doanh thu\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    // _medicalCode.focus();
                    $scope.$broadcast('SetFocusTypeOfRevenue');
                });
                flag = false;
                return;
            };


            //check empty details of invoice
            if (description1.value == '' && price1.value == ''
                && description2.value == '' && price2.value == ''
                && description3.value == '' && price3.value == ''
                && $rootScope.FileTemplateData == undefined) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    description3.focus();
                });
                flag = false;
                return;
            };

            //IF ALL VALIDATION IS OK
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;

                var amount4 = 0;
                var amountNotVAT4 = 0;
                var amount5 = 0;
                var amountNotVAT5 = 0;
                var amount6 = 0;
                var amountNotVAT6 = 0;
                var amount7 = 0;
                var amountNotVAT7 = 0;
                var amount8 = 0;
                var amountNotVAT8 = 0;
                var amount9 = 0;
                var amountNotVAT9 = 0;
                var amount10 = 0;
                var amountNotVAT10 = 0;

                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;
                val4 = val4 != '' ? val4 : 0;
                val5 = val5 != '' ? val5 : 0;
                val6 = val6 != '' ? val6 : 0;
                val7 = val7 != '' ? val7 : 0;
                val8 = val8 != '' ? val8 : 0;
                val9 = val9 != '' ? val9 : 0;
                val10 = val10 != '' ? val10 : 0;

                quan1 = quan1 != '' ? quan1 : 1;
                quan2 = quan2 != '' ? quan2 : 1;
                quan3 = quan3 != '' ? quan3 : 1;
                quan4 = quan4 != '' ? quan4 : 1;
                quan5 = quan5 != '' ? quan5 : 1;
                quan6 = quan6 != '' ? quan6 : 1;
                quan7 = quan7 != '' ? quan7 : 1;
                quan8 = quan8 != '' ? quan8 : 1;
                quan9 = quan9 != '' ? quan9 : 1;
                quan10 = quan10 != '' ? quan10 : 1;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = (parseFloat(quan1) * parseFloat(val1));

                    if (vatAmount1.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                        amount1 = amountNotVAT1 + parseFloat(vatAmount);
                    }
                    else amount1 = amountNotVAT1;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = (parseFloat(quan2) * parseFloat(val2));

                    if (vatAmount2.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                        amount2 = amountNotVAT2 + parseFloat(vatAmount);
                    }
                    else amount2 = amountNotVAT2;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = (parseFloat(quan3) * parseFloat(val3));

                    if (vatAmount3.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                        amount3 = amountNotVAT3 + parseFloat(vatAmount);
                    }
                    else amount3 = amountNotVAT3;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 4
                if (description4.value != '') {
                    amountNotVAT4 = (parseFloat(quan4) * parseFloat(val4));

                    if (vatAmount4.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount4.value, ',', '');
                        amount4 = amountNotVAT4 + parseFloat(vatAmount);
                    }
                    else amount4 = amountNotVAT4;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 5
                if (description5.value != '') {
                    amountNotVAT5 = (parseFloat(quan5) * parseFloat(val5));

                    if (vatAmount5.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount5.value, ',', '');
                        amount5 = amountNotVAT5 + parseFloat(vatAmount);
                    }
                    else amount5 = amountNotVAT5;

                }

                //get TotalAmount and TotalAmountNotVAT from detail 6
                if (description6.value != '') {
                    amountNotVAT6 = (parseFloat(quan6) * parseFloat(val6));

                    if (vatAmount6.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount6.value, ',', '');
                        amount6 = amountNotVAT6 + parseFloat(vatAmount);
                    }
                    else amount6 = amountNotVAT6;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 7
                if (description7.value != '') {
                    amountNotVAT7 = (parseFloat(quan7) * parseFloat(val7));

                    if (vatAmount7.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount7.value, ',', '');
                        amount7 = amountNotVAT7 + parseFloat(vatAmount);
                    }
                    else amount7 = amountNotVAT7;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 8
                if (description8.value != '') {
                    amountNotVAT8 = (parseFloat(quan8) * parseFloat(val8));

                    if (vatAmount8.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount8.value, ',', '');
                        amount8 = amountNotVAT8 + parseFloat(vatAmount);
                    }
                    else amount8 = amountNotVAT8;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 9
                if (description9.value != '') {
                    amountNotVAT9 = (parseFloat(quan9) * parseFloat(val9));

                    if (vatAmount9.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount9.value, ',', '');
                        amount9 = amountNotVAT9 + parseFloat(vatAmount);
                    }
                    else amount9 = amountNotVAT9;

                }
                //get TotalAmount and TotalAmountNotVAT from detail 10
                if (description10.value != '') {
                    amountNotVAT10 = (parseFloat(quan10) * parseFloat(val10));

                    if (vatAmount10.value != '-') {
                        var vatAmount = $filter('replace')(vatAmount10.value, ',', '');
                        amount10 = amountNotVAT10 + parseFloat(vatAmount);
                    }
                    else amount10 = amountNotVAT10;

                }

                // totalAmount = parseFloat(amount1 + amount2 + amount3);
                // totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3);
                totalAmount = parseFloat(amount1 + amount2 + amount3 + amount4 + amount5 + amount6 + amount7 + amount8 + amount9 + amount10);
                totalAmountNotVAT = parseFloat(amountNotVAT1 + amountNotVAT2 + amountNotVAT3 + amountNotVAT4 + amountNotVAT5 + amountNotVAT6 + amountNotVAT7 + amountNotVAT8 + amountNotVAT9 + amountNotVAT10);

                // console.log(_NQDinh.value === '' ? 1 : 2);
                // // console.log(reConvertJSONDate(_NQDinh.value));
                // return;
                var inputData = {
                    'ID': sessionStorage.itemId != 'undefined' ? sessionStorage.itemId : -1,
                    'dateOfInvoice': reConvertJSONDate(_dateOfInvoice.value),
                    'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                    'LoaiHoaDon': '',
                    'LoaiDoanhThu': typeOfRevenueId,
                    'SoPhieu': '',
                    'MaHoSo': '',
                    'HinhThucHoaDon': _HTHoaDon,
                    'MaCoQuanThue': '',
                    'LoaiHoaDonCQT': _LoaiHoaDon,

                    'typeOfPaymentCode': $scope.TypeOfPayment.selected.typeOfPaymentCode,
                    'typeOfPaymentName': $scope.TypeOfPayment.selected.typeOfPaymentName,

                    'taxCode': _taxCode.value,
                    'customerName': _customerName.value,
                    'companyId': '0',
                    'companyName': _companyName.value,
                    'phone': '',
                    'email': '',
                    'address': _address.value,
                    'accountNumber': '',
                    'medicalCode': _medicalCode.value,
                    'hospitalizationNumber': "",//_hospitalizationNumber.value,
                    'healthInsuranceCardNumber': "",// _healthInsuranceCardNumber.value,

                    'totalAmountNotVAT': totalAmountNotVAT,
                    'totalAmount': totalAmount,
                    'Discount': 0,

                    'description': _notes.value,
                    'userCreated': user.ID,
                    'userUpdated': user.ID,
                    'EnterpriseId': sessionStorage.enterpriseId,

                    //TS-CONG
                    'SQDinh': _SQDinh.value,
                    'NQDinh': _NQDinh.value === '' ? null : reConvertJSONDate(_NQDinh.value),
                    'CQBHQDinh': _CQBHQDinh.value,
                    'HTBan': _HTBan.value,

                    'MUA_MDVQHNSach': _MUA_MDVQHNSach.value,
                    'DDVCHDen': _DDVCHDen.value,
                    'TGVCHDTu': _TGVCHDTu.value === '' ? null : reConvertJSONDate(_TGVCHDTu.value),
                    'TGVCHDDen': _TGVCHDDen.value === '' ? null : reConvertJSONDate(_TGVCHDDen.value),
                    'IsTSCONG': 1,
                    "NMuaSTKNHang": _NMuaSTKNHang.value,
                    "NMuaTNHang": _NMuaTNHang.value,

                };

                //TAO HOA DON  CO FILE CHI TIET
                if ($rootScope.FileTemplateData != undefined) {

                    var data = new FormData();
                    data = $rootScope.FileTemplateData;
                    data.append("model", JSON.stringify(inputData));

                    var _api = 'api/QD1450/QD1450_HOADON_COFILE';

                    if ($scope.IsImportN === true) { // import hàng loạt hd theo template mẫu -- thienmv add 20241016
                        _api = 'api/QD1450/QD1450_HOADON_COFILE_NN';
                    }

                    // console.log(_api);
                    // return;

                    //Upload file Template
                    var reg = {
                        // url: hostName.url + 'api/QD1450/QD1450_HOADON_COFILE',   
                        url: hostName.url + _api,
                        method: 'POST',
                        data: data,
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                    };

                    $http(reg).then(function (response) {
                        var result = response.data;

                        if (result.ResultCode == 0) { //SUCCESS
                            swal({
                                title: "Thông báo",
                                text: "Lưu thông tin hóa đơn thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                var invoiceId = result.Data;
                                sessionStorage.itemId = invoiceId;
                                $state.reload();
                            });
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: result.Message,
                                icon: "error",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }
                    }, //#SUCCESS
                        function (error) { //ERROR
                            swal("Không thể xuất hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                            $state.reload();
                        }); //#ERROR

                }

                //TAO HOA DON K CO FILE
                else {

                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON", inputData)
                        .then(function (response) { //UPDATE SUCCESS

                            var objResult = response.data;

                            var invoiceId = objResult.Data;
                            sessionStorage.itemId = invoiceId;
                            var flagDetail = true;

                            //EDIT ON DAY
                            if ($scope.checkNew == false) {

                                //ADD DETAIL 1
                                if (description1.value != '') {
                                    var amountNotVAT = parseFloat(quan1) * parseFloat(val1);
                                    var vatAmount = 0;
                                    if (vatAmount1.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount1.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID1 == undefined ? -1 : $scope.inputID1,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description1.value,
                                        'unitName': unitName1.value,
                                        'quantity': quantity1.value != '' ? quantity1.value : 1,
                                        'price': price1.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat1.value != '' ? vat1.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };

                                //ADD DETAIL 2
                                if (description2.value != '') {
                                    var amountNotVAT = parseFloat(quan2) * parseFloat(val2);
                                    var vatAmount = 0;
                                    if (vatAmount2.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount2.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID2 == undefined ? -1 : $scope.inputID2,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description2.value,
                                        'unitName': unitName2.value,
                                        'quantity': quantity2.value != '' ? quantity2.value : 1,
                                        'price': price2.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat2.value != '' ? vat2.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };

                                //ADD DETAIL 3
                                if (description3.value != '') {
                                    var amountNotVAT = parseFloat(quan3) * parseFloat(val3);
                                    var vatAmount = 0;
                                    if (vatAmount3.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount3.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID3 == undefined ? -1 : $scope.inputID3,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description3.value,
                                        'unitName': unitName3.value,
                                        'quantity': quantity3.value != '' ? quantity3.value : 1,
                                        'price': price3.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat3.value != '' ? vat3.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 4
                                if (description4.value != '') {
                                    var amountNotVAT = parseFloat(quan4) * parseFloat(val4);
                                    var vatAmount = 0;
                                    if (vatAmount4.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount4.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID4 == undefined ? -1 : $scope.inputID4,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description4.value,
                                        'unitName': unitName4.value,
                                        'quantity': quantity4.value != '' ? quantity4.value : 1,
                                        'price': price4.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat4.value != '' ? vat4.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 5
                                if (description5.value != '') {
                                    var amountNotVAT = parseFloat(quan5) * parseFloat(val5);
                                    var vatAmount = 0;
                                    if (vatAmount5.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount5.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID5 == undefined ? -1 : $scope.inputID5,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description5.value,
                                        'unitName': unitName5.value,
                                        'quantity': quantity5.value != '' ? quantity5.value : 1,
                                        'price': price5.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat5.value != '' ? vat5.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 6
                                if (description6.value != '') {
                                    var amountNotVAT = parseFloat(quan6) * parseFloat(val6);
                                    var vatAmount = 0;
                                    if (vatAmount6.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount6.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID6 == undefined ? -1 : $scope.inputID6,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description6.value,
                                        'unitName': unitName6.value,
                                        'quantity': quantity6.value != '' ? quantity6.value : 1,
                                        'price': price6.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat6.value != '' ? vat6.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 7
                                if (description7.value != '') {
                                    var amountNotVAT = parseFloat(quan7) * parseFloat(val7);
                                    var vatAmount = 0;
                                    if (vatAmount7.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount7.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID7 == undefined ? -1 : $scope.inputID7,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description7.value,
                                        'unitName': unitName7.value,
                                        'quantity': quantity7.value != '' ? quantity7.value : 1,
                                        'price': price7.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat7.value != '' ? vat7.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 8
                                if (description8.value != '') {
                                    var amountNotVAT = parseFloat(quan8) * parseFloat(val8);
                                    var vatAmount = 0;
                                    if (vatAmount8.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount8.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID8 == undefined ? -1 : $scope.inputID8,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description8.value,
                                        'unitName': unitName8.value,
                                        'quantity': quantity8.value != '' ? quantity8.value : 1,
                                        'price': price8.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat8.value != '' ? vat8.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 9
                                if (description9.value != '') {
                                    var amountNotVAT = parseFloat(quan9) * parseFloat(val9);
                                    var vatAmount = 0;
                                    if (vatAmount9.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount9.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID9 == undefined ? -1 : $scope.inputID9,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description9.value,
                                        'unitName': unitName9.value,
                                        'quantity': quantity9.value != '' ? quantity9.value : 1,
                                        'price': price9.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat9.value != '' ? vat9.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                                //ADD DETAIL 10
                                if (description10.value != '') {
                                    var amountNotVAT = parseFloat(quan10) * parseFloat(val10);
                                    var vatAmount = 0;
                                    if (vatAmount10.value != '-')
                                        vatAmount = parseFloat($filter('replace')(vatAmount10.value, ',', ''));

                                    var data = {
                                        'ID': $scope.inputID10 == undefined ? -1 : $scope.inputID10,
                                        'QD1450_HOADON_Id': invoiceId,
                                        'goodAndServiceName': description10.value,
                                        'unitName': unitName10.value,
                                        'quantity': quantity10.value != '' ? quantity10.value : 1,
                                        'price': price10.value,
                                        'amountNotVAT': amountNotVAT,
                                        'VAT': vat10.value != '' ? vat10.value : 0,
                                        'VATAmount': vatAmount,
                                        'amount': amountNotVAT + vatAmount,
                                        'enterpriseId': sessionStorage.enterpriseId
                                    };
                                    $http.post(hostName.url + "api/QD1450/QD1450_HOADON_CHITIET", data)
                                        .then(function (success) { }, function (error) {
                                            flagDetail = false;
                                            console.log(error);
                                        });
                                };
                            }
                            //### END EDIT ON DAY

                            if (flagDetail == true) {
                                swal({
                                    title: "Thông báo",
                                    text: "Lưu dữ liệu thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function () {
                                    /* TAO LAI FILE XML KHI LUU HD */
                                    // ReplaceXML();//BVCD 
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                    icon: "error",
                                    dangerMode: true,
                                    button: "Đóng",
                                }).then(function () {
                                    $state.reload();
                                });
                            }

                            //#UPDATE SUCCESS
                        },
                            function (reason) { //UPDATE ERRORS
                                var objResult = reason.data;

                                swal({
                                    title: "Thông báo",
                                    text: objResult.Message,
                                    icon: "error",
                                    dangerMode: true,
                                    button: "Đóng",
                                }).then(function () {
                                    location.href = "#/Invoice1450_TSCONG";
                                });
                            }); //#UPDATE ERRORS

                }




            } //#IF ALL VALIDATION IS OK

        }; //#FUNCTION SAVE DATA


        //XEM TRUOC HOA DON
        $scope.reviewInvoice = function () {

            $scope.IsDisabled = true;

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            //===   REVIEW BY PDF   ===
            $http({
                method: 'POST',
                url: hostName.url + "api/QD1450/QD1450_HOADON_ReviewPDF",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "HoaDon_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.IsDisabled = false;

            }).error(function (message) {
                $scope.IsDisabled = false;
                //console.log(message);
            });

        };

        //PHAT HANH HOA DON GUI CO QUAN THUE
        $scope.publishInvoice = function () {

            //PUBLISH INVOICE FROM SERVER FOR BENH VIEN
            // PublishInvoiceFromServer();
            publishInvoice_KYSO()

        };
        //### END PUBLISH INVOICE

        //PHAT HANH HOA DON GUI CO QUAN THUE
        function publishInvoice_KYSO() {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },

                            data: JSON.stringify({
                                'Id': sessionStorage.itemId,
                                'MLTDiep': $scope.LoaiThongDiep,
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450_TSCONG";
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450_TSCONG";
                            });
                            console.log(error);
                        });

                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });

        };
        //PUBLISH INVOICE FROM SERVER FOR BENH VIEN
        function PublishInvoiceFromServer() {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        swal({
                            title: "Thông báo",
                            text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/Invoice1450_TSCONG";
                        });

                    },

                    //ERRORS
                    function (errs) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/Invoice1450_TSCONG";
                        });
                        console.log(errs);
                    });

        };
        //### END PUBLISH INVOICE FROM SERVER FOR BENH VIEN


        //PUBLISH INVOICE FROM CLIENT FOR CLOUD
        function PublishInvoiceFromClient() {

            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        var UrlDownload = hostName.url + 'temp/';   // + user.enterpriseId  + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://hddt-data:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },
                            data: JSON.stringify({
                                'Id': sessionStorage.itemId,
                                'MLTDiep': $scope.LoaiThongDiep,
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                location.href = "#/Invoice1450";
                            });
                            console.log(error);
                        });

                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });

        };
        //### END PUBLISH INVOICE FROM CLIENT FOR CLOUD

        /** Manage upload File **/
        $scope.removeFileInvoiceDetail = function () {
            $rootScope.fileTemplate = undefined;
            $rootScope.FileTemplateData = undefined;
            this.isHasFile = false;
            this.checkEdit = false;
        }

        $scope.uploadFileInvoiceDetail = function () {
            angular.element("input[type='file']").val(null);
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            // console.log(1);
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    // console.log(result);
                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);

                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx")) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function () {
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;

                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", sessionStorage.enterpriseId);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;

                        //SET READONLY FOR DETAIL'S CONTROLS
                        $scope.checkEdit = true;
                        $scope.isHasFile = true;
                    }
                });
        };
        /** End Manage upload file **/

        $scope.ImportHoaDonN = function () {
            $scope.IsImportN = !$scope.IsImportN;

            if ($scope.IsImportN == true) {
                // console.log(1);
                $scope.FileMauChiTiet = hostName.url + "Templates/ChiTietHoaDon_Import_N_N.xlsx";
            }
            else {
                // console.log(2);
            }
        }

        //REPLACE XML SIGNED 
        function ReplaceXML() {
            $scope.IsDisabled = true;
            $scope.LoaiThongDiep = $scope.HTHoaDon.selected.ID == 'COMA' ? '200' : '203';

            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };

            $http.post(hostName.url + "api/QD1450/QD1450_HOADON_Publish", inputData)
                .then(
                    //SUCCESS
                    function (success) {
                    },
                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });
        };
    };
    /******  ### END CONTROLLER  ******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.12.2018
 */
(function () {
    'use strict';

    //declare controller for InvoiceApproved
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('InvoiceApprovedPageCtrl', InvoiceApprovedPageCtrl);

    /******************************************/
    /*******controller for InvoiceApproved List*******/
    /******************************************/
    function InvoiceApprovedPageCtrl($scope, $http, $state, hostName, $window, $filter, fileReader) {

        $scope.smartTablePageSize = 10;
        $scope.TotalAmount = 0;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        vm.TotalAmount = 0;
        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        sessionStorage.editId = undefined;
        sessionStorage.editable = false;
        $scope.checkDate = convertJSONDate(new Date());
        var user = JSON.parse(localStorage.getItem("dataUser"));
        // $scope.pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';
        // $scope.pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';
        $scope.pathFileInvoice = hostName.url;

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }

        //function then call  WEB API get ElectricInvoice's data is success
        function successCallBack(response) {
            //console.log(response.data);
            vm.rowCollection = response.data[0];
            //console.log(response.data.Table2[0].totalAmount);
            vm.TotalAmount = 0;
            var total = response.data[1].totalAmount;
            
            if (total != undefined) {
                vm.TotalAmount = total.replace(/,/g,".");
            }

            //display message into Console
            //console.log(response.data);
        };

        //function then call WEB API get ElectricInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectricInvoice's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        toDate = new Date();
        fromDate = new Date(nowYear, nowMonth, 1);
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&medicalCode=";
        $http({
          method: "GET",
          url: hostName.url + "api/ElectronicInvoice/SearchElectricInvoice_Approved?" + queryString
        }).then(successCallBack, errorCallBack);

        //select Status
        $scope.selectChangedStatus = function(objSelect) {
            $scope.Status = objSelect;
        }

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function(objSelect) {
            $scope.InvoiceTemplate = objSelect;
        }

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //redirect to other pages
        $scope.open = function(url, id) {
            sessionStorage.itemId = id;
            sessionStorage.urlReturn = '#/invoiceApproved';
            location.href = url;
        };

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function() {
            $window.open("https://drive.google.com/open?id=1SLpUulz9ozFu6VnUKeqE1mDpOZ64dkSU");
        }

        //edit invoice's general information
        $scope.editInvoice = function(url, id) {
            sessionStorage.itemId = id;
            sessionStorage.editable = true;
            sessionStorage.urlReturn = '#/invoiceApproved';
            location.href = url;
        };

        $scope.importDataFromExcel = function() {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        }

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                  var fileName = $scope.file.name;
                  //console.log(sessionStorage.invoiceId);
                  if (fileName.indexOf(".xls") <= 0 && fileName.indexOf(".xlsx") <= 0 ) {
                      swal({
                          title: "Vui lòng chọn đúng file định dạng Excel!",
                          icon: "warning",
                          button: "Đóng"
                      }).then(function(){
                          return;
                      });
                  }
                  else {
                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);
    
                        //Upload file Template
                        var reg = {
                            url: hostName.url + 'api/HIS/ImportDataFromExcel',
                            method: 'POST',
                            data: data,
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            },
                        };

                        $http(reg).then(function(response) {
                            var result = response.data;
                            if (result.ResultCode == 0) {
                                swal({
                                    title: "Thông báo",
                                    text: "Xuất hóa đơn từ file Excel thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: result.Message,
                                    icon: "error",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                        }, function(error) {
                            swal("Không thể xuất hóa đơn từ file Excel, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                            console.log(error);
                        })
                  }
                });
        };

        //Create new Invoice
        $scope.createInvoice = function() {
            location.href = '#/createInvoice';
            // var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            // $http({
            //     method: "GET",
            //     url: hostName.url + "api/Enterprise/CheckLicenseOfEnterprise?enterpriseCode=" + enterpriseId,
            // }).then(function(response) {
            //     var objResult = response.data;

            //     if (objResult.ResultCode == "0") {
            //         location.href = '#/createInvoice';
            //     }
            //     else {
            //         swal({
            //             title: "Thông báo",
            //             text: "Bản quyền hệ thống không hợp lệ hoặc đã hết hạn, vui lòng liên hệ nhà cung cấp để được hỗ trợ!",
            //             icon: "error",
            //             dangerMode:true,
            //             button: "Đóng",
            //         }).then(function() {
            //             console.clear();
            //         });
            //     }
                
            // }, function(reason) {
            //     var objResult = reason.data;

            //     swal({
            //         title: "Thông báo",
            //         text: "Bản quyền hệ thống không hợp lệ hoặc đã hết hạn, vui lòng liên hệ nhà cung cấp để được hỗ trợ!",
            //         icon: "error",
            //         dangerMode:true,
            //         button: "Đóng",
            //     }).then(function() {
            //         console.clear();
            //     });
            // });
        }

        //create file convert
        $scope.createFileConvert = function(ID, fileInvoice) {
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            swal({
                title: "Bạn muốn tạo Bản chuyển đổi cho Hóa đơn này không?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            }).then(function(willDelete)  {
                if (willDelete) {
                    var queryString = 'electronicInvoiceId=' + ID + '&fileInvoice=' + fileInvoice + "&Username=" + user.Username + "&enterpriseId=" + enterpriseId;
                    $http.post(hostName.url + "api/HIS/HIS_PublishInvoiceConvert?" + queryString).then(function(data){
                        swal("Đã xuất Hóa đơn chuyển đổi thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể xuất được Hóa đơn chuyển đổi, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    });
                } else {
                    //no action;
                }
            });
        }//end create file convert

        //+++CREATE FILE INVOICE XML
        $scope.createFileInvoiceXML = function(ID) {
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            swal({
                title: "Bạn muốn tạo File hóa đơn XML cho hóa đơn này không?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            }).then(function(willDelete)  {
                if (willDelete) {
                    var queryString = 'electronicInvoiceId=' + ID + "&Username=" + user.Username + "&enterpriseId=" + enterpriseId;
                    $http.post(hostName.url + "api/HIS/HIS_PublishInvoiceXML?" + queryString).then(function(data){
                        swal("Đã xuất Hóa đơn XML thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể xuất được Hóa đơn XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    });
                } else {
                    //no action;
                }
            });
        }//###CREATE FILE INVOICE XML

        //filter ElectricInvoice's data
        $scope.findData = function() {
            vm.rowCollection = [];
            vm.TotalAmount = 0;
            $scope.TotalAmount = 0;
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&medicalCode=" + medicalCode.value + "&billNumber=" + billNumber.value + "&symbol=" + symbol.value + "&customerName=" + customerName.value + "&statusId=" + statusId + "&invoiceTemplateId=" + invoiceTemplateId;
                //console.log(queryString);
            }
            else {
                queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&customerName=&billNumber=&symbol=&medicalCode=";
                //console.log(queryString);
            }
            
            //call Webservice to get ElectricInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/SearchElectricInvoice_Approved?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectricInvoice's data
        
    };
    /******End controller for InvoiceApproved List******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 18.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for EditInvoiceMain
    angular.module('BlurAdmin.pages.electricInvoice')
      .controller('EditInvoiceMainPageCtrl', EditInvoiceMainPageCtrl);

    /******************************************/
    /*******controller for EditInvoiceMain*******/
    /******************************************/
    function EditInvoiceMainPageCtrl($scope, $http, $state, hostName) {

        $scope.isPrint = false;
        $scope.isCreatInvoice = false;
        $scope.isSave = true;
        $scope.IsDisabled = false;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //load ElectricInvoice's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();

            //call Webservice to get ElectricInvoice's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    $scope.inputBillNumber = $scope.ElectricInvoice.billNumber;
                    $scope.inputInvoiceTemplate = $scope.ElectricInvoice.invoiceTemplateCode;
                    $scope.inputDateOfInvoice = convertJSONDate($scope.ElectricInvoice.dateOfInvoice);
                }
            }, function(reason) {
                console.log(reason);
            });

            //load ElectricInvoice_Adjust's data if it's existed
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoices_Adjust/GetElectricInvoices_Adjust?electronicInvoiceId=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.Adjust = response.data;
                
                if ($scope.Adjust.ID > 0) {
                    $scope.ID = $scope.Adjust.ID;
                    //put ElectricInvoice's data into Form's controls
                    if ($scope.Adjust.typeOfAction == 'DELETE') {
                        $scope.isPrint = true;
                        $scope.isSave = false;
                        $scope.isCreatInvoice = false;
                        $scope.typeOfAction = {
                            name: 'DELETE',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'ADJUST') {
                        $scope.isPrint = false;
                        $scope.isCreatInvoice = true;
                        $scope.isSave = false;
                        $scope.typeOfAction = {
                            name: 'ADJUST',
                            disabled: true
                        };
                    }
                    if ($scope.Adjust.typeOfAction == 'REPLACE') {
                        $scope.isPrint = true;
                        $scope.typeOfAction = {
                            name: 'REPLACE',
                            disabled: true
                        };
                    }
                    var dateCreated = new Date($scope.Adjust.dateCreated);
                    $scope.inputDateCreated = new Date(dateCreated.getFullYear(), dateCreated.getMonth(), dateCreated.getDate());
                    $scope.inputDescription = $scope.Adjust.description;
                }
                else {
                    $scope.typeOfAction = {
                        name: 'DELETE',
                        disabled: false
                    };
                    $scope.isPrint = false;
                    $scope.isSave = true;
                    $scope.isCreatInvoice = false;
                    $scope.inputDateCreated = new Date();
                }
            }, function(reason) {
                console.log(reason);
            });
        };

        //redirect to other pages
        $scope.backPage = function() {
            location.href = sessionStorage.urlReturn;
        };

        //create new Adjusted Invoice
        $scope.changeInvoice = function() {
            $scope.IsDisabled = true;
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/CheckLicenseOfEnterprise?enterpriseCode=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                var objResult = response.data;

                if (objResult.ResultCode == "0") {
                    location.href = '#/adjustInvoice';
                }
                else {
                    swal({
                        title: "Thông báo",
                        text: objResult.Message,
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function() {
                        $scope.IsDisabled = false;
                        console.clear();
                    });
                }
                
            }, function(reason) {
                var objResult = reason.data;

                swal({
                    title: "Thông báo",
                    text: objResult.Message,
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function() {
                    $scope.IsDisabled = false;
                    console.clear();
                });
            });
        }

        //Print Notification
        $scope.printNotification = function() {
            $scope.IsDisabled = true;
            var typeOfAction = $scope.typeOfAction.name;
            if (typeOfAction == 'ADJUST') {
                 //Print modify invoice document
            }
            else if (typeOfAction == 'DELETE') {
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/ElectronicInvoices_Adjust/PrintNotification?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = "ThongBaoHuyHoaDon.docx"; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    //console.log(contentType);
                }).error(function (message) {
                    console.log(message);
                });
                $scope.IsDisabled = false;
            }
        }

        //Print Document
        $scope.printDocument = function() {
            $scope.IsDisabled = true;
            var typeOfAction = $scope.typeOfAction.name;
            if (typeOfAction == 'ADJUST') {
                 //Print modify invoice document
            }
            else if (typeOfAction == 'DELETE') {
                //Print cancel invoice document
                $http({
                    method: "GET",
                    url: hostName.url + "api/ElectronicInvoices_Adjust/PrintDocument?electronicInvoiceId=" + sessionStorage.itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = "BienBanHuyHoaDon.docx"; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    //console.log(contentType);
                }).error(function (message) {
                    
                    console.log(message);
                });
                $scope.IsDisabled = false;
            }
        }

        $scope.save = function() {
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplate = angular.element(document).find('#inputInvoiceTemplate')[0];
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var dateCreated = angular.element(document).find('#inputDateCreated')[0];
            var typeOfAction = $scope.typeOfAction.name;
            var description = angular.element(document).find('#inputDescription')[0];
            var flag = true;

            //check empty billNumber
            if (billNumber.value == '') {
                swal({
                    title: "Thông tin Số hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    billNumber.focus();
                });
                flag = false;
                return;
            };

            //check empty invoiceTemplate
            if (invoiceTemplate.value == '') {
                swal({
                    title: "Thông tin Mẫu hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    invoiceTemplate.focus();
                });
                flag = false;
                return;
            };

            //check empty dateOfInvoice
            if (dateOfInvoice.value == '') {
                swal({
                    title: "Thông tin Ngày hóa đơn",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    dateOfInvoice.focus();
                });
                flag = false;
                return;
            };

            //check empty dateCreated
            if (dateCreated.value == '') {
                swal({
                    title: "Thông tin Ngày xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    dateCreated.focus();
                });
                flag = false;
                return;
            };

            //check empty typeOfAction
            if (typeOfAction == '') {
                swal({
                    title: "Thông tin Hình thức xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    typeOfAction.focus();
                });
                flag = false;
                return;
            };

            //check empty description
            if (description.value == '') {
                swal({
                    title: "Thông tin Lý do xử lý",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                $scope.IsDisabled = true;
                if ($scope.ID == undefined) { //add new 
                    var statusCode = "";
                    if (typeOfAction == 'ADJUST') {
                        statusCode = 'MODIFY';
                    }
                    else if (typeOfAction == 'DELETE') {
                        statusCode = 'CANCEL';
                    }
                    else if (typeOfAction == 'REPLACE') {
                        statusCode = 'REPLACE';
                    }
                    var inputData = {
                        'electronicInvoiceId': itemId,
                        'dateCreated': reConvertJSONDate(dateCreated.value),
                        'typeOfAction': typeOfAction,
                        'description': description.value,
                        'userCreated': user.ID,
                        'enterpriseId': sessionStorage.enterpriseId
                    };
                    $http.post(hostName.url + "api/ElectronicInvoices_Adjust/AddElectricInvoices_Adjust", inputData)
                    .then(function(response) {
                        var inputData = {
                            'ID': itemId,
                            'statusCode': statusCode,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/ElectronicInvoice/UpdateElectricInvoiceStatus", inputData)
                        .then(function(data){}, function(data) {});

                        swal({
                            title: "Thông báo",
                            text: "Lưu dữ liệu thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(reason) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceApproved";
                        });
                        console.log(reason);
                    });
                }
                // else { //update
                //     var inputData = {
                //         'ID': $scope.ID,
                //         'dateCreated': reConvertJSONDate(dateCreated.value),
                //         'description': description.value,
                //         'userUpdated': user.ID
                //     };
                //     $http.post(hostName.url + "api/ElectricInvoices_Adjust/UpdateElectricInvoices_Adjust", inputData)
                //     .then(function(response) {
                //         swal({
                //             title: "Thông báo",
                //             text: "Lưu dữ liệu thành công!",
                //             icon: "success",
                //             button: "Đóng",
                //         }).then(function(){
                //             $state.reload();
                //         });
                //     }, function(reason) {
                //         swal({
                //             title: "Thông báo",
                //             text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                //             icon: "error",
                //             dangerMode:true,
                //             button: "Đóng",
                //         }).then(function(){
                //             location.href = "#/invoiceApproved";
                //         });
                //         console.log(reason);
                //     });
                // }
                
            } // end of if flag == true

        }; // end of function Save
      
    };
    /******End controller for EditInvoiceMain******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 19.09.2018
 */
(function () {
    'use strict';
  
    //declare controller for InvoiceMain
    angular.module('BlurAdmin.pages.electricInvoice')
      .controller('InvoiceMainPageCtrl', InvoiceMainPageCtrl);

    /******************************************/
    /*******controller for InvoiceMain List*******/
    /******************************************/
    function InvoiceMainPageCtrl($scope, $http, $state, hostName, $location, layoutPaths) {

      $scope.smartTablePageSize = 10;
      var n = 0;
      var vm = this;
      vm.rowCollection = [];
      sessionStorage.itemId = undefined;
      $scope.pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';

      //function then call Webservice get ElectricInvoice's data is success
      function successCallBack(response) {
        vm.rowCollection = response.data;

        for (n=0; n<vm.rowCollection.length; n++) {
          // Encrypt
          vm.rowCollection[n].No = n+1;
          vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);
          if (vm.rowCollection[n].fileInvoice != '')
            vm.rowCollection[n].fileInvoice = $scope.pathSigned + vm.rowCollection[n].fileInvoice;
        }

        //display message into Console
        //console.log(response.data);
      };

      //function then call Webservice get ElectricInvoice's data is error
      function errorCallBack(reason) {
        $scope.error = reason.data;

        //display message into Console
        console.log(reason);
      }

      //call Webservice to get ElectricInvoice's data
      $http({
        method: "GET",
        url: hostName.url + "api/ElectricInvoice/GetAllElectricInvoice?enterpriseId=" + sessionStorage.enterpriseId
      }).then(successCallBack, errorCallBack);

      //check True/False for isActive chechbox
      $scope.checkShow = function(dataCheck){
        if (dataCheck) {
          return 1;
        }
        else {
          return 0;
        }
      };

      //save data to local variable when change Select's control
      $scope.selectChanged = function(objectSelect) {
        $scope.Status = objectSelect;
      }
      
      //redirect to other pages
      $scope.open = function(url, id) {
          location.href = url;
          sessionStorage.itemId = id;
      };

      $scope.checkAll = function(flagAll) {
        for (n=0; n<vm.rowCollection.length; n++) {
          var checkboxInvoice = angular.element(document).find('#checkInvoice' + vm.rowCollection[n].ID)[0];
          if (checkboxInvoice != undefined) {
            if (checkboxInvoice.checked == true) {
              console.log(vm.rowCollection[n].ID);
            }
          }
        }
      }

      $scope.checkInvoice = function(flag, ID) {
        console.log("Check Item: " + flag);
        console.log(ID);
      }

      //filter ElectricInvoice's data
      $scope.findData = function() {
        vm.rowCollection = [];
        var fromDate = angular.element(document).find('#inputFromDate')[0];
        var toDate = angular.element(document).find('#inputToDate')[0];
        var billNumber = angular.element(document).find('#inputBillNumber')[0];
        var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
        var contactPerson = angular.element(document).find('#inputContactPerson')[0];
        var customerName = angular.element(document).find('#inputCustomerName')[0];
        var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
        var symbol = angular.element(document).find('#inputSymbol')[0];
        
        var queryString = "";

        if (fromDate != undefined) {
          var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
          var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&billNumber=" + billNumber.value + "&statusId=" + statusId + "&contactPerson=" + contactPerson.value + "&customerName=" + customerName.value + "&invoiceTemplateId=" + invoiceTemplateId + "&symbol=" + symbol.value;
          //console.log(queryString);
        }
        else {
          var date = new Date();
          var nowYear = date.getFullYear();
          var nowMonth = date.getMonth();
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&billNumber=&statusId=&contactPerson=&customerName=&invoiceTemplateId=&symbol=";
          //console.log(queryString);
        }
         
        //call Webservice to get ElectricInvoice's data
        $http({
          method: "GET",
          url: hostName.url + "api/ElectricInvoice/SearchElectricInvoice?" + queryString,
        }).then(successCallBack, errorCallBack);
      }
      //end filter ElectricInvoice's data
      
    };
    /******End controller for InvoiceMain List******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 19.09.2018
 */
(function () {
    'use strict';
  
    //declare controller for InvoiceMain
    angular.module('BlurAdmin.pages.electricInvoice')
      .controller('UpdateInvoiceMainPageCtrl', UpdateInvoiceMainPageCtrl);

    /******************************************/
    /*******controller for Update InvoiceMain*******/
    /******************************************/
    function UpdateInvoiceMainPageCtrl($scope, $http, $state, $rootScope, $filter, $location, layoutPaths, hostName) {

      var n=0;
      $rootScope.flagGetCustomer = false;
      $scope.isPublic = $scope.isEdit = false;
      $scope.isUpdate = true;
      //Set data for Page Title
      $scope.PageTitle = "Lập mới hóa đơn điện tử";
      $scope.InvoiceTemplate = {};
      $scope.CurrencyOfPayment = {};
      $scope.TypeOfPayment = {};
      var user = JSON.parse(localStorage.getItem("dataUser"));

      /******Define data for Table******/
      $scope.Products = [
        {
          ID: 1,
          goodAndServiceId: '',
          goodAndServiceName: '',
          unitName: '',
          quantity: '',
          price: '',
          amountNotVAT: '',
          VAT: '',
          amountVAT: '',
          productCode: '',
          quantityCode: '',
        }
      ];

      //load ElectricInvoice's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin hóa đơn điện tử";

        //call Webservice to get ElectricInvoice's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/ElectricInvoice/GetElectricInvoice/" + itemId,
        }).then(function(response) {
          $scope.ElectricInvoice = [];
          $scope.ElectricInvoice = response.data;
          //console.log($scope.ElectricInvoice);
          
          if ($scope.ElectricInvoice != undefined) {
            //put ElectricInvoice's data into Form's controls
            var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
            var dateInput = new Date($scope.ElectricInvoice.dateInput);
            $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
            $scope.inputDateInput = new Date(dateInput.getFullYear(), dateInput.getMonth(), dateInput.getDate());
            $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode};
            $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
            $scope.inputSymbol = $scope.ElectricInvoice.symbol;
            $scope.inputContactPerson = $scope.ElectricInvoice.contactPerson;
            $scope.inputPhone = $scope.ElectricInvoice.phone;
            $scope.inputBillNumber = $scope.ElectricInvoice.billNumber;
            $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
            $scope.CurrencyOfPayment.selected = {ID:$scope.ElectricInvoice.currencyOfPaymentId, currencyOfPaymentName:$scope.ElectricInvoice.currencyOfPaymentName };
            $scope.inputEmail = $scope.ElectricInvoice.email;
            $scope.inputExchangeRate = $scope.ElectricInvoice.exchangeRate;
            $scope.inputAddress = $scope.ElectricInvoice.address;
            $scope.TypeOfPayment.selected = {ID: $scope.ElectricInvoice.typeOfPaymentId, typeOfPaymentName: $scope.ElectricInvoice.typeOfPaymentName};
          
            // //if status != "NOTPUBLISH" then don't allow update information
            // if ($scope.ElectricInvoice.statusId != 3) {
              
            // }
            // else {
              
            // }

            //if status != PUBLISHED then allow Public and don't allow process
            if ($scope.ElectricInvoice.statusId != 4) {
              $scope.isPublic = true;
              $scope.isEdit = false;
              $scope.isUpdate = true;
            }
            else {
              $scope.isPublic = false;
              $scope.isEdit = true;
              $scope.isUpdate = false;
            }

            if ( $scope.ElectricInvoice.statusId == 6 || $scope.ElectricInvoice.statusId == 7 || $scope.ElectricInvoice.statusId == 8) {
              $scope.isPublic = false;
              $scope.isEdit = false;
              $scope.isUpdate = false;
            }

            $http({
              method: "GET",
              url: hostName.url + "api/ElectricInvoiceDetail/GetElectricInvoiceDetail?electricInvoiceId=" + $scope.ElectricInvoice.ID,
            }).then(function(response) {
              $scope.Products = response.data;
              for (n=0; n<$scope.Products.length; n++) {
                $scope.Products[n].productCode = {ID: $scope.Products[n].goodAndServiceId, goodAndServiceName: $scope.Products[n].goodAndServiceName};
                $scope.Products[n].quantityCode = $scope.Products[n].quantity;
              }
            }, function(reason) {
              $scope.error = reason.data;
              console.log(reason);
            });
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }
      else {
        $scope.inputDateOfInvoice = new Date();
        $scope.inputDateInput = new Date();
      }

      //save data to local variable when change Select's control
      $scope.changeInvoiceTemplate = function(objectSelect) {
        $scope.InvoiceTemplate.selected = objectSelect;
        //call Webservice to get InvoiceTemplate's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
        }).then(function(response) {
            var invoiceTemplate = response.data;
            
            if (invoiceTemplate.ID > 0) {
                //put InvoiceTemplate's data into Form's controls
                $scope.inputSymbol = invoiceTemplate.symbol;
                $scope.inputBillNumber = invoiceTemplate.currentNumber;
            }
        }, function(reason) {
            //$scope.error = reason.data;
            console.log(reason);
        });
      };

      $scope.changeCurrencyOfPayment = function(objectSelect) {
        $scope.CurrencyOfPayment.selected = objectSelect;
        //call Webservice to get CurrencyOfPayment's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/CurrencyOfPayment/GetCurrencyOfPayment/" + objectSelect.ID,
        }).then(function(response) {
          var currencyOfPayment = response.data;
          
          if (currencyOfPayment.ID > 0) {
            //put CurrencyOfPayment's data into Form's controls
            $scope.inputExchangeRate = $filter('currency')(currencyOfPayment.exchangeRate, '', 0);
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      };

      $scope.changeTypeOfPayment = function(objectSelect) {
        $scope.TypeOfPayment.selected = objectSelect;
      };

      $scope.findCustomer = function(taxCode) {
        //call Webservice to get Customer's data by taxCode
        $http({
          method: "GET",
          url: hostName.url + "api/Customer/GetCustomer?taxCode=" + taxCode,
        }).then(function(response) {
          //$scope.Customer = [];
          $scope.Customer = response.data;
          //console.log($scope.Customer);

          if ($scope.Customer.ID > 0) {
            //put Customer's data into Form's controls
            $scope.inputCustomerName = $scope.Customer.customerName;
            //$scope.inputTaxCode = $scope.Customer.taxCode;
            //$scope.inputBankName = $scope.Customer.bankName;
            $scope.inputContactPerson = $scope.Customer.contactPerson;
            $scope.inputPhone = $scope.Customer.phone;
            $scope.inputAddress = $scope.Customer.address;
            $scope.inputEmail = $scope.Customer.email;

            $rootScope.flagGetCustomer = true;
            //console.log($rootScope.flagGetCustomer);
          }
          else {
            $scope.inputCustomerName = "";
            //$scope.inputTaxCode = $scope.Customer.taxCode;
            //$scope.inputBankName = $scope.Customer.bankName;
            $scope.inputContactPerson = "";
            $scope.inputPhone = "";
            $scope.inputAddress = "";

            $rootScope.flagGetCustomer = false;
            //console.log($rootScope.flagGetCustomer);
          };
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });

        //alert($rootScope.flagGetCustomer);
      };
      
      //redirect to other pages
      $scope.open = function(url) {
          location.href = url;
          sessionStorage.urlReturn = '#/createInvoiceMain';
      };
  
      $scope.removeProduct = function(item) {
        var index = $scope.Products.indexOf(item);
        $scope.Products.splice(index,1);
      };
  
      $scope.addProduct = function() {
        $scope.inserted = {
          ID: $scope.Products.length+1,
          goodAndServiceId: '',
          goodAndServiceName: '',
          unitName: '',
          quantity: '',
          price: '',
          amountNotVAT: '',
          VAT: '',
          amountVAT: '',
          productCode: '',
          quantityCode: '',
        };
        $scope.Products.push($scope.inserted);
      };

      $scope.selectProduct = function(objSelect, productId) {
        $scope.GoodAndService = objSelect;

        for (n=0; n<$scope.Products.length; n++) {
          if ($scope.Products[n].ID == productId) {
            $scope.Products[n].goodAndServiceId = $scope.GoodAndService.ID;
            $scope.Products[n].goodAndServiceName = $scope.GoodAndService.goodAndServiceName;
            $scope.Products[n].unitName = $scope.GoodAndService.unitName;
            $scope.Products[n].price = $scope.GoodAndService.price;
            $scope.Products[n].VAT = $scope.GoodAndService.VAT;
            $scope.Products[n].quantity = $scope.Products[n].quantityCode = 1;
            var amountNotVAT = $scope.Products[n].price * $scope.Products[n].quantity;
            var amountVAT = ((amountNotVAT * $scope.Products[n].VAT)/100) + amountNotVAT;
            $scope.Products[n].amountNotVAT = amountNotVAT;
            $scope.Products[n].amountVAT = amountVAT;
          }
        }
      }

      $scope.changeQuantity = function(productId, quantity) {
        //alert(productId);
        //console.log("Change Quantity");
        //console.log(goodID);
        //var quantity = angular.element(document).find('#inputQuantity');
        //console.log(quantity);
        
        for (n=0; n<$scope.Products.length; n++) {
          if ($scope.Products[n].ID == productId) {
            $scope.Products[n].quantity = quantity;
            var amountNotVAT = $scope.Products[n].price * quantity;
            var amountVAT = ((amountNotVAT * $scope.Products[n].VAT)/100) + amountNotVAT;
            $scope.Products[n].amountNotVAT = amountNotVAT;
            $scope.Products[n].amountVAT = amountVAT;
          }
        }
      }

      //publish Invoice
      $scope.publishInvoice = function() {
        var itemId = sessionStorage.itemId.toString();
        $http({
            method: 'GET',
            url: hostName.url + "api/ElectricInvoice/UpdateElectricInvoicePublish?ID=" + itemId + "&userUpdated=" + user.ID,
            //responseType: 'arraybuffer',
            //params: inputData
        }).success(function (data, status, headers) {
            //console.log(data);
            var pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';
            var pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';
            var urlDownload = pathTemp + data;
            //console.log(urlDownload);
            //console.log(pathSigned);
            //console.log($location.absUrl());
            // var inputData = JSON.stringify({
            //     'file': urlDownload,
            //     'urlUpload': "",
            // });
            
            var req = {
              method: 'POST',
              url: 'http://localhost:7001/PdfSignService/SignInvoice',
              headers: {
                'Content-Type': "application/json"
              },
              data: JSON.stringify({ 
                'file': urlDownload,
                'urlUpload': hostName.url + "api/ElectricInvoice/UploadFileToServer",
                'id': itemId
              })
            };
            
            $http(req).then(function(response){
              swal("Hóa đơn đã xuất thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                location.href = "#/invoiceMain";
              });
            }, function(error) {
              var inputData = {
                'ID': itemId,
                'statusCode': 'SIGNERROR'
              };
              $http.post(hostName.url + "api/ElectricInvoice/UpdateElectricInvoiceStatus", inputData).then(function(data){
                swal("Ký số lỗi, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                }).then(function(){
                  location.href = "#/invoiceMain";
                });
              }, function(data) {});
              console.log(error);
            });
        }).error(function (message) {
            console.log(message);
        });
      }

      $scope.save = function() {  //start Save function
        //console.log($scope.Products);

        var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
        var dateInput = angular.element(document).find('#inputDateInput')[0];
        var invoiceTemplateId = $scope.InvoiceTemplate.selected == undefined ? 0:$scope.InvoiceTemplate.selected.ID;
        var invoiceTemplateCode = $scope.InvoiceTemplate.selected == undefined ? '':$scope.InvoiceTemplate.selected.invoiceTemplateCode;
        var taxCode = angular.element(document).find('#inputTaxCode')[0]; //require if add new customer
        var symbol = angular.element(document).find('#inputSymbol')[0];
        var customerName = angular.element(document).find('#inputCustomerName')[0]; //require if add new customer
        var billNumber = angular.element(document).find('#inputBillNumber')[0];
        var contactPerson = angular.element(document).find('#inputContactPerson')[0];
        var phone = angular.element(document).find('#inputPhone')[0];
        var currencyOfPaymentId = $scope.CurrencyOfPayment.selected == undefined ? 0:$scope.CurrencyOfPayment.selected.ID;
        var currencyOfPaymentName = $scope.CurrencyOfPayment.selected == undefined ? 0:$scope.CurrencyOfPayment.selected.currencyOfPaymentName;
        var email = angular.element(document).find('#inputEmail')[0];
        var exchangeRate = angular.element(document).find('#inputExchangeRate')[0];
        var address = angular.element(document).find('#inputAddress')[0];
        var typeOfPaymentId = $scope.TypeOfPayment.selected == undefined ? 0:$scope.TypeOfPayment.selected.ID;
        var typeOfPaymentName = $scope.TypeOfPayment.selected == undefined ? 0:$scope.TypeOfPayment.selected.typeOfPaymentName;
        var customerId = 0;
        var totalAmountNotVAT = 0;
        var totalAmount = 0;
        var flag = true;

        //check empty dateOfInvoice
        if (dateOfInvoice.value == '') {
          swal({
              title: "Thông tin Ngày hóa đơn",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            dateOfInvoice.focus();
          });
          flag = false;
          return;
        }

        //check empty dateInput
        if (dateInput.value == '') {
          swal({
              title: "Thông tin Ngày nhập",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            dateInput.focus();
          });
          flag = false;
          return;
        }

        //check empty invoiceTemplateId
        if (invoiceTemplateId == 0) {
          swal({
              title: "Thông tin Mẫu hóa đơn",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
              $scope.$broadcast('SetFocusInvoiceTemplate');
          });
          flag = false;
          return;
        }

        //check empty contactPerson
        if (contactPerson.value == '') {
          swal({
              title: "Thông tin Người mua hàng",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            contactPerson.focus();
          });
          flag = false;
          return;
        }

        //check empty phone
        if (phone.value == '') {
          swal({
              title: "Thông tin Điện thoại",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            phone.focus();
          });
          flag = false;
          return;
        }

        //check empty currencyOfPaymentId
        if (currencyOfPaymentId == 0) {
          swal({
              title: "Thông tin Đồng tiền thanh toán",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
              $scope.$broadcast('SetFocusCurrencyOfPayment');
          });
          flag = false;
          return;
        }

        //check empty email
        if (email.value == '') {
          swal({
              title: "Thông tin Email",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            email.focus();
          });
          flag = false;
          return;
        }

        //check empty exchangeRate
        if (exchangeRate.value == '') {
          swal({
              title: "Thông tin Tỷ giá",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            exchangeRate.focus();
          });
          flag = false;
          return;
        }

        //check empty address
        if (address.value == '') {
          swal({
              title: "Thông tin Địa chỉ",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
            address.focus();
          });
          flag = false;
          return;
        }

        //check empty typeOfPaymentId
        if (typeOfPaymentId == 0) {
          swal({
              title: "Thông tin Hình thức thanh toán",
              text: 'không được để trống!',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
              $scope.$broadcast('SetFocusTypeOfPayment');
          });
          flag = false;
          return;
        }

        if (($scope.Products[0] != undefined && $scope.Products[0].goodAndServiceId == '') || $scope.Products[0] == undefined) {
          swal({
            title: "Thông tin Hàng hóa & dịch vụ",
            text: 'không được để trống!',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            $scope.$broadcast('SetFocusProduct');
          });
          flag = false;
          return;
        }

        //get Total Amount
        for (n=0; n<$scope.Products.length; n++) {
          totalAmountNotVAT += $scope.Products[n].amountNotVAT;
          totalAmount += $scope.Products[n].amountVAT;
        }

        //console.log("Total Amount: " + totalAmount);

        //declare function to alert when success or error
        //success function
        function successCallBack(data) {
          if (sessionStorage.itemId == 'undefined') {
            sessionStorage.itemId = data.data;

            //add ElectricInvoice detail's data
            for (n=0; n<$scope.Products.length; n++) {
              var data = {
                'electricInvoiceId': sessionStorage.itemId,
                'goodAndServiceId': $scope.Products[n].goodAndServiceId,
                'goodAndServiceName': $scope.Products[n].goodAndServiceName,
                'unitName': $scope.Products[n].unitName,
                'quantity': $scope.Products[n].quantity,
                'price': $scope.Products[n].price,
                'amountNotVAT': $scope.Products[n].amountNotVAT,
                'VAT': $scope.Products[n].VAT,
                'amountVAT': $scope.Products[n].amountVAT,
                'enterpriseId': sessionStorage.enterpriseId
              };
              $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                  .then();
            }
          }
          else { //update ElectricInvoice detail's data
            for (n=0; n<$scope.Products.length; n++) {
              var data = {
                'ID': $scope.Products[n].ID,
                'goodAndServiceId': $scope.Products[n].goodAndServiceId,
                'goodAndServiceName': $scope.Products[n].goodAndServiceName,
                'unitName': $scope.Products[n].unitName,
                'quantity': $scope.Products[n].quantity,
                'price': $scope.Products[n].price,
                'amountNotVAT': $scope.Products[n].amountNotVAT,
                'VAT': $scope.Products[n].VAT,
                'amountVAT': $scope.Products[n].amountVAT
              };
              $http.post(hostName.url + "api/ElectricInvoiceDetail/UpdateElectricInvoiceDetail", data)
                  .then();
            }
          }

          swal({
              title: "Thông báo",
              text: "Lưu dữ liệu thành công!",
              icon: "success",
              button: "Đóng",
          }).then(function(){
              $state.reload();
          });
          //console.log(data);
        }
        //error function
        function errorCallBack(data) {
            swal({
                title: "Thông báo",
                text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                icon: "error",
                dangerMode:true,
                button: "Đóng",
            }).then(function(){
                location.href = "#/invoiceMain";
            });
            console.log(data);
        }

        //if not empty with data which must to have
        if (flag == true) {
          //Update ElectricInvoice's data
          if (sessionStorage.itemId != 'undefined') {
            var dateOfInvoice = reConvertJSONDate(dateOfInvoice.value);
            var dateInput = reConvertJSONDate(dateInput.value);

            var data = {
                'ID': sessionStorage.itemId,
                'dateOfInvoice': dateOfInvoice,
                'dateInput': dateInput,
                'invoiceTemplateId': invoiceTemplateId,
                'invoiceTemplateCode': invoiceTemplateCode,
                'symbol': symbol.value,
                'billNumber': billNumber.value,
                'currencyOfPaymentId': currencyOfPaymentId,
                'currencyOfPaymentName': currencyOfPaymentName,
                'exchangeRate': exchangeRate.value,
                'typeOfPaymentId': typeOfPaymentId,
                'typeOfPaymentName': typeOfPaymentName,
                'customerId': customerId,
                'taxCode': taxCode.value,
                'customerName': customerName.value,
                'contactPerson': contactPerson.value,
                'phone': phone.value,
                'email': email.value,
                'address': address.value,
                'totalAmountNotVAT': totalAmountNotVAT,
                'totalAmount': totalAmount,
                'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/ElectricInvoice/UpdateElectricInvoice", data)
                .then(successCallBack, errorCallBack);
          }
          //Add new ElectricInvoice's data
          else {
            var dateOfInvoice = reConvertJSONDate(dateOfInvoice.value);
            var dateInput = reConvertJSONDate(dateInput.value);

            var data = {
              'dateOfInvoice': dateOfInvoice,
              'dateInput': dateInput,
              'invoiceTemplateId': invoiceTemplateId,
              'invoiceTemplateCode': invoiceTemplateCode,
              'symbol': symbol.value,
              'billNumber': billNumber.value,
              'currencyOfPaymentId': currencyOfPaymentId,
              'currencyOfPaymentName': currencyOfPaymentName,
              'exchangeRate': exchangeRate.value,
              'typeOfPaymentId': typeOfPaymentId,
              'typeOfPaymentName': typeOfPaymentName,
              'customerId': customerId,
              'taxCode': taxCode.value,
              'customerName': customerName.value,
              'contactPerson': contactPerson.value,
              'phone': phone.value,
              'email': email.value,
              'address': address.value,
              'totalAmountNotVAT': totalAmountNotVAT,
              'totalAmount': totalAmount,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            $http.post(hostName.url + "api/ElectricInvoice/AddElectricInvoice", data)
                .then(successCallBack, errorCallBack);
          }
        }

      } //end Save function
      
    };
    /******End controller for Update InvoiceMain******/

    

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 16.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for InvoicePending
    angular.module('BlurAdmin.pages.lists')
      .controller('InvoicePendingPageCtrl', InvoicePendingPageCtrl);

    //******controller for InvoicePending******
    function InvoicePendingPageCtrl($scope, $http, $state, hostName) {

      $scope.smartTablePageSize = 10;
      var n = 0;
      var vm = this;
      vm.rowCollection = [];
      sessionStorage.itemId = undefined;
      sessionStorage.pendingId = undefined;
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //function then call Webservice get InvoicePending's data is success
      function successCallBack(response) {
        vm.rowCollection = response.data;

        for (n=0; n < vm.rowCollection.length; n++) {
          vm.rowCollection[n].No = n+1;
          vm.rowCollection[n].datePending = convertJSONDate(vm.rowCollection[n].datePending);
        }

        //display message into Console
        //console.log(response);
      };

      //function then call Webservice get InvoicePending's data is error
      function errorCallBack(reason) {
        $scope.error = reason.data;

        //display message into Console
        console.log(reason);
      }

      //call Webservice to get InvoicePending's data
      $http({
        method: "GET",
        url: hostName.url + "api/InvoiceTemplate_Pending/GetAllInvoiceTemplate_Pending?enterpriseId=" + sessionStorage.enterpriseId
      }).then(successCallBack, errorCallBack);

      //check True/False for isActive chechbox
      $scope.checkShow = function(dataCheck){
        if (dataCheck) {
          return 1;
        }
        else {
          return 0;
        }
      };

      //save data to local variable when change Select's control
    $scope.selectChanged = function(objectSelect) {
        $scope.InvoiceTemplate = objectSelect;
      }
      
      //redirect to other pages
      $scope.open = function(url, id) {
        location.href = url;
        sessionStorage.itemId = id;
        sessionStorage.pendingId = id;
      };

      //filter InvoicePending's data
      $scope.findData = function() {
        vm.rowCollection = [];
        var fromDate = angular.element(document).find('#inputFromDate')[0];
        var toDate = angular.element(document).find('#inputToDate')[0];
        var invoiceTemplateId = $scope.InvoiceTemplate == undefined ? "":$scope.InvoiceTemplate.ID;
        var symbol = angular.element(document).find('#inputSymbol')[0];
        var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
        var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
        var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
        //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
        if (isActiveAll.checked == true) {
          isActive = "";
        }
        else if (isActiveTrue.checked == true) {
          isActive = true;
        }
        else {
          isActive = false;
        }
        var queryString = "";

        if (fromDate != undefined) {
          var dateFrom = reConvertJSONDate(fromDate.value);
          var dateTo = reConvertJSONDate(toDate.value);
          
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&invoiceTemplateId=" + invoiceTemplateId + "&symbol=" + symbol.value + "&isActive=" + isActive;
        }
        else {
          var date = new Date();
          var nowYear = date.getFullYear();
          var nowMonth = date.getMonth();
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&invoiceTemplateId=&symbol=&isActive=";
        }
         
        //call Webservice to get InvoicePending's data
        $http({
          method: "GET",
          url: hostName.url + "api/InvoiceTemplate_Pending/SearchInvoiceTemplate_Pending?" + queryString,
        }).then(successCallBack, errorCallBack);
      }
      //end filter InvoicePending's data

      //update Status of InvoicePending
      $scope.updateStatus = function(flag, itemId) {
        if (flag == true) {
          //Stop
          swal({
            title: "Bạn muốn kích hoạt thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete) {
            if (willDelete) {
              var inputData = {
                'ID': itemId,
                'isActive': true,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/InvoiceTemplate_Pending/UpdateInvoiceTemplate_PendingStatus", inputData).then(function(data){
                swal("Kích hoạt thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
        else {
          //Active
          swal({
            title: "Bạn muốn ngừng sử dụng thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var inputData = {
                'ID': itemId,
                'isActive': false,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/InvoiceTemplate_Pending/UpdateInvoiceTemplate_PendingStatus", inputData).then(function(data){
                swal("Ngừng sử dụng thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
      }

    };
    //******End controller for InvoicePending******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 16.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Update InvoicePending
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateInvoicePendingPageCtrl', UpdateInvoicePendingPageCtrl);

    /******************************************/
    /******controller for Update InvoicePending******/
    /******************************************/
    function UpdateInvoicePendingPageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin hóa đơn tạm giữ in sau";
      $scope.checkStatus = 'Y';
      $scope.InvoiceTemplate = {};
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load InvoicePending's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin hóa đơn tạm giữ in sau";

        //call Webservice to get InvoicePending's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/InvoiceTemplate_Pending/GetInvoiceTemplate_Pending/" + itemId,
        }).then(function(response) {
          $scope.InvoicePending = [];
          $scope.InvoicePending = response.data;
          
          if ($scope.InvoicePending != undefined) {
            //put InvoicePending's data into Form's controls
            $scope.InvoiceTemplate.selected = {ID: $scope.InvoicePending.invoiceTemplateId, invoiceTemplateCode: $scope.InvoicePending.invoiceTemplateCode};
            var datePending = new Date($scope.InvoicePending.datePending);
            $scope.inputDatePending = new Date(datePending.getFullYear(), datePending.getMonth(), datePending.getDate());
            $scope.inputFromNumber = $scope.InvoicePending.fromNumber;
            $scope.inputToNumber = $scope.InvoicePending.toNumber;
            $scope.checkStatus = $scope.InvoicePending.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }
      else {
        $scope.inputDatePending = new Date();
      }

      $scope.selectChanged = function(objectSelect) {
        $scope.InvoiceTemplate.selected = objectSelect;
        //get invoiceTemplate's data
        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
          }).then(function(response) {
            $scope.templateDate = response.data;
            $scope.inputFromNumber = $scope.templateDate.currentNumber;
          }, function(error) {
              console.log(error);
          });
      }

      //save InvoicePending's data into Database via Webservice
      $scope.save = function () {

        var invoiceTemplateId = $scope.InvoiceTemplate.selected != undefined ? $scope.InvoiceTemplate.selected.ID : 0;
        var invoiceTemplateCode = $scope.InvoiceTemplate.selected != undefined ? $scope.InvoiceTemplate.selected.invoiceTemplateCode : 0;
        var datePending = angular.element(document).find('#inputDatePending')[0];
        var fromNumber = angular.element(document).find('#inputFromNumber')[0];
        var toNumber = angular.element(document).find('#inputToNumber')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        
        var flag = true;

        //check empty invoiceTemplateId
        if (invoiceTemplateId == 0) {
          swal({
            title: "Thông tin Mẫu hóa đơn",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            $scope.$broadcast('SetFocus');
          });
          flag = false;
          return;
        }

        //console.log($scope.templateDate);

        //check empty datePending
        if (datePending.value == '') {
          swal({
            title: "Thông tin Ngày tạm giữ",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            datePending.focus();
          });
          flag = false;
          return;
        }

        //check empty fromNumber
        if (fromNumber.value == '') {
            swal({
              title: "Thông tin Từ số",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                fromNumber.focus();
            });
            flag = false;
            return;
        }

        //check fromNumber cannot less than template's currentNumber
        if (fromNumber.value < $scope.templateDate.currentNumber) {
            swal({
              title: "Số bắt đầu tạm giữ không thể nhỏ hơn số hiện tại của mẫu hóa đơn!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                fromNumber.focus();
            });
            flag = false;
            return;
        }

        //check empty toNumber
        if (toNumber.value == '') {
            swal({
              title: "Thông tin Đến số",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                toNumber.focus();
            });
            flag = false;
            return;
        }

        //check toNumber cannot greater than template's toNumber
        if (toNumber.value > $scope.templateDate.toNumber) {
            swal({
            title: "Số kết thúc tạm giữ không thể lớn hơn số kết thúc của mẫu hóa đơn!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                toNumber.focus();
            });
            flag = false;
            return;
        }

        //check fromNumber cannot greater than toNumber
        if (fromNumber.value > toNumber.value) {
            swal({
            title: "Số bắt đầu không thể lớn hơn số kết thúc!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                toNumber.focus();
            });
            flag = false;
            return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/invoicePending";
          });
          //console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/invoicePending";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update InvoicePending's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var datePending = reConvertJSONDate(datePending.value);
            var inputData = {
              'ID': sessionStorage.itemId,
              'invoiceTemplateId': invoiceTemplateId, 
              'invoiceTemplateCode': invoiceTemplateCode, 
              'symbol': $scope.templateDate.symbol,
              'datePending': datePending,
              'fromNumber': fromNumber.value,
              'toNumber': toNumber.value,
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/InvoiceTemplate_Pending/UpdateInvoiceTemplate_Pending", inputData)
            .then(successCallBack, errorCallBack);
          }
          //Add new InvoicePending's data
          else {
            var datePending = reConvertJSONDate(datePending.value);
            var inputData = {
                'invoiceTemplateId': invoiceTemplateId, 
              'invoiceTemplateCode': invoiceTemplateCode, 
              'symbol': $scope.templateDate.symbol,
              'datePending': datePending,
              'fromNumber': fromNumber.value,
              'toNumber': toNumber.value,
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/InvoiceTemplate_Pending/AddInvoiceTemplate_Pending", inputData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save InvoicePending's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update InvoicePending******/

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 30.11.2018
 */
(function () {
    'use strict';

    //declare controller for InvoicePublicTotal
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('InvoicePublicTotalPageCtrl', InvoicePublicTotalPageCtrl);

    /******************************************/
    /*******controller for InvoicePublicTotal List*******/
    /******************************************/
    function InvoicePublicTotalPageCtrl($scope, $http, $state, hostName, $location, layoutPaths, $uibModal) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';
        $scope.pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';

        //function then call  WEB API get ElectricInvoice's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);

                //file Invoice
                if (vm.rowCollection[n].fileInvoice != '')
                    vm.rowCollection[n].fileInvoice = $scope.pathSigned + vm.rowCollection[n].fileInvoice;

                //file detail of invoice
                if (vm.rowCollection[n].fileListDetail != '')
                    vm.rowCollection[n].fileListDetail = $scope.pathTemp + vm.rowCollection[n].fileListDetail;
            }

            //display message into Console
            //console.log(response.data);
        };

        //function then call WEB API get ElectricInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectricInvoice's data
        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/GetAllElectricInvoice?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);

        //save data to local variable when change Select's control
        $scope.selectChanged = function(objectSelect) {
            $scope.Status = objectSelect;
        }

        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
            sessionStorage.urlReturn = '#/invoicePublicTotal';
        };

        //filter ElectricInvoice's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var symbol = angular.element(document).find('#inputSymbol')[0];
            
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&billNumber=" + billNumber.value + "&statusId=" + statusId + "&invoiceTemplateId=" + invoiceTemplateId + "&symbol=" + symbol.value;
                //console.log(queryString);
            }
            else {
                var date = new Date();
                var nowYear = date.getFullYear();
                var nowMonth = date.getMonth();
                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&billNumber=&statusId=&invoiceTemplateId=&symbol=";
                //console.log(queryString);
            }
            
            //call Webservice to get ElectricInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ElectricInvoice/SearchElectricInvoice_HIS?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
      //end filter ElectricInvoice's data
        
    };
    /******End controller for InvoicePublicTotal List******/
    
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
        return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 14.01.2019
 */
(function () {
    'use strict';

    //declare controller for Collapse InvoiceQueuePageCtrl
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CollapseInvoiceQueuePageCtrl', CollapseInvoiceQueuePageCtrl);

    /******************************************/
    /*******controller for Edit InvoiceQueue*******/
    /******************************************/
    function CollapseInvoiceQueuePageCtrl($scope, $http, hostName, $filter) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        //call API success
        function successCallBack(response) {
            vm.rowCollection = response.data;
            //console.log(vm.rowCollection);

            for (n=0; n < vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
            }
        };

        //call API error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //load data from Database via API with itemId
        if (sessionStorage.collapseID != 'undefined') {
            var collapseID = sessionStorage.collapseID.toString();
            $scope.inputSalesVoucherID = sessionStorage.VoucherNum;

            //call API to get data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/SalesVoucher/GetTotalAmount_ByMultiID?SalesVoucherID=" + collapseID,
            }).then(function(response) {
                var objData = response.data;
                $scope.inputTotalAmount = $filter('currency')(objData != undefined ? objData.TotalAmount : 0, '', 0);
                $scope.inputCustomerName = objData != undefined ? objData.CustomerName : 0;
                $scope.inputTaxCode = objData != undefined ? objData.VATNo : 0;
                $scope.inputCompanyName = objData != undefined ? objData.VATObjectName : 0;
                $scope.inputAddress = objData != undefined ? objData.VATObjectAddress : 0;

            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });

            //Call API to get List Data
            $http({
                method: "GET",
                url: hostName.url + "api/SalesVoucher/GetSalesVoucher_DetailByID?SalesVoucherID=" + collapseID,
            }).then(successCallBack, errorCallBack);
        };

        $scope.save = function() {
            /**
             *  Requirement: 
             *      - TaxCode & CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];
            var totalAmount = angular.element(document).find('#inputTotalAmount')[0];
            var amount = $filter('replace')(totalAmount.value, ',', '');
            amount = parseInt(amount);
            var flag = true;
            var pendingId = sessionStorage.pendingId != 'undefined' ? sessionStorage.pendingId : 0;
            
            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mã số thuế\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    taxCode.focus();
                });
                flag = false;
                return;
            };

            //check empty companyName
            if (companyName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    companyName.focus();
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                var inputData = {
                    'SalesVoucherID': sessionStorage.collapseID,
                    'enterpriseId': sessionStorage.enterpriseId,
                    'userCreated': user.ID,
                    'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                    'customerName': customerName.value,
                    'companyName': companyName.value,
                    'taxCode': taxCode.value,
                    'address': address.value,
                    'description': notes.value,
                    'amount': amount,
                    'pendingId': pendingId,
                };

                $http.post(hostName.url + "api/SalesVoucher/FTCAddElectricInvoice_Collapse", inputData)
                .then(function(response) {
                    var invoiceId = response.data;

                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function(){
                        sessionStorage.pendingId = undefined;
                        location.href = "#/invoiceQueue";
                    });
                }, function(reason) {
                    console.log(reason);
                    swal({
                        title: "Thông báo",
                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/invoiceQueue";
                    });
                });
            }
        };
        
    };
    /******End controller for Collapse InvoiceQueuePageCtrl******/

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 08.01.2019
 */
(function () {
    'use strict';

    //declare controller for Create Invoice
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateInvoicePageCtrl', CreateInvoicePageCtrl);

    /******************************************/
    /*******controller for Create Invoice*******/
    /******************************************/
    function CreateInvoicePageCtrl($scope, $http, hostName, $filter, $state) {

        var n = 0;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();
        $scope.InvoiceTemplate = {};
        $scope.TypeOfRevenue = {};
        $scope.isPublic = false;
        $scope.checkEdit = sessionStorage.editable == "true" ? true : false;
        $scope.IsDisabled = false;

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        if (sessionStorage.itemId != 'undefined') {
            $scope.isPublic = true;
            var itemId = sessionStorage.itemId;

            //call Webservice to get ElectricInvoice's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/ElectronicInvoice/GetElectricInvoice?ID=" + itemId + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).then(function(response) {
                $scope.ElectricInvoice = [];
                $scope.ElectricInvoice = response.data;
                
                if ($scope.ElectricInvoice != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    var dateOfInvoice = new Date($scope.ElectricInvoice.dateOfInvoice);
                    $scope.inputDateOfInvoice = new Date(dateOfInvoice.getFullYear(), dateOfInvoice.getMonth(), dateOfInvoice.getDate());
                    $scope.InvoiceTemplate.selected = {ID: $scope.ElectricInvoice.invoiceTemplateId, invoiceTemplateCode: $scope.ElectricInvoice.invoiceTemplateCode, invoiceTemplateName: $scope.ElectricInvoice.invoiceTemplateName};
                    $scope.inputSymbol = $scope.ElectricInvoice.symbol;
                    // $scope.inputBillNumber = $scope.ElectricInvoice.billNumber;

                    $scope.inputCompanyName = $scope.ElectricInvoice.companyName;
                    $scope.inputTaxCode = $scope.ElectricInvoice.taxCode;
                    $scope.inputCustomerName = $scope.ElectricInvoice.customerName;
                    $scope.inputAddress = $scope.ElectricInvoice.address;
                    $scope.inputMedicalCode = $scope.ElectricInvoice.medicalCode;
                    $scope.inputHealthInsuranceCardNumber = $scope.ElectricInvoice.healthInsuranceCardNumber;
                    $scope.inputHospitalizationNumber = $scope.ElectricInvoice.hospitalizationNumber;

                    $scope.inputNotes = $scope.ElectricInvoice.description;

                    $scope.TypeOfRevenue.selected = {ID: $scope.ElectricInvoice.typeOfRevenueId, typeOfRevenueName: $scope.ElectricInvoice.typeOfRevenueName};
        
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ElectronicInvoiceDetail/GetElectricInvoiceDetail?electronicInvoiceId=" + $scope.ElectricInvoice.ID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function(response) {
                        $scope.Products = response.data;

                        //detail 1
                        if ($scope.Products.length > 0) {
                            $scope.inputDescription1 = $scope.Products[0].goodAndServiceName;
                            $scope.inputUnitName1 = $scope.Products[0].unitName;
                            $scope.inputQuantity1 = $scope.Products[0].quantity;
                            $scope.inputPrice1 = $scope.Products[0].price;
                            $scope.inputVAT1 = $scope.Products[0].VAT;
                            $scope.inputVATAmount1 = $scope.Products[0].VATAmount;

                            //detail 2
                            if ($scope.Products.length > 1) {
                                $scope.inputDescription2 = $scope.Products[1].goodAndServiceName;
                                $scope.inputUnitName2 = $scope.Products[1].unitName;
                                $scope.inputQuantity2 = $scope.Products[1].quantity;
                                $scope.inputPrice2 = $scope.Products[1].price;
                                $scope.inputVAT2 = $scope.Products[1].VAT;
                                $scope.inputVATAmount2 = $scope.Products[1].VATAmount;
        
                                //detail 3
                                if ($scope.Products.length > 2) {
                                    $scope.inputDescription3 = $scope.Products[2].goodAndServiceName;
                                    $scope.inputUnitName3 = $scope.Products[2].unitName;
                                    $scope.inputQuantity3 = $scope.Products[2].quantity;
                                    $scope.inputPrice3 = $scope.Products[2].price;
                                    $scope.inputVAT3 = $scope.Products[2].VAT;
                                    $scope.inputVATAmount3 = $scope.Products[2].VATAmount;
                                }
                            }
                        }
                    }, function(reason) {
                        console.log(reason);
                    });
                }
            }, function(reason) {
                console.log(reason);
            });
        }
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
            }).then(function(response){ //SUCCESS
                $scope.InvoiceTemplate.selected = {ID: response.data[0].ID, invoiceTemplateCode: response.data[0].invoiceTemplateCode, invoiceTemplateName: response.data[0].invoiceTemplateName};
                $scope.inputSymbol = response.data[0].symbol;

                getTypeOfRevenue(response.data[0].typeOfInvoiceId);
            }, function(error){ //ERROR
                console.log(error);
            });
        }

        //Change Type of Revenue
        $scope.changeTypeOfRevenue = function(obj) {
            $scope.TypeOfRevenue.selected = obj;
        }

        //Change Invoice Template
        $scope.changeInvoiceTemplate = function(objectSelect) {
            $scope.InvoiceTemplate.selected = objectSelect;
           
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + objectSelect.ID,
            }).then(function(response) {
                var invoiceTemplate = response.data;
                
                if (invoiceTemplate.ID > 0) {
                    $scope.inputSymbol = invoiceTemplate.symbol;
                    getTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                }
            }, function(reason) {
                console.log(reason);
            });
        };

        //GET TypeOfRevenue's Information
        function getTypeOfRevenue(typeOfInvoiceId) {
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId + "&typeOfInvoiceId=" + typeOfInvoiceId
            }).then(function(response) {
                $scope.TypeOfRevenues = response.data;
            }, function(reason) {
                console.log(reason);
            });
        }

        //event onBlur of Price 1 of Description 1
        $scope.calVATAmount1 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount1')[0];
            if (price != undefined) {
                vatAmount.value = $filter('number')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 2 of Description 2
        $scope.calVATAmount2 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount2')[0];
            if (price != undefined) {
                vatAmount.value = $filter('number')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //event onBlur of Price 3 of Description 3
        $scope.calVATAmount3 = function(price, vat, quantity) {
            if (vat == undefined) vat = 0;
            if (quantity == undefined) quantity = 1;
            
            var vatAmount =  angular.element(document).find('#inputVATAmount3')[0];
            if (price != undefined) {
                vatAmount.value = $filter('number')( roundNumber((price * quantity * vat)/100) , 0);
            }
        };

        //Save input data to database
        $scope.save = function() {
            /**
             *  Requirement: 
             *      - MaYTe & CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            // var billNumber = angular.element(document).find('#inputBillNumber')[0];

            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var healthInsuranceCardNumber = angular.element(document).find('#inputHealthInsuranceCardNumber')[0];
            var hospitalizationNumber = angular.element(document).find('#inputHospitalizationNumber')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];
            var typeOfRevenueId = $scope.TypeOfRevenue.selected != undefined ? $scope.TypeOfRevenue.selected.ID : 0;

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];
            var vatAmount1 =  angular.element(document).find('#inputVATAmount1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];
            var vatAmount2 =  angular.element(document).find('#inputVATAmount2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            var vatAmount3 =  angular.element(document).find('#inputVATAmount3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var flag = true;
            
            //check empty customerName
            if ($scope.InvoiceTemplate.selected == undefined) {
                swal({
                    title: "Vui lòng chọn thông tin \"Mẫu hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusInvoiceTemplate');
                });
                flag = false;
                return;
            };

            //check empty customerName
            if (customerName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    customerName.focus();
                });
                flag = false;
                return;
            };

            //check empty medicalCode
            if (medicalCode.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mã y tế\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    medicalCode.focus();
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' && description2.value == '' && price2.value == '' && description3.value == '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description3.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                $scope.IsDisabled = true;
                var amount1 = 0;
                var amountNotVAT1 = 0;
                var amount2 = 0;
                var amountNotVAT2 = 0;
                var amount3 = 0;
                var amountNotVAT3 = 0;
                var totalAmount = 0;
                var totalAmountNotVAT = 0;
                val1 = val1 != '' ? val1 : 0;
                val2 = val2 != '' ? val2 : 0;
                val3 = val3 != '' ? val3 : 0;

                //get TotalAmount and TotalAmountNotVAT from detail 1
                if (description1.value != '') {
                    amountNotVAT1 = amountNotVAT1 + parseInt(quantity1.value!=''?quantity1.value:1) * parseInt(val1);
                    var vatAmount = $filter('replace')(vatAmount1.value, ',', '');
                    amount1 = amountNotVAT1 + parseInt(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 2
                if (description2.value != '') {
                    amountNotVAT2 = amountNotVAT2 + parseInt(quantity2.value!=''?quantity2.value:1) * parseInt(val2);
                    var vatAmount = $filter('replace')(vatAmount2.value, ',', '');
                    amount2 = amountNotVAT2 + parseInt(vatAmount);
                }

                //get TotalAmount and TotalAmountNotVAT from detail 3
                if (description3.value != '') {
                    amountNotVAT3 = amountNotVAT3 + parseInt(quantity3.value!=''?quantity3.value:1) * parseInt(val3);
                    var vatAmount = $filter('replace')(vatAmount3.value, ',', '');
                    amount3 = amountNotVAT3 + parseInt(vatAmount);
                }
                totalAmount = amount1 + amount2 + amount3;
                totalAmountNotVAT = amountNotVAT1 + amountNotVAT2 + amountNotVAT3;

                //Update data
                if (sessionStorage.itemId != 'undefined') {
                    var inputData = {
                        'electronicInvoiceId': sessionStorage.itemId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        'typeOfRevenueId': typeOfRevenueId,
                        'customerName': customerName.value,
                        'companyName': companyName.value,
                        'taxCode': taxCode.value,
                        'medicalCode': medicalCode.value,
                        'healthInsuranceCardNumber': healthInsuranceCardNumber.value,
                        'hospitalizationNumber': hospitalizationNumber.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                        'enterpriseId': sessionStorage.enterpriseId,
                    };
    
                    $http.post(hostName.url + "api/HIS/HIS_ElectricInvoice_Update", inputData)
                    .then(function(response) {
                        
                        var objResult = response.data;

                        //Check License
                        if (objResult.ResultCode != "0") {
                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                        else {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
    
                    }, function(reason) {
                        var objResult = reason.data;

                        swal({
                            title: "Thông báo",
                            text: objResult.Message,
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceApproved";
                        });
                    });
                }
                //Add new data
                else {
                    var inputData = {
                        'enterpriseId': sessionStorage.enterpriseId,
                        'userCreated': user.ID,
                        'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                        'invoiceTemplateId': $scope.InvoiceTemplate.selected.ID,
                        'invoiceTemplateCode': $scope.InvoiceTemplate.selected.invoiceTemplateCode,
                        'symbol': symbol.value,
                        'typeOfRevenueId': typeOfRevenueId,
                        'customerName': customerName.value,
                        'companyName': companyName.value,
                        'taxCode': taxCode.value,
                        'medicalCode': medicalCode.value,
                        'healthInsuranceCardNumber': healthInsuranceCardNumber.value,
                        'hospitalizationNumber': hospitalizationNumber.value,
                        'address': address.value,
                        'description': notes.value,
                        'totalAmountNotVAT': totalAmountNotVAT,
                        'totalAmount': totalAmount,
                    };
    
                    $http.post(hostName.url + "api/HIS/HIS_ElectricInvoice_Create", inputData)
                    .then(function(response) {
                        var objResult = response.data;

                        //Check License
                        if (objResult.ResultCode != "0") {
                            swal({
                                title: "Thông báo",
                                text: objResult.Message,
                                icon: "error",
                                dangerMode:true,
                                button: "Đóng",
                            }).then(function(){
                                $state.reload();
                            });
                        }
                        else {
                            var invoiceId = objResult.Data;
                            sessionStorage.itemId = invoiceId;
                            var flagDetail = true;
        
                            //detail 1
                            if (description1.value != '') {
                                var amountNotVAT = parseInt(quantity1.value!=''?quantity1.value:1) * parseInt(val1);
                                var vatAmount = parseInt($filter('replace')(vatAmount1.value, ',', ''));
                                
                                var data = {
                                    'electronicInvoiceId': invoiceId,
                                    'goodAndServiceName': description1.value,
                                    'unitName': unitName1.value,
                                    'quantity': quantity1.value!=''?quantity1.value:1,
                                    'price': price1.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat1.value!=''?vat1.value:0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
        
                            //detail 2
                            if (description2.value != '') {
                                var amountNotVAT = parseInt(quantity2.value!=''?quantity2.value:1) * parseInt(val2);
                                var vatAmount = parseInt($filter('replace')(vatAmount2.value, ',', ''));

                                var data = {
                                    'electronicInvoiceId': invoiceId,
                                    'goodAndServiceName': description2.value,
                                    'unitName': unitName2.value,
                                    'quantity': quantity2.value!=''?quantity2.value:1,
                                    'price': price2.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat2.value!=''?vat2.value:0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
        
                            //detail 3
                            if (description3.value != '') {
                                var amountNotVAT = parseInt(quantity3.value!=''?quantity3.value:1) * parseInt(val3);
                                var vatAmount = parseInt($filter('replace')(vatAmount3.value, ',', ''));

                                var data = {
                                    'electronicInvoiceId': invoiceId,
                                    'goodAndServiceName': description3.value,
                                    'unitName': unitName3.value,
                                    'quantity': quantity3.value!=''?quantity3.value:1,
                                    'price': price3.value,
                                    'amountNotVAT': amountNotVAT,
                                    'VAT': vat3.value!=''?vat3.value:0,
                                    'VATAmount': vatAmount,
                                    'amount': amountNotVAT + vatAmount,
                                    'enterpriseId': sessionStorage.enterpriseId
                                };
                                $http.post(hostName.url + "api/ElectronicInvoiceDetail/AddElectricInvoiceDetail", data)
                                    .then(function(success){}, function(error){
                                        flagDetail = false;
                                        console.log(error);
                                    });
                            };
                            
                            if (flagDetail == true) {
                                swal({
                                    title: "Thông báo",
                                    text: "Lưu dữ liệu thành công!",
                                    icon: "success",
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                            else {
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            }
                        }
                    }, function(reason) {
                        var objResult = reason.data;

                        swal({
                            title: "Thông báo",
                            text: objResult.Message,
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceApproved";
                        });
                    });
                }
            }
        };

        //publish Invoice
        $scope.publishInvoice = function() {
            $scope.IsDisabled = true;
            var itemId = sessionStorage.itemId.toString();
            $http({
                method: 'POST',
                url: hostName.url + "api/HIS/HIS_PublishInvoice?electronicInvoiceId=" + itemId + "&Username=" + user.Username + "&enterpriseId=" + sessionStorage.enterpriseId,
            }).success(function (data) {
                //console.log(data);
                swal("Hóa đơn đã xuất thành công!", {
                    icon: "success",
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/invoiceApproved";
                });
            }).error(function (message) {
                console.log(message);
                swal("Không thể xuất được hóa đơn, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng"
                }).then(function(){
                    location.href = "#/invoiceApproved";
                });
            });
        }
        
    };
    /******End controller for Create Invoice******/

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 08.01.2019
 */
(function () {
    'use strict';

    //declare controller for Edit InvoiceQueue
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('EditInvoiceQueuePageCtrl', EditInvoiceQueuePageCtrl);

    /******************************************/
    /*******controller for Edit InvoiceQueue*******/
    /******************************************/
    function EditInvoiceQueuePageCtrl($scope, $http, hostName, $filter) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        //load data from Database via API with itemId
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();

            //call API to get data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/SalesVoucher/GetSalesVoucher_ByID?UserID=" + user.Username + "&SalesVoucherID=" + itemId,
            }).then(function(response) {
                $scope.SalesVoucher = response.data;
                
                if ($scope.SalesVoucher != undefined) {
                    //put ElectricInvoice's data into Form's controls
                    $scope.inputSalesVoucherID = $scope.SalesVoucher.VoucherNum;
                    $scope.inputTotalAmount = $filter('currency')($scope.SalesVoucher.TotalAmount, '', 0);
                    $scope.inputCompanyName = $scope.SalesVoucher.VATObjectName;
                    $scope.inputCustomerName = $scope.SalesVoucher.CustomerName;
                    $scope.inputTaxCode = $scope.SalesVoucher.VATNo;
                    $scope.inputAddress = $scope.SalesVoucher.VATObjectAddress;
                    vm.TotalAmount = $scope.SalesVoucher.TotalAmount;
                }
            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        };

        $scope.endPrice1 = function(price) {
            var price1 = angular.element(document).find('#inputPrice1')[0];
            if (price != undefined)
                price1.value = $filter('number')(price, 0);
        };

        $scope.endPrice2 = function(price) {
            var price2 = angular.element(document).find('#inputPrice2')[0];
            if (price != undefined)
                price2.value = $filter('number')(price, 0);
        };

        $scope.endPrice3 = function(price) {
            var price3 = angular.element(document).find('#inputPrice3')[0];
            if (price != undefined)
                price3.value = $filter('number')(price, 0);
        };

        $scope.save = function() {
            /**
             *  Requirement: 
             *      - TaxCode & CompanyName & Address
             *      - Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
             **/
            //general information of Electric Invoice
            var dateOfInvoice = angular.element(document).find('#inputDateOfInvoice')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var address = angular.element(document).find('#inputAddress')[0];
            var notes = angular.element(document).find('#inputNotes')[0];
            var pendingId = sessionStorage.pendingId != 'undefined' ? sessionStorage.pendingId : 0;

            //detail 1
            var description1 = angular.element(document).find('#inputDescription1')[0];
            var price1 = angular.element(document).find('#inputPrice1')[0];
            var unitName1 = angular.element(document).find('#inputUnitName1')[0];
            var quantity1 = angular.element(document).find('#inputQuantity1')[0];
            var vat1 = angular.element(document).find('#inputVAT1')[0];

            //detail 2
            var description2 = angular.element(document).find('#inputDescription2')[0];
            var price2 = angular.element(document).find('#inputPrice2')[0];
            var unitName2 = angular.element(document).find('#inputUnitName2')[0];
            var quantity2 = angular.element(document).find('#inputQuantity2')[0];
            var vat2 = angular.element(document).find('#inputVAT2')[0];

            //detail 3
            var description3 = angular.element(document).find('#inputDescription3')[0];
            var price3 = angular.element(document).find('#inputPrice3')[0];
            var unitName3 = angular.element(document).find('#inputUnitName3')[0];
            var quantity3 = angular.element(document).find('#inputQuantity3')[0];
            var vat3 = angular.element(document).find('#inputVAT3')[0];
            
            var val1 = $filter('replace')(price1.value, ',', '');
            var val2 = $filter('replace')(price2.value, ',', '');
            var val3 = $filter('replace')(price3.value, ',', '');
            var flag = true;
            var amount = parseInt(val1!=''?val1:0) + parseInt(val2!=''?val2:0) + parseInt(val3!=''?val3:0);
            
            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mã số thuế\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    taxCode.focus();
                });
                flag = false;
                return;
            };

            //check empty companyName
            if (companyName.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khách hàng\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    companyName.focus();
                });
                flag = false;
                return;
            };

            //check empty address
            if (address.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    address.focus();
                });
                flag = false;
                return;
            };

            //check empty details of invoice
            if (description1.value == '' && price1.value == '' && description2.value == '' && price2.value == '' && description3.value == '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 1
            if (description1.value != '' && price1.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price1.focus();
                });
                flag = false;
                return;
            };

            //check empty description 1
            if (description1.value == '' && price1.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 1\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description1.focus();
                });
                flag = false;
                return;
            };

            //check empty price 2
            if (description2.value != '' && price2.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price2.focus();
                });
                flag = false;
                return;
            };

            //check empty description 2
            if (description2.value == '' && price2.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 2\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description2.focus();
                });
                flag = false;
                return;
            };

            //check empty price 3
            if (description3.value != '' && price3.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đơn giá 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price3.focus();
                });
                flag = false;
                return;
            };

            //check empty description 3
            if (description3.value == '' && price3.value != '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Diễn giải 3\"",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    description3.focus();
                });
                flag = false;
                return;
            };

            //check Amount can not greater than Total Amount
            if (amount > vm.TotalAmount) {
                swal({
                    title: "Số tiền chi tiết không thể lớn hơn Tổng số tiền của phiếu xuất!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    price1.focus();
                });
                flag = false;
                return;
            };

            //if all ok then save data to database
            if (flag == true) {
                var inputData = {
                    'SalesVoucherID': sessionStorage.itemId,
                    'enterpriseId': sessionStorage.enterpriseId,
                    'userCreated': user.ID,
                    'dateOfInvoice': reConvertJSONDate(dateOfInvoice.value),
                    'customerName': customerName.value,
                    'companyName': companyName.value,
                    'taxCode': taxCode.value,
                    'address': address.value,
                    'description': notes.value,
                    'amount': amount,
                    'pendingId': pendingId,
                };

                $http.post(hostName.url + "api/SalesVoucher/FTCAddElectricInvoice_Divide", inputData)
                .then(function(response) {
                    var invoiceId = response.data;
                    var flagDetail = true;

                    //detail 1
                    if (description1.value != '') {
                        var amountNotVAT = parseInt(quantity1.value!=''?quantity1.value:1) * parseInt(val1);
                        var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat1.value!=''?vat1.value:0))/100);
                        var data = {
                            'electricInvoiceId': invoiceId,
                            'goodAndServiceName': description1.value,
                            'unitName': unitName1.value,
                            'quantity': quantity1.value!=''?quantity1.value:1,
                            'price': price1.value,
                            'amountNotVAT': amountNotVAT,
                            'VAT': vat1.value!=''?vat1.value:0,
                            'amountVAT': amountVAT,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                            .then(function(success){}, function(error){
                                flagDetail = false;
                                console.log(error);
                            });
                    };

                    //detail 2
                    if (description2.value != '') {
                        var amountNotVAT = parseInt(quantity2.value!=''?quantity2.value:1) * parseInt(val2);
                        var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat2.value!=''?vat2.value:0))/100);
                        var data = {
                            'electricInvoiceId': invoiceId,
                            'goodAndServiceName': description2.value,
                            'unitName': unitName2.value,
                            'quantity': quantity2.value!=''?quantity2.value:1,
                            'price': price2.value,
                            'amountNotVAT': amountNotVAT,
                            'VAT': vat2.value!=''?vat2.value:0,
                            'amountVAT': amountVAT,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                            .then(function(success){}, function(error){
                                flagDetail = false;
                                console.log(error);
                            });
                    };

                    //detail 3
                    if (description3.value != '') {
                        var amountNotVAT = parseInt(quantity3.value!=''?quantity3.value:1) * parseInt(val3);
                        var amountVAT = amountNotVAT + ((amountNotVAT * parseInt(vat3.value!=''?vat3.value:0))/100);
                        var data = {
                            'electricInvoiceId': invoiceId,
                            'goodAndServiceName': description3.value,
                            'unitName': unitName3.value,
                            'quantity': quantity3.value!=''?quantity3.value:1,
                            'price': price3.value,
                            'amountNotVAT': amountNotVAT,
                            'VAT': vat3.value!=''?vat3.value:0,
                            'amountVAT': amountVAT,
                            'enterpriseId': sessionStorage.enterpriseId
                        };
                        $http.post(hostName.url + "api/ElectricInvoiceDetail/AddElectricInvoiceDetail", data)
                            .then(function(success){}, function(error){
                                flagDetail = false;
                                console.log(error);
                            });
                    };
                    
                    if (flagDetail == true) {
                        swal({
                            title: "Thông báo",
                            text: "Lưu dữ liệu thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function(){
                            sessionStorage.pendingId = undefined;
                            location.href = "#/invoiceQueue";
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/invoiceQueue";
                        });
                    }

                }, function(reason) {
                    console.log(reason);
                    swal({
                        title: "Thông báo",
                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        location.href = "#/invoiceQueue";
                    });
                });
            }
        };
        
    };
    /******End controller for Edit InvoiceQueue******/

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 07.11.2018
 */
(function () {
    'use strict';

    //declare controller for InvoiceQueue
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('InvoiceQueuePageCtrl', InvoiceQueuePageCtrl);

    /******************************************/
    /*******controller for InvoiceQueue List*******/
    /******************************************/
    function InvoiceQueuePageCtrl($scope, $http, $state, hostName, $location, layoutPaths, $uibModal) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.inputDateOfInvoice = new Date();

        //call API success
        function successCallBack(response) {
            //vm.rowCollection = response.data;
            console.log(response.data);

            // for (n=0; n < vm.rowCollection.length; n++) {
            //     vm.rowCollection[n].No = n+1;
            // }

            //display message into Console
            //console.log(vm.rowCollection);
        };

        //call API error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        // //call API to get data
        // var queryString = "UserID=" + user.Username;
        // $http({
        //     method: "GET",
        //     url: hostName.url + "api/SalesVoucher/GetSalesVoucher_List?" + queryString
        // }).then(successCallBack, errorCallBack);

        //redirect to other pages
        $scope.open = function(url, id) {
            sessionStorage.itemId = id;
            location.href = url;
        };

        //create new Invoice
        $scope.createInvoice = function() {
            location.href = '#/createInvoice';
        }

        //find data
        $scope.findData = function() {
            // var voucherNum = angular.element(document).find('#inputVoucherNum')[0];
            // var taxCode = angular.element(document).find('#inputTaxCode')[0];
            // var customerName = angular.element(document).find('#inputCustomerName')[0];
            // var queryString = "VoucherNum=" + voucherNum.value + "&VATNo=" + taxCode.value + "&VATObjectName=" + customerName.value;

            // $http({
            //     method: "GET",
            //     url: hostName.url + "api/SalesVoucher/SearchSalesVoucher?" + queryString,
            // }).then(successCallBack, errorCallBack);

            $http({
                method: "GET",
                url: hostName.url + "api/HIS/GetThongTinBenhNhan?MaBenhNhan=2&Username=" + user.Username,
            }).then(successCallBack, errorCallBack);
        };
        
    };
    /******End controller for InvoiceQueue List******/

})();

/**
 * @author Nguyen Huu Tuan
 * created on 30.11.2018
 */
(function () {
    'use strict';

    //declare controller for InvoiceRePublic
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('InvoiceRePublicPageCtrl', InvoiceRePublicPageCtrl);

    /******************************************/
    /*******controller for InvoiceRePublic List*******/
    /******************************************/
    function InvoiceRePublicPageCtrl($scope, $http, $state, hostName, $location, layoutPaths, $uibModal) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        
        //function then call WEB API get HIS's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n < vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
            }

            //display message into Console
            //console.log(vm.rowCollection);
        };

        //function then call  WEB API get HIS's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call  WEB API to get HIS Master's data
        var queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&typeOfData=RePublic";
        $http({
            method: "GET",
            url: hostName.url + "api/HIS/GetAllHISMaster?" + queryString
        }).then(successCallBack, errorCallBack);

        //View Invoice Detail
        $scope.viewDetail = function(page, size, REF_ID) {
            //call Webservice to get HIS Detail's data
            $http({
                method: "GET",
                url: hostName.url + "api/HIS/GetAllHISDetail?REF_ID=" + REF_ID
            }).then(function(response){
                vm.detail = response.data;
                //console.log(vm.detail);

                $uibModal.open({
                    animation: true,
                    templateUrl: page,
                    size: size,
                    controller: ['detail', ViewDetailModalCtrl],
                    controllerAs: 'vm',
                    resolve: {
                        detail: function () {
                            return vm.detail;
                        }
                    }
                });
            }, function(error){
                console.log(error);
            });
        };

        //find data
        $scope.findData = function() {
            var customerCode = angular.element(document).find('#inputCustomerCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseName = angular.element(document).find('#inputEnterpriseName')[0];
            var queryString = "MaKhachHang=" + customerCode.value + "&TenKhachHang=" + customerName.value + "&TenDonVi=" + enterpriseName.value + "&enterpriseId=" + sessionStorage.enterpriseId + "&typeOfData=RePublic";

            $http({
                method: "GET",
                url: hostName.url + "api/HIS/SearchHISMaster?" + queryString,
            }).then(successCallBack, errorCallBack);
        };

        $scope.publicInvoice = function(REF_ID) {

            function successCallBack(data) {
                var invoiceId = data.data;

                //public Invoice
                $http({
                    method: 'GET',
                    url: hostName.url + "api/ElectricInvoice/UpdateElectricInvoicePublish?ID=" + invoiceId + "&userUpdated=" + user.ID,
                }).success(function (data, status, headers) {
                    //console.log(data);
                    var pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';
                    var urlDownload = pathTemp + data;
                    
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({ 
                            'file': urlDownload,
                            'urlUpload': hostName.url + "api/ElectricInvoice/UploadFileToServer",
                            'id': invoiceId
                        })
                    };
                    
                    $http(req).then(function(response){
                        swal("Hóa đơn đã xuất thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(error) {
                        var inputData = {
                            'ID': invoiceId,
                            'statusCode': 'SIGNERROR'
                        };
                        $http.post(hostName.url + "api/ElectricInvoice/UpdateElectricInvoiceStatus", inputData).then(function(data){
                            swal("Ký số lỗi, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {});
                        console.log(error);
                    });
                }).error(function (message) {
                    console.log(message);
                });
                
                //console.log(data);
            }
    
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    $state.reload();
                });
                console.log(data);
            }

            if (REF_ID == "") {
                swal("Vui lòng chọn thông tin để xuất hóa đơn!", {
                    icon: "warning",
                    button: "Đóng"
                }).then();
            }
            else {
                var queryString = "REF_ID=" + REF_ID + "&enterpriseId=" + sessionStorage.enterpriseId + "&userCreated=" + user.ID;

                $http.post(hostName.url + "api/HIS/AddElectricInvoiceHIS_RePublic?" + queryString)
                    .then(successCallBack, errorCallBack);
            }
        };
    };
    /******End controller for InvoiceRePublic List******/

    //view detail for Receipt
    function ViewDetailModalCtrl(detail) {
        var vm = this;
        
        vm.detail = detail;
    }

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
        return "";
        else return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.12.2018
 */
(function () {
    'use strict';

    //declare controller for InvoiceWait4Approve
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('InvoiceWait4ApprovePageCtrl', InvoiceWait4ApprovePageCtrl);

    /******************************************/
    /*******controller for InvoiceWait4Approve List*******/
    /******************************************/
    function InvoiceWait4ApprovePageCtrl($scope, $http, $state, hostName, $location, layoutPaths, $uibModal) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        sessionStorage.pendingId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathSigned = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'signed/';
        $scope.pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';

        //function then call  WEB API get ElectricInvoice's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);
            
                //file Invoice
                if (vm.rowCollection[n].fileInvoice != '')
                    vm.rowCollection[n].fileInvoice = $scope.pathTemp + vm.rowCollection[n].fileInvoice;
            }

            //display message into Console
            //console.log(response.data);
        };

        //function then call WEB API get ElectricInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectricInvoice's data
        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/GetAllElectricInvoice?enterpriseId=" + sessionStorage.enterpriseId + "&statusCode=NOTPUBLISH"
        }).then(successCallBack, errorCallBack);

        //save data to local variable when change Select's control
        $scope.selectChanged = function(objectSelect) {
            $scope.InvoiceTemplate = objectSelect;
        }

        //filter ElectricInvoice's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var companyName = angular.element(document).find('#inputCompanyName')[0];
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var symbol = angular.element(document).find('#inputSymbol')[0];
            
            var queryString = "";

            if (fromDate != undefined) {
                var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
                var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&billNumber=" + billNumber.value + "&symbol=" + symbol.value + "&companyName=" + companyName.value + "&statusCode=NOTPUBLISH";
                //console.log(queryString);
            }
            else {
                var date = new Date();
                var nowYear = date.getFullYear();
                var nowMonth = date.getMonth();
                queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&billNumber=&symbol=&companyName=" + "&statusCode=NOTPUBLISH";
                //console.log(queryString);
            }
            
            //call Webservice to get ElectricInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ElectricInvoice/SearchElectricInvoice_FTC?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectricInvoice's data

        //View Invoice Detail
        $scope.viewDetail = function(page, size, REF_ID, SalesVoucherID) {
            //call API to get data
            //console.log(REF_ID);
            $http({
                method: "GET",
                url: hostName.url + "api/SalesVoucher/GetSalesVoucher_Detail?SalesVoucherID=" + SalesVoucherID + "&electricInvoiceId=" + REF_ID
            }).then(function(response){
                vm.detail = response.data;
                //console.log(vm.detail);

                $uibModal.open({
                    animation: true,
                    templateUrl: page,
                    size: size,
                    controller: ['detail', ViewDetailModalCtrl],
                    controllerAs: 'vm',
                    resolve: {
                        detail: function () {
                            return vm.detail;
                        }
                    }
                });
            }, function(error){
                console.log(error);
            });
        };

        //export SalesVoucher Book
        $scope.exportInvoiceBook = function(SalesVoucherID) {
            $http({
                method: 'POST',
                url: hostName.url + "api/SalesVoucher/PublishSalesVoucher_Book?SalesVoucherID=" + SalesVoucherID,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BangKeKemHoaDon.xlsx"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        }

        //Approve Invoice
        $scope.approveInvoice = function() {
            //$scope.Invoices = [];
            var REF_ID = "";

            for (n=0; n<vm.rowCollection.length; n++) {
                var checkboxInvoice = angular.element(document).find("#checkInvoice" + vm.rowCollection[n].ID)[0];
                //console.log(checkboxInvoice.checked);
                if (checkboxInvoice != undefined) {
                    if (checkboxInvoice.checked == true) {
                        REF_ID = REF_ID + vm.rowCollection[n].ID + "|";
                        //$scope.inserted = {ID: vm.rowCollection[n].ID};
                        //$scope.Invoices.push($scope.inserted);
                    }
                }
            }

            if (REF_ID == 0) {
                swal("Vui lòng chọn thông tin để duyệt hóa đơn!", {
                    icon: "warning",
                    button: "Đóng"
                }).then();
            }
            else {
                $http({
                    method: 'GET',
                    url: hostName.url + "api/ElectricInvoice/UpdateElectricInvoicePublish?ID=" + REF_ID + "&userUpdated=" + user.ID + "&statusCode=PUBLISHED",
                }).success(function (data, status, headers) {
                    //console.log(data);
                    var pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';
                    var fileList = data;
                    //var invoideId, fileName;

                    //console.log(invoideId + ":" + fileName);
                    //var urlDownload = pathTemp + fileName;
                    var req = {
                        method: 'POST',
                        url: 'http://localhost:7001/PdfSignService/SignInvoice',
                        headers: {
                            'Content-Type': "application/json"
                        },
                        data: JSON.stringify({ 
                            'file': fileList,
                            'urlDownload':  pathTemp,
                            'urlUpload': hostName.url + "api/ElectricInvoice/UploadFileToServer",
                            'id': REF_ID
                        })
                    };
                    
                    $http(req).then(function() {
                        swal({
                            title: "Thông báo",
                            text: "Lưu dữ liệu thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            $state.reload();
                        });
                        console.log(error);
                    });

                    // while (REF_ID.length > 0) {
                    //     invoideId = REF_ID.substr(0, REF_ID.indexOf('|'));
                    //     fileName = fileList.substr(0, fileList.indexOf('|'));

                        

                    //     fileList = fileList.substr(fileList.indexOf("|") + 1, fileList.length);
                    //     REF_ID = REF_ID.substr(REF_ID.indexOf("|") + 1, REF_ID.length);
                    // }
                });

                // function doJob(invoiceId) {
                //     //console.log(invoiceId);
                //     $http({
                //         method: 'GET',
                //         url: hostName.url + "api/ElectricInvoice/UpdateElectricInvoicePublish?ID=" + invoiceId + "&userUpdated=" + user.ID,
                //     }).success(function (data, status, headers) {
                //         //console.log(data);
                //         // var pathTemp = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + layoutPaths.images.template + 'temp/';
                //         // var urlDownload = pathTemp + data;
                        
                //         // var req = {
                //         //     method: 'POST',
                //         //     url: 'http://localhost:7001/PdfSignService/SignInvoice',
                //         //     headers: {
                //         //         'Content-Type': "application/json"
                //         //     },
                //         //     data: JSON.stringify({ 
                //         //         'file': urlDownload,
                //         //         'urlUpload': hostName.url + "api/ElectricInvoice/UploadFileToServer",
                //         //         'id': invoiceId
                //         //     })
                //         // };
                        
                //         // $http(req).then(function() {}, function(error) {
                //         //     console.log(error);
                //         // });
                        
                //     }).error(function (message) {
                //         console.log(message);
                //     });
                //}

                // var p = Promise.resolve(true);
                // var stopCount = 0;
                // var p = Promise.resolve(true);
                // var invoiceId;
                // for(var i = 0; i < $scope.Invoices.length; i++) {
                //     invoiceId = $scope.Invoices[i].ID;
                //     (function(idx) { //We need to wrap it or we will pass incorrect i into doJob
                //         p = p.then(function() {
                //             return doJob(idx);
                //         });
                //     })(invoiceId);
                // }

                //for(i = 0; i < $scope.Invoices.length; i++) {
                    // (function(idx) { //We need to wrap it or we will pass incorrect i into doJob
                    //     p = p.then(function() {
                    //         return doJob(idx);
                    //     });
                    // })($scope.Invoices[i].ID);
                //}
                //p.then(function() {
                    // if ($scope.Invoices.length == i) {
                    //     swal({
                    //         title: "Thông báo",
                    //         text: "Lưu dữ liệu thành công!",
                    //         icon: "success",
                    //         button: "Đóng",
                    //     }).then(function(){
                    //         $state.reload();
                    //     });
                    // }
                    // else {
                    //     swal({
                    //         title: "Thông báo",
                    //         text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    //         icon: "error",
                    //         dangerMode:true,
                    //         button: "Đóng",
                    //     }).then(function(){
                    //         $state.reload();
                    //     });
                    // }
                //});
                
                // angular.forEach( $scope.Invoices, function(invoice) {
                //     //Publish Invoice
                //     var invoiceId = invoice.ID;
                    
                //     //$interval( function(){ $scope.callService(); }, 3000, true);
                // });
            }
        }
        
    };
    /******End controller for InvoiceWait4Approve List******/

    function ViewDetailModalCtrl(detail) {
        var vm = this;
        
        vm.detail = detail;
    }
    
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
        return "";
        else return date;
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for Category
    angular.module('BlurAdmin.pages.lists')
      .controller('CategoryPageCtrl', CategoryPageCtrl);

    //******controller for Category******
    function CategoryPageCtrl($scope, $http, $state, hostName) {

      $scope.smartTablePageSize = 10;
      var n = 0;
      var vm = this;
      vm.rowCollection = [];
      sessionStorage.itemId = undefined;
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //function then call Webservice get Categories's data is success
      function successCallBack(response) {
        vm.rowCollection = response.data;

        for (n=0; n < vm.rowCollection.length; n++) {
          // Encrypt
          vm.rowCollection[n].No = n+1;
          vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
          //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
        }

        //display message into Console
        //console.log(response);
      };

      //function then call Webservice get Categories's data is error
      function errorCallBack(reason) {
        $scope.error = reason.data;

        //display message into Console
        console.log(reason);
      }

      //call Webservice to get Categories's data
      $http({
        method: "GET",
        url: hostName.url + "api/Category/GetAllCategory?enterpriseId=" + sessionStorage.enterpriseId
      }).then(successCallBack, errorCallBack);

      //check True/False for isActive chechbox
      $scope.checkShow = function(dataCheck){
        if (dataCheck) {
          return 1;
        }
        else {
          return 0;
        }
      };
      
      //redirect to other pages
      $scope.open = function(url, id) {
        location.href = url;
        sessionStorage.itemId = id;
      };

      //filter Categories's data
      $scope.findData = function() {
        vm.rowCollection = [];
        var fromDate = angular.element(document).find('#inputFromDate')[0];
        var toDate = angular.element(document).find('#inputToDate')[0];
        var categoryId = angular.element(document).find('#inputCategoryId')[0];
        var categoryName = angular.element(document).find('#inputCategoryName')[0];
        var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
        var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
        var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
        //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
        if (isActiveAll.checked == true) {
          isActive = "";
        }
        else if (isActiveTrue.checked == true) {
          isActive = true;
        }
        else {
          isActive = false;
        }
        var queryString = "";

        if (fromDate != undefined) {
          var dateFrom = reConvertJSONDate(fromDate.value);
          var dateTo = reConvertJSONDate(toDate.value);
          
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&categoryId=" + categoryId.value + "&categoryName=" + categoryName.value + "&isActive=" + isActive;
        }
        else {
          var date = new Date();
          var nowYear = date.getFullYear();
          var nowMonth = date.getMonth();
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&categoryId=&categoryName=&isActive=";
        }
         
        //call Webservice to get Categories's data
        $http({
          method: "GET",
          url: hostName.url + "api/Category/SearchCategory?" + queryString,
        }).then(successCallBack, errorCallBack);
      }
      //end filter Categories's data

      //update Status of Category
      $scope.updateStatus = function(flag, itemId) {
        if (flag == true) {
          //Stop
          swal({
            title: "Bạn muốn kích hoạt thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete) {
            if (willDelete) {
              var categoryData = {
                'ID': itemId,
                'isActive': true,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Category/UpdateCategoryStatus", categoryData).then(function(data){
                swal("Kích hoạt thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
        else {
          //Active
          swal({
            title: "Bạn muốn ngừng sử dụng thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var categoryData = {
                'ID': itemId,
                'isActive': false,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Category/UpdateCategoryStatus", categoryData).then(function(data){
                swal("Ngừng sử dụng thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
      }

    };
    //******End controller for Categories******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for Category
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateCategoryPageCtrl', UpdateCategoryPageCtrl);

    /******************************************/
    /******controller for Update Categories******/
    /******************************************/
    function UpdateCategoryPageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin loại hàng hóa";
      $scope.checkStatus = 'Y';
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load Categories's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin loại hàng hóa";

        //call Webservice to get Category's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/Category/GetCategory/" + itemId,
        }).then(function(response) {
          $scope.Category = [];
          $scope.Category = response.data;
          console.log($scope.Category);
          
          if ($scope.Category != undefined) {
            //put Category's data into Form's controls
            $scope.inputCategoryId = $scope.Category.categoryId;
            $scope.inputCategoryName = $scope.Category.categoryName;
            $scope.inputDescription = $scope.Category.description;
            $scope.checkStatus = $scope.Category.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }

      //save Categories's data into Database via Webservice
      $scope.save = function () {

        var categoryId = angular.element(document).find('#inputCategoryId')[0];
        var categoryName = angular.element(document).find('#inputCategoryName')[0];
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var flag = true;

        //check empty categoryId
        if (categoryId.value == '') {
          swal({
            title: "Thông tin Mã loại hàng hóa",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            categoryId.focus();
          });
          flag = false;
          return;
        }

        //check maxlength of categoryId
        if (categoryId.value.length > 5) {
          swal({
            title: "Thông tin Mã loại hàng hóa",
            text: 'không được quá 5 ký tự!',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            categoryId.focus();
          });
          flag = false;
          return;
        }

        //check empty categoryName
        if (categoryName.value == '') {
          swal({
            title: "Thông tin Tên loại hàng hóa",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            categoryName.focus();
          });
          flag = false;
          return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/category";
          });
          console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/category";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update Category's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var categoryData = {
              'ID': sessionStorage.itemId,
              'categoryId': categoryId.value, 
              'categoryName': categoryName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/Category/UpdateCategory", categoryData)
            .then(successCallBack, errorCallBack);
          }
          //Add new Category's data
          else {
            var categoryData = {
              'categoryId': categoryId.value, 
              'categoryName': categoryName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/Category/AddCategory", categoryData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save Categories's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update Categories******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for CurrencyOfPayment
  angular.module('BlurAdmin.pages.lists')
    .controller('CurrencyOfPaymentPageCtrl', CurrencyOfPaymentPageCtrl);

  //******controller for CurrencyOfPayment******
  function CurrencyOfPaymentPageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //function then call Webservice get CurrencyOfPayment's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get CurrencyOfPayment's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get CurrencyOfPayment's data
    $http({
      method: "GET",
      url: hostName.url + "api/CurrencyOfPayment/GetAllCurrencyOfPayment?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };
    
    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter CurrencyOfPayment's data
    $scope.findData = function() {
      vm.rowCollection = [];
      var fromDate = angular.element(document).find('#inputFromDate')[0];
      var toDate = angular.element(document).find('#inputToDate')[0];
      var currencyOfPaymentId = angular.element(document).find('#inputCurrencyOfPaymentId')[0];
      var currencyOfPaymentName = angular.element(document).find('#inputCurrencyOfPaymentName')[0];
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";

      if (fromDate != undefined) {
        var dateFrom = reConvertJSONDate(fromDate.value);
        var dateTo = reConvertJSONDate(toDate.value);
        
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&currencyOfPaymentId=" + currencyOfPaymentId.value + "&currencyOfPaymentName=" + currencyOfPaymentName.value + "&isActive=" + isActive;
      }
      else {
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&currencyOfPaymentId=&currencyOfPaymentName=&isActive=";
      }
       
      //call Webservice to get CurrencyOfPayment's data
      $http({
        method: "GET",
        url: hostName.url + "api/CurrencyOfPayment/SearchCurrencyOfPayment?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter CurrencyOfPayment's data

    //update Status of CurrencyOfPayment
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/CurrencyOfPayment/UpdateCurrencyOfPaymentStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/CurrencyOfPayment/UpdateCurrencyOfPaymentStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for CurrencyOfPayment******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for CurrencyOfPayment
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateCurrencyOfPaymentPageCtrl', UpdateCurrencyOfPaymentPageCtrl);

    /******************************************/
    /******controller for Update CurrencyOfPayment******/
    /******************************************/
    function UpdateCurrencyOfPaymentPageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin tiền thanh toán";
      $scope.checkStatus = 'Y';
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load CurrencyOfPayment's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin tiền thanh toán";

        //call Webservice to get CurrencyOfPayment's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/CurrencyOfPayment/GetCurrencyOfPayment/" + itemId,
        }).then(function(response) {
          $scope.CurrencyOfPayment = [];
          $scope.CurrencyOfPayment = response.data;
          //console.log($scope.CurrencyOfPayment);
          
          if ($scope.CurrencyOfPayment != undefined) {
            //put CurrencyOfPayment's data into Form's controls
            $scope.inputCurrencyOfPaymentId = $scope.CurrencyOfPayment.currencyOfPaymentId;
            $scope.inputCurrencyOfPaymentName = $scope.CurrencyOfPayment.currencyOfPaymentName;
            $scope.inputExchangeRate = $scope.CurrencyOfPayment.exchangeRate;
            $scope.inputDescription = $scope.CurrencyOfPayment.description;
            $scope.checkStatus = $scope.CurrencyOfPayment.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }

      //save CurrencyOfPayment's data into Database via Webservice
      $scope.save = function () {

        var currencyOfPaymentId = angular.element(document).find('#inputCurrencyOfPaymentId')[0];
        var currencyOfPaymentName = angular.element(document).find('#inputCurrencyOfPaymentName')[0];
        var exchangeRate = angular.element(document).find('#inputExchangeRate')[0];
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var flag = true;

        //check empty currencyOfPaymentId
        if (currencyOfPaymentId.value == '') {
          swal({
            title: "Thông tin Mã tiền thanh toán",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            currencyOfPaymentId.focus();
          });
          flag = false;
          return;
        }

        //check empty currencyOfPaymentName
        if (currencyOfPaymentName.value == '') {
          swal({
            title: "Thông tin Tên tiền thanh toán",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            currencyOfPaymentName.focus();
          });
          flag = false;
          return;
        }

        //check empty exchangeRate
        if (exchangeRate.value == '') {
            swal({
                title: "Thông tin Tỷ lệ hối đoái với VND",
                text: "không được để trống!",
                icon: "warning",
                button: "Đóng"
            }).then(function(){
                exchangeRate.focus();
            });
            flag = false;
            return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/currencyOfPayment";
          });
          console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/currencyOfPayment";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update CurrencyOfPayment's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var inputDate = {
              'ID': sessionStorage.itemId,
              'currencyOfPaymentId': currencyOfPaymentId.value, 
              'currencyOfPaymentName': currencyOfPaymentName.value, 
              'exchangeRate': exchangeRate.value,
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/CurrencyOfPayment/UpdateCurrencyOfPayment", inputDate)
            .then(successCallBack, errorCallBack);
          }
          //Add new CurrencyOfPayment's data
          else {
            var inputData = {
                'currencyOfPaymentId': currencyOfPaymentId.value, 
                'currencyOfPaymentName': currencyOfPaymentName.value, 
                'exchangeRate': exchangeRate.value,
                'description': description.value, 
                'isActive': isActive.checked,
                'enterpriseId': sessionStorage.enterpriseId,
                'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/CurrencyOfPayment/AddCurrencyOfPayment", inputData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save CurrencyOfPayment's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update CurrencyOfPayment******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 27.08.2018
 */
(function () {
  'use strict';

  //declare controller for Customer
  angular.module('BlurAdmin.pages.lists')
    .controller('CustomerPageCtrl', CustomerPageCtrl);

  /******************************************/
  /*******controller for Customer List*******/
  /******************************************/
  function CustomerPageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    //$scope.Customers = [];
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //CHECK ADMIN PERMISSION
    $scope.isShow = false;
    var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
    if (userRole != undefined) {
      for (var ur = 0; ur < userRole.length; ur++) {
        if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
          $scope.isShow = true;
      };
    }

    //function then call Webservice get customer's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n = 0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n + 1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].customerId, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get customer's data is error
    function errorCallBack(reason) {
      //display message into Console
      console.log(reason);
    }

    //call Webservice to get Customer's data
    $http({
      method: "GET",
      url: hostName.url + "api/Customer/GetAllCustomer?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function (dataCheck) {
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };

    //save data to local variable when change Select's control
    $scope.selections = [];
    var selectedValue = "";
    $scope.selectionChanged = function (idx) {
      selectedValue = $scope.selections[idx].cityId;
    };

    //CHANGE ORGANIZATION
    $scope.changeOrganization = function (obj) {
      $scope.Enterprise = obj;
    };
    //#CHANGE ORGANIZATION

    //redirect to other pages
    $scope.open = function (url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter Customer's data
    $scope.findData = function () {
      vm.rowCollection = [];
      // var fromDate = angular.element(document).find('#inputStartDate')[0];
      // var toDate = angular.element(document).find('#inputEndDate')[0];
      var customerName = angular.element(document).find('#inputCustomerName')[0];
      var taxCode = angular.element(document).find('#inputTaxCode')[0];
      var contactPerson = angular.element(document).find('#inputContactPerson')[0];
      var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
      var queryString = "";
      queryString = "enterpriseId=" + enterpriseId + "&customerName=" + customerName.value
        + "&taxCode=" + taxCode.value + "&cityId=" + selectedValue
        + "&contactPerson=" + contactPerson.value;

      // if (fromDate != undefined) {
      //   var dateFrom = reConvertJSONDate(fromDate.value);//fromDate.value;//reConvertJSONDate(fromDate.value);
      //   var dateTo = reConvertJSONDate(toDate.value);//toDate.value;//reConvertJSONDate(toDate.value);

      //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&customerName=" + customerName.value + "&taxCode=" + taxCode.value + "&cityId=" + selectedValue + "&contactPerson=" + contactPerson.value;
      // }
      // else {
      //   var date = new Date();
      //   var nowYear = date.getFullYear();
      //   var nowMonth = date.getMonth();
      //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&customerName=&taxCode=&cityId=&contactPerson=";
      // }

      //call Webservice to get Customer's data
      $http({
        method: "GET",
        url: hostName.url + "api/Customer/SearchCustomer?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter Customer's data

    //update Status of Customer
    $scope.updateStatus = function (flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
          .then(function (willDelete) {
            if (willDelete) {
              var customerData = {
                'ID': itemId,
                'isActive': true,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Customer/UpdateCustomerStatus", customerData).then(function (data) {
                swal("Kích hoạt thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function () {
                  $state.reload();
                });
              }, function (data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
          .then(function (willDelete) {
            if (willDelete) {
              var customerData = {
                'ID': itemId,
                'isActive': false,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Customer/UpdateCustomerStatus", customerData).then(function (data) {
                swal("Ngừng sử dụng thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function () {
                  $state.reload();
                });
              }, function (data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
      }
    }

  };
  /******End controller for Customer List******/

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0, 2);
    var month = strDate.slice(3, 5);
    var year = strDate.slice(6, 10);
    var date = month + '/' + day + '/' + year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 27.08.2018
 */
(function () {
  'use strict';

  //declare controller for Customer
  angular.module('BlurAdmin.pages.lists')
    .controller('UpdateCustomerPageCtrl', UpdateCustomerPageCtrl);

  /******************************************/
  /******controller for Update Customer******/
  /******************************************/
  function UpdateCustomerPageCtrl($scope, $http, $log, hostName) {
    //Set data for Page Title
    $scope.PageTitle = "Tạo mới thông tin khách hàng";
    var user = JSON.parse(localStorage.getItem("dataUser"));
    $scope.Enterprise = [];

    //CHECK ADMIN PERMISSION
    $scope.isShow = false;
    var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
    if (userRole != undefined) {
      for (var ur = 0; ur < userRole.length; ur++) {
        if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
          $scope.isShow = true;
      };
    }

    /******Load City's data******/
    $scope.City = {};
    $scope.Cities = [];
    $scope.checkStatus = 'Y';

    var successCallBack = function (response) {
      $scope.Cities = response.data;
    };

    var errorCallBack = function (reason) {
      console.log(reason);

      if ($scope.Cities.length == 0) {
        $scope.Cities = [
          { cityName: "Hà Nội", cityId: "01" },
          { cityName: "Hồ Chí Minh", cityId: "79" }
        ];
      };
    }
    $http({
      method: "GET",
      url: hostName.url + "api/City/GetAllCity"
    }).then(successCallBack, errorCallBack);
    /******End Load City's data******/

    //load Customer's data from Database via Webservice with itemId
    if (sessionStorage.itemId != 'undefined') {
      // Decrypt
      //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
      //var itemId = bytes.toString(CryptoJS.enc.Utf8);
      var itemId = sessionStorage.itemId.toString();

      //Update Page Title
      $scope.PageTitle = "Cập nhật thông tin khách hàng";

      //call Webservice to get Customer's data by Id
      $http({
        method: "GET",
        url: hostName.url + "api/Customer/GetCustomer/" + itemId,
      }).then(function (response) {
        $scope.Customer = [];
        $scope.Customer = response.data;

        if ($scope.Customer != undefined) {
          //put Customer's data into Form's controls
          $scope.inputCustomerName = $scope.Customer.customerName;
          $scope.inputCustomerCode = $scope.Customer.customerCode;
          $scope.inputTaxCode = $scope.Customer.taxCode;
          $scope.inputContactPerson = $scope.Customer.contactPerson;
          $scope.inputAddress = $scope.Customer.address;
          $scope.City.selected = { cityName: $scope.Customer.cityName, cityId: $scope.Customer.cityId };
          console.log($scope.City.selected);
          $scope.inputPhone = $scope.Customer.phone;
          $scope.inputEmail = $scope.Customer.email;
          $scope.checkStatus = $scope.Customer.isActive == true ? 'Y' : 'N';
          sessionStorage.cityId = $scope.Customer.cityId;

          //GET Enterprise's Information
          $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.Customer.enterpriseId,
          }).then(function (response) {
            var obj = response.data;
            $scope.Enterprise.selected = { ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN };
          }, function (reason) {
            console.log(reason);
          });
        }
      }, function (reason) {
        $scope.error = reason.data;
        $log.info(reason);
      });
    }

    //CHANGE ORGANIZATION
    $scope.changeOrganization = function (obj) {
      $scope.Enterprise.selected = obj;
    };
    //#CHANGE ORGANIZATION

    $scope.selectChanged = function (City) {
      $scope.City.selected = City;
    }

    //save Customer's data into Database via Webservice
    $scope.save = function () {

      var customerName = angular.element(document).find('#inputCustomerName')[0];
      var customerCode = angular.element(document).find('#inputCustomerCode')[0];
      var taxCode = angular.element(document).find('#inputTaxCode')[0];
      // var contactPerson = angular.element(document).find('#inputContactPerson')[0];
      var address = angular.element(document).find('#inputAddress')[0];
      var phone = angular.element(document).find('#inputPhone')[0];
      var email = angular.element(document).find('#inputEmail')[0];
      var isActive = angular.element(document).find('#inputIsActive')[0];
      var cityId = $scope.City.selected == undefined ? "" : $scope.City.selected.cityId;
      var cityName = $scope.City.selected == undefined ? "" : $scope.City.selected.cityName;
      var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
      var flag = true;

      //check empty Enterprise
      if ($scope.isShow && $scope.Enterprise.selected == undefined) {
        swal({
          title: "Thông tin Đơn vị",
          text: 'không được để trống',
          icon: "warning",
          button: "Đóng"
        }).then(function () {
          $scope.$broadcast('SetFocusEnt');
        });
        flag = false;
        return;
      }

      //check empty customerName
      if (customerName.value == '') {
        swal({
          title: "Thông tin Tên khách hàng",
          text: 'không được để trống',
          icon: "warning",
          button: "Đóng"
        }).then(function () {
          customerName.focus();
        });
        flag = false;
        return;
      }

      //check taxCode can not have space ' '
      if (taxCode.value != '' && taxCode.value.indexOf(' ') > -1) {
        swal({
          title: "Thông tin Mã số thuế",
          text: "không được có khoảng trắng!",
          icon: "warning",
          button: "Đóng"
        }).then(function () {
          taxCode.focus();
        });
        flag = false;
        return;
      }

      // //check empty contactPerson
      // if (contactPerson.value == '') {
      //   swal({
      //     title: "Thông tin Người giao dịch",
      //     text: "không được để trống!",
      //     icon: "warning",
      //     button: "Đóng"
      //   }).then(function(){
      //     contactPerson.focus();
      //   });
      //   flag = false;
      //   return;
      // }

      //check empty address
      if (address.value == '') {
        swal({
          title: "Thông tin Địa chỉ",
          text: "không được để trống!",
          icon: "warning",
          button: "Đóng"
        }).then(function () {
          address.focus();
        });
        flag = false;
        return;
      }

      //check empty cityId
      if (sessionStorage.cityId == 'undefined') {
        swal({
          title: "Thông tin Tỉnh/Thành phố",
          text: "không được để trống!",
          icon: "warning",
          button: "Đóng"
        }).then(function () {
          $scope.$broadcast('SetFocus');
        });
        flag = false;
        return;
      }

      //declare variable to store information about Webservice with POST method
      function successCallBack(data) {
        swal({
          title: "Thông báo",
          text: "Lưu dữ liệu thành công!",
          icon: "success",
          button: "Đóng",
        }).then(function () {
          location.href = "#/customer";
        });
      }

      function errorCallBack(data) {
        swal({
          title: "Thông báo",
          text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
          icon: "error",
          dangerMode: true,
          button: "Đóng",
        }).then(function () {
          location.href = "#/customer";
        });
        console.log(data);
      }

      //check if data's input is not empty
      if (flag == true) {

        //update Customer's data
        if (sessionStorage.itemId != 'undefined') {
          // Decrypt
          //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
          //var itemId = bytes.toString(CryptoJS.enc.Utf8);
          var itemId = sessionStorage.itemId.toString();
          var customerData = {
            'ID': itemId,
            'customerName': customerName.value,
            'customerCode': customerCode.value,
            'taxCode': taxCode.value,
            //  'contactPerson': contactPerson.value,
            'contactPerson': '',
            'address': address.value,
            'cityId': cityId,
            'cityName': cityName,
            'phone': phone.value,
            'email': email.value,
            'isActive': isActive.checked,
            'userUpdated': user.ID,
            'enterpriseId': enterpriseId,
            'userCreated': user.ID,
            'dateUpdated': new Date()
          };
          //debugger;
          $http.post(hostName.url + "api/Customer/UpdateCustomer", customerData)
            .then(successCallBack, errorCallBack);
        }
        //Add new Customer's data
        else {
          var customerData = {
            'customerName': customerName.value,
            'customerCode': customerCode.value,
            'taxCode': taxCode.value,
            //  'contactPerson': contactPerson.value,
            'contactPerson': '',
            'address': address.value,
            'cityId': cityId,
            'cityName': cityName,
            'phone': phone.value,
            'email': email.value,
            'isActive': isActive.checked,
            'enterpriseId': enterpriseId,
            'userCreated': user.ID,
            'userUpdated': user.ID,
            'dateCreated': new Date(),
            'dateUpdated': new Date()
          };
          //debugger;
          $http.post(hostName.url + "api/Customer/AddCustomer", customerData)
            .then(successCallBack, errorCallBack);
        }

      }
    };
    //end function save Customer's data into Database via Webservice

    //redirect to other pages
    $scope.open = function (url) {
      location.href = url;
    };

  }
  /******End controller for Update Customer******/

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0, 2);
    var month = strDate.slice(3, 5);
    var year = strDate.slice(6, 10);
    var date = month + '/' + day + '/' + year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 16.06.2020
 */
(function () {
    'use strict';
  
    //declare controller for Department
    angular.module('BlurAdmin.pages.lists')
        .controller('DepartmentCtrl', DepartmentCtrl);

    /******************************************/
    /*******controller for Department*******/
    /******************************************/
    function DepartmentCtrl($scope, $http, $state, hostName) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        };

        //function then call API get data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n + 1;
                vm.rowCollection[n].DateUpdated = convertJSONDate(vm.rowCollection[n].DateUpdated);
            }
            //console.log(vm.rowCollection);

        };

        //function then call API get data is error
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        }

        //call API to get data
        $http({
            method: "GET",
            url: hostName.url + "api/Department/GetAll?EnterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);

        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };


        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        //filter data
        $scope.findData = function() {
            vm.rowCollection = [];
            var DepartmentName = angular.element(document).find('#inputDepartmentName')[0];
            var IsActive = "";//= angular.element(document).find('#inputIsActive')[0];
            var IsActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
            var IsActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
            var EnterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            if (IsActiveAll.checked == true) {
                IsActive = "";
            }
            else if (IsActiveTrue.checked == true) {
                IsActive = true;
            }
            else {
                IsActive = false;
            }
            
            var queryString = "EnterpriseId=" + EnterpriseId;
            queryString += "&DepartmentName=" + DepartmentName.value;
            queryString += "&IsActive=" + IsActive;

            //call API to get data
            $http({
                method: "GET",
                url: hostName.url + "api/Department/Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter data

        //update Status
        $scope.updateStatus = function(flag, itemId) {

            //Active
            if (flag == true) {
                swal({
                    title: "Bạn muốn kích hoạt thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                        var data = {
                            'ID': itemId,
                            'IsActive': true,
                            'UserUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/Department/UpdateStatus", data).then(function(data){
                            swal("Kích hoạt thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }

                }); //end swal

            } //end Active

            //DeActive
            else {
                swal({
                    title: "Bạn muốn ngừng sử dụng thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                        var data = {
                            'ID': itemId,
                            'IsActive': false,
                            'UserUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/Department/UpdateStatus", data).then(function(data){
                            swal("Ngừng sử dụng thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(error) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                            console.log(error);
                            $state.reload();
                        });
                    } else {
                        //no action;
                    }

                }); //end swal

            } //end DeActive

        } //end update Status
      
    };
    /******End controller for Department******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 17.06.2020
 */
(function () {
    'use strict';
  
    //declare controller for Manage User Department
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('ManageUserDepartmentCtrl', ManageUserDepartmentCtrl);
  
    //******controller for Manage User Department******
    function ManageUserDepartmentCtrl($scope, $http, hostName) {
      
        //get data from Users
        $scope.Users = [];
        $scope.User = {};
        $scope.displayedCollection = [];
        var vm = this;
        vm.UserDelete = [];
        var n = 0;
        var enterpriseId = sessionStorage.enterpriseId;

        //Get User information
        if (sessionStorage.itemId != undefined) {
            $http({
                method: "GET",
                url: hostName.url + "api/Department/GetById/" + sessionStorage.itemId,
            }).then(function(response){
                enterpriseId = response.data.EnterpriseId;
                
                var successCallBackUser = function (response) {
                    $scope.Users = response.data;
        
                    //GET LIST USER BY DEPARTMENT ID
                    var successCallBackDepartment = function (response) {
                        var listUsers = response.data;
        
                        for (var u = 0; u < $scope.Users.length; u++) {
                            for (var l = 0; l < listUsers.length; l++) {
                                if (listUsers[l].UserId == $scope.Users[u].ID) {
                                    if ($scope.displayedCollection.indexOf($scope.Users[u]) < 0) {
                                        $scope.displayedCollection.push($scope.Users[u]);
                                        $scope.Users.splice(u, 1);
                                    }
                                }
                            }
                        }
                    }; //#GET LIST USER BY DEPARTMENT ID
                    var errorCallBackDepartment = function (reason) {
                        console.log(reason);
                    } //#errorCallBackDepartment
        
                    $http({
                        method: "GET",
                        url: hostName.url + "api/UserDepartment/GetUserByDepartment?DepartmentId=" + sessionStorage.itemId
                    }).then(successCallBackDepartment, errorCallBackDepartment);
                }; //#successCallBackUser
                var errorCallBackUser = function (reason) {
                    $scope.error = reason.data;
                    
                    console.log(reason);
                } //#errorCallBackUser
        
                //GET LIST USERS by EnterpriseId
                $http({
                    method: "GET",
                    url: hostName.url + "api/User/ListsUser?enterpriseId=" + enterpriseId
                }).then(successCallBackUser, errorCallBackUser);
                //#GET LIST USERS by EnterpriseId
            }, function(error){
                console.log(error);
            });
        } //#Get User information

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        //choose User and add to list
        $scope.changeUser = function(User) {
            var index = $scope.Users.indexOf(User);
            for (n=0; n<$scope.Users.length; n++) {
                if (User.ID == $scope.Users[n].ID) {
                    $scope.Users.splice(index,1);
                    $scope.User.selected = undefined;
                    $scope.displayedCollection.push(User);
                }
            }
        }

        //Remove User from list
        $scope.removeUser = function(User) {
            var index = $scope.displayedCollection.indexOf(User);
            for (n=0; n<$scope.displayedCollection.length; n++) {
                if (User.ID == $scope.displayedCollection[n].ID) {
                    $scope.displayedCollection.splice(index,1);
                    $scope.Users.push(User);
                    vm.UserDelete.push(User.ID);
                }
            }
        }

        //function to save data to database
        $scope.save = function() {
            
            //check if empty User
            if ($scope.displayedCollection.length == 0) {
                swal({
                    title: "Chưa có người dùng được chọn, bạn muốn bỏ qua việc phân quyền?",
                    icon: "warning",
                    buttons: ["Hủy bỏ", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        location.href = "#/department";
                    } else {
                        $scope.$broadcast('SetFocusUser');
                    }
                });
            } //#check if empty User

            //check if delete data
            if (vm.UserDelete.length > 0) {
                for (n=0; n<vm.UserDelete.length; n++) {
                    var inputData = {
                        'UserId': vm.UserDelete[n], 
                        'DepartmentId': sessionStorage.itemId, 
                        'EnterpriseId': enterpriseId
                    };
                    $http.post(hostName.url + "api/UserDepartment/Delete", inputData)
                    .then(function(data) {
                        //NO Action
                    }, function(error){
                        console.log(error);
                    });
                    vm.UserDelete.splice(n,1);
                }
            } //#check if delete data

            //check to add new data
            for (n=0; n<$scope.displayedCollection.length; n++) {
                var UserID = $scope.displayedCollection[n].ID;
                var inputData = {
                    'UserId': UserID, 
                    'DepartmentId': sessionStorage.itemId, 
                    'EnterpriseId': enterpriseId
                };

                $http.post(hostName.url + "api/UserDepartment/Insert", inputData)
                    .then(function(data) {
                        if (n == $scope.displayedCollection.length) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/department";
                            });
                        }
                    }, function(error){
                        console.log(error);
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/department";
                        });
                    });
            } //end check to add new data

        } //end function to save data to database
  
    }; //******End controller for Manage User Department******
  
})();
/**
 * @author Nguyen Huu Tuan
 * created on 16.06.2020
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateDepartmentCtrl', UpdateDepartmentCtrl);

    //******CONTROLLER UPDATE DEPARTMENT******
    function UpdateDepartmentCtrl($scope, $http, hostName, $filter) {

        //LOCAL VARIABLES
        $scope.PageTitle = "Tạo mới thông tin phòng ban";
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.checkStatus = 'Y';

        //LOAD DATA FROM DATABASE
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();
            
            $scope.PageTitle = "Cập nhật thông tin phòng ban";

            //CALL API GET FROM SERVER
            $http({
                method: "GET",
                url: hostName.url + "api/Department/GetById/" + itemId,
            }).then(function(response) {
                $scope.Department = [];
                $scope.Department = response.data;

                if ($scope.Department != undefined) {
                    //PUT DATA TO FORM'S CONTROLS
                    $scope.inputDepartmentCode = $scope.Department.DepartmentCode;
                    $scope.inputDepartmentName = $scope.Department.DepartmentName;
                    $scope.checkStatus = $scope.Department.IsActive == true ? 'Y' : 'N';
                    $scope.inputDescription = $scope.Department.Description;
                }
            }, function(reason) {
                console.log(reason);
            });
        }

        //SAVE DATA TO DATABASE
        $scope.save = function () {

            var DepartmentCode = angular.element(document).find('#inputDepartmentCode')[0];
            var DepartmentName = angular.element(document).find('#inputDepartmentName')[0];
            var Description = angular.element(document).find('#inputDescription')[0];
            var isActive = angular.element(document).find('#inputIsActive')[0];
            var flag = true;

            //check empty DepartmentCode
            if (DepartmentCode.value == '') {
                swal({
                    title: "Thông tin Mã phòng ban",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    DepartmentCode.focus();
                });
                flag = false;
                return;
            }
            
            //check empty DepartmentName
            if (DepartmentName.value == '') {
                swal({
                    title: "Thông tin Tên phòng ban",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    DepartmentName.focus();
                });
                flag = false;
                return;
            }
            
            //FUNCTION SUCCESS WHEN CALL API
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/department";
                });
            }; //#FUNCTION SUCCESS WHEN CALL API

            //FUNCTION ERROR WHEN CALL API
            function errorCallBack(error) {
                swal({
                    title: "Thông báo",
                    text: error.data.Message,
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/department";
                });
                console.log(error);
            }; //#FUNCTION ERROR WHEN CALL API
            
            
            //CHECK DATA'S INPUT IS VALID
            if (flag == true) {

                //+++ START CASE UPDATE
                if (sessionStorage.itemId != 'undefined') {
                    var itemId = sessionStorage.itemId.toString();
                    var date = new Date();
                    
                    var inputData = {
                        'ID': itemId, 
                        'DepartmentCode': DepartmentCode.value, 
                        'DepartmentName': DepartmentName.value, 
                        'Description': Description.value, 
                        'DateUpdated': date, 
                        'UserUpdated': user.ID, 
                        'IsActive': isActive.checked,
                        'EnterpriseId': sessionStorage.enterpriseId
                    };
                    
                    //CALL API TO UPDATE'S DATA
                    $http.post(hostName.url + "api/Department/Update", inputData)
                    .then(successCallBack, errorCallBack);
                }
                //### END CASE UPDATE

                //+++ START CASE INSERT
                else {
                    var date = new Date();
                    
                    var inputData = { 
                        'DepartmentCode': DepartmentCode.value, 
                        'DepartmentName': DepartmentName.value, 
                        'Description': Description.value, 
                        'DateCreated': date, 
                        'DateUpdated': date, 
                        'UserCreated': user.ID, 
                        'UserUpdated': user.ID, 
                        'IsActive': isActive.checked,
                        'EnterpriseId': sessionStorage.enterpriseId
                    };
                    
                    //CALL API TO UPDATE'S DATA
                    $http.post(hostName.url + "api/Department/Insert", inputData)
                    .then(successCallBack, errorCallBack);
                }
                //### END CASE INSERT
            
            }; //#CHECK DATA'S INPUT IS VALID

        }; //#SAVE DATA TO DATABASE

        //REDIRECT TO OTHER PAGES
        $scope.open = function(url) {
            location.href = url;
        };

    }
    //######CONTROLLER UPDATE DEPARTMENT######
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 05.09.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.lists')
        .controller('DocumentPageCtrl', DocumentPageCtrl);

    //******CONTROLLER DOCUMENT******
    function DocumentPageCtrl($scope, $http, $state, hostName) {

        //LOCAL VARIABLES
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        
        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }

        //FUNCTION SUCCESS WHEN CALL API
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
                vm.rowCollection[n].PathFileTemplate = hostName.url + "Templates/" + vm.rowCollection[n].enterpriseId + "/" + vm.rowCollection[n].fileName;
            }
        }; //#FUNCTION SUCCESS WHEN CALL API

        //FUNCTION ERROR WHEN CALL API
        function errorCallBack(reason) {
            console.log(reason);
        }; //#FUNCTION ERROR WHEN CALL API

        //CALL API GET FROM SERVER
        $http({
            method: "GET",
            url: hostName.url + "api/Document/GetAllDocument?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
        //#CALL API GET FROM SERVER

        //CHECK TRUE / FALSE
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION
        
        //REDIRECT TO OTHER PAGES
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };
        //#REDIRECT TO OTHER PAGES

        //SEARCH DOCUMENT'S DATA
        $scope.findData = function() {
            vm.rowCollection = [];
            // var fromDate = angular.element(document).find('#inputStartDate')[0];
            // var toDate = angular.element(document).find('#inputEndDate')[0];
            var documentName = angular.element(document).find('#inputDocumentName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            var queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&documentName=" + documentName.value;

            // //QUERY STRING
            // if (fromDate != undefined) {
            //     var dateFrom = reConvertJSONDate(fromDate.value);
            //     var dateTo = reConvertJSONDate(toDate.value);

            //     queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&documentName=" + documentName.value;
            // }
            // else {
            //     var date = new Date();
            //     var nowYear = date.getFullYear();
            //     var nowMonth = date.getMonth();
            //     queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&documentName=";
            // } //#QUERY STRING
            
            //CALL API GET FROM SERVER
            $http({
                method: "GET",
                url: hostName.url + "api/Document/SearchDocument?" + queryString,
            }).then(successCallBack, errorCallBack);
            //#CALL API GET FROM SERVER

        };
        //SEARCH DOCUMENT'S DATA

    };
    //######CONTROLLER DOCUMENT######

    //FUNCTION 2 CONVERT JSON DATE TO NORMAL DATE
    function convertJSONDate(strDate) {
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    //FUNCTION 2 CONVERT NORMAL DATE TO JSON DATE
    function reConvertJSONDate(strDate) {
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
          return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 19.09.2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateDocumentPageCtrl', UpdateDocumentPageCtrl);

    //******CONTROLLER UPDATE DOCUMENT******
    function UpdateDocumentPageCtrl($scope, $http, fileReader, $rootScope, hostName, $filter) {
      
        //LOCAL VARIABLES
        $scope.PageTitle = "Tạo mới thông tin mẫu báo cáo";
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.checkStatus = 'Y';

        //LOAD DOCUMENT'S DATA FROM DATABASE
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();
            
            $scope.PageTitle = "Cập nhật thông tin mẫu báo cáo";

            //CALL API GET FROM SERVER
            $http({
                method: "GET",
                url: hostName.url + "api/Document/GetDocument/" + itemId,
            }).then(function(response) {
                $scope.Document = [];
                $scope.Document = response.data;

                if ($scope.Document != undefined) {
                    //PUT DATA TO FORM'S CONTROLS
                    $scope.enterpriseId = $scope.Document.enterpriseId;
                    $scope.inputDocumentCode = $scope.Document.documentCode;
                    $scope.inputDocumentName = $scope.Document.documentName;
                    $scope.checkStatus = $scope.Document.isSeperateTax == true ? 'Y' : 'N';
                    $scope.inputStartRow = $scope.Document.startRow;
                    $scope.inputStartCol = $scope.Document.startCol;
                    $scope.inputDescription = $scope.Document.description;
                    $scope.fileName = $rootScope.fileTemplate = $scope.Document.fileName;
                }
            }, function(reason) {
                console.log(reason);
            });
        }

        $scope.checkSeperateTax = function(obj) {
            $scope.checkStatus = obj == true ? 'Y' : 'N';
        }

        //UPLOAD FILE FROM CLIENT TO SERVER
        $scope.uploadFile = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        //GET FILE DATA FROM CLIENT
        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    if (fileName.indexOf(".doc") <= 0 && fileName.indexOf(".docx") <= 0 
                        && fileName.indexOf(".xls") <= 0 && fileName.indexOf(".xlsx") <= 0 ) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Word / Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function(){
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;
                        var templateImage = "";

                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", $scope.enterpriseId);
                        data.append("templateImage", templateImage);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;
                    }
                });
        };
        //#GET FILE DATA FROM CLIENT

        //SAVE DATA TO DATABASE
        $scope.save = function () {

            var documentCode = angular.element(document).find('#inputDocumentCode')[0];
            var documentName = angular.element(document).find('#inputDocumentName')[0];
            var startRow = angular.element(document).find('#inputStartRow')[0];
            var startCol = angular.element(document).find('#inputStartCol')[0];
            var description = angular.element(document).find('#inputDescription')[0];
            var fileInput = document.getElementById('uploadFile');
            var flag = true;

            //check empty documentCode
            if (documentCode.value == '') {
                swal({
                    title: "Thông tin Mã mẫu báo cáo",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    documentCode.focus();
                });
                flag = false;
                return;
            }
            
            //check empty documentName
            if (documentName.value == '') {
                swal({
                    title: "Thông tin Tên mẫu báo cáo",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    documentName.focus();
                });
                flag = false;
                return;
            }

            if ($rootScope.fileTemplate == undefined) {
                swal({
                    title: "File mẫu báo cáo",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    fileInput.focus();
                });
                flag = false;
                return;
            }

            //check empty startRow
            if (startRow.value == '') {
                swal({
                    title: "Thông tin Start Row",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    startRow.focus();
                });
                flag = false;
                return;
            }

            //check empty startCol
            if (startCol.value == '') {
                swal({
                    title: "Thông tin Start Column",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    startCol.focus();
                });
                flag = false;
                return;
            }
            
            //FUNCTION SUCCESS WHEN CALL API
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/document";
                });
            }; //#FUNCTION SUCCESS WHEN CALL API

            //FUNCTION ERROR WHEN CALL API
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/document";
                });
                console.log(data);
            }; //#FUNCTION ERROR WHEN CALL API
            
            
            //CHECK DATA'S INPUT IS VALID
            if (flag == true && sessionStorage.itemId != 'undefined') {
            
                //UPDATE DATA TO DATABASE WHICH NOT UPLOAD FILE
                if ($rootScope.FileTemplateData == undefined) {
                    var itemId = sessionStorage.itemId.toString();
                    var dateCreated;
                    var date = new Date();
                    dateCreated = $filter('date')(date, 'dd/MM/yyyy');
                    
                    var inputData = {
                        'ID': itemId, 
                        'documentCode': documentCode.value, 
                        'documentName': documentName.value, 
                        'fileName': $scope.fileName, 
                        'isSeperateTax': $scope.checkStatus == 'Y' ? true: false, 
                        'startRow': startRow.value, 
                        'startCol': startCol.value, 
                        'description': description.value, 
                        'dateCreated': dateCreated, 
                        'dateUpdated': dateCreated, 
                        'userCreated': user.ID, 
                        'userUpdated': user.ID, 
                        'isActive': true,
                        'enterpriseId': sessionStorage.enterpriseId
                    };
                    
                    //CALL API TO UPDATE'S DATA
                    $http.post(hostName.url + "api/Document/UpdateDocument", inputData)
                    .then(successCallBack, errorCallBack);
                }

                //UPDATE DATA TO DATABASE WHICH HAS UPLOAD FILE
                else {
                    //UPLOAD FILE TO SERVER
                    var data = new FormData();
                    data = $rootScope.FileTemplateData;

                    var reg = {
                        url: hostName.url + 'api/Template/UploadFileToDocmentLibrary',
                        method: 'POST',
                        data: data,
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                    }

                    //CALL API TO UPLOAD FILE TO SERVER
                    $http(reg).then(function(response){
                        var fileName = data.getAll("filename")[0];
                        var itemId = sessionStorage.itemId.toString();
                        var inputData = {
                            'ID': itemId,
                            'fileName': fileName,
                            'description': description.value, 
                            'userUpdated': user.ID
                        };

                        //CALL API TO UPDATE'S DATA
                        $http.post(hostName.url + "api/Document/UpdateDocument", inputData)
                        .then(successCallBack, errorCallBack);

                    }, function(reason){
                        swal({
                            title: "Thông báo",
                            text: "Không thể tải được file mẫu báo cáo, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            console.log(data);
                        });

                    }); //#CALL API TO UPLOAD FILE TO SERVER
                };
            
            }; //#CHECK DATA'S INPUT IS VALID

        }; //#SAVE DATA TO DATABASE

        //REDIRECT TO OTHER PAGES
        $scope.open = function(url) {
            location.href = url;
        };

    }
    //######CONTROLLER UPDATE DOCUMENT######

    //FUNCTION 2 CONVERT NORMAL DATE TO JSON DATE
    function convertJSONDate(strDate) {
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for GoodAndService
  angular.module('BlurAdmin.pages.lists')
    .controller('GoodAndServicePageCtrl', GoodAndServicePageCtrl);

  //******controller for GoodAndService******
  function GoodAndServicePageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //function then call Webservice get GoodAndService's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get GoodAndService's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get GoodAndService's data
    $http({
      method: "GET",
      url: hostName.url + "api/GoodAndService/GetAllGoodAndService?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };

    //save data to local variable when change Select's control
    $scope.selectChanged = function(objectSelect) {
      $scope.Category = objectSelect;
    }
    
    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter GoodAndService's data
    $scope.findData = function() {
      vm.rowCollection = [];
      var fromDate = angular.element(document).find('#inputFromDate')[0];
      var toDate = angular.element(document).find('#inputToDate')[0];
      var goodAndServiceId = angular.element(document).find('#inputGoodAndServiceId')[0];
      var goodAndServiceName = angular.element(document).find('#inputGoodAndServiceName')[0];
      var categoryId = $scope.Category == undefined ? "":$scope.Category.ID;
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";

      if (fromDate != undefined) {
        var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
        var dateTo = toDate.value;//reConvertJSONDate(toDate.value);
        
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&goodAndServiceId=" + goodAndServiceId.value + "&goodAndServiceName=" + goodAndServiceName.value + "&categoryId=" + categoryId + "&isActive=" + isActive;
      }
      else {
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&goodAndServiceId=&goodAndServiceName=&categoryId=&isActive=";
      }
       
      //call Webservice to get GoodAndService's data
      $http({
        method: "GET",
        url: hostName.url + "api/GoodAndService/SearchGoodAndService?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter GoodAndService's data

    //update Status of GoodAndService
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/GoodAndService/UpdateGoodAndServiceStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/GoodAndService/UpdateGoodAndServiceStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for GoodAndService******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for Update GoodAndService
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateGoodAndServicePageCtrl', UpdateGoodAndServicePageCtrl);

    /******************************************/
    /******controller for Update GoodAndService******/
    /******************************************/
    function UpdateGoodAndServicePageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin hàng hóa & dịch vụ";
      $scope.checkStatus = 'Y';
      $scope.Category = {};
      $scope.Unit = {};
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load GoodAndService's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin hàng hóa & dịch vụ";

        //call Webservice to get GoodAndService's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/GoodAndService/GetGoodAndService/" + itemId,
        }).then(function(response) {
          $scope.GoodAndService = [];
          $scope.GoodAndService = response.data;
          
          //console.log($scope.GoodAndService);
          
          if ($scope.GoodAndService != undefined) {
            //put GoodAndService's data into Form's controls
            $scope.inputGoodAndServiceId = $scope.GoodAndService.goodAndServiceId;
            $scope.inputGoodAndServiceName = $scope.GoodAndService.goodAndServiceName;
            $scope.inputPrice = $scope.GoodAndService.price;
            $scope.inputVAT = $scope.GoodAndService.VAT;
            $scope.Category.selected = {ID: $scope.GoodAndService.categoryId, categoryName: $scope.GoodAndService.categoryName};
            $scope.Unit.selected = {ID: $scope.GoodAndService.unitId, unitName: $scope.GoodAndService.unitName};
            $scope.checkStatus = $scope.GoodAndService.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }

      $scope.selectCategory = function(objectSelect) {
        $scope.Category.selected = objectSelect;
      }

      $scope.selectUnit = function(objectSelect) {
        $scope.Unit.selected = objectSelect;
      }

      //save GoodAndService's data into Database via Webservice
      $scope.save = function () {

        var goodAndServiceId = angular.element(document).find('#inputGoodAndServiceId')[0];
        var goodAndServiceName = angular.element(document).find('#inputGoodAndServiceName')[0];
        var price = angular.element(document).find('#inputPrice')[0];
        var VAT = angular.element(document).find('#inputVAT')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var categoryId = $scope.Category.selected != undefined ? $scope.Category.selected.ID : 0;
        var unitId = $scope.Unit.selected != undefined ? $scope.Unit.selected.ID : 0;
        var flag = true;

        //check empty goodAndServiceId
        if (goodAndServiceId.value == '') {
          swal({
            title: "Thông tin Mã hàng hóa & dịch vụ",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            goodAndServiceId.focus();
          });
          flag = false;
          return;
        }

        //check empty goodAndServiceName
        if (goodAndServiceName.value == '') {
          swal({
            title: "Thông tin Tên hàng hóa & dịch vụ",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            goodAndServiceName.focus();
          });
          flag = false;
          return;
        }

        //check empty price
        if (price.value == '') {
            swal({
              title: "Thông tin Giá tiền",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
              price.focus();
            });
            flag = false;
            return;
        }

        //check empty VAT
        if (VAT.value == '') {
            swal({
              title: "Thông tin thuế VAT",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                VAT.focus();
            });
            flag = false;
            return;
        }

        //check empty categoryId
        if (categoryId == 0) {
            swal({
              title: "Thông tin Loại hàng hóa",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                $scope.$broadcast('SetFocusCategory');
            });
            flag = false;
            return;
        }

        //check empty unitId
        if (unitId == 0) {
            swal({
              title: "Thông tin Đơn vị tính",
              text: "không được để trống!",
              icon: "warning",
              button: "Đóng"
            }).then(function(){
                $scope.$broadcast('SetFocusUnit');
            });
            flag = false;
            return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/goodAndService";
          });
          console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/goodAndService";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update GoodAndService's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var inputData = {
              'ID': sessionStorage.itemId,
              'goodAndServiceId': goodAndServiceId.value, 
              'goodAndServiceName': goodAndServiceName.value, 
              'unitId': unitId, 
              'price': price.value, 
              'VAT': VAT.value, 
              'categoryId': categoryId, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/GoodAndService/UpdateGoodAndService", inputData)
            .then(successCallBack, errorCallBack);
          }
          //Add new GoodAndService's data
          else {
            var inputData = {
                'goodAndServiceId': goodAndServiceId.value, 
                'goodAndServiceName': goodAndServiceName.value, 
                'unitId': unitId, 
                'price': price.value, 
                'VAT': VAT.value, 
                'categoryId': categoryId, 
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/GoodAndService/AddGoodAndService", inputData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save GoodAndService's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update GoodAndService******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 27.08.2018
 */
(function () {
    'use strict';

    //declare controller for Supplier
    angular.module('BlurAdmin.pages.lists')
      .controller('SupplierPageCtrl', SupplierPageCtrl);

    //******controller for Supplier******
    function SupplierPageCtrl($scope, $http, $state, hostName) {
  
      $scope.smartTablePageSize = 10;
      //$scope.Suppliers = [];
      var n = 0;
      var vm = this;
      vm.rowCollection = [];
      sessionStorage.itemId = undefined;
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //function then call Webservice get Supplier's data is success
      var successCallBack = function (response) {
        vm.rowCollection = response.data;
        
        for (n=0; n<vm.rowCollection.length; n++) {
          // Encrypt
          vm.rowCollection[n].No = n+1;
          vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
          //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].supplierId, 'VietInfo@32XVNTQUANBINHTHANH');
        }

        //display message into Console
        //console.log(response);
      };

      //function then call Webservice get Supplier's data is error
      var errorCallBack = function (reason) {
        $scope.error = reason.data;

        //display message into Console
        console.log(response);
      }

      //call Webservice to get Supplier's data
      $http({
        method: "GET",
        url: hostName.url + "api/Supplier/GetAllSupplier?enterpriseId=" + sessionStorage.enterpriseId
      }).then(successCallBack, errorCallBack);

      //check True/False for isActive chechbox
      $scope.checkShow = function(dataCheck){
        if (dataCheck) {
          return 1;
        }
        else {
          return 0;
        }
      };

      //save data to local variable when change Select's control
      $scope.selections = [];
      var selectedValue = "";
      $scope.selectionChanged = function(idx) {
        selectedValue = $scope.selections[idx].cityId;
      };

      //redirect to other pages
      $scope.open = function(url, id) {
        location.href = url;
        sessionStorage.itemId = id;
      };

      //filter Supplier's data
      $scope.findData = function() {
        vm.rowCollection = [];
        var fromDate = angular.element(document).find('#inputFromDate')[0];
        var toDate = angular.element(document).find('#inputToDate')[0];
        var supplierName = angular.element(document).find('#inputSupplierName')[0];
        var taxCode = angular.element(document).find('#inputTaxCode')[0];
        var contactPerson = angular.element(document).find('#inputContactPerson')[0];
        var queryString = "";

        if (fromDate != undefined) {
          var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
          var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&supplierName=" + supplierName.value + "&taxCode=" + taxCode.value + "&cityId=" + selectedValue + "&contactPerson=" + contactPerson.value;
        }
        else {
          var date = new Date();
          var nowYear = date.getFullYear();
          var nowMonth = date.getMonth();
          queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&supplierName=&taxCode=&cityId=&contactPerson=";
        }

        //call Webservice to get Supplier's data
        $http({
          method: "GET",
          url: hostName.url + "api/Supplier/SearchSupplier?" + queryString,
        }).then(successCallBack, errorCallBack);
      }
      //end filter Supplier's data

      //update Status of Supplier
      $scope.updateStatus = function(flag, itemId) {
        if (flag == true) {
          //Stop
          swal({
            title: "Bạn muốn kích hoạt thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var supplierData = {
                'ID': itemId,
                'isActive': true,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Supplier/UpdateSupplierStatus", supplierData).then(function(data){
                swal("Kích hoạt thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
        else {
          //Active
          swal({
            title: "Bạn muốn ngừng sử dụng thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var supplierData = {
                'ID': itemId,
                'isActive': false,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Supplier/UpdateSupplierStatus", supplierData).then(function(data){
                swal("Ngừng sử dụng thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
      }
    };
    //******End controller for Supplier******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 27.08.2018
 */
(function () {
    'use strict';

    //declare controller for Supplier
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateSupplierPageCtrl', UpdateSupplierPageCtrl);

    /******************************************/
    /******controller for Update Supplier******/
    /******************************************/
    function UpdateSupplierPageCtrl($scope, $http, $state, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin nhà cung cấp";
      sessionStorage.cityId = undefined;
      var user = JSON.parse(localStorage.getItem("dataUser"));
      //$scope.isAddNew = false;

      /******Load City's data******/
      $scope.City = {};
      $scope.Cities = [];
      $scope.checkStatus = 'Y';

      var successCallBack = function (response) {
        $scope.Cities = response.data;
        //console.log(response);
      };

      var errorCallBack = function (reason) {
        $scope.error = reason.data;
        console.log(reason);
      
        if ($scope.Cities.length == 0) {
          $scope.Cities = [
            {cityName: "Hà Nội", cityId: "01"},
            {cityName: "Hồ Chí Minh", cityId: "79"}
          ];
        };
      }

      $http({
        method: "GET",
        url: hostName.url + "api/City/GetAllCity"
      }).then(successCallBack, errorCallBack);
      /******End Load City's data******/

      //load Supplier's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        //show button AddNew
        $scope.isAddNew = true;

        // Decrypt
        // var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        // var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin nhà cung cấp";

        //call Webservice to get Supplier's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/Supplier/GetSupplier/" + itemId,
        }).then(function(response) {
          $scope.Supplier = [];
          $scope.Supplier = response.data;
          //console.log($scope.Supplier);

          if ($scope.Supplier != undefined) {
            //put Supplier's data into Form's controls
            $scope.inputSupplierName = $scope.Supplier.supplierName;
            $scope.inputTaxCode = $scope.Supplier.taxCode;
            $scope.inputContactPerson = $scope.Supplier.contactPerson;
            $scope.inputAddress = $scope.Supplier.address;
            $scope.City.selected = {cityName: $scope.Supplier.cityName, cityId: $scope.Supplier.cityId};
            $scope.inputPhone = $scope.Supplier.phone;
            $scope.inputEmail = $scope.Supplier.email;
            $scope.checkStatus = $scope.Supplier.isActive == true?'Y':'N';
            sessionStorage.cityId = $scope.Supplier.cityId;
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }

      $scope.selectChanged = function(City) {
        sessionStorage.cityId = City.cityId;
      }

      /*
      $scope.refresh = function() {
        sessionStorage.itemId = undefined;
        $state.reload();
      }*/

      //save Supplier's data into Database via Webservice
      $scope.save = function () {
        
        var supplierName = angular.element(document).find('#inputSupplierName')[0];
        var taxCode = angular.element(document).find('#inputTaxCode')[0];
        var contactPerson = angular.element(document).find('#inputContactPerson')[0];
        var address = angular.element(document).find('#inputAddress')[0];
        var phone = angular.element(document).find('#inputPhone')[0];
        var email = angular.element(document).find('#inputEmail')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var cityId = sessionStorage.cityId;
        var flag = true;

        //check empty supplierName
        if (supplierName.value == '') {
          swal({
            title: "Thông tin Tên nhà cung cấp",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            supplierName.focus();
          });
          flag = false;
          return;
        }

        //check empty taxCode
        if (taxCode.value == '') {
          swal({
            title: "Thông tin Mã số thuế",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            taxCode.focus();
          });
          flag = false;
          return;
        }

        //check empty contactPerson
        if (contactPerson.value == '') {
          swal({
            title: "Thông tin Người giao dịch",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            contactPerson.focus();
          });
          flag = false;
          return;
        }

        //check empty address
        if (address.value == '') {
          swal({
            title: "Thông tin Địa chỉ",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            address.focus();
          });
          flag = false;
          return;
        }

        //check empty cityId
        if (sessionStorage.cityId == 'undefined') {
          swal({
            title: "Thông tin Tỉnh/Thành phố",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            $scope.$broadcast('SetFocus');
          });
          flag = false;
          return;
        }

        //declare variable to store information about Webservice with POST method
        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            // if (sessionStorage.itemId == 'undefined') {
            //   sessionStorage.itemId = data.data;
            // }
            // $state.reload();
            location.href = "#/supplier";
          });
          //console.log(data.data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/supplier";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {
          
          //update Supplier's data
          if (sessionStorage.itemId != 'undefined') {
            // Decrypt
            // var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
            // var itemId = bytes.toString(CryptoJS.enc.Utf8);
            var itemId = sessionStorage.itemId.toString();
            //debugger;
            var supplierData = {
              'ID': itemId,
              'supplierName': supplierName.value, 
              'taxCode': taxCode.value, 
              'contactPerson': contactPerson.value, 
              'address': address.value, 
              'cityId': cityId, 
              'phone': phone.value, 
              'email': email.value,
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/Supplier/UpdateSupplier", supplierData)
            .then(successCallBack, errorCallBack);
          }
          //Add new Supplier's data
          else {
            var supplierData = {
              'supplierName': supplierName.value, 
              'taxCode': taxCode.value, 
              'contactPerson': contactPerson.value, 
              'address': address.value, 
              'cityId': cityId, 
              'phone': phone.value, 
              'email': email.value,
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/Supplier/AddSupplier", supplierData)
            .then(successCallBack, errorCallBack);
          }

        }

      };
      //end function save Supplier's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update Supplier******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for TaxAuthority
  angular.module('BlurAdmin.pages.lists')
    .controller('TaxAuthorityPageCtrl', TaxAuthorityPageCtrl);

  //******controller for TaxAuthority******
  function TaxAuthorityPageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //function then call Webservice get TaxAuthority's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get TaxAuthority's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get TaxAuthority's data
    $http({
      method: "GET",
      url: hostName.url + "api/TaxAuthority/GetAllTaxAuthority"
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };
    
    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter TaxAuthority's data
    $scope.findData = function() {
      vm.rowCollection = [];
      var fromDate = angular.element(document).find('#inputFromDate')[0];
      var toDate = angular.element(document).find('#inputToDate')[0];
      var taxAuthorityId = angular.element(document).find('#inputTaxAuthorityId')[0];
      var taxAuthorityName = angular.element(document).find('#inputTaxAuthorityName')[0];
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";

      if (fromDate != undefined) {
        var dateFrom = reConvertJSONDate(fromDate.value);
        var dateTo = reConvertJSONDate(toDate.value);
        
        queryString = "fromDate=" + dateFrom + "&toDate=" + dateTo + "&taxAuthorityId=" + taxAuthorityId.value + "&taxAuthorityName=" + taxAuthorityName.value + "&isActive=" + isActive;
      }
      else {
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        queryString = "fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&taxAuthorityId=&taxAuthorityName=&isActive=";
      }
       
      //call Webservice to get TaxAuthority's data
      $http({
        method: "GET",
        url: hostName.url + "api/TaxAuthority/SearchTaxAuthority?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter TaxAuthority's data

    //update Status of TaxAuthority
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete) {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TaxAuthority/UpdateTaxAuthorityStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TaxAuthority/UpdateTaxAuthorityStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for TaxAuthority******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 15.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for TaxAuthority
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateTaxAuthorityPageCtrl', UpdateTaxAuthorityPageCtrl);

    /******************************************/
    /******controller for Update TaxAuthority******/
    /******************************************/
    function UpdateTaxAuthorityPageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin cơ quan thuế";
      $scope.checkStatus = 'Y';
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load TaxAuthority's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin cơ quan thuế";

        //call Webservice to get TaxAuthority's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/TaxAuthority/GetTaxAuthority/" + itemId,
        }).then(function(response) {
          $scope.TaxAuthority = [];
          $scope.TaxAuthority = response.data;
          //console.log($scope.TaxAuthority);
          
          if ($scope.TaxAuthority != undefined) {
            //put TaxAuthority's data into Form's controls
            $scope.inputTaxAuthorityId = $scope.TaxAuthority.taxAuthorityId;
            $scope.inputTaxAuthorityName = $scope.TaxAuthority.taxAuthorityName;
            $scope.inputPhone = $scope.TaxAuthority.phone;
            $scope.inputAddress = $scope.TaxAuthority.address;
            $scope.inputDescription = $scope.TaxAuthority.description;
            $scope.checkStatus = $scope.TaxAuthority.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          console.log(reason);
        });
      }

      //save TaxAuthority's data into Database via Webservice
      $scope.save = function () {

        var taxAuthorityId = angular.element(document).find('#inputTaxAuthorityId')[0];
        var taxAuthorityName = angular.element(document).find('#inputTaxAuthorityName')[0];
        var phone = angular.element(document).find('#inputPhone')[0];
        var address = angular.element(document).find('#inputAddress')[0];
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var flag = true;

        //check empty taxAuthorityId
        if (taxAuthorityId.value == '') {
          swal({
            title: "Thông tin Mã cơ quan thuế",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            taxAuthorityId.focus();
          });
          flag = false;
          return;
        }

        //check empty taxAuthorityName
        if (taxAuthorityName.value == '') {
          swal({
            title: "Thông tin Tên cơ quan thuế",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            taxAuthorityName.focus();
          });
          flag = false;
          return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/taxAuthority";
          });
          console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/taxAuthority";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update TaxAuthority's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var inputData = {
              'ID': sessionStorage.itemId,
              'taxAuthorityId': taxAuthorityId.value, 
              'taxAuthorityName': taxAuthorityName.value, 
              'phone': phone.value, 
              'address': address.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TaxAuthority/UpdateTaxAuthority", inputData)
            .then(successCallBack, errorCallBack);
          }
          //Add new TaxAuthority's data
          else {
            var inputData = {
                'taxAuthorityId': taxAuthorityId.value, 
                'taxAuthorityName': taxAuthorityName.value, 
                'phone': phone.value, 
                'address': address.value, 
                'description': description.value, 
                'isActive': isActive.checked,
                'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/TaxAuthority/AddTaxAuthority", inputData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save TaxAuthority's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update TaxAuthority******/
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 05.09.2018
 */
(function () {
    'use strict';
  
    //declare controller for Template
    angular.module('BlurAdmin.pages.lists')
      .controller('TemplatePageCtrl', TemplatePageCtrl);

    //******controller for Template******
    function TemplatePageCtrl($scope, $http, $state, hostName) {

      $scope.smartTablePageSize = 10;
      var n = 0;
      var vm = this;
      vm.rowCollection = [];
      sessionStorage.itemId = undefined;
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //CHECK ADMIN PERMISSION
      $scope.isShow = false;
      var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
      if (userRole != undefined) {
          for (var ur = 0; ur < userRole.length; ur++) { 
              if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                  $scope.isShow = true;
          };
      }

      //function then call Webservice get Template's data is success
      function successCallBack(response) {
        vm.rowCollection = response.data;

        for (n=0; n<vm.rowCollection.length; n++) {
          // Encrypt
          vm.rowCollection[n].No = n+1;
          vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
          vm.rowCollection[n].PathFileTemplate = hostName.url + "Templates/" + sessionStorage.enterpriseId + "/" + vm.rowCollection[n].fileName;
        }

        //display message into Console
        //console.log(response);
      };

      //function then call Webservice get Template's data is error
      function errorCallBack(reason) {
        $scope.error = reason.data;

        //display message into Console
        console.log(reason);
      }

      //call Webservice to get Template's data
      $http({
        method: "GET",
        url: hostName.url + "api/Template/GetAllTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&isActive=''"
      }).then(successCallBack, errorCallBack);

      //check True/False for isActive chechbox
      $scope.checkShow = function(dataCheck){
        if (dataCheck) {
          return 1;
        }
        else {
          return 0;
        }
      };

      //changeEnterprise(sessionStorage.enterpriseId);
      //CHANGE ORGANIZATION
      $scope.changeOrganization = function(obj) {
        $scope.Enterprise = obj;

        //changeEnterprise($scope.Enterprise.ID);
      };
      //#CHANGE ORGANIZATION

      // function changeEnterprise(enterpriseId) {
      //   //GET TypeOfInvoice's Information
      //   $http({
      //       method: "GET",
      //       url: hostName.url + "api/TypeOfInvoice/GetAllTypeOfInvoice?enterpriseId=" + enterpriseId
      //   }).then(function(response) {
      //       $scope.TypeOfInvoices = response.data;
      //   }, function(reason) {
      //       console.log(reason);
      //   });
      // };

      // //save data to local variable when change Select's control
      // $scope.selectChanged = function(objectSelect) {
      //   $scope.TypeOfInvoice = objectSelect;
      // }
      
      //redirect to other pages
      $scope.open = function(url, id) {
          location.href = url;
          sessionStorage.itemId = id;
      };

      //filter Template's data
      $scope.findData = function() {
        vm.rowCollection = [];
        // var fromDate = angular.element(document).find('#inputStartDate')[0];
        // var toDate = angular.element(document).find('#inputEndDate')[0];
        var templateName = angular.element(document).find('#inputTemplateName')[0];
        var templateCode = angular.element(document).find('#inputTemplateCode')[0];
        //var typeOfInvoiceId = $scope.TypeOfInvoice != undefined ? $scope.TypeOfInvoice.ID : 0;  //get typeOfInvoiceId from UI Select
        var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
        var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
        var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
        var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
        //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
        
        if (isActiveAll.checked == true) {
          isActive = "";
        }
        else if (isActiveTrue.checked == true) {
          isActive = true;
        }
        else {
          isActive = false;
        }
        var queryString = "";
        queryString = "enterpriseId=" + enterpriseId + "&templateName=" + templateName.value 
                    + "&templateCode=" + templateCode.value + "&isActive=" + isActive;

        // if (fromDate != undefined) {
        //   var dateFrom = reConvertJSONDate(fromDate.value);//fromDate.value;//reConvertJSONDate(fromDate.value);
        //   var dateTo = reConvertJSONDate(toDate.value);//toDate.value;//reConvertJSONDate(toDate.value);

        //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&templateName=" + templateName.value + "&isActive=" + isActive;
        // }
        // else {
        //   var date = new Date();
        //   var nowYear = date.getFullYear();
        //   var nowMonth = date.getMonth();
        //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&templateName=&isActive=";
        // }
        
        //call Webservice to get Template's data
        $http({
          method: "GET",
          url: hostName.url + "api/Template/SearchTemplate?" + queryString,
        }).then(successCallBack, errorCallBack);
      }
      //end filter Template's data

      //update Status of Template
      $scope.updateStatus = function(flag, itemId) {
        if (flag == true) {
          //Stop
          swal({
            title: "Bạn muốn kích hoạt thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var inputData = {
                'ID': itemId,
                'isActive': true,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Template/UpdateTemplateActive", inputData).then(function(data){
                swal("Kích hoạt thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
        else {
          //Active
          swal({
            title: "Bạn muốn ngừng sử dụng thông tin này?",
            icon: "warning",
            buttons: ["Trở về", "Đồng ý!"],
            dangerMode: true,
          })
          .then(function(willDelete)  {
            if (willDelete) {
              var inputData = {
                'ID': itemId,
                'isActive': false,
                'userUpdated': user.ID
              };
              $http.post(hostName.url + "api/Template/UpdateTemplateActive", inputData).then(function(data){
                swal("Ngừng sử dụng thành công!", {
                  icon: "success",
                  button: "Đóng"
                }).then(function(){
                  $state.reload();
                });
              }, function(data) {
                swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                  icon: "error",
                  button: "Đóng"
                });
              });
            } else {
              //no action;
            }
          });
        }
      }

    };
    //******End controller for Template******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 18.09.2018
 */
(function () {
    'use strict';
  
    //declare controller for Template
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateTemplatePageCtrl', UpdateTemplatePageCtrl);

    /******************************************/
    /******controller for Update Template******/
    /******************************************/
    function UpdateTemplatePageCtrl($scope, $http, fileReader, layoutPaths, $rootScope, hostName) {
      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin mẫu hóa đơn";
      $scope.checkStatus = 'Y';
      //$scope.TypeOfInvoice = {};
      var user = JSON.parse(localStorage.getItem("dataUser"));
      $scope.Enterprise = [];

      //CHECK ADMIN PERMISSION
      $scope.isShow = false;
      var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
      if (userRole != undefined) {
          for (var ur = 0; ur < userRole.length; ur++) { 
              if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                  $scope.isShow = true;
          };
      }

      //load Template's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin mẫu hóa đơn";

        //call Webservice to get Template's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/Template/GetTemplate/" + itemId,
        }).then(function(response) {
          $scope.Template = [];
          $scope.Template = response.data;

          if ($scope.Template != undefined) {
            //put Template's data into Form's controls
            $scope.inputTemplateCode = $scope.Template.templateCode;
            $scope.inputTemplateName = $scope.Template.templateName;
            $scope.inputDescription = $scope.Template.description;
            //$scope.TypeOfInvoice.selected = {typeOfInvoiceName: $scope.Template.typeOfInvoiceName, ID: $scope.Template.typeOfInvoiceId};
            $scope.checkStatus = $scope.Template.isActive == true?'Y':'N';
            $scope.fileName = $rootScope.fileTemplate = $scope.Template.fileName;
            $scope.templateImage = $scope.Template.templateImage;

            //GET Enterprise's Information
            $http({
              method: "GET",
              url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.Template.enterpriseId,
            }).then(function(response) {
                var obj = response.data;
                $scope.Enterprise.selected = {ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN};
            }, function(reason) {
                console.log(reason);
            });
          }
        }, function(reason) {
          console.log(reason);
        });
      };

      //CHANGE ORGANIZATION
      //changeEnterprise(sessionStorage.enterpriseId);
      $scope.changeOrganization = function(obj) {
        $scope.Enterprise.selected = obj;

        //changeEnterprise($scope.Enterprise.selected.ID);
      };

      // function changeEnterprise(enterpriseId) {
      //   //GET TypeOfInvoice's Information
      //   $http({
      //       method: "GET",
      //       url: hostName.url + "api/TypeOfInvoice/GetAllTypeOfInvoice?enterpriseId=" + enterpriseId
      //   }).then(function(response) {
      //       $scope.TypeOfInvoices = response.data;
      //   }, function(reason) {
      //       console.log(reason);
      //   });
      // };
      //#CHANGE ORGANIZATION

      // $scope.selectChanged = function(objectSelect) {
      //   $scope.TypeOfInvoice = {};
      //   $scope.TypeOfInvoice.selected = objectSelect;
      // };

      /** Manage upload File **/
      $scope.uploadFile = function () {
        var fileInput = document.getElementById('uploadFile');
        fileInput.click();
      };

      $scope.getFile = function ($scope) {
          fileReader.readAsDataUrl($scope.file, $scope)
              .then(function (result) {
                var fileName = $scope.file.name;
                if (fileName.indexOf(".doc") <= 0 && fileName.indexOf(".docx") <= 0 ) {
                    swal({
                        title: "Vui lòng chọn đúng file định dạng Word!",
                        icon: "warning",
                        button: "Đóng"
                    }).then(function(){
                        return;
                    });
                }
                else {
                    $rootScope.fileTemplate = fileName;
                    var templateImage = "";

                    if (fileName.indexOf(".doc") >= 0 ) {
                        templateImage = fileName.substr(0, fileName.indexOf(".doc"));
                    }
                    if (fileName.indexOf(".docx") >= 0 ) {
                        templateImage = fileName.substr(0, fileName.indexOf(".docx"));
                    }

                    var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
                    var data = new FormData();
                    data.append("filename", $scope.file.name);
                    //data.append("storagePath", "Templates\\");
                    data.append("enterpriseId", enterpriseId);
                    data.append("templateImage", templateImage);
                    data.append("file", $scope.file);
                    //console.log(data.getAll("storagePath")[0]);

                    $rootScope.FileTemplateData = data;
                }
              });
      };
      /** End Manage upload Picture **/

      //save Template's data into Database via Webservice
      $scope.save = function () {

        var templateCode = angular.element(document).find('#inputTemplateCode')[0];
        var templateName = angular.element(document).find('#inputTemplateName')[0];
        //var typeOfInvoiceId = $scope.TypeOfInvoice.selected != undefined ? $scope.TypeOfInvoice.selected.ID : 0;
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var fileInput = document.getElementById('uploadFile');
        var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
        var flag = true;

        //check empty Enterprise
        if ($scope.isShow && $scope.Enterprise.selected == undefined) {
          swal({
              title: "Thông tin Đơn vị",
              text: 'không được để trống',
              icon: "warning",
              button: "Đóng"
          }).then(function(){
              $scope.$broadcast('SetFocusEnt');
          });
          flag = false;
          return;
        }

        //check empty templateCode
        if (templateCode.value == '') {
          swal({
            title: "Thông tin Mã mẫu hóa đơn",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            templateCode.focus();
          });
          flag = false;
          return;
        }

        //check templateCode can not have space ' '
        if (templateCode.value.indexOf(' ') > -1) {
          swal({
            title: "Thông tin Mã mẫu hóa đơn",
            text: 'không được có khoảng trắng',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            templateCode.focus();
          });
          flag = false;
          return;
        }

        //check empty templateName
        if (templateName.value == '') {
          swal({
            title: "Thông tin Tên mẫu hóa đơn",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            templateName.focus();
          });
          flag = false;
          return;
        }

        // //check empty typeOfInvoiceId
        // if (typeOfInvoiceId == 0) {
        //     swal({
        //         title: "Thông tin Loại hóa đơn",
        //         text: "không được để trống!",
        //         icon: "warning",
        //         button: "Đóng"
        //     }).then(function(){
        //         $scope.$broadcast('SetFocus');
        //     });
        //     flag = false;
        //     return;
        // }

        //alert($rootScope.FileTemplateData);
        if ($rootScope.fileTemplate == undefined) {
            swal({
                title: "File mẫu hóa đơn",
                text: "không được để trống!",
                icon: "warning",
                button: "Đóng"
            }).then(function(){
                fileInput.focus();
            });
            flag = false;
            return;
        }
        
        //declare variable to store information about Webservice with POST method
        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/template";
          });
          //console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/template";
          });
          console.log(data);
        }
        
        //check if data's input is not empty and call service to save data
        if (flag == true && sessionStorage.itemId == 'undefined') {
          //Add new Template's data

            //Upload file Template
            var data = new FormData();
            data = $rootScope.FileTemplateData;
            var reg = {
                url: hostName.url + 'api/Template/UploadFileToDocmentLibrary',
                method: 'POST',
                data: data,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
            }

            $http(reg).then(function(response){
                var fileName = data.getAll("filename")[0];
                var templateImage = data.getAll("templateImage")[0] + ".png";
                //var storagePath = data.getAll("storagePath")[0];

                var inputData = {
                  'templateCode': templateCode.value, 
                  'templateName': templateName.value, 
                  'fileName': fileName,
                  'templateImage': templateImage,
                  //'typeOfInvoiceId': typeOfInvoiceId, 
                  'description': description.value, 
                  'isActive': isActive.checked,
                  'enterpriseId': enterpriseId,
                  'userCreated': user.ID
                };
                //debugger;
                $http.post(hostName.url + "api/Template/AddTemplate", inputData)
                .then(successCallBack, errorCallBack);
            }, function(reason){
                swal({
                    title: "Thông báo",
                    text: "Không thể tải được file mẫu hóa đơn, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    console.log(data);
                });
            });

        }
        else if (flag == true && sessionStorage.itemId != 'undefined') {
          //update Template's data
          
          //update Template's data which doesn't update File Template
          if ($rootScope.FileTemplateData == undefined) {
            var itemId = sessionStorage.itemId.toString();
            var inputData = {
              'ID': itemId,
              'templateCode': templateCode.value, 
              'templateName': templateName.value, 
              'fileName': $scope.fileName,
              'templateImage': $scope.templateImage,
              //'typeOfInvoiceId': typeOfInvoiceId, 
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/Template/UpdateTemplate", inputData)
            .then(successCallBack, errorCallBack);
          }
          //update Template's data which has update File Template
          else {
            //Upload file Template
            var data = new FormData();
            data = $rootScope.FileTemplateData;
            var reg = {
                url: hostName.url + 'api/Template/UploadFileToDocmentLibrary',
                method: 'POST',
                data: data,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
            }

            $http(reg).then(function(response){
                var fileName = data.getAll("filename")[0];
                var templateImage = data.getAll("templateImage")[0] + ".png";
                //var storagePath = data.getAll("storagePath")[0];

                var itemId = sessionStorage.itemId.toString();
                var inputData = {
                  'ID': itemId,
                  'templateCode': templateCode.value, 
                  'templateName': templateName.value, 
                  'fileName': fileName,
                  'templateImage': templateImage,
                  //'typeOfInvoiceId': typeOfInvoiceId, 
                  'description': description.value, 
                  'isActive': isActive.checked,
                  'userUpdated': user.ID
                };
                //debugger;
                $http.post(hostName.url + "api/Template/UpdateTemplate", inputData)
                .then(successCallBack, errorCallBack);
            }, function(reason){
                swal({
                    title: "Thông báo",
                    text: "Không thể tải được file mẫu hóa đơn, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    console.log(data);
                });
            });
          };
          
        };

      }; //end function save Template's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };

    }
    /******End controller for Update Template******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for TypeOfInvoice
  angular.module('BlurAdmin.pages.lists')
    .controller('TypeOfInvoicePageCtrl', TypeOfInvoicePageCtrl);

  //******controller for TypeOfInvoice******
  function TypeOfInvoicePageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //CHECK ADMIN PERMISSION
    $scope.isShow = false;
    var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
    if (userRole != undefined) {
        for (var ur = 0; ur < userRole.length; ur++) { 
            if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                $scope.isShow = true;
        };
    }; //#CHECK ADMIN PERMISSION

    //function then call Webservice get TypeOfInvoice's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get TypeOfInvoice's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get TypeOfInvoice's data
    $http({
      method: "GET",
      url: hostName.url + "api/TypeOfInvoice/GetAllTypeOfInvoice?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };
    
    //CHANGE ORGANIZATION
    $scope.changeOrganization = function(obj) {
      $scope.Enterprise = obj;
    };
    //#CHANGE ORGANIZATION

    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter TypeOfInvoice's data
    $scope.findData = function() {
      vm.rowCollection = [];
      // var fromDate = angular.element(document).find('#inputStartDate')[0];
      // var toDate = angular.element(document).find('#inputEndDate')[0];
      var typeOfInvoiceCode = angular.element(document).find('#inputTypeOfInvoiceCode')[0];
      var typeOfInvoiceName = angular.element(document).find('#inputTypeOfInvoiceName')[0];
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";
      queryString = "enterpriseId=" + enterpriseId + "&typeOfInvoiceCode=" + typeOfInvoiceCode.value 
                  + "&typeOfInvoiceName=" + typeOfInvoiceName.value + "&isActive=" + isActive;

      // if (fromDate != undefined) {
      //   var dateFrom = reConvertJSONDate(fromDate.value);
      //   var dateTo = reConvertJSONDate(toDate.value);
        
      //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&typeOfInvoiceCode=" + typeOfInvoiceCode.value + "&typeOfInvoiceName=" + typeOfInvoiceName.value + "&isActive=" + isActive;
      // }
      // else {
      //   var date = new Date();
      //   var nowYear = date.getFullYear();
      //   var nowMonth = date.getMonth();
      //   queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&typeOfInvoiceCode=&typeOfInvoiceName=&isActive=";
      // }
       
      //call Webservice to get TypeOfInvoice's data
      $http({
        method: "GET",
        url: hostName.url + "api/TypeOfInvoice/SearchTypeOfInvoice?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter TypeOfInvoice's data

    //update Status of TypeOfInvoice
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TypeOfInvoice/UpdateTypeOfInvoiceStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TypeOfInvoice/UpdateTypeOfInvoiceStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for TypeOfInvoice******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for TypeOfInvoice
  angular.module('BlurAdmin.pages.lists')
    .controller('UpdateTypeOfInvoicePageCtrl', UpdateTypeOfInvoicePageCtrl);

  /******************************************/
  /******controller for Update TypeOfInvoice******/
  /******************************************/
  function UpdateTypeOfInvoicePageCtrl($scope, $http, hostName) {

    //Set data for Page Title
    $scope.PageTitle = "Tạo mới thông tin loại hóa đơn";
    $scope.checkStatus = 'Y';
    $scope.Enterprise = [];
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //CHECK ADMIN PERMISSION
    $scope.isShow = false;
    var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
    if (userRole != undefined) {
        for (var ur = 0; ur < userRole.length; ur++) { 
            if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                $scope.isShow = true;
        };
    }

    //load TypeOfInvoice's data from Database via Webservice with itemId
    if (sessionStorage.itemId != 'undefined') {
      // Decrypt
      //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
      //var itemId = bytes.toString(CryptoJS.enc.Utf8);
      var itemId = sessionStorage.itemId.toString();
      
      //Update Page Title
      $scope.PageTitle = "Cập nhật thông tin loại hóa đơn";

      //call Webservice to get TypeOfInvoice's data by Id
      $http({
        method: "GET",
        url: hostName.url + "api/TypeOfInvoice/GetTypeOfInvoice/" + itemId,
      }).then(function(response) {
        $scope.TypeOfInvoice = [];
        $scope.TypeOfInvoice = response.data;
        
        if ($scope.TypeOfInvoice != undefined) {
          //put TypeOfInvoice's data into Form's controls
          $scope.inputTypeOfInvoiceCode = $scope.TypeOfInvoice.typeOfInvoiceCode;
          $scope.inputTypeOfInvoiceName = $scope.TypeOfInvoice.typeOfInvoiceName;
          $scope.inputDescription = $scope.TypeOfInvoice.description;
          $scope.checkStatus = $scope.TypeOfInvoice.isActive == true?'Y':'N';

          //GET Enterprise's Information
          $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.TypeOfInvoice.enterpriseId,
          }).then(function(response) {
              var obj = response.data;
              $scope.Enterprise.selected = {ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN};
          }, function(reason) {
              console.log(reason);
          });
        }
      }, function(reason) {
        $log.info(reason);
      });
    }

    //CHANGE ORGANIZATION
    $scope.changeOrganization = function(obj) {
      $scope.Enterprise.selected = obj;
    };
    //#CHANGE ORGANIZATION

    //save TypeOfInvoice's data into Database via Webservice
    $scope.save = function () {

      var typeOfInvoiceCode = angular.element(document).find('#inputTypeOfInvoiceCode')[0];
      var typeOfInvoiceName = angular.element(document).find('#inputTypeOfInvoiceName')[0];
      var description = angular.element(document).find('#inputDescription')[0];
      var isActive = angular.element(document).find('#inputIsActive')[0];
      var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
      var flag = true;

      //check empty Enterprise
      if ($scope.isShow && $scope.Enterprise.selected == undefined) {
        swal({
            title: "Thông tin Đơn vị",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
        }).then(function(){
            $scope.$broadcast('SetFocusEnt');
        });
        flag = false;
        return;
      }

      //check empty typeOfInvoiceCode
      if (typeOfInvoiceCode.value == '') {
        swal({
          title: "Thông tin Mã loại hóa đơn",
          text: 'không được để trống',
          icon: "warning",
          button: "Đóng"
        }).then(function(){
          typeOfInvoiceCode.focus();
        });
        flag = false;
        return;
      }

      //check typeOfInvoiceCode can not have space ' '
      if (typeOfInvoiceCode.value.indexOf(' ') > -1) {
        swal({
          title: "Thông tin Mã loại hóa đơn",
          text: 'không được có khoảng trắng',
          icon: "warning",
          button: "Đóng"
        }).then(function(){
          typeOfInvoiceCode.focus();
        });
        flag = false;
        return;
      }

      //check empty typeOfInvoiceName
      if (typeOfInvoiceName.value == '') {
        swal({
          title: "Thông tin Tên loại hóa đơn",
          text: "không được để trống!",
          icon: "warning",
          button: "Đóng"
        }).then(function(){
          typeOfInvoiceName.focus();
        });
        flag = false;
        return;
      }

      function successCallBack(data) {
        swal({
          title: "Thông báo",
          text: "Lưu dữ liệu thành công!",
          icon: "success",
          button: "Đóng",
        }).then(function(){
          location.href = "#/typeOfInvoice";
        });
      }

      function errorCallBack(data) {
        swal({
          title: "Thông báo",
          text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
          icon: "error",
          dangerMode:true,
          button: "Đóng",
        }).then(function(){
          location.href = "#/typeOfInvoice";
        });
        console.log(data);
      }
      
      //check if data's input is not empty
      if (flag == true) {

        //update TypeOfInvoice's data
        if (sessionStorage.itemId != 'undefined') {
          //debugger;
          var inputData = {
            'ID': sessionStorage.itemId,
            'typeOfInvoiceCode': typeOfInvoiceCode.value, 
            'typeOfInvoiceName': typeOfInvoiceName.value, 
            'description': description.value, 
            'isActive': isActive.checked,
            'userUpdated': user.ID
          };
          $http.post(hostName.url + "api/TypeOfInvoice/UpdateTypeOfInvoice", inputData)
          .then(successCallBack, errorCallBack);
        }
        //Add new TypeOfInvoice's data
        else {
          var inputData = {
            'typeOfInvoiceCode': typeOfInvoiceCode.value, 
            'typeOfInvoiceName': typeOfInvoiceName.value, 
            'description': description.value, 
            'isActive': isActive.checked,
            'enterpriseId': enterpriseId,
            'userCreated': user.ID
          };
          //debugger;
          $http.post(hostName.url + "api/TypeOfInvoice/AddTypeOfInvoice", inputData)
          .then(successCallBack, errorCallBack);
        }
      }

    };
    //end function save TypeOfInvoice's data into Database via Webservice

    //redirect to other pages
    $scope.open = function(url) {
      location.href = url;
    };
  }
  /******End controller for Update TypeOfInvoice******/

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for TypeOfPayment
  angular.module('BlurAdmin.pages.lists')
    .controller('TypeOfPaymentPageCtrl', TypeOfPaymentPageCtrl);

  //******controller for TypeOfPayment******
  function TypeOfPaymentPageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //function then call Webservice get TypeOfPayment's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get TypeOfPayment's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get TypeOfPayment's data
    $http({
      method: "GET",
      url: hostName.url + "api/TypeOfPayment/GetAllTypeOfPayment?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };
    
    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter TypeOfPayment's data
    $scope.findData = function() {
      vm.rowCollection = [];
      var fromDate = angular.element(document).find('#inputFromDate')[0];
      var toDate = angular.element(document).find('#inputToDate')[0];
      var typeOfPaymentId = angular.element(document).find('#inputTypeOfPaymentId')[0];
      var typeOfPaymentName = angular.element(document).find('#inputTypeOfPaymentName')[0];
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";

      if (fromDate != undefined) {
        var dateFrom = reConvertJSONDate(fromDate.value);
        var dateTo = reConvertJSONDate(toDate.value);
        
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&typeOfPaymentId=" + typeOfPaymentId.value + "&typeOfPaymentName=" + typeOfPaymentName.value + "&isActive=" + isActive;
      }
      else {
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&typeOfPaymentId=&typeOfPaymentName=&isActive=";
      }
       
      //call Webservice to get TypeOfPayment's data
      $http({
        method: "GET",
        url: hostName.url + "api/TypeOfPayment/SearchTypeOfPayment?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter TypeOfPayment's data

    //update Status of TypeOfPayment
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TypeOfPayment/UpdateTypeOfPaymentStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TypeOfPayment/UpdateTypeOfPaymentStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for TypeOfPayment******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for TypeOfPayment
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateTypeOfPaymentPageCtrl', UpdateTypeOfPaymentPageCtrl);
  
    /******************************************/
    /******controller for Update TypeOfPayment******/
    /******************************************/
    function UpdateTypeOfPaymentPageCtrl($scope, $http, hostName) {
  
      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin hình thức thanh toán";
      $scope.checkStatus = 'Y';
      var user = JSON.parse(localStorage.getItem("dataUser"));
  
      //load TypeOfPayment's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin hình thức thanh toán";
  
        //call Webservice to get TypeOfPayment's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/TypeOfPayment/GetTypeOfPayment/" + itemId,
        }).then(function(response) {
          $scope.TypeOfPayment = [];
          $scope.TypeOfPayment = response.data;
          console.log($scope.TypeOfPayment);
          
          if ($scope.TypeOfPayment != undefined) {
            //put TypeOfPayment's data into Form's controls
            $scope.inputTypeOfPaymentId = $scope.TypeOfPayment.typeOfPaymentId;
            $scope.inputTypeOfPaymentName = $scope.TypeOfPayment.typeOfPaymentName;
            $scope.inputDescription = $scope.TypeOfPayment.description;
            $scope.checkStatus = $scope.TypeOfPayment.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          $log.info(reason);
        });
      }
  
      //save TypeOfPayment's data into Database via Webservice
      $scope.save = function () {
  
        var typeOfPaymentId = angular.element(document).find('#inputTypeOfPaymentId')[0];
        var typeOfPaymentName = angular.element(document).find('#inputTypeOfPaymentName')[0];
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var flag = true;
  
        //check empty typeOfPaymentId
        if (typeOfPaymentId.value == '') {
          swal({
            title: "Thông tin Mã hình thức thanh toán",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            typeOfPaymentId.focus();
          });
          flag = false;
          return;
        }
  
        //check empty typeOfPaymentName
        if (typeOfPaymentName.value == '') {
          swal({
            title: "Thông tin Tên hình thức thanh toán",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            typeOfPaymentName.focus();
          });
          flag = false;
          return;
        }
  
        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/typeOfPayment";
          });
          console.log(data);
        }
  
        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/typeOfPayment";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {
  
          //update TypeOfPayment's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var inputData = {
              'ID': sessionStorage.itemId,
              'typeOfPaymentId': typeOfPaymentId.value, 
              'typeOfPaymentName': typeOfPaymentName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/TypeOfPayment/UpdateTypeOfPayment", inputData)
            .then(successCallBack, errorCallBack);
          }
          //Add new TypeOfPayment's data
          else {
            var inputData = {
              'typeOfPaymentId': typeOfPaymentId.value, 
              'typeOfPaymentName': typeOfPaymentName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/TypeOfPayment/AddTypeOfPayment", inputData)
            .then(successCallBack, errorCallBack);
          }
        }
  
      };
      //end function save TypeOfPayment's data into Database via Webservice
  
      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update TypeOfPayment******/
  
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }
  
    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 30.09.2019
 */
(function () {
    'use strict';
  
    //declare controller for TypeOfRevenue
    angular.module('BlurAdmin.pages.lists')
        .controller('TypeOfRevenuePageCtrl', TypeOfRevenuePageCtrl);
  
    //******controller for TypeOfRevenue******
    function TypeOfRevenuePageCtrl($scope, $http, $state, hostName) {
  
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.TypeOfInvoice = {};
        $scope.Enterprise = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }
    
        function successCallBack(response) {
            vm.rowCollection = response.data;
    
            for (n=0; n < vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
            }
        };
    
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        }
    
        $http({
            method: "GET",
            url: hostName.url + "api/TypeOfRevenue/GetAllTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    
        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };

        //CHANGE ORGANIZATION
        changeEnterprise(sessionStorage.enterpriseId);
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise.selected = obj;

            changeEnterprise($scope.Enterprise.selected.ID);
        };

        function changeEnterprise(enterpriseId) {
            //GET TypeOfInvoice's Information
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfInvoice/GetAllTypeOfInvoice?enterpriseId=" + enterpriseId
            }).then(function(response) {
                $scope.TypeOfInvoices = response.data;
            }, function(reason) {
                console.log(reason);
            });
        };
        //#CHANGE ORGANIZATION
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        //CHANGE TYPE OF INVOICE
        $scope.changeTypeOfInvoice = function(obj) {
            $scope.TypeOfInvoice.selected = obj;
        }
        //#CHANGE TYPE OF INVOICE
    
        //filter TypeOfRevenue's data
        $scope.findData = function() {
            vm.rowCollection = [];
            // var fromDate = angular.element(document).find('#inputFromDate')[0];
            // var toDate = angular.element(document).find('#inputToDate')[0];
            var typeOfRevenueCode = angular.element(document).find('#inputTypeOfRevenueCode')[0];
            var typeOfRevenueName = angular.element(document).find('#inputTypeOfRevenueName')[0];
            var typeOfInvoiceId = $scope.TypeOfInvoice.selected != undefined ? $scope.TypeOfInvoice.selected.ID : "";
            var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
            var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
            var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
            var enterpriseId = $scope.Enterprise.selected != undefined ? $scope.Enterprise.selected.ID : sessionStorage.enterpriseId;
            
            if (isActiveAll.checked == true) {
                isActive = "";
            }
            else if (isActiveTrue.checked == true) {
                isActive = true;
            }
            else {
                isActive = false;
            }
            var queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&typeOfRevenueCode=" + typeOfRevenueCode.value 
                        + "&typeOfRevenueName=" + typeOfRevenueName.value 
                        + "&typeOfInvoiceId=" + typeOfInvoiceId 
                        + "&isActive=" + isActive;
    
            // if (fromDate != undefined) {
            //     var dateFrom = reConvertJSONDate(fromDate.value);
            //     var dateTo = reConvertJSONDate(toDate.value);
                
            //     queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&typeOfRevenueCode=" + typeOfRevenueCode.value + "&typeOfRevenueName=" + typeOfRevenueName.value + "&isActive=" + isActive;
            // }
            // else {
            //     var date = new Date();
            //     var nowYear = date.getFullYear();
            //     var nowMonth = date.getMonth();
            //     queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&typeOfRevenueCode=&typeOfRevenueName=&isActive=";
            // }
            
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/SearchTypeOfRevenue?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
    
        //update Status of TypeOfRevenue
        $scope.updateStatus = function(flag, itemId) {
            if (flag == true) {
                //Stop
                swal({
                    title: "Bạn muốn kích hoạt thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': true,
                            'userUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/TypeOfRevenue/UpdateTypeOfRevenueStatus", inputData).then(function(data){
                            swal("Kích hoạt thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                    //no action;
                    }
                });
            }
            else {
                //Active
                swal({
                    title: "Bạn muốn ngừng sử dụng thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': false,
                            'userUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/TypeOfRevenue/UpdateTypeOfRevenueStatus", inputData).then(function(data){
                            swal("Ngừng sử dụng thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                    //no action;
                    }
                });
            }
        }
    
    };
    //******End controller for TypeOfInvoice******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 30.09.2018
 */
(function () {
    'use strict';
  
    //declare controller for TypeOfRevenue
    angular.module('BlurAdmin.pages.lists')
        .controller('UpdateTypeOfRevenuePageCtrl', UpdateTypeOfRevenuePageCtrl);
  
    /******************************************/
    /******controller for Update TypeOfRevenue******/
    /******************************************/
    function UpdateTypeOfRevenuePageCtrl($scope, $http, hostName) {
  
        //Set data for Page Title
        $scope.PageTitle = "Tạo mới thông tin loại doanh thu";
        $scope.checkStatus = 'Y';
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.TypeOfInvoice = {};
        $scope.Enterprise = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }
    
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();
            
            //Update Page Title
            $scope.PageTitle = "Cập nhật thông tin loại doanh thu";
    
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfRevenue/GetTypeOfRevenue/" + itemId,
            }).then(function(response) {
                $scope.TypeOfRevenue = [];
                $scope.TypeOfRevenue = response.data;
                
                if ($scope.TypeOfRevenue != undefined) {
                    //put TypeOfRevenue's data into Form's controls
                    $scope.inputTypeOfRevenueCode = $scope.TypeOfRevenue.typeOfRevenueCode;
                    $scope.inputTypeOfRevenueName = $scope.TypeOfRevenue.typeOfRevenueName;
                    $scope.inputDescription = $scope.TypeOfRevenue.description;
                    $scope.checkStatus = $scope.TypeOfRevenue.isActive == true?'Y':'N';
                    $scope.TypeOfInvoice.selected = {ID: $scope.TypeOfRevenue.typeOfInvoiceId, typeOfInvoiceName: $scope.TypeOfRevenue.typeOfInvoiceName}
                
                    //GET Enterprise's Information
                    $http({
                        method: "GET",
                        url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.TypeOfRevenue.enterpriseId,
                    }).then(function(response) {
                        var obj = response.data;
                        $scope.Enterprise.selected = {ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN};
                    }, function(reason) {
                        console.log(reason);
                    });
                }
            }, function(reason) {
                console.log(reason);
            });
        }

        //CHANGE ORGANIZATION
        changeEnterprise(sessionStorage.enterpriseId);
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise.selected = obj;

            changeEnterprise($scope.Enterprise.selected.ID);
        };

        function changeEnterprise(enterpriseId) {
            //GET TypeOfInvoice's Information
            $http({
                method: "GET",
                url: hostName.url + "api/TypeOfInvoice/GetAllTypeOfInvoice?enterpriseId=" + enterpriseId
            }).then(function(response) {
                $scope.TypeOfInvoices = response.data;
                if ($scope.TypeOfInvoices.length == 0) {
                    $scope.TypeOfInvoice.selected = undefined;
                }
            }, function(reason) {
                console.log(reason);
            });
        };
        //#CHANGE ORGANIZATION

        //CHANGE TYPE OF INVOICE
        $scope.changeTypeOfInvoice = function(obj) {
            $scope.TypeOfInvoice.selected = obj;
        }
        //#CHANGE TYPE OF INVOICE
    
        //SAVE DATA TO DATABASE
        $scope.save = function () {
    
            var typeOfRevenueCode = angular.element(document).find('#inputTypeOfRevenueCode')[0];
            var typeOfRevenueName = angular.element(document).find('#inputTypeOfRevenueName')[0];
            var description = angular.element(document).find('#inputDescription')[0];
            var isActive = angular.element(document).find('#inputIsActive')[0];
            var typeOfInvoiceId = $scope.TypeOfInvoice.selected != undefined ? $scope.TypeOfInvoice.selected.ID : 0;
            var typeOfInvoiceName = $scope.TypeOfInvoice.selected != undefined ? $scope.TypeOfInvoice.selected.typeOfInvoiceName : "";
            var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
            var flag = true;

            //check empty Enterprise
            if ($scope.isShow && $scope.Enterprise.selected == undefined) {
                swal({
                    title: "Thông tin Đơn vị",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusEnt');
                });
                flag = false;
                return;
            }
    
            //check empty typeOfInvoiceId
            if (typeOfInvoiceId == 0) {
                swal({
                    title: "Thông tin Loại hóa đơn",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty typeOfRevenueCode
            if (typeOfRevenueCode.value == '') {
                swal({
                    title: "Thông tin Mã loại doanh thu",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    typeOfRevenueCode.focus();
                });
                flag = false;
                return;
            }

            //check typeOfRevenueCode can not have space ' '
            if (typeOfRevenueCode.value.indexOf(' ') > -1) {
                swal({
                    title: "Thông tin Mã loại doanh thu",
                    text: 'không được có khoảng trắng',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    typeOfRevenueCode.focus();
                });
                flag = false;
                return;
            }
    
            //check empty typeOfRevenueName
            if (typeOfRevenueName.value == '') {
                swal({
                    title: "Thông tin Tên loại doanh thu",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    typeOfRevenueName.focus();
                });
                flag = false;
                return;
            }
    
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/typeOfRevenue";
                });
            }
    
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/typeOfRevenue";
                });
                console.log(data);
            }
            
            //check if data's input is not empty
            if (flag == true) {
    
                //update TypeOfRevenue's data
                if (sessionStorage.itemId != 'undefined') {
                    var inputData = {
                        'ID': sessionStorage.itemId,
                        'typeOfRevenueCode': typeOfRevenueCode.value, 
                        'typeOfRevenueName': typeOfRevenueName.value, 
                        'typeOfInvoiceId': typeOfInvoiceId,
                        'typeOfInvoiceName': typeOfInvoiceName,
                        'description': description.value, 
                        'isActive': isActive.checked,
                        'userUpdated': user.ID
                    };

                    $http.post(hostName.url + "api/TypeOfRevenue/UpdateTypeOfRevenue", inputData)
                    .then(successCallBack, errorCallBack);
                }

                //Add new TypeOfRevenue's data
                else {
                    var inputData = {
                        'typeOfRevenueCode': typeOfRevenueCode.value, 
                        'typeOfRevenueName': typeOfRevenueName.value, 
                        'description': description.value, 
                        'typeOfInvoiceId': typeOfInvoiceId,
                        'typeOfInvoiceName': typeOfInvoiceName,
                        'isActive': isActive.checked,
                        'enterpriseId': enterpriseId,
                        'userCreated': user.ID
                    };
                    
                    $http.post(hostName.url + "api/TypeOfRevenue/AddTypeOfRevenue", inputData)
                    .then(successCallBack, errorCallBack);
                }

            }
    
        };
    
        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };
    }
    /******End controller for Update TypeOfRevenue******/
  
    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }
  
    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
  'use strict';

  //declare controller for Unit
  angular.module('BlurAdmin.pages.lists')
    .controller('UnitPageCtrl', UnitPageCtrl);

  //******controller for Unit******
  function UnitPageCtrl($scope, $http, $state, hostName) {

    $scope.smartTablePageSize = 10;
    var n = 0;
    var vm = this;
    vm.rowCollection = [];
    sessionStorage.itemId = undefined;
    var user = JSON.parse(localStorage.getItem("dataUser"));

    //function then call Webservice get Unit's data is success
    function successCallBack(response) {
      vm.rowCollection = response.data;

      for (n=0; n < vm.rowCollection.length; n++) {
        // Encrypt
        vm.rowCollection[n].No = n+1;
        vm.rowCollection[n].dateUpdated = convertJSONDate(vm.rowCollection[n].dateUpdated);
        //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
      }

      //display message into Console
      //console.log(response);
    };

    //function then call Webservice get Unit's data is error
    function errorCallBack(reason) {
      $scope.error = reason.data;

      //display message into Console
      console.log(reason);
    }

    //call Webservice to get Unit's data
    $http({
      method: "GET",
      url: hostName.url + "api/Unit/GetAllUnit?enterpriseId=" + sessionStorage.enterpriseId
    }).then(successCallBack, errorCallBack);

    //check True/False for isActive chechbox
    $scope.checkShow = function(dataCheck){
      if (dataCheck) {
        return 1;
      }
      else {
        return 0;
      }
    };
    
    //redirect to other pages
    $scope.open = function(url, id) {
      location.href = url;
      sessionStorage.itemId = id;
    };

    //filter Unit's data
    $scope.findData = function() {
      vm.rowCollection = [];
      var fromDate = angular.element(document).find('#inputFromDate')[0];
      var toDate = angular.element(document).find('#inputToDate')[0];
      var unitId = angular.element(document).find('#inputUnitId')[0];
      var unitName = angular.element(document).find('#inputUnitName')[0];
      var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
      var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
      var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
      //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
      if (isActiveAll.checked == true) {
        isActive = "";
      }
      else if (isActiveTrue.checked == true) {
        isActive = true;
      }
      else {
        isActive = false;
      }
      var queryString = "";

      if (fromDate != undefined) {
        var dateFrom = reConvertJSONDate(fromDate.value);
        var dateTo = reConvertJSONDate(toDate.value);
        
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + dateFrom + "&toDate=" + dateTo + "&unitId=" + unitId.value + "&unitName=" + unitName.value + "&isActive=" + isActive;
      }
      else {
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&unitId=&unitName=&isActive=";
      }
       
      //call Webservice to get Unit's data
      $http({
        method: "GET",
        url: hostName.url + "api/Unit/SearchUnit?" + queryString,
      }).then(successCallBack, errorCallBack);
    }
    //end filter Unit's data

    //update Status of Unit
    $scope.updateStatus = function(flag, itemId) {
      if (flag == true) {
        //Stop
        swal({
          title: "Bạn muốn kích hoạt thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': true,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/Unit/UpdateUnitStatus", inputData).then(function(data){
              swal("Kích hoạt thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
      else {
        //Active
        swal({
          title: "Bạn muốn ngừng sử dụng thông tin này?",
          icon: "warning",
          buttons: ["Trở về", "Đồng ý!"],
          dangerMode: true,
        })
        .then(function(willDelete)  {
          if (willDelete) {
            var inputData = {
              'ID': itemId,
              'isActive': false,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/Unit/UpdateUnitStatus", inputData).then(function(data){
              swal("Ngừng sử dụng thành công!", {
                icon: "success",
                button: "Đóng"
              }).then(function(){
                $state.reload();
              });
            }, function(data) {
              swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                icon: "error",
                button: "Đóng"
              });
            });
          } else {
            //no action;
          }
        });
      }
    }

  };
  //******End controller for Unit******

  //Commmon function to convert JSON Date to Normal Date
  function convertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    var currentTime = new Date(strDate);
    var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
    var day = ("0" + currentTime.getDate()).slice(-2);
    var year = currentTime.getFullYear();
    var date = day + '/' + month + '/' + year;
    return date;
  }

  function reConvertJSONDate(strDate) {
    //var dateString = strDate.substr(6);
    //var currentTime = new Date(strDate);
    var day = strDate.slice(0,2);
    var month = strDate.slice(3,5);
    var year = strDate.slice(6,10);
    var date = month + '/' + day + '/' +  year;
    if (strDate == "")
      return "";
    else return date;
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 28.08.2018
 */
(function () {
    'use strict';
  
    //declare controller for Unit
    angular.module('BlurAdmin.pages.lists')
      .controller('UpdateUnitPageCtrl', UpdateUnitPageCtrl);

    /******************************************/
    /******controller for Update Unit******/
    /******************************************/
    function UpdateUnitPageCtrl($scope, $http, hostName) {

      //Set data for Page Title
      $scope.PageTitle = "Tạo mới thông tin đơn vị tính";
      $scope.checkStatus = 'Y';
      var user = JSON.parse(localStorage.getItem("dataUser"));

      //load Unit's data from Database via Webservice with itemId
      if (sessionStorage.itemId != 'undefined') {
        // Decrypt
        //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
        //var itemId = bytes.toString(CryptoJS.enc.Utf8);
        var itemId = sessionStorage.itemId.toString();
        
        //Update Page Title
        $scope.PageTitle = "Cập nhật thông tin đơn vị tính";

        //call Webservice to get Unit's data by Id
        $http({
          method: "GET",
          url: hostName.url + "api/Unit/GetUnit/" + itemId,
        }).then(function(response) {
          $scope.Unit = [];
          $scope.Unit = response.data;
          //console.log($scope.Unit);
          
          if ($scope.Unit != undefined) {
            //put Unit's data into Form's controls
            $scope.inputUnitId = $scope.Unit.unitId;
            $scope.inputUnitName = $scope.Unit.unitName;
            $scope.inputDescription = $scope.Unit.description;
            $scope.checkStatus = $scope.Unit.isActive == true?'Y':'N';
          }
        }, function(reason) {
          $scope.error = reason.data;
          $log.info(reason);
        });
      }

      //save Unit's data into Database via Webservice
      $scope.save = function () {

        var unitId = angular.element(document).find('#inputUnitId')[0];
        var unitName = angular.element(document).find('#inputUnitName')[0];
        var description = angular.element(document).find('#inputDescription')[0];
        var isActive = angular.element(document).find('#inputIsActive')[0];
        var flag = true;

        //check empty unitId
        if (unitId.value == '') {
          swal({
            title: "Thông tin Mã đơn vị tính",
            text: 'không được để trống',
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            unitId.focus();
          });
          flag = false;
          return;
        }

        //check empty unitName
        if (unitName.value == '') {
          swal({
            title: "Thông tin Tên đơn vị tính",
            text: "không được để trống!",
            icon: "warning",
            button: "Đóng"
          }).then(function(){
            unitName.focus();
          });
          flag = false;
          return;
        }

        function successCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Lưu dữ liệu thành công!",
            icon: "success",
            button: "Đóng",
          }).then(function(){
            location.href = "#/unit";
          });
          console.log(data);
        }

        function errorCallBack(data) {
          swal({
            title: "Thông báo",
            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
            icon: "error",
            dangerMode:true,
            button: "Đóng",
          }).then(function(){
            location.href = "#/unit";
          });
          console.log(data);
        }
        
        //check if data's input is not empty
        if (flag == true) {

          //update Unit's data
          if (sessionStorage.itemId != 'undefined') {
            //debugger;
            var inputData = {
              'ID': sessionStorage.itemId,
              'unitId': unitId.value, 
              'unitName': unitName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'userUpdated': user.ID
            };
            $http.post(hostName.url + "api/Unit/UpdateUnit", inputData)
            .then(successCallBack, errorCallBack);
          }
          //Add new Unit's data
          else {
            var inputData = {
                'unitId': unitId.value, 
                'unitName': unitName.value, 
              'description': description.value, 
              'isActive': isActive.checked,
              'enterpriseId': sessionStorage.enterpriseId,
              'userCreated': user.ID
            };
            //debugger;
            $http.post(hostName.url + "api/Unit/AddUnit", inputData)
            .then(successCallBack, errorCallBack);
          }
        }

      };
      //end function save Unit's data into Database via Webservice

      //redirect to other pages
      $scope.open = function(url) {
        location.href = url;
      };
    }
    /******End controller for Update Unit******/

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      var currentTime = new Date(strDate);
      var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
      var day = ("0" + currentTime.getDate()).slice(-2);
      var year = currentTime.getFullYear();
      var date = day + '/' + month + '/' + year;
      return date;
    }

    function reConvertJSONDate(strDate) {
      //var dateString = strDate.substr(6);
      //var currentTime = new Date(strDate);
      var day = strDate.slice(0,2);
      var month = strDate.slice(3,5);
      var year = strDate.slice(6,10);
      var date = month + '/' + day + '/' +  year;
      if (strDate == "")
        return "";
      else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 29.05.2020
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .directive('clusteredBarChart', clusteredBarChart);
  
    /** @ngInject */
    function clusteredBarChart() {
        return {
            restrict: 'E',
            controller: 'ClusteredBarChart',
            templateUrl: 'app/pages/dashboard/am4Chart/clusteredBarChart.html'
        };
    }
    
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    //am4core.useTheme(am4themes_frozen);
    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('ClusteredBarChart', ClusteredBarChart);
  
    /** @ngInject */
    function ClusteredBarChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO CLUSTERED BAR CHART: HOA DON VA DOANH THU QUA 5 NAM
         */
        // Create chart instance
        var chart = am4core.create("clusteredBarChart", am4charts.XYChart3D);
        //chart.numberFormatter.numberFormat = "#,###.##";
        
        // Create axes
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Title";
        categoryAxis.numberFormatter.numberFormat = "#,###.##";
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.cellStartLocation = 0.1;
        categoryAxis.renderer.cellEndLocation = 0.9;
        categoryAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        
        var  valueAxis = chart.xAxes.push(new am4charts.ValueAxis()); 
        valueAxis.renderer.opposite = true;
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        
        // Create series
        function createSeries(field, name, color) {
            var series = chart.series.push(new am4charts.ColumnSeries3D());
            series.dataFields.valueX = field;
            series.dataFields.categoryY = "Title";
            series.name = name;
            series.fill = am4core.color(color);
            series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
            series.columns.template.height = am4core.percent(100);
            series.sequencedInterpolation = true;
            series.columns.template.fillOpacity = .8;
        
            var valueLabel = series.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.fill = am4core.color("#FFFFFF");
            valueLabel.label.text = "{valueX}";
            valueLabel.label.horizontalCenter = "left";
            valueLabel.label.dx = 10;
            valueLabel.label.hideOversized = false;
            valueLabel.label.truncate = false;
        
            var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
            categoryLabel.label.text = "{name}";
            categoryLabel.label.horizontalCenter = "right";
            categoryLabel.label.dx = -5;
            categoryLabel.label.fill = am4core.color("#FFFFFF");
            categoryLabel.label.hideOversized = false;
            categoryLabel.label.truncate = false;

            series.columns.template.interactionsEnabled = true;
            series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            series.columns.template.events.on("hit", function(ev) {
                var item = ev.target.dataItem.dataContext;

                sessionStorage.typeOfDetail = ev.target.dataItem.component.dataFields.valueX == "Value1" ? "HD" : "DT"; // HD | DT
                sessionStorage.yearValue = item.Title;
                sessionStorage.monthValue = 0;
                if ($scope.checkUrl == "BV") {
                    location.href = "#/invoiceApproved";
                }
                else {
                    location.href = "#/businessInvoice";
                }
                
            }, this);
        }

        // Add a legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.labels.template.fill = am4core.color("#FFF");

        var flagOnce = 1;

        loadData4Chart();
        function loadData4Chart() {
            //Lay Doanh thu theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetInvoiceAndRevenueOverYears?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                $scope.ClusteredBarChartTitle = response.data.Title[0];
                $scope.checkUrl = response.data.Title[3];
                
                if (flagOnce == 1) {
                    flagOnce = 2;
                    createSeries("Value1", response.data.Title[1], "#5EC5FF");
                    createSeries("Value2", response.data.Title[2], "#0975DA");
                }

                chart.data = response.data.ChartData;
                
            }, function(reason) {
                console.log(reason);
            });
        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 05/12/2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .controller('detailStep1Ctrl', detailStep1Ctrl);
  
    /** @ngInject */
    function detailStep1Ctrl($scope) {

        if (sessionStorage.enterpriseId == undefined || sessionStorage.enterpriseId == "undefined" ) {
            location.href = "/authSignIn";
        }

        //var NowADay = new Date();
        $scope.thisYear = sessionStorage.yearValue; //NowADay.getFullYear();

        //Init page
        if (sessionStorage.typeOfDetail == "HD") {
            if (sessionStorage.monthValue == 0) {
                $scope.Title1 = "Hóa đơn đã lập theo Loại hóa đơn trong năm " + sessionStorage.yearValue;
                $scope.Title2 = "Hóa đơn đã lập theo Loại hóa đơn (Tăng trưởng)";
            }
            else {
                $scope.Title1 = "Hóa đơn đã lập theo Loại hóa đơn trong tháng " + sessionStorage.monthValue + "/" + sessionStorage.yearValue;
                $scope.Title2 = "Hóa đơn đã lập theo Loại hóa đơn (Tăng trưởng theo ngày)";
            }
        }
        else if (sessionStorage.typeOfDetail == "DT") {
            if (sessionStorage.monthValue == 0) {
                $scope.Title1 = "Doanh thu theo Loại hóa đơn trong năm " + sessionStorage.yearValue + " (triệu đồng)";
                $scope.Title2 = "Doanh thu theo Loại hóa đơn (Tăng trưởng)";
            }
            else {
                $scope.Title1 = "Doanh thu theo Loại hóa đơn trong tháng " + sessionStorage.monthValue + "/" + sessionStorage.yearValue;
                $scope.Title2 = "Doanh thu theo Loại hóa đơn (Tăng trưởng theo ngày)";
            }
        }
        else {
            $scope.Title1 = "";
            $scope.Title2 = "";
        }

        //Back to Last Page 
        $scope.backLastPage = function() {
            sessionStorage.urlLastPage = "#/dashboard";
            location.href = sessionStorage.urlLastPage;
        }

    }
  
})();
/**
 * @author Nguyen Huu Tuan
 * created on 06/12/2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .controller('detailStep2Ctrl', detailStep2Ctrl);
  
    /** @ngInject */
    function detailStep2Ctrl($scope, $http, hostName) {

        if (sessionStorage.enterpriseId == undefined || sessionStorage.enterpriseId == "undefined" ) {
            location.href = "/authSignIn";
        }

        //var NowADay = new Date();
        $scope.thisYear = sessionStorage.yearValue; //NowADay.getFullYear();

        //Back to Last Page 
        $scope.backLastPage = function() {
            location.href = sessionStorage.urlLastPage;
        }

        $scope.smartTablePageSize = 10;
        $scope.TotalAmount = 0;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        vm.TotalAmount = 0;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.pathFileInvoice = hostName.url;

        //function then call  WEB API get ElectricInvoice's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data.Table1;
            vm.TotalAmount = 0;
            var total = response.data.Table2[0].totalAmount;
            
            if (total != undefined) {
                vm.TotalAmount = total.replace(/,/g,".");
            }
        };

        //function then call WEB API get ElectricInvoice's data is error
        function errorCallBack(reason) {

            //display message into Console
            console.log(reason);
        }

        //call WEB API to get ElectricInvoice's data
        var queryString = "";
        queryString = "enterpriseId=" + sessionStorage.enterpriseId 
                    + "&Year=" + sessionStorage.yearValue 
                    + "&Month=" + sessionStorage.monthValue 
                    + "&Day=" + sessionStorage.dayValue
                    + "&LoaiHoaDon=" + sessionStorage.LoaiHoaDon
                    + "&typeOfDetail=" + sessionStorage.typeOfDetail;
        $http({
            method: "GET",
            url: hostName.url + "api/Dashboard/GetListElectricInvoices?" + queryString
        }).then(successCallBack, errorCallBack);

    }
  
})();
/**
 * @author Nguyen Huu Tuan
 * created on 29.05.2020
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .directive('growthRevenueBarChart', growthRevenueBarChart);
  
    /** @ngInject */
    function growthRevenueBarChart() {
        return {
            restrict: 'E',
            controller: 'GrowthRevenueBarChart',
            templateUrl: 'app/pages/dashboard/am4Chart/growthRevenueBarChart.html'
        };
    }
    
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('GrowthRevenueBarChart', GrowthRevenueBarChart);
  
    /** @ngInject */
    function GrowthRevenueBarChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO BAR CHART: HOA DON NAM HIEN TAI
         */

        // Create chart instance
        var chart = am4core.create("barChartGrowthRevenue", am4charts.XYChart3D);

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Title";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.hideOversized = false;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.tooltip.label.rotation = 270;
        categoryAxis.tooltip.label.horizontalCenter = "right";
        categoryAxis.tooltip.label.verticalCenter = "middle";
        // categoryAxis.renderer.grid.template.location = 0;
        // categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");

        // categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
        //     if (target.dataItem && target.dataItem.index & 2 == 2) {
        //         return dy + 25;
        //     }
        //     return dy;
        // });

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "(" + ($scope.thisYear-1) + " - " + $scope.thisYear + ")";
        valueAxis.title.fill = am4core.color("#FFFFFF");
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        // valueAxis.renderer.labels.template.adapter.add("text", function(text) {
        //     return text + "%";
        // });

        // Create series1
        var series1 = chart.series.push(new am4charts.ColumnSeries3D());
        series1.dataFields.valueY = "Value1";
        series1.dataFields.categoryX = "Title";
        series1.clustered = false;
        series1.columns.template.fillOpacity = .8;
        series1.fill = am4core.color("#5EC5FF"); //#C767DC
        //series.columns.template.alwaysShowTooltip = true;

        // Create series2
        var series2 = chart.series.push(new am4charts.ColumnSeries3D());
        series2.dataFields.valueY = "Value2";
        series2.dataFields.categoryX = "Title";
        series2.clustered = false;
        series2.fill = am4core.color("#0975DA"); //#8067DC

        var columnTemplate1 = series1.columns.template;
        var columnTemplate2 = series2.columns.template;
        columnTemplate1.strokeWidth = columnTemplate2.strokeWidth = 2;
        columnTemplate1.strokeOpacity = columnTemplate2.strokeOpacity = 1;
        columnTemplate1.stroke = columnTemplate2.stroke = am4core.color("#FFFFFF");

        // columnTemplate1.adapter.add("fill", function(fill, target) {
        //     return chart.colors.getIndex(target.dataItem.index);
        // });
          
        // columnTemplate1.adapter.add("stroke", function(stroke, target) {
        //     return chart.colors.getIndex(target.dataItem.index);
        // });

        // columnTemplate2.adapter.add("fill", function(fill, target) {
        //     return chart.colors.getIndex(target.dataItem.index);
        // });
          
        // columnTemplate2.adapter.add("stroke", function(stroke, target) {
        //     return chart.colors.getIndex(target.dataItem.index);
        // });
          
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineY.strokeOpacity = 0;

        // Add a legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.labels.template.fill = am4core.color("#FFF");

        series1.columns.template.interactionsEnabled = true;
        series1.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series1.columns.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.dataContext;
            var year = ev.target.tooltipText.substr(ev.target.tooltipText.indexOf("Năm ") + 4, 4);
            var month = item.Title.substr(item.Title.indexOf("Tháng ") + 6);
            
            sessionStorage.typeOfDetail = "DT"; // HD | DT
            sessionStorage.yearValue = year;
            sessionStorage.monthValue = month;
            
            if ($scope.checkUrl == "BV") {
                location.href = "#/invoiceApproved";
            }
            else {
                location.href = "#/businessInvoice";
            }
        }, this);

        series2.columns.template.interactionsEnabled = true;
        series2.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series2.columns.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.dataContext;
            var year = ev.target.tooltipText.substr(ev.target.tooltipText.indexOf("Năm ") + 4, 4);
            var month = item.Title.substr(item.Title.indexOf("Tháng ") + 6);
            
            sessionStorage.typeOfDetail = "DT"; // HD | DT
            sessionStorage.yearValue = year;
            sessionStorage.monthValue = month;

            if ($scope.checkUrl == "BV") {
                location.href = "#/invoiceApproved";
            }
            else {
                location.href = "#/businessInvoice";
            }
        }, this);

        loadData4Chart();
        function loadData4Chart() {
            //Lay So hoa don theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetGrowthRevenue?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                $scope.yearSeries = response.data.Title;
                chart.data = response.data.ChartData;

                $scope.RevenueBarChartTitle = $scope.yearSeries[0];
                $scope.checkUrl = response.data.Title[3];

                series1.name = $scope.yearSeries[1];
                series1.columns.template.tooltipText = "Doanh thu (" + $scope.yearSeries[1] + "): [bold]{valueY}[/]";

                series2.name = $scope.yearSeries[2];
                series2.columns.template.tooltipText = "Doanh thu (" + $scope.yearSeries[2] + "): [bold]{valueY}[/]";

            }, function(reason) {
                console.log(reason);
            });
        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
    
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('invoice3DBarChart', invoice3DBarChart);
  
    /** @ngInject */
    function invoice3DBarChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO BAR CHART: HOA DON NAM HIEN TAI
         */
        // Create chart instance
        var chart = am4core.create("barChartInvoice", am4charts.XYChart3D);
        chart.showHandOnHover = true;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Title";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.hideOversized = false;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.tooltip.label.rotation = 270;
        categoryAxis.tooltip.label.horizontalCenter = "right";
        categoryAxis.tooltip.label.verticalCenter = "middle";
        //categoryAxis.renderer.grid.template.location = 0;
        //categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");

        // categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
        //     if (target.dataItem && target.dataItem.index & 2 == 2) {
        //         return dy + 25;
        //     }
        //     return dy;
        // });

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        //valueAxis.title.text = "Số hóa đơn (" + $scope.thisYear + ")";
        valueAxis.title.fill = am4core.color("#FFFFFF");
        //valueAxis.title.fontWeight = "bold";
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        //valueAxis.renderer.labels.template.fontSize = 20;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "Value1";
        series.dataFields.categoryX = "Title";

        //SET DATA TO GET WHEN CLICK ON COLUMN
        series.dataFields.categoryY = "Value2";
        series.dataFields.valueX = "Value3";

        series.name = "Value1";
        //series.stroke = am4core.color("#CDA2AB");
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;
        //series.columns.template.alwaysShowTooltip = true;
        series.columns.template.interactionsEnabled = true;
        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        //series.strokeWidth = 2;
        //series.minBulletDistance = 15;
        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";
        // series.events.on("tooltipshownat", function(event){
        //     console.log(event.dataItem.dataContext)
        // });

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        columnTemplate.stroke = am4core.color("#FFFFFF");

        columnTemplate.adapter.add("fill", function(fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });
          
        columnTemplate.adapter.add("stroke", function(stroke, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });
          
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineY.strokeOpacity = 0;

        series.columns.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.dataContext;
            sessionStorage.urlLastPage = "#/dashboard";
            sessionStorage.typeOfDetail = "HD"; // HD | DT
            sessionStorage.yearValue = item.Value2;
            sessionStorage.monthValue = item.Value3;
            location.href = "#/detailStep1";
            //console.log(ev.target.dataItem.dataContext.Value3);
            //console.log(ev.target.dataItem.valueY);
        }, this);

        loadData4Chart();
        function loadData4Chart() {
            //Lay So hoa don theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetBarChartYearInvoicesAM?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                chart.data = response.data;
                
            }, function(reason) {
                console.log(reason);
            });
        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    //am4core.useTheme(am4themes_frozen);
    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('revenue3DBarChart', revenue3DBarChart);
  
    /** @ngInject */
    function revenue3DBarChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO BAR CHART: DOANH THU NAM HIEN TAI
         */
        // Create chart instance
        var chart = am4core.create("barChartRevenue", am4charts.XYChart3D);

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Title";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.hideOversized = false;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.tooltip.label.rotation = 270;
        categoryAxis.tooltip.label.horizontalCenter = "right";
        categoryAxis.tooltip.label.verticalCenter = "middle";
        //categoryAxis.renderer.grid.template.location = 0;
        //categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");

        // categoryAxis.renderer.labels.template.adapter.add("dy", function(dy, target) {
        //     if (target.dataItem && target.dataItem.index & 2 == 2) {
        //         return dy + 25;
        //     }
        //     return dy;
        // });

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        //valueAxis.title.text = "Doanh thu (" + $scope.thisYear + ")";
        valueAxis.title.fill = am4core.color("#FFFFFF");
        //valueAxis.title.fontWeight = "bold";
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        //valueAxis.renderer.labels.template.fontSize = 20;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "Value1";
        series.dataFields.categoryX = "Title";

        //SET DATA TO GET WHEN CLICK ON COLUMN
        series.dataFields.categoryY = "Value2";
        series.dataFields.valueX = "Value3";
        series.name = "Value1";
        //series.stroke = am4core.color("#CDA2AB");
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;
        //series.columns.template.alwaysShowTooltip = true;
        series.columns.template.interactionsEnabled = true;
        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        //series.strokeWidth = 2;
        //series.minBulletDistance = 15;
        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";
        // series.events.on("tooltipshownat", function(event){
        //     console.log(event.dataItem.dataContext)
        // });

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        columnTemplate.stroke = am4core.color("#FFFFFF");

        columnTemplate.adapter.add("fill", function(fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });
          
        columnTemplate.adapter.add("stroke", function(stroke, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });
          
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineY.strokeOpacity = 0;

        series.columns.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.dataContext;
            sessionStorage.urlLastPage = "#/dashboard";
            sessionStorage.typeOfDetail = "DT"; // HD | DT
            sessionStorage.yearValue = item.Value2;
            sessionStorage.monthValue = item.Value3;
            location.href = "#/detailStep1";
            //console.log(ev.target.dataItem.dataContext.Value3);
            //console.log(ev.target.dataItem.valueY);
        }, this);

        loadData4Chart();
        function loadData4Chart() {
            //Lay Doanh thu theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetBarChartYearRevenueAM?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                chart.data = response.data;
                
            }, function(reason) {
                console.log(reason);
            });

        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    //am4core.useTheme(am4themes_frozen);
    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('semiPieChart', semiPieChart);
  
    /** @ngInject */
    function semiPieChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO STACKED COLUMN CHART: DOANH THU THEO LOAI HOA DON
         */
        // Create chart instance
        var chart = am4core.create("semiPieChart", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.radius = am4core.percent(70);
        chart.innerRadius = am4core.percent(40);
        chart.startAngle = 180;
        chart.endAngle = 360;

        var series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "Value1";
        series.dataFields.category = "Title";
        series.dataFields.text = "Value2";
        series.labels.template.fill = am4core.color("#FFF");

        series.slices.template.cornerRadius = 10;
        series.slices.template.innerCornerRadius = 7;
        series.slices.template.draggable = true;
        series.slices.template.inert = false;
        
        series.ticks.template.disabled = true;
        series.alignLabels = false;
        series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        series.labels.template.radius = am4core.percent(-30);
        series.labels.template.relativeRotation = 90;

        series.hiddenState.properties.startAngle = 90;
        series.hiddenState.properties.endAngle = 90;

        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.labels.template.fill = am4core.color("#FFF");
        chart.legend.labels.template.text = "{name}: {value.percent.formatNumber('#.0')} %";
        series.legendSettings.valueText = "{valueY.close}";

        series.slices.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series.slices.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.dataContext;
            sessionStorage.urlLastPage = "#/detailStep1";
            sessionStorage.LoaiHoaDon = item.Value2;
            sessionStorage.dayValue = 0;
            location.href = "#/detailStep2";
            //console.log(ev.target.dataItem.dataContext.Value3);
            //console.log(ev.target.dataItem.valueY);
        }, this);

        loadData4Chart();
        function loadData4Chart() {
            if (sessionStorage.typeOfDetail == "HD") { //Lay So Hoa don theo nam
                $http.get(hostName.url + "api/Dashboard/GetPieChartYearInvoicesAM?Year=" + sessionStorage.yearValue 
                    + "&Month=" + sessionStorage.monthValue
                    + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                    
                    chart.data = response.data;
                    
                }, function(reason) {
                    console.log(reason);
                });
            }
            else {  //Lay Doanh thu Loai Hoa Don theo nam
                $http.get(hostName.url + "api/Dashboard/GetPieChartYearRevenueAM?Year=" + sessionStorage.yearValue 
                    + "&Month=" + sessionStorage.monthValue
                    + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                    
                    chart.data = response.data;
                    
                }, function(reason) {
                    console.log(reason);
                });
            }
        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    //am4core.useTheme(am4themes_frozen);
    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('stackedAreaChart', stackedAreaChart);
  
    /** @ngInject */
    function stackedAreaChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO STACKED AREA CHART: DOANH THU THEO LOAI HOA DON
         */
        // Create chart instance
        var chart = am4core.create("barChartArea", am4charts.XYChart);
        
        if (sessionStorage.monthValue == 0) {
            chart.dateFormatter.inputDateFormat = "yyyy-MM";
        }
        else {
            chart.dateFormatter.inputDateFormat = "dd";
        }
        
        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 60;
        if (sessionStorage.monthValue == 0) {
            dateAxis.dateFormats.setKey("month", "MM/yyyy");
            dateAxis.periodChangeDateFormats.setKey("month", "MM/yyyy");
        }
        else {
            dateAxis.dateFormats.setKey("day", "dd");
            dateAxis.periodChangeDateFormats.setKey("day", "dd");
        }
        dateAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        dateAxis.startLocation = 0.5;
        dateAxis.endLocation = 0.5;
        dateAxis.baseInterval = {
            timeUnit: "Title",
            count: 1
        }
        
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");
        
        var series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "Title";
        //series.legendSettings.labelText = "[bold {color}]{name}[/]";
        series.dataFields.valueY = "Value1";
        series.tooltipText = "[#000]{valueY.value}[/]";
        series.tooltip.background.fill = am4core.color("#FFF");
        series.tooltip.getStrokeFromObject = true;
        series.tooltip.background.strokeWidth = 3;
        series.tooltip.getFillFromObject = false;
        series.fillOpacity = 0.6;
        series.strokeWidth = 2;
        series.stacked = true;
        
        var series2 = chart.series.push(new am4charts.LineSeries());
        //series2.legendSettings.labelText = "[bold {color}]{name}[/]";
        series2.dataFields.dateX = "Title";
        series2.dataFields.valueY = "Value2";
        series2.tooltipText = "[#000]{valueY.value}[/]";
        series2.tooltip.background.fill = am4core.color("#FFF");
        series2.tooltip.getFillFromObject = false;
        series2.tooltip.getStrokeFromObject = true;
        series2.tooltip.background.strokeWidth = 3;
        series2.sequencedInterpolation = true;
        series2.fillOpacity = 0.6;
        series2.stacked = true;
        series2.strokeWidth = 2;
        
        var series3 = chart.series.push(new am4charts.LineSeries());
        //series3.legendSettings.labelText = "[bold {color}]{name}[/]";
        series3.dataFields.dateX = "Title";
        series3.dataFields.valueY = "Value3";
        series3.tooltipText = "[#000]{valueY.value}[/]";
        series3.tooltip.background.fill = am4core.color("#FFF");
        series3.tooltip.getFillFromObject = false;
        series3.tooltip.getStrokeFromObject = true;
        series3.tooltip.background.strokeWidth = 3;
        series3.sequencedInterpolation = true;
        series3.fillOpacity = 0.6;
        series3.defaultState.transitionDuration = 1000;
        series3.stacked = true;
        series3.strokeWidth = 2;
        
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
        //chart.scrollbarX = new am4core.Scrollbar();
        
        // Add a legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.labels.template.fill = am4core.color("#FFF");
        
        // // axis ranges
        // var range = dateAxis.axisRanges.create();
        // range.date = new Date(2001, 0, 1);
        // range.endDate = new Date(2003, 0, 1);
        // range.axisFill.fill = chart.colors.getIndex(7);
        // range.axisFill.fillOpacity = 0.2;
        
        // range.label.text = "Fines for speeding increased";
        // range.label.inside = true;
        // range.label.rotation = 90;
        // range.label.horizontalCenter = "right";
        // range.label.verticalCenter = "bottom";
        
        // var range2 = dateAxis.axisRanges.create();
        // range2.date = new Date(2007, 0, 1);
        // range2.grid.stroke = chart.colors.getIndex(7);
        // range2.grid.strokeOpacity = 0.6;
        // range2.grid.strokeDasharray = "5,2";
        
        // range2.label.text = "Motorcycle fee introduced";
        // range2.label.inside = true;
        // range2.label.rotation = 90;
        // range2.label.horizontalCenter = "right";
        // range2.label.verticalCenter = "bottom";

        series.segments.template.interactionsEnabled = true;
        series.segments.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series.segments.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.component.tooltipDataItem.dataContext;
            sessionStorage.urlLastPage = "#/detailStep1";

            if (sessionStorage.monthValue != 0) {
                sessionStorage.dayValue = item.Title;
            }
            else {
                sessionStorage.dayValue = 0;
                var year = item.Title.substr(0, item.Title.indexOf("-"));
                var month = item.Title.substr(item.Title.indexOf("-") + 1);
                sessionStorage.yearValue = year;
                sessionStorage.monthValue = month;
            }

            sessionStorage.LoaiHoaDon = ev.target.dataItem.component.dataFields.valueX;
            location.href = "#/detailStep2";
        }, this);

        series2.segments.template.interactionsEnabled = true;
        //series2.segments.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series2.segments.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.component.tooltipDataItem.dataContext;
            sessionStorage.urlLastPage = "#/detailStep1";

            if (sessionStorage.monthValue != 0) {
                sessionStorage.dayValue = item.Title;
            }
            else {
                sessionStorage.dayValue = 0;
                var year = item.Title.substr(0, item.Title.indexOf("-"));
                var month = item.Title.substr(item.Title.indexOf("-") + 1);
                sessionStorage.yearValue = year;
                sessionStorage.monthValue = month;
            }

            sessionStorage.LoaiHoaDon = ev.target.dataItem.component.dataFields.valueX;
            location.href = "#/detailStep2";
        }, this);

        series3.segments.template.interactionsEnabled = true;
        series2.segments.template.cursorOverStyle = series3.segments.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series3.segments.template.events.on("hit", function(ev) {
            var item = ev.target.dataItem.component.tooltipDataItem.dataContext;
            sessionStorage.urlLastPage = "#/detailStep1";

           if (sessionStorage.monthValue != 0) {
                sessionStorage.dayValue = item.Title;
            }
            else {
                sessionStorage.dayValue = 0;
                var year = item.Title.substr(0, item.Title.indexOf("-"));
                var month = item.Title.substr(item.Title.indexOf("-") + 1);
                sessionStorage.yearValue = year;
                sessionStorage.monthValue = month;
            }

            sessionStorage.LoaiHoaDon = ev.target.dataItem.component.dataFields.valueX;
            location.href = "#/detailStep2";
        }, this);

        loadData4Chart();
        function loadData4Chart() {
            //Lay Doanh thu theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetStackedAreaChart?Year=" + sessionStorage.yearValue
                + "&Month=" + sessionStorage.monthValue
                + "&typeOfDetail=" + sessionStorage.typeOfDetail
                + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                $scope.series = response.data.Title;
                chart.data = response.data.ChartData;

                series.name = $scope.series[1][0];
                series.dataFields.valueX = $scope.series[0][0];
                series.tooltipHTML = "<span style='font-size:14px; color:#000000;'>" + $scope.series[0][0] + ": <b>{valueY.value}</b></span>";
                series2.name = $scope.series[1][1];
                series2.dataFields.valueX = $scope.series[0][1];
                series2.tooltipHTML = "<span style='font-size:14px; color:#000000;'>" + $scope.series[1][1] + ": <b>{valueY.value}</b></span>";
                series3.name = $scope.series[1][2];
                series3.dataFields.valueX = $scope.series[0][2];
                series3.tooltipHTML = "<span style='font-size:14px; color:#000000;'>" + $scope.series[1][2] + ": <b>{valueY.value}</b></span>";
                
            }, function(reason) {
                console.log(reason);
            });

        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 25.11.2019
 */
(function () {
    'use strict';

    //am4core.useTheme(am4themes_frozen);
    am4core.useTheme(am4themes_animated);

    angular.module('BlurAdmin.pages.dashboard')
        .controller('stackedColumnChart', stackedColumnChart);
  
    /** @ngInject */
    function stackedColumnChart($scope, $http, hostName, $interval) {

        /**
         * ******************************************************************
         * KHAI BAO THONG TIN CHO STACKED COLUMN CHART: DOANH THU THEO LOAI HOA DON
         */
        // Create chart instance
        var chart = am4core.create("barChartColumn", am4charts.XYChart);

        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.colors.step = 2;
        chart.padding(30, 30, 10, 30);
        //chart.legend = new am4charts.Legend();

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Title";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.strictMinMax = true;
        valueAxis.calculateTotals = true;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.labels.template.fill = am4core.color("#FFFFFF");

        var series1 = chart.series.push(new am4charts.ColumnSeries());
        series1.columns.template.width = am4core.percent(80);
        series1.columns.template.tooltipText = "{name}: {valueY}";
        //"{name}: {valueY.totalPercent.formatNumber('#.00')}%";
        //series1.legendSettings.labelText = "[bold {color}]{name}[/]";
        series1.dataFields.categoryX = "Title";
        series1.dataFields.valueY = "Value1";
        series1.dataFields.valueYShow = "totalPercent";
        series1.dataItems.template.locations.categoryX = 0.5;
        series1.stacked = true;
        series1.tooltip.pointerOrientation = "vertical";

        //chart.legend = new am4charts.Legend();

        var bullet1 = series1.bullets.push(new am4charts.LabelBullet());
        bullet1.interactionsEnabled = false;
        bullet1.label.text = "{valueY.totalPercent.formatNumber('#.00')}%";
        bullet1.label.fill = am4core.color("#ffffff");
        bullet1.locationY = 0.5;

        var series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.columns.template.width = am4core.percent(80);
        series2.columns.template.tooltipText = "{name}: {valueY}";
        //"{name}: {valueY.totalPercent.formatNumber('#.00')}%";
        //series2.legendSettings.labelText = "[bold {color}]{name}[/]";
        series2.dataFields.categoryX = "Title";
        series2.dataFields.valueY = "Value2";
        series2.dataFields.valueYShow = "totalPercent";
        series2.dataItems.template.locations.categoryX = 0.5;
        series2.stacked = true;
        series2.tooltip.pointerOrientation = "vertical";

        var bullet2 = series2.bullets.push(new am4charts.LabelBullet());
        bullet2.interactionsEnabled = false;
        bullet2.label.text = "{valueY.totalPercent.formatNumber('#.00')}%";
        bullet2.locationY = 0.5;
        bullet2.label.fill = am4core.color("#ffffff");

        var series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.columns.template.width = am4core.percent(80);
        series3.columns.template.tooltipText = "{name}: {valueY}";
        //"{name}: {valueY.totalPercent.formatNumber('#.00')}%";
        //series3.legendSettings.labelText = "[bold {color}]{name}[/]";
        series3.dataFields.categoryX = "Title";
        series3.dataFields.valueY = "Value3";
        series3.dataFields.valueYShow = "totalPercent";
        series3.dataItems.template.locations.categoryX = 0.5;
        series3.stacked = true;
        series3.tooltip.pointerOrientation = "vertical";

        var bullet3 = series3.bullets.push(new am4charts.LabelBullet());
        bullet3.interactionsEnabled = false;
        bullet3.label.text = "{valueY.totalPercent.formatNumber('#.00')}%";
        bullet3.locationY = 0.5;
        bullet3.label.fill = am4core.color("#ffffff");

        //chart.scrollbarX = new am4core.Scrollbar();
        // Add a legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
        chart.legend.labels.template.fill = am4core.color("#FFF");

        loadData4Chart();
        function loadData4Chart() {
            //Lay Doanh thu theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetStackedColumnChart?Year=" + sessionStorage.yearValue 
                + "&Month=" + sessionStorage.monthValue
                + "&typeOfDetail=" + sessionStorage.typeOfDetail
                + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                
                $scope.series = response.data.Title;
                chart.data = response.data.ChartData;

                series1.name = $scope.series[0];
                series2.name = $scope.series[1];
                series3.name = $scope.series[2];
                
            }, function(reason) {
                console.log(reason);
            });

        };

        //DESTROY CHART OBJECT
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        //AUTO LOOP CALL FUNCTION
        $interval(function () {
            loadData4Chart();
        }, 30000);

    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);
  
    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil, $http, hostName, baSidebarService) {
  
        // //HIDE LEFT MENU
        // baSidebarService.setMenuCollapsed(true);
    
        var NowADay = new Date();
        var thisYear = NowADay.getFullYear();
        var thisMonth = NowADay.getMonth() + 1;
        var thisDay = NowADay.getDay();
        var vm = this;
        vm.dataObject = {};
        var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    
        $http.get(hostName.url + "api/Dashboard/GetDashboardTitle?Year=" + thisYear 
                    + "&Month=" + thisMonth + "&Day=" + thisDay + "&enterpriseId=" 
                    + sessionStorage.enterpriseId).then(function(response) {
            vm.dataObject = response.data;
    
            // $scope.charts = [{
            //     color: pieColor,
            //     description: 'Hóa đơn lập mới ' + thisYear,
            //     stats: vm.dataObject.LapMoi,
            //     icon: 'invoiceYear',
            //   }, {
            //     color: pieColor,
            //     description: 'Doanh thu năm ' + thisYear,
            //     stats: vm.dataObject.DoanhThu + ' đ',
            //     icon: 'revenueYear',
            //   }, {
            //     color: pieColor,
            //     description: 'Tổng hóa đơn đã lập',
            //     stats: vm.dataObject.TongDaLap,
            //     icon: 'invoiceTotal',
            //   }, {
            //     color: pieColor,
            //     description: 'Tổng doanh thu',
            //     stats: vm.dataObject.TongDoanhThu + ' đ',
            //     icon: 'revenueTotal',
            //   }
            // ];
    
            $scope.charts = [{
                    color: pieColor,
                    description: vm.dataObject.Panel3Title,
                    stats: vm.dataObject.Panel3Value + ' đ',
                    icon: 'revenueYear',
                }, {
                    color: pieColor,
                    description: vm.dataObject.Panel4Title,
                    stats: vm.dataObject.Panel4Value + ' đ',
                    icon: 'revenueTotal',
                }
            ];
    
        }, function(reason) {
            console.log(reason);
        });
    
        function getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        }
    
        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round',
                });
            });
    
            $('.refresh-data').on('click', function () {
                updatePieCharts();
            });
        };
    
        function updatePieCharts() {
            $('.pie-charts .chart').each(function(index, chart) {
                $(chart).data('easyPieChart').update(getRandomArbitrary(90, 90));
                //$(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
            });
        };
    
        $timeout(function () {
            loadPieCharts();
            updatePieCharts();
        }, 1000);

    };

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author ThienVM
 * created on 2025-05-15
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CHUNGTU_DANHSACH_04Ctrl', CHUNGTU_DANHSACH_04Ctrl);

    /*******    +++ START CONTROLLER    *******/
    function CHUNGTU_DANHSACH_04Ctrl($scope, $http, $state, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.arrData = [];
        $scope.arrTypeOfAction = [];

        $scope.mTotalInvoice = 0;
        $scope.mTotalList = 0;
        $scope.smartTablePageSize = 10;

        GetTypeOfAction();

        function GetTypeOfAction() {
            // $scope.arrTypeOfAction.push({ ID: 'DELETE', Name: 'Hủy' });
            $scope.arrTypeOfAction.push({ ID: 'ADJUST', Name: 'Điều chỉnh' });
            $scope.arrTypeOfAction.push({ ID: 'REPLACE', Name: 'Thay thế' });
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalInvoice = 0;
            $scope.mTotalList = 0;

            var total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;

            total = response.data[1][0].TotalList;
            if (total != undefined)
                $scope.mTotalList = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction="
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&Descr=";
        $http({
            method: "GET",
            url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditDanhSachChungTuSaiSot = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/DanhSachChungTuSai';
            location.href = '#/CreateDanhSachChungTuSai';
        };

        $scope.CreateDanhSachChungTuSaiSot = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateDanhSachChungTuSai';
        }


        $scope.FindData = function () {
            searchData();
        };

        function searchData() {
            $scope.arrData = [];
            $scope.mTotalInvoice = 0;
            $scope.mTotalList = 0;
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';
            var queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction=" + $scope.mTypeOfAction
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
                + "&Descr=" + $scope.mDescr;
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }

        $scope.PrintThongBaoSaiSot = function (ID, RefNbr) {
            var _fileName = RefNbr + '_' + "ThongBaoSaiSot.pdf";

            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_PrintThongBaoSaiSot?ID=" + ID,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };

        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileSigned = function (FileXML, RefNbr, RefDate) {

            var _fileName = RefNbr + '_' + $filter('replace')(RefDate, '/', '-');
            $http({
                method: 'GET',
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_GetFileSigned?" + "FileXML=" + FileXML + '&EnterpriseID=' + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
            });

        };

        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo", text: "Đã có kết quả phản hồi từ Cơ quan Thuế!", icon: "success", button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo", text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo", text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error", dangerMode: true, button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CHUNGTU_DIEUCHINHCtrl', CHUNGTU_DIEUCHINHCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CHUNGTU_DIEUCHINHCtrl($scope, $http, $stateParams, hostName, $filter) {
        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));

        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mTotalAmount = 0;
        $scope.mTotalInvoice = 0;
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        $scope.arrStatus = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.mModule = $stateParams.Module;

        $scope.Statuses = [];
        $scope.Status = {};
        $scope.InvoiceTemplates = [];
        $scope.InvoiceTemplate = {};

        // console.log("$scope.mModule=" + $scope.mModule);
        if ($scope.mModule == "REPLACE")
            $scope.PageTitle = "Chứng từ Thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = "Chứng từ Điều chỉnh";
        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;

        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            // $scope.arrStatus = response.data;
            $scope.Statuses = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
        }).then(function (response) {
            // $scope.arrInvoiceTemplate = response.data;
            $scope.InvoiceTemplates = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        }).then(function (response) {
            $scope.arrTypeOfRevenue = response.data.Table1;
        }, function (error) {
            console.log(error);
        });

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total; //.replace(/,/g,".");

            total = response.data[1][0].TotalInvoice;
            if (total != undefined)
                $scope.mTotalInvoice = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=&CustomerName=&BillNumber=&Symbol=&TaxCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_Search?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.EditChungTuDieuChinh = function (id) {
            console.log(id);

            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = $scope.mModule === "ADJUST" ? "#/ChungTuDieuChinh" : "#/ChungTuThayThe";
            location.href = '#/CreateCHUNGTU_TNCN_THAYDOI';
        };

        // $scope.CreateHoaDonDieuChinh = function () {
        //     sessionStorage.itemId = 0;
        //     sessionStorage.IsUpdate = false;
        //     location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        // }

        $scope.SearchChungTuThayDoi = function () {
            location.href = '#/SEARCH_CHUNGTU_THAYDOI';
            sessionStorage.urlReturn = $scope.mModule === "ADJUST" ? "#/ChungTuDieuChinh" : "#/ChungTuThayThe";
            sessionStorage.Module = $scope.mModule;

        }

        $scope.ReviewBienBan = function (QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ND70/QD1450_HOADON_THAYDOI_Review?ID=" + QD1450_HOADON_THAYDOI_ID,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetFileSigned = function (FileBienBan, QD1450_HOADON_THAYDOI_ID, KyHieu, SoHoaDon) {
            SoHoaDon = ("00000000" + SoHoaDon).slice(-8);
            var _fileName = KyHieu + '_' + SoHoaDon + '_' + QD1450_HOADON_THAYDOI_ID;
            $http({
                method: 'GET',
                url: hostName.url + "api/ND70/QD1450_HOADON_THAYDOI_GetFileSigned?FileBienBan=" + FileBienBan,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };


        $scope.FindData = function () {

            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalInvoice = 0;

            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mBillNumber == undefined)
                $scope.mBillNumber = '';

            var fromDate = angular.element(document).find('#inputFromDate')[0].value;
            var toDate = angular.element(document).find('#inputToDate')[0].value;
            var statusId = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : '';
            var invoiceTemplateId = $scope.InvoiceTemplate.ID != undefined ? $scope.InvoiceTemplate.ID : 0;
            var _taxCode = angular.element(document).find('#TaxCode')[0].value;

            queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + convertDateFormat(fromDate) + "&ToDate=" + convertDateFormat(toDate)
                + "&TaxCode=" + _taxCode// $scope.mTaxCode
                + "&BillNumber=" + $scope.mBillNumber
                + "&Symbol=" + $scope.mSymbol + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + statusId + "&InvoiceTemplateID=" + invoiceTemplateId
                + "&LoaiThu=" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
    function convertDateFormat(dateStr) {
        var parts = dateStr.split('/');
        if (parts.length !== 3) return dateStr; // basic validation
        return parts[1] + '/' + parts[0] + '/' + parts[2];
    };
})();

/**
 * @author Nguyen Huu Tuan
 * created on 29.06.2020
 */
(function () {
    'use strict';

    //+++   ANGULAR CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CHUNGTU_GUI_CQTCtrl', CHUNGTU_GUI_CQTCtrl);

    //+++   FUNCTION OF CONTROLLER
    function CHUNGTU_GUI_CQTCtrl($scope, $http, $state, hostName, $filter) {

        $scope.smartTablePageSize = 10;
        var vm = this;
        vm.rowCollection = [];
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.IsDisabled = false;

        // $scope.IsCollection = false;

        // //LAY THONG TIN LOAI HOA DON VA HINH THUC HOA DON DA DANG KY CUA DON VI
        // GetHTHD();
        // function GetHTHD() {
        //     $http({
        //         method: "GET",
        //         url: hostName.url + "api/QD1450/QD1450_LTD100_GetHTHD?EnterpriseId=" + sessionStorage.enterpriseId
        //     }).then(function (data) {
        //         var _data = data.data[0];

        //         //CO MA
        //         if (_data != undefined && _data.TransferPivotTabel == true) {
        //             $scope.IsCollection = true;
        //         }
        //     }, function (error) {
        //         console.log(error);
        //     });
        // };

        //function then call  WEB API get data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
            //console.log(vm.rowCollection);
        };

        //function then call WEB API get data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        ngInit();
        function ngInit() {
            //call WEB API to get data
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GUI_CQT?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(successCallBack, errorCallBack);
        }

        $scope.GuiCQT = function () {
            $scope.IsDisabled = true;

            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GUI_CQT_SEND?EnterpriseId="
                    + sessionStorage.enterpriseId,
            }).then(function (response) {
                //var _resultCode = response.data.ResultCode;
                swal({
                    title: "Thông báo",
                    text: "Đã gửi kết quả thành công đến cơ quan Thuế!",
                    icon: "success",
                    button: "Đóng",
                }).then(function () {
                    $scope.IsDisabled = false;
                    ngInit();
                });

            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể đẩy dữ liệu tra cứu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                    $scope.IsDisabled = false;
                });
                console.log(error);
            });
        };

    };
    //###   END FUNCTION OF CONTROLLER

})();

/**
 * @author Nguyen Huu Tuan
 * created on 29.06.2020
 */
(function () {
    'use strict';

    //+++   ANGULAR CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CHUNGTU_NHANKQ_TCTCtrl', CHUNGTU_NHANKQ_TCTCtrl);

    //+++   FUNCTION OF CONTROLLER
    function CHUNGTU_NHANKQ_TCTCtrl($scope, $http, $state, hostName, $filter) {

        $scope.smartTablePageSize = 10;
        var vm = this;
        vm.rowCollection = [];
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.IsDisabled = false;
        $scope.IsCollection = false;

        //function then call  WEB API get data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
        };

        //function then call WEB API get data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        ngInit();
        function ngInit() {
            //call WEB API to get data
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_NHANKQ_TCT?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(successCallBack, errorCallBack);
        }

        $scope.ReceiveResult = function () {
            $scope.IsDisabled = true;

            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVERESULT?EnterpriseId="
                    + sessionStorage.enterpriseId,
            }).then(function (response) {
                //var _resultCode = response.data.ResultCode;

                swal({
                    title: "Thông báo",
                    text: "Đã nhận kết quả thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function () {
                    $scope.IsDisabled = false;
                    ngInit();
                });

            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ TCT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                    $scope.IsDisabled = false;
                });
                console.log(error);
            });
        };

    };
    //###   END FUNCTION OF CONTROLLER


})();

/**
 * @author THIENVM
 * created on 2025-05-08
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CHUNGTU_TNCNCtrl', CHUNGTU_TNCNCtrl);

    /*******    +++ START CONTROLLER    *******/
    function CHUNGTU_TNCNCtrl($scope, $http, $stateParams, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.arrData = [];
        $scope.mModule = "TK";
        $scope.mTotalAmount = 0;
        $scope.mTotalList = 0;
        $scope.smartTablePageSize = 10;
        $scope.Statuses = [];
        $scope.Status = {};
        $scope.InvoiceTemplates = [];
        $scope.InvoiceTemplate = {};

        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            // $scope.arrStatus = response.data;
            $scope.Statuses = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                + "&TypeOfInvoiceCode=" + $scope.mModule
        }).then(function (response) {
            // $scope.arrInvoiceTemplate = response.data;
            $scope.InvoiceTemplates = response.data;
        }, function (error) {
            console.log(error);
        });

        // //call WEB API to get ElectronicInvoice's data
        // INIT search
        var queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&RefNbr=&MaTinhTrang=&InvoiceTemplateID=&CustomerName=&InvNumber=&InvSerialNo=&TypeOfRevenueID=&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ND70/ND70_CHUNGTU_Search?" + queryString
        }).then(successCallBack, errorCallBack);

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function (objSelect) {
            $scope.InvoiceTemplate = objSelect;
        }
        $scope.EditToKhaiThueTNCN = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = true;
            sessionStorage.urlReturn = '#/CHUNGTU_TNCN';
            location.href = '#/CreateCHUNGTU_TNCN';
        };

        // $scope.CreateToKhaiThueTNCN_ByCopy = function (id) {
        //     sessionStorage.itemId = id;
        //     sessionStorage.IsUpdate = false;
        //     location.href = '#/CreateCHUNGTU_TNCN';
        // }2

        $scope.CreateToKhaiThueTNCN = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = '#/CreateCHUNGTU_TNCN';
        }

        $scope.FindData = function () {
            searchData();
        };

        function searchData() {

            $scope.arrData = [];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;
            var queryString = "";
            if ($scope.mInvNumber == undefined)
                $scope.mInvNumber = '';
            var fromDate = angular.element(document).find('#inputFromDate')[0].value;
            var toDate = angular.element(document).find('#inputToDate')[0].value;
            var statusId = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : '';
            var invoiceTemplateId = $scope.InvoiceTemplate.ID != undefined ? $scope.InvoiceTemplate.ID : 0;

            // console.log(fromDate);

            queryString = "Module=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + convertDateFormat(fromDate) + "&ToDate=" + convertDateFormat(toDate)
                + "&RefNbr=" + $scope.mRefNbr + "&InvNumber=" + $scope.mInvNumber
                + "&InvSerialNo=" + $scope.mInvSerialNo + "&CustomerName=" + $scope.mCustomerName
                + "&MaTinhTrang=" + statusId + "&InvoiceTemplateID=" + invoiceTemplateId
                + "&TypeOfRevenueID=&UserID=";
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_Search?" + queryString,
            }).then(successCallBack, errorCallBack);
        }


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileSigned = function (ND70_CHUNGTUID, InvNumber, RefNbr) {
            InvNumber = ("0000000" + InvNumber).slice(-7);
            var _fileName = RefNbr + '_' + InvNumber + ".pdf";
            $http({
                method: 'GET',
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GetFileSigned?ID=" + ND70_CHUNGTUID + '&EnterpriseID=' + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetFileHoaDonXML = function (ToKhaiID, FileHoaDonXML) {
            // InvNumber = ("0000000" + InvNumber).slice(-7);
            // var _fileName = RefNbr + '_' + InvNumber + ".pdf";
            var _fileName = FileHoaDonXML;
            $http({
                method: 'GET',
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GetFileSignedXML?ID=" + ToKhaiID + '&EnterpriseId=' + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.GetResultFromTCT = function (MaThongDiep) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo", text: "Đã có kết quả phản hồi từ Cơ quan Thuế!", icon: "success", button: "Đóng",
                    }).then(function () {
                        searchData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo", text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo", text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error", dangerMode: true, button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };

        /* GỬI 1 tờ ĐẾN CQT  */
        $scope.Send2CQT = function (MaThongDiep, FileHoaDon, MaLoaiThongDiep, DateOfInvoice) {
            // console.log(MaThongDiep);
            // console.log(FileHoaDon);
            // console.log(MaLoaiThongDiep);
            // console.log(DateOfInvoice);
            // return;

            swal({
                title: "Gửi hóa đơn đến CQT !",
                icon: "warning",
                buttons: ["Đóng", "Gửi CQT"],
            }).then(function (data) {
                if (data === true) {
                    //
                    $http({
                        method: "GET",
                        url: hostName.url + "api/QD1450/QD1450_HOADON_SEND_TCTN_1_1?FileHoaDon=" + FileHoaDon + "&DateOfInvoice=" + DateOfInvoice + "&MaThongDiep=" + MaThongDiep + "&MaLoaiThongDiep=" + MaLoaiThongDiep
                    }).then(function (response) {
                        swal({
                            title: "Thông báo",
                            text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                            $state.reload();
                        });
                    }, function (error) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi hóa đơn đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            // location.href = "#/Invoice1450";
                            $state.reload();
                        });
                        console.log(error);
                    });
                }
                else {

                }
            })
        }
        /* end 20230111 */


        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
            $scope.mTotalAmount = 0;
            $scope.mTotalList = 0;
            // console.log($scope.arrData);

            var total = response.data[1][0].TotalAmount;
            if (total != undefined)
                $scope.mTotalAmount = total;

            total = response.data[1][0].TotalList;
            if (total != undefined)
                $scope.mTotalList = total;
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
    function convertDateFormat(dateStr) {
        var parts = dateStr.split('/');
        if (parts.length !== 3) return dateStr; // basic validation
        return parts[1] + '/' + parts[0] + '/' + parts[2];
    };
})();

/**
  * @author ThienVM
 * created on 2025-05-15
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CreateCHUNGTU_DANHSACH_04Ctr', CreateCHUNGTU_DANHSACH_04Ctr);

    /*******    +++ START CONTROLLER    *******/
    function CreateCHUNGTU_DANHSACH_04Ctr($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mRefDate = new Date();
        $scope.mFromDate = $scope.mRefDate;
        $scope.mToDate = $scope.mRefDate;
        $scope.arrTypeOfAction = [];
        $scope.arrData = [];
        $scope.IsPublic = false;
        $scope.IsUnlock = true;
        $scope.IsUpdate = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.mND70_CHUNGTU_SAISOT_ID = 0;

        GetTypeOfAction();
        // Update
        if ($scope.IsUpdate == true) {
            $scope.mND70_CHUNGTU_SAISOT_ID = sessionStorage.itemId;
            $scope.IsPublic = true;
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_GetByID?ID=" + $scope.mND70_CHUNGTU_SAISOT_ID + '&EnterpriseID=' + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.SaiSot = response.data[0];
                if ($scope.SaiSot != undefined) {
                    if ($scope.SaiSot.MaTinhTrang == 'CHOKETQUA' || $scope.SaiSot.MaTinhTrang == 'DUYET'
                        || $scope.SaiSot.MaTinhTrang == '20002') {
                        $scope.IsPublic = false;
                    };
                    $scope.IsUnlock = false;/* ẨN 'ĐỒNG Ý' NẾU ĐÃ LẬP TBSS */

                    $scope.mND70_CHUNGTU_SAISOT_ID = $scope.SaiSot.ID;
                    $scope.mRefDate = decryptDate($scope.SaiSot.RefDate);
                    $scope.mRefNbr = $scope.SaiSot.RefNbr;
                    $scope.mFromDate = decryptDate($scope.SaiSot.FromDate);
                    $scope.mToDate = decryptDate($scope.SaiSot.ToDate);
                    $scope.mDescr = $scope.SaiSot.Descr;
                    $scope.mTypeOfAction = $scope.SaiSot.TypeOfAction;
                    $scope.mQuantityInvoice = $scope.SaiSot.QuantityInvoice;
                    $scope.mTotalInvoice = $scope.SaiSot.QuantityInvoice;
                    $scope.mTotalSearch = 0;
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_CHITIET_GetByMasterID?ND70_CHUNGTU_SAISOT_ID=" + $scope.mND70_CHUNGTU_SAISOT_ID + '&EnterpriseID=' + sessionStorage.enterpriseId,
                    }).then(function (response) { //SUCCESS
                        $scope.arrData = response.data;
                    }, function (reason) { //ERROR
                        console.log(reason);
                    });
                }
            }, function (reason) {
                console.log(reason);
            });
        }
        //Insert
        else {
        };

        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtDescr = angular.element(document).find('#txtDescr')[0];
            var flag = true;
            //check empty 
            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày báo cáo\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mDescr == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ghi chú\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            //check empty details of invoice
            if ($scope.arrData === undefined || $scope.arrData.length == 0) {
                swal({
                    title: "Vui lòng nhập thông tin \"Chi tiết hóa đơn sai\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            $scope.mListID = "";
            for (var i = 0; i < $scope.arrData.length; i += 1) {
                $scope.mListID = $scope.mListID + $scope.arrData[i]['ND70_CHUNGTU_HOADON_THAYDOI_ID'] + ';';
            }
            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mND70_CHUNGTU_SAISOT_ID <= 0 ? -1 : $scope.mND70_CHUNGTU_SAISOT_ID,
                    'RefDate': encryptDate($scope.mRefDate),
                    'FromDate': encryptDate($scope.mFromDate),
                    'ToDate': encryptDate($scope.mToDate),
                    'Descr': $scope.mDescr,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                    'ListID': $scope.mListID,
                };

                $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mND70_CHUNGTU_SAISOT_ID = objResult.Data;
                    sessionStorage.itemId = objResult.Data;
                    sessionStorage.IsUpdate = true;
                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        $state.reload();
                        //location.href = "#/DanhSachChungTuSai";
                    });
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            location.href = "#/DanhSachChungTuSai";
                        });
                    });
            }
        };

        $scope.FindData = function () {
            $scope.arrData = [];
            $scope.mTotalInvoice = 0;
            $scope.mTotalSearch = 0;;
            var queryString = "";
            queryString = "EnterpriseID=" + sessionStorage.enterpriseId + "&TypeOfAction=" + $scope.mTypeOfAction
                + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate);
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SearchHoaDon?" + queryString,
            }).then(function (response) { //SUCCESS
                $scope.arrData = response.data[0];

                var total = response.data[1][0].TotalInvoice;
                if (total != undefined)
                    $scope.mTotalInvoice = total;
                total = response.data[1][0].TotalSearch;
                if (total != undefined)
                    $scope.mTotalSearch = total;
            }, function (reason) { //ERROR
                console.log(reason);
            });
        };

        $scope.BackPage = function () {
            location.href = "#/DanhSachChungTuSai";
        };

        function GetTypeOfAction() {
            // $scope.arrTypeOfAction.push({ ID: 'DELETE', Name: 'Hủy' });
            $scope.arrTypeOfAction.push({ ID: 'ADJUST', Name: 'Điều chỉnh' });
            $scope.arrTypeOfAction.push({ ID: 'REPLACE', Name: 'Thay thế' });
        }

        //Phát hành hóa đơn gửi cơ quan thuế
        $scope.PublishInvoice = function () {
            $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_Publish?ID=" + $scope.mND70_CHUNGTU_SAISOT_ID, $scope.mND70_CHUNGTU_SAISOT_ID).then(
                //SUCCESS
                function (success) {
                    swal({
                        title: "Thông báo", text: "Đã gửi thông báo đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!", icon: "success", button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                },
                //ERRORS
                function (errs) {
                    swal({
                        title: "Thông báo", text: "Không thể gửi thông báo đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", icon: "error", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                    console.log(errs);
                });

        };

        $scope.PrintThongBaoSaiSot = function () {
            var _fileName = $scope.mRefNbr + '_' + "ThongBaoSaiSot.pdf";

            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_SAISOT_PrintThongBaoSaiSot?ID=" + $scope.mND70_CHUNGTU_SAISOT_ID + '&EnterpriseID=' + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
            }).error(function (message) {

                console.log(message);
                $scope.IsDisabled = false;
            });
        };

    };

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author THIENVM
 * created on 2025-05-08
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.electricInvoice')
        .controller('CreateCHUNGTU_TNCNCtr', CreateCHUNGTU_TNCNCtr);

    /*******    +++ START CONTROLLER    *******/
    function CreateCHUNGTU_TNCNCtr($scope, $http, $stateParams, hostName, $state, $rootScope, fileReader) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.arrInvoiceTemplate = [];
        $scope.mRefDate = new Date();
        $scope.IsPublic = false;
        $scope.IsUnlock = true;
        $scope.IsUpdate = false;
        $scope.IsReview = false;
        $scope.IsPDF = false;
        $scope.IsDelete = false;
        $scope.Module = "TK";
        $scope.IsDisabled = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true")
            $scope.IsUpdate = true;
        $scope.mChungTu_Id = 0;

        GetInvoiceTemplate();

        $scope.importfile = true; // ẩn hiện import
        $rootScope.fileTemplate = undefined;
        $rootScope.FileTemplateData = undefined;
        $scope.FileMauChiTiet = hostName.url + "Templates/" + "ChungTuKhauTruThueTNCN.xlsx";

        // Update
        if ($scope.IsUpdate == true) {
            $scope.mChungTu_Id = sessionStorage.itemId;
            $scope.IsPublic = true;
            Paste($scope.mChungTu_Id, false);
        }
        //Insert
        else {
            if (sessionStorage.itemId > 0)
                Paste(sessionStorage.itemId, true);
        };

        function Paste(ChungTu_ID, IsCopy) {
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GetByID?ID=" + ChungTu_ID + '&EnterpriseId=' + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.ChungTu = response.data[0];
                // console.log($scope.ChungTu);
                if ($scope.ChungTu != undefined) {
                    $scope.IsPDF = true;
                    if (IsCopy == false) {
                        if ($scope.ChungTu.MaTinhTrang == 'DUYET' || $scope.ChungTu.MaTinhTrang == 'HUY') {
                            // $scope.IsPublic = false; 
                            $scope.IsUnlock = false;
                            $scope.IsDelete = true;/* TK DUYET => hiển thị hủy */
                            $scope.IsPDF = false;
                        };

                        // if ($scope.ChungTu.FileHoaDonXML === '' || $scope.ChungTu.FileHoaDonXML === null || $scope.ChungTu.FileHoaDonXML === undefined) {
                        //     $scope.IsPublic = true;
                        // } else {
                        //     $scope.IsPublic = false;
                        // }

                        $scope.mRefDate = decryptDate($scope.ChungTu.RefDate);
                        $scope.mRefNbr = $scope.ChungTu.RefNbr;
                        $scope.mCustomerName = $scope.ChungTu.CustomerName;
                        $scope.mCompanyName = $scope.ChungTu.CompanyName;
                        $scope.mTaxCode = $scope.ChungTu.TaxCode;
                        $scope.mAddress = $scope.ChungTu.Address;
                        $scope.mInvNumber = $scope.ChungTu.InvNumber;

                        $scope.mFromDate = decryptDate($scope.ChungTu.FromDate);
                        $scope.mToDate = decryptDate($scope.ChungTu.ToDate);
                        $scope.mNationality = $scope.ChungTu.Nationality;
                        //$scope.mIsResident = $scope.ChungTu.IsResident;
                        var txtIsResident = angular.element(document).find('#txtIsResident')[0];
                        txtIsResident.checked = $scope.ChungTu.IsResident;

                        // $scope.mPassportNumber = $scope.ChungTu.PassportNumber;
                        // $scope.mPlaceOfIssue = $scope.ChungTu.PlaceOfIssue;
                        // $scope.mDateOfIssue = decryptDate($scope.ChungTu.DateOfIssue);
                        // $scope.mTotalInsuranceAmount = $scope.ChungTu.TotalInsuranceAmount;
                        // $scope.mTotalBeforeReductIncomeAmount = $scope.ChungTu.TotalBeforeReductIncomeAmount;
                        // $scope.mTotalIncomeAmount = $scope.ChungTu.TotalIncomeAmount;
                        // $scope.mTotalTaxAmount = $scope.ChungTu.TotalTaxAmount;
                        // $scope.mTotalAmount = $scope.ChungTu.TotalAmount;

                        $scope.CCCDan = $scope.ChungTu.CCCDan;
                        $scope.SDThoai = $scope.ChungTu.SDThoai;
                        $scope.DCTDTu = $scope.ChungTu.DCTDTu;
                        $scope.GChu = $scope.ChungTu.GChu;

                        $scope.BHiem = $scope.ChungTu.BHiem;
                        $scope.TThien = $scope.ChungTu.TThien;
                        $scope.TTNCThue = $scope.ChungTu.TTNCThue;
                        $scope.TTNTThue = $scope.ChungTu.TTNTThue;
                        $scope.SThue = $scope.ChungTu.SThue;

                        /* ẨN TK KHI TK ĐÃ HỦY */
                        if ($scope.ChungTu.MaTinhTrang == 'HUY' && $scope.ChungTu.DaThayDoi == 'DELETE') {
                            $scope.IsDelete = false;
                        };
                    }
                    else {
                        $scope.mRefDate = new Date();
                        $scope.mRefNbr = "";
                        $scope.mCustomerName = "";
                        $scope.mCompanyName = "";
                        $scope.mTaxCode = "";
                        $scope.mAddress = "";
                        $scope.mInvNumber = "";
                    }
                    $scope.mInvoiceTemplateID = $scope.ChungTu.InvoiceTemplateID.toString();
                    $scope.mInvFormNo = $scope.ChungTu.InvFormNo;
                    $scope.mInvSerialNo = $scope.ChungTu.InvSerialNo;
                    $scope.mDescr = $scope.ChungTu.Descr;
                    $scope.IsReview = true;
                }
            }, function (reason) {
                console.log(reason);
            });
        }


        //FUNCTION SAVE DATA
        $scope.save = function () {
            // Requirement:  Description 1 together Price 1 | Description 2 together Price 2 | Description 3 together Price 3
            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtCustomerName = angular.element(document).find('#txtCustomerName')[0];
            var cboInvoiceTemplate = angular.element(document).find('#cboInvoiceTemplate')[0];

            var txtTaxCode = angular.element(document).find('#txtTaxCode')[0];
            var txtAddress = angular.element(document).find('#txtAddress')[0];
            var txtCCCDan = angular.element(document).find('#CCCDan')[0];
            var txtSDThoai = angular.element(document).find('#SDThoai')[0];
            var txtDCTDTu = angular.element(document).find('#DCTDTu')[0];
            var txtGChu = angular.element(document).find('#GChu')[0];
            // var txtPassportNumber = angular.element(document).find('#txtPassportNumber')[0];
            // var txtPlaceOfIssue = angular.element(document).find('#txtPlaceOfIssue')[0];
            // var txtDateOfIssue = angular.element(document).find('#txtDateOfIssue')[0];

            var txtDescr = angular.element(document).find('#txtDescr')[0];
            var txtFromDate = angular.element(document).find('#txtFromDate')[0];
            var txtToDate = angular.element(document).find('#txtToDate')[0];

            var _BHiem = angular.element(document).find('#BHiem')[0];
            var _TThien = angular.element(document).find('#TThien')[0];
            var _TTNCThue = angular.element(document).find('#TTNCThue')[0];
            var _TTNTThue = angular.element(document).find('#TTNTThue')[0];
            var _SThue = angular.element(document).find('#SThue')[0];

            var flag = true;
            //check empty 
            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày chứng từ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mInvoiceTemplateID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mẫu chứng từ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboInvoiceTemplate.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mCustomerName == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Họ và tên\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtCustomerName.focus();
                });
                flag = false;
                return;
            };
            // if ($scope.mTaxCode == '') {
            //     swal({title: "Vui lòng nhập thông tin \"Mã số thuế\"", icon: "warning", button: "Đóng"
            //     }).then(function(){
            //         txtTaxCode.focus();
            //     });
            //     flag = false;
            //     return;
            // };
            if (txtSDThoai.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Số điện thoại\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtSDThoai.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mAddress == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ \"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtAddress.focus();
                });
                flag = false;
                return;
            };


            if ($scope.mTaxCode == '') {
                // if ($scope.mNationality == '') {
                //     swal({
                //         title: "Vui lòng nhập thông tin \"Quốc tịch\"", icon: "warning", button: "Đóng"
                //     }).then(function () {
                //         txtNationality.focus();
                //     });
                //     flag = false;
                //     return;
                // };

                if (txtCCCDan.value == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"CMND\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtCCCDan.focus();
                    });
                    flag = false;
                    return;
                };
                // if ($scope.mDateOfIssue == '' || $scope.mDateOfIssue == undefined) {
                //     swal({
                //         title: "Vui lòng nhập thông tin \"Ngày cấp\"", icon: "warning", button: "Đóng"
                //     }).then(function () {
                //         txtDateOfIssue.focus();
                //     });
                //     flag = false;
                //     return;
                // };
                // if ($scope.mPlaceOfIssue == '') {
                //     swal({
                //         title: "Vui lòng nhập thông tin \"Nơi cấp\"", icon: "warning", button: "Đóng"
                //     }).then(function () {
                //         txtPlaceOfIssue.focus();
                //     });
                //     flag = false;
                //     return;
                // };
            }

            if ($scope.mDescr == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khoản thu nhập\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mFromDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Từ ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtFromDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mToDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đến ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtToDate.focus();
                });
                flag = false;
                return;
            };

            console.log(_BHiem.value);

            if (_BHiem.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Bảo hiểm\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _BHiem.focus();
                });
                flag = false;
                return;
            };
            if (_TThien.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khoản từ thiện\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TThien.focus();
                });
                flag = false;
                return;
            };

            if (_TTNCThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thu nhập chịu thuế \"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TTNCThue.focus();
                });
                flag = false;
                return;
            };
            if (_TTNTThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thu nhập tính thuế\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TTNTThue.focus();
                });
                flag = false;
                return;
            };
            if (_SThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thuế TNCN đã khấu trừ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _SThue.focus();
                });
                flag = false;
                return;
            };

            // if ($scope.mTotalAmount == '' || $scope.mTotalAmount == '0') {
            //     swal({
            //         title: "Vui lòng nhập thông tin \"TNCN còn được nhận\"", icon: "warning", button: "Đóng"
            //     }).then(function () {
            //         txtTotalAmount.focus();
            //     });
            //     flag = false;
            //     return;
            // };

            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mChungTu_Id <= 0 ? -1 : $scope.mChungTu_Id,
                    'RefDate': encryptDate($scope.mRefDate),
                    'RefNbr': "",
                    'Module': $scope.Module,
                    'FromDate': encryptDate($scope.mFromDate),
                    'ToDate': encryptDate($scope.mToDate),
                    'CustomerName': $scope.mCustomerName,
                    'CompanyName': $scope.mCompanyName,
                    'TaxCode': txtTaxCode.value,
                    'Address': $scope.mAddress,
                    'CCCDan': txtCCCDan.value,
                    'SDThoai': txtSDThoai.value,
                    'DCTDTu': txtDCTDTu.value,
                    'GChu': txtGChu.value,
                    /*'CodeToFind': "",*/
                    'Nationality': $scope.mNationality,
                    'IsResident': txtIsResident.checked,
                    'PassportNumber': "",// $scope.mPassportNumber,
                    'PlaceOfIssue': "",// $scope.mPlaceOfIssue,
                    'DateOfIssue': "",// $scope.mDateOfIssue == undefined || $scope.mDateOfIssue == '' ? '01/01/1900' : encryptDate($scope.mDateOfIssue),
                    /*'TypeOfPaymentID': $scope.mTypeOfPaymentID,
                    'TypeOfRevenueID': $scope.mTypeOfRevenueID,*/
                    'InvoiceTemplateID': $scope.mInvoiceTemplateID,
                    /*
                    'InvFormNo': $scope.mInvFormNo,
                    'InvSerialNo': $scope.mInvSerialNo,
                    'InvNumber': $scope.mInvNumber,*/
                    'BHiem': _BHiem.value,
                    'TThien': _TThien.value,
                    'TTNCThue': _TTNCThue.value,
                    'TTNTThue': _TTNTThue.value,
                    'SThue': _SThue.value,

                    'Descr': $scope.mDescr,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                };
                // console.log();
                // return;
                $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    $scope.mChungTu_Id = objResult.Data;
                    sessionStorage.itemId = objResult.Data;
                    sessionStorage.IsUpdate = true;
                    swal({
                        title: "Thông báo",
                        text: "Lưu dữ liệu thành công!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $scope.BackPage();
                        });
                    });
            }
        };

        $scope.BackPage = function () {
            location.href = "#/CHUNGTU_TNCN";
        };

        //Phát hành chứng từ gửi cơ quan thuế
        $scope.PublishInvoice = function () {
            $scope.IsDisabled = true;
            var inputData = {
                'ID': sessionStorage.itemId,
                'EnterpriseId': sessionStorage.enterpriseId
            };
            $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_Publish", inputData).then(
                //SUCCESS
                function (success) {
                    swal({
                        title: "Thông báo", text: "Phát hành XML thành công!", icon: "success", button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                },
                //ERRORS
                function (errs) {
                    swal({
                        title: "Thông báo", text: "Không thể phát hành XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", icon: "error", dangerMode: true, button: "Đóng",
                    }).then(function () {
                        $state.reload();
                    });
                    console.log(errs);
                });

        };

        // $scope.SignPDF = function () {
        //     $scope.IsDisabled = true;
        //     var inputData = {
        //         'ID': sessionStorage.itemId,
        //         'EnterpriseId': sessionStorage.enterpriseId
        //     };
        //     $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_PublishPDF", inputData).then(
        //         //SUCCESS
        //         function (success) {
        //             swal({
        //                 title: "Thông báo", text: "Ký PDF thành công!", icon: "success", button: "Đóng",
        //             }).then(function () {
        //                 // $state.reload();
        //                 $scope.BackPage();
        //             });
        //         },
        //         //ERRORS    
        //         function (errs) {
        //             swal({
        //                 title: "Thông báo", text: "Không thể Ký PDF XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", icon: "error", dangerMode: true, button: "Đóng",
        //             }).then(function () {
        //                 $state.reload();
        //             });
        //             console.log(errs);
        //         });

        // };
        $scope.Review = function () {
            $scope.IsDisabled = true;

            var _fileName = $scope.mRefNbr + '_' + ("0000000" + $scope.mInvNumber).slice(-7) + ".pdf";
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GenFilePDF?ID=" + $scope.mChungTu_Id + "&IsSign=false",
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);

                $scope.IsDisabled = false;
            }).error(function (message) {
                console.log(message);
                $scope.IsDisabled = false;
            });
        };

        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + $scope.mInvoiceTemplateID,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mInvFormNo = invoiceTemplate.invoiceTemplateCode;
                    $scope.mInvSerialNo = invoiceTemplate.symbol;
                }
            }, function (reason) {
            });
        };

        function GetInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                    + "&TypeOfInvoiceCode=" + $scope.Module
            }).then(function (response) {
                $scope.arrInvoiceTemplate = response.data;
                if ($scope.IsUpdate == false) {
                    $scope.mInvoiceTemplateID = String(response.data[0].ID);
                    $scope.mInvFormNo = response.data[0].invoiceTemplateCode;
                    $scope.mInvSerialNo = response.data[0].symbol;
                }
            }, function (error) {
                console.log(error);
            });
        }



        /* DELETE chứng từ KHẤU TRỪ THUẾ TNCN => UPDATE ND70_LTD109_TNCN DATHAYDOI = DELETE */
        // $scope.delete = function () {
        //     $scope.IsDisabled = true;
        //     $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_Delete?ID=" + sessionStorage.itemId).then(function (response) { //UPDATE SUCCESS
        //         swal({
        //             title: "Thông báo",
        //             text: "Hủy chứng từ thành công!",
        //             icon: "success",
        //             button: "Đóng",
        //         }).then(function () {
        //             // $state.reload();
        //             $scope.BackPage();
        //         });
        //     }, function (reason) { //UPDATE ERRORS
        //         var objResult = reason.data;
        //         swal({
        //             title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
        //         }).then(function () {
        //             $scope.BackPage();
        //         });
        //     });
        // }



        /** Manage upload File **/
        $scope.removeFileInvoiceDetail = function () {
            $rootScope.fileTemplate = undefined;
            $rootScope.FileTemplateData = undefined;
            this.isHasFile = false;
            this.checkEdit = false;
            // $scope.IsUnlock = true;//Hieện nút đồng ý khi bỏ excel

        }

        $scope.uploadFileInvoiceDetail = function () {
            angular.element("input[type='file']").val(null);
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
            // $scope.IsUnlock = false;//Ẩn nút đồng ý nếu import excel

        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {

                    var fileName = $scope.file.name;
                    var index = fileName.lastIndexOf(".");
                    var ext = fileName.substr(index, fileName.length - index);
                    if (index <= 0 || (index > 0 && ext != ".xls" && ext != ".xlsx")) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng Excel!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function () {
                            return;
                        });
                    }
                    else {
                        $rootScope.fileTemplate = fileName;
                        var data = new FormData();
                        data.append("filename", $scope.file.name);
                        data.append("enterpriseId", sessionStorage.enterpriseId);
                        data.append("userID", user.ID);
                        data.append("file", $scope.file);

                        $rootScope.FileTemplateData = data;

                        //SET READONLY FOR DETAIL'S CONTROLS
                        $scope.checkEdit = true;
                        $scope.isHasFile = true;
                    }
                });
        };

        $scope.Import = function () {
            if ($rootScope.FileTemplateData != undefined) {
                $scope.OpenFile = true;
                // var typeOfRevenueId = $scope.TypeOfRevenue.selected != undefined ? $scope.TypeOfRevenue.selected.ID : 0;

                var inputData = {
                    // 'ID': $scope.mChungTu_Id <= 0 ? -1 : $scope.mChungTu_Id,
                    'ID': -1,
                    'Module': $scope.Module,
                    'InvoiceTemplateID': $scope.mInvoiceTemplateID,
                    // 'TypeOfRevenueID': typeOfRevenueId,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,
                };

                // console.log(inputData);
                // return;

                var data = new FormData();
                data = $rootScope.FileTemplateData;
                data.append("model", JSON.stringify(inputData));
                //Upload file Template
                var reg = {
                    url: hostName.url + 'api/ND70/ND70_CHUNGTU_IMPORT',
                    method: 'POST',
                    data: data,
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    },
                };

                $http(reg).then(function (response) {
                    var result = response.data;

                    if (result.ResultCode == 0) { //SUCCESS
                        swal({
                            title: "Thông báo",
                            text: "Lưu thông tin thành công!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            // var invoiceId = result.Data;
                            // sessionStorage.itemId = invoiceId;
                            location.href = "#/CHUNGTU_TNCN";
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo",
                            text: result.Message,
                            icon: "error",
                            button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                    }
                }, //#SUCCESS
                    function (error) { //ERROR
                        swal("Không thể lưu thông tin, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                        $state.reload();
                    }); //#ERROR

            }
        }


        $scope.IMPORT_FILE = function () {
            $scope.checkImport = !$scope.checkImport;
            console.log("import");
            if ($scope.checkImport === false) {
                $scope.btnImport = "btn btn-danger btn-with-icon btn-xs col-sm-offset-1";
                $scope.nameImport = "BỎ IMPORT";
                $scope.iconImport = "ion-close-circled";
            }
            if ($scope.checkImport === true) {
                $scope.btnImport = "btn btn-info btn-with-icon btn-xs col-sm-offset-1";
                $scope.nameImport = "IMPORT";
                $scope.iconImport = "ion-archive";
            }
        }

        /* GÁN GIÁ TRỊ = 0 LÊN DOM */
        $scope.CalTotalAmount = function () {
            if ($scope.BHiem === 0) {
                angular.element(document).find('#BHiem').val(0).triggerHandler('input');
            }
            if ($scope.TThien === 0) {
                angular.element(document).find('#TThien').val(0).triggerHandler('input');
            }
            if ($scope.TTNCThue === 0) {
                angular.element(document).find('#TTNCThue').val(0).triggerHandler('input');
            }
            if ($scope.TTNTThue === 0) {
                angular.element(document).find('#TTNTThue').val(0).triggerHandler('input');
            }
            if ($scope.SThue === 0) {
                angular.element(document).find('#SThue').val(0).triggerHandler('input');
            }
        }
    };

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author THIENVM
 * created on 2025-05-14
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('CreateCHUNGTU_TNCN_THAYDOICtrl', CreateCHUNGTU_TNCN_THAYDOICtrl);

    /*******    +++ START CONTROLLER    *******/
    function CreateCHUNGTU_TNCN_THAYDOICtrl($scope, $http, $stateParams, hostName, $state) {
        //GENERAL VARIABLES
        var user = JSON.parse(localStorage.getItem("dataUser"));

        // $scope.mRefDate = (new Date());

        $scope.arrLoaiHoaDonCQT = [];
        $scope.arrHinhThucHoaDon = [];
        $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.ShowTBSS = false;
        $scope._title = "Tạo ";
        // $scope.mModule = $stateParams.Module;
        $scope.mModule = sessionStorage.Module;

        // console.log($scope.mModule);
        if (sessionStorage.IsUpdate == true) {
            $scope._title = "Thông tin "
        }

        if ($scope.mModule == "REPLACE")

            $scope.PageTitle = $scope._title + "Chứng từ Thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = $scope._title + "Chứng từ Điều chỉnh";

        $scope.IsChinhThongTin = false;
        $scope.IsUnlock = true;
        $scope.IsPublic = false;
        $scope.IsUpdate = false;
        if (sessionStorage.IsUpdate == true || sessionStorage.IsUpdate == "true") {
            $scope.IsUpdate = true;
        }

        $scope.IsAdjust = true;
        if ($scope.mModule == "REPLACE")
            $scope.IsAdjust = false;
        // console.log("$scope.mModule=" + $scope.mModule + "; $scope.IsAdjust=" + $scope.IsAdjust);

        $scope.mND70_CHUNGTU_THAYDOI_ID = 0;
        $scope.mParentID = 0;
        $scope.mND70_CHUNGTU_ID = 0;

        // getTypeOfPayment();
        // getInvoiceTemplate();
        // GetLoaiDieuChinh();
        // GetHTHD();//Lấy thông tin loại Chứng từ, hình thức Chứng từ đã đăng ký của đơn vị

        // console.log($scope.IsUpdate);//false


        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + $scope.mInvoiceTemplateID,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mInvFormNo = invoiceTemplate.invoiceTemplateCode;
                    $scope.mInvSerialNo = invoiceTemplate.symbol;
                }
            }, function (reason) {
            });
        };
        GetInvoiceTemplate();
        function GetInvoiceTemplate() {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId
                    + "&TypeOfInvoiceCode=TK"
            }).then(function (response) {
                $scope.arrInvoiceTemplate = response.data;
                if ($scope.IsUpdate == false) {
                    $scope.mInvoiceTemplateID = String(response.data[0].ID);
                    $scope.mInvFormNo = response.data[0].invoiceTemplateCode;
                    $scope.mInvSerialNo = response.data[0].symbol;
                }
            }, function (error) {
                console.log(error);
            });
        }
        // Update
        if ($scope.IsUpdate == true) {
            // console.log(sessionStorage.itemId);
            // return;
            $scope.IsPublic = true;
            $scope.ShowTBSS = true;//SHOW TBSS
            $scope.mND70_CHUNGTU_THAYDOI_ID = sessionStorage.itemId;

            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_GetByID?ID=" + $scope.mND70_CHUNGTU_THAYDOI_ID + '&EnterpriseID=' + sessionStorage.enterpriseId,
            }).then(function (response) {
                $scope.Adjust = response.data[0];
                // console.log($scope.Adjust);
                // return;

                if ($scope.Adjust != undefined) {
                    $scope.mND70_CHUNGTU_ID = $scope.Adjust.ND70_CHUNGTU_NewId; // ct hiện tại
                    $scope.ParentID = $scope.Adjust.ND70_CHUNGTU_Id; // ct củ

                    console.log($scope.mND70_CHUNGTU_ID);
                    console.log($scope.ParentID);

                    if ($scope.Adjust.MaTinhTrang != 'LAPMOI')
                        $scope.IsUnlock = false;
                    if ($scope.Adjust.FileBienBan != '')
                        $scope.IsPublic = false;

                    Paste($scope.mND70_CHUNGTU_ID, false);
                    // Lấy thông tin Chứng từ cũ  
                    $http({
                        method: "GET",
                        url: hostName.url + "api/ND70/ND70_CHUNGTU_GetById?ID=" + $scope.ParentID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                    }).then(function (response) {
                        $scope.ChungTu = response.data[0];
                        if ($scope.ChungTu != undefined) {
                            $scope.old_mRefDate = decryptDate($scope.ChungTu.RefDate);
                            $scope.old_mInvSerialNo = $scope.ChungTu.InvSerialNo;
                            $scope.old_mInvNumber = $scope.ChungTu.InvNumber;
                        }
                    }, function (reason) { //ERROR
                        console.log(reason);
                    });
                }
            }, function (reason) {
                console.log(reason);
            });


        }
        //Insert
        else {
            console.log(sessionStorage.itemId);

            if (sessionStorage.itemId != undefined)
                $scope.mND70_CHUNGTU_ID = sessionStorage.itemId;

            if ($scope.mND70_CHUNGTU_ID != 0)
                Paste($scope.mND70_CHUNGTU_ID, true);
        };

        function Paste(ChungTu_ID, IsCopy) {
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_GetByID?ID=" + ChungTu_ID,
            }).then(function (response) {
                $scope.ChungTu = response.data[0];

                if ($scope.ChungTu != undefined) {

                    if (IsCopy == false) { // update
                        $scope.mInvoiceTemplateID = $scope.ChungTu.InvoiceTemplateID.toString();

                        $scope.mRefDate = decryptDate($scope.ChungTu.RefDate);
                        $scope.mInvFormNo = $scope.ChungTu.InvFormNo;
                        $scope.mInvSerialNo = $scope.ChungTu.InvSerialNo;
                        $scope.mInvNumber = $scope.ChungTu.InvNumber;
                        $scope.LDo = $scope.ChungTu.SaiSot_LyDo;
                        $scope.GChu = $scope.ChungTu.GChu;

                    }
                    else { // insert
                        $scope.mRefDate = new Date();
                        $scope.mND70_CHUNGTU_ID = -1;
                        $scope.mParentID = $scope.ChungTu.ID;

                        $scope.old_mRefDate = decryptDate($scope.ChungTu.RefDate);
                        $scope.old_mInvSerialNo = $scope.ChungTu.InvSerialNo;
                        $scope.old_mInvNumber = $scope.ChungTu.InvNumber;
                    }

                    // $scope.mParentID = $scope.ChungTu.ID;

                    //  $scope.mRefDate = decryptDate($scope.ChungTu.RefDate);
                    $scope.mCustomerName = $scope.ChungTu.CustomerName;
                    $scope.mCompanyName = $scope.ChungTu.CompanyName;
                    $scope.mTaxCode = $scope.ChungTu.TaxCode;
                    $scope.mAddress = $scope.ChungTu.Address;

                    $scope.mFromDate = decryptDate($scope.ChungTu.FromDate);
                    $scope.mToDate = decryptDate($scope.ChungTu.ToDate);
                    $scope.mNationality = $scope.ChungTu.Nationality;

                    var txtIsResident = angular.element(document).find('#txtIsResident')[0];
                    txtIsResident.checked = $scope.ChungTu.IsResident;

                    $scope.CCCDan = $scope.ChungTu.CCCDan;
                    $scope.SDThoai = $scope.ChungTu.SDThoai;
                    $scope.DCTDTu = $scope.ChungTu.DCTDTu;


                    $scope.BHiem = $scope.ChungTu.BHiem;
                    $scope.TThien = $scope.ChungTu.TThien;
                    $scope.TTNCThue = $scope.ChungTu.TTNCThue;
                    $scope.TTNTThue = $scope.ChungTu.TTNTThue;
                    $scope.SThue = $scope.ChungTu.SThue;
                }
            }, function (reason) { //ERROR
                console.log(reason);
            });
        }


        //FUNCTION SAVE DATA
        $scope.save = function () {

            var txtRefDate = angular.element(document).find('#txtRefDate')[0];
            var txtCustomerName = angular.element(document).find('#mCustomerName')[0];
            var cboInvoiceTemplate = angular.element(document).find('#cboInvoiceTemplate')[0];

            var txtTaxCode = angular.element(document).find('#txtTaxCode')[0];
            var txtAddress = angular.element(document).find('#txtAddress')[0];
            var txtCCCDan = angular.element(document).find('#CCCDan')[0];
            var txtSDThoai = angular.element(document).find('#SDThoai')[0];
            var txtDCTDTu = angular.element(document).find('#DCTDTu')[0];
            var txtGChu = angular.element(document).find('#GChu')[0];

            var txtDescr = angular.element(document).find('#mDescr')[0];

            var txtFromDate = angular.element(document).find('#mFromDate')[0];
            var txtToDate = angular.element(document).find('#mToDate')[0];

            var _BHiem = angular.element(document).find('#BHiem')[0];
            var _TThien = angular.element(document).find('#TThien')[0];
            var _TTNCThue = angular.element(document).find('#TTNCThue')[0];
            var _TTNTThue = angular.element(document).find('#TTNTThue')[0];
            var _SThue = angular.element(document).find('#SThue')[0];

            var txtLDo = angular.element(document).find('#LDo')[0];

            //check empty

            var flag = true;
            if ($scope.old_mRefDate == '') {
                swal({ title: "Thông tin Số Chứng từ cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldBillNumber.focus();
                });
                flag = false;
                return;
            };
            if ($scope.old_mInvSerialNo == '') {
                swal({ title: "Thông tin Ký hiệu Chứng từ cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldSymbol.focus();
                });
                flag = false;
                return;
            };

            if ($scope.old_mInvNumber == '') {
                swal({ title: "Thông tin Ngày Chứng từ cũ", text: 'không được để trống!', icon: "warning", button: "Đóng" }).then(function () {
                    txtOldDateOfInvoice.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mRefDate == "") {
                swal({
                    title: "Vui lòng chọn thông tin \"Ngày chứng từ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtRefDate.focus();
                });
                flag = false;
                return;
            };
            if ($scope.mInvoiceTemplateID == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Mẫu chứng từ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    cboInvoiceTemplate.focus();
                });
                flag = false;
                return;
            };

            if ($scope.mCustomerName == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Họ và tên\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtCustomerName.focus();
                });
                flag = false;
                return;
            };
            if (txtSDThoai.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Số điện thoại\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtSDThoai.focus();
                });
                flag = false;
                return;
            }

            if ($scope.mAddress == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Địa chỉ \"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtAddress.focus();
                });
                flag = false;
                return;
            }

            if ($scope.mTaxCode == '') {
                if (txtCCCDan.value == '') {
                    swal({
                        title: "Vui lòng nhập thông tin \"CMND\"", icon: "warning", button: "Đóng"
                    }).then(function () {
                        txtCCCDan.focus();
                    });
                    flag = false;
                    return;
                };
            }

            if ($scope.mDescr == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khoản thu nhập\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtDescr.focus();
                });
                flag = false;
                return;
            }
            if ($scope.mFromDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Từ ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtFromDate.focus();
                });
                flag = false;
                return;
            }

            if ($scope.mToDate == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Đến ngày\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtToDate.focus();
                });
                flag = false;
                return;
            }

            if (_BHiem.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Bảo hiểm\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _BHiem.focus();
                });
                flag = false;
                return;
            };

            if (_TThien.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Khoản từ thiện\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TThien.focus();
                });
                flag = false;
                return;
            };

            if (_TTNCThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thu nhập chịu thuế \"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TTNCThue.focus();
                });
                flag = false;
                return;
            };

            if (_TTNTThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thu nhập tính thuế\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _TTNTThue.focus();
                });
                flag = false;
                return;
            };

            if (_SThue.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Thuế TNCN đã khấu trừ\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    _SThue.focus();
                });
                flag = false;
                return;
            };

            if (txtLDo.value == '') {
                swal({
                    title: "Vui lòng nhập thông tin \"Lý do xử lý\"", icon: "warning", button: "Đóng"
                }).then(function () {
                    txtLDo.focus();
                });
                flag = false;
                return;
            };

            // return;
            //if all ok then SAVE data to database
            if (flag == true) {
                var inputData = {
                    'ID': $scope.mND70_CHUNGTU_THAYDOI_ID <= 0 ? -1 : $scope.mND70_CHUNGTU_THAYDOI_ID,
                    'RefDate': encryptDate($scope.mRefDate),
                    'RefNbr': "",
                    'Module': "TK",

                    'FromDate': (txtFromDate.value),
                    'ToDate': (txtToDate.value),
                    // 'FromDate': encryptDate($scope.mFromDate),
                    // 'ToDate': encryptDate($scope.mToDate),
                    'CustomerName': txtCustomerName.value,//$scope.mCustomerName,
                    'CompanyName': $scope.mCompanyName,
                    'TaxCode': txtTaxCode.value,
                    'Address': $scope.mAddress,
                    'CCCDan': txtCCCDan.value,
                    'SDThoai': txtSDThoai.value,
                    'DCTDTu': txtDCTDTu.value,
                    'GChu': txtGChu.value,
                    'Nationality': $scope.mNationality,
                    'IsResident': txtIsResident.checked,
                    'PassportNumber': "",// $scope.mPassportNumber,
                    'PlaceOfIssue': "",// $scope.mPlaceOfIssue,
                    'DateOfIssue': "",// $scope.mDateOfIssue == undefined || $scope.mDateOfIssue == '' ? '01/01/1900' : encryptDate($scope.mDateOfIssue),

                    'InvoiceTemplateID': $scope.mInvoiceTemplateID,

                    'BHiem': _BHiem.value,
                    'TThien': _TThien.value,
                    'TTNCThue': _TTNCThue.value,
                    'TTNTThue': _TTNTThue.value,
                    'SThue': _SThue.value,

                    'Descr': txtDescr.value,
                    'Crtd_User': user.ID,
                    'LUpd_User': user.ID,
                    'EnterpriseID': sessionStorage.enterpriseId,

                    'ParentID': $scope.mParentID,
                    'SaiSot_Loai': $scope.mModule,
                    'SaiSot_IsThongTin': 0,
                    'SaiSot_LyDo': txtLDo.value,
                    'SaiSot_ThongTinTruoc': "",//$scope.mSaiSot_ThongTinTruoc,
                    'SaiSot_ThongTinSau': "",//$scope.mSaiSot_ThongTinSau,
                    'IsTBSS': 0,

                };
                // console.log(inputData);
                // return;
                $http.post(hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_Insert", inputData).then(function (response) { //UPDATE SUCCESS
                    var objResult = response.data;
                    // $scope.mND70_CHUNGTU_ID = objResult.Data;
                    $scope.mND70_CHUNGTU_THAYDOI_ID = objResult.ResultCode;
                    var flagDetail = true;

                    if (flagDetail == true) {
                        swal({
                            title: "Thông báo", text: "Lưu dữ liệu thành công!", icon: "success", button: "Đóng",
                        }).then(function () {
                            sessionStorage.itemId = $scope.mND70_CHUNGTU_THAYDOI_ID;
                            sessionStorage.IsUpdate = true;
                            $state.reload();
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo", text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!", icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $state.reload();
                        });
                    }
                },
                    function (reason) { //UPDATE ERRORS
                        var objResult = reason.data;
                        swal({
                            title: "Thông báo", text: objResult.Message, icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            // location.href = "#/HoaDon" + $scope.mModule;
                            // _backPage();
                        });
                    });
            }
        };


        $scope.backPage = function () {
            _backPage();
            // if ($scope.mModule == "REPLACE") {
            //     location.href = "#/ChungTuThayThe";
            // }
            // else {
            //     location.href = "#/ChungTuDieuChinh";
            // }
        };

        function _backPage() {
            if ($scope.mModule == "REPLACE") {
                location.href = "#/ChungTuThayThe";
            }
            else {
                location.href = "#/ChungTuDieuChinh";
            }
        }

        $scope.ReviewBienBan = function () {
            var _fileName = $scope.mSymbol + '_' + ("00000000" + $scope.mBillNumber).slice(-8) + '_' + $scope.mND70_CHUNGTU_THAYDOI_ID;
            $http({
                method: 'POST',
                url: hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Review?ID=" + $scope.mND70_CHUNGTU_THAYDOI_ID,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BienBan_" + _fileName + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
            }).error(function (message) {
                console.log(message);
            });

        };

        $scope.PublishBienBan = function () {
            $http.post(hostName.url + "api/ModifyInvoice/QD1450_HOADON_THAYDOI_Publish?ID=" + $scope.mND70_CHUNGTU_THAYDOI_ID, $scope.mND70_CHUNGTU_THAYDOI_ID)
                .then(function (success) {
                    swal({
                        title: "Thông báo",
                        text: "Biên bản đã phát hành, vui lòng đợi ký số!",
                        icon: "success", button: "Đóng",
                    }).then(function () {
                        $scope.backPage();
                    });
                },
                    function (errs) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể phát hành biên bản Chứng từ sai sót, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error", dangerMode: true, button: "Đóng",
                        }).then(function () {
                            $scope.backPage();
                        });
                        console.log(errs);
                    });
        };
        // $scope.FindData = function () {
        //     sessionStorage.Module = $scope.mModule;
        //     location.href = '#/SearchHoaDon';
        // };


        $scope.cboInvoiceTemplate_SelectedChangeEvent = function () {
            $http({
                method: "GET",
                url: hostName.url + "api/InvoiceTemplate/GetInvoiceTemplate/" + $scope.mInvoiceTemplateID,
            }).then(function (response) {
                var invoiceTemplate = response.data;
                if (invoiceTemplate.ID > 0) {
                    $scope.mSymbol = invoiceTemplate.symbol;
                    getTypeOfRevenue(invoiceTemplate.typeOfInvoiceId);
                }
            }, function (reason) {
            });
        };


        // function getTypeOfPayment() {
        //     $http({
        //         method: "GET",
        //         url: hostName.url + "api/TypeOfPayment/List?enterpriseId=" + sessionStorage.enterpriseId
        //     }).then(function (response) { //SUCCESS
        //         $scope.arrTypeOfPayment = response.data;
        //         $scope.mTypeOfPaymentCode = 'TM';
        //     }, function (error) { //ERROR
        //     });
        // };

        // function GetLoaiDieuChinh() {
        //     $scope.arrLoaiDieuChinh.push({ ID: 'THONGTIN', Name: 'Thông tin' });
        //     $http({
        //         method: "GET",
        //         url: hostName.url + "api/ModifyInvoice/IsUserSupperModifyInvoice?UserID=" + user.ID + "&EnterpriseID=" + sessionStorage.enterpriseId
        //     }).then(function (response) {
        //         if (response.data == true)
        //             $scope.arrLoaiDieuChinh.push({ ID: 'TIEN', Name: 'Chi tiết, số tiền' });
        //     }, function (error) {
        //         console.log(error);
        //     });

        //     $scope.mLoaiDieuChinh = 'THONGTIN';
        //     if ($scope.IsAdjust == true) {
        //         $scope.IsChinhThongTin = true;
        //         $scope.arrLoaiDieuChinh.push({ ID: 'TBSS', Name: 'TBSS Đ/C' });
        //     }
        // }


        // function getTypeOfRevenue(typeOfInvoiceId) {
        //     $http({
        //         method: "GET",
        //         url: hostName.url + "api/TypeOfRevenue/ListsTypeOfRevenue?enterpriseId=" + sessionStorage.enterpriseId + "&typeOfInvoiceId=" + typeOfInvoiceId
        //     }).then(function (response) {
        //         $scope.arrTypeOfRevenue = response.data;
        //     }, function (reason) {
        //         console.log(reason);
        //     });
        // }

        /* PRINT THONG BAO SAI SOT */
        $scope.TBSS = function () {
            var _fileName = $scope.old_mInvSerialNo + '_' + ("00000000" + $scope.old_mInvNumber).slice(-8) + '_' + "ThongBaoSaiSot_ChungTu.pdf";

            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_TBSS?ChungTuId=" + $scope.ParentID + "&EnterpriseId=" + sessionStorage.enterpriseId,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = _fileName; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                $scope.IsDisabled = false;
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
                $scope.IsDisabled = false;
            });
        }
    };

    function roundNumber(amount) {
        var quote = Math.floor(amount);
        var remainder = amount % 1;
        if (remainder > 0.5)
            quote += 1;
        return quote;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + '/' + day + '/' + year;
        if (strDate == "")
            return "";
        else return date;
    }

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }

    function decryptDate(strDate) {
        var x = new Date(Date.parse(strDate));
        var year = x.getFullYear();
        if (year == 1) {
            return new Date("0000/00/00");
        }
        return x;
    }

})();

/**
 * @author ThamPTH
 * created on 02/08/2022
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('SearchCHUNGTU_THAYDOICtrl', SearchCHUNGTU_THAYDOICtrl);

    /*******    +++ START CONTROLLER    *******/
    function SearchCHUNGTU_THAYDOICtrl($scope, $http, $stateParams, hostName, $filter, fileReader, $window) {

        var vDate = new Date();
        var vYear = vDate.getFullYear();
        var vMonth = vDate.getMonth();
        var user = JSON.parse(localStorage.getItem("dataUser"));
        $scope.mFromDate = new Date(vYear, vMonth, 1);
        $scope.mToDate = new Date();
        $scope.mStatusCode = "";
        $scope.mTypeOfRevenueCode = "";
        $scope.mInvoiceTemplateID = 0;
        $scope.arrData = [];
        // $scope.arrStatus = [];
        // $scope.arrInvoiceTemplate = [];
        $scope.arrTypeOfRevenue = [];
        $scope.mModule = sessionStorage.Module;

        $scope.Statuses = [];
        $scope.Status = {};
        $scope.InvoiceTemplates = [];
        $scope.InvoiceTemplate = {};
        // $scope.mModule = "DELETE";
        // if (sessionStorage.Module != undefined)
        //     $scope.mModule = sessionStorage.Module;

        if ($scope.mModule == "REPLACE")
            $scope.PageTitle = "Chứng từ Thay thế";
        else if ($scope.mModule == "ADJUST")
            $scope.PageTitle = "Chứng từ Điều chỉnh";

        //GENERAL VARIABLES
        $scope.smartTablePageSize = 10;

        $http({
            method: "GET",
            url: hostName.url + "api/QD1450/QD1450_DMTINHTRANG_Lists?"
                + "LoaiTinhTrang=300&EnterpriseId=" + sessionStorage.enterpriseId
        }).then(function (response) {
            // $scope.arrStatus = response.data;
            $scope.Statuses = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/InvoiceTemplate/GetListInvoiceTemplate?enterpriseId=" + sessionStorage.enterpriseId + "&TypeOfInvoiceCode=HD"
        }).then(function (response) {
            // $scope.arrInvoiceTemplate = response.data;
            $scope.InvoiceTemplates = response.data;
        }, function (error) {
            console.log(error);
        });

        $http({
            method: "GET",
            url: hostName.url + "api/ElectricInvoice/ListsTypeOfRevenues"
        }).then(function (response) {
            $scope.arrTypeOfRevenue = response.data.Table1;
        }, function (error) {
            console.log(error);
        });

        //select User
        $scope.selectUser = function (objSelect) {
            $scope.User = objSelect;
        }

        //function then call  WEB API get ElectronicInvoice's data is success
        function successCallBack(response) {
            $scope.arrData = response.data[0];
        };

        //function then call WEB API get ElectronicInvoice's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
        }

        //call WEB API to get ElectronicInvoice's data
        var queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
            + "&FromDate=" + encryptDate($scope.mFromDate) + "&ToDate=" + encryptDate($scope.mToDate)
            + "&StatusCode=&InvoiceTemplateID=&CustomerName=&InvNumber=&InvSerialNo=&TaxCode=&LoaiThu=%&UserID=";
        $http({
            method: "GET",
            url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_SearchHoaDon?" + queryString
        }).then(successCallBack, errorCallBack);


        $scope.ReturnParent = function (id) {
            sessionStorage.itemId = id;
            sessionStorage.IsUpdate = false;

            // if ($scope.mModule == "ADJUST") {
            sessionStorage.Module = $scope.mModule;
            console.log($scope.mModule);

            location.href = '#/CreateCHUNGTU_TNCN_THAYDOI'
            // }
            // if ($scope.mModule == "DELETE")
            //     location.href = '#/CreateHuyHoaDon';
            // else
            //     location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        $scope.backPage = function () {
            sessionStorage.itemId = 0;
            sessionStorage.IsUpdate = false;
            location.href = sessionStorage.urlReturn;

            // if ($scope.mModule == "DELETE")
            //     location.href = '#/CreateHuyHoaDon';
            // else
            //     location.href = '#/CreateHoaDonDieuChinh/' + $scope.mModule;
        };

        //filter ElectronicInvoice's data

        $scope.FindData = function () {
            searchData();
        };

        function searchData() {

            $scope.arrData = [];
            var UserId = $scope.User != undefined ? $scope.User.ID : '';
            var queryString = "";
            if ($scope.mInvNumber == undefined)
                $scope.mInvNumber = '';

            var fromDate = angular.element(document).find('#inputFromDate')[0].value;
            var toDate = angular.element(document).find('#inputToDate')[0].value;
            var statusId = $scope.Status.selected != undefined ? $scope.Status.selected.MaTinhTrang : '';
            var invoiceTemplateId = $scope.InvoiceTemplate.ID != undefined ? $scope.InvoiceTemplate.ID : 0;
            var _taxCode = angular.element(document).find('#TaxCode')[0].value;

            queryString = "TypeOfAction=" + $scope.mModule + "&EnterpriseID=" + sessionStorage.enterpriseId
                + "&FromDate=" + convertDateFormat(fromDate) + "&ToDate=" + convertDateFormat(toDate)
                + "&TaxCode=" + _taxCode// $scope.mTaxCode
                + "&InvNumber=" + $scope.InvNumber
                + "&InvSerialNo=" + $scope.InvSerialNo + "&CustomerName=" + $scope.mCustomerName
                + "&StatusCode=" + statusId + "&InvoiceTemplateID=" + invoiceTemplateId
                + "&LoaiThu=" + $scope.mTypeOfRevenueCode + "&UserID=" + UserId;
            //call Webservice to get ElectronicInvoice's data
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_CHUNGTU_THAYDOI_SearchHoaDon?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter ElectronicInvoice's data


    };
    /******  ### END CONTROLLER  ******/

    function encryptDate(objDate) {
        var month = ("0" + (objDate.getMonth() + 1)).slice(-2);
        var day = ("0" + objDate.getDate()).slice(-2);
        var year = objDate.getFullYear();
        var date = month + '/' + day + '/' + year;
        if (date == "aN/aN/NaN")
            return '01/01/0001';
        return date;
    }
    function convertDateFormat(dateStr) {
        var parts = dateStr.split('/');
        if (parts.length !== 3) return dateStr; // basic validation
        return parts[1] + '/' + parts[0] + '/' + parts[2];
    };
})();

/**
 * @author Nguyen Huu Tuan
 * created on 06.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.enterprise')
        .controller('Message100Ctrl', Message100Ctrl);

    /**
     * CONTROLLER FOR MESSAGE 100
     * @param {*} $scope 
     * @param {*} $http 
     * @param {*} hostName 
     */
    function Message100Ctrl($scope, $http, hostName, $filter, $window) {

        sessionStorage.editId = undefined;

        /**
         * GLOBAL VARIABLES
         */
        var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        vm.rowCollection = [];


        /**
         * GET DATA LIST FROM DATABASE
         */
        function successCallBack(response) {
            vm.rowCollection = response.data;
        };

        function errorCallBack(reason) {
            console.log(reason);
        }

        //DOWNLOAD SIGNATURE SERVICE
        $scope.getSignature = function () {
            //$window.open("https://drive.google.com/open?id=1SLpUulz9ozFu6VnUKeqE1mDpOZ64dkSU");
            // $window.open("https://drive.google.com/file/d/1vYqp_eJHeFLRhEDjy5nWHRdANmZk-ocC/view?usp=sharing");
            $window.open("https://drive.google.com/file/d/1LCsOoTelVoFwX9e2a6FJki6GNqWsLf2-/view?usp=sharing");

        }

        //init data
        initData();
        function initData() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_LTD100_Search?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(successCallBack, errorCallBack);
        };

        $scope.getResultFromTCT = function () {
            QD1450_RECEIVE_RESULT();
        };

        function QD1450_RECEIVE_RESULT() {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_RECEIVE_RESULT?EnterpriseId=" + sessionStorage.enterpriseId
                //method: "POST",
                //url: hostName.url + "api/QD1450/AUTO_QD1450_RECEIVE_RESULT"
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;

                //CO KET QUA
                if (_resultCode == "0") {
                    swal({
                        title: "Thông báo",
                        text: "Đã có kết quả phản hồi từ Cơ quan Thuế!",
                        icon: "success",
                        button: "Đóng",
                    }).then(function () {
                        initData();
                        //$state.reload();
                    });
                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo",
                        text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning",
                        dangerMode: true,
                        button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //+++   LAY KET QUA PHAN HOI TU CO QUAN THUE THEO MA THONG DIEP
        $scope.GetResultFromTCT = function (MaThongDiep, MaTinhTrang) {
            $scope.GetResult = true;

            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;
                var _MaLoaiThongDiep = response.data.MaLoaiThongDiep;

                //CO KET QUA
                if (_resultCode == "0") {

                    if (MaTinhTrang == 'DATIEPNHAN' && _MaLoaiThongDiep == "102") {
                        swal({
                            title: "Thông báo",
                            text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                            icon: "warning",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            //$state.reload();
                            $scope.GetResult = false;
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo",
                            text: "Đã có kết quả phản hồi từ Cơ quan Thuế!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            $scope.GetResult = false;
                            initData();
                            //$state.reload();
                        });
                    }

                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo",
                        text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning",
                        dangerMode: true,
                        button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileXML = function (FileXML) {

            $scope.OpenFile = true;

            // var inputData = {
            //     'FileHoaDon': FileXML,
            //     'EnterpriseId': sessionStorage.enterpriseId
            // };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            $http({
                method: 'GET',
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetFile?"
                    + "FileHoaDon=" + FileXML + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "DangKySuDung_" + _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };


        /**
         * METHODS
         */
        $scope.editRegisterInvoice = function (id) {
            sessionStorage.editId = id;
            location.href = '#/RegisterInvoice';
        };

        $scope.registerInvoice = function () {
            location.href = '#/RegisterInvoice';
        };

    };
    /**
     * END CONTROLLER
     */

})();

/**
 * @author Nguyen Huu Tuan
 * created on 03.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.QD1450')
        .controller('RegisterInvoiceCtrl', RegisterInvoiceCtrl);

    /**
     * CONTROLLER FOR REGISTER INVOICE
     * @param {*} $scope 
     * @param {*} $filter 
     * @param {*} $http 
     * @param {*} $state 
     * @param {*} hostName 
     */
    function RegisterInvoiceCtrl($scope, $filter, $http, $state, hostName) {

        /**
         * GLOBAL VARIABLES
         */
        $scope.isAlerted = false;
        $scope.isSave = true;
        $scope.GTinh = "NAM";
        $scope.TaxAuthority = {};
        $scope.ChildTaxAuthority = {};
        $scope.HThucDKys = [
            { ID: 1, Name: 'Đăng ký mới' },
            { ID: 0, Name: 'Thay đổi thông tin' },
        ];
        $scope.HThucDKy = {};
        $scope.HThucDKy.selected = { ID: 1, Name: 'Đăng ký mới' };
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //EDIT MODE
        if (sessionStorage.editId != undefined && sessionStorage.editId != 'undefined') {
            $scope.isAlerted = true;

            $http({
                method: "GET",
                url: hostName.url
                    + "api/QD1450/QD1450_LTD100_GetById?ID=" + sessionStorage.editId
                    + "&EnterpriseId=" + sessionStorage.enterpriseId,
            })
                .then(function (response) {
                    var ltd100 = response.data[0];

                    //NEU CO DU LIEU
                    if (ltd100 != undefined) {
                        if (ltd100.MaTinhTrang == 'CHOKETQUA' || ltd100.MaTinhTrang == 'DATIEPNHAN') {
                            $scope.isAlerted = false;
                            $scope.isSave = false;
                        };

                        $scope.inputTaxCode = ltd100.TaxCode;
                        $scope.inputBusinessNameVN = ltd100.enterpriseNameVN;
                        $scope.ChildTaxAuthority.selected = { ID: ltd100.taxAuthorityId, taxAuthorityName: ltd100.taxAuthorityName };
                        $scope.inputContactPerson = ltd100.ContactPerson;
                        $scope.inputEmail = ltd100.Email;
                        $scope.inputPhone = ltd100.Phone;

                        if (ltd100.NewRegistration == true) $scope.HThucDKy.selected = { ID: 1, Name: 'Đăng ký mới' };
                        else $scope.HThucDKy.selected = { ID: 0, Name: 'Thay đổi thông tin' };

                        $scope.inputHTHDonCoMa = ltd100.HaveCode;
                        $scope.inputHTHDonKhongMa = ltd100.DontHaveCode;

                        // $scope.inputNNTDBKKhan = ltd100.DifficultArea;
                        // $scope.inputNNTKTDNUBND = ltd100.CommitteeSuggest;
                        // $scope.inputCDLTTDCQT = ltd100.TransferDataDirect;
                        // $scope.inputCDLQTCTN = ltd100.TransferDataViaTCTN;

                        $scope.inputCDDu = ltd100.TransferFull;
                        $scope.inputCBTHop = ltd100.TransferPivotTabel;

                        $scope.inputHDGTGT = ltd100.UseVATInvoice;
                        $scope.inputHDBHang = ltd100.UseBillOfSale;
                        $scope.inputHDBTSCong = ltd100.UsePublicProperty;
                        $scope.inputHDBHDTQGia = ltd100.UseNationalReserve;
                        $scope.inputHDKhac = ltd100.UseOther;
                        $scope.inputCTu = ltd100.UseDocument;

                        $scope.TNDDPLuat = ltd100.TNDDPLuat;
                        $scope.DTDDPLuat = ltd100.DTDDPLuat;
                        $scope.CCCDan = ltd100.CCCDan;
                        $scope.SHChieu = ltd100.SHChieu;
                        $scope.NSDDPLuat = new Date(ltd100.NSDDPLuat); //convertJSONDate(ltd100.NSDDPLuat);
                        $scope.GTinh = ltd100.GTinh;


                        $scope.HDGTGTTHBLai = ltd100.HDGTGTTHBLai;
                        $scope.HDBHTHBLai = ltd100.HDBHTHBLai;
                        $scope.HDTMai = ltd100.HDTMai;
                        $scope.HDNCCNN = ltd100.HDNCCNN;
                        //get list Child of TaxAuthorities
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + ltd100.taxParentID,
                        }).then(function (response) {
                            $scope.ChildTaxAuthorities = response.data;
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });

                        //get Child of TaxAuthorites selected
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + ltd100.taxParentID,
                        }).then(function (response) {
                            var taxParent = response.data;
                            $scope.TaxAuthority.selected = { ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode };
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });
                    };

                }, function (reason) {
                    console.log(reason);
                });
        }

        //NEW MODE
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/GetEnterprise?ID=" + sessionStorage.enterpriseId,
            })
                .then(function (response) {
                    //$scope.Enterprise = [];
                    $scope.Enterprise = response.data;
                    //console.log($scope.Enterprise);
                    if ($scope.Enterprise != undefined) {
                        //put Enterprise's data into Form's controls
                        $scope.inputTaxCode = $scope.Enterprise.taxCode;
                        $scope.ChildTaxAuthority.selected = { ID: $scope.Enterprise.taxAuthorityId, taxAuthorityName: $scope.Enterprise.taxAuthorityName };
                        $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;

                        $scope.inputContactPerson = $scope.Enterprise.contactPerson;
                        $scope.inputEmail = $scope.Enterprise.email;
                        $scope.inputPhone = $scope.Enterprise.phone;

                        $scope.inputHDGTGT = true;
                        $scope.inputHTHDonCoMa = true;
                        $scope.inputCDDu = true;

                        //get list Child of TaxAuthorities
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            $scope.ChildTaxAuthorities = response.data;
                        }, function (reason) {
                            console.log(reason);
                        });

                        //get Child of TaxAuthorites selected
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            var taxParent = response.data;
                            $scope.TaxAuthority.selected = { ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode };
                        }, function (reason) {
                            console.log(reason);
                        });
                    }
                }, function (reason) {
                    console.log(reason);
                });
        };

        //change taxAuthority
        $scope.selectChanged = function (taxAuthority) {
            $scope.TaxAuthority.selected = taxAuthority;
            $scope.ChildTaxAuthority.selected = undefined;

            //get list Child of TaxAuthorities
            $http({
                method: "GET",
                url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + taxAuthority.taxAuthorityCode,
            }).then(function (response) {
                $scope.ChildTaxAuthorities = response.data;
            }, function (reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        };

        $scope.selectChangedChild = function (taxAuthority) {
            $scope.ChildTaxAuthority.selected = taxAuthority;
        };
        $scope.onGenderChange = function (_gender) {
            // console.log(_gender);
            $scope.GTinh = _gender;
        }
        $scope.changeHThucDKy = function (obj) {
            $scope.HThucDKy.selected = obj;
        };

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseNameVN = angular.element(document).find('#inputBusinessNameVN')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var email = angular.element(document).find('#inputEmail')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var taxAuthorityId = $scope.ChildTaxAuthority.selected != undefined ? $scope.ChildTaxAuthority.selected.ID : 0;

            var HTDKy = $scope.HThucDKy.selected.ID;
            var HTHDonCoMa = angular.element(document).find('#inputHTHDonCoMa')[0];
            var HTHDonKhongMa = angular.element(document).find('#inputHTHDonKhongMa')[0];
            var HTHDonCoMaMTT = angular.element(document).find('#inputHTHDonCoMaMTT')[0];

            // var NNTDBKKhan = angular.element(document).find('#inputNNTDBKKhan')[0];
            // var NNTKTDNUBND = angular.element(document).find('#inputNNTKTDNUBND')[0];
            // var CDLTTDCQT = angular.element(document).find('#inputCDLTTDCQT')[0];
            // var CDLQTCTN = angular.element(document).find('#inputCDLQTCTN')[0];

            var CDDu = angular.element(document).find('#inputCDDu')[0];
            var CBTHop = angular.element(document).find('#inputCBTHop')[0];

            var HDGTGT = angular.element(document).find('#inputHDGTGT')[0];
            var HDBHang = angular.element(document).find('#inputHDBHang')[0];
            var HDBTSCong = angular.element(document).find('#inputHDBTSCong')[0];
            var HDBHDTQGia = angular.element(document).find('#inputHDBHDTQGia')[0];
            var HDKhac = angular.element(document).find('#inputHDKhac')[0];
            var CTu = angular.element(document).find('#inputCTu')[0];
            // ND70
            var TNDDPLuat = angular.element(document).find('#TNDDPLuat')[0];
            var DTDDPLuat = angular.element(document).find('#DTDDPLuat')[0];
            var CCCDan = angular.element(document).find('#CCCDan')[0];
            var SHChieu = angular.element(document).find('#SHChieu')[0];
            var NSDDPLuat = angular.element(document).find('#NSDDPLuat')[0];
            // var GTinh = angular.element(document).find('#GTinh')[0];
            var HDGTGTTHBLai = angular.element(document).find('#HDGTGTTHBLai')[0];
            var HDBHTHBLai = angular.element(document).find('#HDBHTHBLai')[0];
            var HDTMai = angular.element(document).find('#HDTMai')[0];
            // var HDNCCNN = angular.element(document).find('#HDNCCNN')[0];

            var flag = true;

            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Thông tin Mã số thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    taxCode.focus();
                });
                flag = false;
                return;
            }

            //check empty enterpriseName
            if (enterpriseNameVN.value == '') {
                swal({
                    title: "Thông tin Tên đơn vị",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    enterpriseNameVN.focus();
                });
                flag = false;
                return;
            }

            //check empty taxAuthority
            if (taxAuthorityId == 0) {
                swal({
                    title: "Thông tin Cơ quan Thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty contactPerson
            if (contactPerson.value == '') {
                swal({
                    title: "Thông tin Người liên hệ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    contactPerson.focus();
                });
                flag = false;
                return;
            }

            //check empty email
            if (email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    email.focus();
                });
                flag = false;
                return;
            }

            //check empty phone
            if (phone.value == '') {
                swal({
                    title: "Thông tin Điện thoại",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    phone.focus();
                });
                flag = false;
                return;
            }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                var _id = data.data.Data;
                sessionStorage.editId = _id;
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function () {
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                //console.log(data);
            }
            //error function
            function errorCallBack(err) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                console.log(err);
            }

            //INPUT DATA IS VALID
            if (flag == true) {

                var _input = {
                    LTD100Id: (sessionStorage.editId == undefined || sessionStorage.editId == 'undefined')
                        ? -1 : sessionStorage.editId,
                    TaxCode: taxCode.value,
                    TaxAuthorityCode: taxAuthorityId,
                    ContactPerson: contactPerson.value,
                    Email: email.value,
                    Phone: phone.value,

                    NewRegistration: HTDKy,

                    HaveCode: HTHDonCoMa.checked,
                    DontHaveCode: HTHDonKhongMa.checked,
                    HaveCodeMTT: HTHDonCoMaMTT.checked,

                    DifficultArea: false, // NNTDBKKhan.checked,
                    CommitteeSuggest: false, // NNTKTDNUBND.checked,
                    TransferDataDirect: false, // CDLTTDCQT.checked,
                    TransferDataViaTCTN: HTHDonCoMa.checked == true ? false :
                        (HTHDonKhongMa.checked == true ? true : false), // CDLQTCTN.checked,    //CO MA = false, KHONG MA = true

                    TransferFull: CDDu.checked,
                    TransferPivotTabel: CBTHop.checked,

                    UseVATInvoice: HDGTGT.checked,
                    UseBillOfSale: HDBHang.checked,
                    UsePublicProperty: HDBTSCong.checked,
                    UseNationalReserve: HDBHDTQGia.checked,
                    UseOther: HDKhac.checked,
                    UseDocument: CTu.checked,

                    UserCreated: user.ID,
                    UserUpdated: user.ID,

                    EnterpriseId: user.enterpriseId,

                    TNDDPLuat: TNDDPLuat.value,
                    DTDDPLuat: DTDDPLuat.value,
                    CCCDan: CCCDan.value,
                    SHChieu: SHChieu.value,
                    NSDDPLuat: reConvertJSONDate(NSDDPLuat.value),
                    GTinh: $scope.GTinh, //GTinh.value,

                    CQXLTSCong: false,
                    NCCNN: false,

                    HDGTGTTHBLai: HDGTGTTHBLai.checked,
                    HDBHTHBLai: HDBHTHBLai.checked,
                    HDTMai: HDTMai.checked,
                    HDNCCNN: false//HDNCCNN.checked,
                };

                $http.post(hostName.url + "api/QD1450/QD1450_LTD100_Insert", _input)
                    .then(successCallBack, errorCallBack);

                //ADD NEW
                if (_input.LTD100Id == -1) {

                }

                //UPDATE
                else {
                    // $http.post(hostName.url + "api/QD1450/QD1450_LTD100_Update", _input)
                    // .then(successCallBack, errorCallBack);
                };

            };
            //#END INPUT DATA IS VALID 

        };
        /** End Check data and call api to save data to database **/

        //+++   SEND 2 TCTN
        $scope.sendCQT = function () {
            var _inputData = "EnterpriseId=" + user.enterpriseId
                + "&LTD100Id=" + sessionStorage.editId;

            $http.post(hostName.url + "api/QD1450/QD1450_LTD100_Publish?" + _inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        var UrlDownload = hostName.url + 'temp/' + user.enterpriseId + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },
                            data: JSON.stringify({
                                'Id': sessionStorage.editId,
                                'MLTDiep': '100',
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };

                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi tờ khai đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi tờ khai đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                            console.log(error);
                        });

                    },

                    //ERRORS
                    function (errs) {
                        console.log(errs);
                    });
        };
        //###   SEND 2 TCTN

        //XEM TRƯỚC NỘI DUNG ĐĂNG KÝ HDDT
        $scope.printRegister = function () {
            $http({
                method: "GET",
                url: 'http://localhost:7001/PdfSignService/GetCertificateClient_LTD100',
                headers: {
                    'Content-Type': "application/json"
                },
            }).success(function (data) {
                var sub = data.Subject;
                var a = sub.search("CN=");
                sub = sub.slice(a + 3);
                var b = sub.indexOf(",");
                sub = sub.slice(0, b);
                // var sub = data.Subject.replace("CN=", "");
                // sub = sub.split(", O=");
                // var subjectToken = sub[0];

                var subjectToken = sub;
                var seriToken = data.Seri;
                var NotBeforeDate = new Date(parseInt(data.NotBefore.substr(6))).toJSON();
                var NotAfterDate = new Date(parseInt(data.NotAfter.substr(6))).toJSON();
                $scope.IsDisabled = true;
                /* mã số thuế + id */
                var _fileName = $scope.inputTaxCode + '_' + sessionStorage.editId + '_' + "XemTruocTTDK.pdf";

                $http({
                    method: "POST",
                    url: hostName.url + "api/QD1450/QD1450_HOADON_GET_XEMTRUOCDK?HoaDonId=" + sessionStorage.editId + "&EnterpriseId=" + sessionStorage.enterpriseId
                        + "&subject=" + subjectToken + "&seri=" + seriToken + "&notbefore=" + NotBeforeDate + "&notafter=" + NotAfterDate
                    ,
                    responseType: 'arraybuffer',
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers["content-type"] || "application/octet-stream";
                    var blob = new Blob([data], { type: contentType });
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    var url = urlCreator.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = _fileName; //you may assign this value from header as well 
                    a.click();
                    window.URL.revokeObjectURL(url);
                    $scope.IsDisabled = false;
                    //console.log(contentType);
                }).error(function (message) {
                    $scope.IsDisabled = false;
                });
            }).error(function (error) {
                console.log(error);
            })
            // return;
            // $scope.IsDisabled = true;
            // /* mã số thuế + id */
            // var _fileName = $scope.inputTaxCode + '_' + sessionStorage.editId + '_' + "XemTruocTTDK.pdf";

            // $http({
            //     method: "POST",
            //     url: hostName.url + "api/QD1450/QD1450_HOADON_GET_XEMTRUOCDK?HoaDonId=" + sessionStorage.editId + "&EnterpriseId=" + sessionStorage.enterpriseId
            //         + "&subject=" + subjectToken + "&seri=" + seriToken + "&notbefore=" + NotBefore + "&notafter=" + NotAfter
            //     ,
            //     responseType: 'arraybuffer',
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = _fileName; //you may assign this value from header as well 
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     $scope.IsDisabled = false;
            //     //console.log(contentType);
            // }).error(function (message) {

            //     $scope.IsDisabled = false;
            // });
        };

    };
    /**
     * END CONTROLLER
     */

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + "/" + day + "/" + year;
        if (strDate == "") return "";
        else return date;
    }
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }
})();

/**
 * @author Nguyen Huu Tuan
 * created on 03.12.2021
 */
 (function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.QD1450')
        .controller('Message106Ctrl', Message106Ctrl);
  
    /** @ngInject */
    function Message106Ctrl($scope, fileReader, $filter, $http, $state, layoutPaths, $rootScope, hostName, baSidebarService) {

        // //HIDE LEFT MENU
        // baSidebarService.setMenuCollapsed(true);

        //Declare global variable of business that are using this system
        //sessionStorage.taxAuthorityId = undefined;
        $scope.TaxAuthority = {};
        $scope.ChildTaxAuthority = {};
        $scope.LoaiHoaDons = [
            {ID: 1, Name: 'Hóa đơn GTGT'}, 
            {ID: 2, Name: 'Hóa đơn bán hàng'}, 
            {ID: 3, Name: 'Hóa đơn khác'}, 
        ];
        $scope.LoaiHoaDon = {};
        $scope.LoaiHoaDon.selected = {ID: 1, Name: 'Hóa đơn GTGT'};
        
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //call REST API to get Enterprise's data by Id
        $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetEnterprise?ID=" + sessionStorage.enterpriseId,
        })
        .then(function(response) {
            //$scope.Enterprise = [];
            $scope.Enterprise = response.data;
            //console.log($scope.Enterprise);
            if ($scope.Enterprise != undefined) {
                //put Enterprise's data into Form's controls
                $scope.inputTaxCode = $scope.Enterprise.taxCode;
                $scope.ChildTaxAuthority.selected = {ID: $scope.Enterprise.taxAuthorityId, taxAuthorityName: $scope.Enterprise.taxAuthorityName};
                $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;

                $scope.inputGPKD = $scope.Enterprise.taxCode;
                $scope.inputAddressVN = $scope.Enterprise.addressVN;
                $scope.inputNgayThanhLap = new Date(2012, 7, 12);
                $scope.inputCQCQDTLap = 'Sở KHĐT TPHCM';

                $scope.inputContactPerson = 'Nguyễn Thanh An';
                $scope.inputEmail = 'nguyenthanhan@gmail.com';
                $scope.inputPhone = '028 3843 4314';

                $scope.inputTHHDVu = 'Thu phí dịch vụ tư vấn';
                $scope.inputTenNMua = 'Võ Minh Thiện';
                $scope.inputDChiMua = 'Bùi Đình Túy, Bình Thạnh, TPHCM';
                $scope.inputMSTMua = '0102454468';
                $scope.inputSoHDong = '';
                $scope.inputNgHDong = '';
                $scope.inputDoanhThu = '5000000';
                
                //get list Child of TaxAuthorities
                $http({
                    method: "GET",
                    url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + $scope.Enterprise.taxParentID,
                }).then(function(response) {
                    $scope.ChildTaxAuthorities = response.data;
                }, function(reason) {
                    $scope.error = reason.data;
                    console.log(reason);
                });

                //get Child of TaxAuthorites selected
                $http({
                    method: "GET",
                    url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + $scope.Enterprise.taxParentID,
                }).then(function(response) {
                    var taxParent = response.data;
                    $scope.TaxAuthority.selected = {ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode};
                }, function(reason) {
                    $scope.error = reason.data;
                    console.log(reason);
                });
            }
        }, function(reason) {
            $scope.error = reason.data;
            console.log(reason);
        });

        //change taxAuthority
        $scope.selectChanged = function(taxAuthority) {
            $scope.TaxAuthority.selected = taxAuthority;
            $scope.ChildTaxAuthority.selected = undefined;

            //get list Child of TaxAuthorities
            $http({
                method: "GET",
                url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + taxAuthority.taxAuthorityCode,
            }).then(function(response) {
                $scope.ChildTaxAuthorities = response.data;
            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        };

        $scope.selectChangedChild = function(taxAuthority) {
            $scope.ChildTaxAuthority.selected = taxAuthority;
        };

        $scope.changeLoaiHoaDon = function(obj) {
            $scope.LoaiHoaDon.selected = obj;
        };

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseNameVN = angular.element(document).find('#inputBusinessNameVN')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var email = angular.element(document).find('#inputEmail')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var taxAuthorityId = $scope.ChildTaxAuthority.selected != undefined ? $scope.ChildTaxAuthority.selected.ID : 0;

            var HTDKy = $scope.HThucDKy.selected.ID;
            var HTHDonCoMa = angular.element(document).find('#inputHTHDonCoMa')[0];
            var HTHDonKhongMa = angular.element(document).find('#inputHTHDonKhongMa')[0];
            
            var NNTDBKKhan = angular.element(document).find('#inputNNTDBKKhan')[0];
            var NNTKTDNUBND = angular.element(document).find('#inputNNTKTDNUBND')[0];
            var CDLTTDCQT = angular.element(document).find('#inputCDLTTDCQT')[0];
            var CDLQTCTN = angular.element(document).find('#inputCDLQTCTN')[0];

            var CDDu = angular.element(document).find('#inputCDDu')[0];
            var CBTHop = angular.element(document).find('#inputCBTHop')[0];

            var HDGTGT = angular.element(document).find('#inputHDGTGT')[0];
            var HDBHang = angular.element(document).find('#inputHDBHang')[0];
            var HDBTSCong = angular.element(document).find('#inputHDBTSCong')[0];
            var HDBHDTQGia = angular.element(document).find('#inputHDBHDTQGia')[0];
            var HDKhac = angular.element(document).find('#inputHDKhac')[0];
            var CTu = angular.element(document).find('#inputCTu')[0];
            
            var flag = true;

            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Thông tin Mã số thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    taxCode.focus();
                });
                flag = false;
                return;
            }

            //check empty enterpriseName
            if (enterpriseNameVN.value == '') {
                swal({
                    title: "Thông tin Tên đơn vị",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    enterpriseNameVN.focus();
                });
                flag = false;
                return;
            }

            //check empty taxAuthority
            if (taxAuthorityId == 0) {
                swal({
                    title: "Thông tin Cơ quan Thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty contactPerson
            if (contactPerson.value == '') {
                swal({
                    title: "Thông tin Người liên hệ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    contactPerson.focus();
                });
                flag = false;
                return;
            }

            //check empty email
            if (email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    email.focus();
                });
                flag = false;
                return;
            }

            //check empty phone
            if (phone.value == '') {
                swal({
                    title: "Thông tin Điện thoại",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    phone.focus();
                });
                flag = false;
                return;
            }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                //console.log(data);
            }
            //error function
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                console.log(data);
            }

            //if not empty with data which must to have
            if (flag == true) {

                

            }

        }
        /** End Check data and call api to save data to database **/
        
    } //end function controller
  
})(); //end function all
  
/**
 * @author Nguyen Huu Tuan
 * created on 06.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('Message109Ctrl', Message109Ctrl);

    /** 
     * CONTROLLER FOR MESSAGE 100
     * @param {*} $scope 
     * @param {*} $http 
     * @param {*} hostName 
     */
    function Message109Ctrl($scope, $http, hostName, $filter) {

        sessionStorage.editId = undefined;

        /**
         * GLOBAL VARIABLES
         */
        var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        vm.rowCollection = [];


        /**
         * GET DATA LIST FROM DATABASE
         */
        function successCallBack(response) {
            //console.log(response.data);
            vm.rowCollection = response.data;
        };

        function errorCallBack(reason) {
            console.log(reason);
        }

        //init data
        initData();
        function initData() {
            $http({
                method: "GET",
                url: hostName.url + "api/ND70/ND70_LTD109_TNCN_Search?EnterpriseId=" + sessionStorage.enterpriseId
            }).then(successCallBack, errorCallBack);
        };

        //+++   LAY KET QUA PHAN HOI TU CO QUAN THUE THEO MA THONG DIEP
        $scope.GetResultFromTCT = function (MaThongDiep, MaTinhTrang) {
            $http({
                method: "GET",
                url: hostName.url + "api/QD1450/QD1450_HOADON_RECEIVE_BY_MTD?EnterpriseId="
                    + sessionStorage.enterpriseId + "&MaThongDiep=" + MaThongDiep,
            }).then(function (response) {
                var _resultCode = response.data.ResultCode;
                var _MaLoaiThongDiep = response.data.MaLoaiThongDiep;

                //CO KET QUA
                if (_resultCode == "0") {

                    if (MaTinhTrang == 'DATIEPNHAN' && _MaLoaiThongDiep == "102") {
                        swal({
                            title: "Thông báo",
                            text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                            icon: "warning",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            //$state.reload();
                        });
                    }
                    else {
                        swal({
                            title: "Thông báo",
                            text: "Đã có kết quả phản hồi từ Cơ quan Thuế!",
                            icon: "success",
                            button: "Đóng",
                        }).then(function () {
                            searchData();
                            //$state.reload();
                        });
                    }

                }

                //CHUA CO KET QUA
                else {
                    swal({
                        title: "Thông báo",
                        text: "Chưa có kết quả phản hồi từ Cơ quan Thuế, vui lòng đợi Cơ quan Thuế phản hồi!",
                        icon: "warning",
                        dangerMode: true,
                        button: "Đóng",
                    }).then(function () {
                        //$state.reload();
                    });
                };
            }, function (error) {
                swal({
                    title: "Thông báo",
                    text: "Không thể nhận kết quả từ CQT, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //$state.reload();
                });
                console.log(error);
            });
        };


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileXML = function (FileXML) {

            $scope.OpenFile = true;

            // var inputData = {
            //     'FileHoaDon': FileXML,
            //     'EnterpriseId': sessionStorage.enterpriseId
            // };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            $http({
                method: 'GET',
                url: hostName.url + "api/ND70/ND70_LTD109_TNCN_GetFile?"
                    + "FileHoaDon=" + FileXML + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "DangKySuDung_" + _fileName + ".xml";
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };


        /**
         * METHODS
         */
        $scope.editRegisterInvoice = function (id) {
            sessionStorage.editId = id;
            location.href = '#/RegisterInvoice109';
        };

        $scope.registerInvoice = function () {
            location.href = '#/RegisterInvoice109';
        };

    };
    /**
     * END CONTROLLER
     */

})();

/**
 * @author Nguyen Huu Tuan
 * created on 03.12.2021
 */
(function () {
    'use strict';

    //DECLARE CONTROLLER
    angular.module('BlurAdmin.pages.ND70')
        .controller('RegisterInvoice109Ctrl', RegisterInvoice109Ctrl);

    /**
     * CONTROLLER FOR REGISTER INVOICE
     * @param {*} $scope 
     * @param {*} $filter 
     * @param {*} $http 
     * @param {*} $state 
     * @param {*} hostName 
     */
    function RegisterInvoice109Ctrl($scope, $filter, $http, $state, hostName) {

        /**
         * GLOBAL VARIABLES
         */
        $scope.isAlerted = false;
        $scope.isSave = true;
        $scope.TaxAuthority = {};
        $scope.ChildTaxAuthority = {};
        $scope.HThucDKys = [
            { ID: 1, Name: 'Đăng ký mới' },
            { ID: 0, Name: 'Thay đổi thông tin' },
        ];
        $scope.HThucDKy = {};
        $scope.HThucDKy.selected = { ID: 1, Name: 'Đăng ký mới' };
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //EDIT MODE
        if (sessionStorage.editId != undefined && sessionStorage.editId != 'undefined') {
            $scope.isAlerted = true;

            $http({
                method: "GET",
                url: hostName.url
                    + "api/ND70/ND70_LTD109_TNCN_GetById?ID=" + sessionStorage.editId
                    + "&EnterpriseId=" + sessionStorage.enterpriseId,
            })
                .then(function (response) {
                    var ltd109 = response.data[0];

                    //NEU CO DU LIEU
                    if (ltd109 != undefined) {
                        if (ltd109.MaTinhTrang == 'CHOKETQUA' || ltd109.MaTinhTrang == 'DATIEPNHAN') {
                            $scope.isAlerted = false;
                            $scope.isSave = false;
                        };

                        $scope.inputTaxCode = ltd109.TaxCode;
                        $scope.inputBusinessNameVN = ltd109.enterpriseNameVN;
                        $scope.ChildTaxAuthority.selected = { ID: ltd109.taxAuthorityId, taxAuthorityName: ltd109.taxAuthorityName };
                        $scope.inputContactPerson = ltd109.ContactPerson;
                        $scope.inputEmail = ltd109.Email;
                        $scope.inputPhone = ltd109.Phone;

                        if (ltd109.NewRegistration == true) $scope.HThucDKy.selected = { ID: 1, Name: 'Đăng ký mới' };
                        else $scope.HThucDKy.selected = { ID: 0, Name: 'Thay đổi thông tin' };

                        $scope.TCCNPHanh = ltd109.TCCNPHanh;
                        $scope.CQTPHanh = ltd109.CQTPHanh;
                        $scope.CTTNCNhan = ltd109.CTTNCNhan;
                        $scope.CTKTTTMDTu = ltd109.CTKTTTMDTu;
                        $scope.BLTPLPKIn = ltd109.BLTPLPKIn;

                        $scope.BLTPLPIn = ltd109.BLTPLPIn;
                        $scope.BLTPLPhi = ltd109.BLTPLPhi;
                        $scope.CDLQCCQT = ltd109.CDLQCCQT;
                        $scope.CDLQTCTN = ltd109.CDLQTCTN;
                        $scope.CDLQTCTNUT = ltd109.CDLQTCTNUT;

                        //get list Child of TaxAuthorities
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + ltd109.taxParentID,
                        }).then(function (response) {
                            $scope.ChildTaxAuthorities = response.data;
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });

                        //get Child of TaxAuthorites selected
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + ltd109.taxParentID,
                        }).then(function (response) {
                            var taxParent = response.data;
                            $scope.TaxAuthority.selected = { ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode };
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });
                    };

                }, function (reason) {
                    console.log(reason);
                });
        }

        //NEW MODE
        else {
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/GetEnterprise?ID=" + sessionStorage.enterpriseId,
            })
                .then(function (response) {
                    //$scope.Enterprise = [];
                    $scope.Enterprise = response.data;
                    //console.log($scope.Enterprise);
                    if ($scope.Enterprise != undefined) {
                        //put Enterprise's data into Form's controls
                        $scope.inputTaxCode = $scope.Enterprise.taxCode;
                        $scope.ChildTaxAuthority.selected = { ID: $scope.Enterprise.taxAuthorityId, taxAuthorityName: $scope.Enterprise.taxAuthorityName };
                        $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;

                        $scope.inputContactPerson = $scope.Enterprise.contactPerson;
                        $scope.inputEmail = $scope.Enterprise.email;
                        $scope.inputPhone = $scope.Enterprise.phone;
                        $scope.CTTNCNhan = true;//Chứng từ điện tử khấu trừ thuế thu nhập cá nhân
                        $scope.CDLQTCTN = true; //Chuyển dữ liệu qua TCTN (Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử 
                        $scope.TCCNPHanh = true;//Tổ chức, cá nhân phát hành

                        //get list Child of TaxAuthorities
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            $scope.ChildTaxAuthorities = response.data;
                        }, function (reason) {
                            console.log(reason);
                        });

                        //get Child of TaxAuthorites selected
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            var taxParent = response.data;
                            $scope.TaxAuthority.selected = { ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode };
                        }, function (reason) {
                            console.log(reason);
                        });
                    }
                }, function (reason) {
                    console.log(reason);
                });
        };

        //change taxAuthority
        $scope.selectChanged = function (taxAuthority) {
            $scope.TaxAuthority.selected = taxAuthority;
            $scope.ChildTaxAuthority.selected = undefined;

            //get list Child of TaxAuthorities
            $http({
                method: "GET",
                url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + taxAuthority.taxAuthorityCode,
            }).then(function (response) {
                $scope.ChildTaxAuthorities = response.data;
            }, function (reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        };

        $scope.onGenderChange = function (_gender) {
            console.log(_gender);

            $scope.GTinh = _gender;
        }
        $scope.selectChangedChild = function (taxAuthority) {
            $scope.ChildTaxAuthority.selected = taxAuthority;
        };

        $scope.changeHThucDKy = function (obj) {
            $scope.HThucDKy.selected = obj;
        };

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseNameVN = angular.element(document).find('#inputBusinessNameVN')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var email = angular.element(document).find('#inputEmail')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var taxAuthorityId = $scope.ChildTaxAuthority.selected != undefined ? $scope.ChildTaxAuthority.selected.ID : 0;

            var HTDKy = $scope.HThucDKy.selected.ID;
            // ND70

            var TCCNPHanh = angular.element(document).find('#TCCNPHanh')[0];
            var CQTPHanh = angular.element(document).find('#CQTPHanh')[0];
            var CTTNCNhan = angular.element(document).find('#CTTNCNhan')[0];
            var CTKTTTMDTu = angular.element(document).find('#CTKTTTMDTu')[0];
            var BLTPLPKIn = angular.element(document).find('#BLTPLPKIn')[0];
            var BLTPLPIn = angular.element(document).find('#BLTPLPIn')[0];
            var BLTPLPhi = angular.element(document).find('#BLTPLPhi')[0];
            var CDLQCCQT = angular.element(document).find('#CDLQCCQT')[0];
            var CDLQTCTN = angular.element(document).find('#CDLQTCTN')[0];
            var CDLQTCTNUT = angular.element(document).find('#CDLQTCTNUT')[0];

            var flag = true;

            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Thông tin Mã số thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    taxCode.focus();
                });
                flag = false;
                return;
            }

            //check empty enterpriseName
            if (enterpriseNameVN.value == '') {
                swal({
                    title: "Thông tin Tên đơn vị",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    enterpriseNameVN.focus();
                });
                flag = false;
                return;
            }

            //check empty taxAuthority
            if (taxAuthorityId == 0) {
                swal({
                    title: "Thông tin Cơ quan Thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty contactPerson
            if (contactPerson.value == '') {
                swal({
                    title: "Thông tin Người liên hệ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    contactPerson.focus();
                });
                flag = false;
                return;
            }

            //check empty email
            if (email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    email.focus();
                });
                flag = false;
                return;
            }

            //check empty phone
            if (phone.value == '') {
                swal({
                    title: "Thông tin Điện thoại",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    phone.focus();
                });
                flag = false;
                return;
            }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                var _id = data.data.Data;
                sessionStorage.editId = _id;
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function () {
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                //console.log(data);
            }
            //error function
            function errorCallBack(err) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    //location.href = "#/dashboard";
                    $state.reload();
                });
                console.log(err);
            }
            //INPUT DATA IS VALID
            if (flag == true) {

                var _input = {
                    LTD109Id: (sessionStorage.editId == undefined || sessionStorage.editId == 'undefined')
                        ? -1 : sessionStorage.editId,
                    TaxCode: taxCode.value,
                    TaxAuthorityCode: taxAuthorityId,
                    ContactPerson: contactPerson.value,
                    Email: email.value,
                    Phone: phone.value,
                    NewRegistration: HTDKy,

                    TCCNPHanh: TCCNPHanh.checked,
                    CQTPHanh: CQTPHanh.checked,
                    CTTNCNhan: CTTNCNhan.checked,
                    CTKTTTMDTu: CTKTTTMDTu.checked,
                    BLTPLPKIn: BLTPLPKIn.checked,
                    BLTPLPIn: BLTPLPIn.checked,
                    BLTPLPhi: BLTPLPhi.checked,
                    CDLQCCQT: CDLQCCQT.checked,
                    CDLQTCTN: CDLQTCTN.checked,
                    CDLQTCTNUT: CDLQTCTNUT.checked,

                    UserCreated: user.ID,
                    UserUpdated: user.ID,

                    EnterpriseId: user.enterpriseId,

                };


                // console.log(_input);
                // return;
                $http.post(hostName.url + "api/ND70/ND70_LTD109_TNCN_Insert", _input)
                    .then(successCallBack, errorCallBack);


            };
            //#END INPUT DATA IS VALID 

        };
        /** End Check data and call api to save data to database **/

        //###   SEND 2 TCTN HSM
        $scope.sendCQT = function () {
            var _inputData = "EnterpriseId=" + user.enterpriseId
                + "&LTD109Id=" + sessionStorage.editId;

            $http.post(hostName.url + "api/ND70/ND70_LTD109_TNCN_Publish?" + _inputData)
                .then(
                    //SUCCESS
                    function (success) {
                        //Ky token
                        var UrlDownload = hostName.url + 'temp/';// + user.enterpriseId  + '/';
                        var fileName = success.data.Data;

                        //Day file qua Service KY SO
                        var req = {
                            method: 'POST',
                            url: 'http://localhost:7001/PdfSignService/Sign1450XML',
                            headers: {
                                'Content-Type': "application/json"
                            },
                            data: JSON.stringify({
                                'Id': sessionStorage.editId,
                                'MLTDiep': '109',
                                'FileName': fileName,
                                'EnterpriseId': user.enterpriseId,
                                'UrlUpload': hostName.url + "api/QD1450/UploadFile2Server",
                                'UrlDownload': UrlDownload,
                            })
                        };
                        $http(req).then(function () {
                            swal({
                                title: "Thông báo",
                                text: "Đã gửi tờ khai đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                        }, function (error) {
                            swal({
                                title: "Thông báo",
                                text: "Không thể gửi tờ khai đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                                icon: "error",
                                dangerMode: true,
                                button: "Đóng",
                            }).then(function () {
                                $state.reload();
                            });
                            console.log(error);
                        });

                        //HSM
                        // swal({
                        //     title: "Thông báo",
                        //     text: "Đã gửi hóa đơn đến Cơ quan Thuế, vui lòng đợi kết quả phản hồi!",
                        //     icon: "success",
                        //     button: "Đóng",
                        // }).then(function () {
                        //     location.href = "#/Message109";
                        // });

                    },
                    //ERRORS
                    function (errs) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể gửi tờ khai đến Cơ quan Thuế, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            location.href = "#/RegisterInvoice109";
                        });
                        console.log(errs);
                    });
        };
    };
    /**
     * END CONTROLLER
     */

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0, 2);
        var month = strDate.slice(3, 5);
        var year = strDate.slice(6, 10);
        var date = month + "/" + day + "/" + year;
        if (strDate == "") return "";
        else return date;
    }
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }
})();

/**
 * @author Nguyen Huu Tuan
 * created on 06.12.2021
 */
 (function () {
    'use strict';

    //declare controller for Receive102103
    angular.module('BlurAdmin.pages.QD1450')
        .controller('Receive102103Ctrl', Receive102103Ctrl);

    /******************************************/
    /*******controller for Receive102103*******/
    /******************************************/
    function Receive102103Ctrl($scope, $http, $state, hostName, $window, $filter, fileReader) {

        
        
    };
    /******End controller for Receive102103 List******/

})();

/**
 * @author Nguyen Huu Tuan
 * created on 17.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for InventoryInvoice
    angular.module('BlurAdmin.pages.reports')
        .controller('InventoryInvoicePageCtrl', InventoryInvoicePageCtrl);
  
    //******controller for InventoryInvoice******
    function InventoryInvoicePageCtrl($scope, $http, $state, hostName) {
        $scope.Years = [];
        $scope.Year = {};

        var thisYear = new Date().getFullYear();
        var n = 0;
        var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        vm.rowCollection = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }; //#CHECK ADMIN PERMISSION

        for (n = new Date().getFullYear(); n > (thisYear-20); n--) {
            $scope.Years.push({ID: n, name: n});
        }
        $scope.Year.selected = {ID: thisYear, name: thisYear};

        //function then call WEB API get Report's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
        };

        //function then call WEB API get Report's data is error
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        }

        //call WEB API to get Report's data
        $http({
            method: "GET",
            url: hostName.url + "api/Report_InventoryInvoice/GetAllReport_InventoryInvoice?YearDeclare=" + thisYear + "&enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //filter Report's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var yearDeclare = $scope.Year.selected == undefined ? "":$scope.Year.selected.ID;
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            //call WEB API to get Report's data
            $http({
                method: "GET",
                url: hostName.url + "api/Report_InventoryInvoice/GetAllReport_InventoryInvoice?YearDeclare=" + yearDeclare + "&enterpriseId=" + enterpriseId,
            }).then(successCallBack, errorCallBack);
        }
        //end filter Report's data
    };
    //******End controller for InventoryInvoice******
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 06.12.2021
 */
 (function () {
    'use strict';

    //declare controller for SendReceiveLog
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('SendReceiveLogCtrl', SendReceiveLogCtrl);

    /******************************************/
    /*******controller for SendReceiveLog*******/
    /******************************************/
    function SendReceiveLogCtrl($scope, $http, hostName, $filter) {

        /**
         * GLOBAL VARIABLES
         */
         var vm = this;
         vm.rowCollection = [];


         /**
         * GET DATA LIST FROM DATABASE
         */
        function successCallBack(response) {
            //console.log(response.data);
            vm.rowCollection = response.data;
            //console.log(vm.rowCollection);
        };

        function errorCallBack(reason) {
            console.log(reason);
        }

        //init data
        initData();
        function initData() {
            vm.rowCollection = [];
            var _FromDate = angular.element(document).find('#inputFromDate')[0];
            var _ToDate = angular.element(document).find('#inputToDate')[0];

            var _queryString = "";
            if (_FromDate != undefined && _ToDate != undefined) {
                _queryString = hostName.url + "api/QD1450/NhatKy_TruyenNhan_Search?enterpriseId=" 
                    + sessionStorage.enterpriseId + "&fromDate=" + _FromDate.value 
                    + "&toDate=" + _ToDate.value;
            }
            else {
                _queryString = hostName.url + "api/QD1450/NhatKy_TruyenNhan_Search?enterpriseId=" 
                + sessionStorage.enterpriseId + "&fromDate=&toDate=";
            };

            $http({
                method: "GET",
                url: _queryString,
            }).then(successCallBack, errorCallBack);
        };


        $scope.getLogs = function() {
            initData();
        };


        //+++   LAY FILE HOA DON TU SERVER
        $scope.GetFileXML = function(FileXML) {

            $scope.OpenFile = true;

            // var inputData = {
            //     'FileHoaDon': FileXML,
            //     'EnterpriseId': sessionStorage.enterpriseId
            // };

            var _today = new Date();
            var _fileName = $filter('date')(_today, 'ddMMyyyyhhmmss', '+0700');

            $http({
                method: 'GET',
                url: hostName.url + "api/QD1450/QD1450_HOADON_GetFile?" 
                    + "FileHoaDon=" + FileXML + "&EnterpriseId=" + sessionStorage.enterpriseId,
                //data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //var _disposition = headers["content-disposition"];
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "NhatKyTruyenNhan_" + _fileName + ".xml";  
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);

                $scope.OpenFile = false;

            }).error(function (message) {
                $scope.OpenFile = false;
                //console.log(message);
            });

        };
        
    };
    /******End controller for SendReceiveLog List******/

})();

/**
 * @author Nguyen Huu Tuan
 * created on 17.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for ReportInvoiceDetail
    angular.module('BlurAdmin.pages.reports')
        .controller('ReportInvoiceDetailPageCtrl', ReportInvoiceDetailPageCtrl);
  
    //******controller for ReportInvoiceDetail******
    function ReportInvoiceDetailPageCtrl($scope, $http, $state, hostName, $filter) {
      
        var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        var n = 0;
        vm.rowCollection = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }; //#CHECK ADMIN PERMISSION

        //function then call WEB API get Report's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;

            for (n=0; n<vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);
            }
        };

        //function then call WEB API get Report's data is error
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        }

        //call WEB API to get Report's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        
        fromDate = new Date(nowYear, nowMonth, 1);
        toDate = new Date();
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&statusId=&invoiceTemplateId=&symbol=&medicalCode=&customerName=&billNumber=";
        $http({
            method: "GET",
            url: hostName.url + "api/Report_InvoiceDetail/GetAllReport_InvoiceDetail?" + queryString
        }).then(successCallBack, errorCallBack);

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //select Status
        $scope.selectChangedStatus = function(objSelect) {
            $scope.Status = objSelect;
        }

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function(objSelect) {
            $scope.InvoiceTemplate = objSelect;
        }

        //export report to Excel
        $scope.exportReport2Excel = function() {
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : "";
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "POST",
                url: hostName.url + "api/Report_InvoiceDetail/ExportReportDetailByExcel?" + queryString,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "ThongKeChiTietHoaDon.xlsx"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        }

        //export report to PDF
        $scope.exportReport2PDF = function() {
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : "";
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "POST",
                url: hostName.url + "api/Report_InvoiceDetail/ExportReportDetailByPDF?" + queryString,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "ThongKeChiTietHoaDon.pdf"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        }

        //filter Report's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            var statusId = $scope.Status != undefined ? $scope.Status.ID : 0;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : "";
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            
            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "GET",
                url: hostName.url + "api/Report_InvoiceDetail/GetAllReport_InvoiceDetail?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter Report's data
    };
    //******End controller for ReportInvoiceDetail******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 17.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for ReportMain
    angular.module('BlurAdmin.pages.reports')
        .controller('ReportMainPageCtrl', ReportMainPageCtrl);
  
    //******controller for ReportMain******
    function ReportMainPageCtrl($scope, $http, $state, hostName, $filter) {
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null )
                    $scope.isShow = true;
            };
        }; //#CHECK ADMIN PERMISSION

        //function then call Webservice get Report's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
            
            for (n=0; n < vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateCreated = convertJSONDate(vm.rowCollection[n].dateCreated);
                if (vm.rowCollection[n].QuarterDeclare == 'QUY1') {
                    vm.rowCollection[n].Quarter = "Quý 1";
                }
                else if (vm.rowCollection[n].QuarterDeclare == 'QUY2') {
                    vm.rowCollection[n].Quarter = "Quý 2";
                }
                else if (vm.rowCollection[n].QuarterDeclare == 'QUY3') {
                    vm.rowCollection[n].Quarter = "Quý 3";
                }
                else if (vm.rowCollection[n].QuarterDeclare == 'QUY4') {
                    vm.rowCollection[n].Quarter = "Quý 4";
                }
                else {
                    vm.rowCollection[n].Quarter = "";
                };
            }; //#for rowCollection
            
        };

        //function then call Webservice get Report's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call Webservice to get Report's data
        $http({
            method: "GET",
            url: hostName.url + "api/Report_TheUseOfInvoice/GetAllReport_TheUseOfInvoice?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //filter Report's data
        $scope.findData = function() {
            vm.rowCollection = [];
            var startDate = angular.element(document).find('#inputStartDate')[0];
            var endDate = angular.element(document).find('#inputEndDate')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var queryString = "";

            var dateFrom = reConvertJSONDate(startDate.value);
            var dateTo = reConvertJSONDate(endDate.value);
            queryString = "enterpriseId=" + enterpriseId + "&startDate=" + dateFrom + "&endDate=" + dateTo;
            
            //call API to get Report's data
            $http({
                method: "GET",
                url: hostName.url + "api/Report_TheUseOfInvoice/SearchReport_TheUseOfInvoice?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter Report's data

        //download file XML
        $scope.DownloadXml = function (filename, data, ReportID) {
            var pathTemp = hostName.url + 'Temp/';
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var dateOfInvoice;
            var date = new Date();
            dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

            var req = {
                method: 'POST',
                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                headers: {
                    'Content-Type': "application/json"
                },
                data: JSON.stringify({ 
                    'file': filename,
                    'urlDownload':  pathTemp,
                    'urlUpload': hostName.url + "api/Report_TheUseOfInvoice/UploadFileToServer",
                    'id': ReportID,
                    'dateOfInvoice': dateOfInvoice,
                    'enterpriseId': enterpriseId
                })
            };
                
            $http(req).then(function(response){
                $http({
                    method: 'GET',
                    url: hostName.url + "api/Report_TheUseOfInvoice/GetReport_TheUseOfInvoice/" + ReportID,
                    //params: inputData
                }).success(function (response) {
                    //console.log(response);
                    var link = document.createElement("a");
                    var pathSigned = hostName.url + 'Reports/' + enterpriseId + '/';
                    link.setAttribute("target", "_blank");
                    link.setAttribute("href", pathSigned + response.fileReport);
                    link.setAttribute("download", "BaoCaoTinhHinhSuDungHoaDon.xml");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).error(function (message) {
                    console.log(message);
                });
            }, function(error) {
                console.log(error);
                swal("Ký số bị lỗi, vui lòng kiểm tra lại token chữ ký số!", {
                    icon: "warning",
                    button: "Đóng"
                }).then();
            });
        };

        //export report to XML file to send to TaxAuthority
        $scope.exportXML = function(QuarterDeclare, YearDeclare) {
            var quarterDeclare = QuarterDeclare;
            var yearDeclare = YearDeclare;
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var inputData = {
                'QuarterDeclare': quarterDeclare,
                'YearDeclare': yearDeclare,
                'userCreated': user.ID,
                'enterpriseId': enterpriseId
            };

            // $http({
            //     method: 'POST',
            //     url: hostName.url + "api/Report_TheUseOfInvoice/WriteXML",
            //     data: inputData,
            //     responseType: 'arraybuffer',
            //     //params: inputData
            // }).success(function (data, status, headers) {
            //     headers = headers();
            //     //console.log(headers);
            //     var contentType = headers["content-type"] || "application/octet-stream";
            //     var blob = new Blob([data], { type: contentType });
            //     var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            //     var url = urlCreator.createObjectURL(blob);
            //     var a = document.createElement("a");
            //     document.body.appendChild(a);
            //     a.style = "display: none";
            //     a.href = url;
            //     a.download = "BaoCaoTinhHinhSuDungHoaDon.xml"; //you may assign this value from header as well 
            //     a.click();
            //     window.URL.revokeObjectURL(url);
            //     //console.log(contentType);
            // }).error(function (message) {
            //   swal("Không thể xuất file XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
            //       icon: "warning",
            //       button: "Đóng"
            //   }).then(function(error){
            //       console.log(error);
            //       $state.reload();
            //   });
            // });

            $http({
                traditional: true,
                url: hostName.url + "api/Report_TheUseOfInvoice/WriteXML2Client",
                method: 'POST',
                data: inputData,
                contentType: "application/json",
                dataType: "json"
            }).success(function (data) {
                $scope.DownloadXml(data.Data.fileName, data.Data.xmlData, data.Data.ReportID);
            }).error(function (data) {
                swal("Không thể xuất file XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $state.reload();
                });
            });
        }

        //export report to Excel file to store
        $scope.exportExcel = function(QuarterDeclare, YearDeclare) {
            var quarterDeclare = QuarterDeclare;
            var yearDeclare = YearDeclare;
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var inputData = {
                'QuarterDeclare': quarterDeclare,
                'YearDeclare': yearDeclare,
                'userCreated': user.ID,
                'enterpriseId': enterpriseId
            };
            $http({
                method: 'POST',
                url: hostName.url + "api/Report_TheUseOfInvoice/AddReport_TheUseOfInvoice",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BaoCaoTinhHinhSuDungHoaDon.xlsx"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        }
    };
    //******End controller for ReportMain******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

    function reConvertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        //var currentTime = new Date(strDate);
        var day = strDate.slice(0,2);
        var month = strDate.slice(3,5);
        var year = strDate.slice(6,10);
        var date = month + '/' + day + '/' +  year;
        if (strDate == "")
            return "";
        else return date;
    }
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 22.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Update ReportMain
    angular.module('BlurAdmin.pages.reports')
      .controller('UpdateReportMainPageCtrl', UpdateReportMainPageCtrl);
  
    //******controller for Update ReportMain******
    function UpdateReportMainPageCtrl($scope, $http, $state, hostName, $filter) {
        $scope.Years = [];
        $scope.Year = {};
        $scope.Quarter = {};
        var thisYear = new Date().getFullYear();
        var thisMonth = new Date().getMonth() + 1;
        var n = 0;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        $scope.Quarters = [
            {ID: 'QUY1', name: 'Quý 1'},
            {ID: 'QUY2', name: 'Quý 2'},
            {ID: 'QUY3', name: 'Quý 3'},
            {ID: 'QUY4', name: 'Quý 4'},
        ];
        if ( thisMonth >= 1 && thisMonth <=3 ) {    // Quarter 1
            $scope.Quarter.selected = {ID: 'QUY1', name: 'Quý 1'};
        }
        else if ( thisMonth >= 4 && thisMonth <=6 ) {    // Quarter 2
            $scope.Quarter.selected = {ID: 'QUY2', name: 'Quý 2'};
        }
        else if ( thisMonth >= 7 && thisMonth <=9 ) {    // Quarter 3
            $scope.Quarter.selected = {ID: 'QUY3', name: 'Quý 3'};
        }
        else {  // Quarter 4
            $scope.Quarter.selected = {ID: 'QUY4', name: 'Quý 4'};
        }

        for (n = new Date().getFullYear(); n > (thisYear-20); n--) {
            $scope.Years.push({ID: n, name: n});
        }
        $scope.Year.selected = {ID: thisYear, name: thisYear};

        $scope.DownloadXml = function (filename, data, ReportID) {
            var pathTemp = hostName.url + 'Temp/';
            var dateOfInvoice;
            var date = new Date();
            dateOfInvoice = $filter('date')(date, 'dd/MM/yyyy');

            var req = {
                method: 'POST',
                url: 'http://localhost:7001/PdfSignService/SignInvoice',
                headers: {
                    'Content-Type': "application/json"
                },
                data: JSON.stringify({ 
                    'file': filename,
                    'urlDownload':  pathTemp,
                    'urlUpload': hostName.url + "api/Report_TheUseOfInvoice/UploadFileToServer",
                    'id': ReportID,
                    'dateOfInvoice': dateOfInvoice,
                    'enterpriseId': sessionStorage.enterpriseId
                })
            };
              
            $http(req).then(function(response){
                $http({
                    method: 'GET',
                    url: hostName.url + "api/Report_TheUseOfInvoice/GetReport_TheUseOfInvoice?ID=" + ReportID + "&enterpriseId=" + sessionStorage.enterpriseId,
                    //params: inputData
                }).success(function (response) {
                    console.log(response);
                    var link = document.createElement("a");
                    var pathSigned = hostName.url + 'Reports/' + sessionStorage.enterpriseId + '/';
                    link.setAttribute("target", "_blank");
                    link.setAttribute("href", pathSigned + response.fileReport);
                    link.setAttribute("download", "BaoCaoTinhHinhSuDungHoaDon.xml");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).error(function (message) {
                    console.log(message);
                });
            }, function(error) {
                console.log(error);
            });
        };

        //export report to XML file
        $scope.exportReportXML = function() {
            var quarterDeclare = $scope.Quarter.selected == undefined ? "":$scope.Quarter.selected.ID;
            var yearDeclare = $scope.Year.selected == undefined ? "":$scope.Year.selected.ID;
            var inputData = {
                'QuarterDeclare': quarterDeclare,
                'YearDeclare': yearDeclare,
                'userCreated': user.ID,
                'enterpriseId': sessionStorage.enterpriseId
            };

            $http({
                traditional: true,
                url: hostName.url + "api/Report_TheUseOfInvoice/WriteXML2Client",
                method: 'POST',
                data: inputData,
                contentType: "application/json",
                dataType: "json"
            }).success(function (data) {
                //console.log(data);
                $scope.DownloadXml(data.Data.fileName, data.Data.xmlData, data.Data.ReportID);
            }).error(function (data) {
                swal("Không thể xuất file XML, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $state.reload();
                });
            });
        }

        //export report to file Excel
        $scope.exportReportExcel = function() {
            var quarterDeclare = $scope.Quarter.selected == undefined ? "":$scope.Quarter.selected.ID;
            var yearDeclare = $scope.Year.selected == undefined ? "":$scope.Year.selected.ID;
            var inputData = {
                'QuarterDeclare': quarterDeclare,
                'YearDeclare': yearDeclare,
                'userCreated': user.ID,
                'enterpriseId': sessionStorage.enterpriseId
            };
            $http({
                method: 'POST',
                url: hostName.url + "api/Report_TheUseOfInvoice/AddReport_TheUseOfInvoice",
                data: inputData,
                responseType: 'arraybuffer',
                //params: inputData
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BaoCaoTinhHinhSuDungHoaDon.xlsx"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        }
    };
    //******End controller for Update ReportMain******
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 21.06.2019
 */
(function () {
    'use strict';
  
    //declare controller for Statistic Chart
    angular.module('BlurAdmin.pages.reports')
      .controller('StatisticChartPageCtrl', StatisticChartPageCtrl);
  
    //******controller for Statistic Chart******
    function StatisticChartPageCtrl($scope, $http, $state, hostName, baConfig) {
        $scope.Years = [];
        $scope.Year = {};

        var n = 0;
        //var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        vm.thisYear = new Date().getFullYear();
        vm.rowCollection = [];

        for (n = new Date().getFullYear(); n > (vm.thisYear-20); n--) {
          $scope.Years.push({ID: n, name: n});
        }
        $scope.Year.selected = {ID: vm.thisYear, name: vm.thisYear};

        //call function when page init
        changeYear(vm.thisYear);

        $scope.selectedYear = function(objectYear) {
            changeYear(objectYear.ID);
        }

        function changeYear(selectedYear) {
            vm.thisYear = selectedYear;
            //console.log(selectedYear);
            var layoutColors = baConfig.colors;
            /**
             * ******************************************************************
             * KHAI BAO THONG TIN CHO BAR CHART: HOA DON NAM HIEN TAI
             */
            $scope.yearColors = [{
                backgroundColor:layoutColors.primary,
                hoverBackgroundColor:layoutColors.primaryDark,
                borderColor:layoutColors.primaryDark,
                hoverBorderColor:layoutColors.primaryDark
            }];
            //Lay So hoa don theo nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetBarChartYearInvoices?Year=" + vm.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                $scope.yearLabels = response.data[0][0];
                $scope.yearData = response.data[1];
                //$scope.yearValues = response.data[2];
            }, function(reason) {
                console.log(reason);
            });
            //Cai dat thuoc tinh hien thi cho BAR CHART Hoa Don nam hien tai
            $scope.yearOptions = {
                legend: {
                    display: false,
                    labels: { fontColor: 'white' },
                    series: { fontColor: 'white' }
                },
                tooltips : {
                    enabled: true,
                    titleFontFamily: "'Roboto'",
                    titleFontStyle: "normal",
                    titleFontColor: "#888888",
                    backgroundColor: "rgba(241, 242, 242, 0.9)",
                    titleFontSize: 15,
                    titleSpacing: 3,
                    titleMarginBottom: 10,
                    yPadding: 5,
                    bodyFontFamily: "'Roboto'",
                    bodyFontColor: "#888888",
                    bodyFontSize: 15,
                    bodySpacing: 5,
                    callbacks : {
                        title: function(items, data) {
                            return 'Số hóa đơn ' + items[0].xLabel;
                        },
                        label: function(item, data) {
                            return data.datasets[item.datasetIndex].data[item.index];// + ' (' + $scope.yearValues[item.datasetIndex][item.index] + ' VND)';
                        }
                    }
                },
            };

            /**
             * ********************************************************************
             * KHAI BAO THONG TIN CHO BAR CHART: DOANH THU NAM HIEN TAI
             */
            $scope.totalColors = [{
                backgroundColor:layoutColors.warning,
                hoverBackgroundColor:layoutColors.warningDark,
                borderColor:layoutColors.warningDark,
                hoverBorderColor:layoutColors.warningDark
            }];
            //Lay Doanh thu cua nam hien tai
            $http.get(hostName.url + "api/Dashboard/GetBarChartYearRevenue?Year=" + vm.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                $scope.totalLabels = response.data[0][0];
                $scope.totalData = response.data[1];
                //console.log($scope.totalData);
                //$scope.totalValues = response.data[2];
            }, function(reason) {
                console.log(reason);
            });
            //Cai dat thuoc tinh hien thi cho BAR CHART Doanh Thu nam hien tai
            $scope.totalOptions = {
                legend: {
                    display: false,
                    labels: { fontColor: 'white' },
                    series: { fontColor: 'white' }
                },
                tooltips : {
                    enabled: true,
                    titleFontFamily: "'Roboto'",
                    titleFontStyle: "normal",
                    titleFontColor: "#888888",
                    backgroundColor: "rgba(241, 242, 242, 0.9)",
                    titleFontSize: 15,
                    titleSpacing: 3,
                    titleMarginBottom: 10,
                    yPadding: 5,
                    bodyFontFamily: "'Roboto'",
                    bodyFontColor: "#888888",
                    bodyFontSize: 15,
                    bodySpacing: 5,
                    callbacks : {
                        title: function(items, data) {
                            return 'Doanh thu ' + items[0].xLabel;                
                        },
                        label: function(item, data) {
                            return data.datasets[item.datasetIndex].data[item.index];// + ' (' + $scope.totalValues[item.datasetIndex][item.index] + ' VND)';
                        }
                    }
                },
            };

            /**
             * ******************************************************************
             * KHAI BAO THONG TIN CHO BAR CHART: DOANH THU TANG TRUONG SO VOI CUNG KY
             */
            $scope.statYearColors = [{
                backgroundColor:layoutColors.primary,
                hoverBackgroundColor:layoutColors.primaryDark,
                borderColor:layoutColors.primaryDark,
                hoverBorderColor:layoutColors.primaryDark
            },
            {
                backgroundColor:layoutColors.warning,
                hoverBackgroundColor:layoutColors.warningDark,
                borderColor:layoutColors.warningDark,
                hoverBorderColor:layoutColors.warningDark
            }];
            //Lay Doanh thu tang truong so voi cung ky
            $http.get(hostName.url + "api/Dashboard/GetBarChart2YearRevenue?Year=" + vm.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                $scope.statYearSeries = response.data[0][0];
                $scope.statYearLabels = response.data[1][0];
                $scope.statYearData = response.data[2];
                //$scope.statYearValues = response.data[3];
            }, function(reason) {
                console.log(reason);
            });
            //Cai dat thuoc tinh hien thi cho BAR CHART Tang truong so voi cung ky
            $scope.statYearOptions = {
                legend: {
                    display: true,
                    labels: { fontColor: 'white' },
                    series: { fontColor: 'white' }
                },
                tooltips : {
                    enabled: true,
                    titleFontFamily: "'Roboto'",
                    titleFontStyle: "normal",
                    titleFontColor: "#888888",
                    backgroundColor: "rgba(241, 242, 242, 0.9)",
                    titleFontSize: 15,
                    titleSpacing: 3,
                    titleMarginBottom: 10,
                    yPadding: 5,
                    bodyFontFamily: "'Roboto'",
                    bodyFontColor: "#888888",
                    bodyFontSize: 15,
                    bodySpacing: 5,
                    callbacks : {
                        title: function(items, data) {
                            return 'Doanh thu ' + items[0].xLabel;                
                        },
                        label: function(item, data) {
                            return data.datasets[item.datasetIndex].data[item.index];// + ' (' + $scope.statYearValues[item.datasetIndex][item.index] + ' VND)';
                        }
                    }
                },
            };
        }
    };
    //******End controller Statistic Chart******
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 17.10.2018
 */
(function () {
    'use strict';

    //declare controller for StatementOfInvoice
    angular.module('BlurAdmin.pages.reports')
        .controller('StatementOfInvoicePageCtrl', StatementOfInvoicePageCtrl);

    //******controller for StatementOfInvoice******
    function StatementOfInvoicePageCtrl($scope, $http, $state, hostName, $filter) {

        var user = JSON.parse(localStorage.getItem("dataUser"));
        var vm = this;
        var n = 0;
        vm.rowCollection = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) {
                if (userRole[ur].Name === "Administrator" && userRole[ur].enterpriseId == null)
                    $scope.isShow = true;
            };
        }; //#CHECK ADMIN PERMISSION

        //function then call WEB API get Report's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
            console.log(response.data);
            for (n = 0; n < vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n + 1;
                vm.rowCollection[n].dateOfInvoice = convertJSONDate(vm.rowCollection[n].dateOfInvoice);
            };
        };

        //function then call WEB API get Report's data is error
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        };

        //call WEB API to get Report's data
        var queryString = "";
        var fromDate, toDate;
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();

        fromDate = new Date(nowYear, nowMonth, 1);
        toDate = new Date();
        fromDate = $filter('date')(fromDate, 'dd/MM/yyyy');
        toDate = $filter('date')(toDate, 'dd/MM/yyyy');
        queryString = "enterpriseId=" + sessionStorage.enterpriseId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&invoiceTemplateId=&billNumber=&symbol=&medicalCode=&customerName=";
        $http({
            method: "GET",
            url: hostName.url + "api/Report_SoldInvoice/GetAllReport_SoldInvoice?" + queryString
        }).then(successCallBack, errorCallBack);

        //select Status
        $scope.selectChangedStatus = function (objSelect) {
            $scope.Status = objSelect;
        };

        //select Invoice Template
        $scope.selectChangedInvoiceTemplate = function (objSelect) {
            $scope.InvoiceTemplate = objSelect;
        };

        //CHANGE ORGANIZATION
        $scope.changeOrganization = function (obj) {
            $scope.Enterprise = obj;
        };
        //#CHANGE ORGANIZATION

        //export report to EXCEL
        $scope.exportReport2Excel = function () {
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            //var statusId = $scope.Status == undefined ? 0 : $scope.Status.ID;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            //queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "POST",
                url: hostName.url + "api/Report_SoldInvoice/ExportReportSoldByExcel?" + queryString,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BangKeHoaDonBanRa.xlsx"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        };

        //export report to PDF
        $scope.exportReport2PDF = function () {
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            //var statusId = $scope.Status == undefined ? 0 : $scope.Status.ID;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            //queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "POST",
                url: hostName.url + "api/Report_SoldInvoice/ExportReportSoldByPDF?" + queryString,
                responseType: 'arraybuffer',
            }).success(function (data, status, headers) {
                headers = headers();
                //console.log(headers);
                var contentType = headers["content-type"] || "application/octet-stream";
                var blob = new Blob([data], { type: contentType });
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var url = urlCreator.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = "BangKeHoaDonBanRa.pdf"; //you may assign this value from header as well 
                a.click();
                window.URL.revokeObjectURL(url);
                //console.log(contentType);
            }).error(function (message) {
                console.log(message);
            });
        };

        //filter Report's data
        $scope.findData = function () {
            vm.rowCollection = [];
            var fromDate = angular.element(document).find('#inputFromDate')[0];
            var toDate = angular.element(document).find('#inputToDate')[0];
            //var statusId = $scope.Status == undefined ? 0 : $scope.Status.ID;
            var billNumber = angular.element(document).find('#inputBillNumber')[0];
            var invoiceTemplateId = $scope.InvoiceTemplate != undefined ? $scope.InvoiceTemplate.ID : 0;
            var symbol = angular.element(document).find('#inputSymbol')[0];
            var medicalCode = angular.element(document).find('#inputMedicalCode')[0];
            var customerName = angular.element(document).find('#inputCustomerName')[0];
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;

            queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&fromDate=" + fromDate.value + "&toDate=" + toDate.value;
            //queryString += "&statusId=" + statusId;
            queryString += "&billNumber=" + billNumber.value;
            queryString += "&invoiceTemplateId=" + invoiceTemplateId;
            queryString += "&symbol=" + symbol.value;
            queryString += "&medicalCode=" + '';//medicalCode.value;
            queryString += "&customerName=" + customerName.value;
            //call WEB API to get Report's data
            $http({
                method: "GET",
                url: hostName.url + "api/Report_SoldInvoice/GetAllReport_SoldInvoice?" + queryString,
            }).then(successCallBack, errorCallBack);
        };
        //end filter Report's data

    };
    //******End controller for StatementOfInvoice******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 21.06.2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.reports')
        .controller('TypeOfInvoiceChartPageCtrl', TypeOfInvoiceChartPageCtrl)
  
    //******controller for TypeOfInvoice Chart******
    function TypeOfInvoiceChartPageCtrl($scope, $http, layoutPaths, hostName, baConfig) {
        $scope.Years = [];
        $scope.Year = {};

        var n = 0;
        //var user = JSON.parse(localStorage.getItem("dataUser"));
        var layoutColors = baConfig.colors;
        $scope.thisYear = new Date().getFullYear();

        for (n = new Date().getFullYear(); n > ($scope.thisYear-20); n--) {
          $scope.Years.push({ID: n, name: n});
        }
        $scope.Year.selected = {ID: $scope.thisYear, name: $scope.thisYear};

        $scope.selectedYear = function(objectYear) {
            changeYear(objectYear.ID);
        }

        //call function when page init
        changeYear($scope.thisYear);

        //change Chart's data
        function changeYear(selectedYear) {
            $scope.thisYear = selectedYear;
            
            //Pie Chart Invoice & Revenue
            var chartInvoice = new AmCharts.AmPieChart();
            var chartRevenue = new AmCharts.AmPieChart();

            //Options for CHARTs
            chartRevenue.titleField = chartInvoice.titleField = "Title";
            chartRevenue.valueField = chartInvoice.valueField = "Value";
            // chartRevenue.titles = chartInvoice.titles = [
            //     {'text': 'Năm ' + thisYear},
            // ];
            chartRevenue.colors = chartInvoice.colors = [layoutColors.primary, layoutColors.success, layoutColors.warning, layoutColors.danger, layoutColors.info]; 
            chartRevenue.outlineColor = chartInvoice.outlineColor = "#FFFFFF";
            chartRevenue.outlineAlpha = chartInvoice.outlineAlpha = 0.8;
            chartRevenue.outlineThickness = chartInvoice.outlineThickness = 1;
            chartRevenue.theme = chartInvoice.theme = "blur";
            // this makes the chart 3D
            chartRevenue.depth3D = chartInvoice.depth3D = 15;
            chartRevenue.angle = chartInvoice.angle = 30;
            chartRevenue.startDuration = chartInvoice.startDuration = 0; //s deplay for start chart
            chartRevenue.alpha = chartInvoice.alpha = 0.8; //opacity
            chartRevenue.theme = chartInvoice.theme = 'blue';
            chartRevenue.addClassNames = chartInvoice.addClassNames = true;
            chartRevenue.color = chartInvoice.color = layoutColors.defaultText;
            chartRevenue.labelTickColor = chartInvoice.labelTickColor = layoutColors.borderDark;
            chartRevenue.labelsEnabled = chartInvoice.labelsEnabled = true;
            chartRevenue.innerRadius = chartInvoice.innerRadius = '40%';
            chartRevenue.legend = chartInvoice.legend = {
                enabled: false,
                position: "bottom",
                align: "center",
                markerType: "square",
                color: layoutColors.defaultText,
                valueText: "",
            };
            chartRevenue.autoMargins = chartInvoice.autoMargins = false;
            chartRevenue.marginTop = chartInvoice.marginTop = -55;
            chartRevenue.marginBottom = chartInvoice.marginBottom = -55;
            chartRevenue.marginLeft = chartInvoice.marginLeft = -55;
            chartRevenue.marginRight = chartInvoice.marginRight = -55;
            chartRevenue.pullOutRadius = chartInvoice.pullOutRadius = '20%';
            //chartRevenue.pathToImages = chartInvoice.pathToImages = layoutPaths.images.amChart;
            chartRevenue.export = chartInvoice.export = {
                enabled: true
            };
            chartRevenue.defs = chartInvoice.defs = {
                filter: [
                    {
                        id: 'shadow',
                        width: '200%',
                        height: '200%',
                        feOffset: {
                            result: 'offOut',
                            in: 'SourceAlpha',
                            dx: 0,
                            dy: 0
                        },
                        feGaussianBlur: {
                            result: 'blurOut',
                            in: 'offOut',
                            stdDeviation: 5
                        },
                        feBlend: {
                            in: 'SourceGraphic',
                            in2: 'blurOut',
                            mode: 'normal'
                        }
                    }
                ]
            };

            //RESPONSIVE
            chartRevenue.responsive = chartInvoice.responsive =  {
                "enabled": true,
                "addDefaultRules": false,
                "rules": [
                    // at 400px wide, we hide legend
                    {
                        "maxWidth": 400,
                        "overrides": {
                            "legend": {
                                "enabled": false
                            },
                        }
                    },
                
                    // at 300px or less, we move value axis labels inside plot area
                    // the legend is still hidden because the above rule is still applicable
                    {
                        "maxWidth": 300,
                        "overrides": {
                            "valueAxes": {
                                "inside": true
                            }
                        }
                    },
                
                    // at 200 px we hide value axis labels altogether
                    {
                        "maxWidth": 200,
                        "overrides": {
                            "valueAxes": {
                                "labelsEnabled": false
                            }
                        }
                    }
                ]
            }
            chartRevenue.zoomOutOnDataUpdate = chartInvoice.zoomOutOnDataUpdate = false;

            // //ADD EVENT
            // chart.addListener('init', handleInit);

            // chart.addListener('rollOverSlice', function (e) {
            //     handleRollOver(e);
            // });

            // function handleInit() {
            //     chart.legend.addListener('rollOverItem', handleRollOver);
            // }

            // function handleRollOver(e) {
            //     var wedge = e.dataItem.wedge.node;
            //     wedge.parentNode.appendChild(wedge);
            // }

            //Data for CHARTs
            //DATA 4 INVOICES
            $http.get(hostName.url + "api/Dashboard/GetPieChartYearInvoices?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                chartInvoice.dataProvider = response.data;
                 
                // WRITE CHART
                chartInvoice.write("chartdivInvoice");
            }, function(reason) {
                console.log(reason);
            });

            //DATA 4 REVENUE
            $http.get(hostName.url + "api/Dashboard/GetPieChartYearRevenue?Year=" + $scope.thisYear + "&enterpriseId=" + sessionStorage.enterpriseId).then(function(response) {
                chartRevenue.dataProvider = response.data;
                // WRITE CHART
                chartRevenue.write("chartdivRevenue");
            }, function(reason) {
                console.log(reason);
            });

            // // // WRITE
            // // chart.write("chartdiv");
            // var w = Math.random() * 300 + 100;
            // var h = Math.random() * 300 + 100;
            // document.getElementById('chartdiv').style.width = w + 'px';
            // document.getElementById('chartdiv').style.height = h + 'px';
            // chart.invalidateSize();

        } //#changeYear function()

    };
    //******End controller TypeOfInvoice Chart******

})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 03.11.2020
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.systemManagement')
      .controller('ConfigSystemCtrl', ConfigSystemCtrl);

    //******CONTROLLER******
    function ConfigSystemCtrl($scope, $http, hostName, $state) {
      
        //LOCAL VARIABLES
        $scope.PageTitle = "Mã hóa mật khẩu hệ thống";

        //+++   HIDE / SHOW PASSWORD
        $scope.inputType = 'password';
        $scope.showHideClass = 'glyphicon glyphicon-eye-open';
        $scope.showPassword = function(){
            var _password = angular.element(document).find('#inputPassword')[0];
            if(_password.value != null)
            {
                if($scope.inputType == 'password')
                {
                    $scope.inputType = 'text';
                    $scope.showHideClass = 'glyphicon glyphicon-eye-close';
                }
                else
                {
                    $scope.inputType = 'password';
                    $scope.showHideClass = 'glyphicon glyphicon-eye-open';
                }
            }
        };
        //###   END HIDE / SHOW PASSWORD

        //SAVE DATA TO DATABASE
        $scope.save = function () {

            var _password = angular.element(document).find('#inputPassword')[0];
            var flag = true;

            //check empty Password
            if (_password.value == '') {
                swal({
                    title: "Thông tin Mật khẩu",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    _password.focus();
                });
                flag = false;
                return;
            }
            
            //FUNCTION SUCCESS WHEN CALL API
            function successCallBack(data) {
                $scope.PasswordReturn = data.data;
            }; //#FUNCTION SUCCESS WHEN CALL API

            //FUNCTION ERROR WHEN CALL API
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể mã hóa được thông tin, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    $state.reload();
                });
                console.log(data);
            }; //#FUNCTION ERROR WHEN CALL API
            
            
            //CHECK DATA'S INPUT IS VALID
            if (flag == true ) {
            
                $http.post(hostName.url + "api/Enterprise/EncryptPassword4System?Password=" + _password.value)
                .then(successCallBack, errorCallBack);
            
            }; //#CHECK DATA'S INPUT IS VALID

        }; //#SAVE DATA TO DATABASE


        //REDIRECT TO OTHER PAGES
        $scope.open = function(url) {
            location.href = url;
        };

    }
    //######CONTROLLER UPDATE DOCUMENT######
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 19.09.2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.pages.systemManagement')
      .controller('ManageLicensePageCtrl', ManageLicensePageCtrl);

    //******CONTROLLER MANAGE LICENSE******
    function ManageLicensePageCtrl($scope, $http, hostName, $filter) {
      
        //LOCAL VARIABLES
        $scope.PageTitle = "Cấp mới bản quyền cho đơn vị";
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //SAVE DATA TO DATABASE
        $scope.save = function () {

            var license = angular.element(document).find('#inputLicense')[0];
            var flag = true;

            //check empty license
            if (license.value == '') {
                swal({
                    title: "Thông tin Số license",
                    text: "không được để trống!",
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    license.focus();
                });
                flag = false;
                return;
            }
            
            //FUNCTION SUCCESS WHEN CALL API
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/organization";
                });
            }; //#FUNCTION SUCCESS WHEN CALL API

            //FUNCTION ERROR WHEN CALL API
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/organization";
                });
                console.log(data);
            }; //#FUNCTION ERROR WHEN CALL API
            
            
            //CHECK DATA'S INPUT IS VALID
            if (flag == true && sessionStorage.itemId != 'undefined') {
            
                var itemId = sessionStorage.itemId.toString();
                
                var queryString = "enterpriseCode=" + itemId + "&NoDown=" + $filter('replace')(license.value, ',', '');
                
                //CALL API TO UPDATE'S DATA
                $http.post(hostName.url + "api/Enterprise/CreateLicense4Enterprise?" + queryString)
                .then(successCallBack, errorCallBack);
            
            }; //#CHECK DATA'S INPUT IS VALID

        }; //#SAVE DATA TO DATABASE


        //REDIRECT TO OTHER PAGES
        $scope.open = function(url) {
            location.href = url;
        };

    }
    //######CONTROLLER UPDATE DOCUMENT######
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 11.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Organization
    angular.module('BlurAdmin.pages.systemManagement')
      .controller('OrganizationPageCtrl', OrganizationPageCtrl);

    angular.module('BlurAdmin.pages.systemManagement')
      .controller('SelectEnterprisePageCtrl', SelectEnterprisePageCtrl);

    /******************************************/
    /*******controller for Organization List*******/
    /******************************************/
    function OrganizationPageCtrl($scope, $http, $state, hostName) {

        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //function then call Webservice get Organization's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
            //console.log(response);

            for (n=0; n<vm.rowCollection.length; n++) {
                vm.rowCollection[n].No = n+1;
                vm.rowCollection[n].dateCreated = convertJSONDate(vm.rowCollection[n].dateCreated);
            }

            //console.log(response);
        };

        //function then call Webservice get Organization's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;

            //display message into Console
            console.log(reason);
        }

        //call Webservice to get Organization's data
        $http({
            method: "GET",
            url: hostName.url + "api/Enterprise/GetAllEnterprise"
        }).then(successCallBack, errorCallBack);

        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };

        //save data to local variable when change Select's control
        $scope.selectChanged = function(objSelect) {
            $scope.City = objSelect;
        };
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        //filter Organization's data
        $scope.findData = function() {
            vm.rowCollection = [];
            // var fromDate = angular.element(document).find('#inputFromDate')[0];
            // var toDate = angular.element(document).find('#inputToDate')[0];
            var enterpriseName = angular.element(document).find('#inputEnterpriseName')[0];
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var cityId = $scope.City == undefined ? "":$scope.City.cityId;
            var isActive = "";
            var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
            var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
            if (isActiveAll.checked == true) {
              isActive = "";
            }
            else if (isActiveTrue.checked == true) {
              isActive = true;
            }
            else {
              isActive = false;
            }
            var queryString = "";
            queryString = "businessName=" + enterpriseName.value + "&taxCode=" + taxCode.value 
                        + "&contactPerson=" + contactPerson.value + "&phone=" + phone.value
                        + "&cityId=" + cityId + "&isActive=" + isActive;

            // if (fromDate != undefined) {
            //     var dateFrom = fromDate.value;//reConvertJSONDate(fromDate.value);
            //     var dateTo = toDate.value;//reConvertJSONDate(toDate.value);

                
            // }
            // else {
            //     var date = new Date();
            //     var nowYear = date.getFullYear();
            //     var nowMonth = date.getMonth();
            //     queryString = "fromDate=" + new Date(nowYear,nowMonth,1); + "&toDate=" + new Date(); + "&businessName=&taxCode=&cityId=&isActive=";
            // }
            
            //call Webservice to get Organization's data
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/SearchEnterprise?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter Organization's data

        //update Status of Organization
        $scope.updateStatus = function(flag, itemId) {
            if (flag == true) {
                //Stop
                swal({
                    title: "Bạn muốn kích hoạt thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': true,
                            'userUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/Enterprise/UpdateEnterpriseStatus", inputData).then(function(data){
                            swal("Kích hoạt thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            }
            else {
                //Active
                swal({
                    title: "Bạn muốn ngừng sử dụng thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete) {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': false,
                            'userUpdated': user.ID
                        };
                        $http.post(hostName.url + "api/Enterprise/UpdateEnterpriseStatus", inputData).then(function(data){
                            swal("Ngừng sử dụng thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            }
        }
      
    };
    /******End controller for Organization List******/

    //******controller for Select Enterprise******
    function SelectEnterprisePageCtrl($scope, $http, hostName) {
        $scope.Enterprises = [];
  
        var successCallBack = function (response) {
          $scope.Enterprises = response.data;
        };
  
        var errorCallBack = function (reason) {
          $scope.error = reason.data;
          
          console.log(reason);
        }
  
        $http({
          method: "GET",
          url: hostName.url + "api/Enterprise/ListEnterprise"
        }).then(successCallBack, errorCallBack);
      }
      //******End controller for Select Role******

    //Commmon function to convert JSON Date to Normal Date
    function convertJSONDate(strDate) {
        //var dateString = strDate.substr(6);
        var currentTime = new Date(strDate);
        var month = ("0" + (currentTime.getMonth() + 1)).slice(-2);
        var day = ("0" + currentTime.getDate()).slice(-2);
        var year = currentTime.getFullYear();
        var date = day + '/' + month + '/' + year;
        return date;
    }
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 11.10.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.systemManagement')
        .controller('UpdateOrganizationPageCtrl', UpdateOrganizationPageCtrl);

    /** @ngInject */
    function UpdateOrganizationPageCtrl($scope, fileReader, $filter, $http, layoutPaths, $rootScope, hostName) {

        //Set data for Page Title
        $scope.TaxAuthority = {};
        $scope.ChildTaxAuthority = {};
        $scope.IsDisabled = false;
        var user = JSON.parse(localStorage.getItem("dataUser"));

        //load business's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            var itemId = sessionStorage.itemId.toString();

            //Update Page Title
            $scope.PageTitle = "Cập nhật thông tin đơn vị";

            //call Webservice to get Enterprise's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/Enterprise/GetEnterprise?ID=" + itemId,
            })
                .then(function (response) {
                    //$scope.Enterprise = [];
                    $scope.Enterprise = response.data;
                    //console.log($scope.Enterprise);
                    if ($scope.Enterprise != undefined) {
                        //put Enterprise's data into Form's controls
                        $scope.inputTaxCode = $scope.Enterprise.taxCode;
                        $scope.ChildTaxAuthority.selected = { ID: $scope.Enterprise.taxAuthorityId, taxAuthorityName: $scope.Enterprise.taxAuthorityName };
                        //sessionStorage.taxAuthorityId = $scope.Enterprise.taxAuthorityId;
                        $scope.inputBusinessNameVN = $scope.Enterprise.enterpriseNameVN;
                        $scope.inputBusinessNameEN = $scope.Enterprise.enterpriseNameEN;
                        $scope.inputPhone = $scope.Enterprise.phone;
                        $scope.inputFax = $scope.Enterprise.fax;
                        $scope.inputAddressVN = $scope.Enterprise.addressVN;
                        $scope.inputAddressEN = $scope.Enterprise.addressEN;
                        $scope.inputEmail = $scope.Enterprise.email;
                        $scope.inputContactPerson = $scope.Enterprise.contactPerson;
                        $scope.inputOwner = $scope.Enterprise.owner;
                        $scope.inputBankAccount = $scope.Enterprise.bankAccount;
                        //$scope.inputAccountName = $scope.Enterprise.accountHolder;
                        $scope.inputBankName = $scope.Enterprise.bankName;
                        $scope.checkStatus = $scope.Enterprise.isLogo == true ? 'Y' : 'N';
                        //sessionStorage.logo = $scope.Enterprise.logoFileName;
                        $rootScope.logo = $scope.Enterprise.logoFileName;
                        $scope.picture = $filter('logoPicture')($rootScope.logo);
                        //console.log($scope.picture);

                        //get list Child of TaxAuthorities
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            $scope.ChildTaxAuthorities = response.data;
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });

                        //get Child of TaxAuthorites selected
                        $http({
                            method: "GET",
                            url: hostName.url + "api/TaxAuthority/GetTaxAuthorityByTaxID?taxAuthorityCode=" + $scope.Enterprise.taxParentID,
                        }).then(function (response) {
                            var taxParent = response.data;
                            $scope.TaxAuthority.selected = { ID: taxParent.ID, taxAuthorityName: taxParent.taxAuthorityName, taxAuthorityCode: taxParent.taxAuthorityCode };
                        }, function (reason) {
                            $scope.error = reason.data;
                            console.log(reason);
                        });
                    }
                }, function (reason) {
                    $scope.error = reason.data;
                    console.log(reason);
                });
        }
        else {
            $scope.picture = $filter('logoPicture')("noimage.png");
        }

        //redirect to other pages
        $scope.open = function (url) {
            location.href = url;
        };

        /** Manage upload Picture **/
        //$scope.picture = $filter('logoPicture')($rootScope.logo);
        //console.log($scope.picture);
        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function ($scope) {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    var fileName = $scope.file.name;
                    //check only Image can use logo
                    if (fileName.indexOf(".jpg") <= 0 && fileName.indexOf(".png") <= 0
                        && fileName.indexOf(".gif") <= 0) {
                        swal({
                            title: "Vui lòng chọn đúng file định dạng hình ảnh (.jpg, .png, .gif)!",
                            icon: "warning",
                            button: "Đóng"
                        }).then(function () {
                            return;
                        });
                    }
                    else {
                        $scope.picture = result;

                        var min = 10000;
                        var max = 100000;
                        var random = Math.floor(Math.random() * (+max - +min)) + +min;
                        var fileName = random + "_" + $scope.file.name;

                        var data = new FormData();
                        data.append("filename", fileName);
                        data.append("storagePath", layoutPaths.images.logo);
                        data.append("file", $scope.file);
                        //console.log(data);
                        //console.log($scope.file);

                        // var ext = fileName.substr(fileName.indexOf(".") + 1, 3);
                        // fileName = fileName.substr(0, fileName.indexOf("."));

                        $rootScope.logo = fileName;
                        $rootScope.FileTemplateData = data;
                    }
                });
        };
        /** End Manage upload Picture **/

        //change taxAuthority
        $scope.selectChanged = function (taxAuthority) {
            $scope.TaxAuthority.selected = taxAuthority;
            $scope.ChildTaxAuthority.selected = undefined;

            //get list Child of TaxAuthorities
            $http({
                method: "GET",
                url: hostName.url + "api/TaxAuthority/GetAllTaxAuthorityByParentID?parentID=" + taxAuthority.taxAuthorityCode,
            }).then(function (response) {
                $scope.ChildTaxAuthorities = response.data;
            }, function (reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        }

        $scope.selectChangedChild = function (taxAuthority) {
            $scope.ChildTaxAuthority.selected = taxAuthority;
        }

        /** Check data and call api to save data to database **/
        $scope.save = function () {

            //get form's controls
            var taxCode = angular.element(document).find('#inputTaxCode')[0];
            var enterpriseNameVN = angular.element(document).find('#inputBusinessNameVN')[0];
            var enterpriseNameEN = angular.element(document).find('#inputBusinessNameEN')[0];
            var phone = angular.element(document).find('#inputPhone')[0];
            var fax = angular.element(document).find('#inputFax')[0];
            var addressVN = angular.element(document).find('#inputAddressVN')[0];
            var addressEN = angular.element(document).find('#inputAddressEN')[0];
            var email = angular.element(document).find('#inputEmail')[0];
            var contactPerson = angular.element(document).find('#inputContactPerson')[0];
            var owner = angular.element(document).find('#inputOwner')[0];
            var bankAccount = angular.element(document).find('#inputBankAccount')[0];
            //var accountHolder = '';//angular.element(document).find('#inputAccountName')[0];
            var bankName = angular.element(document).find('#inputBankName')[0];
            var isLogo = angular.element(document).find('#inputIsActiveLogo')[0];
            var logoFileName = $rootScope.logo//sessionStorage.logo;
            var isActive = angular.element(document).find('#inputIsActive')[0];
            var taxAuthorityId = $scope.ChildTaxAuthority.selected != undefined ? $scope.ChildTaxAuthority.selected.ID : 0;
            var flag = true;
            /*  */

            // console.log(taxCode.value);
            // console.log(email.value);
            // send_mail();
            // return;
            // function send_mail() {
            //     $http({
            //         method: "POST",
            //         url: hostName.url + "api/QD1450/SendEmail_1450_CreateOrganization?TaxCode=" + taxCode.value + "&EmailAddress="
            //             + email.value
            //         // responseType: 'blob',    
            //     }).success(function (data) {
            //         console.log(data);
            //         $scope.OpenFile = false;
            //     }).error(function (a) {
            //         console.log(a);
            //     })
            // }

            //check empty taxCode
            if (taxCode.value == '') {
                swal({
                    title: "Thông tin Mã số thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    taxCode.focus();
                });
                flag = false;
                return;
            }

            //check empty taxAuthority
            if (taxAuthorityId == 0) {
                swal({
                    title: "Thông tin Cơ quan Thuế",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty enterpriseName
            if (enterpriseNameVN.value == '') {
                swal({
                    title: "Thông tin Tên đơn vị",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    enterpriseNameVN.focus();
                });
                flag = false;
                return;
            }

            //check empty address
            if (addressVN.value == '') {
                swal({
                    title: "Thông tin Địa chỉ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    addressVN.focus();
                });
                flag = false;
                return;
            }

            //check empty email
            if (email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    email.focus();
                });
                flag = false;
                return;
            }

            //check empty contactPerson
            if (contactPerson.value == '') {
                swal({
                    title: "Thông tin Người liên hệ",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    contactPerson.focus();
                });
                flag = false;
                return;
            }

            //check empty owner
            if (owner.value == '') {
                swal({
                    title: "Thông tin Người đại diện",
                    text: 'không được để trống!',
                    icon: "warning",
                    button: "Đóng"
                }).then(function () {
                    owner.focus();
                });
                flag = false;
                return;
            }

            //declare function to alert when success or error
            //success function
            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function () {
                    location.href = "#/organization";
                });
            }
            //error function
            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode: true,
                    button: "Đóng",
                }).then(function () {
                    location.href = "#/organization";
                });
                console.log(data);
            }

            //if not empty with data which must to have
            if (flag == true) {
                $scope.IsDisabled = true;

                //upload Logo to Server
                var data = new FormData();
                data = $rootScope.FileTemplateData;
                var reg = {
                    url: hostName.url + 'api/Enterprise/UploadFileToDocmentLibrary',
                    method: 'POST',
                    data: data,
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    },
                };

                //check if user change Logo
                if (data != undefined) {
                    $http(reg).then(function (response) {

                    }, function (reason) {
                        swal({
                            title: "Thông báo",
                            text: "Không thể upload được Logo, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode: true,
                            button: "Đóng",
                        }).then(function () {
                            console.log(reason.data);
                        });
                    });
                }

                //update enterprise
                if (sessionStorage.itemId != 'undefined') {
                    var enterpriseData = {
                        'ID': sessionStorage.itemId,
                        'taxCode': taxCode.value,
                        'taxAuthorityId': taxAuthorityId,
                        'enterpriseNameVN': enterpriseNameVN.value,
                        'enterpriseNameEN': enterpriseNameEN.value,
                        'phone': phone.value,
                        'fax': fax.value,
                        'addressVN': addressVN.value,
                        'addressEN': addressEN.value,
                        'email': email.value,
                        'contactPerson': contactPerson.value,
                        'owner': owner.value,
                        'bankAccount': bankAccount.value,
                        'accountHolder': '',//accountHolder.value,
                        'bankName': bankName.value,
                        'isLogo': isLogo.checked,
                        'logoFileName': logoFileName,
                        'description': '',
                        'isActive': true,
                        'userUpdated': user.ID
                    };
                    $http.post(hostName.url + "api/Enterprise/UpdateEnterprise", enterpriseData)
                        .then(successCallBack, errorCallBack);
                }
                //add new enterprise
                else {
                    var enterpriseData = {
                        'taxCode': taxCode.value,
                        'taxAuthorityId': taxAuthorityId,
                        'enterpriseNameVN': enterpriseNameVN.value,
                        'enterpriseNameEN': enterpriseNameEN.value,
                        'phone': phone.value,
                        'fax': fax.value,
                        'addressVN': addressVN.value,
                        'addressEN': addressEN.value,
                        'email': email.value,
                        'contactPerson': contactPerson.value,
                        'owner': owner.value,
                        'bankAccount': bankAccount.value,
                        'accountHolder': '',//accountHolder.value,
                        'bankName': bankName.value,
                        'isLogo': isLogo.checked,
                        'logoFileName': logoFileName,
                        'description': '',
                        'isActive': true,
                        'userCreated': user.ID
                    };
                    $http.post(hostName.url + "api/Enterprise/AddEnterprise", enterpriseData)
                        .success(function (data) {
                            send_mail();
                            successCallBack();
                        }).error(function (data) {
                            errorCallBack();
                        })

                    // .then(successCallBack, errorCallBack);
                    /* THÊM SEND EMAIL KHI TẠO MỚI TT-KH THÀNH CÔNG */
                    function send_mail() {
                        $http({
                            method: "POST",
                            url: hostName.url + "api/QD1450/SendEmail_1450_CreateOrganization?TaxCode=" + enterpriseData.taxCode + "&EmailAddress="
                                + enterpriseData.email + "&Enterprise=" + enterpriseData.enterpriseNameVN
                            // responseType: 'blob',    
                        }).success(function (data) {
                            console.log("Gửi email thành công " + enterpriseData.email);
                        }).error(function (a) {
                            console.log("Gửi email thất bại " + enterpriseData.email);
                        })
                    }
                }
            }

        }/** End Check data and call api to save data to database **/

    } //end function controller

})(); //end function all

/**
 * @author Nguyen Huu Tuan
 * created on 10.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Manage Role
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('ManageRolePageCtrl', ManageRolePageCtrl);
  
    //******controller for Manage Role******
    function ManageRolePageCtrl($scope, $http, hostName) {

        //get data from Roles
        $scope.Roles = [];
        $scope.Role = {};
        $scope.displayedCollection = [];
        var vm = this;
        vm.RoleDelete = [];
        var n = 0;
        var enterpriseId = sessionStorage.enterpriseId;
        
        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        //Get Role information
        if (sessionStorage.itemId != undefined) {
            $http({
                method: "GET",
                url: hostName.url + "api/User/GetUser/" + sessionStorage.itemId,
            }).then(function(response){
                enterpriseId = response.data.enterpriseId;

                var successCallBackRole = function (response) {
                    $scope.Roles = response.data;
        
                    var successCallBackUserRole = function (response) {
                        var listRoles = response.data;
        
                        for (var u = 0; u < $scope.Roles.length; u++) {
                            for (var l = 0; l < listRoles.length; l++) {
                                if (listRoles[l].RoleID == $scope.Roles[u].ID) {
                                    if ($scope.displayedCollection.indexOf($scope.Roles[u]) < 0) {
                                        $scope.displayedCollection.push($scope.Roles[u]);
                                        $scope.Roles.splice(u, 1);
                                    }
                                }
                            }
                        }
                    }; //#successCallBackUserRole
                    var errorCallBackUserRole = function (reason) {
                        console.log(reason);
                    } //#errorCallBackUserRole
        
                    $http({
                        method: "GET",
                        url: hostName.url + "api/UserRole/GetUserRoleByUserId?userId=" + sessionStorage.itemId
                    }).then(successCallBackUserRole, errorCallBackUserRole);
        
                }; //#successCallBackRole
                var errorCallBackRole = function (reason) {
                    console.log(reason);
                } //#errorCallBackRole
        
                $http({
                    method: "GET",
                    url: hostName.url + "api/Role/ListsRole?enterpriseId=" + enterpriseId
                }).then(successCallBackRole, errorCallBackRole);
            }, function(error){
                console.log(error);
            });
        }

        //choose Role and add to list
        $scope.selectChanged = function(Role) {
            var index = $scope.Roles.indexOf(Role);
            for (n=0; n<$scope.Roles.length; n++) {
                if (Role.ID == $scope.Roles[n].ID) {
                    $scope.Roles.splice(index,1);
                    $scope.Role.selected = undefined;
                    $scope.displayedCollection.push(Role);
                }
            }
        }

        //Remove Role from list
        $scope.removeRole = function(Role) {
            var index = $scope.displayedCollection.indexOf(Role);
            for (n=0; n<$scope.displayedCollection.length; n++) {
                if (Role.ID == $scope.displayedCollection[n].ID) {
                    $scope.displayedCollection.splice(index,1);
                    $scope.Roles.push(Role);
                    vm.RoleDelete.push(Role.ID);
                }
            }
        }

        //function to save data to database
        $scope.save = function() {
            
            //check if empty Role
            if ($scope.displayedCollection.length == 0) {
                swal({
                    title: "Chưa có nhóm người dùng được chọn, bạn muốn bỏ qua việc phân quyền?",
                    icon: "warning",
                    buttons: ["Hủy bỏ", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        location.href = "#/users";
                    } else {
                        $scope.$broadcast('SetFocus');
                    }
                });
            } //#check if empty Role

            //check if delete data
            if (vm.RoleDelete.length > 0) {
                for (n=0; n<vm.RoleDelete.length; n++) {
                    var inputData = {
                        'UserID': sessionStorage.itemId, 
                        'RoleID': vm.RoleDelete[n],
                        'enterpriseId': enterpriseId//sessionStorage.enterpriseId
                    };
                    $http.post(hostName.url + "api/UserRole/DeleteUserRole", inputData)
                        .then(function(data) {
                            //No Action
                        }, function(error){
                        console.log(error);
                    });
                    vm.RoleDelete.splice(n,1);
                }
            } //#check if delete data

            //check to add new data
            for (n=0; n<$scope.displayedCollection.length; n++) {
                var RoleID = $scope.displayedCollection[n].ID;
                var inputData = {
                    'UserID': sessionStorage.itemId, 
                    'RoleID': RoleID,
                    'enterpriseId': enterpriseId//sessionStorage.enterpriseId
                };

                $http.post(hostName.url + "api/UserRole/AddUserRole", inputData)
                    .then(function(data) {
                        if (n == $scope.displayedCollection.length) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/users";
                            });
                        }
                    }, function(error){
                        console.log(error);
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/users";
                        });
                    });
            } //#check to add new data

        } //end function to save data to database
  
    };
    //******End controller for Manage Role******
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 09.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Role
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('RolePageCtrl', RolePageCtrl);

    angular.module('BlurAdmin.pages.systemManagement')
        .controller('SelectRolePageCtrl', SelectRolePageCtrl);
  
    //******controller for Role******
    function RolePageCtrl($scope, $http, $state, hostName) {
  
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" )
                    $scope.isShow = true;
            };
        }
    
        //function then call Webservice get Role's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
    
            for (n=0; n < vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
            }
    
            //display message into Console
            //console.log(response);
        };
    
        //function then call Webservice get Role's data is error
        function errorCallBack(reason) {
            //display message into Console
            console.log(reason);
        }
    
        //call Webservice to get Role's data
        $http({
            method: "GET",
            url: hostName.url + "api/Role/GetAllRole?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    
        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;
        }
    
        //filter Role's data
        $scope.findData = function() {
            //clear data
            vm.rowCollection = [];

            var roleName = angular.element(document).find('#inputRoleName')[0];
            var isActive = "";//= angular.element(document).find('#inputIsActive')[0];
            var isActiveAll = angular.element(document).find('#radioIsActiveAll')[0];
            var isActiveTrue = angular.element(document).find('#radioIsActiveTrue')[0];
            //var isActiveFalse = angular.element(document).find('#radioIsActiveFalse')[0];
            if (isActiveAll.checked == true) {
                isActive = "";
            }
            else if (isActiveTrue.checked == true) {
                isActive = true;
            }
            else {
                isActive = false;
            }

            var enterpriseId = $scope.Enterprise == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.ID;
            
            var queryString = "";
            queryString = "enterpriseId=" + enterpriseId + "&Name=" + roleName.value + "&isActive=" + isActive;
            
            //call Webservice to get Role's data
            $http({
                method: "GET",
                url: hostName.url + "api/Role/SearchRole?" + queryString,
            }).then(successCallBack, errorCallBack);
        }
        //end filter Role's data
    
        //update Status of Role
        $scope.updateStatus = function(flag, itemId) {
            if (flag == true) {
                //Stop
                swal({
                    title: "Bạn muốn kích hoạt thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': true
                        };
                        $http.post(hostName.url + "api/Role/UpdateRoleStatus", inputData).then(function(data){
                            swal("Kích hoạt thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            } //#Stop
            else {
                //Active
                swal({
                    title: "Bạn muốn ngừng sử dụng thông tin này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'isActive': false
                        };
                        $http.post(hostName.url + "api/Role/UpdateRoleStatus", inputData).then(function(data){
                            swal("Ngừng sử dụng thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            } //#Active
        }
  
    };
    //******End controller for Role******

    //******controller for Select Role******
    function SelectRolePageCtrl($scope, $http, hostName) {
        $scope.Roles = [];

        var successCallBack = function (response) {
            $scope.Roles = response.data;
        };

        var errorCallBack = function (reason) {
            $scope.error = reason.data;
            
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/Role/GetAllRole?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select Role******
  
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 09.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Update Role
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('UpdateRolePageCtrl', UpdateRolePageCtrl);

    /******************************************/
    /******controller for Update Role******/
    /******************************************/
    function UpdateRolePageCtrl($scope, $http, hostName) {

        //Set data for Page Title
        $scope.PageTitle = "Tạo mới thông tin nhóm người dùng";
        $scope.checkStatus = 'Y';
        $scope.Enterprise = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" )
                    $scope.isShow = true;
            };
        }

        //load Role's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            // Decrypt
            //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
            //var itemId = bytes.toString(CryptoJS.enc.Utf8);
            var itemId = sessionStorage.itemId.toString();
            
            //Update Page Title
            $scope.PageTitle = "Cập nhật thông tin nhóm người dùng";

            //call Webservice to get Role's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/Role/GetRole/" + itemId,
            }).then(function(response) {
                $scope.Role = [];
                $scope.Role = response.data;
                //console.log($scope.Role);
                
                if ($scope.Role != undefined) {
                    //GET Enterprise's Information
                    $http({
                        method: "GET",
                        url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.Role.enterpriseId,
                    }).then(function(response) {
                        var obj = response.data;
                        $scope.Enterprise.selected = {ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN};
                    }, function(reason) {
                        $scope.error = reason.data;
                        console.log(reason);
                    });

                    //put Role's data into Form's controls
                    $scope.inputRoleName = $scope.Role.Name;
                    $scope.checkStatus = $scope.Role.isActive == true?'Y':'N';
                }
            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        }

        $scope.changeOrganization = function(obj) {
            $scope.Enterprise.selected = obj;
        }

        //save Role's data into Database via Webservice
        $scope.save = function () {

            var roleName = angular.element(document).find('#inputRoleName')[0];
            var isActive = angular.element(document).find('#inputIsActive')[0];
            var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
            var flag = true;

            //check empty Enterprise
            if ($scope.isShow && $scope.Enterprise.selected == undefined) {
                swal({
                    title: "Thông tin Đơn vị",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocus');
                });
                flag = false;
                return;
            }

            //check empty roleName
            if (roleName.value == '') {
                swal({
                    title: "Thông tin Tên nhóm người dùng",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    roleName.focus();
                });
                flag = false;
                return;
            }

            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/roles";
                });
                //console.log(data);
            }

            function errorCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/roles";
                });
                console.log(data);
            }
            
            //check if data's input is not empty
            if (flag == true) {

            //update Role's data
            if (sessionStorage.itemId != 'undefined') {
                //debugger;
                var inputData = {
                    'ID': sessionStorage.itemId,
                    'Name': roleName.value, 
                    'isActive': isActive.checked,
                    'enterpriseId': enterpriseId //sessionStorage.enterpriseId
                };
                $http.post(hostName.url + "api/Role/UpdateRole", inputData)
                    .then(successCallBack, errorCallBack);
            }
            //Add new Role's data
            else {
                var inputData = {
                    'Name': roleName.value, 
                    'isActive': isActive.checked,
                    'enterpriseId': enterpriseId //sessionStorage.enterpriseId
                };
                //debugger;
                $http.post(hostName.url + "api/Role/AddRole", inputData)
                    .then(successCallBack, errorCallBack);
            }
            }

        };
        //end function save Role's data into Database via Webservice

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };
    }
    /******End controller for Update Role******/
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 11.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Grant Permission
    angular.module('BlurAdmin.pages.systemManagement')
      .controller('GrantPermissionPageCtrl', GrantPermissionPageCtrl);
  
    //******controller for Grant Permission******
    function GrantPermissionPageCtrl($scope, $http, $state, $filter, hostName) {
  
        //initialize page
        var n=0;
        $scope.Enterprise = {};
        $scope.GrantPermission = [];

        //get Role list
        $scope.Roles = [];

        //get Menu list
        $scope.Menus = [];
        $scope.MenuTemp = $state.get()
            .filter(function(s) {
                return s.sidebarMeta;
            })
            .map(function(s) {
                var meta = s.sidebarMeta;
                //alert("baSideBar" + s.title + s.role);
                return {
                    name: s.name,
                    title: s.title,
                    level: ((s.name.match(/\./g) || []).length - 1),
                    order: meta.order,
                    icon: meta.icon,
                    stateRef: s.name,
                };
            })
            .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
            });

        for (n=0; n<$scope.MenuTemp.length; n++) {
            if ( ($scope.MenuTemp[n].level == 1 && $scope.MenuTemp[n].name.indexOf('.form.') < 0 
                && $scope.MenuTemp[n].name.indexOf('.tables.') < 0
                && $scope.MenuTemp[n].name.indexOf('.charts.') < 0
                && $scope.MenuTemp[n].name.indexOf('.organization') < 0
                && $scope.MenuTemp[n].name.indexOf('.grantPermission') < 0 ) 
                || $scope.MenuTemp[n].name.indexOf('.reports') > 0 
                || $scope.MenuTemp[n].name.indexOf('.lists') > 0 
                //|| $scope.MenuTemp[n].name.indexOf('.dashboard') > 0 
                ) {
                    $scope.Menus.push($scope.MenuTemp[n]);
                }
        }

        $scope.Menus = $filter('orderBy')($scope.Menus, 'order', false) 
        //console.log($scope.MenuTemp);
        //console.log($scope.Menus);

        $scope.changeOrganization = function(obj) {
            selectChanged(obj);
        }

        selectChanged({ID: sessionStorage.enterpriseId, Name: sessionStorage.enterpriseId});
        function selectChanged(obj) {
        //$scope.selectChanged = function(obj) {
            $scope.Enterprise.selected = obj;
            //console.log($scope.Enterprise.selected);

            var successCallBackRole = function (response) {
                $scope.Roles = response.data;

                //add roles to menu to check permission
                var k=0;
                for (n=0; n<$scope.Menus.length; n++) {
                    $scope.Menus[n].Roles = [];
                    for (k=0; k<$scope.Roles.length; k++) {
                        $scope.Roles[k].No = k;
                        var newRole = {'ID': $scope.Roles[k].ID, 'isHas': false};
                        $scope.Menus[n].Roles.push(newRole);
                    }
                    if ($scope.Roles.length == 0) {
                        $scope.Menus[n].Roles = undefined;
                    }
                }
                //console.log($scope.Menus);
                //console.log($scope.Roles);

                //get data permission to check the checkbox
                var successCallBack = function (response) {
                    $scope.GrantPermission = response.data;
                    //console.log($scope.Menus);
                    var j=0;
        
                    for (n=0; n<$scope.Menus.length; n++) {
                        for (k=0; k<$scope.GrantPermission.length; k++) {
                            for (j=0; j<$scope.Menus[n].Roles.length; j++) {
                                if ($scope.GrantPermission[k].menuId == $scope.Menus[n].name
                                && $scope.GrantPermission[k].roleId == $scope.Menus[n].Roles[j].ID) {
                                    $scope.Menus[n].Roles[j].isHas = $scope.GrantPermission[k].isHas;
                                }
                            }
                        }
                    }
                    //console.log($scope.Menus);
                };
                var errorCallBack = function (reason) {
                    console.log(reason);
                }
                $http({
                    method: "GET",
                    url: hostName.url + "api/GrantPermission/GetGrantPermission?enterpriseId=" + $scope.Enterprise.selected.ID
                }).then(successCallBack, errorCallBack);
            };
            var errorCallBackRole = function (reason) {
                console.log(reason);
            }
            $http({
                method: "GET",
                url: hostName.url + "api/Role/ListsRole?enterpriseId=" + $scope.Enterprise.selected.ID
            }).then(successCallBackRole, errorCallBackRole);

        } //#fuction selectChanged

        //call function when check permission
        //function checkPermission(menuId, roleId, flagCheck) {
        $scope.checkPermission = function(menuId, roleId, flagCheck) {
            var objPermission = {
                'enterpriseId': $scope.Enterprise.selected.ID,
                'menuId': menuId,
                'roleId': roleId,
                'isHas': flagCheck
            }

            for (n=0; n<$scope.GrantPermission.length; n++) {
                if ($scope.GrantPermission[n].enterpriseId == objPermission.enterpriseId
                    && $scope.GrantPermission[n].menuId == objPermission.menuId
                    && $scope.GrantPermission[n].roleId == objPermission.roleId
                ) {
                    $scope.GrantPermission.splice(n,1);
                }
            }

            $scope.GrantPermission.push(objPermission);
            //console.log($scope.GrantPermission);
        };

        //save data to database
        $scope.save = function() {
            //update data of StateMenu
            for (n=0; n<$scope.Menus.length; n++) {
                if ($scope.Menus[n].icon == undefined) {
                    $scope.Menus[n].icon = "";
                }

                var inputData = {
                    'name': $scope.Menus[n].name, 
                    'title': $scope.Menus[n].title,
                    'level': $scope.Menus[n].level,
                    'order': $scope.Menus[n].order,
                    'icon': $scope.Menus[n].icon,
                    'stateRef': $scope.Menus[n].stateRef
                };
        
                $http.post(hostName.url + "api/StateMenu/AddStateMenu", inputData)
                .then(function(data) {
                    if (n == $scope.Menus.length) { //when finish update data of StateMenu
                        //Update data of GrantPermission
                        for (n=0; n<$scope.GrantPermission.length; n++) {
                            var inputData = {
                                'enterpriseId': $scope.GrantPermission[n].enterpriseId, 
                                'menuId': $scope.GrantPermission[n].menuId,
                                'roleId': $scope.GrantPermission[n].roleId,
                                'isHas': $scope.GrantPermission[n].isHas
                            };
                    
                            $http.post(hostName.url + "api/GrantPermission/AddGrantPermission", inputData)
                            .then(function(data) {
                                if (n == $scope.GrantPermission.length) {
                                    swal({
                                        title: "Thông báo",
                                        text: "Lưu dữ liệu thành công!",
                                        icon: "success",
                                        button: "Đóng",
                                    }).then(function(){
                                        $state.reload();
                                    });
                                }
                            }, function(error){
                                console.log(error);
                                swal({
                                    title: "Thông báo",
                                    text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                                    icon: "error",
                                    dangerMode:true,
                                    button: "Đóng",
                                }).then(function(){
                                    $state.reload();
                                });
                            });
                        } //end Update data of GrantPermission
                    }
                }, function(error){
                    console.log(error);
                    swal({
                        title: "Thông báo",
                        text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                        icon: "error",
                        dangerMode:true,
                        button: "Đóng",
                    }).then(function(){
                        $state.reload();
                    });
                });

            } // end update data of StateMenu

        }
  
    }; //******End controller for Grant Permission******
    
  })();
  
/**
 * @author Nguyen Huu Tuan
 * created on 10.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Manage User
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('ManageUserPageCtrl', ManageUserPageCtrl);
  
    //******controller for Manage User******
    function ManageUserPageCtrl($scope, $http, hostName) {
      
        //get data from Users
        $scope.Users = [];
        $scope.User = {};
        $scope.displayedCollection = [];
        var vm = this;
        vm.UserDelete = [];
        var n = 0;
        var enterpriseId = sessionStorage.enterpriseId;

        //Get User information
        if (sessionStorage.itemId != undefined) {
            $http({
                method: "GET",
                url: hostName.url + "api/Role/GetRole/" + sessionStorage.itemId,
            }).then(function(response){
                enterpriseId = response.data.enterpriseId;
                
                var successCallBackUser = function (response) {
                    $scope.Users = response.data;
        
                    //GET LIST USER BY ROLE ID
                    var successCallBackRole = function (response) {
                        var listUsers = response.data;
        
                        for (var u = 0; u < $scope.Users.length; u++) {
                            for (var l = 0; l < listUsers.length; l++) {
                                if (listUsers[l].UserID == $scope.Users[u].ID) {
                                    if ($scope.displayedCollection.indexOf($scope.Users[u]) < 0) {
                                        $scope.displayedCollection.push($scope.Users[u]);
                                        $scope.Users.splice(u, 1);
                                    }
                                }
                            }
                        }
                    }; //#GET LIST USER BY ROLE ID
                    var errorCallBackRole = function (reason) {
                        console.log(reason);
                    } //#errorCallBackRole
        
                    $http({
                        method: "GET",
                        url: hostName.url + "api/UserRole/GetUserRoleByRoleId?roleId=" + sessionStorage.itemId
                    }).then(successCallBackRole, errorCallBackRole);
                }; //#successCallBackUser
                var errorCallBackUser = function (reason) {
                    $scope.error = reason.data;
                    
                    console.log(reason);
                } //#errorCallBackUser
        
                //GET LIST USERS by EnterpriseId
                $http({
                    method: "GET",
                    url: hostName.url + "api/User/ListsUser?enterpriseId=" + enterpriseId
                }).then(successCallBackUser, errorCallBackUser);
                //#GET LIST USERS by EnterpriseId
            }, function(error){
                console.log(error);
            });
        } //#Get User information

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };

        //choose User and add to list
        $scope.selectChanged = function(User) {
            var index = $scope.Users.indexOf(User);
            for (n=0; n<$scope.Users.length; n++) {
                if (User.ID == $scope.Users[n].ID) {
                    $scope.Users.splice(index,1);
                    $scope.User.selected = undefined;
                    $scope.displayedCollection.push(User);
                }
            }
        }

        //Remove User from list
        $scope.removeUser = function(User) {
            var index = $scope.displayedCollection.indexOf(User);
            for (n=0; n<$scope.displayedCollection.length; n++) {
                if (User.ID == $scope.displayedCollection[n].ID) {
                    $scope.displayedCollection.splice(index,1);
                    $scope.Users.push(User);
                    vm.UserDelete.push(User.ID);
                }
            }
        }

        //function to save data to database
        $scope.save = function() {
            
            //check if empty User
            if ($scope.displayedCollection.length == 0) {
                swal({
                    title: "Chưa có người dùng được chọn, bạn muốn bỏ qua việc phân quyền?",
                    icon: "warning",
                    buttons: ["Hủy bỏ", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        location.href = "#/roles";
                    } else {
                        $scope.$broadcast('SetFocus');
                    }
                });
            } //#check if empty User

            //check if delete data
            if (vm.UserDelete.length > 0) {
                for (n=0; n<vm.UserDelete.length; n++) {
                    var inputData = {
                        'UserID': vm.UserDelete[n], 
                        'RoleID': sessionStorage.itemId, 
                        'enterpriseId': enterpriseId
                    };
                    $http.post(hostName.url + "api/UserRole/DeleteUserRole", inputData)
                    .then(function(data) {
                        //NO Action
                    }, function(error){
                        console.log(error);
                    });
                    vm.UserDelete.splice(n,1);
                }
            } //#check if delete data

            //check to add new data
            for (n=0; n<$scope.displayedCollection.length; n++) {
                var UserID = $scope.displayedCollection[n].ID;
                var inputData = {
                    'UserID': UserID, 
                    'RoleID': sessionStorage.itemId, 
                    'enterpriseId': enterpriseId
                };

                $http.post(hostName.url + "api/UserRole/AddUserRole", inputData)
                    .then(function(data) {
                        if (n == $scope.displayedCollection.length) {
                            swal({
                                title: "Thông báo",
                                text: "Lưu dữ liệu thành công!",
                                icon: "success",
                                button: "Đóng",
                            }).then(function(){
                                location.href = "#/roles";
                            });
                        }
                    }, function(error){
                        console.log(error);
                        swal({
                            title: "Thông báo",
                            text: "Không thể lưu được dữ liệu, vui lòng liên hệ quản trị hệ thống!",
                            icon: "error",
                            dangerMode:true,
                            button: "Đóng",
                        }).then(function(){
                            location.href = "#/roles";
                        });
                    });
            } //end check to add new data

        } //end function to save data to database
  
    }; //******End controller for Manage User******
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 10.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for Update User
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('UpdateUserPageCtrl', UpdateUserPageCtrl);

    /******************************************/
    /******controller for Update User******/
    /******************************************/
    function UpdateUserPageCtrl($scope, $http, hostName) {

        //Set data for Page Title
        $scope.PageTitle = "Tạo mới thông tin người dùng";
        $scope.checkStatus = 'Y';
        $scope.flagEdit = false;
        $scope.Enterprise = [];

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" )
                    $scope.isShow = true;
            };
        };

        //load Role's data from Database via Webservice with itemId
        if (sessionStorage.itemId != 'undefined') {
            // Decrypt
            //var bytes  = CryptoJS.AES.decrypt(sessionStorage.itemId.toString(), 'VietInfo@32XVNTQUANBINHTHANH');
            //var itemId = bytes.toString(CryptoJS.enc.Utf8);
            var itemId = sessionStorage.itemId.toString();
            
            //Update Page Title
            $scope.PageTitle = "Cập nhật thông tin người dùng";
            $scope.flagEdit = true;

            //call Webservice to get User's data by Id
            $http({
                method: "GET",
                url: hostName.url + "api/User/GetUser/" + itemId,
            }).then(function(response) {
                $scope.User = [];
                $scope.User = response.data;
                //console.log($scope.User);
                
                if ($scope.User != undefined) {
                    //put User's data into Form's controls
                    $scope.inputFullName = $scope.User.FullName;
                    $scope.inputEmail = $scope.User.Email;
                    $scope.inputUsername = $scope.User.Username;
                    $scope.inputPassword =  $scope.User.Password;
                    $scope.checkStatus = $scope.User.PasswordMustChange == true?'Y':'N';
                    $scope.inputBirthday = $scope.User.Birthday;
                    $scope.inputPhone = $scope.User.Phone;
                    $scope.inputProfilePicture = $scope.User.ProfilePicture;
                    $scope.inputSocialProfile = $scope.User.SocialProfile;

                    //GET Enterprise's Information
                    $http({
                        method: "GET",
                        url: hostName.url + "api/Enterprise/GetEnterprise/" + $scope.User.enterpriseId,
                    }).then(function(response) {
                        var obj = response.data;
                        $scope.Enterprise.selected = {ID: obj.ID, enterpriseNameVN: obj.enterpriseNameVN};
                    }, function(reason) {
                        $scope.error = reason.data;
                        console.log(reason);
                    });
                }
            }, function(reason) {
                $scope.error = reason.data;
                console.log(reason);
            });
        };

        $scope.changeOrganization = function(obj) {
            $scope.Enterprise.selected = obj;
        };

        //save User's data into Database via Webservice
        $scope.save = function () {

            var FullName = angular.element(document).find('#inputFullName')[0];
            var Email = angular.element(document).find('#inputEmail')[0];
            var Username = angular.element(document).find('#inputUsername')[0];
            var Password = angular.element(document).find('#inputPassword')[0];
            var Birthday = angular.element(document).find('#inputBirthday')[0];
            var Phone = angular.element(document).find('#inputPhone')[0];
            var PasswordMustChange = angular.element(document).find('#inputPasswordMustChange')[0];
            var enterpriseId = $scope.Enterprise.selected == undefined ? sessionStorage.enterpriseId : $scope.Enterprise.selected.ID;
            // var ProfilePicture = angular.element(document).find('#inputProfilePicture')[0];
            // var SocialProfile = angular.element(document).find('#inputSocialProfile')[0];
            var flag = true;

            //check empty Enterprise
            if ($scope.isShow && $scope.Enterprise.selected == undefined) {
                swal({
                    title: "Thông tin Đơn vị",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    $scope.$broadcast('SetFocusEnt');
                });
                flag = false;
                return;
            };

            //check empty FullName
            if (FullName.value == '') {
                swal({
                    title: "Thông tin Tên người dùng",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    FullName.focus();
                });
                flag = false;
                return;
            };

            //check empty Email
            if (Email.value == '') {
                swal({
                    title: "Thông tin Email",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    Email.focus();
                });
                flag = false;
                return;
            };

            //check valid Email
            if (Email.value.indexOf("@") < 1) {
                swal({
                    title: "Địa chỉ Email",
                    text: 'không hợp lệ',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    Email.focus();
                });
                flag = false;
                return;
            };

            //check empty Username
            if (Username.value == '') {
                swal({
                    title: "Thông tin Username",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    Username.focus();
                });
                flag = false;
                return;
            };

            //check empty Password
            if (Password.value == '') {
                swal({
                    title: "Thông tin Mật khẩu",
                    text: 'không được để trống',
                    icon: "warning",
                    button: "Đóng"
                }).then(function(){
                    Password.focus();
                });
                flag = false;
                return;
            };

            function successCallBack(data) {
                swal({
                    title: "Thông báo",
                    text: "Lưu dữ liệu thành công!",
                    icon: "success",
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/users";
                });
            };

            function errorCallBack(error) {
                swal({
                    title: "Thông báo",
                    text: error.data.Message,
                    icon: "error",
                    dangerMode:true,
                    button: "Đóng",
                }).then(function(){
                    location.href = "#/users";
                });
                console.log(error);
            };
            
            //check if data's input is not empty
            if (flag == true) {

                //update User's data
                if (sessionStorage.itemId != 'undefined') {
                    //debugger;
                    var inputData = {
                        'ID': sessionStorage.itemId,
                        'FullName': FullName.value, 
                        'Email': Email.value,
                        'Username': Username.value,
                        'Password': Password.value,
                        'PasswordMustChange': 0,//PasswordMustChange.checked,
                        'Birthday': Birthday.value,
                        'Phone': Phone.value,
                        //   'ProfilePicture': ProfilePicture.value,
                        //   'SocialProfile': SocialProfile.value,
                        'enterpriseId': enterpriseId
                    };
                    $http.post(hostName.url + "api/User/UpdateUser", inputData)
                    .then(successCallBack, errorCallBack);
                }
                //Add new User's data
                else {
                    var inputData = {
                        'FullName': FullName.value, 
                        'Email': Email.value,
                        'Username': Username.value,
                        'Password': Password.value,
                        'PasswordMustChange': 0,//PasswordMustChange.checked,
                        'Birthday': Birthday.value,
                        'Phone': Phone.value,
                        //   'ProfilePicture': ProfilePicture.value,
                        //   'SocialProfile': SocialProfile.value,
                        'enterpriseId': enterpriseId
                    };
                    //debugger;
                    $http.post(hostName.url + "api/User/AddUser", inputData)
                    .then(successCallBack, errorCallBack);
                }
            }

        };
        //end function save User's data into Database via Webservice

        //redirect to other pages
        $scope.open = function(url) {
            location.href = url;
        };
    }
    /******End controller for Update User******/
  
})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 10.10.2018
 */
(function () {
    'use strict';
  
    //declare controller for User
    angular.module('BlurAdmin.pages.systemManagement')
        .controller('UserPageCtrl', UserPageCtrl);

      angular.module('BlurAdmin.pages.systemManagement')
        .controller('SelectUserPageCtrl', SelectUserPageCtrl);
  
    //******controller for User******
    function UserPageCtrl($scope, $http, $state, hostName) {
  
        $scope.smartTablePageSize = 10;
        var n = 0;
        var vm = this;
        vm.rowCollection = [];
        sessionStorage.itemId = undefined;

        //CHECK ADMIN PERMISSION
        $scope.isShow = false;
        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { 
                if ( userRole[ur].Name === "Administrator" )
                    $scope.isShow = true;
            };
        }
    
        //function then call Webservice get User's data is success
        function successCallBack(response) {
            vm.rowCollection = response.data;
    
            for (n=0; n < vm.rowCollection.length; n++) {
                // Encrypt
                vm.rowCollection[n].No = n+1;
                //vm.rowCollection[n].itemId = CryptoJS.AES.encrypt(vm.rowCollection[n].ID, 'VietInfo@32XVNTQUANBINHTHANH');
            }
    
            //display message into Console
            //console.log(response);
        };
    
        //function then call Webservice get User's data is error
        function errorCallBack(reason) {
            $scope.error = reason.data;
    
            //display message into Console
            console.log(reason);
        }
    
        // //call Webservice to get User's data
        // $http({
        //     method: "GET",
        //     url: hostName.url + "api/User/GetAllUser?enterpriseId=" + sessionStorage.enterpriseId
        // }).then(successCallBack, errorCallBack);
    
        //check True/False for isActive chechbox
        $scope.checkShow = function(dataCheck){
            if (dataCheck) {
                return 1;
            }
            else {
                return 0;
            }
        };

        //save data to local variable when change Select's control
        $scope.selectChanged = function(objectSelect) {
            $scope.Role = objectSelect;
        }

        changeEnterprise(sessionStorage.enterpriseId);
        $scope.changeOrganization = function(obj) {
            $scope.Enterprise = obj;

            changeEnterprise($scope.Enterprise.ID);
        };

        function changeEnterprise(enterpriseId) {
            //GET Role's Information
            $http({
                method: "GET",
                url: hostName.url + "api/Role/GetAllRole?enterpriseId=" + enterpriseId
            }).then(function(response) {
                $scope.Roles = response.data;
            }, function(reason) {
                console.log(reason);
            });
        };
        
        //redirect to other pages
        $scope.open = function(url, id) {
            location.href = url;
            sessionStorage.itemId = id;
        };

        searchData();
        $scope.findData = function() {
            searchData();
        } ;
    
        //filter User's data
        function searchData () {
            //clear data
            vm.rowCollection = [];

            var FullName = angular.element(document).find('#inputFullName')[0];
            var Email = angular.element(document).find('#inputEmail')[0];
            var roleId = $scope.Role != undefined ? $scope.Role.ID : "";  //get roleId from UI Select
            var enterpriseId = $scope.Enterprise != undefined ? $scope.Enterprise.ID : sessionStorage.enterpriseId;
            var LockoutEnabled = "";//= angular.element(document).find('#inputLockoutEnabled')[0];
            var LockoutEnabledAll = angular.element(document).find('#radioLockoutEnabledAll')[0];
            var LockoutEnabledTrue = angular.element(document).find('#radioLockoutEnabledTrue')[0];
            //var LockoutEnabledFalse = angular.element(document).find('#radioLockoutEnabledFalse')[0];
            if (LockoutEnabledAll.checked == true) {
                LockoutEnabled = "";
            }
            else if (LockoutEnabledTrue.checked == true) {
                LockoutEnabled = true;
            }
            else {
                LockoutEnabled = false;
            }
            var queryString = "";
    
            queryString = "enterpriseId=" + enterpriseId + "&FullName=" + FullName.value + "&Email=" + Email.value + "&roleId=" + roleId + "&LockoutEnabled=" + LockoutEnabled;
            
            //call Webservice to get User's data
            $http({
                method: "GET",
                url: hostName.url + "api/User/SearchUser?" + queryString,
            }).then(successCallBack, errorCallBack);
        };
        //end filter User's data

        $scope.resetPassword = function(itemId) {
            swal({
                title: "Bạn muốn đặt lại mật khẩu người dùng này?",
                icon: "warning",
                buttons: ["Trở về", "Đồng ý!"],
                dangerMode: true,
            })
            .then(function(willDelete)  {
                if (willDelete) {
                    var inputData = {
                        'ID': itemId,
                        'Password': '123456'
                    };
                    $http.post(hostName.url + "api/User/SetupPassword", inputData).then(function(data){
                        swal("Đã đặt lại mậu khẩu thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                    });
                } else {
                    //no action;
                }
            });
        };
    
        //Locked User
        $scope.updateStatus = function(flag, itemId) {
            if (flag == true) {
                //Stop
                swal({
                    title: "Bạn muốn khóa người dùng này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                    var inputData = {
                        'ID': itemId,
                        'LockoutEnabled': true
                    };
                    $http.post(hostName.url + "api/User/LockedUser", inputData).then(function(data){
                        swal("Đã khóa thành công!", {
                            icon: "success",
                            button: "Đóng"
                        }).then(function(){
                            $state.reload();
                        });
                    }, function(data) {
                        swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                            icon: "error",
                            button: "Đóng"
                        });
                    });
                    } else {
                        //no action;
                    }
                });
            }
            else {
                //Active
                swal({
                    title: "Bạn muốn bỏ khóa người dùng này?",
                    icon: "warning",
                    buttons: ["Trở về", "Đồng ý!"],
                    dangerMode: true,
                })
                .then(function(willDelete)  {
                    if (willDelete) {
                        var inputData = {
                            'ID': itemId,
                            'LockoutEnabled': false
                        };
                        $http.post(hostName.url + "api/User/LockedUser", inputData).then(function(data){
                            swal("Bỏ khóa thành công!", {
                                icon: "success",
                                button: "Đóng"
                            }).then(function(){
                                $state.reload();
                            });
                        }, function(data) {
                            swal("Không thể cập nhật được dữ liệu, vui lòng liên hệ quản trị hệ thống để được hỗ trợ!", {
                                icon: "error",
                                button: "Đóng"
                            });
                        });
                    } else {
                        //no action;
                    }
                });
            };
        };
  
    };
    //******End controller for User******

    //******controller for Select User******
    function SelectUserPageCtrl($scope, $http, hostName) {
        $scope.Users = [];

        var successCallBack = function (response) {
            $scope.Users = response.data;
        };

        var errorCallBack = function (reason) {
            $scope.error = reason.data;
            
            console.log(reason);
        }

        $http({
            method: "GET",
            url: hostName.url + "api/User/GetAllUser?enterpriseId=" + sessionStorage.enterpriseId
        }).then(successCallBack, errorCallBack);
    }
    //******End controller for Select User******
  
})();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 11.01.2019
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .filter('replace', replace);
  
    /** @ngInject */
    function replace () {
      
        return function (input, from, to) {
      
            if(input === undefined) {
              return;
            }
        
            var regex = new RegExp(from, 'g');
            return input.replace(regex, to);
             
        };
         
    };
  
})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 12.09.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .filter('logoPicture', logoPicture);
  
    /** @ngInject */
    function logoPicture(layoutPaths) {
      return function(input) {
        //ext = ext || 'png';
        return layoutPaths.images.logo + input; //+ '.' + ext;
      };
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input;// + '.' + ext;
    };
  }

})();

/**
 * @author Nguyen Huu Tuan
 * created on 14.09.2018
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .filter('templatePicture', templatePicture);
  
    /** @ngInject */
    function templatePicture(layoutPaths) {
      return function(input) {
        //ext = ext || 'png';
        return layoutPaths.images.template + input; //+ '.' + ext;
      };
    }
  
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              //alert("baSideBar" + s.title + s.role);
              return {
                name: s.name,
                title: s.title,
                level: ((s.name.match(/\./g) || []).length - 1),
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);
  
    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService) {

        var userRole = JSON.parse(localStorage.getItem("dataUserRole"));
        var grantPermission = JSON.parse(localStorage.getItem("grantPermission"));
        var flagAdmin = false;
    
        //Get flag Admin
        if (userRole != undefined) {
            for (var ur = 0; ur < userRole.length; ur++) { //userRole loop
                if ( userRole[ur].Name === "Administrator" 
                    //|| item.Name === "Quản trị hệ thống" 
                    ) flagAdmin = true;
            };
        }
    
        var objMenu = baSidebarService.getMenuItems();
        $scope.menuItems = [];
    
        //loop all menu
        for (var m = 0; m < objMenu.length; m++) {

            if (flagAdmin == true) { //Administrator
                $scope.menuItems.push(objMenu[m]);
            } //#Administrator

            else { //not Administrator

                if (objMenu[m].name == "main.dashboard") { //add default dashboard
                    $scope.menuItems.push(objMenu[m]);
                } //#add default dashboard

                else { //not dashboard
                    
                    if (objMenu[m].subMenu == null) { //if menu dont have submenu

                        for (var g = 0; g < grantPermission.length; g++) { //loop grantPermission
                            if (grantPermission[g].menuId == objMenu[m].name) {
                                for (var ur = 0; ur < userRole.length; ur++) { //userRole loop
                                    if (userRole[ur].RoleID == grantPermission[g].roleId 
                                        && grantPermission[g].isHas == true) {
                                        $scope.menuItems.push(objMenu[m]);
                                        g = grantPermission.length; //exit grantPermission loop
                                        ur = userRole.length; //exit userRole loop
                                    }
                                };
                            }
                        }

                    }  //#if menu dont have submenu

                    else { //if menu have submenu
                        var flagAdd = false;
                        var menu = objMenu[m];
                        var subMenu = objMenu[m].subMenu;
                        menu.subMenu = [];
                        
                        for (var g = 0; g < grantPermission.length; g++) { //loop grantPermission
                            for (var sm = 0; sm < subMenu.length; sm++) { // loop subMenu
                                if (subMenu[sm].name == grantPermission[g].menuId) {
                                    for (var ur = 0; ur < userRole.length; ur++) { //userRole loop
                                        if (userRole[ur].RoleID == grantPermission[g].roleId 
                                            && grantPermission[g].isHas == true) {
                                            if (menu.subMenu.indexOf(subMenu[sm]) < 0)
                                                menu.subMenu.push(subMenu[sm]);
                                            flagAdd = true;
                                            ur = userRole.length; //exit userRole loop
                                        }
                                    };
                                }
                            }
                        }

                        if (flagAdd == true) { //Add menu with submenu
                            //g = grantPermission.length; //exit grantPermission loop
                            if ($scope.menuItems.indexOf(menu) < 0)
                                $scope.menuItems.push(menu);
                        }

                    } //#if menu have submenu
                    
                } //#not dashboard
                
            }  //#not Administrator
            
        } //#loop all menu
    
        // objMenu.forEach(function(item) {
        //   if (flagAdmin == true) {
        //     $scope.menuItems.push(item);
        //   }
        //   else {
        //     if (item.name == "main.dashboard") {
        //       $scope.menuItems.push(item);
        //     };
            
        //     var flagAdd = false;
        //     grantPermission.forEach(function(grant) {
        //       if (grant.isHas == true) { //if user have permission
        //         if (item.subMenu == null) { //if menu dont have submenu
        //           if (grant.menuId == item.name) {
        //             userRole.forEach(function(role) {
        //               if (role.RoleID == grant.roleId) {
        //                 flagAdd = true;
        //               }
        //             });
        //           }
        //         }
        //         else { //if menu have submenu
        //           item.subMenu.forEach(function(sub) {
        //             if (sub.name == grant.menuId) {
        //               userRole.forEach(function(role) {
        //                 if (role.RoleID == grant.roleId) {
        //                   flagAdd = true;
        //                 }
        //               });
        //               break;
        //             }
        //             else {
        //               console.log(sub.name);
        //               // var index = item.subMenu.indexOf(sub);
        //               // item.subMenu.splice(index,1);
        //             }
        //           });
        //         } //#if menu have submenu
                
        //       } //#if user have permission
        //     });
    
        //     if (flagAdd == true) {
        //       $scope.menuItems.push(item);
        //       //console.log(item);
        //     }
            
        //   }
        //   // if (item.name != "main.lists" && item.name != "main.systemManagement") {
        //   //   $scope.menuItems.push(item);
        //   // }
        //   // else if (item.name === "main.lists" && flagAdmin == true) {
        //   //   $scope.menuItems.push(item);
        //   // }
        //   // else if (item.name === "main.systemManagement" && flagAdmin == true) {
        //   //   $scope.menuItems.push(item);
        //   // }
        // });
    
        //$scope.menuItems = objMenu;
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    
        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };
    
        $scope.$on('$stateChangeSuccess', function () {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author Nguyen Huu Tuan
 * created on 29.05.2020
 */
(function () {
    'use strict';
  
    /**
     * Includes basic panel layout inside of current element.
     */
    angular.module('BlurAdmin.theme')
        .directive('chartPanel', chartPanel);
  
    /** @ngInject */
    function chartPanel(chartPanel, baConfig) {
        return angular.extend({}, chartPanel, {
            template: function(el, attrs) {
                var res = '<div class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.chartPanelClass || '');
                res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
                res += chartPanel.template(el, attrs);
                res += '</div>';
                return res;
            }
        });
    }

})();
  
/**
 * @author Nguyen Huu Tuan
 * created on 29.05.2020
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .factory('chartPanel', chartPanel);
  
    /** @ngInject */
    function chartPanel() {
  
        /** Base chartPanel directive */
        return {
            restrict: 'A',
            transclude: true,
            template: function(elem, attrs) {
                var res = '<div class="panel-body" ng-transclude id="' + attrs.chartPanelId 
                            + '" style="width: ' + (attrs.chartPanelWidth || '100%')
                            + '; height: ' + (attrs.chartPanelHeight || '60vh') + ' !important"></div>';
                if (attrs.chartPanelTitle) {
                    var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.chartPanelTitle + '</h3></div>';
                    res = titleTpl + res; // title should be before
                }
        
                return res;
            }
        };
    }
  
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  };

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, $filter) {
    var user = JSON.parse(localStorage.getItem("dataUser"));
    $scope.FullName = user.FullName;
    if (user.ProfilePicture == null) {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
    }
    else {
      $scope.picture = $filter('profilePicture')(user.ProfilePicture);
    }
    //console.log(user);

    // $scope.users = {
    //   0: {
    //     name: 'Vlad',
    //   },
    //   1: {
    //     name: 'Kostya',
    //   },
    //   2: {
    //     name: 'Andrey',
    //   },
    //   3: {
    //     name: 'Nasta',
    //   }
    // };

    // $scope.notifications = [
    //   {
    //     userId: 0,
    //     template: '&name posted a new article.',
    //     time: '1 min ago'
    //   },
    //   {
    //     userId: 1,
    //     template: '&name changed his contact information.',
    //     time: '2 hrs ago'
    //   },
    //   {
    //     image: 'assets/img/shopping-cart.svg',
    //     template: 'New orders received.',
    //     time: '5 hrs ago'
    //   },
    //   {
    //     userId: 2,
    //     template: '&name replied to your comment.',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 3,
    //     template: 'Today is &name\'s birthday.',
    //     time: '2 days ago'
    //   },
    //   {
    //     image: 'assets/img/comments.svg',
    //     template: 'New comments on your post.',
    //     time: '3 days ago'
    //   },
    //   {
    //     userId: 1,
    //     template: '&name invited you to join the event.',
    //     time: '1 week ago'
    //   }
    // ];

    // $scope.messages = [
    //   {
    //     userId: 3,
    //     text: 'After you get up and running, you can place Font Awesome icons just about...',
    //     time: '1 min ago'
    //   },
    //   {
    //     userId: 0,
    //     text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
    //     time: '2 hrs ago'
    //   },
    //   {
    //     userId: 1,
    //     text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
    //     time: '10 hrs ago'
    //   },
    //   {
    //     userId: 2,
    //     text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 3,
    //     text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 1,
    //     text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
    //     time: '2 days ago'
    //   },
    //   {
    //     userId: 0,
    //     text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
    //     time: '1 week ago'
    //   }
    // ];

    // $scope.getMessage = function(msg) {
    //   var text = msg.template;
    //   if (msg.userId || msg.userId === 0) {
    //     text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
    //   }
    //   return $sce.trustAsHtml(text);
    // };
  }
})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope, $filter) {

        $scope.open = open;
        $scope.openedFrom = false;
        $scope.openedTo = false;
        $scope.openedStart = false;
        $scope.openedEnd = false;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false,
        };
        var date = new Date();
        var nowYear = date.getFullYear();
        var nowMonth = date.getMonth();
        $scope.inputFromDate = new Date(nowYear, nowMonth, 1);
        $scope.inputToDate = new Date();

        // //Start and End Date for amoung 30days
        // var d = new Date();
        // $scope.input30Days = new Date();
        // $scope.input0Days = new Date(d.setDate(d.getDate() - 30));

        $scope.inputStartDate = new Date(nowYear, 0, 1);
        $scope.inputEndDate = new Date();
        if (nowMonth == '1' || nowMonth == '2' || nowMonth == '3') {
            $scope.inputFromQuarterDate = new Date(nowYear, 0, 1);
        }
        else if (nowMonth == '4' || nowMonth == '5' || nowMonth == '6') {
            $scope.inputFromQuarterDate = new Date(nowYear, 3, 1);
        }
        else if (nowMonth == '7' || nowMonth == '8' || nowMonth == '9') {
            $scope.inputFromQuarterDate = new Date(nowYear, 6, 1);
        }
        else if (nowMonth == '10' || nowMonth == '11' || nowMonth == '12') {
            $scope.inputFromQuarterDate = new Date(nowYear, 9, 1);
        }
        $scope.inputToQuarterDate = new Date();
        // $scope.inputDateCreated = new Date();
        // $scope.inputDateOfInvoice = new Date();
        // $scope.inputDateInput = new Date();
        // $scope.inputDatePending = new Date();

        $scope.checkFromToDate = function () {
            var from = new Date($scope.inputFromDate);
            var to = new Date($scope.inputToDate);

            if (from > to) {
                swal("Từ ngày không thể lớn hơn Đến ngày!!!").then(function () {
                    var fromDate = angular.element(document).find('#inputFromDate')[0];
                    var toDate = angular.element(document).find('#inputToDate')[0];
                    fromDate.value = $filter('date')(new Date(nowYear, nowMonth, 1), 'dd/MM/yyyy');
                    toDate.value = $filter('date')(new Date(), 'dd/MM/yyyy');
                    $scope.inputFromDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                    $scope.inputToDate = new Date();
                });
            };
        };

        $scope.checkStartEndDate = function () {
            var start = new Date($scope.inputStartDate);
            var end = new Date($scope.inputEndDate);

            if (start > end) {
                swal("Từ ngày không thể lớn hơn Đến ngày!!!").then(function () {
                    var fromDate = angular.element(document).find('#inputStartDate')[0];
                    var toDate = angular.element(document).find('#inputEndDate')[0];
                    fromDate.value = $filter('date')(new Date(nowYear, 0, 1), 'dd/MM/yyyy');
                    toDate.value = $filter('date')(new Date(), 'dd/MM/yyyy');
                    $scope.inputStartDate = new Date(new Date().getFullYear(), 0, 1);
                    $scope.inputEndDate = new Date();
                });
            };
        };

        $scope.checkFromToQuarterDate = function () {
            var start = new Date($scope.inputFromQuarterDate);
            var end = new Date($scope.inputToQuarterDate);

            if (start > end) {
                swal("Từ ngày không thể lớn hơn Đến ngày!!!").then(function () {
                    var fromDate = angular.element(document).find('#inputFromQuarterDate')[0];
                    var toDate = angular.element(document).find('#inputToQuarterDate')[0];

                    if (nowMonth == '1' || nowMonth == '2' || nowMonth == '3') {
                        $scope.inputFromQuarterDate = new Date(nowYear, 0, 1);
                        fromDate.value = $filter('date')(new Date(nowYear, 0, 1), 'dd/MM/yyyy');
                    }
                    else if (nowMonth == '4' || nowMonth == '5' || nowMonth == '6') {
                        $scope.inputFromQuarterDate = new Date(nowYear, 3, 1);
                        fromDate.value = $filter('date')(new Date(nowYear, 3, 1), 'dd/MM/yyyy');
                    }
                    else if (nowMonth == '7' || nowMonth == '8' || nowMonth == '9') {
                        $scope.inputFromQuarterDate = new Date(nowYear, 6, 1);
                        fromDate.value = $filter('date')(new Date(nowYear, 6, 1), 'dd/MM/yyyy');
                    }
                    else if (nowMonth == '10' || nowMonth == '11' || nowMonth == '12') {
                        $scope.inputFromQuarterDate = new Date(nowYear, 9, 1);
                        fromDate.value = $filter('date')(new Date(nowYear, 9, 1), 'dd/MM/yyyy');
                    }

                    toDate.value = $filter('date')(new Date(), 'dd/MM/yyyy');
                    $scope.inputToQuarterDate = new Date();
                });
            };
        };

        function open(flag) {
            if (flag == true) {
                $scope.openedFrom = true;
                $scope.openedStart = true;
            }
            else if (flag == false) {
                $scope.openedTo = true;
                $scope.openedEnd = true;
            }
            else
                $scope.opened = true;
        }
    }

})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/authSignIn/authSignIn.html','<div class="login" ng-controller="authSignInCtrl as signInVm"><main class="auth-main"><div class="auth-block"><h1>H\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED Vi.eInvoice</h1><form class="form-horizontal" ng-submit="signInVm.logar()"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" ng-model="signInVm.user" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><div class="input-group"><input type="{{inputType}}" class="form-control" id="inputPassword" ng-model="signInVm.passWord" placeholder="M\u1EADt kh\u1EA9u"> <span class="input-group-addon input-group-addon-default addon-right"><span class="{{showHideClass}}" ng-click="showPassword()" style="cursor:pointer"></span></span></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">\u0110\u0103ng nh\u1EADp</button></div></div></form></div></main></div>');
$templateCache.put('app/pages/authSignIn/messageLicense.html','<div><main class="auth-main"><div class="messageLicense"><h1>{{messageLicense}}</h1><div class="horizontal-scroll"><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr><td colspan="4">Ph\u1EA7n m\u1EC1m H\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED Vi.eInvoice \u0111\u01B0\u1EE3c ph\xE1t tri\u1EC3n b\u1EDFi C\xF4ng ty C\u1ED5 ph\u1EA7n c\xF4ng ngh\u1EC7 VietInfo</td></tr></thead><tbody><tr><td style="width:20%; text-align:right;">\u0110\u1ECBa ch\u1EC9:</td><td colspan="3">32 X\xF4 Vi\u1EBFt Ngh\u1EC7 T\u0129nh, Ph\u01B0\u1EDDng 19, Qu\u1EADn B\xECnh Th\u1EA1nh, TPHCM</td></tr><tr><td style="width:20%; text-align:right;">\u0110i\u1EC7n tho\u1EA1i:</td><td>028.62582324</td><td style="width:20%; text-align:right;">Fax:</td><td>028.62582325</td></tr><tr><td style="width:20%; text-align:right;">Email:</td><td colspan="3">support@vietinfo.tech</td></tr></tbody><tfoot><tr><td colspan="4" style="text-align:right;"><a target="_blank" href="http://www.vietinfo.tech" class="forgot-pass">\u0110\u0103ng k\xFD b\u1EA3n quy\u1EC1n</a></td></tr></tfoot></table></div></div></main></div>');
$templateCache.put('app/pages/authSignUp/authSignUp.html','<div class="login"><main class="auth-main"><div class="auth-block"><h1>\u0110\u0103ng k\xFD t\xE0i kho\u1EA3n</h1><a ui-sref="authSignIn" class="auth-link">\u0110\xE3 c\xF3 t\xE0i kho\u1EA3n? \u0110\u0103ng nh\u1EADp!</a><form class="form-horizontal"><div class="form-group"><label for="inputName3" class="col-sm-2 control-label">H\u1ECD t\xEAn</label><div class="col-sm-10"><input type="text" class="form-control" id="inputName3" placeholder="T\xEAn \u0111\u1EA7y \u0111\u1EE7"></div></div><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><label for="inputConfirmPassword3" class="col-sm-2 control-label">Repeat</label><div class="col-sm-10"><input type="password" class="form-control" id="inputConfirmPassword3" placeholder="Repeat Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">\u0110\u0103ng k\xFD</button></div></div></form><div class="auth-sep"><span><span>ho\u1EB7c \u0110\u0103ng k\xFD v\u1EDBi 1 l\u1EA7n nh\u1EA5n</span></span></div><div class="al-share-auth"><ul class="al-share clearfix"><li><i class="socicon socicon-facebook" title="Share on Facebook"></i></li><li><i class="socicon socicon-twitter" title="Share on Twitter"></i></li><li><i class="socicon socicon-google" title="Share on Google Plus"></i></li></ul></div></div></main></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><section ng-controller="dashboardCtrl"><div class="row"><div class="col-md-6" style="padding-left: 15px; padding-right:15px;"><growth-revenue-bar-chart></growth-revenue-bar-chart></div><div class="col-md-6" style="padding-left: 15px; padding-right:15px;"><clustered-bar-chart></clustered-bar-chart></div></div></section>');
$templateCache.put('app/pages/lists/lists.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="ListsPageCtrl as ctrl"><div class="form-horizontal text-center"><div class="form-group"><div class="col-sm-3 col-xs-6"><label class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n</label><br><a ui-sref="main.typeOfInvoice"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/loaihoadon.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label><br><a ui-sref="main.template"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/mauhoadon.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">Kh\xE1ch h\xE0ng</label><br><a ui-sref="main.customer"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/khachhang.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">Bi\u1EC3u m\u1EABu</label><br><a ui-sref="main.document"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/document.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div></div><div class="form-group"><div class="col-sm-3 col-xs-6"><label class="control-label">Lo\u1EA1i doanh thu</label><br><a ui-sref="main.typeOfRevenue"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/loaidoanhthu.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6" ng-show="isShow"><label class="control-label">Ph\xF2ng ban</label><br><a ui-sref="main.department"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/lists/phongban.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div></div></div></div></div>');
$templateCache.put('app/pages/reports/reports.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal text-center"><div class="form-group"><div class="col-sm-3 col-xs-6"><label class="control-label">B\xE1o c\xE1o t\xECnh h\xECnh s\u1EED d\u1EE5ng</label><br><a ui-sref="main.reportMain"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/reports/tinhhinhsudung.jpg\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">Th\u1ED1ng k\xEA chi ti\u1EBFt H\u0110</label><br><a ui-sref="main.reportInvoiceDetail"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/reports/thongkechitiet.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">Qu\u1EA3n l\xFD kho H\u0110</label><br><a ui-sref="main.inventoryInvoice"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/reports/khohoadon.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label">B\u1EA3ng k\xEA H\u0110 b\xE1n ra</label><br><a ui-sref="main.statementOfInvoice"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/reports/bangkebanra.jpg\' | appImage )}}" class="btn btn-default btn-lg"></a></div></div><div class="form-group"></div></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><h3 class="with-line">Th\xF4ng tin chung</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">H\xECnh \u0111\u1EA1i di\u1EC7n</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Thay \u0111\u1ED5i h\xECnh \u0111\u1EA1i di\u1EC7n</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFullName" class="col-sm-3 control-label">T\xEAn \u0111\u1EA7y \u0111\u1EE7</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFullName" ng-model="inputFullName"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputDateOfBirth" class="col-sm-3 control-label">N\u0103m sinh</label><div class="col-sm-6" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfBirth" id="inputDateOfBirth" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><h3 class="with-line">\u0110\u1ED5i m\u1EADt kh\u1EA9u</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">M\u1EADt kh\u1EA9u</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" ng-model="inputPassword"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">L\u1EB7p l\u1EA1i m\u1EADt kh\u1EA9u</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" ng-model="inputConfirmPassword"></div></div></div></div><h3 class="with-line">Th\xF4ng tin li\xEAn h\u1EC7</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" readonly="" id="inputEmail" ng-model="inputEmail"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">\u0110i\u1EC7n tho\u1EA1i</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" ng-model="inputPhone"></div></div></div><button type="button" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>C\u1EADp nh\u1EADt th\xF4ng tin</button></div></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/QD1450/QD1450.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal text-center"><div class="form-group"><div class="col-sm-3 col-xs-6"><label class="control-label" style="text-align: center;">\u0110\u0103ng k\xFD/thay \u0111\u1ED5i th\xF4ng tin<br>s\u1EED d\u1EE5ng H\u0110\u0110T</label><br><a ui-sref="main.Message100"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/qd1450/100.png\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label" style="text-align: center;">K\u1EBFt qu\u1EA3 \u0111\u0103ng k\xFD</label><br><br><br><a ui-sref="main.Receive102103"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/qd1450/106.jpg\' | appImage )}}" class="btn btn-default btn-lg"></a></div><div class="col-sm-3 col-xs-6"><label class="control-label" style="text-align: center;">Nh\u1EADt k\xFD truy\u1EC1n nh\u1EADn</label><br><br><br><a ui-sref="main.SendReceiveLog"><input type="image" style="width: 100; height: 100px;" ng-src="{{::( \'app/qd1450/101.jpg\' | appImage )}}" class="btn btn-default btn-lg"></a></div></div></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown="">{{FullName}}</li></ul>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Dashboard</a></li></ul></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>Vi.</span>eInvoice</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix" ng-controller="MsgCenterCtrl"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{ picture }}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/main/profile"><i class="fa fa-user"></i>Th\xF4ng tin c\xE1 nh\xE2n</a></li><li><a href="#/authSignIn" class="signout"><i class="fa fa-power-off"></i>Tho\xE1t</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/electricInvoice/adjustInvoice/adjustInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="isPublic" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputMedicalCode" class="control-label">M\xE3 y t\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputMedicalCode" id="inputMedicalCode" placeholder="M\xE3 y t\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-5"><input type="text" class="form-control" id="inputCompanyName" ng-model="inputCompanyName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputHealthInsuranceCardNumber" class="control-label">Th\u1EBB BHYT</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputHealthInsuranceCardNumber" id="inputHealthInsuranceCardNumber" placeholder="Th\u1EBB BHYT"></div><div class="col-sm-2" style="text-align: right;"><label for="inputHospitalizationNumber" class="control-label">S\u1ED1 nh\u1EADp vi\u1EC7n</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputHospitalizationNumber" id="inputHospitalizationNumber" placeholder="S\u1ED1 nh\u1EADp vi\u1EC7n"></div></div><div class="horizontal-scroll"><label for="inputIsActive" class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND)</td><td>% (VAT)</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice1(inputPrice1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT1" ng-model="inputVAT1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice2(inputPrice2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT2" ng-model="inputVAT2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice3(inputPrice3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT3" ng-model="inputVAT3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceApproved\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/businessInvoice/adjustBusinessInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyCode" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-9" ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label> &nbsp;&nbsp; <label class="col-sm-offset-5" style="text-align: right;">File chi ti\u1EBFt:</label> &nbsp; &nbsp; <label for="fileName"><b style="color:yellow">{{$root.fileTemplate}}</b></label> &nbsp; <a title="B\u1ECF file chi ti\u1EBFt" style="color:burlywood;" ng-show="isHasFile" href="" ng-click="removeFileInvoiceDetail()">B\u1ECF</a> &nbsp;|&nbsp; <a href="" class="change-userpic" ng-click="uploadFileInvoiceDetail()">T\u1EA3i l\xEAn</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> &nbsp;|&nbsp; <a title="File m\u1EABu chi ti\u1EBFt H\u0110" href="{{FileMauChiTiet}}">File m\u1EABu</a><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/businessInvoice\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/businessInvoice/businessInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="BusinessInvoicePageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectStatusByApprovedPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChangedStatus(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="createInvoice()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button><button type="button" title="C\u1EA7n ph\u1EA3i ch\u1EA1y ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 tr\u01B0\u1EDBc khi xu\u1EA5t h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mainCtrl.TotalAmount}} / {{mainCtrl.TotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center" ng-if="mainCtrl.isXML == 1">XML</td><td class="text-center">H\u0110 \u0110T</td><td class="text-center">H\u0110 C\u0110</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.statusCode != \'NOTPUBLISH\' && item.statusCode != \'MODIFIED\'"><a title="X\u1EED l\xFD h\xF3a \u0111\u01A1n" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/editBusinessInvoice\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div><div ng-if="item.statusCode == \'NOTPUBLISH\'"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createBusinessInvoice\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td class="text-center"><div ng-if="item.statusCode == \'PUBLISHED\' && item.dateOfInvoice == checkDate"><a style="color:yellow" href="" ng-click="editInvoice(\'#/createBusinessInvoice\', item.ID)">{{("0000000"+item.billNumber).slice(-7)}}</a></div><div ng-if="item.statusCode != \'PUBLISHED\' || item.dateOfInvoice != checkDate">{{("0000000"+item.billNumber).slice(-7)}}</div></td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td><td class="text-center" ng-if="mainCtrl.isXML == 1"><div ng-if="item.fileInvoiceXML != \'\' && item.statusCode == \'PUBLISHED\'"><a href="{{pathFileInvoice + item.fileInvoiceXML}}" target="_blank" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div><div ng-if="item.fileInvoiceXML == \'\' && item.statusCode == \'PUBLISHED\'"><a href="" ng-click="createFileInvoiceXML(item.ID)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-export"></span></a></div></td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{pathFileInvoice + item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td class="text-center"><div ng-if="item.fileConvert != \'\' && (item.statusCode == \'PUBLISHED\' || item.statusCode == \'MODIFIED\')"><a href="{{pathFileInvoice + item.fileConvert}}" target="_blank" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-file"></span></a></div><div ng-if="item.fileConvert == \'\' && (item.statusCode == \'PUBLISHED\' || item.statusCode == \'MODIFIED\')"><a href="" ng-click="createFileConvert(item.ID, item.fileName)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-export"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/businessInvoice/createBusinessInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyCode" class="control-label">T\xEAn \u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-9" ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Ng\u01B0\u1EDDi mua</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua"></div><div class="col-sm-1" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-1" style="text-align: right;"><label for="inputTaxCode" class="control-label">HTTT</label></div><div class="col-sm-2"><ui-select focus-on="SetFocusHTTT" ng-model="HTTT.selected" ng-change="changeHTTT(HTTT.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTTT in HTTTs | filter: $select.search"><span ng-bind-html="HTTT.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label> &nbsp;&nbsp; <label class="col-sm-offset-5" style="text-align: right;">File chi ti\u1EBFt:</label> &nbsp; &nbsp; <label for="fileName"><b style="color:yellow">{{$root.fileTemplate}}</b></label> &nbsp; <a title="B\u1ECF file chi ti\u1EBFt" style="color:burlywood;" ng-show="isHasFile" href="" ng-click="removeFileInvoiceDetail()">B\u1ECF</a> &nbsp;|&nbsp; <a href="" class="change-userpic" ng-click="uploadFileInvoiceDetail()">T\u1EA3i l\xEAn</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> &nbsp;|&nbsp; <a title="File m\u1EABu chi ti\u1EBFt H\u0110" href="{{FileMauChiTiet}}">File m\u1EABu</a><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/businessInvoice\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/businessInvoice/CreateInvoiceNotCode.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyCode" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-9" ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label> &nbsp;&nbsp; <label class="col-sm-offset-5" style="text-align: right;">File chi ti\u1EBFt:</label> &nbsp; &nbsp; <label for="fileName"><b style="color:yellow">{{$root.fileTemplate}}</b></label> &nbsp; <a title="B\u1ECF file chi ti\u1EBFt" style="color:burlywood;" ng-show="isHasFile" href="" ng-click="removeFileInvoiceDetail()">B\u1ECF</a> &nbsp;|&nbsp; <a href="" class="change-userpic" ng-click="uploadFileInvoiceDetail()">T\u1EA3i l\xEAn</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> &nbsp;|&nbsp; <a title="File m\u1EABu chi ti\u1EBFt H\u0110" href="{{FileMauChiTiet}}">File m\u1EABu</a><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>G\u1EEDi c\u01A1 quan Thu\u1EBF</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/businessInvoice\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/businessInvoice/editBusinessInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputBillNumber" ng-model="inputBillNumber"></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputInvoiceTemplate" ng-model="inputInvoiceTemplate"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputDateOfInvoice" ng-model="inputDateOfInvoice"></div><div class="col-sm-2" style="text-align: right;"><label for="inputDateCreated" class="control-label">Ng\xE0y x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateCreated" id="inputDateCreated" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">H\xECnh th\u1EE9c x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-4" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="DELETE"> <span>H\u1EE7y</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="ADJUST"> <span>\u0110i\u1EC1u ch\u1EC9nh</span></label></div></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">L\xFD do x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><textarea placeholder="L\xFD do x\u1EED l\xFD" class="form-control" id="inputDescription" ng-model="inputDescription"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isCreatInvoice" ng-click="changeInvoice()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi H\u0110</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPrint" ng-click="printDocument()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>In bi\xEAn b\u1EA3n</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPrint" ng-click="printNotification()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Th\xF4ng b\xE1o</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="backPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/BienLaiToKhai/BienLai.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="BienLaiCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="cboStatus" class="control-label">T\xECnh tr\u1EA1ng bi\xEAn lai</label></div><div class="col-sm-4"><select id="cboStatus" ng-model="mMaTinhTrang" ng-init="mMaTinhTrang=\'\'" class="form-control"><option value="">-- Ch\u1ECDn t\xECnh tr\u1EA1ng --</option><option ng-repeat="x in arrStatus" value="{{x.MaTinhTrang}}">{{x.TenTinhTrang}}</option></select></div><div class="col-sm-2" style="text-align: right;"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu bi\xEAn lai</label></div><div class="col-sm-4"><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=0" class="form-control"><option value="0">-- Ch\u1ECDn M\u1EABu bi\xEAn lai --</option><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtInvNumber" class="control-label">S\u1ED1 bi\xEAn lai</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" id="txtInvNumber" placeholder="S\u1ED1 bi\xEAn lai"></div><div class="col-sm-2" style="text-align: right;"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" id="txtInvSerialNo" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 tra c\u1EE9u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mRefNbr" ng-init="mRefNbr=\'\'" id="txtRefNbr" placeholder="M\xE3 tra c\u1EE9u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUserName" class="control-label">Ng\u01B0\u1EDDi l\u1EADp</label></div><div class="col-sm-4" ng-controller="SelectUserPageCtrl as ctrlUser"><ui-select focus-on="SetFocus" ng-model="User.selected" ng-change="selectUser(User.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.FullName}}</ui-select-match><ui-select-choices repeat="User in Users | filter: $select.search"><span ng-bind-html="User.FullName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="cboTypeOfRevenue" class="control-label">Lo\u1EA1i thu</label></div><div class="col-sm-4"><select id="cboTypeOfRevenue" ng-model="mTypeOfRevenueID" ng-init="mTypeOfRevenueID=\'0\'" class="form-control"><option value="0">-- Ch\u1ECDn Lo\u1EA1i thu --</option><option ng-repeat="x in arrTypeOfRevenue" value="{{x.ID}}">{{x.typeOfRevenueName}}</option></select></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateBienLai()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 ti\u1EC1n / Danh s\xE1ch: <span style="color:yellow">{{mTotalAmount}} / {{mTotalList}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="InvNumber">S\u1ED1 bi\xEAn lai</th><th st-sort="RefDate">Ng\xE0y bi\xEAn lai</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="CustomerName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="RefNbr">M\xE3 tra c\u1EE9u</th><th st-sort="TotalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">BL \u0110T</td><td class="text-center">Copy</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditBienLai(item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.CustomerName}}</td><td>{{item.RefNbr}}</td><td>{{item.TotalAmount}}</td><td>{{item.StatusName}}</td><td class="text-center"><div ng-if="item.FileHoaDon != \'\'"><a href="" title="In bi\xEAn lai" ng-click="GetFileSigned(item.ID, item.InvNumber, item.RefNbr)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div><a href="" title="Copy cho l\u1EADp m\u1EDBi" ng-click="CreateBienLai_ByCopy(item.ID)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-erase"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/BienLaiToKhai/CreateBienLai.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateBienLaiCtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtRefDate" class="control-label">Ng\xE0y bi\xEAn lai</label> <input type="date" readonly="" id="txtRefDate" ng-model="mRefDate" class="form-control"></div><div class="col-sm-2"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu bi\xEAn lai (<b style="color:red;">*</b>)</label><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=\'\'" ng-disabled="disable_MauBienLai" ng-change="cboInvoiceTemplate_SelectedChangeEvent()" class="form-control"><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div><div class="col-sm-2"><label for="txtInvFormNo" class="control-label">M\u1EABu s\u1ED1</label> <input type="text" readonly="" id="txtInvFormNo" ng-model="mInvFormNo" ng-init="mInvFormNo=\'\'" class="form-control" placeholder="M\u1EABu s\u1ED1"></div><div class="col-sm-2"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtInvSerialNo" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtInvNumber" class="control-label">S\u1ED1 bi\xEAn lai</label> <input type="text" readonly="" id="txtInvNumber" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" class="form-control" placeholder="S\u1ED1 bi\xEAn lai"></div></div><div class="form-group"><div class="col-sm-6 col-md-offset-1"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label> <input type="text" id="txtCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" class="form-control" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2"><label for="txtTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="txtTaxCode" ng-model="mTaxCode" ng-init="mTaxCode=\'\'" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2"><label for="txtRefNbr" class="control-label">M\xE3 tra c\u1EE9u</label> <input type="text" readonly="" id="txtRefNbr" ng-model="mRefNbr" ng-init="mRefNbr=\'\'" class="form-control" placeholder="M\xE3 tra c\u1EE9u"></div></div><div class="form-group"><div class="col-sm-8 col-md-offset-1"><label for="txtAddress" class="control-label">\u0110\u1ECBa ch\u1EC9</label> <input type="text" id="txtAddress" ng-model="mAddress" ng-init="mAddress=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9"></div><div class="col-sm-2"><label for="cboTypeOfPayment" class="control-label">HTTT</label><select id="cboTypeOfPayment" ng-model="mTypeOfPaymentID" ng-init="mTypeOfPaymentID=\'\'" class="form-control" placeholder="HTTT"><option ng-repeat="x in arrTypeOfPayment" value="{{x.ID}}">{{x.typeOfPaymentName}}</option></select></div></div><div class="form-group"><div class="col-sm-8 col-md-offset-1"><label for="cboTypeOfRevenue" class="control-label">Lo\u1EA1i ph\xED, l\u1EC7 ph\xED (<b style="color:red;">*</b>)</label><select id="cboTypeOfRevenue" ng-model="mTypeOfRevenueID" ng-init="mTypeOfRevenueID=\'\'" class="form-control" placeholder="Lo\u1EA1i ph\xED, l\u1EC7 ph\xED"><option ng-repeat="x in arrTypeOfRevenue" value="{{x.ID}}">{{x.typeOfRevenueName}}</option></select></div><div class="col-sm-2"><label for="txtTotalAmount" class="control-label">S\u1ED1 ti\u1EC1n (<b style="color:red;">*</b>)</label> <input type="text" maxlength="12" class="form-control" number-input="" id="txtTotalAmount" ng-model="mTotalAmount" ng-init="mTotalAmount=\'\'"></div></div><div class="form-group"><div class="col-sm-10 col-md-offset-1"><label for="txtDescr" class="control-label">Ghi ch\xFA</label> <input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'\'" class="form-control" placeholder="Ghi ch\xFA"></div></div></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-if="disable_MauBienLai" ng-click="Review()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-show="IsPublic" ng-click="PublishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t bi\xEAn lai</button> <button type="button" ng-click="BackPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/BienLaiToKhai/CreateToKhaiThueTNCN.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateToKhaiThueTNCNCtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtRefDate" class="control-label">Ng\xE0y t\u1EDD khai</label> <input type="date" readonly="" id="txtRefDate" ng-model="mRefDate" class="form-control"></div><div class="col-sm-2"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu t\u1EDD khai (<b style="color:red;">*</b>)</label><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=\'\'" ng-disabled="disable_MauToKhai" ng-change="cboInvoiceTemplate_SelectedChangeEvent()" class="form-control"><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div><div class="col-sm-2"><label for="txtInvFormNo" class="control-label">M\u1EABu s\u1ED1</label> <input type="text" readonly="" id="txtInvFormNo" ng-model="mInvFormNo" ng-init="mInvFormNo=\'\'" class="form-control" placeholder="M\u1EABu s\u1ED1"></div><div class="col-sm-2"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtInvSerialNo" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtInvNumber" class="control-label">S\u1ED1 t\u1EDD khai</label> <input type="text" readonly="" id="txtInvNumber" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" class="form-control" placeholder="S\u1ED1 t\u1EDD khai"></div></div><div class="form-group"><div class="col-sm-6 col-md-offset-1"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn (<b style="color:red;">*</b>)</label> <input type="text" id="txtCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" class="form-control" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2"><label for="txtTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="txtTaxCode" ng-model="mTaxCode" ng-init="mTaxCode=\'\'" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2"><label for="txtRefNbr" class="control-label">M\xE3 tra c\u1EE9u</label> <input type="text" readonly="" id="txtRefNbr" ng-model="mRefNbr" ng-init="mRefNbr=\'\'" class="form-control" placeholder="M\xE3 tra c\u1EE9u"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtNationality" class="control-label">Qu\u1ED1c t\u1ECBch (<b style="color:red;">*</b>)</label> <input type="text" id="txtNationality" ng-model="mNationality" ng-init="mNationality=\'Vi\u1EC7t Nam\'" class="form-control" placeholder="Qu\u1ED1c t\u1ECBch"></div><div class="col-sm-2" style="text-align: center;"><label for="txtIsResident" class="control-label">C\xE1 nh\xE2n c\u01B0 tr\xFA</label> <input style="width: 2rem;margin: auto;" type="checkbox" id="txtIsResident" ng-model="mIsResident" ng-checked="true" class="form-control"></div><div class="col-sm-6"><label for="txtAddress" class="control-label">\u0110\u1ECBa ch\u1EC9/\u0111i\u1EC7n tho\u1EA1i</label> <input type="text" id="txtAddress" ng-model="mAddress" ng-init="mAddress=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9/\u0111i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtPassportNumber" class="control-label">CMND/CCCD (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="txtPassportNumber" ng-model="mPassportNumber" maxlength="12" ng-init="mPassportNumber=\'\'" placeholder="CMND"></div><div class="col-sm-2"><label for="txtDateOfIssue" class="control-label">Ng\xE0y c\u1EA5p (<b style="color:red;">*</b>)</label> <input type="date" id="txtDateOfIssue" ng-model="mDateOfIssue" class="form-control"></div><div class="col-sm-6"><label for="txtPlaceOfIssue" class="control-label">N\u01A1i c\u1EA5p (<b style="color:red;">*</b>)</label> <input type="text" id="txtPlaceOfIssue" ng-model="mPlaceOfIssue" ng-init="mPlaceOfIssue=\'\'" class="form-control" placeholder="N\u01A1i c\u1EA5p"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="txtFromDate" ng-model="mFromDate" ng-init="mFromDate=\'\'" class="form-control"></div><div class="col-sm-2"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="txtToDate" ng-model="mToDate" ng-init="mToDate=\'\'" class="form-control"></div><div class="col-sm-6"><label for="txtDescr" class="control-label">Kho\u1EA3n thu nh\u1EADp (<b style="color:red;">*</b>)</label> <input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'Ti\u1EC1n c\xF4ng, ti\u1EC1n l\u01B0\u01A1ng\'" class="form-control" placeholder="Kho\u1EA3n thu nh\u1EADp"></div></div><div class="form-group"><div class="col-sm-3 col-md-offset-1"><label for="txtTotalIncomeAmount" class="control-label">Thu nh\u1EADp ch\u1ECBu thu\u1EBF (<b style="color:red;">*</b>)</label> <input type="text" maxlength="12" class="form-control" number-input="" id="txtTotalIncomeAmount" ng-model="mTotalIncomeAmount" ng-init="mTotalIncomeAmount=\'\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-3"><label for="txtTotalTaxAmount" class="control-label">Thu\u1EBF TNCN \u0111\xE3 kh\u1EA5u tr\u1EEB (<b style="color:red;">*</b>)</label> <input type="text" maxlength="12" class="form-control" number-input="" id="txtTotalTaxAmount" ng-model="mTotalTaxAmount" ng-init="mTotalTaxAmount=\'\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-3"><label for="txtTotalAmount" class="control-label">TNCN c\xF2n \u0111\u01B0\u1EE3c nh\u1EADn (<b style="color:red;">*</b>)</label> <input type="text" maxlength="12" class="form-control" number-input="" id="txtTotalAmount" ng-model="mTotalAmount" ng-init="mTotalAmount=\'\'"></div></div></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-click="Review()" ng-show="IsPublic" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button><button type="button" ng-show="IsPublic" ng-click="PublishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t t\u1EDD khai</button> <button type="button" ng-click="BackPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/BienLaiToKhai/ToKhaiThueTNCN.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="ToKhaiThueTNCNCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="cboStatus" class="control-label">T\xECnh tr\u1EA1ng t\u1EDD khai</label></div><div class="col-sm-4"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in arrStatus | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu t\u1EDD khai</label></div><div class="col-sm-4"><ui-select ng-model="Templates.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="Templates in arrInvoiceTemplate | filter: $select.search"><span ng-bind-html="Templates.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtInvNumber" class="control-label">S\u1ED1 t\u1EDD khai</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" id="txtInvNumber" placeholder="S\u1ED1 t\u1EDD khai"></div><div class="col-sm-2" style="text-align: right;"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" id="txtInvSerialNo" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 tra c\u1EE9u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mRefNbr" ng-init="mRefNbr=\'\'" id="txtRefNbr" placeholder="M\xE3 tra c\u1EE9u"></div></div></div><div class="form-group" style="text-align:center"><label><span style="color:yellow">(L\u01B0u \xFD: \u0110\u1EC3 k\xFD t\u1EDD khai thu\u1EBF TNCN c\u1EA7n ph\u1EA3i ki\u1EC3m tra USB Token \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EAFn v\xE0o m\xE1y v\xE0 ch\u1EA1y Service k\xFD s\u1ED1 m\u1EDBi nh\u1EA5t</span><br><span style="color:yellow">n\u1EBFu ch\u01B0a c\xF3 vui l\xF2ng nh\u1EA5n v\xE0o n\xFAt "Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1" \u0111\u1EC3 t\u1EA3i v\u1EC1 !!! )</span></label></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateToKhaiThueTNCN()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" title="T\u1EA3i ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 ti\u1EC1n / Danh s\xE1ch: <span style="color:yellow">{{mTotalAmount}} / {{mTotalList}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="InvNumber">S\u1ED1 t\u1EDD khai</th><th st-sort="RefDate">Ng\xE0y t\u1EDD khai</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="CustomerName">H\u1ECD v\xE0 t\xEAn</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="RefNbr">M\xE3 tra c\u1EE9u</th><th st-sort="TotalIncomeAmount">Thu nh\u1EADp</th><th st-sort="TotalTaxAmount">Thu\u1EBF TNCN</th><th st-sort="TotalAmount">C\xF2n nh\u1EADn</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">TK \u0110T</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditToKhaiThueTNCN(item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.CustomerName}}</td><td>{{item.TaxCode}}</td><td>{{item.RefNbr}}</td><td>{{item.TotalIncomeAmount}}</td><td>{{item.TotalTaxAmount}}</td><td>{{item.TotalAmount}}</td><td>{{item.StatusName}}</td><td class="text-center"><div ng-if="item.FileHoaDon != \'\'"><a href="" title="In bi\xEAn lai" ng-click="GetFileSigned(item.ID, item.InvNumber, item.RefNbr)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/checkInvoiceBook/checkInvoiceBook.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Ki\u1EC3m tra b\u1EA3ng k\xEA"><div class="panel-content" ng-controller="CheckInvoiceBookPageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCompanyName" id="inputCompanyName" placeholder="Kh\xE1ch h\xE0ng"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td>Chuy\u1EC3n duy\u1EC7t</td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>T\xECnh tr\u1EA1ng</th><th class="text-center">B\u1EA3ng k\xEA</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a ng-click="sendToApprove(item.ID)" href="" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-repeat"></span></a></td><td class="text-center">{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.companyName}}</td><td>{{item.totalAmount | currency:"":0}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileListDetail != \'\'"><a href="{{item.fileListDetail}}" target="_blank" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-th-list"></span></a></div><br><a href="" class="change-userpic" ng-click="uploadInvoiceBook(item.ID)">T\u1EA3i l\xEAn</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450/AdjustInvoice1450.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputBillNumber" ng-model="inputBillNumber"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputSymbol" ng-model="inputSymbol"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputDateOfInvoice" ng-model="inputDateOfInvoice"></div><div class="col-sm-2" style="text-align: right;"><label for="inputDateCreated" class="control-label">Ng\xE0y x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateCreated" id="inputDateCreated" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">H\xECnh th\u1EE9c x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-4" style="text-align: left; padding-left: 15px;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="DELETE"> <span>H\u1EE7y</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="ADJUST"> <span>\u0110i\u1EC1u ch\u1EC9nh</span></label></div><div class="col-md-4" ng-show="VIETINFO"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="TBSS"> <span>Gi\u1EA3i tr\xECnh</span></label></div></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">L\xFD do x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><textarea placeholder="L\xFD do x\u1EED l\xFD" class="form-control" id="inputDescription" ng-model="inputDescription"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isCreatInvoice" ng-click="changeInvoice()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi H\u0110</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic && GUITHUE == 0" ng-click="send2CQT()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-clipboard"></i>Th\xF4ng b\xE1o Thu\u1EBF</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPrint" ng-click="printDocument()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Bi\xEAn b\u1EA3n</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="printNotifycation()" class="btn btn-info btn-with-icon save-profile"><i class="ion-clipboard"></i>Xem tr\u01B0\u1EDBc TBSS</button><button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="sendEmailTBSS()" class="btn btn-info btn-with-icon save-profile"><i class="ion-email"></i>G\u1EEDi E-mail</button><button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="backPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450/EditInvoice1450.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="inputDateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputLoaiHoaDon">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusLoaiHoaDon" ng-model="LoaiHoaDon.selected" ng-change="changeLoaiHoaDon(LoaiHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDon in LoaiHoaDons | filter: $select.search"><span ng-bind-html="LoaiHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputHTHoaDon">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusHTHoaDon" ng-model="HTHoaDon.selected" ng-change="changeHTHoaDon(HTHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTHoaDon in HTHoaDons | filter: $select.search"><span ng-bind-html="HTHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputSymbol">K\xFD hi\u1EC7u</label> <input type="text" readonly="" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</label> <input type="text" readonly="" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-3"><div class="form-group"><label for="inputCustomerName">Ng\u01B0\u1EDDi mua</label> <input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputPhone">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</label> <input type="text" class="form-control" id="inputPhone" ng-model="inputPhone" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="col-sm-3"><div class="form-group"><label for="inputEmail">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" class="form-control" id="inputEmail" ng-model="inputEmail" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-10"><div class="form-group"><label for="inputCompanyCode" class="control-label">T\xEAn \u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label><div ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-8"><div class="form-group"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">H\xECnh th\u1EE9c thanh to\xE1n</label><div><ui-select focus-on="SetFocusHTTT" ng-model="HTTT.selected" ng-change="changeHTTT(HTTT.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTTT in HTTTs | filter: $select.search"><span ng-bind-html="HTTT.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="form-horizontal"><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><textarea style="height: 50px;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><textarea style="height: 50px;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><textarea style="height: 50px;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-if="DEBUG_MODE == false" ng-disabled="IsDisabled" ng-show="isReview" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/Invoice1450\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450/Invoice1450.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="Invoice1450Ctrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div class="form-group" style="text-align: center;"><label><span style="color:yellow">(L\u01B0u \xFD: c\u1EA7n ph\u1EA3i ki\u1EC3m tra USB Token \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EAFn v\xE0o m\xE1y v\xE0 ch\u1EA1y Service k\xFD s\u1ED1 m\u1EDBi nh\u1EA5t theo TT78, n\u1EBFu ch\u01B0a c\xF3 vui l\xF2ng nh\u1EA5n v\xE0o n\xFAt "Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1" \u0111\u1EC3 t\u1EA3i v\u1EC1!!!)</span></label></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="createInvoice()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" title="T\u1EA3i ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mainCtrl.TotalAmount}} / {{mainCtrl.TotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">Nh\u1EADn KQ</td><td class="text-center">H\xF3a \u0111\u01A1n</td><td class="text-center" ng-if="DEBUG_MODE == false">Th\u1EC3 hi\u1EC7n</td><td class="text-center" ng-if="DEBUG_MODE == false">Chuy\u1EC3n \u0111\u1ED5i</td><td class="text-center" ng-if="DEBUG_MODE == false">G\u1EEDi Email</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.statusCode == \'LAPMOI\'"><a ng-show="item.TinhChatHoaDonLQ == \'\'" title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/NewInvoice1450\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td class="text-center"><div ng-if="item.statusCode != \'DUYET\' && item.statusCode != \'SAISOT\' && item.statusCode != \'CHOPHANHOI\' && item.statusCode != \'DIEUCHINH\' && item.dateOfInvoice == checkDate"><span style="color:yellow">{{("00000000"+item.billNumber).slice(-8)}}</span></div><div ng-if="item.statusCode == \'DUYET\' || item.statusCode == \'SAISOT\' || item.statusCode == \'CHOPHANHOI\' || item.statusCode == \'DIEUCHINH\' || item.dateOfInvoice != checkDate">{{("00000000"+item.billNumber).slice(-8)}}</div></td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="( item.statusCode == \'CHOPHANHOI\' || item.statusCode == \'CHOKETQUA\')"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileHoaDon(item.FileHoaDon, item.MaSoThueBan, item.symbol, item.billNumber)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\' && DEBUG_MODE == false"><a href="" ng-disabled="OpenFile" ng-click="GetBanTheHien(item.ID, item.MaSoThueBan, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\' && DEBUG_MODE == false && item.HUY == false"><a href="" ng-disabled="OpenFile" ng-click="GetChuyenDoi(item.ID, item.MaSoThueBan, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\' && DEBUG_MODE == false && item.HUY == false"><a href="" ng-disabled="OpenFile" ng-click="GuiEmail(item.ID,item.FileHoaDon, item.MaSoThueBan, item.symbol, item.billNumber)" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-send"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450/NewInvoice1450.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="inputDateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputLoaiHoaDon">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusLoaiHoaDon" ng-model="LoaiHoaDon.selected" ng-change="changeLoaiHoaDon(LoaiHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDon in LoaiHoaDons | filter: $select.search"><span ng-bind-html="LoaiHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputHTHoaDon">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusHTHoaDon" ng-model="HTHoaDon.selected" ng-change="changeHTHoaDon(HTHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTHoaDon in HTHoaDons | filter: $select.search"><span ng-bind-html="HTHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputSymbol">K\xFD hi\u1EC7u</label> <input type="text" readonly="" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</label> <input type="text" readonly="" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-3"><div class="form-group"><label for="inputCustomerName">Ng\u01B0\u1EDDi mua</label> <input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputPhone">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</label> <input type="text" class="form-control" id="inputPhone" ng-model="inputPhone" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="col-sm-3"><div class="form-group"><label for="inputEmail">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" class="form-control" id="inputEmail" ng-model="inputEmail" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-10"><div class="form-group"><label for="inputCompanyCode" class="control-label">T\xEAn \u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label><div ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-8"><div class="form-group"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">H\xECnh th\u1EE9c thanh to\xE1n</label><div><ui-select focus-on="SetFocusHTTT" ng-model="HTTT.selected" ng-change="changeHTTT(HTTT.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTTT in HTTTs | filter: $select.search"><span ng-bind-html="HTTT.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="CCCDan">CCCD</label> <input type="text" class="form-control" ng-model="CCCDan" id="CCCDan" placeholder="CCCD"></div></div><div class="col-sm-2"><div class="form-group"><label for="SHChieu">S\u1ED1 h\u1ED9 chi\u1EBFu</label> <input type="text" class="form-control" ng-model="SHChieu" id="SHChieu" placeholder="S\u1ED1 h\u1ED9 chi\u1EBFu"></div></div><div class="col-sm-4"><div class="form-group"><label for="MDVQHNSach">M\xE3 \u0110VQH ng\xE2n s\xE1ch</label> <input type="text" class="form-control" ng-model="MDVQHNSach" id="MDVQHNSach" placeholder="M\xE3 \u0111\u01A1n v\u1ECB quan h\u1EC7 ng\xE2n s\xE1ch"></div></div></div><div class="form-horizontal"><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td><td></td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><textarea style="height: 50px;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td><td style="width:1%;" ng-if="inputID1 !=undefined ||inputID1 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID1)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr><td style="width:5%;">2</td><td><textarea style="height: 50px;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td><td style="width:1%;" ng-if="inputID2 !=undefined ||inputID2 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID2)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td><td style="width:1%;" ng-if="inputID3 !=undefined ||inputID3 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID3)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">4</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription4" ng-model="inputDescription4"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName4" ng-model="inputUnitName4"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputQuantity4" ng-model="inputQuantity4"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputPrice4" ng-model="inputPrice4"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputVAT4" ng-model="inputVAT4"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount4" ng-model="inputVATAmount4"></td><td style="width:1%;" ng-if="inputID4 !=undefined ||inputID4 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID4)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">5</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription5" ng-model="inputDescription5"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName5" ng-model="inputUnitName5"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputQuantity5" ng-model="inputQuantity5"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputPrice5" ng-model="inputPrice5"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputVAT5" ng-model="inputVAT5"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount5" ng-model="inputVATAmount5"></td><td style="width:1%;" ng-if="inputID5 !=undefined ||inputID5 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID5)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">6</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription6" ng-model="inputDescription6"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName6" ng-model="inputUnitName6"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputQuantity6" ng-model="inputQuantity6"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputPrice6" ng-model="inputPrice6"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputVAT6" ng-model="inputVAT6"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount6" ng-model="inputVATAmount6"></td><td style="width:1%;" ng-if="inputID6 !=undefined ||inputID6 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID6)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">7</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription7" ng-model="inputDescription7"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName7" ng-model="inputUnitName7"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputQuantity7" ng-model="inputQuantity7"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputPrice7" ng-model="inputPrice7"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputVAT7" ng-model="inputVAT7"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount7" ng-model="inputVATAmount7"></td><td style="width:1%;" ng-if="inputID7 !=undefined ||inputID7 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID7)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">8</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription8" ng-model="inputDescription8"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName8" ng-model="inputUnitName8"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputQuantity8" ng-model="inputQuantity8"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputPrice8" ng-model="inputPrice8"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputVAT8" ng-model="inputVAT8"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount8" ng-model="inputVATAmount8"></td><td style="width:1%;" ng-if="inputID8 !=undefined ||inputID8 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID8)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">9</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription9" ng-model="inputDescription9"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName9" ng-model="inputUnitName9"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputQuantity9" ng-model="inputQuantity9"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputPrice9" ng-model="inputPrice9"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputVAT9" ng-model="inputVAT9"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount9" ng-model="inputVATAmount9"></td><td style="width:1%;" ng-if="inputID9 !=undefined ||inputID9 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID9)"><span class="glyphicon glyphicon-trash"></span></a></td></tr><tr class="editable-row"><td style="width:5%;">10</td><td><textarea style="height: 50px;" ng-readonly="checkEdit" class="form-control" id="inputDescription10" ng-model="inputDescription10"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName10" ng-model="inputUnitName10"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputQuantity10" ng-model="inputQuantity10"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputPrice10" ng-model="inputPrice10"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputVAT10" ng-model="inputVAT10"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount10" ng-model="inputVATAmount10"></td><td style="width:1%;" ng-if="inputID10 !=undefined ||inputID10 !=null"><a style="color: white;" title="X\xF3a d\u1EEF li\u1EC7u" href="" ng-click="delete(inputID10)"><span class="glyphicon glyphicon-trash"></span></a></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-if="DEBUG_MODE == false" ng-disabled="IsDisabled" ng-show="isReview" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/Invoice1450\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450/ReferenceInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="inputDateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputLoaiHoaDon">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusLoaiHoaDon" ng-model="LoaiHoaDon.selected" ng-change="changeLoaiHoaDon(LoaiHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDon in LoaiHoaDons | filter: $select.search"><span ng-bind-html="LoaiHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputHTHoaDon">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusHTHoaDon" ng-model="HTHoaDon.selected" ng-change="changeHTHoaDon(HTHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTHoaDon in HTHoaDons | filter: $select.search"><span ng-bind-html="HTHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputSymbol">K\xFD hi\u1EC7u</label> <input type="text" readonly="" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</label> <input type="text" readonly="" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-3"><div class="form-group"><label for="inputCustomerName">Ng\u01B0\u1EDDi mua</label> <input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputPhone">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</label> <input type="text" class="form-control" id="inputPhone" ng-model="inputPhone" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="col-sm-3"><div class="form-group"><label for="inputEmail">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" class="form-control" id="inputEmail" ng-model="inputEmail" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-10"><div class="form-group"><label for="inputCompanyCode" class="control-label">T\xEAn \u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label><div ng-controller="SelectCustomerPageCtrl as ctrl"><ui-select focus-on="SetFocusCustomer" ng-model="Customer.selected" ng-change="changeCustomer(Customer.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.customerName}}</ui-select-match><ui-select-choices repeat="Customer in Customers | filter: $select.search"><span ng-bind-html="Customer.customerName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-8"><div class="form-group"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTaxCode">H\xECnh th\u1EE9c thanh to\xE1n</label><div><ui-select focus-on="SetFocusHTTT" ng-model="HTTT.selected" ng-change="changeHTTT(HTTT.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTTT in HTTTs | filter: $select.search"><span ng-bind-html="HTTT.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-sm-1"><div class="form-group"><label class="control-label">H\xF3a \u0111\u01A1n li\xEAn quan</label></div></div><div class="col-sm-2"><div class="form-group"><label for="inputTinhChat">T\xEDnh ch\u1EA5t (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusTinhChat" ng-model="TinhChat.selected" ng-change="changeTinhChat(TinhChat.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="TinhChat in TinhChats | filter: $select.search"><span ng-bind-html="TinhChat.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-4"><div class="form-group"><label for="inputLoaiHoaDonLQ">Lo\u1EA1i h\xF3a \u0111\u01A1n LQ (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusLoaiHoaDonLQ" ng-model="LoaiHoaDonLQ.selected" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDonLQ in LoaiHoaDonLQs | filter: $select.search"><span ng-bind-html="LoaiHoaDonLQ.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-1"><div class="form-group"><label for="inputInvoiceTemplateCodeLQ">M\u1EABu s\u1ED1 (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" ng-blur="changeTinhChat(null)" ng-model="inputInvoiceTemplateCodeLQ" id="inputInvoiceTemplateCodeLQ" placeholder="M\u1EABu s\u1ED1"></div></div><div class="col-sm-1"><div class="form-group"><label for="inputSymbolLQ">K\xFD hi\u1EC7u (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" ng-blur="changeTinhChat(null)" ng-model="inputSymbolLQ" id="inputSymbolLQ" placeholder="K\xFD hi\u1EC7u"></div></div><div class="col-sm-1"><div class="form-group"><label for="inputBillNumberLQ">S\u1ED1 H\u0110 (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" ng-blur="changeTinhChat(null)" ng-model="inputBillNumberLQ" id="inputBillNumberLQ" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputDateOfInvoiceLQ">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-change="changeTinhChat(null)" ng-model="inputDateOfInvoiceLQ" id="inputDateOfInvoiceLQ" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="form-horizontal"><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><textarea style="height: 60px;" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><textarea style="height: 60px;" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><textarea style="height: 60px;" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-if="DEBUG_MODE == false" ng-disabled="IsDisabled" ng-show="isReview" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/Invoice1450\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450_TSCONG/Invoice1450_TSCONG.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="Invoice1450_TSCONGCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplate_TSCONGPageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputMedicalCode" class="control-label">M\xE3</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputMedicalCode" id="inputMedicalCode" placeholder="M\xE3"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUserName" class="control-label">Ng\u01B0\u1EDDi l\u1EADp</label></div><div class="col-sm-3" ng-controller="SelectUserPageCtrl as ctrlUser"><ui-select focus-on="SetFocus" ng-model="User.selected" ng-change="selectUser(User.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.FullName}}</ui-select-match><ui-select-choices repeat="User in Users | filter: $select.search"><span ng-bind-html="User.FullName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfRevenue" class="control-label">Lo\u1EA1i thu</label></div><div class="col-sm-3"><ui-select ng-model="TypeOfRevenue.selected" ng-change="selectTypeOfRevenue(TypeOfRevenue.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Ten}}</ui-select-match><ui-select-choices repeat="TypeOfRevenue in TypeOfRevenues | filter: $select.search"><span ng-bind-html="TypeOfRevenue.Ten | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="createInvoice()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50,100]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mainCtrl.TotalAmount}} / {{mainCtrl.TotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">Nh\u1EADn KQ</td><td class="text-center">H\xF3a \u0111\u01A1n</td><td class="text-center" ng-if="DEBUG_MODE == false">Th\u1EC3 hi\u1EC7n</td><td class="text-center" ng-if="DEBUG_MODE == false">Chuy\u1EC3n \u0111\u1ED5i</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.SUA == 1"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/NewInvoice1450_TSCONG\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td class="text-center">{{("00000000"+item.billNumber).slice(-8)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.medicalCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.NHANKETQUA == 1"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div><div ng-if="item.NHANKETQUA == 2 && item.FileHoaDon != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileKetQua(item.FileHoaDon, item.symbol, item.billNumber, item.dateOfInvoice)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileHoaDon(item.FileHoaDon, item.symbol, item.billNumber, item.dateOfInvoice)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\' && DEBUG_MODE == false"><a href="" ng-disabled="OpenFile" ng-click="GetBanTheHien(item.ID, item.symbol, item.billNumber, item.dateOfInvoice)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="(item.MaLoaiThongDiep == \'200\' || item.MaLoaiThongDiep == \'203\') && (item.FileHoaDon != \'\' && item.DaChuyenDoi == \'0\')"><a href="" ng-disabled="TaoFileCD" ng-click="TaoChuyenDoi(item.ID, item.symbol, item.billNumber, item.dateOfInvoice)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-export"></span></a></div><div ng-if="(item.MaLoaiThongDiep == \'200\' || item.MaLoaiThongDiep == \'203\') && item.FileHoaDon != \'\' && item.DaChuyenDoi == \'1\'"><a href="" ng-disabled="TaoFileCD" ng-click="TaoChuyenDoi(item.ID, item.symbol, item.billNumber, item.dateOfInvoice)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/Invoice1450_TSCONG/NewInvoice1450_TSCONG.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="inputDateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputLoaiHoaDon">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusLoaiHoaDon" ng-model="LoaiHoaDon.selected" ng-change="changeLoaiHoaDon(LoaiHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDon in LoaiHoaDons | filter: $select.search"><span ng-bind-html="LoaiHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputHTHoaDon">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><div><ui-select focus-on="SetFocusHTHoaDon" ng-model="HTHoaDon.selected" ng-change="changeHTHoaDon(HTHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkNew" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTHoaDon in HTHoaDons | filter: $select.search"><span ng-bind-html="HTHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-2"><div class="form-group"><label for="inputSymbol">K\xFD hi\u1EC7u</label> <input type="text" readonly="" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</label> <input type="text" readonly="" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="inputTaxCode">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" ng-change="LoadKhachHang(inputTaxCode)" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="col-sm-5"><div class="form-group"><label for="inputCustomerName">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplate_TSCONGPageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkEdit" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-offset-1 col-sm-7"><div class="form-group"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9</label> <input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="col-sm-3"><div class="form-group"><label for="NMuaSTKNHang">S\u1ED1 t\xE0i kho\u1EA3n</label> <input type="text" class="form-control" ng-model="NMuaSTKNHang" id="NMuaSTKNHang" placeholder="S\u1ED1 t\xE0i kho\u1EA3n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-5"><div class="form-group"><label for="inputCompanyName">T\xEAn \u0111\u01A1n v\u1ECB</label> <input type="text" class="form-control" ng-model="inputCompanyName" id="inputCompanyName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div><div class="col-sm-2"><div class="form-group"><label for="inputMedicalCode">M\xE3 tra c\u1EE9u (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="inputMedicalCode" ng-model="inputMedicalCode" placeholder="M\xE3 tra c\u1EE9u"></div></div><div class="col-sm-3"><div class="form-group"><label for="NMuaTNHang">T\xEAn ng\xE2n h\xE0ng</label> <input type="text" class="form-control" id="NMuaTNHang" ng-model="NMuaTNHang" placeholder="T\xEAn ng\xE2n h\xE0ng"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-5"><label for="inputTypeOfRevenue">Lo\u1EA1i doanh thu</label><ui-select focus-on="SetFocusTypeOfRevenue" ng-model="TypeOfRevenue.selected" ng-change="changeTypeOfRevenue(TypeOfRevenue.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfRevenueName}}</ui-select-match><ui-select-choices repeat="TypeOfRevenue in TypeOfRevenues | filter: $select.search"><span ng-bind-html="TypeOfRevenue.typeOfRevenueName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label for="inputTypeOfPayment">HTTT (<b style="color:red;">*</b>)</label><ui-select focus-on="SetFocusTypeOfPayment" ng-model="TypeOfPayment.selected" ng-change="changeTypeOfPayment(TypeOfPayment.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfPaymentName}}</ui-select-match><ui-select-choices repeat="TypeOfPayment in TypeOfPayments | filter: $select.search"><span ng-bind-html="TypeOfPayment.typeOfPaymentName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="row" style="margin-top: 1rem;"><div class="col-md-offset-1 col-sm-3"><div class="form-group"><label for="CQBHQDinh">C\u01A1 quan ban h\xE0nh quy\u1EBFt \u0111\u1ECBnh (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="CQBHQDinh" ng-model="CQBHQDinh" placeholder="C\u01A1 quan ban h\xE0nh quy\u1EBFt \u0111\u1ECBnh"></div></div><div class="col-sm-2"><div class="form-group"><label for="SQDinh">S\u1ED1 quy\u1EBFt \u0111\u1ECBnh b\xE1n (<b style="color:red;">*</b>)</label> <input type="text" class="form-control" id="SQDinh" ng-model="SQDinh" placeholder="S\u1ED1 quy\u1EBFt \u0111\u1ECBnh b\xE1n"></div></div><div class="col-sm-2"><div class="form-group"><label for="NQDinh">Ng\xE0y quy\u1EBFt \u0111\u1ECBnh (<b style="color:red;">*</b>)</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="NQDinh" id="NQDinh" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-3"><div class="form-group"><label for="HTBan">H\xECnh th\u1EE9c b\xE1n t\xE0i s\u1EA3n</label> <input type="text" class="form-control" id="HTBan" ng-model="HTBan" placeholder="H\xECnh th\u1EE9c b\xE1n t\xE0i s\u1EA3n"></div></div></div><div class="row"><div class="col-md-offset-1 col-sm-2"><div class="form-group"><label for="MUA_MDVQHNSach">M\xE3 \u0111\u01A1n v\u1ECB quan h\u1EC7 ng\xE2n s\xE1ch</label> <input type="text" class="form-control" id="MUA_MDVQHNSach" ng-model="MUA_MDVQHNSach" placeholder="M\xE3 \u0111\u01A1n v\u1ECB quan h\u1EC7 ng\xE2n s\xE1ch"></div></div><div class="col-sm-2"><div class="form-group"><label for="TGVCHDTu">Th\u1EDDi gian v\u1EADn chuy\u1EC3n h\xE0ng T\u1EEA</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="TGVCHDTu" id="TGVCHDTu" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-2"><div class="form-group"><label for="TGVCHDDen">Th\u1EDDi gian v\u1EADn chuy\u1EC3n h\xE0ng \u0110\u1EBEN</label><div ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="TGVCHDDen" id="TGVCHDDen" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-sm-4"><div class="form-group"><label for="DDVCHDen">\u0110\u1ECBa \u0111i\u1EC3m v\u1EADn chuy\u1EC3n h\xE0ng \u0111\u1EBFn</label> <input type="text" class="form-control" id="DDVCHDen" ng-model="DDVCHDen" placeholder="\u0110\u1ECBa \u0111i\u1EC3m v\u1EADn chuy\u1EC3n h\xE0ng \u0111\u1EBFn"></div></div></div><div class="row" style="margin-top: 1rem;"><div class="col-md-offset-1 col-sm-10"><input style="width:1.5rem;margin: auto;" ng-show="isPHCN" type="checkbox" ng-model="IsImportN" ng-click="ImportHoaDonN()" id="IsImportN" ng-checked="IsImportN"> <i ng-show="isPHCN" style="color:yellow;">T\xEDch ch\u1ECDn \u0111\u1EC3 Import t\u1EA1o nhi\u1EC1u h\xF3a \u0111\u01A1n./ N\u1EBFu Import "chi ti\u1EBFt h\xF3a \u0111\u01A1n" vui l\xF2ng kh\xF4ng t\xEDch ! L\u01B0u \xFD khi t\xEDch ch\u1ECDn !!!</i></div></div><div class="form-horizontal"><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label> &nbsp;&nbsp; <label class="col-sm-offset-5" style="text-align: right;">File chi ti\u1EBFt:</label> <span style="padding-right: 5px !important;"></span> <span ng-show="isHasFile"><label for="fileName"><b style="color:yellow">{{$root.fileTemplate}}</b></label> &nbsp; <a title="B\u1ECF file chi ti\u1EBFt" class="btn btn-danger btn-xs" href="" ng-click="removeFileInvoiceDetail()"><span class="glyphicon glyphicon-remove-circle"></span> B\u1ECF</a></span> <a ng-show="!checkEdit" href="" class="btn btn-info btn-xs" ng-click="uploadFileInvoiceDetail()"><span class="glyphicon glyphicon-upload"></span> T\u1EA3i l\xEAn</a> <span style="padding-right: 5px !important;"></span> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> <a title="File m\u1EABu chi ti\u1EBFt H\u0110" href="{{FileMauChiTiet}}" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-file"></span> File m\u1EABu</a><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>T\xEAn t\xE0i s\u1EA3n (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" number-input="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr class="editable-row"><td style="width:5%;">2</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr><tr class="editable-row"><td style="width:5%;">4</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription4" ng-model="inputDescription4"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName4" ng-model="inputUnitName4"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputQuantity4" ng-model="inputQuantity4"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputPrice4" ng-model="inputPrice4"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount4(inputPrice4, inputVAT4, inputQuantity4)" id="inputVAT4" ng-model="inputVAT4"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount4" ng-model="inputVATAmount4"></td></tr><tr class="editable-row"><td style="width:5%;">5</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription5" ng-model="inputDescription5"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName5" ng-model="inputUnitName5"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputQuantity5" ng-model="inputQuantity5"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputPrice5" ng-model="inputPrice5"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount5(inputPrice5, inputVAT5, inputQuantity5)" id="inputVAT5" ng-model="inputVAT5"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount5" ng-model="inputVATAmount5"></td></tr><tr class="editable-row"><td style="width:5%;">6</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription6" ng-model="inputDescription6"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName6" ng-model="inputUnitName6"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputQuantity6" ng-model="inputQuantity6"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputPrice6" ng-model="inputPrice6"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount6(inputPrice6, inputVAT6, inputQuantity6)" id="inputVAT6" ng-model="inputVAT6"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount6" ng-model="inputVATAmount6"></td></tr><tr class="editable-row"><td style="width:5%;">7</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription7" ng-model="inputDescription7"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName7" ng-model="inputUnitName7"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputQuantity7" ng-model="inputQuantity7"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputPrice7" ng-model="inputPrice7"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount7(inputPrice7, inputVAT7, inputQuantity7)" id="inputVAT7" ng-model="inputVAT7"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount7" ng-model="inputVATAmount7"></td></tr><tr class="editable-row"><td style="width:5%;">8</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription8" ng-model="inputDescription8"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName8" ng-model="inputUnitName8"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputQuantity8" ng-model="inputQuantity8"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputPrice8" ng-model="inputPrice8"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount8(inputPrice8, inputVAT8, inputQuantity8)" id="inputVAT8" ng-model="inputVAT8"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount8" ng-model="inputVATAmount8"></td></tr><tr class="editable-row"><td style="width:5%;">9</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription9" ng-model="inputDescription9"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName9" ng-model="inputUnitName9"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputQuantity9" ng-model="inputQuantity9"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputPrice9" ng-model="inputPrice9"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount9(inputPrice9, inputVAT9, inputQuantity9)" id="inputVAT9" ng-model="inputVAT9"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount9" ng-model="inputVATAmount9"></td></tr><tr class="editable-row"><td style="width:5%;">10</td><td><textarea style="height:40px ;" type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription10" ng-model="inputDescription10"></textarea></td><td style="width:10%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName10" ng-model="inputUnitName10"></td><td style="width:11%;"><input type="text" maxlength="9" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputQuantity10" ng-model="inputQuantity10"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" number-input="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputPrice10" ng-model="inputPrice10"></td><td style="width:7%;"><input ng-disabled="vatTSFalse" type="text" maxlength="3" ng-readonly="vatTSFalse" class="form-control" allow-only-numbers="" ng-blur="calVATAmount10(inputPrice10, inputVAT10, inputQuantity10)" id="inputVAT10" ng-model="inputVAT10"></td><td style="width:13%;"><input ng-disabled="vatTSFalse" type="text" ng-readonly="vatTSFalse" class="form-control" id="inputVATAmount10" ng-model="inputVATAmount10"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-if="DEBUG_MODE == false" ng-disabled="IsDisabled" ng-show="isReview" ng-click="reviewInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/Invoice1450_TSCONG\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/CreateDanhSachSaiSot.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateDanhSachSaiSotCtrl as mainCtrl"><div class="row"><div class="col-sm-2"><div class="form-group"><label for="txtRefDae" class="control-label">Ng\xE0y b\xE1o c\xE1o</label> <input type="date" id="txtRefDae" ng-model="mRefDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label> <input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label> <input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="cboTypeOfAction" class="control-label">Lo\u1EA1i sai s\xF3t</label><select id="cboTypeOfAction" ng-model="mTypeOfAction" ng-init="mTypeOfAction=\'\'" class="form-control"><option value="">-- Ch\u1ECDn Lo\u1EA1i sai s\xF3t --</option><option ng-repeat="x in arrTypeOfAction" value="{{x.ID}}">{{x.Name}}</option></select></div></div><div class="col-sm-2" ng-if="IsUnlock" style="top:2.3rem;"><div class="form-group"><button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div></div></div><div class="row"><div class="col-sm-10"><div class="form-group"><label for="txtDescr" class="control-label">Ghi ch\xFA</label> <input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'\'" class="form-control" placeholder="Ghi ch\xFA"></div></div></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-5 col-sm-5 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 h\xF3a \u0111\u01A1n / T\xECm ki\u1EBFm: <span style="color:yellow">{{mTotalInvoice}} / {{mTotalSearch}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="DateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="totalAmount">S\u1ED1 ti\u1EC1n</th><th st-sort="Description">L\xFD do</th><th st-sort="TypeOfActionName">Lo\u1EA1i x\u1EED l\xFD</th><th st-sort="MaTinhTrang">T\xECnh tr\u1EA1ng</th><th st-sort="NewSymbol">K\xFD hi\u1EC7u m\u1EDBi</th><th st-sort="NewBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n m\u1EDBi</th><th st-sort="NewDateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="NewTotalAmount">S\u1ED1 ti\u1EC1n</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td>{{item.DateAdjust}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.billNumber}}</td><td>{{item.totalAmount}}</td><td>{{item.Description}}</td><td>{{item.TypeOfActionName}}</td><td>{{item.MaTinhTrang}}</td><td>{{item.NewSymbol}}</td><td>{{item.NewBillNumber}}</td><td>{{item.NewDateOfInvoice}}</td><td>{{item.NewTotalAmount}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-if="!IsUnlock" ng-click="PrintThongBaoSaiSot()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-show="IsPublic" ng-click="PublishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh th\xF4ng b\xE1o</button> <button type="button" ng-click="BackPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/CreateHoaDonDieuChinh.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="CreateHoaDonDieuChinhCtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-md-offset-1 col-sm-2"><label for="txtOldDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n c\u0169</label> <input type="date" readonly="" id="txtOldDateOfInvoice" ng-model="mOldDateOfInvoice" class="form-control"></div><div class="col-sm-2"><label for="txtOldSymbol" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtOldSymbol" ng-model="mOldSymbol" ng-init="mOldSymbol=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtOldBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n c\u0169</label> <input type="text" readonly="" id="txtOldBillNumber" ng-model="mOldBillNumber" ng-init="mOldBillNumber=\'\'" class="form-control" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="top:2.4rem"><button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm h\xF3a \u0111\u01A1n</button></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-2"><label for="txtDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label> <input type="date" readonly="" id="txtDateOfInvoice" ng-model="mDateOfInvoice" class="form-control"></div><div class="col-sm-2"><label for="cboLoaiHoaDonCQT" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><select id="cboLoaiHoaDonCQT" ng-model="mLoaiHoaDonCQT" ng-init="mLoaiHoaDonCQT=\'\'" placeholder="Lo\u1EA1i h\xF3a \u0111\u01A1n" class="form-control"><option ng-repeat="x in arrLoaiHoaDonCQT" value="{{x.ID}}">{{x.Name}}</option></select></div><div class="col-sm-2"><label for="cboHinhThucHoaDon" class="control-label">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label><select id="cboHinhThucHoaDon" ng-model="mHinhThucHoaDon" placeholder="H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n" class="form-control"><option ng-repeat="x in arrHinhThucHoaDon" value="{{x.ID}}">{{x.Name}}</option></select></div><div class="col-sm-2"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtSymbol" ng-model="mSymbol" ng-init="mSymbol=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label> <input type="text" readonly="" id="txtBillNumber" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" class="form-control" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-2"><label for="txtTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label><input type="text" class="form-control" id="txtTaxCode" ng-model="mTaxCode" ng-init="mTaxCode=\'\'" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-4"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label> <input type="text" id="txtCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" class="form-control" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2"><label for="txtEmail" class="control-label">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" id="txtEmail" ng-model="mEmail" ng-init="mEmail=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div><div class="col-sm-2"><label for="inputTaxCode">H\xECnh th\u1EE9c thanh to\xE1n</label><ui-select focus-on="SetFocusHTTT" ng-model="HTTT.selected" ng-change="changeHTTT(HTTT.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HTTT in HTTTs | filter: $select.search"><span ng-bind-html="HTTT.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-10"><label for="txtCompanyName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label> <input type="text" id="txtCompanyName" ng-model="mCompanyName" ng-init="mCompanyName=\'\'" class="form-control" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-7"><label for="txtAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" id="txtAddress" ng-model="mAddress" ng-init="mAddress=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9"></div><div class="col-sm-3" ng-show="IsAdjust"><label for="cboLoaiDieuChinh" class="control-label">Lo\u1EA1i \u0111i\u1EC1u ch\u1EC9nh (<b style="color:red;">*</b>)</label><ui-select focus-on="cboLoaiDieuChinh" ng-model="LoaiDieuChinh.selected" ng-change="cboLoaiDieuChinh_SelectedChangeEvent(LoaiDieuChinh.selected)" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Lo\u1EA1i \u0111i\u1EC1u ch\u1EC9nh">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiDieuChinh in arrLoaiDieuChinh | filter: $select.search"><span ng-bind-html="LoaiDieuChinh.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-10"><label for="txtSaiSot_LyDo" class="control-label">L\xFD do x\u1EED l\xFD (<b style="color:red;">*</b>)</label> <textarea style="height: 35px;" id="txtSaiSot_LyDo" ng-model="mSaiSot_LyDo" ng-init="mSaiSot_LyDo=\'\'" class="form-control" placeholder="L\xFD do x\u1EED l\xFD"></textarea></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-5"><label for="txtSaiSot_ThongTinTruoc" class="control-label">N\u1ED9i dung c\u0169</label> <textarea style="height: 35px;" type="text" id="txtSaiSot_ThongTinTruoc" ng-model="mSaiSot_ThongTinTruoc" ng-init="mSaiSot_ThongTinTruoc=\'\'" class="form-control" placeholder="N\u1ED9i dung c\u0169"></textarea></div><div class="col-sm-5"><label for="txtSaiSot_ThongTinSau" class="control-label">N\u1ED9i dung m\u1EDBi</label> <textarea style="height: 35px;" id="txtSaiSot_ThongTinSau" ng-model="mSaiSot_ThongTinSau" ng-init="mSaiSot_ThongTinSau=\'\'" class="form-control" placeholder="N\u1ED9i dung m\u1EDBi"></textarea></div></div></div><div class="form-horizontal"><div class="horizontal-scroll"><label class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label> &nbsp;&nbsp;<table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><textarea style="height: 50px;" class="form-control" id="txtDescription1" ng-model="mDescription1" ng-init="mDescription1=\'\'"></textarea></td><td style="width:10%;"><input type="text" class="form-control" id="txtUnitName1" ng-model="mUnitName1" ng-init="mUnitName1=\'\'" ng-readonly="IsChinhThongTin"></td><td style="width:11%;"><input type="text" maxlength="9" class="form-control" number-input="" ng-blur="calVATAmount1(mPrice1, mVAT1, mQuantity1)" id="txtQuantity1" ng-model="mQuantity1" ng-readonly="IsChinhThongTin"></td><td style="width:14%;"><input type="text" class="form-control" number-input="" ng-blur="calVATAmount1(mPrice1, mVAT1, mQuantity1)" id="txtPrice1" ng-model="mPrice1" ng-readonly="IsChinhThongTin"></td><td style="width:7%;"><input type="text" maxlength="3" class="form-control" allow-only-numbers="" ng-blur="calVATAmount1(mPrice1, mVAT1, mQuantity1)" id="txtVAT1" ng-model="mVAT1" ng-readonly="IsChinhThongTin"></td><td style="width:13%;"><input type="text" class="form-control" number-input="" id="txtVATAmount1" ng-model="mVATAmount1" ng-readonly="IsChinhThongTin"></td></tr><tr><td style="width:5%;">2</td><td><textarea style="height: 50px;" type="text" class="form-control" id="txtDescription2" ng-model="mDescription2" ng-init="mDescription2=\'\'"></textarea></td><td style="width:10%;"><input type="text" class="form-control" id="txtUnitName2" ng-model="mUnitName2" ng-init="mUnitName2=\'\'" ng-readonly="IsChinhThongTin"></td><td style="width:11%;"><input type="text" maxlength="9" class="form-control" number-input="" ng-blur="calVATAmount2(mPrice2, mVAT2, mQuantity2)" id="txtQuantity2" ng-model="mQuantity2" ng-readonly="IsChinhThongTin"></td><td style="width:14%;"><input type="text" class="form-control" number-input="" ng-blur="calVATAmount2(mPrice2, mVAT2, mQuantity2)" id="txtPrice2" ng-model="mPrice2" ng-readonly="IsChinhThongTin"></td><td style="width:7%;"><input type="text" maxlength="3" class="form-control" allow-only-numbers="" ng-blur="calVATAmount2(mPrice2, mVAT2, mQuantity2)" id="txtVAT2" ng-model="mVAT2" ng-readonly="IsChinhThongTin"></td><td style="width:13%;"><input type="text" class="form-control" number-input="" id="txtVATAmount2" ng-model="mVATAmount2" ng-readonly="IsChinhThongTin"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><textarea style="height: 50px;" class="form-control" id="txtDescription3" ng-model="mDescription3" ng-init="mDescription3=\'\'"></textarea></td><td style="width:10%;"><input type="text" class="form-control" id="txtUnitName3" ng-model="mUnitName3" ng-init="mUnitName3=\'\'" ng-readonly="IsChinhThongTin"></td><td style="width:11%;"><input type="text" maxlength="9" class="form-control" number-input="" ng-blur="calVATAmount3(mPrice3, mVAT3, mQuantity3)" id="txtQuantity3" ng-model="mQuantity3" ng-readonly="IsChinhThongTin"></td><td style="width:14%;"><input type="text" class="form-control" number-input="" ng-blur="calVATAmount3(mPrice3, mVAT3, mQuantity3)" id="txtPrice3" ng-model="mPrice3" ng-readonly="IsChinhThongTin"></td><td style="width:7%;"><input type="text" maxlength="3" class="form-control" allow-only-numbers="" ng-blur="calVATAmount3(mPrice3, mVAT3, mQuantity3)" id="txtVAT3" ng-model="mVAT3" ng-readonly="IsChinhThongTin"></td><td style="width:13%;"><input type="text" class="form-control" number-input="" id="txtVATAmount3" ng-model="mVATAmount3" ng-readonly="IsChinhThongTin"></td></tr></table></div><br><div class="form-group" hidden=""><div class="col-sm-2" style="text-align: right;"><label for="txtDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><input type="text" id="txtDescription" ng-model="mDescription" ng-init="mDescription=\'\'" placeholder="Ghi ch\xFA" class="form-control"></div></div></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-show="IsPublic" ng-click="PublishBienBan()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh bi\xEAn b\u1EA3n</button> <button type="button" ui-sref="main.electricInvoice.HoaDon{{mModule}}" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/CreateHuyHoaDon.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateHuyHoaDonCtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="txtBillNumber" ng-model="mBillNumber" ng-init="mBillNumber=\'\'"></div><div class="col-sm-2" style="text-align: right;"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="txtSymbol" ng-model="mSymbol" ng-init="mSymbol=\'\'"></div><div class="col-sm-2" ng-show="!checkEdit"><button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm h\xF3a \u0111\u01A1n</button></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="date" id="txtDateOfInvoice" ng-model="mDateOfInvoice" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" readonly="" class="form-control" id="txtCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtDateAdjust" class="control-label">Ng\xE0y h\u1EE7y (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="date" id="txtDateAdjust" ng-model="mDateAdjust" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtTotalAmount" class="control-label">S\u1ED1 ti\u1EC1n</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" number-input="" id="txtTotalAmount" ng-model="mTotalAmount" ng-init="mTotalAmount=0"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtDescription" class="control-label">L\xFD do h\u1EE7y (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><textarea placeholder="L\xFD do x\u1EED l\xFD" class="form-control" id="txtDescription" ng-model="mDescription" ng-init="mDescription=\'\'"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-show="IsPublic" ng-click="PublishBienBan()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh bi\xEAn b\u1EA3n</button> <button type="button" ng-click="backPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/DanhSachSaiSot.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="DanhSachSaiSotCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="cboTypeOfAction" class="control-label">Lo\u1EA1i sai s\xF3t</label></div><div class="col-sm-4"><ui-select ng-model="TypeOfAction.selected" ng-change="selectChangedInvoiceTemplate(TypeOfAction.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="TypeOfAction in arrTypeOfAction | filter: $select.search"><span ng-bind-html="TypeOfAction.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="txtDescr" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-4"><input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'\'" class="form-control" placeholder="Ghi ch\xFA"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateDanhSachSaiSot()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 h\xF3a \u0111\u01A1n / Danh s\xE1ch: <span style="color:yellow">{{mTotalInvoice}} / {{mTotalList}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="RefDate">Ng\xE0y l\u1EADp</th><th st-sort="FromDate">T\u1EEB ng\xE0y</th><th st-sort="ToDate">\u0110\u1EBFn ng\xE0y</th><th st-sort="QuantityInvoice">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="Descr">Ghi ch\xFA</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">Nh\u1EADn KQ</td><td class="text-center">XML k\u1EBFt qu\u1EA3</td><td class="text-center">TBSS</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditDanhSachSaiSot(item.QD1450_SAISOT_ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.RefDate}}</td><td>{{item.FromDate}}</td><td>{{item.ToDate}}</td><td>{{item.QuantityInvoice}}</td><td>{{item.Descr}}</td><td>{{item.StatusName}}</td><td class="text-center"><div ng-if="item.NhanKetQua == 1"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div><div ng-if="item.NHANKETQUA == 2 && item.FileHoaDonXMLCQT != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileSigned(item.FileHoaDonXMLCQT, item.RefNbr, item.RefDate)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDonXML != \'\'"><a href="" ng-click="GetFileSigned(item.FileHoaDonXML, item.RefNbr, item.RefDate)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div><a href="" title="In th\xF4ng b\xE1o sai s\xF3t" ng-click="PrintThongBaoSaiSot(item.QD1450_SAISOT_ID,item.RefNbr)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/HoaDonDieuChinh.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="HoaDonDieuChinhCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="txtBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="txtSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="txtMedicalCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mMedicalCode" ng-init="mMedicalCode=\'\'" id="txtMedicalCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div class="form-group" style="text-align:center"><label><span style="color:yellow">(L\u01B0u \xFD: \u0110\u1EC3 k\xFD file bi\xEAn b\u1EA3n c\u1EA7n ph\u1EA3i ki\u1EC3m tra USB Token \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EAFn v\xE0o m\xE1y v\xE0 ch\u1EA1y Service k\xFD s\u1ED1 m\u1EDBi nh\u1EA5t theo TT78</span><br><span style="color:yellow">n\u1EBFu ch\u01B0a c\xF3 vui l\xF2ng nh\u1EA5n v\xE0o n\xFAt "Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1" \u0111\u1EC3 t\u1EA3i v\u1EC1 !!! )</span></label></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateHoaDonDieuChinh()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" title="T\u1EA3i ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mTotalAmount}} / {{mTotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="dateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="NewBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="NewSymbol">K\xFD hi\u1EC7u</th><th st-sort="NewTotalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>Xem tr\u01B0\u1EDBc</th><th>Bi\xEAn b\u1EA3n</th><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n c\u0169</th><th st-sort="dateOfInvoice">Ng\xE0y c\u0169</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n c\u0169</th><th>E-mail</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><div ng-if="item.SUA == 1"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditHoaDonDieuChinh(item.QD1450_HOADON_THAYDOI_ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.dateAdjust}}</td><td>{{("00000000"+item.NewBillNumber).slice(-8)}}</td><td>{{item.NewSymbol}}</td><td>{{item.NewTotalAmount}}</td><td class="text-center"><div><a href="" ng-click="ReviewBienBan(item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-click="GetFileSigned(item.FileBienBan, item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td>{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-disabled="IsDisabled" ng-click="sendEmailTBSS(item.FileBienBan,item.QD1450_HOADON_THAYDOI_ID)"><i style="font-size:3rem ;" class="ion-email"></i></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/HoaDonThayThe.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="HoaDonThayTheCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="cboStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><select id="cboStatus" ng-model="mStatusCode" ng-init="mStatusCode=\'\'" class="form-control"><option value="">-- Ch\u1ECDn t\xECnh tr\u1EA1ng --</option><option ng-repeat="x in arrStatus" value="{{x.MaTinhTrang}}">{{x.TenTinhTrang}}</option></select></div><div class="col-sm-2" style="text-align: right;"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=0" class="form-control"><option value="0">-- Ch\u1ECDn M\u1EABu h\xF3a \u0111\u01A1n --</option><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="txtBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="txtSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="txtMedicalCode" class="control-label">M\xE3 y t\u1EBF</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mMedicalCode" ng-init="mMedicalCode=\'\'" id="txtMedicalCode" placeholder="M\xE3 y t\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUserName" class="control-label">Ng\u01B0\u1EDDi l\u1EADp</label></div><div class="col-sm-4" ng-controller="SelectUserPageCtrl as ctrlUser"><ui-select focus-on="SetFocus" ng-model="User.selected" ng-change="selectUser(User.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.FullName}}</ui-select-match><ui-select-choices repeat="User in Users | filter: $select.search"><span ng-bind-html="User.FullName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="cboTypeOfRevenue" class="control-label">Lo\u1EA1i thu</label></div><div class="col-sm-4"><select id="cboTypeOfRevenue" ng-model="mTypeOfRevenueCode" ng-init="mTypeOfRevenueCode=\'%\'" class="form-control"><option value="%">-- Ch\u1ECDn Lo\u1EA1i thu --</option><option ng-repeat="x in arrTypeOfRevenue" value="{{x.LoaiThu}}">{{x.Ten}}</option></select></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateHoaDonDieuChinh()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mTotalAmount}} / {{mTotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="dateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="NewBillNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="NewSymbol">K\xFD hi\u1EC7u</th><th st-sort="NewTotalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>Xem tr\u01B0\u1EDBc</th><th>Bi\xEAn b\u1EA3n</th><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n c\u0169</th><th st-sort="dateOfInvoice">Ng\xE0y c\u0169</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 y t\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n c\u0169</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><div ng-if="item.SUA == 1"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditHoaDonDieuChinh(item.QD1450_HOADON_THAYDOI_ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.dateAdjust}}</td><td>{{("00000000"+item.NewBillNumber).slice(-8)}}</td><td>{{item.NewSymbol}}</td><td>{{item.NewTotalAmount}}</td><td class="text-center"><div><a href="" ng-click="ReviewBienBan(item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-click="GetFileSigned(item.FileBienBan, item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td>{{("00000000"+item.billNumber).slice(-8)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.medicalCode}}</td><td>{{item.totalAmount}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/HuyHoaDon.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="HuyHoaDonCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" placeholder="mm/dd/yyyy" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="txtBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="txtSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="txtMedicalCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mMedicalCode" ng-init="mMedicalCode=\'\'" id="txtMedicalCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div class="form-group" style="text-align:center"><label><span style="color:yellow">(L\u01B0u \xFD: \u0110\u1EC3 k\xFD file bi\xEAn b\u1EA3n c\u1EA7n ph\u1EA3i ki\u1EC3m tra USB Token \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EAFn v\xE0o m\xE1y v\xE0 ch\u1EA1y Service k\xFD s\u1ED1 m\u1EDBi nh\u1EA5t theo TT78</span><br><span style="color:yellow">n\u1EBFu ch\u01B0a c\xF3 vui l\xF2ng nh\u1EA5n v\xE0o n\xFAt "Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1" \u0111\u1EC3 t\u1EA3i v\u1EC1 !!! )</span></label></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateHuyHoaDon()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" title="T\u1EA3i ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mTotalAmount}} / {{mTotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="dateAdjust">Ng\xE0y h\u1EE7y</th><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>Xem tr\u01B0\u1EDBc</th><th>Bi\xEAn b\u1EA3n</th><th>E-Mail</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditHuyHoaDon(item.QD1450_HOADON_THAYDOI_ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.dateAdjust}}</td><td>{{("00000000"+item.billNumber).slice(-8)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td class="text-center"><div><a href="" ng-click="ReviewBienBan(item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-click="GetFileSigned(item.FileBienBan, item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-disabled="IsDisabled" ng-click="sendEmailTBSS(item.FileBienBan,item.QD1450_HOADON_THAYDOI_ID,item.symbol, item.billNumber)"><i style="font-size:3rem ;" class="ion-email"></i></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/HoaDonThayDoi/SearchHoaDon.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="SearchHoaDonCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="txtBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="txtSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="txtSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="txtMedicalCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="mMedicalCode" ng-init="mMedicalCode=\'\'" id="txtMedicalCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group" hidden=""><div class="col-sm-2" style="text-align: right;"><label for="cboStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-4"><select id="cboStatus" ng-model="mStatusCode" ng-init="mStatusCode=\'\'" class="form-control"><option value="">-- Ch\u1ECDn t\xECnh tr\u1EA1ng --</option><option ng-repeat="x in arrStatus" value="{{x.MaTinhTrang}}">{{x.TenTinhTrang}}</option></select></div><div class="col-sm-2" style="text-align: right;"><label for="cboTypeOfRevenue" class="control-label">Lo\u1EA1i thu</label></div><div class="col-sm-4"><select id="cboTypeOfRevenue" ng-model="mTypeOfRevenueCode" ng-init="mTypeOfRevenueCode=\'%\'" class="form-control"><option value="%">-- Ch\u1ECDn Lo\u1EA1i thu --</option><option ng-repeat="x in arrTypeOfRevenue" value="{{x.LoaiThu}}">{{x.Ten}}</option></select></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="backPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1ECDn h\xF3a \u0111\u01A1n" class="btn btn-primary btn-xs" href="" ng-click="ReturnParent(item.QD1450_HOADON_ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoicePublicTotal/invoicePublicTotal.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Danh s\xE1ch h\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED"><div class="panel-content" ng-controller="InvoicePublicTotalPageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectStatusPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChanged(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChanged(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateCode}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateCode | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th st-sort="customerName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>T\xECnh tr\u1EA1ng</th><th class="text-center">H\xF3a \u0111\u01A1n</th><th class="text-center">B\u1EA3ng k\xEA</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="X\u1EED l\xFD h\xF3a \u0111\u01A1n" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/editInvoiceMain\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td class="text-center">{{item.billNumber}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.customerName}}</td><td>{{item.totalAmount | currency:"":0}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td class="text-center"><div ng-if="item.fileListDetail != \'\'"><a href="{{item.fileListDetail}}" target="_blank" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-th-list"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceApproved/invoiceApproved.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="InvoiceApprovedPageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectStatusByApprovedPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChangedStatus(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputMedicalCode" class="control-label">M\xE3 y t\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputMedicalCode" id="inputMedicalCode" placeholder="M\xE3 y t\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" title="V\xE0o m\xE0n h\xECnh th\xEAm m\u1EDBi h\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED!" class="btn btn-primary btn-with-icon save-profile" ng-click="createInvoice()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" title="T\xECm ki\u1EBFm h\xF3a \u0111\u01A1n theo \u0111i\u1EC1u ki\u1EC7n l\u1ECDc \u1EDF tr\xEAn!" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n: <span style="color:yellow">{{mainCtrl.TotalAmount}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 y t\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">H\u0110 \u0110T</td><td class="text-center">H\u0110 C\u0110</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.statusCode != \'NOTPUBLISH\' && item.statusCode != \'MODIFIED\'"><a title="X\u1EED l\xFD h\xF3a \u0111\u01A1n" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/editInvoiceMain\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div><div ng-if="item.statusCode == \'NOTPUBLISH\'"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createInvoice\', item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td class="text-center"><div ng-if="item.statusCode == \'PUBLISHED\' && item.dateOfInvoice == checkDate"><a style="color:yellow" href="" ng-click="editInvoice(\'#/createInvoice\', item.ID)">{{("0000000"+item.billNumber).slice(-7)}}</a></div><div ng-if="item.statusCode != \'PUBLISHED\' || item.dateOfInvoice != checkDate">{{("0000000"+item.billNumber).slice(-7)}}</div></td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.medicalCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{pathFileInvoice + item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td class="text-center"><div ng-if="item.fileConvert != \'\' && item.statusCode == \'PUBLISHED\'"><a href="{{pathFileInvoice + item.fileConvert}}" target="_blank" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-file"></span></a></div><div ng-if="item.fileConvert == \'\' && item.statusCode == \'PUBLISHED\'"><a href="" ng-click="createFileConvert(item.ID, item.fileName)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-export"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceMain/createInvoiceMain.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputDateInput" class="control-label">Ng\xE0y nh\u1EADp (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateInput" id="inputDateInput" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateCode}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateCode | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-blur="findCustomer(inputTaxCode)" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"></div><div class="col-sm-2"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi mua h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" ng-readonly="$root.flagGetCustomer" style="width:220px !important;" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi mua h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" ng-readonly="$root.flagGetCustomer" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-6"><input type="text" ng-readonly="$root.flagGetCustomer" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">\u0110\u1ED3ng ti\u1EC1n thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="SelectCurrencyOfPaymentPageCtrl as ctrl"><ui-select focus-on="SetFocusCurrencyOfPayment" ng-model="CurrencyOfPayment.selected" ng-change="changeCurrencyOfPayment(CurrencyOfPayment.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.currencyOfPaymentName}}</ui-select-match><ui-select-choices repeat="CurrencyOfPayment in CurrencyOfPayments | filter: $select.search"><span ng-bind-html="CurrencyOfPayment.currencyOfPaymentName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-6"><input type="text" ng-readonly="$root.flagGetCustomer" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div><div class="col-sm-2" style="text-align: right;"><label for="inputExchangeRate" class="control-label">T\u1EF7 gi\xE1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputExchangeRate" id="inputExchangeRate" placeholder="T\u1EF7 gi\xE1"></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-6"><input type="text" ng-readonly="$root.flagGetCustomer" class="form-control" ng-model="inputAddress" id="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfPayment" class="control-label">H\xECnh th\u1EE9c thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="SelectTypeOfPaymentPageCtrl as ctrl"><ui-select focus-on="SetFocusTypeOfPayment" ng-model="TypeOfPayment.selected" ng-change="changeTypeOfPayment(TypeOfPayment.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfPaymentName}}</ui-select-match><ui-select-choices repeat="TypeOfPayment in TypeOfPayments | filter: $select.search"><span ng-bind-html="TypeOfPayment.typeOfPaymentName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="horizontal-scroll"><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>H\xE0ng h\xF3a & d\u1ECBch v\u1EE5</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND)</td><td>Th\xE0nh ti\u1EC1n ch\u01B0a VAT</td><td>% (VAT)</td><td>Th\xE0nh ti\u1EC1n c\xF3 VAT</td><td style="text-align: center;"><a class="btn btn-primary btn-xs" ng-show="isUpdate" ng-click="addProduct()" href=""><span class="glyphicon glyphicon-plus"></span></a></td></tr><tr ng-repeat="pro in Products" class="editable-row"><td>{{$index+1}}</td><td style="width:23%;" ng-controller="SelectGoodAndServicePageCtrl as ctrl"><ui-select focus-on="SetFocusProduct" ng-model="pro.productCode" ng-change="selectProduct($select.selected, pro.ID)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.goodAndServiceName}}</ui-select-match><ui-select-choices repeat="GoodAndService in GoodAndServices | filter: $select.search"><span ng-bind-html="GoodAndService.goodAndServiceName | highlight: $select.search"></span></ui-select-choices></ui-select></td><td><label>{{pro.unitName}}</label></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="pro.quantityCode" ng-model="pro.quantityCode" ng-change="changeQuantity(pro.ID, pro.quantityCode)"></td><td><label>{{pro.price | currency:"":0}}</label></td><td><label>{{pro.amountNotVAT | currency:"":0}}</label></td><td><label>{{pro.VAT}}</label></td><td><label>{{pro.amountVAT | currency:"":0}}</label></td><td style="width:8%; text-align: center"><a class="btn btn-danger btn-xs" ng-show="isUpdate" ng-click="removeProduct(pro)" href=""><span class="glyphicon glyphicon-trash"></span></a></td></tr></table></div></div><div style="text-align: center !important;"><button type="button" ng-show="isUpdate" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t h\xF3a \u0111\u01A1n</button> <button type="button" ng-show="isEdit" ng-click="open(\'#/editInvoiceMain\')" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>X\u1EED l\xFD h\xF3a \u0111\u01A1n</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceMain\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceMain/editInvoiceMain.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputBillNumber" ng-model="inputBillNumber"></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputInvoiceTemplate" ng-model="inputInvoiceTemplate"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputDateOfInvoice" ng-model="inputDateOfInvoice"></div><div class="col-sm-2" style="text-align: right;"><label for="inputDateCreated" class="control-label">Ng\xE0y x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateCreated" id="inputDateCreated" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">H\xECnh th\u1EE9c x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-4" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="DELETE"> <span>H\u1EE7y</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="typeOfAction.name" ng-disabled="typeOfAction.disabled" value="ADJUST"> <span>\u0110i\u1EC1u ch\u1EC9nh</span></label></div></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">L\xFD do x\u1EED l\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><textarea placeholder="L\xFD do x\u1EED l\xFD" class="form-control" id="inputDescription" ng-model="inputDescription"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-show="isSave" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isCreatInvoice" ng-click="changeInvoice()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi H\u0110</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPrint" ng-click="printDocument()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>In bi\xEAn b\u1EA3n</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPrint" ng-click="printNotification()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>In th\xF4ng b\xE1o</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="backPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceMain/invoiceMain.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Danh s\xE1ch h\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED"><div class="panel-content" ng-controller="InvoiceMainPageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectStatusPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChanged(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi mua h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi mua h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChanged(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateCode}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateCode | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createInvoiceMain\')"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th st-sort="customerName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>T\xECnh tr\u1EA1ng</th><th class="text-center">H\xF3a \u0111\u01A1n</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createInvoiceMain\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td class="text-center">{{item.billNumber}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.customerName}}</td><td>{{item.totalAmount | currency:"":0}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoicePending/createInvoicePending.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select focus-on="SetFocus" ng-model="InvoiceTemplate.selected" ng-change="selectChanged(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateCode}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateCode | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputDatePending" class="control-label">Ng\xE0y t\u1EA1m gi\u1EEF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDatePending" id="inputDatePending" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group row"><div class="col-sm-2" style="text-align: right;"><label for="inputFromNumber" class="control-label">T\u1EEB s\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputFromNumber" id="inputFromNumber" placeholder="T\u1EEB s\u1ED1"></div><div class="col-sm-2" style="text-align: right;"><label for="inputToNumber" class="control-label">\u0110\u1EBFn s\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputToNumber" id="inputToNumber" placeholder="\u0110\u1EBFn s\u1ED1"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoicePending\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="form-group row"><div>&nbsp;</div></div><div class="form-group row"><div>&nbsp;</div></div><div class="form-group row"><div>&nbsp;</div></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoicePending/invoicePending.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Danh s\xE1ch h\xF3a \u0111\u01A1n \u0111i\u1EC7n t\u1EED t\u1EA1m gi\u1EEF in sau"><div class="panel-content" ng-controller="InvoicePendingPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChanged(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateCode}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateCode | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createInvoicePending\')"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td style="text-align: center;">S\u1EEDa</td><td style="text-align: center;">L\u1EADp H\u0110</td><td st-sort="invoiceTemplateCode">M\u1EABu h\xF3a \u0111\u01A1n</td><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="fromNumber">T\u1EEB s\u1ED1</th><th st-sort="toNumber">\u0110\u1EBFn s\u1ED1</th><th>S\u1ED1 hi\u1EC7n t\u1EA1i</th><th st-sort="datePending">Ng\xE0y gi\u1EEF</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.currentNumber == item.fromNumber"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createInvoicePending\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td class="text-center"><a title="L\u1EADp m\u1EDBi h\xF3a \u0111\u01A1n" class="btn btn-warning btn-xs" href="" ng-click="open(\'#/invoiceQueue\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.invoiceTemplateCode}}</td><td>{{item.symbol}}</td><td>{{item.fromNumber}}</td><td>{{item.toNumber}}</td><td>{{item.currentNumber}}</td><td>{{item.datePending}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceQueue/collapseInvoiceQueue.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="G\u1ED9p h\xF3a \u0111\u01A1n"><div class="panel-content" ng-controller="CollapseInvoiceQueuePageCtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSalesVoucherID" class="control-label">S\u1ED1 phi\u1EBFu</label></div><div class="col-sm-8"><input type="text" readonly="" class="form-control" id="inputSalesVoucherID" ng-model="inputSalesVoucherID"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputTotalAmount" class="control-label">T\u1ED5ng s\u1ED1 ti\u1EC1n</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputTotalAmount" ng-model="inputTotalAmount"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Ng\u01B0\u1EDDi mua h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputCompanyName" ng-model="inputCompanyName" placeholder="Kh\xE1ch h\xE0ng"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="horizontal-scroll"><label for="inputIsActive" class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-bordered table-hover table-condensed"><thead><tr class="sortable"><td style="text-align: center;">STT</td><td style="text-align: center;">Di\u1EC5n gi\u1EA3i</td><td style="text-align: center;">Th\xE0nh ti\u1EC1n tr\u01B0\u1EDBc thu\u1EBF</td><td style="text-align: center;">Ti\u1EC1n thu\u1EBF VAT</td><td style="text-align: center;">Th\xE0nh ti\u1EC1n sau thu\u1EBF</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.InventoryName}}</td><td style="text-align: right;">{{item.Price | currency:"":2}}</td><td style="text-align: right;">{{item.AmountVAT | currency:"":2}}</td><td style="text-align: right;">{{item.TotalAmount | currency:"":2}}</td></tr></tbody></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceQueue\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceQueue/createInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrl"><ui-select focus-on="SetFocusInvoiceTemplate" ng-model="InvoiceTemplate.selected" ng-change="changeInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkEdit" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><input type="text" class="form-control" readonly="" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputMedicalCode" class="control-label">M\xE3 y t\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputMedicalCode" id="inputMedicalCode" placeholder="M\xE3 y t\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-5"><input type="text" class="form-control" id="inputCompanyName" ng-model="inputCompanyName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" class="form-control" id="inputTaxCode" ng-model="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputHealthInsuranceCardNumber" class="control-label">Th\u1EBB BHYT</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputHealthInsuranceCardNumber" id="inputHealthInsuranceCardNumber" placeholder="Th\u1EBB BHYT"></div><div class="col-sm-2" style="text-align: right;"><label for="inputHospitalizationNumber" class="control-label">S\u1ED1 nh\u1EADp vi\u1EC7n</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputHospitalizationNumber" id="inputHospitalizationNumber" placeholder="S\u1ED1 nh\u1EADp vi\u1EC7n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfRevenue" class="control-label">Lo\u1EA1i doanh thu</label></div><div class="col-sm-5"><ui-select focus-on="SetFocusTypeOfRevenue" ng-model="TypeOfRevenue.selected" ng-change="changeTypeOfRevenue(TypeOfRevenue.selected)" class="btn-group bootstrap-select form-control" ng-disabled="checkEdit" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfRevenueName}}</ui-select-match><ui-select-choices repeat="TypeOfRevenue in TypeOfRevenues | filter: $select.search"><span ng-bind-html="TypeOfRevenue.typeOfRevenueName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="horizontal-scroll"><label for="inputIsActive" class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td><td>Ti\u1EC1n thu\u1EBF</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:8%;"><input type="text" maxlength="4" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount1(inputPrice1, inputVAT1, inputQuantity1)" id="inputVAT1" ng-model="inputVAT1"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" id="inputVATAmount1" ng-model="inputVATAmount1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:8%;"><input type="text" maxlength="4" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount2(inputPrice2, inputVAT2, inputQuantity2)" id="inputVAT2" ng-model="inputVAT2"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" id="inputVATAmount2" ng-model="inputVATAmount2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" ng-readonly="checkEdit" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:8%;"><input type="text" maxlength="4" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:14%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:7%;"><input type="text" maxlength="3" ng-readonly="checkEdit" class="form-control" format="" ng-blur="calVATAmount3(inputPrice3, inputVAT3, inputQuantity3)" id="inputVAT3" ng-model="inputVAT3"></td><td style="width:13%;"><input type="text" ng-readonly="checkEdit" class="form-control" format="" id="inputVATAmount3" ng-model="inputVATAmount3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" ng-show="isPublic" ng-click="publishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Xu\u1EA5t h\xF3a \u0111\u01A1n</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceApproved\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceQueue/editInvoiceQueue.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="T\xE1ch h\xF3a \u0111\u01A1n"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSalesVoucherID" class="control-label">S\u1ED1 phi\u1EBFu</label></div><div class="col-sm-8"><input type="text" readonly="" class="form-control" id="inputSalesVoucherID" ng-model="inputSalesVoucherID"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputTotalAmount" class="control-label">T\u1ED5ng s\u1ED1 ti\u1EC1n</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputTotalAmount" ng-model="inputTotalAmount"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Ng\u01B0\u1EDDi mua h\xE0ng</label></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Ng\u01B0\u1EDDi mua h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">Kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputCompanyName" ng-model="inputCompanyName" placeholder="Kh\xE1ch h\xE0ng"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputAddress" ng-model="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="horizontal-scroll"><label for="inputIsActive" class="control-label">Chi ti\u1EBFt h\xF3a \u0111\u01A1n</label><table class="table table-bordered table-hover table-condensed"><tr><td>STT</td><td>Di\u1EC5n gi\u1EA3i (<b style="color:red;">*</b>)</td><td>\u0110\u01A1n v\u1ECB t\xEDnh</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>\u0110\u01A1n gi\xE1 (VND) (<b style="color:red;">*</b>)</td><td>% (VAT)</td></tr><tr class="editable-row"><td style="width:5%;">1</td><td><input type="text" class="form-control" id="inputDescription1" ng-model="inputDescription1"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName1" ng-model="inputUnitName1"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity1" ng-model="inputQuantity1"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice1(inputPrice1)" id="inputPrice1" ng-model="inputPrice1"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT1" ng-model="inputVAT1"></td></tr><tr><td style="width:5%;">2</td><td><input type="text" class="form-control" id="inputDescription2" ng-model="inputDescription2"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName2" ng-model="inputUnitName2"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity2" ng-model="inputQuantity2"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice2(inputPrice2)" id="inputPrice2" ng-model="inputPrice2"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT2" ng-model="inputVAT2"></td></tr><tr class="editable-row"><td style="width:5%;">3</td><td><input type="text" class="form-control" id="inputDescription3" ng-model="inputDescription3"></td><td style="width:10%;"><input type="text" class="form-control" id="inputUnitName3" ng-model="inputUnitName3"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputQuantity3" ng-model="inputQuantity3"></td><td style="width:23%;"><input type="text" class="form-control" allow-only-numbers="" ng-blur="endPrice3(inputPrice3)" id="inputPrice3" ng-model="inputPrice3"></td><td style="width:8%;"><input type="text" class="form-control" allow-only-numbers="" id="inputVAT3" ng-model="inputVAT3"></td></tr></table></div><br><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNotes" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputNotes" id="inputNotes"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceQueue\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceQueue/invoiceQueue.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Danh s\xE1ch ch\u1EDD l\u1EADp h\xF3a \u0111\u01A1n"><div class="panel-content" ng-controller="InvoiceQueuePageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputVoucherNum" class="control-label">S\u1ED1 phi\u1EBFu</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputVoucherNum" id="inputVoucherNum" placeholder="S\u1ED1 phi\u1EBFu"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="Kh\xE1ch h\xE0ng"></div></div></div><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfInvoice" class="control-label">Ng\xE0y h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateOfInvoice" id="inputDateOfInvoice" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="form-horizontal" style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button><button type="button" ng-click="createInvoice()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-plus-round"></i>T\u1EF1 l\u1EADp H\u0110</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td><div><label class="custom-checkbox"><input type="checkbox" id="inputCheckAll" ng-model="inputCheckAll"> <span>&nbsp;</span></label></div></td><th class="text-center">T\xE1ch H\u0110</th><th st-sort="VoucherNum">S\u1ED1 phi\u1EBFu</th><th st-sort="VATNo">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="VATObjectName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="VATObjectAddress">\u0110\u1ECBa ch\u1EC9</th><th st-sort="Amount">S\u1ED1 ti\u1EC1n</th><th class="text-center">Chi ti\u1EBFt</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.GroupInvoice == 0"><label class="custom-checkbox"><input type="checkbox" id="{{item.SalesVoucherID}}" ng-model="checkInvoice" ng-checked="inputCheckAll"> <span>&nbsp;</span></label></div></td><td class="text-center"><a title="T\xE1ch h\xF3a \u0111\u01A1n" class="btn btn-success btn-xs" href="" ng-click="open(\'#/editInvoiceQueue\', item.SalesVoucherID)"><span class="glyphicon glyphicon-duplicate"></span></a></td><td>{{item.VoucherNum}}</td><td>{{item.VATNo}}</td><td>{{item.VATObjectName}}</td><td>{{item.VATObjectAddress}}</td><td>{{item.TotalAmount | currency:"":2}}</td><td class="text-center"><div ng-if="item.GroupInvoice == 0"><a ng-click="viewDetail(\'app/pages/electricInvoice/invoiceQueue/invoiceQueueDetail.html\', lg, item.SalesVoucherID)" href="" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-list-alt"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceQueue/invoiceQueueDetail.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div><table st-table="vm.detail" class="table table-striped"><thead><tr><td>N\u1ED9i dung</td><td>S\u1ED1 l\u01B0\u1EE3ng</td><td>Th\xE0nh ti\u1EC1n tr\u01B0\u1EDBc thu\u1EBF</td><td>Ti\u1EC1n thu\u1EBF</td><td>Th\xE0nh ti\u1EC1n sau thu\u1EBF</td></tr></thead><tbody><tr ng-repeat="item in vm.detail"><td>{{item.InventoryName}}</td><td>{{item.Quantity}}</td><td>{{item.Price | currency:"":2}}</td><td>{{item.AmountVAT | currency:"":2}}</td><td>{{item.TotalAmount | currency:"":2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceWait4Approve/invoiceWait4Approve.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Danh s\xE1ch h\xF3a \u0111\u01A1n ch\u1EDD duy\u1EC7t"><div class="panel-content" ng-controller="InvoiceWait4ApprovePageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCompanyName" class="control-label">Kh\xE1ch h\xE0ng</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCompanyName" id="inputCompanyName" placeholder="Kh\xE1ch h\xE0ng"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" ng-click="approveInvoice()" class="btn btn-info btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Duy\u1EC7t h\xF3a \u0111\u01A1n</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td><div><label class="custom-checkbox"><input type="checkbox" id="inputCheckAll" ng-model="inputCheckAll"> <span>&nbsp;</span></label></div></td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><th>T\xECnh tr\u1EA1ng</th><th class="text-center">H\xF3a \u0111\u01A1n</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><label class="custom-checkbox"><input type="checkbox" id="checkInvoice{{item.ID}}" ng-model="checkInvoice" ng-checked="inputCheckAll"> <span>&nbsp;</span></label></td><td class="text-center">{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.companyName}}</td><td>{{item.totalAmount | currency:"":0}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/electricInvoice/invoiceRePublic/invoiceRePublic.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Xu\u1EA5t l\u1EA1i h\xF3a \u0111\u01A1n kh\xE1ch l\u1EBB"><div class="panel-content" ng-controller="InvoiceRePublicPageCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerCode" class="control-label">M\xE3 kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerCode" id="inputCustomerCode" placeholder="M\xE3 kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn kh\xE1ch h\xE0ng"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterpriseName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEnterpriseName" id="inputEnterpriseName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="MaBenhNhan">M\xE3 kh\xE1ch h\xE0ng</th><th st-sort="TenBenhNhan">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="DiaChi">\u0110\u1ECBa ch\u1EC9</th><th st-sort="SoDienThoai">\u0110i\u1EC7n tho\u1EA1i</th><th st-sort="TotalAmount">S\u1ED1 ti\u1EC1n</th><th class="text-center">Chi ti\u1EBFt</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a ng-click="publicInvoice(item.REF_ID)" href="" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-open-file"></span></a></td><td>{{item.MaBenhNhan}}</td><td>{{item.TenBenhNhan}}</td><td>{{item.DiaChi}}</td><td>{{item.SoDienThoai}}</td><td>{{item.TotalAmount | currency:"":0}}</td><td class="text-center"><a ng-click="viewDetail(\'app/pages/electricInvoice/invoiceQueue/invoiceQueueDetail.html\', lg, item.REF_ID)" href="" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-list-alt"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/enterprise/branch/branch.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createBranch\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table table-striped" st-table="branchs"><thead><tr class="sortable"><th class="table-id" st-sort="branchId" st-sort-default="true">#</th><th st-sort="branchName">T\xEAn chi nh\xE1nh</th><th st-sort="address">\u0110\u1ECBa ch\u1EC9</th><th st-sort="phone">\u0110i\u1EC7n tho\u1EA1i</th><th st-sort="fax">Fax</th><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th>S\u1EED d\u1EE5ng</th></tr><tr><th></th><th><input st-search="branchName" placeholder="T\xEAn chi nh\xE1nh" class="input-sm form-control search-input" type="search"></th><th><input st-search="address" placeholder="\u0110\u1ECBa ch\u1EC9" class="input-sm form-control search-input" type="search"></th><th><input st-search="phone" placeholder="\u0110i\u1EC7n tho\u1EA1i" class="input-sm form-control search-input" type="search"></th><th><input st-search="fax" placeholder="S\u1ED1 Fax" class="input-sm form-control search-input" type="search"></th><th><input st-search="taxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in branchs" class="editable-row"><td class="table-id">{{item.branchId}}</td><td>{{item.branchName}}</td><td>{{item.address}}</td><td>{{item.phone}}</td><td>{{item.fax}}</td><td>{{item.taxCode}}</td><td class="text-center"><input type="checkbox" checked=""></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/enterprise/branch/createBranch.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBranchName" class="control-label">T\xEAn chi nh\xE1nh</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputBranchName" placeholder="T\xEAn chi nh\xE1nh"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddressVN" class="control-label">\u0110\u1ECBa ch\u1EC9</label></div><div class="col-sm-8"><input type="text" class="form-control" id="inputAddressVN" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div><div class="col-sm-2" style="text-align: right;"><label for="inputFax" class="control-label">Fax</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputFax" placeholder="S\u1ED1 Fax"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>&nbsp;</span></label></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/branch\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/enterprise/branchInvoice/branchInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBranchName" class="control-label">Chi nh\xE1nh</label></div><div class="col-sm-3"><select id="inputBranchName" class="form-control" title="L\u1EF1a ch\u1ECDn" selectpicker=""><option>VietInfo</option><option>FPT</option><option>Viettel</option><option>Vingroup</option><option>VNPT</option></select></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfInvoice" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><select id="inputTypeOfInvoice" class="form-control" title="L\u1EF1a ch\u1ECDn" selectpicker=""><option>M\u1EABu s\u1ED1 1</option><option>M\u1EABu s\u1ED1 2</option><option>M\u1EABu s\u1ED1 3</option><option>M\u1EABu s\u1ED1 4</option><option>M\u1EABu s\u1ED1 5</option></select></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createBranchInvoice\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table table-striped" st-table="branchInvoices"><thead><tr class="sortable"><th class="table-id" st-sort="branchInvoiceId" st-sort-default="true">#</th><th st-sort="branchName">T\xEAn chi nh\xE1nh</th><th st-sort="invoiceTemplateName">M\u1EABu h\xF3a \u0111\u01A1n</th><th st-sort="pattern">M\u1EABu s\u1ED1</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="fromNumber">T\u1EEB s\u1ED1</th><th st-sort="toNumber">\u0110\u1EBFn s\u1ED1</th><th st-sort="timesOfAttribution">L\u1EA7n ph\xE2n b\u1ED5</th><th st-sort="dateOfAttribution">Ng\xE0y ph\xE2n b\u1ED5</th><th>S\u1EED d\u1EE5ng</th></tr><tr><th></th><th><input st-search="branchName" placeholder="T\xEAn chi nh\xE1nh" class="input-sm form-control search-input" type="search"></th><th><input st-search="invoiceTemplateName" placeholder="M\u1EABu h\xF3a \u0111\u01A1n" class="input-sm form-control search-input" type="search"></th><th><input st-search="pattern" placeholder="M\u1EABu s\u1ED1" class="input-sm form-control search-input" type="search"></th><th><input st-search="symbol" placeholder="K\xFD hi\u1EC7u" class="input-sm form-control search-input" type="search"></th><th><input st-search="fromNumber" placeholder="T\u1EEB s\u1ED1" class="input-sm form-control search-input" type="search"></th><th><input st-search="toNumber" placeholder="\u0110\u1EBFn s\u1ED1" class="input-sm form-control search-input" type="search"></th><th><input st-search="timesOfAttribution" placeholder="L\u1EA7n ph\xE2n b\u1ED5" class="input-sm form-control search-input" type="search"></th><th><input st-search="dateOfAttribution" placeholder="Ng\xE0y ph\xE2n b\u1ED5" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in branchInvoices" class="editable-row"><td class="table-id">{{item.branchInvoiceId}}</td><td>{{item.branchName}}</td><td>{{item.invoiceTemplateName}}</td><td>{{item.pattern}}</td><td>{{item.symbol}}</td><td>{{item.fromNumber}}</td><td>{{item.toNumber}}</td><td>{{item.timesOfAttribution}}</td><td>{{item.dateOfAttribution}}</td><td class="text-center"><input type="checkbox" checked=""></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/enterprise/branchInvoice/createBranchInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBranchName" class="control-label">Chi nh\xE1nh</label></div><div class="col-sm-6"><select id="inputBranchName" class="form-control" title="L\u1EF1a ch\u1ECDn" selectpicker=""><option>VietInfo</option><option>FPT</option><option>Viettel</option><option>Vingroup</option><option>VNPT</option></select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfInvoice" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-6"><select id="inputTypeOfInvoice" class="form-control" title="L\u1EF1a ch\u1ECDn" selectpicker=""><option>M\u1EABu s\u1ED1 1</option><option>M\u1EABu s\u1ED1 2</option><option>M\u1EABu s\u1ED1 3</option><option>M\u1EABu s\u1ED1 4</option><option>M\u1EABu s\u1ED1 5</option></select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPattern" class="control-label">M\u1EABu s\u1ED1</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputPattern" placeholder="M\u1EABu s\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u m\u1EABu</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" id="inputSymbol" placeholder="K\xFD hi\u1EC7u m\u1EABu"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputFromNumber" class="control-label">T\u1EEB s\u1ED1</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputFromNumber" placeholder="T\u1EEB s\u1ED1"></div><div class="col-sm-2" style="text-align: right;"><label for="inputToNumber" class="control-label">\u0110\u1EBFn s\u1ED1</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputToNumber" placeholder="\u0110\u1EBFn s\u1ED1"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTimesOfAttribution" class="control-label">L\u1EA7n ph\xE2n b\u1ED5</label></div><div class="col-sm-3"><input type="text" class="form-control" id="inputTimesOfAttribution" placeholder="L\u1EA7n ph\xE2n b\u1ED5"></div><div class="col-sm-2" style="text-align: right;"><label for="inputDateOfAttribution" class="control-label">Ng\xE0y ph\xE2n b\u1ED5</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>&nbsp;</span></label></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/branchInvoice\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/enterprise/registerInformation/registerInformation.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthority" class="control-label" id="inputTaxAuthority">C\u01A1 quan Thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectTaxAuthorityPageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TaxAuthority.selected" ng-change="selectChanged(TaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="TaxAuthority in TaxAuthorities | filter: $select.search"><span ng-bind-html="TaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="ChildTaxAuthority.selected" ng-change="selectChangedChild(ChildTaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="ChildTaxAuthority in ChildTaxAuthorities | filter: $select.search"><span ng-bind-html="ChildTaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBusinessNameEN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB ti\u1EBFng Anh</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputBusinessNameEN" id="inputBusinessNameEN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB ti\u1EBFng Anh"></div><div class="col-sm-2" style="text-align: right;"><label for="inputFax" class="control-label">Fax</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputFax" id="inputFax"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddressVN" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-9"><input type="text" class="form-control" ng-model="inputAddressVN" id="inputAddressVN" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddressEN" class="control-label">\u0110\u1ECBa ch\u1EC9 ti\u1EBFng Anh</label></div><div class="col-sm-9"><input type="text" class="form-control" ng-model="inputAddressEN" id="inputAddressEN" placeholder="\u0110\u1ECBa ch\u1EC9 ti\u1EBFng Anh"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-9"><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7 (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputOwner" class="control-label">Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputOwner" id="inputOwner" placeholder="Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputBankAccount" class="control-label">S\u1ED1 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputBankAccount" id="inputBankAccount" placeholder="S\u1ED1 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng"></div></div></div></div><div class="row" style="padding-bottom: 10px;"><div class="col-sm-11"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputBankName" class="control-label">T\xEAn ng\xE2n h\xE0ng</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputBankName" id="inputBankName" placeholder="T\xEAn ng\xE2n h\xE0ng"></div></div></div></div></div><div class="col-sm-3"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()" class="img-responsive"></div><a href="" class="change-userpic" ng-click="uploadPicture()">Ch\u1ECDn Logo \u0111\u1EC3 thay \u0111\u1ED5i</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div><div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActiveLogo" ng-model="inputIsActiveLogo" ng-checked="checkStatus==\'Y\'"> <span>S\u1EED d\u1EE5ng Logo</span></label></div></div></div></div><div class="row"><div class="col-sm-11" style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-warning btn-with-icon save-profile" ng-click="refreshPage()"><i class="ion-refresh"></i>B\u1ECF qua</button></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/enterprise/invoiceTemplate/createInvoiceTemplate.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-2"><input type="text" readonly="" class="form-control" ng-model="inputTaxCode" id="inputTaxCode"></div><div class="col-sm-2" style="text-align: right;"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-4"><input type="text" disabled="" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN"></div><div class="col-sm-2"><span>&nbsp;</span></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddressVN" class="control-label">\u0110\u1ECBa ch\u1EC9</label></div><div class="col-sm-8"><input type="text" disabled="" class="form-control" ng-model="inputAddressVN" id="inputAddressVN"></div><div class="col-sm-2"><span>&nbsp;</span></div></div><div class="form-group"><div class="col-sm-8"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" disabled="" class="form-control" ng-model="inputPhone" id="inputPhone"></div><div class="col-sm-3" style="text-align: right;"><label for="inputFax" class="control-label">Fax</label></div><div class="col-sm-3"><input type="text" disabled="" class="form-control" ng-model="inputFax" id="inputFax"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputBankName" class="control-label">T\xEAn ng\xE2n h\xE0ng</label></div><div class="col-sm-9"><input type="text" disabled="" class="form-control" ng-model="inputBankName" id="inputBankName"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputBankAccount" class="control-label">TK ng\xE2n h\xE0ng</label></div><div class="col-sm-3"><input type="text" disabled="" class="form-control" ng-model="inputBankAccount" id="inputBankAccount"></div><div class="col-sm-3" style="text-align: right;"><label for="inputCategoryName" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectTypeOfInvoicePageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TypeOfInvoice.selected" ng-change="changeTypeOfInvoice(TypeOfInvoice.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfInvoiceName}}</ui-select-match><ui-select-choices repeat="TypeOfInvoice in TypeOfInvoices | filter: $select.search"><span ng-bind-html="TypeOfInvoice.typeOfInvoiceName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputInvoiceTemplateName" class="control-label">T\xEAn m\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputInvoiceTemplateName" id="inputInvoiceTemplateName" placeholder="T\xEAn m\u1EABu h\xF3a \u0111\u01A1n"></div><div class="col-sm-3" style="text-align: right;"><label for="inputInvoiceTemplateCode" class="control-label">M\xE3 m\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputInvoiceTemplateCode" id="inputInvoiceTemplateCode" placeholder="M\xE3 m\u1EABu h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputDateCreated" class="control-label">Ng\xE0y kh\u1EDFi t\u1EA1o (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputDateCreated" id="inputDateCreated" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-3" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u m\u1EABu (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u m\u1EABu"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputFromNumber" class="control-label">T\u1EEB s\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" format="" ng-model="inputFromNumber" id="inputFromNumber" placeholder="T\u1EEB s\u1ED1"></div><div class="col-sm-3" style="text-align: right;"><label for="inputToNumber" class="control-label">\u0110\u1EBFn s\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" format="" ng-model="inputToNumber" id="inputToNumber" placeholder="\u0110\u1EBFn s\u1ED1"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-9"><input type="text" class="form-control" ng-model="inputDescription" id="inputDescription" placeholder="Ghi ch\xFA"></div></div></div><div class="col-sm-4"><div class="form-group"><div class="col-md-offset-1 col-sm-6"><label for="inputDescription" class="control-label">Ch\u1ECDn m\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-9" ng-controller="SelectTemplatePageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="Template.selected" ng-change="selectChanged(Template.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.templateName}}</ui-select-match><ui-select-choices repeat="Template in Templates | filter: $select.search"><span ng-bind-html="Template.templateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div><div class="col-md-offset-1 img-thumbnail img-fluid"><a ng-click="viewFullImage(\'app/pages/enterprise/invoiceTemplate/viewFullImage.html\', lg)" href=""><img ng-src="{{ picture }}" width="294px" height="236px"></a></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-show="isPublic" ng-click="publish()" class="btn btn-success btn-with-icon save-profile"><i class="ion-document-text"></i>Ph\xE1t h\xE0nh</button><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/invoiceTemplate\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/enterprise/invoiceTemplate/invoiceTemplate.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="InvoiceTemplatePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" class="form-control" id="inputFromDate" name="inputFromDate" ng-model="inputFromDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" readonly="" id="inputToDate" name="inputToDate" ng-model="inputToDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left; padding-left: 15px;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createInvoiceTemplate\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="dateInit" class="text-center">Ng\xE0y t\u1EA1o</th><td style="text-align: center;">T\u1EEB s\u1ED1</td><td style="text-align: center;">\u0110\u1EBFn s\u1ED1</td><td style="text-align: center;">S\u1ED1 hi\u1EC7n t\u1EA1i</td><td style="text-align: center;">Lo\u1EA1i h\xF3a \u0111\u01A1n</td><td style="text-align: center;">T\xECnh tr\u1EA1ng</td><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><div ng-if="item.statusCode != \'APPROVED\'"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createInvoiceTemplate\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.symbol}}</td><td class="text-center">{{item.dateInit}}</td><td class="text-center">{{item.fromNumber | number}}</td><td class="text-center">{{item.toNumber | number}}</td><td class="text-center">{{item.currentNumber | number}}</td><td class="text-center">{{item.typeOfInvoiceName}}</td><td style="text-align: center;"><div ng-if="item.statusCode == \'PENDING\'"><a title="Duy\u1EC7t" class="btn btn-warning btn-xs" href="" ng-click="approveInvoiceTemplate(item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-android-checkmark-circle"></span></a></div><div ng-if="item.statusCode != \'PENDING\'">{{item.statusName}}</div></td><td style="text-align: center;"><div ng-if="checkShow(item.isLock) == 0"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></div><div ng-if="checkShow(item.isLock) == 1"><a class="btn btn-danger btn-xs"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/enterprise/invoiceTemplate/viewFullImage.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div><img ng-src="{{vm.picture}}" width="600px" height="500px"></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/am4Chart/clusteredBarChart.html','<div chart-panel="" chart-panel-title="{{ClusteredBarChartTitle}}" chart-panel-id="clusteredBarChart"></div>');
$templateCache.put('app/pages/dashboard/am4Chart/detailStep1.html','<section ng-controller="detailStep1Ctrl"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{Title1}}" ba-panel-class="with-scroll"><div ng-controller="semiPieChart" id="semiPieChart" style="width: 100%; height: 60vh !important"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{Title2}}" ba-panel-class="with-scroll"><div ng-controller="stackedAreaChart" id="barChartArea" style="width: 100%; height: 60vh !important"></div></div></div></div><div class="row"><div class="col-md-12"><div style="text-align: center !important;"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="backLastPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></section>');
$templateCache.put('app/pages/dashboard/am4Chart/detailStep2.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="detailStep2Ctrl as mainCtrl"><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n: <span style="color:yellow">{{mainCtrl.TotalAmount}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="medicalCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">XML</td><td class="text-center">H\u0110 \u0110T</td><td class="text-center">H\u0110 C\u0110</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center">{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.symbol}}</td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td><td class="text-center"><div ng-if="item.fileInvoiceXML != \'\' && item.statusCode == \'PUBLISHED\'"><a href="{{pathFileInvoice + item.fileInvoiceXML}}" target="_blank" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.fileInvoice != \'\'"><a href="{{pathFileInvoice + item.fileInvoice}}" target="_blank" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td class="text-center"><div ng-if="item.fileConvert != \'\' && item.statusCode == \'PUBLISHED\'"><a href="{{pathFileInvoice + item.fileConvert}}" target="_blank" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="row"><div style="text-align: center !important;"><button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="backLastPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/dashboard/am4Chart/growthRevenueBarChart.html','<div chart-panel="" chart-panel-title="{{RevenueBarChartTitle}}" chart-panel-id="barChartGrowthRevenue"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/lists/category/category.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin lo\u1EA1i h\xE0ng h\xF3a"><div class="panel-content" ng-controller="CategoryPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">M\xE3 lo\u1EA1i h\xE0ng h\xF3a</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCategoryId" id="inputCategoryId" placeholder="M\xE3 lo\u1EA1i h\xE0ng h\xF3a"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryName" class="control-label">T\xEAn lo\u1EA1i h\xE0ng h\xF3a</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCategoryName" id="inputCategoryName" placeholder="T\xEAn lo\u1EA1i h\xE0ng h\xF3a"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createCategory"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="categoryId">M\xE3 lo\u1EA1i h\xE0ng h\xF3a</th><th st-sort="categoryName">T\xEAn lo\u1EA1i h\xE0ng h\xF3a</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createCategory\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td style="width: 8%; text-align: center">{{item.categoryId}}</td><td style="width: 25%">{{item.categoryName}}</td><td style="width: 25%">{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/category/createCategory.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">M\xE3 lo\u1EA1i h\xE0ng h\xF3a (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCategoryId" id="inputCategoryId" placeholder="M\xE3 lo\u1EA1i h\xE0ng h\xF3a"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryName" class="control-label">T\xEAn lo\u1EA1i h\xE0ng h\xF3a (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCategoryName" id="inputCategoryName" placeholder="T\xEAn lo\u1EA1i h\xE0ng h\xF3a"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.category"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_DANHSACH_04.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CHUNGTU_DANHSACH_04Ctrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div><div class="col-sm-2" style="text-align: right;"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-4"><input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateDanhSachChungTuSaiSot()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 h\xF3a \u0111\u01A1n / Danh s\xE1ch: <span style="color:yellow">{{mTotalInvoice}} / {{mTotalList}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="RefDate">Ng\xE0y l\u1EADp</th><th st-sort="FromDate">T\u1EEB ng\xE0y</th><th st-sort="ToDate">\u0110\u1EBFn ng\xE0y</th><th st-sort="QuantityInvoice">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="Descr">Ghi ch\xFA</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">Nh\u1EADn KQ</td><td class="text-center">XML k\u1EBFt qu\u1EA3</td><td class="text-center">TBSS</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditDanhSachChungTuSaiSot(item.ND70_CHUNGTU_SAISOT_ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.RefDate}}</td><td>{{item.FromDate}}</td><td>{{item.ToDate}}</td><td>{{item.QuantityInvoice}}</td><td>{{item.Descr}}</td><td>{{item.StatusName}}</td><td class="text-center"><div ng-if="item.NhanKetQua == 1"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div><div ng-if="item.NHANKETQUA == 2 && item.FileHoaDonXMLCQT != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileSigned(item.FileHoaDonXMLCQT, item.RefNbr, item.RefDate)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDonXML != \'\'"><a href="" ng-click="GetFileSigned(item.FileHoaDonXML, item.RefNbr, item.RefDate)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div><a href="" title="In th\xF4ng b\xE1o sai s\xF3t" ng-click="PrintThongBaoSaiSot(item.ND70_CHUNGTU_SAISOT_ID,item.RefNbr)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_DIEUCHINH.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="CHUNGTU_DIEUCHINHCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="mBillNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="mBillNumber" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div><div class="col-sm-2" style="text-align: right;"><label for="mSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="mSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="TaxCode" ng-init="TaxCode=\'\'" id="TaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="SearchChungTuThayDoi()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mTotalAmount}} / {{mTotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="dateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="NewInvNumber">S\u1ED1 Ch\u1EE9ng t\u1EEB</th><th st-sort="NewInvSerialNo">K\xFD hi\u1EC7u</th><th>Xem tr\u01B0\u1EDBc</th><th>Bi\xEAn b\u1EA3n</th><th st-sort="InvNumber">S\u1ED1 Ch\u1EE9ng t\u1EEB c\u0169</th><th st-sort="RefDate">Ng\xE0y c\u0169</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="customerName">T\xEAn kh\xE1ch h\xE0ng c\u0169</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><div ng-if="item.SUA == 1"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditChungTuDieuChinh(item.ND70_CHUNGTU_THAYDOI_ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.dateAdjust}}</td><td>{{("0000000"+item.NewInvNumber).slice(-7)}}</td><td>{{item.NewInvSerialNo}}</td><td class="text-center"><div><a href="" ng-click="ReviewBienBan(item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-click="GetFileSigned(item.FileBienBan, item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.customerName}}</td><td>{{item.TaxCode}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_GUI_CQT.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CHUNGTU_GUI_CQTCtrl as ctrl"><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="GuiCQT()"><i class="ion-forward"></i>G\u1EEDi C\u01A1 quan Thu\u1EBF</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100,200]"></select></div></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="NgayCT">Ng\xE0y ch\u1EE9ng t\u1EEB</th><th st-sort="InvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB</th><th st-sort="customerName">Kh\xE1ch h\xE0ng</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.NgayCT}}</td><td>{{item.InvNumber}}</td><td>{{item.customerName}}</td><td>{{item.TaxCode}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5" st-template="pagination.html"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_NHANKQ_TCT.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CHUNGTU_NHANKQ_TCTCtrl as ctrl"><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="ReceiveResult()"><i class="ion-reply-all"></i>Nh\u1EADn k\u1EBFt qu\u1EA3 t\u1EEB TCT</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100,200]"></select></div></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="RefDate">Ng\xE0y ch\u1EE9ng t\u1EEB</th><th st-sort="InvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB</th><th st-sort="customerName">Kh\xE1ch h\xE0ng</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="TenTinhTrang">T\xECnh tr\u1EA1ng</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.RefDate}}</td><td>{{item.InvNumber}}</td><td>{{item.customerName}}</td><td>{{item.TaxCode}}</td><td>{{item.TenTinhTrang}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5" st-template="pagination.html"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_THAYTHE.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="CHUNGTU_DIEUCHINHCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="mBillNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="mBillNumber" ng-init="mBillNumber=\'\'" id="mBillNumber" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div><div class="col-sm-2" style="text-align: right;"><label for="mSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mSymbol" ng-init="mSymbol=\'\'" id="mSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="TaxCode" ng-init="TaxCode=\'\'" id="TaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="SearchChungTuThayDoi()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>T\u1ED5ng s\u1ED1 ti\u1EC1n / H\u0110: <span style="color:yellow">{{mTotalAmount}} / {{mTotalInvoice}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="dateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="NewInvNumber">S\u1ED1 Ch\u1EE9ng t\u1EEB</th><th st-sort="NewInvSerialNo">K\xFD hi\u1EC7u</th><th>Xem tr\u01B0\u1EDBc</th><th>Bi\xEAn b\u1EA3n</th><th st-sort="InvNumber">S\u1ED1 Ch\u1EE9ng t\u1EEB c\u0169</th><th st-sort="RefDate">Ng\xE0y c\u0169</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="customerName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><div ng-if="item.SUA == 1"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditChungTuDieuChinh(item.ND70_CHUNGTU_THAYDOI_ID)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.dateAdjust}}</td><td>{{("0000000"+item.NewInvNumber).slice(-7)}}</td><td>{{item.NewInvSerialNo}}</td><td class="text-center"><div><a href="" ng-click="ReviewBienBan(item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-show="item.FileBienBan !=\'\'"><a href="" ng-click="GetFileSigned(item.FileBienBan, item.QD1450_HOADON_THAYDOI_ID, item.symbol, item.billNumber)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-file"></span></a></div></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.customerName}}</td><td>{{item.TaxCode}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CHUNGTU_TNCN.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CHUNGTU_TNCNCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtInvNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" id="txtInvNumber" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div><div class="col-sm-2" style="text-align: right;"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" id="txtInvSerialNo" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mRefNbr" ng-init="mRefNbr=\'\'" id="txtRefNbr" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="CreateToKhaiThueTNCN()"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-8 col-sm-3 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label><label>Danh s\xE1ch: <span style="color:yellow">{{mTotalList}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="InvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB</th><th st-sort="RefDate">Ng\xE0y ch\u1EE9ng t\u1EEB</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="CustomerName">H\u1ECD v\xE0 t\xEAn</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="CCCDan">CCCD</th><th st-sort="BHiem">B\u1EA3o hi\u1EC3m</th><th st-sort="TThien">T\u1EEB thi\u1EC7n</th><th st-sort="TTNCThue">T\u1ED5ng TN ch\u1ECBu thu\u1EBF</th><th st-sort="TTNTThue">T\u1ED5ng TN t\xEDnh thu\u1EBF</th><th st-sort="SThue">S\u1ED1 thu\u1EBF TNCN \u0111\xE3 kh\u1EA5u tr\u1EEB</th><td>T\xECnh tr\u1EA1ng</td><td class="text-center">Nh\u1EADn KQ</td><td class="text-center">CT \u0110T</td><td class="text-center">XML</td><td class="text-center">G\u1EEDi CQT</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="EditToKhaiThueTNCN(item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.CustomerName}}</td><td>{{item.TaxCode}}</td><td>{{item.CCCDan}}</td><td>{{item.BHiem}}</td><td>{{item.TThien }}</td><td>{{item.TTNCThue}}</td><td>{{item.TTNTThue}}</td><td>{{item.SThue}}</td><td>{{item.StatusName}}</td><td class="text-center"><div ng-if="item.NhanKetQua == 1"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div><div ng-if="item.NHANKETQUA == 2 && item.FileHoaDonXMLCQT != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileSigned(item.FileHoaDonXMLCQT, item.RefNbr, item.RefDate)" class="btn btn-warning btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDon != \'\'"><a href="" title="In bi\xEAn lai" ng-click="GetFileSigned(item.ID, item.InvNumber, item.RefNbr)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.FileHoaDonXML != \'\'"><a href="" ng-disabled="OpenFile" ng-click="GetFileHoaDonXML(item.ID,item.FileHoaDonXML)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></div></td><td class="text-center"><div ng-if="item.GUITHUE===1"><a href="" ng-click="Send2CQT(item.MaThongDiep, item.FileHoaDonXML, item.MaLoaiThongDiep, item.Date)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-send"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CreateCHUNGTU_DANHSACH_04.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateCHUNGTU_DANHSACH_04Ctr as mainCtrl"><div class="row"><div class="col-sm-2"><div class="form-group"><label for="txtRefDae" class="control-label">Ng\xE0y b\xE1o c\xE1o</label> <input type="date" id="txtRefDae" ng-model="mRefDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y</label> <input type="date" id="txtFromDate" ng-model="mFromDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label> <input type="date" id="txtToDate" ng-model="mToDate" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label for="cboTypeOfAction" class="control-label">Lo\u1EA1i sai s\xF3t</label><select id="cboTypeOfAction" ng-model="mTypeOfAction" ng-init="mTypeOfAction=\'\'" class="form-control"><option value="">-- Ch\u1ECDn Lo\u1EA1i sai s\xF3t --</option><option ng-repeat="x in arrTypeOfAction" value="{{x.ID}}">{{x.Name}}</option></select></div></div><div class="col-sm-2" ng-show="!IsUpdate"><button style="margin-top: 2rem;" type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ch\u1EE9ng t\u1EEB sai</button></div></div><div class="row"><div class="col-sm-10"><div class="form-group"><label for="txtDescr" class="control-label">Ghi ch\xFA</label> <input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'\'" class="form-control" placeholder="Ghi ch\xFA"></div></div></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div><div class="col-sm-offset-5 col-sm-5 form-group select-page-size-wrap" style="text-align: right;"><label>&nbsp;</label> <label>S\u1ED1 ch\u1EE9ng t\u1EEB / T\xECm ki\u1EBFm: <span style="color:yellow">{{mTotalInvoice}} / {{mTotalSearch}}</span></label></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="DateAdjust">Ng\xE0y x\u1EED l\xFD</th><th st-sort="RefDate">Ng\xE0y ch\u1EE9ng t\u1EEB</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="InvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB</th><th st-sort="Description">L\xFD do</th><th st-sort="TypeOfActionName">Lo\u1EA1i x\u1EED l\xFD</th><th st-sort="MaTinhTrang">T\xECnh tr\u1EA1ng</th><th st-sort="NewInvSerialNo">K\xFD hi\u1EC7u m\u1EDBi</th><th st-sort="NewInvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB m\u1EDBi</th><th st-sort="NewRefDate">Ng\xE0y ch\u1EE9ng t\u1EEB m\u1EDBi</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td>{{item.DateAdjust}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.InvNumber}}</td><td>{{item.Description}}</td><td>{{item.TypeOfActionName}}</td><td>{{item.MaTinhTrang}}</td><td>{{item.NewInvSerialNo}}</td><td>{{item.NewInvNumber}}</td><td>{{item.NewRefDate}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-if="!IsUnlock" ng-click="PrintThongBaoSaiSot()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" ng-show="IsPublic" ng-click="PublishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh th\xF4ng b\xE1o</button> <button type="button" ng-click="BackPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CreateCHUNGTU_TNCN.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="CreateCHUNGTU_TNCNCtr as mainCtrl"><div class="form-horizontal"><div class="row" ng-if="importfile && !checkImport"><label class="col-sm-offset-1" style="text-align: right;"></label> <span style="padding-right: 5px !important;"></span> <span ng-show="isHasFile"><label for="fileName"><b style="color:yellow">{{$root.fileTemplate}}</b></label> &nbsp; <a ng-disabled="OpenFile" title="B\u1ECF file chi ti\u1EBFt" class="btn btn-danger btn-xs" href="" ng-click="removeFileInvoiceDetail()"><span class="glyphicon glyphicon-remove-circle"></span> B\u1ECF</a></span> <a ng-show="!checkEdit" href="" class="btn btn-info btn-xs" ng-click="uploadFileInvoiceDetail()"><span class="glyphicon glyphicon-upload"></span> T\u1EA3i l\xEAn</a> <span style="padding-right: 5px !important;"></span> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> <a ng-disabled="OpenFile" title="File m\u1EABu chi ti\u1EBFt H\u0110" href="{{FileMauChiTiet}}" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-file"></span> File m\u1EABu</a> <button ng-disabled="OpenFile" ng-if="checkEdit" ng-click="Import()" class="btn btn-primary btn-with-icon save-profile btn-xs"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="mRefDate" class="control-label">Ng\xE0y ch\u1EE9ng t\u1EEB</label> <input type="text" id="mRefDate" ng-model="mRefDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true" readonly=""></div><div class="col-sm-2"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB (<b style="color:red;">*</b>)</label><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=\'\'" ng-change="cboInvoiceTemplate_SelectedChangeEvent()" class="form-control"><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div><div class="col-sm-2"><label for="txtInvFormNo" class="control-label">M\u1EABu s\u1ED1</label> <input type="text" readonly="" id="txtInvFormNo" ng-model="mInvFormNo" ng-init="mInvFormNo=\'\'" class="form-control" placeholder="M\u1EABu s\u1ED1"></div><div class="col-sm-2"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtInvSerialNo" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtInvNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label> <input type="text" readonly="" id="txtInvNumber" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" class="form-control" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div></div><div class="form-group"><div class="col-sm-4 col-md-offset-1"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn (<b style="color:red;">*</b>)</label> <input type="text" id="txtCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" class="form-control" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2"><label for="txtTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="txtTaxCode" ng-model="mTaxCode" ng-init="mTaxCode=\'\'" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2"><label for="CCCDan" class="control-label">CCCDan</label> <input type="text" class="form-control" id="CCCDan" ng-model="CCCDan" ng-init="CCCDan=\'\'" placeholder="CCCDan"></div><div class="col-sm-2"><label for="SDThoai" class="control-label">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i (<b style="color:red;">*</b>)</label> <input type="text" id="SDThoai" ng-model="SDThoai" ng-init="SDThoai=\'\'" class="form-control" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-4 col-md-offset-1"><label for="txtAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" id="txtAddress" ng-model="mAddress" ng-init="mAddress=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9"></div><div class="col-sm-2"><label for="txtNationality" class="control-label">Qu\u1ED1c t\u1ECBch</label> <input type="text" id="txtNationality" ng-model="mNationality" ng-init="mNationality=\'Vi\u1EC7t Nam\'" class="form-control" placeholder="Qu\u1ED1c t\u1ECBch"></div><div class="col-sm-2" style="text-align: center;"><label for="txtIsResident" class="control-label">C\xE1 nh\xE2n c\u01B0 tr\xFA (<b style="color:red;">*</b>)</label> <input style="width:2.2rem;margin: auto;" type="checkbox" id="txtIsResident" ng-model="mIsResident" ng-checked="true" class="form-control"></div><div class="col-sm-2"><label for="DCTDTu" class="control-label">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" id="DCTDTu" ng-model="DCTDTu" ng-init="DCTDTu=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="txtFromDate" class="control-label">T\u1EEB ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="txtFromDate" ng-model="mFromDate" ng-init="mFromDate=\'\'" class="form-control"></div><div class="col-sm-2"><label for="txtToDate" class="control-label">\u0110\u1EBFn ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="txtToDate" ng-model="mToDate" ng-init="mToDate=\'\'" class="form-control"></div><div class="col-sm-6"><label for="txtDescr" class="control-label">Kho\u1EA3n thu nh\u1EADp (<b style="color:red;">*</b>)</label> <input type="text" id="txtDescr" ng-model="mDescr" ng-init="mDescr=\'Ti\u1EC1n c\xF4ng, ti\u1EC1n l\u01B0\u01A1ng\'" class="form-control" placeholder="Kho\u1EA3n thu nh\u1EADp"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="BHiem" class="control-label">Kho\u1EA3n \u0111\xF3ng BH b\u1EAFt bu\u1ED9c (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="BHiem" ng-model="BHiem" ng-init="BHiem=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TThien" class="control-label">Kho\u1EA3n t\u1EEB thi\u1EC7n (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TThien" ng-model="TThien" ng-init="TThien=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TTNCThue" class="control-label">Thu nh\u1EADp ch\u1ECBu thu\u1EBF (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TTNCThue" ng-model="TTNCThue" ng-init="TTNCThue=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TTNTThue" class="control-label">Thu nh\u1EADp t\xEDnh thu\u1EBF (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TTNTThue" ng-model="TTNTThue" ng-init="TTNTThue=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="SThue" class="control-label">Thu\u1EBF TNCN \u0111\xE3 kh\u1EA5u tr\u1EEB (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="SThue" ng-model="SThue" ng-init="SThue=\'0\'" ng-blur="CalTotalAmount()"></div></div><div class="form-group"><div class="col-sm-10 col-md-offset-1"><label for="GChu" class="control-label">Ghi ch\xFA</label> <textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="GChu" id="GChu"></textarea></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-disabled="IsDisabled" ng-if="IsReview" ng-click="Review()" class="btn btn-info btn-with-icon save-profile"><i class="ion-information"></i>Xem tr\u01B0\u1EDBc</button><button type="button" ng-disabled="IsDisabled" ng-show="IsPublic" ng-click="PublishInvoice()" class="btn btn-success btn-with-icon save-profile"><i class="ion-clipboard"></i>Ph\xE1t h\xE0nh XML</button> <button type="button" ng-disabled="IsDisabled" ng-click="BackPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/CreateCHUNGTU_TNCN_THAYDOI.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="CreateCHUNGTU_TNCN_THAYDOICtrl as mainCtrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="old_mRefDate" class="control-label" style="color: yellowgreen;">Ng\xE0y ch\u1EE9ng t\u1EEB c\u0169</label> <input type="text" id="old_mRefDate" ng-model="old_mRefDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true" readonly=""></div><div class="col-sm-2"><label for="old_mInvSerialNo" class="control-label" style="color: yellowgreen;">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtOldSymbol" ng-model="old_mInvSerialNo" ng-init="old_mInvSerialNo=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="old_mInvNumber" class="control-label" style="color: yellowgreen;">S\u1ED1 ch\u1EE9ng t\u1EEB c\u0169</label> <input type="text" readonly="" id="old_mInvNumber" ng-model="old_mInvNumber" ng-init="old_mInvNumber=\'\'" class="form-control" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="mRefDate" class="control-label">Ng\xE0y ch\u1EE9ng t\u1EEB</label> <input type="text" id="mRefDate" ng-model="mRefDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true" readonly=""></div><div class="col-sm-2"><label for="cboInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB (<b style="color:red;">*</b>)</label><select id="cboInvoiceTemplate" ng-model="mInvoiceTemplateID" ng-init="mInvoiceTemplateID=\'\'" ng-change="cboInvoiceTemplate_SelectedChangeEvent()" class="form-control"><option ng-repeat="x in arrInvoiceTemplate" value="{{x.ID}}">{{x.invoiceTemplateName}}</option></select></div><div class="col-sm-2"><label for="txtInvFormNo" class="control-label">M\u1EABu s\u1ED1</label> <input type="text" readonly="" id="txtInvFormNo" ng-model="mInvFormNo" ng-init="mInvFormNo=\'\'" class="form-control" placeholder="M\u1EABu s\u1ED1"></div><div class="col-sm-2"><label for="txtInvSerialNo" class="control-label">K\xFD hi\u1EC7u</label> <input type="text" readonly="" id="txtInvSerialNo" ng-model="mInvSerialNo" ng-init="mInvSerialNo=\'\'" class="form-control" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2"><label for="txtInvNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label> <input type="text" readonly="" id="txtInvNumber" ng-model="mInvNumber" ng-init="mInvNumber=\'\'" class="form-control" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div></div><div class="form-group"><div class="col-sm-4 col-md-offset-1"><label for="mCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn (<b style="color:red;">*</b>)</label> <input type="text" id="mCustomerName" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" class="form-control" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2"><label for="txtTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label> <input type="text" class="form-control" id="txtTaxCode" ng-model="mTaxCode" ng-init="mTaxCode=\'\'" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2"><label for="CCCDan" class="control-label">CCCDan</label> <input type="text" class="form-control" id="CCCDan" ng-model="CCCDan" ng-init="CCCDan=\'\'" placeholder="CCCDan"></div><div class="col-sm-2"><label for="SDThoai" class="control-label">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i (<b style="color:red;">*</b>)</label> <input type="text" id="SDThoai" ng-model="SDThoai" ng-init="SDThoai=\'\'" class="form-control" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-4 col-md-offset-1"><label for="txtAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label> <input type="text" id="txtAddress" ng-model="mAddress" ng-init="mAddress=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9"></div><div class="col-sm-2"><label for="txtNationality" class="control-label">Qu\u1ED1c t\u1ECBch</label> <input type="text" id="txtNationality" ng-model="mNationality" ng-init="mNationality=\'Vi\u1EC7t Nam\'" class="form-control" placeholder="Qu\u1ED1c t\u1ECBch"></div><div class="col-sm-2" style="text-align: center;"><label for="txtIsResident" class="control-label">C\xE1 nh\xE2n c\u01B0 tr\xFA (<b style="color:red;">*</b>)</label> <input style="width:2.2rem;margin: auto;" type="checkbox" id="txtIsResident" ng-model="mIsResident" ng-checked="true" class="form-control"></div><div class="col-sm-2"><label for="DCTDTu" class="control-label">\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED</label> <input type="text" id="DCTDTu" ng-model="DCTDTu" ng-init="DCTDTu=\'\'" class="form-control" placeholder="\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="mFromDate" class="control-label">T\u1EEB ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="mFromDate" ng-model="mFromDate" ng-init="mFromDate=\'\'" class="form-control"></div><div class="col-sm-2"><label for="mToDate" class="control-label">\u0110\u1EBFn ng\xE0y (<b style="color:red;">*</b>)</label> <input type="date" id="mToDate" ng-model="mToDate" ng-init="mToDate=\'\'" class="form-control"></div><div class="col-sm-6"><label for="mDescr" class="control-label">Kho\u1EA3n thu nh\u1EADp (<b style="color:red;">*</b>)</label> <input type="text" id="mDescr" ng-model="mDescr" ng-init="mDescr=\'Ti\u1EC1n c\xF4ng, ti\u1EC1n l\u01B0\u01A1ng\'" class="form-control" placeholder="Kho\u1EA3n thu nh\u1EADp"></div></div><div class="form-group"><div class="col-sm-2 col-md-offset-1"><label for="BHiem" class="control-label">Kho\u1EA3n \u0111\xF3ng BH b\u1EAFt bu\u1ED9c (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="BHiem" ng-model="BHiem" ng-init="BHiem=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TThien" class="control-label">Kho\u1EA3n t\u1EEB thi\u1EC7n (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TThien" ng-model="TThien" ng-init="TThien=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TTNCThue" class="control-label">Thu nh\u1EADp ch\u1ECBu thu\u1EBF (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TTNCThue" ng-model="TTNCThue" ng-init="TTNCThue=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="TTNTThue" class="control-label">Thu nh\u1EADp t\xEDnh thu\u1EBF (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="TTNTThue" ng-model="TTNTThue" ng-init="TTNTThue=\'0\'" ng-blur="CalTotalAmount()"></div><div class="col-sm-2"><label for="SThue" class="control-label">Thu\u1EBF TNCN \u0111\xE3 kh\u1EA5u tr\u1EEB (<b style="color:red;">*</b>)</label> <input type="text" maxlength="15" class="form-control" number-input="" id="SThue" ng-model="SThue" ng-init="SThue=\'0\'" ng-blur="CalTotalAmount()"></div></div><div class="form-group"><div class="col-sm-10 col-md-offset-1"><label for="LDo" class="control-label">L\xFD do thay \u0111\u1ED5i (<b style="color:red;">*</b>)</label> <textarea placeholder="L\xFD do" class="form-control" ng-model="LDo" id="LDo"></textarea></div></div><div class="form-group"><div class="col-sm-10 col-md-offset-1"><label for="GChu" class="control-label">Ghi ch\xFA</label> <textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="GChu" id="GChu"></textarea></div></div></div></div><div style="text-align: center !important;"><button type="button" ng-if="IsUnlock" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" ng-if="ShowTBSS" ng-click="TBSS()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-clipboard"></i>Xem TBSS</button> <button type="button" ng-click="backPage()" class="btn btn-danger btn-with-icon save-profile"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div>');
$templateCache.put('app/pages/ND70/CHUNGTU/SearchCHUNGTU_THAYDOI.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content" ng-controller="SearchCHUNGTU_THAYDOICtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="Status.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.TenTinhTrang}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.TenTinhTrang | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="InvNumber" class="control-label">S\u1ED1 ch\u1EE9ng t\u1EEB</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="InvNumber" ng-init="InvNumber=\'\'" id="InvNumber" placeholder="S\u1ED1 ch\u1EE9ng t\u1EEB"></div><div class="col-sm-2" style="text-align: right;"><label for="InvSerialNo" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="InvSerialNo" ng-init="InvSerialNo=\'\'" id="InvSerialNo" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="txtCustomerName" class="control-label">H\u1ECD v\xE0 t\xEAn</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="mCustomerName" ng-init="mCustomerName=\'\'" id="txtCustomerName" placeholder="H\u1ECD v\xE0 t\xEAn"></div><div class="col-sm-2" style="text-align: right;"><label for="txtRefNbr" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="TaxCode" ng-init="TaxCode=\'\'" id="TaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="FindData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="backPage()"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="arrData" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="InvNumber">S\u1ED1 ch\u1EE9ng t\u1EEB</th><th st-sort="RefDate">Ng\xE0y ch\u1EE9ng t\u1EEB</th><th st-sort="InvSerialNo">K\xFD hi\u1EC7u</th><th st-sort="companyName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="TaxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="totalAmount">T\u1ED5ng s\u1ED1 ti\u1EC1n</th><td>T\xECnh tr\u1EA1ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.OrderNo}}</td><td class="text-center"><a title="Ch\u1ECDn ch\u1EE9ng t\u1EEB" class="btn btn-primary btn-xs" href="" ng-click="ReturnParent(item.ND70_CHUNGTU_ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{("0000000"+item.InvNumber).slice(-7)}}</td><td>{{item.RefDate}}</td><td>{{item.InvSerialNo}}</td><td>{{item.customerName}}</td><td>{{item.TaxCode}}</td><td>{{item.totalAmount}}</td><td>{{item.statusName}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/currencyOfPayment/createCurrencyOfPayment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCurrencyOfPaymentId" class="control-label">M\xE3 ti\u1EC1n thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputCurrencyOfPaymentId" id="inputCurrencyOfPaymentId" placeholder="M\xE3 ti\u1EC1n thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCurrencyOfPaymentName" class="control-label">T\xEAn ti\u1EC1n thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCurrencyOfPaymentName" id="inputCurrencyOfPaymentName" placeholder="T\xEAn ti\u1EC1n thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputExchangeRate" class="control-label">T\u1EF7 l\u1EC7 h\u1ED1i \u0111o\xE1i (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputExchangeRate" id="inputExchangeRate" placeholder="T\u1EF7 l\u1EC7 h\u1ED1i \u0111o\xE1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.currencyOfPayment"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/currencyOfPayment/currencyOfPayment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin ti\u1EC1n thanh to\xE1n"><div class="panel-content" ng-controller="CurrencyOfPaymentPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCurrencyOfPaymentId" class="control-label">M\xE3 ti\u1EC1n thanh to\xE1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCurrencyOfPaymentId" id="inputCurrencyOfPaymentId" placeholder="M\xE3 ti\u1EC1n thanh to\xE1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCurrencyOfPaymentName" class="control-label">T\xEAn ti\u1EC1n thanh to\xE1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCurrencyOfPaymentName" id="inputCurrencyOfPaymentName" placeholder="T\xEAn ti\u1EC1n thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createCurrencyOfPayment"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="currencyOfPaymentId">M\xE3 ti\u1EC1n thanh to\xE1n</th><th st-sort="currencyOfPaymentName">T\xEAn ti\u1EC1n thanh to\xE1n</th><th st-sort="exchangeRate">T\u1EF7 l\u1EC7 h\u1ED1i \u0111o\xE1i</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createCurrencyOfPayment\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.currencyOfPaymentId}}</td><td>{{item.currencyOfPaymentName}}</td><td>{{item.exchangeRate | currency:""}} VND</td><td>{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/document/document.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin m\u1EABu b\xE1o c\xE1o"><div class="panel-content" ng-controller="DocumentPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDocumentName" class="control-label">T\xEAn m\u1EABu b\xE1o c\xE1o</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputDocumentName" id="inputDocumentName" placeholder="T\xEAn m\u1EABu b\xE1o c\xE1o"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="templateName">T\xEAn m\u1EABu b\xE1o c\xE1o</th><th st-sort="fileName">File m\u1EABu</th><th st-sort="fileName">Start Row</th><th st-sort="fileName">Start Column</th><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/updateDocument\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.documentName}}</td><td><a href="{{item.PathFileTemplate}}" target="_blank">{{item.fileName}}</a></td><td>{{item.startRow}}</td><td>{{item.startCol}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></div><div ng-if="checkShow(item.isActive) == 1"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/document/updateDocument.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDocumentCode" class="control-label">M\xE3 m\u1EABu b\xE1o c\xE1o (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" readonly="" class="form-control" ng-model="inputDocumentCode" id="inputDocumentCode" placeholder="M\xE3 m\u1EABu b\xE1o c\xE1o"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDocumentName" class="control-label">T\xEAn m\u1EABu b\xE1o c\xE1o (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" readonly="" ng-model="inputDocumentName" id="inputDocumentName" placeholder="T\xEAn m\u1EABu b\xE1o c\xE1o"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">File m\u1EABu (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><button type="button" ng-click="uploadFile()" class="btn btn-info btn-with-icon"><i class="ion-chevron-up"></i>Ch\u1ECDn file</button> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> <label for="fileName"><b style="color:black">{{$root.fileTemplate}}</b></label></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">Thu\u1EBF ri\xEAng bi\u1EC7t?</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-click="checkSeperateTax(inputIsActive)" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStartRow" class="control-label">Start Row (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-number-only="" ng-model="inputStartRow" id="inputStartRow" placeholder="Start Row"></div><div class="col-sm-2" style="text-align: right;"><label for="inputStartCol" class="control-label">Start Column (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-number-only="" ng-model="inputStartCol" id="inputStartCol" placeholder="Start Column"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.document"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/goodAndService/createGoodAndService.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputGoodAndServiceId" class="control-label">M\xE3 h\xE0ng h\xF3a (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputGoodAndServiceId" id="inputGoodAndServiceId" placeholder="M\xE3 h\xE0ng h\xF3a"></div><div class="col-sm-2" style="text-align: right;"><label for="inputGoodAndServiceName" class="control-label">T\xEAn h\xE0ng h\xF3a (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputGoodAndServiceName" id="inputGoodAndServiceName" placeholder="T\xEAn h\xE0ng h\xF3a"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPrice" class="control-label">Gi\xE1 ti\u1EC1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" format="number" allow-only-numbers="" ng-model="inputPrice" id="inputPrice" placeholder="Gi\xE1 ti\u1EC1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputVAT" class="control-label">% VAT (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" allow-only-numbers="" ng-model="inputVAT" id="inputVAT" placeholder="VAT"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">Lo\u1EA1i h\xE0ng h\xF3a (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectCategoryPageCtrl as CategoryCtrl"><ui-select focus-on="SetFocusCategory" ng-model="Category.selected" ng-change="selectCategory(Category.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.categoryName}}</ui-select-match><ui-select-choices repeat="Category in Categories | filter: $select.search"><span ng-bind-html="Category.categoryName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputUnitId" class="control-label">\u0110\u01A1n v\u1ECB t\xEDnh (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectUnitPageCtrl as UnitCtrl"><ui-select focus-on="SetFocusUnit" ng-model="Unit.selected" ng-change="selectUnit(Unit.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.unitName}}</ui-select-match><ui-select-choices repeat="Unit in Units | filter: $select.search"><span ng-bind-html="Unit.unitName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.goodAndService"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/goodAndService/goodAndService.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin h\xE0ng h\xF3a & d\u1ECBch v\u1EE5"><div class="panel-content" ng-controller="GoodAndServicePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputGoodAndServiceId" class="control-label">M\xE3 h\xE0ng h\xF3a</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputGoodAndServiceId" id="inputGoodAndServiceId" placeholder="M\xE3 h\xE0ng h\xF3a"></div><div class="col-sm-2" style="text-align: right;"><label for="inputGoodAndServiceName" class="control-label">T\xEAn h\xE0ng h\xF3a</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputGoodAndServiceName" id="inputGoodAndServiceName" placeholder="T\xEAn h\xE0ng h\xF3a"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">Lo\u1EA1i h\xE0ng h\xF3a</label></div><div class="col-sm-3" ng-controller="SelectCategoryPageCtrl as CategoryCtrl"><ui-select ng-model="Category.selected" ng-change="selectChanged(Category.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.categoryName}}</ui-select-match><ui-select-choices repeat="Category in Categories | filter: $select.search"><span ng-bind-html="Category.categoryName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createGoodAndService"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="goodAndServiceId">M\xE3 h\xE0ng h\xF3a</th><th st-sort="goodAndServiceName">T\xEAn h\xE0ng h\xF3a</th><th st-sort="unitId">\u0110\u01A1n v\u1ECB t\xEDnh</th><th st-sort="price">\u0110\u01A1n gi\xE1 (VND)</th><th st-sort="VAT">VAT (%)</th><th st-sort="categoryId">Lo\u1EA1i h\xE0ng h\xF3a</th><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createGoodAndService\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.goodAndServiceId}}</td><td>{{item.goodAndServiceName}}</td><td>{{item.unitName}}</td><td>{{item.price | currency:"":0}}</td><td>{{item.VAT}}</td><td>{{item.categoryName}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/department/department.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin ph\xF2ng ban"><div class="panel-content" ng-controller="DepartmentCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDepartmentName" class="control-label">T\xEAn ph\xF2ng ban</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputDepartmentName" id="inputDepartmentName" placeholder="T\xEAn ph\xF2ng ban"></div><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.updateDepartment"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,25,50,100,200]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="DepartmentCode">M\xE3 ph\xF2ng ban</th><th st-sort="DepartmentName">T\xEAn ph\xF2ng ban</th><th st-sort="Description">M\xF4 t\u1EA3</th><th st-sort="DateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td>Nh\xE2n s\u1EF1 (Ph\xF2ng ban)</td><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/updateDepartment\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.DepartmentCode}}</td><td>{{item.DepartmentName}}</td><td>{{item.Description}}</td><td>{{item.DateUpdated}}</td><td style="text-align: center;"><a title="Nh\xE2n s\u1EF1 (Ph\xF2ng ban)" class="btn btn-default btn-xs" href="" ng-click="open(\'#/manageUserDepartment\',item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-wrench"></span></a></td><td style="text-align: center;"><div ng-if="checkShow(item.IsActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.IsActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/department/manageUserDepartment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Th\xEAm nh\xE2n s\u1EF1 v\xE0o Ph\xF2ng ban"><div class="panel-content" ng-controller="ManageUserDepartmentCtrl as ctrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputUserName" class="control-label">Ng\u01B0\u1EDDi d\xF9ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocusUser" ng-model="User.selected" ng-change="changeUser(User.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.FullName}}</ui-select-match><ui-select-choices repeat="User in Users | filter: $select.search"><span ng-bind-html="User.FullName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="horizontal-scroll"><table class="table table-striped"><tbody><tr ng-repeat="item in displayedCollection"><td style="width:25%;">{{$index + 1}}</td><td style="width:40%;">{{item.FullName}}</td><td><a class="btn btn-danger btn-xs" href="" ng-click="removeUser(item)"><span class="glyphicon glyphicon-remove"></span></a></td></tr></tbody></table></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/department\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/department/updateDepartment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDepartmentCode" class="control-label">M\xE3 ph\xF2ng ban (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputDepartmentCode" id="inputDepartmentCode" placeholder="M\xE3 ph\xF2ng ban"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDepartmentName" class="control-label">T\xEAn ph\xF2ng ban (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputDepartmentName" id="inputDepartmentName" placeholder="T\xEAn ph\xF2ng ban"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.department"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/supplier/createSupplier.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSupplierName" class="control-label">T\xEAn nh\xE0 cung c\u1EA5p (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputSupplierName" id="inputSupplierName" placeholder="T\xEAn nh\xE0 cung c\u1EA5p"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi giao d\u1ECBch (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi giao d\u1ECBch"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputAddress" id="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label id="selectCityId" for="inputCityId" class="control-label">T\u1EC9nh/Th\xE0nh ph\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="City.selected" ng-change="selectChanged(City.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.cityName}}</ui-select-match><ui-select-choices repeat="City in Cities | filter: $select.search"><span ng-bind-html="City.cityName | highlight: $select.search"></span> <small ng-bind-html="City.cityId | highlight: $select.search"></small></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputEmail" class="control-label">Email</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button><button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.supplier"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/supplier/supplier.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin nh\xE0 cung c\u1EA5p"><div class="panel-content" ng-controller="SupplierPageCtrl as suppCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" readonly="" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" id="inputToDate" ng-change="checkFromToDate()" readonly="" ng-model="inputToDate" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSupplierName" class="control-label">T\xEAn nh\xE0 cung c\u1EA5p</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSupplierName" id="inputSupplierName" placeholder="T\xEAn nh\xE0 cung c\u1EA5p"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCityId" class="control-label">T\u1EC9nh/Th\xE0nh ph\u1ED1</label></div><div class="col-sm-3" ng-controller="SelectCityPageCtrl as cityCtrl"><ui-select ng-model="selections[$index]" ng-change="selectionChanged($index)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.cityName}}</ui-select-match><ui-select-choices repeat="City in Cities | filter: $select.search"><span ng-bind-html="City.cityName | highlight: $select.search"></span> <small ng-bind-html="City.cityId | highlight: $select.search"></small></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createSupplier"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="suppCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="customerName">T\xEAn nh\xE0 cung c\u1EA5p</th><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="contactPerson">Ng\u01B0\u1EDDi li\xEAn h\u1EC7</th><td>\u0110i\u1EC7n tho\u1EA1i</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createSupplier\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.supplierName}}</td><td>{{item.taxCode}}</td><td>{{item.contactPerson}}</td><td>{{item.phone}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/taxAuthority/createTaxAuthority.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthorityId" class="control-label">M\xE3 c\u01A1 quan thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputTaxAuthorityId" id="inputTaxAuthorityId" placeholder="M\xE3 c\u01A1 quan thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthorityName" class="control-label">T\xEAn c\u01A1 quan thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputTaxAuthorityName" id="inputTaxAuthorityName" placeholder="T\xEAn c\u01A1 quan thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputAddress" id="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.taxAuthority"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/taxAuthority/taxAuthority.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin c\u01A1 quan thu\u1EBF"><div class="panel-content" ng-controller="TaxAuthorityPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthorityId" class="control-label">M\xE3 c\u01A1 quan thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxAuthorityId" id="inputTaxAuthorityId" placeholder="M\xE3 c\u01A1 quan thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthorityName" class="control-label">T\xEAn c\u01A1 quan thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxAuthorityName" id="inputTaxAuthorityName" placeholder="T\xEAn c\u01A1 quan thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createTaxAuthority"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="taxAuthorityId">M\xE3 c\u01A1 quan thu\u1EBF</th><th st-sort="taxAuthorityName">T\xEAn c\u01A1 quan thu\u1EBF</th><th>\u0110\u1ECBa ch\u1EC9</th><th>\u0110i\u1EC7n tho\u1EA1i</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createTaxAuthority\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.taxAuthorityId}}</td><td>{{item.taxAuthorityName}}</td><td>{{item.address}}</td><td>{{item.phone}}</td><td>{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/customer/createCustomer.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocusEnt" ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn kh\xE1ch h\xE0ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn kh\xE1ch h\xE0ng"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerCode" class="control-label">M\xE3 kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerCode" id="inputCustomerCode" placeholder="M\xE3 kh\xE1ch h\xE0ng"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddress" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputAddress" id="inputAddress" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label id="selectCityId" for="inputCityId" class="control-label">T\u1EC9nh/Th\xE0nh ph\u1ED1 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="City.selected" ng-change="selectChanged(City.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.cityName}}</ui-select-match><ui-select-choices repeat="City in Cities | filter: $select.search"><span ng-bind-html="City.cityName | highlight: $select.search"></span> <small ng-bind-html="City.cityId | highlight: $select.search"></small></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputEmail" class="control-label">Email</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.customer"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/customer/customer.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin kh\xE1ch h\xE0ng"><div class="panel-content" ng-controller="CustomerPageCtrl as custCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn kh\xE1ch h\xE0ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCityId" class="control-label">T\u1EC9nh/Th\xE0nh ph\u1ED1</label></div><div class="col-sm-3" ng-controller="SelectCityPageCtrl as cityCtrl"><ui-select ng-model="selections[$index]" ng-change="selectionChanged($index)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.cityName}}</ui-select-match><ui-select-choices repeat="City in Cities | filter: $select.search"><span ng-bind-html="City.cityName | highlight: $select.search"></span> <small ng-bind-html="City.cityId | highlight: $select.search"></small></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createCustomer"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button><button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="custCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="customerName">T\xEAn kh\xE1ch h\xE0ng</th><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="customerCode">M\xE3 kh\xE1ch h\xE0ng</th><td>\u0110i\u1EC7n tho\u1EA1i</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createCustomer\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.customerName}}</td><td>{{item.taxCode}}</td><td>{{item.customerCode}}</td><td>{{item.phone}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/template/createTemplate.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocusEnt" ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">M\xE3 m\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTemplateCode" id="inputTemplateCode" placeholder="M\xE3 m\u1EABu h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryName" class="control-label">T\xEAn m\u1EABu h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputTemplateName" id="inputTemplateName" placeholder="T\xEAn m\u1EABu h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryId" class="control-label">File m\u1EABu (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><button type="button" ng-click="uploadFile()" class="btn btn-info btn-with-icon"><i class="ion-chevron-up"></i>Ch\u1ECDn file</button> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"> <label for="fileName"><b style="color:black">{{$root.fileTemplate}}</b></label></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.template"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/template/template.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin m\u1EABu h\xF3a \u0111\u01A1n"><div class="panel-content" ng-controller="TemplatePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTemplateName" class="control-label">T\xEAn m\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTemplateName" id="inputTemplateName" placeholder="T\xEAn m\u1EABu h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTemplateCode" class="control-label">M\xE3 m\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTemplateCode" id="inputTemplateCode" placeholder="M\xE3 m\u1EABu h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createTemplate"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button><button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="templateName">T\xEAn m\u1EABu h\xF3a \u0111\u01A1n</th><th st-sort="templateCode">M\xE3 m\u1EABu</th><th st-sort="fileName">File m\u1EABu</th><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createTemplate\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.templateName}}</td><td>{{item.templateCode}}</td><td><a href="{{item.PathFileTemplate}}" target="_blank">{{item.fileName}}</a></td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/typeOfPayment/createTypeOfPayment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputTypeOfPaymentId" class="control-label">M\xE3 h\xECnh th\u1EE9c thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputTypeOfPaymentId" id="inputTypeOfPaymentId" placeholder="M\xE3 h\xECnh th\u1EE9c thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputTypeOfPaymentName" class="control-label">T\xEAn h\xECnh th\u1EE9c thanh to\xE1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputTypeOfPaymentName" id="inputTypeOfPaymentName" placeholder="T\xEAn h\xECnh th\u1EE9c thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.typeOfPayment"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/typeOfPayment/typeOfPayment.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin h\xECnh th\u1EE9c thanh to\xE1n"><div class="panel-content" ng-controller="TypeOfPaymentPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfPaymentId" class="control-label">M\xE3 h\xECnh th\u1EE9c thanh to\xE1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfPaymentId" id="inputTypeOfPaymentId" placeholder="M\xE3 h\xECnh th\u1EE9c thanh to\xE1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfPaymentName" class="control-label">T\xEAn h\xECnh th\u1EE9c thanh to\xE1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfPaymentName" id="inputTypeOfPaymentName" placeholder="T\xEAn h\xECnh th\u1EE9c thanh to\xE1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createTypeOfPayment"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="typeOfPaymentId">M\xE3 h\xECnh th\u1EE9c thanh to\xE1n</th><th st-sort="typeOfPaymentName">T\xEAn h\xECnh th\u1EE9c thanh to\xE1n</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createTypeOfPayment\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td style="width: 8%; text-align: center">{{item.typeOfPaymentId}}</td><td style="width: 25%">{{item.typeOfPaymentName}}</td><td style="width: 25%">{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/typeOfRevenue/createTypeOfRevenue.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocusEnt" ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryName" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="TypeOfInvoice.selected" ng-change="changeTypeOfInvoice(TypeOfInvoice.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfInvoiceName}}</ui-select-match><ui-select-choices repeat="TypeOfInvoice in TypeOfInvoices | filter: $select.search"><span ng-bind-html="TypeOfInvoice.typeOfInvoiceName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfRevenueCode" class="control-label">M\xE3 lo\u1EA1i doanh thu (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputTypeOfRevenueCode" id="inputTypeOfRevenueCode" placeholder="M\xE3 lo\u1EA1i doanh thu"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputtypeOfRevenueName" class="control-label">T\xEAn lo\u1EA1i doanh thu (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputTypeOfRevenueName" id="inputTypeOfRevenueName" placeholder="T\xEAn lo\u1EA1i doanh thu"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.typeOfRevenue"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/typeOfRevenue/typeOfRevenue.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="TypeOfRevenuePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfRevenueCode" class="control-label">M\xE3 lo\u1EA1i doanh thu</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfRevenueCode" id="inputTypeOfRevenueCode" placeholder="M\xE3 lo\u1EA1i doanh thu"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfRevenueName" class="control-label">T\xEAn lo\u1EA1i doanh thu</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfRevenueName" id="inputTypeOfRevenueName" placeholder="T\xEAn lo\u1EA1i doanh thu"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCategoryName" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="TypeOfInvoice.selected" ng-change="changeTypeOfInvoice(TypeOfInvoice.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.typeOfInvoiceName}}</ui-select-match><ui-select-choices repeat="TypeOfInvoice in TypeOfInvoices | filter: $select.search"><span ng-bind-html="TypeOfInvoice.typeOfInvoiceName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createTypeOfRevenue"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="typeOfRevenueCode">M\xE3 lo\u1EA1i doanh thu</th><th st-sort="typeOfRevenueName">T\xEAn lo\u1EA1i doanh thu</th><th st-sort="typeOfRevenueName">Lo\u1EA1i h\xF3a \u0111\u01A1n</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createTypeOfRevenue\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td style="width: 8%; text-align: center">{{item.typeOfRevenueCode}}</td><td style="width: 25%">{{item.typeOfRevenueName}}</td><td style="width: 25%">{{item.typeOfInvoiceName}}</td><td style="width: 25%">{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/lists/typeOfInvoice/createTypeOfInvoice.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocusEnt" ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfInvoiceCode" class="control-label">M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputTypeOfInvoiceCode" id="inputTypeOfInvoiceCode" placeholder="M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputtypeOfInvoiceName" class="control-label">T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputTypeOfInvoiceName" id="inputTypeOfInvoiceName" placeholder="T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.typeOfInvoice"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/typeOfInvoice/typeOfInvoice.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin lo\u1EA1i h\xF3a \u0111\u01A1n"><div class="panel-content" ng-controller="TypeOfInvoicePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfInvoiceCode" class="control-label">M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfInvoiceCode" id="inputTypeOfInvoiceCode" placeholder="M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTypeOfInvoiceName" class="control-label">T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTypeOfInvoiceName" id="inputTypeOfInvoiceName" placeholder="T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createTypeOfInvoice"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button><button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="typeOfInvoiceId">M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n</th><th st-sort="typeOfInvoiceName">T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createTypeOfInvoice\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td style="width: 8%; text-align: center">{{item.typeOfInvoiceCode}}</td><td style="width: 25%">{{item.typeOfInvoiceName}}</td><td style="width: 25%">{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/reports/inventoryInvoice/inventoryInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="InventoryInvoicePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-2" style="text-align: right;"><label class="control-label">N\u0103m</label></div><div class="col-sm-3"><ui-select ng-model="Year.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="Year in Years | filter: $select.search"><span ng-bind-html="Year.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td rowspan="2" style="text-align: center;">#</td><th rowspan="2" style="vertical-align:top;" st-sort="unitId">M\xE3 lo\u1EA1i h\xF3a \u0111\u01A1n</th><th rowspan="2" style="vertical-align:top;" st-sort="unitName">T\xEAn lo\u1EA1i h\xF3a \u0111\u01A1n</th><th rowspan="2" style="vertical-align:top;" st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th rowspan="2" style="vertical-align:top;" st-sort="symbol">K\xFD hi\u1EC7u</th><td colspan="3" style="text-align:center;">Ph\xE1t h\xE0nh</td><td rowspan="2" style="vertical-align:top;text-align:center;">\u0110\xE3 s\u1EED d\u1EE5ng</td><td rowspan="2" style="vertical-align:top;text-align:center;">Ch\u01B0a s\u1EED d\u1EE5ng</td><td rowspan="2" style="vertical-align:top;text-align:center;">\u0110\xE3 h\u1EE7y</td></tr><tr><td style="text-align:center;">S\u1ED1 l\u01B0\u1EE3ng</td><td style="text-align:center;">T\u1EEB s\u1ED1</td><td style="text-align:center;">\u0110\u1EBFn s\u1ED1</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.typeOfInvoiceCode}}</td><td>{{item.typeOfInvoiceName}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.symbol}}</td><td style="text-align:center;">{{item.quantity | number}}</td><td style="text-align:center;">{{item.fromNumber | number}}</td><td style="text-align:center;">{{item.toNumber | number}}</td><td style="text-align:center;">{{item.isUsed | number}}</td><td style="text-align:center;">{{item.notUsed | number}}</td><td style="text-align:center;">{{item.isCancel | number}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/reports/reportMain/createReportMain.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="UpdateReportMainPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label class="control-label">Qu\xFD</label></div><div class="col-sm-3"><ui-select ng-model="Quarter.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="Quarter in Quarters | filter: $select.search"><span ng-bind-html="Quarter.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label class="control-label">N\u0103m</label></div><div class="col-sm-3"><ui-select ng-model="Year.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="Year in Years | filter: $select.search"><span ng-bind-html="Year.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="exportReportXML()" class="btn btn-success btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t XML</button> <button type="button" ng-click="exportReportExcel()" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <a href="http://nhantokhai.gdt.gov.vn/ihtkk_nnt/home_public.jsp" target="_blank" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>N\u1ED9p b\xE1o c\xE1o</a> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reportMain"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div>');
$templateCache.put('app/pages/reports/reportMain/reportMain.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="ReportMainPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputStartDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputStartDate" ng-change="checkStartEndDate()" ng-model="inputStartDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedStart" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputEndDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputEndDate" ng-change="checkStartEndDate()" ng-model="inputEndDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedEnd" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createReportMain"><i class="ion-plus-round"></i>L\u1EADp m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="Quarter">K\u1EF3 k\xEA khai</th><th st-sort="YearDeclare">N\u0103m</th><th st-sort="dateCreated">Ng\xE0y l\u1EADp</th><th st-sort="FullName">Ng\u01B0\u1EDDi l\u1EADp</th><td style="text-align: center;">B\xE1o c\xE1o XML</td><td style="text-align: center;">B\xE1o c\xE1o Excel</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.Quarter}}</td><td>{{item.YearDeclare}}</td><td>{{item.dateCreated}}</td><td>{{item.FullName}}</td><td class="text-center"><a href="" ng-click="exportXML(item.QuarterDeclare, item.YearDeclare)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-file"></span></a></td><td class="text-center"><a href="" ng-click="exportExcel(item.QuarterDeclare, item.YearDeclare)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-th-list"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/reports/reportInvoiceDetail/reportInvoiceDetail.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="ReportInvoiceDetailPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" class="form-control" id="inputFromDate" ng-model="inputFromDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" readonly="" id="inputToDate" ng-model="inputToDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectStatusPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChangedStatus(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn kh\xE1ch h\xE0ng"></div></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" ng-click="exportReport2Excel()" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" ng-click="exportReport2PDF()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t PDF</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="billNumber" style="text-align: center;">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="dateOfInvoice">Ng\xE0y h\xF3a \u0111\u01A1n</th><th st-sort="invoiceTemplateCode">M\u1EABu s\u1ED1</th><th st-sort="symbol">K\xFD hi\u1EC7u</th><td>Ti\u1EC1n h\xE0ng</td><td>Ti\u1EC1n VAT</td><td>T\u1ED5ng ti\u1EC1n thanh to\xE1n</td><td>T\xECnh tr\u1EA1ng h\xF3a \u0111\u01A1n</td><td>Ng\u01B0\u1EDDi l\u1EADp</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center">{{("0000000"+item.billNumber).slice(-7)}}</td><td>{{item.dateOfInvoice}}</td><td>{{item.invoiceTemplateCode}}</td><td>{{item.symbol}}</td><td>{{item.totalAmountNotVAT | currency:"":0}}</td><td>{{item.VATAmount | currency:"":0}}</td><td>{{item.totalAmount | currency:"":0}}</td><td>{{item.statusName}}</td><td>{{item.FullName}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/reports/statementOfInvoice/statementOfInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="StatementOfInvoicePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" class="form-control" id="inputFromDate" ng-model="inputFromDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" class="form-control" readonly="" id="inputToDate" ng-model="inputToDate" ng-change="checkFromToDate()" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputBillNumber" class="control-label">S\u1ED1 h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputBillNumber" id="inputBillNumber" placeholder="S\u1ED1 h\xF3a \u0111\u01A1n"></div><div class="col-sm-2" style="text-align: right;"><label for="inputInvoiceTemplate" class="control-label">M\u1EABu h\xF3a \u0111\u01A1n</label></div><div class="col-sm-3" ng-controller="SelectInvoiceTemplatePageCtrl as ctrlTemplate"><ui-select ng-model="InvoiceTemplate.selected" ng-change="selectChangedInvoiceTemplate(InvoiceTemplate.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.invoiceTemplateName}}</ui-select-match><ui-select-choices repeat="InvoiceTemplate in InvoiceTemplates | filter: $select.search"><span ng-bind-html="InvoiceTemplate.invoiceTemplateName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSymbol" class="control-label">K\xFD hi\u1EC7u</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputSymbol" id="inputSymbol" placeholder="K\xFD hi\u1EC7u"></div><div class="col-sm-2" style="text-align: right;"><label for="inputCustomerName" class="control-label">T\xEAn kh\xE1ch h\xE0ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputCustomerName" id="inputCustomerName" placeholder="T\xEAn kh\xE1ch h\xE0ng"></div></div><div class="form-group"></div></div><div style="text-align: center !important;"><button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" ng-click="exportReport2Excel()" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" ng-click="exportReport2PDF()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t PDF</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="billNumber">S\u1ED1 h\xF3a \u0111\u01A1n</th><th st-sort="goodAndServiceName">Chi ti\u1EBFt</th><th>Doanh thu ch\u01B0a thu\u1EBF</th><th st-sort="VAT">Thu\u1EBF su\u1EA5t</th><th>Ti\u1EC1n thu\u1EBF</th><th>T\u1ED5ng c\u1ED9ng</th><th>Ng\u01B0\u1EDDi l\u1EADp</th></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.billNumber}}</td><td>{{item.goodAndServiceName}}</td><td>{{item.amountNotVAT | currency:"":0}}</td><td>{{item.VAT}}</td><td>{{item.VATAmount | currency:"":0}}</td><td>{{item.amountVAT | currency:"":0}}</td><td>{{item.FullName}}</td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/reports/typeOfInvoiceChart/typeOfInvoiceChart.html','<div class="widgets" ng-controller="TypeOfInvoiceChartPageCtrl"><div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-2" style="text-align: right;"><label class="control-label">N\u0103m</label></div><div class="col-sm-3"><ui-select ng-model="Year.selected" ng-change="selectedYear(Year.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="Year in Years | filter: $select.search"><span ng-bind-html="Year.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="S\u1ED1 h\xF3a \u0111\u01A1n trong n\u0103m {{thisYear}}" ba-panel-class="with-scroll"><div id="chartdivInvoice" style="height: 40vh !important" ng-controller="TypeOfInvoiceChartPageCtrl"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Doanh thu trong n\u0103m {{thisYear}}" ba-panel-class="with-scroll"><div id="chartdivRevenue" style="height: 40vh !important" ng-controller="TypeOfInvoiceChartPageCtrl"></div></div></div></div></div>');
$templateCache.put('app/pages/reports/statisticChart/statisticChart.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="StatisticChartPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-2" style="text-align: right;"><label class="control-label">N\u0103m</label></div><div class="col-sm-3"><ui-select ng-model="Year.selected" ng-change="selectedYear(Year.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="Year in Years | filter: $select.search"><span ng-bind-html="Year.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.reports"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><section><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="S\u1ED1 h\xF3a \u0111\u01A1n trong n\u0103m {{ctrl.thisYear}}" ba-panel-class="with-scroll"><canvas id="bar" style="height: 50vh !important" class="chart chart-bar" chart-data="yearData" chart-labels="yearLabels" chart-series="yearSeries" chart-colors="yearColors" chart-options="yearOptions" chart-dataset-override="DataSetOverride"></canvas></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Doanh thu trong n\u0103m {{ctrl.thisYear}} (t\u1EF7 \u0111\u1ED3ng)" ba-panel-class="with-scroll"><canvas id="bar" style="height: 50vh !important" class="chart chart-bar" chart-data="totalData" chart-labels="totalLabels" chart-series="totalSeries" chart-colors="totalColors" chart-options="totalOptions" chart-dataset-override="DataSetOverride"></canvas></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="Doanh thu t\u0103ng tr\u01B0\u1EDFng so v\u1EDBi c\xF9ng k\u1EF3 (t\u1EF7 \u0111\u1ED3ng)" ba-panel-class="with-scroll"><canvas id="bar" style="height: 50vh !important" class="chart chart-bar" chart-data="statYearData" chart-labels="statYearLabels" chart-series="statYearSeries" chart-colors="statYearColors" chart-options="statYearOptions" chart-dataset-override="DataSetOverride"></canvas></div></div></div></section></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/grantPermission/grantPermission.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-7" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><table class="table table-striped"><thead><tr><td style="width:20%"></td><td style="text-align:center; width:10%" ng-repeat="item in Roles">{{item.Name}}</td></tr></thead><tbody><tr ng-repeat="menu in Menus"><td style="text-align:left;">{{menu.title}}</td><td style="text-align:center; width:6%" ng-repeat="role in Roles"><div><label class="custom-checkbox"><input type="checkbox" ng-model="checkbox" ng-checked="menu.Roles[role.No].isHas" ng-click="checkPermission(menu.name, role.ID, checkbox)"> <span>&nbsp;</span></label></div></td></tr></tbody></table></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button></div></div></div>');
$templateCache.put('app/pages/lists/unit/createUnit.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUnitId" class="control-label">M\xE3 \u0111\u01A1n v\u1ECB t\xEDnh (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input ngmaxlength="10" type="text" class="form-control" ng-model="inputUnitId" id="inputUnitId" placeholder="M\xE3 \u0111\u01A1n v\u1ECB t\xEDnh"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUnitName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB t\xEDnh (<b style="color:red;">*</b>)</label></div><div class="col-sm-8"><input type="text" class="form-control" ng-model="inputUnitName" id="inputUnitName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB t\xEDnh"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDescription" class="control-label">Ghi ch\xFA</label></div><div class="col-sm-8"><textarea placeholder="Ghi ch\xFA" class="form-control" ng-model="inputDescription" id="inputDescription"></textarea></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-8"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.unit"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/lists/unit/unit.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Qu\u1EA3n l\xFD th\xF4ng tin \u0111\u01A1n v\u1ECB t\xEDnh"><div class="panel-content" ng-controller="UnitPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" name="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" name="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputUnitId" class="control-label">M\xE3 \u0111\u01A1n v\u1ECB t\xEDnh</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputUnitId" id="inputUnitId" placeholder="M\xE3 \u0111\u01A1n v\u1ECB t\xEDnh"></div><div class="col-sm-2" style="text-align: right;"><label for="inputUnitName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB t\xEDnh</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputUnitName" id="inputUnitName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB t\xEDnh"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ui-sref="main.createUnit"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.lists"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="unitId">M\xE3 \u0111\u01A1n v\u1ECB t\xEDnh</th><th st-sort="unitName">T\xEAn \u0111\u01A1n v\u1ECB t\xEDnh</th><td>Ghi ch\xFA</td><th st-sort="dateUpdated">Ng\xE0y c\u1EADp nh\u1EADt</th><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createUnit\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.unitId}}</td><td>{{item.unitName}}</td><td>{{item.description}}</td><td>{{item.dateUpdated}}</td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/systemManagement/organization/createOrganization.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-inline"><div class="row form-inline"><div class="form-group col-sm-2"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-2"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="form-group col-sm-2"><label for="inputTaxAuthority" id="inputTaxAuthority" class="control-label">Ch\u1ECDn c\u01A1 quan thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-3" ng-controller="SelectTaxAuthorityPageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TaxAuthority.selected" ng-change="selectChanged(TaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="TaxAuthority in TaxAuthorities | filter: $select.search"><span ng-bind-html="TaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-3"><ui-select focus-on="SetFocus" ng-model="ChildTaxAuthority.selected" ng-change="selectChangedChild(ChildTaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="ChildTaxAuthority in ChildTaxAuthorities | filter: $select.search"><span ng-bind-html="ChildTaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><br><div class="row form-inline"><div class="form-group col-sm-2"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-5"><input type="text" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="form-group col-sm-2"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="form-group col-sm-2"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone"></div></div><br><div class="row form-inline"><div class="form-group col-sm-2"><label for="inputBusinessNameEN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB ti\u1EBFng Anh</label></div><div class="form-group col-sm-5"><input type="text" class="form-control" ng-model="inputBusinessNameEN" id="inputBusinessNameEN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB ti\u1EBFng Anh"></div><div class="form-group col-sm-2"><label for="inputFax" class="control-label">Fax</label></div><div class="form-group col-sm-2"><input type="text" class="form-control" ng-model="inputFax" id="inputFax"></div></div><br><div class="row form-inline"><div class="form-group col-sm-2"><label for="inputAddressVN" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-9"><input type="text" class="form-control" ng-model="inputAddressVN" id="inputAddressVN" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div><br><div class="row form-inline"><div class="form-group col-sm-2"><label for="inputAddressEN" class="control-label">\u0110\u1ECBa ch\u1EC9 ti\u1EBFng Anh</label></div><div class="form-group col-sm-9"><input type="text" class="form-control" ng-model="inputAddressEN" id="inputAddressEN" placeholder="\u0110\u1ECBa ch\u1EC9 ti\u1EBFng Anh"></div></div><br><div class="row form-inline"><div class="col-md-8"><div class="row form-inline"><div class="form-group col-sm-3"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-8"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div><br><div class="row form-inline"><div class="form-group col-sm-3"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7 (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-8"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div></div><br><div class="row form-inline"><div class="form-group col-sm-3"><label for="inputOwner" class="control-label">Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt (<b style="color:red;">*</b>)</label></div><div class="form-group col-sm-8"><input type="text" class="form-control" ng-model="inputOwner" id="inputOwner" placeholder="Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt"></div></div><br><div class="row form-inline"><div class="form-group col-sm-3"><label for="inputBankAccount" class="control-label">S\u1ED1 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng</label></div><div class="form-group col-sm-8"><input type="text" class="form-control" ng-model="inputBankAccount" id="inputBankAccount" placeholder="S\u1ED1 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng"></div></div><br><div class="row form-inline"><div class="form-group col-sm-3"><label for="inputBankName" class="control-label">T\xEAn ng\xE2n h\xE0ng</label></div><div class="form-group col-sm-8"><input type="text" class="form-control" ng-model="inputBankName" id="inputBankName" placeholder="T\xEAn ng\xE2n h\xE0ng"></div></div></div><div class="col-md-4"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><a href="" class="change-userpic" ng-click="uploadPicture()">Ch\u1ECDn Logo \u0111\u1EC3 thay \u0111\u1ED5i</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div><div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActiveLogo" ng-model="inputIsActiveLogo" ng-checked="checkStatus==\'Y\'"> <span>S\u1EED d\u1EE5ng Logo</span></label></div></div></div></div><div style="text-align: center !important;"><button type="button" ng-disabled="IsDisabled" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" ng-disabled="IsDisabled" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/organization\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/organization/manageLicense.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-5" style="text-align: right;"><label for="inputLicense" class="control-label">S\u1ED1 license (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" format="" ng-model="inputLicense" id="inputLicense" placeholder="S\u1ED1 license"></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/organization\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/organization/organization.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="OrganizationPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterpriseName" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEnterpriseName" id="inputEnterpriseName" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div><div class="col-sm-2" style="text-align: right;"><label for="inputPhone" class="control-label">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left; padding-left: 15px;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createOrganization\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="customerName">T\xEAn \u0111\u01A1n v\u1ECB</th><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="contactPerson">Ng\u01B0\u1EDDi li\xEAn h\u1EC7</th><td>\u0110i\u1EC7n tho\u1EA1i</td><th st-sort="dateUpdated">Ng\xE0y t\u1EA1o</th><td style="text-align: center;">License</td><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createOrganization\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.enterpriseNameVN}}</td><td>{{item.taxCode}}</td><td>{{item.contactPerson}}</td><td>{{item.phone}}</td><td>{{item.dateCreated}}</td><td style="text-align: center;"><a title="C\u1EA5p quy\u1EC1n s\u1EED d\u1EE5ng" class="btn btn-default btn-xs" href="" ng-click="open(\'#/manageLicense\', item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-wrench"></span></a></td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/systemManagement/roles/createRole.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-3" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-7" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocus" ng-model="Enterprise.selected" ng-change="selectChanged(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputRoleName" class="control-label">T\xEAn nh\xF3m ng\u01B0\u1EDDi d\xF9ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-7"><input type="text" class="form-control" ng-model="inputRoleName" id="inputRoleName" placeholder="T\xEAn nh\xF3m ng\u01B0\u1EDDi d\xF9ng"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputIsActive" ng-model="inputIsActive" ng-checked="checkStatus==\'Y\'"> <span>&nbsp;</span></label></div></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/roles\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/roles/manageRole.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Th\xEAm nh\xF3m ng\u01B0\u1EDDi d\xF9ng v\xE0o ng\u01B0\u1EDDi d\xF9ng"><div class="panel-content" ng-controller="ManageRolePageCtrl as ctrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputRoleName" class="control-label">Nh\xF3m ng\u01B0\u1EDDi d\xF9ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="Role.selected" ng-change="selectChanged(Role.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="Role in Roles | filter: $select.search"><span ng-bind-html="Role.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="horizontal-scroll"><table class="table table-striped"><tbody><tr ng-repeat="item in displayedCollection"><td style="width:25%;">{{$index + 1}}</td><td style="width:40%;">{{item.Name}}</td><td><a class="btn btn-danger btn-xs" href="" ng-click="removeRole(item)"><span class="glyphicon glyphicon-remove"></span></a></td></tr></tbody></table></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/users\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/roles/roles.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="RolePageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-3" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-7" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputRoleName" class="control-label">T\xEAn nh\xF3m ng\u01B0\u1EDDi d\xF9ng</label></div><div class="col-sm-7"><input type="text" class="form-control" ng-model="inputRoleName" id="inputRoleName" placeholder="T\xEAn nh\xF3m ng\u01B0\u1EDDi d\xF9ng"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputIsActive" class="control-label">S\u1EED d\u1EE5ng</label></div><div class="col-sm-3" style="text-align: left; padding-left: 15px;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioIsActiveAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveTrue"> <span>C\xF3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioIsActiveFalse"> <span>Kh\xF4ng</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createRole\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="roleName">T\xEAn nh\xF3m ng\u01B0\u1EDDi d\xF9ng</th><td style="text-align: center;">Ph\xE2n quy\u1EC1n</td><td style="text-align: center;">S\u1EED d\u1EE5ng</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createRole\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.Name}}</td><td style="text-align: center;"><a title="Th\xEAm ng\u01B0\u1EDDi d\xF9ng v\xE0o nh\xF3m" class="btn btn-default btn-xs" href="" ng-click="open(\'#/manageUser\',item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-wrench"></span></a></td><td style="text-align: center;"><div ng-if="checkShow(item.isActive) == 0"><a title="K\xEDch ho\u1EA1t th\xF4ng tin" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div><div ng-if="checkShow(item.isActive) == 1"><a title="Ng\u1EEBng s\u1EED d\u1EE5ng th\xF4ng tin" class="btn btn-success btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/systemManagement/configSystem/configSystem.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}" ng-controller="ConfigSystemCtrl as ctrl"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-5" style="text-align: right;"><label for="inputPassword" class="control-label">M\u1EADt kh\u1EA9u (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><div class="input-group"><input type="{{inputType}}" class="form-control" id="inputPassword" ng-model="inputPassword" placeholder="M\u1EADt kh\u1EA9u"> <span class="input-group-addon input-group-addon-default addon-right"><span class="{{showHideClass}}" ng-click="showPassword()" style="cursor:pointer"></span></span></div></div></div><div class="form-group"><div class="col-sm-5" style="text-align: right;"><label class="control-label">M\u1EADt kh\u1EA9u \u0111\xE3 m\xE3 h\xF3a</label></div><div class="col-sm-2"><label class="control-label" style="color: yellow;">{{PasswordReturn}}</label></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/users/createUser.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{PageTitle}}"><div class="panel-content"><div class="form-horizontal"><div class="form-group" ng-show="isShow"><div class="col-sm-3" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-7" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select focus-on="SetFocusEnt" ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputFullName" class="control-label">T\xEAn ng\u01B0\u1EDDi d\xF9ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-7"><input type="text" class="form-control" ng-model="inputFullName" id="inputFullName" placeholder="T\xEAn ng\u01B0\u1EDDi d\xF9ng"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-7"><input type="email" ng-disabled="{{flagEdit}}" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputUsername" class="control-label">Username (<b style="color:red;">*</b>)</label></div><div class="col-sm-7"><input type="text" ng-disabled="{{flagEdit}}" class="form-control" ng-model="inputUsername" id="inputUsername" placeholder="Username"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputPassword" class="control-label">M\u1EADt kh\u1EA9u (<b style="color:red;">*</b>)</label></div><div class="col-sm-7"><input type="password" class="form-control" ng-model="inputPassword" id="inputPassword" placeholder="M\u1EADt kh\u1EA9u"></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputBirthday" class="control-label">N\u0103m sinh</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputBirthday" id="inputBirthday" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110i\u1EC7n tho\u1EA1i</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/users\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/users/manageUser.html','<div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Th\xEAm ng\u01B0\u1EDDi d\xF9ng v\xE0o nh\xF3m ng\u01B0\u1EDDi d\xF9ng"><div class="panel-content" ng-controller="ManageUserPageCtrl as ctrl"><div class="form-horizontal"><div class="form-group"><div class="col-sm-3" style="text-align: right;"><label for="inputUserName" class="control-label">Ng\u01B0\u1EDDi d\xF9ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="User.selected" ng-change="selectChanged(User.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.FullName}}</ui-select-match><ui-select-choices repeat="User in Users | filter: $select.search"><span ng-bind-html="User.FullName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="horizontal-scroll"><table class="table table-striped"><tbody><tr ng-repeat="item in displayedCollection"><td style="width:25%;">{{$index + 1}}</td><td style="width:40%;">{{item.FullName}}</td><td><a class="btn btn-danger btn-xs" href="" ng-click="removeUser(item)"><span class="glyphicon glyphicon-remove"></span></a></td></tr></tbody></table></div><div style="text-align: center !important;"><button type="submit" ng-click="save()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>\u0110\u1ED3ng \xFD</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ng-click="open(\'#/roles\')"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/systemManagement/users/users.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="UserPageCtrl as ctrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputFullName" class="control-label">T\xEAn ng\u01B0\u1EDDi d\xF9ng</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputFullName" id="inputFullName" placeholder="T\xEAn ng\u01B0\u1EDDi d\xF9ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputEmail" class="control-label">Email</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputRole" class="control-label">Nh\xF3m ng\u01B0\u1EDDi d\xF9ng</label></div><div class="col-sm-3"><ui-select ng-model="Role.selected" ng-change="selectChanged(Role.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="Role in Roles | filter: $select.search"><span ng-bind-html="Role.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputIsActive" class="control-label">Kh\xF3a?</label></div><div class="col-sm-3" style="text-align: left; padding-left: 15px;"><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" checked="" id="radioLockoutEnabledAll"> <span>T\u1EA5t c\u1EA3</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioLockoutEnabledFalse"> <span>Kh\xF4ng</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="radioLockoutEnabledTrue"> <span>C\xF3</span></label></div></div></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="open(\'#/createUser\')"><i class="ion-plus-round"></i>Th\xEAm m\u1EDBi</button> <button type="button" ng-click="findData()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>T\xECm ki\u1EBFm</button> <button type="button" class="btn btn-info btn-with-icon save-profile"><i class="ion-log-in"></i>Xu\u1EA5t Excel</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="displayedCollection" st-safe-src="ctrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><td></td><th st-sort="FullName">T\xEAn ng\u01B0\u1EDDi d\xF9ng</th><th st-sort="Email">Email</th><td style="text-align: center;">Ph\xE2n quy\u1EC1n</td><td style="text-align: center;">\u0110\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u</td><td style="text-align: center;">Kh\xF3a?</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td class="text-center"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="open(\'#/createUser\',item.ID)"><span class="glyphicon glyphicon-pencil"></span></a></td><td>{{item.FullName}}</td><td>{{item.Email}}</td><td style="text-align: center;"><a title="Ph\xE2n quy\u1EC1n ng\u01B0\u1EDDi d\xF9ng" class="btn btn-default btn-xs" href="" ng-click="open(\'#/manageRole\',item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-wrench"></span></a></td><td style="text-align: center;"><a title="\u0110\u1EB7t l\u1EA1i m\u1EADt kh\u1EA9u" class="btn btn-warning btn-xs" href="" ng-click="resetPassword(item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-refresh"></span></a></td><td style="text-align: center;"><div ng-if="checkShow(item.LockoutEnabled) == 1"><a title="K\xEDch ho\u1EA1t ng\u01B0\u1EDDi d\xF9ng" class="btn btn-danger btn-xs" href="" ng-click="updateStatus(false, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-checkmark-round"></span></a></div><div ng-if="checkShow(item.LockoutEnabled) == 0"><a title="Kh\xF3a ng\u01B0\u1EDDi d\xF9ng" class="btn btn-success btn-xs" href="" ng-click="updateStatus(true, item.ID)"><span ng-class="myDynamicClass" id="iconStatus" class="ion-close-round"></span></a></div></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/QD1450/Message106/Message106.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthority" class="control-label" id="inputTaxAuthority">C\u01A1 quan Thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectTaxAuthorityPageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TaxAuthority.selected" ng-change="selectChanged(TaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="TaxAuthority in TaxAuthorities | filter: $select.search"><span ng-bind-html="TaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputChildTaxAuthorityChild" class="control-label">Chi c\u1EE5c (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><ui-select focus-on="SetFocus" ng-model="ChildTaxAuthority.selected" ng-change="selectChangedChild(ChildTaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="ChildTaxAuthority in ChildTaxAuthorities | filter: $select.search"><span ng-bind-html="ChildTaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" readonly="" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputAddressVN" class="control-label">\u0110\u1ECBa ch\u1EC9 (<b style="color:red;">*</b>)</label></div><div class="col-sm-10"><input type="text" class="form-control" ng-model="inputAddressVN" id="inputAddressVN" placeholder="\u0110\u1ECBa ch\u1EC9"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div><div class="col-sm-1" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div><div class="col-sm-1" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110. Tho\u1EA1i (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputGPKD" class="control-label">S\u1ED1 Q\u0110 th\xE0nh l\u1EADp</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputGPKD" id="inputGPKD" placeholder="S\u1ED1 Q\u0110 th\xE0nh l\u1EADp"></div><div class="col-sm-2" style="text-align: right;"><label for="inputNgayThanhLap" class="control-label">Ng\xE0y Q\u0110 th\xE0nh l\u1EADp (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputNgayThanhLap" id="inputNgayThanhLap" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCQCQDTLap" class="control-label">C\u01A1 quan c\u1EA5p Q\u0110</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputCQCQDTLap" id="inputCQCQDTLap" placeholder="C\u01A1 quan c\u1EA5p Q\u0110"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTNNHDon" class="control-label">T\xEAn ng\u01B0\u1EDDi nh\u1EADn H\u0110</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTNNHDon" id="inputTNNHDon" placeholder="T\xEAn ng\u01B0\u1EDDi nh\u1EADn H\u0110"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputCMND" class="control-label">S\u1ED1 CMND</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputCMND" id="inputCMND" placeholder="S\u1ED1 CMND"></div><div class="col-sm-2" style="text-align: right;"><label for="inputNgCCMND" class="control-label">Ng\xE0y c\u1EA5p</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputNgCCMND" id="inputNgCCMND" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputNCCMND" class="control-label">N\u01A1i c\u1EA5p</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputNCCMND" id="inputNCCMND" placeholder="N\u01A1i c\u1EA5p"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputNDDNghi" class="control-label">N\u1ED9i dung \u0111\u1EC1 ngh\u1ECB</label></div><div class="col-md-offset-5 col-sm-2" style="text-align: right;"><label for="inputLoaiHoaDon" class="control-label">Lo\u1EA1i h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><ui-select focus-on="SetFocus" ng-model="LoaiHoaDon.selected" ng-change="changeLoaiHoaDon(LoaiHoaDon.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="LoaiHoaDon in LoaiHoaDons | filter: $select.search"><span ng-bind-html="LoaiHoaDon.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTHHDVu" class="control-label">T\xEAn HH D\u1ECBch v\u1EE5 (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputTHHDVu" id="inputTHHDVu" placeholder="T\xEAn HH D\u1ECBch v\u1EE5"></div><div class="col-sm-2" style="text-align: right;"><label for="inputTenNMua" class="control-label">T\xEAn ng\u01B0\u1EDDi mua (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputTenNMua" id="inputTenNMua" placeholder="T\xEAn ng\u01B0\u1EDDi mua"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputDChiMua" class="control-label">\u0110\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi mua (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" class="form-control" ng-model="inputDChiMua" id="inputDChiMua" placeholder="\u0110\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi mua"></div><div class="col-sm-2" style="text-align: right;"><label for="inputMSTMua" class="control-label">M\xE3 s\u1ED1 thu\u1EBF</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputMSTMua" id="inputMSTMua" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div></div></div></div><div class="row"><div class="col-sm-11"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputSoHDong" class="control-label">S\u1ED1 h\u1EE3p \u0111\u1ED3ng</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputSoHDong" id="inputSoHDong" placeholder="S\u1ED1 h\u1EE3p \u0111\u1ED3ng"></div><div class="col-sm-2" style="text-align: right;"><label for="inputNgHDong" class="control-label">Ng\xE0y h\u1EE3p \u0111\u1ED3ng</label></div><div class="col-sm-2" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" ng-model="inputNgHDong" id="inputNgHDong" readonly="" style="font-size: 13px;" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputDoanhThu" class="control-label">Doanh thu (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" format="" ng-model="inputDoanhThu" id="inputDoanhThu" placeholder="Doanh thu"></div></div></div></div><div class="row"><div class="col-sm-11" style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="save()"><i class="ion-android-checkmark-circle"></i>L\u01B0u th\xF4ng tin</button> <button type="button" class="btn btn-warning btn-with-icon save-profile" ng-click="sendCQT()"><i class="ion-forward"></i>G\u1EEDi c\u01A1 quan Thu\u1EBF</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.QD1450"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/QD1450/Receive102103/Receive102103.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="Receive102103Ctrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">Lo\u1EA1i th\xF4ng \u0111i\u1EC7p</label></div><div class="col-sm-3" ng-controller="SelectStatusByApprovedPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChangedStatus(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputStatus" class="control-label">T\xECnh tr\u1EA1ng</label></div><div class="col-sm-3" ng-controller="SelectStatusByApprovedPageCtrl as ctrlSelect"><ui-select ng-model="Status.selected" ng-change="selectChangedStatus(Status.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.statusName}}</ui-select-match><ui-select-choices repeat="Status in Statuses | filter: $select.search"><span ng-bind-html="Status.statusName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div style="text-align: center !important;"><button type="button" title="T\xECm ki\u1EBFm h\xF3a \u0111\u01A1n theo \u0111i\u1EC1u ki\u1EC7n l\u1ECDc \u1EDF tr\xEAn!" ng-click="getMessage()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>Nh\u1EADn k\u1EBFt qu\u1EA3</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="companyName">T\xEAn \u0111\u01A1n v\u1ECB</th><th st-sort="address">\u0110\u1ECBa ch\u1EC9</th><th st-sort="typeOfMessage">Lo\u1EA1i th\xF4ng \u0111i\u1EC7p</th><td>T\xECnh tr\u1EA1ng</td><td>Ng\xE0y nh\u1EADn</td><td class="text-center">File chi ti\u1EBFt</td></tr></thead><tbody><tr><td>1</td><td>0311928954</td><td>C\xF4ng ty C\u1ED5 ph\u1EA7n C\xF4ng ngh\u1EC7 VietInfo</td><td>32 X\xF4 vi\u1EBFt ngh\u1EC7 t\u0129nh, Ph\u01B0\u1EDDng 19, Qu\u1EADn B\xECnh Th\u1EA1nh, TPHCM</td><td>100</td><td>\u0110\xE3 ti\u1EBFp nh\u1EADn</td><td>06/12/2021</td><td class="text-center"><a href="{{pathFileInvoice + item.fileInvoiceXML}}" target="_blank" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/QD1450/Message100/Message100.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="Message100Ctrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><label><span style="color:yellow">(L\u01B0u \xFD: c\u1EA7n ph\u1EA3i ki\u1EC3m tra USB Token \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EAFn v\xE0o m\xE1y v\xE0 ch\u1EA1y Service k\xFD s\u1ED1 m\u1EDBi nh\u1EA5t theo TT78, n\u1EBFu ch\u01B0a c\xF3 vui l\xF2ng nh\u1EA5n v\xE0o n\xFAt "Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1" \u0111\u1EC3 t\u1EA3i v\u1EC1!!!)</span></label></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="registerInvoice()"><i class="ion-plus-round"></i>\u0110\u0103ng k\xFD</button><button type="button" title="T\u1EA3i ph\u1EA7n m\u1EC1m k\xFD s\u1ED1 h\xF3a \u0111\u01A1n!" ng-click="getSignature()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-log-in"></i>Ph\u1EA7n m\u1EC1m k\xFD s\u1ED1</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;"></td><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="companyName">T\xEAn \u0111\u01A1n v\u1ECB</th><th st-sort="address">\u0110\u1ECBa ch\u1EC9</th><th st-sort="typeOfMessage">Lo\u1EA1i th\xF4ng \u0111i\u1EC7p</th><td>T\xECnh tr\u1EA1ng</td><td>Ng\xE0y nh\u1EADn</td><td>Nh\u1EADn KQ</td><td class="text-center">File chi ti\u1EBFt</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td class="text-center"><div ng-if="item.MaTinhTrang != \'DUYET\'"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="editRegisterInvoice(item.LTD100Id)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.TaxCode}}</td><td>{{item.enterpriseNameVN}}</td><td>{{item.addressVN}}</td><td>{{item.TypeOfMessage}}</td><td>{{item.TenTinhTrang}}</td><td>{{item.DateCreated}}</td><td class="text-center"><div ng-if="(item.MaTinhTrang == \'CHOKETQUA\' || item.MaTinhTrang == \'DATIEPNHAN\')"><a href="" ng-disabled="OpenFile" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep, item.MaTinhTrang)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div></td><td class="text-center"><a ng-show="item.FileXML != \'\'" ng-disabled="OpenFile" href="" ng-click="GetFileXML(item.FileXML)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/QD1450/Message100/RegisterInvoice.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-2" style="text-align: right;"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><input type="text" readonly="" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthority" class="control-label" id="inputTaxAuthority">C\u01A1 quan Thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectTaxAuthorityPageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TaxAuthority.selected" ng-change="selectChanged(TaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="TaxAuthority in TaxAuthorities | filter: $select.search"><span ng-bind-html="TaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputChildTaxAuthorityChild" class="control-label">Chi c\u1EE5c (<b style="color:red;">*</b>)</label></div><div class="col-sm-5"><ui-select focus-on="SetFocus" ng-model="ChildTaxAuthority.selected" ng-change="selectChangedChild(ChildTaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="ChildTaxAuthority in ChildTaxAuthorities | filter: $select.search"><span ng-bind-html="ChildTaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="TNDDPLuat" class="control-label">T\xEAn ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="TNDDPLuat" id="TNDDPLuat" placeholder="T\xEAn ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt"></div><div class="col-sm-1" style="text-align: right;"><label for="CCCDan" class="control-label">CCCDan</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="CCCDan" id="CCCDan" placeholder="CCCDan"></div><div class="col-sm-1" style="text-align: right;"><label for="DTDDPLuat" class="control-label">\u0110.tho\u1EA1i N\u0110Di\u1EC7n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="DTDDPLuat" id="DTDDPLuat" placeholder="\u0110i\u1EC7n tho\u1EA1i ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ph\xE1p lu\u1EADt"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="SHChieu" class="control-label">S\u1ED1 h\u1ED9 chi\u1EBFu</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="SHChieu" id="SHChieu" placeholder="S\u1ED1 h\u1ED9 chi\u1EBFu"></div><div class="col-sm-1" style="text-align: right;"><label for="NSDDPLuat" class="control-label">Ng\xE0y sinh N\u0110Di\u1EC7n (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="datepickerpopupCtrl"><p class="input-group"><input type="text" id="NSDDPLuat" ng-model="NSDDPLuat" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-1" style="text-align: right;"><label for="GTinh" class="control-label">Gi\u1EDBi t\xEDnh(<b style="color:red;">*</b>)</label></div><div class="col-sm-2" style="margin-top: 0.5rem;"><input type="radio" ng-model="GTinh" value="NAM" ng-change="onGenderChange(\'NAM\')"> Nam <input type="radio" ng-model="GTinh" value="NU" ng-change="onGenderChange(\'NU\')"> N\u1EEF</div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div><div class="col-sm-1" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div><div class="col-sm-1" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110. Tho\u1EA1i (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputHThucDKy" class="control-label">H\xECnh th\u1EE9c \u0111\u0103ng k\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><ui-select focus-on="SetFocus" ng-model="HThucDKy.selected" ng-change="changeHThucDKy(HThucDKy.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HThucDKy in HThucDKys | filter: $select.search"><span ng-bind-html="HThucDKy.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="inputHTHDon" class="control-label">H\xECnh th\u1EE9c h\xF3a \u0111\u01A1n (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHTHDonCoMa" ng-model="inputHTHDonCoMa"> <span style="font-weight: 500;">C\xF3 m\xE3</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHTHDonKhongMa" ng-model="inputHTHDonKhongMa"> <span style="font-weight: 500;">Kh\xF4ng m\xE3</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" name="radiobox" id="inputHTHDonCoMaMTT" ng-model="inputHTHDonCoMaMTT"> <span style="font-weight: 500;">C\xF3 m\xE3 t\u1EEB m\xE1y t\xEDnh ti\u1EC1n</span></label></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPThuc" class="control-label">P. Th\u1EE9c chuy\u1EC3n DL (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputCDDu" ng-model="inputCDDu"> <span style="font-weight: 500;">Chuy\u1EC3n \u0111\u1EA7y \u0111\u1EE7</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputCBTHop" ng-model="inputCBTHop"> <span style="font-weight: 500;">Chuy\u1EC3n b\u1EA3ng t\u1ED5ng h\u1EE3p</span></label></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputLHDSDung" class="control-label">Lo\u1EA1i H\u0110 s\u1EED d\u1EE5ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHDGTGT" ng-model="inputHDGTGT"> <span style="font-weight: 500;">H\xF3a \u0111\u01A1n GTGT</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHDBHang" ng-model="inputHDBHang"> <span style="font-weight: 500;">H\xF3a \u0111\u01A1n b\xE1n h\xE0ng</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHDBTSCong" ng-model="inputHDBTSCong"> <span style="font-weight: 500;">H\u0110 b\xE1n t\xE0i s\u1EA3n c\xF4ng</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHDBHDTQGia" ng-model="inputHDBHDTQGia"> <span style="font-weight: 500;">H\u0110 b\xE1n h\xE0ng d\u1EF1 tr\u1EEF Qu\u1ED1c gia</span></label></div></div><div class="col-sm-1"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputHDKhac" ng-model="inputHDKhac"> <span style="font-weight: 500;">H\u0110 kh\xE1c</span></label></div></div><div class="col-sm-1"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="inputCTu" ng-model="inputCTu"> <span style="font-weight: 500;">Ch\u1EE9ng t\u1EEB</span></label></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="HDGTGTTHBLai" ng-model="HDGTGTTHBLai"> <span style="font-weight: 500;">H\xF3a \u0111\u01A1n GTGT t\xEDch h\u1EE3p bi\xEAn lai thu thu\u1EBF, ph\xED, l\u1EC7 ph\xED</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="HDBHTHBLai" ng-model="HDBHTHBLai"> <span style="font-weight: 500;">H\xF3a \u0111\u01A1n b\xE1n h\xE0ng t\xEDch h\u1EE3p bi\xEAn lai thu thu\u1EBF, ph\xED, l\u1EC7 ph\xED</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="HDTMai" ng-model="HDTMai"> <span style="font-weight: 500;">H\xF3a \u0111\u01A1n th\u01B0\u01A1ng m\u1EA1i</span></label></div></div></div></div><div class="row"><div class="col-sm-11" style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-show="isSave" ng-click="save()"><i class="ion-android-checkmark-circle"></i>L\u01B0u th\xF4ng tin</button> <button type="button" ng-show="isAlerted" class="btn btn-warning btn-with-icon save-profile" ng-click="sendCQT()"><i class="ion-forward"></i>N\u1ED9p t\u1EDD khai</button><button type="button" ng-show="isAlerted" ng-click="printRegister()" class="btn btn-info btn-with-icon save-profile"><i class="ion-clipboard"></i>Xem tr\u01B0\u1EDBc</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.Message100"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/QD1450/SendReceiveLog/SendReceiveLog.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="SendReceiveLogCtrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ng-controller="datepickerpopupCtrl"><div class="col-sm-2" style="text-align: right;"><label for="inputFromDate" class="control-label">T\u1EEB ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" id="inputFromDate" ng-change="checkFromToDate()" ng-model="inputFromDate" readonly="" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(true)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-sm-2" style="text-align: right;"><label for="inputToDate" class="control-label">\u0110\u1EBFn ng\xE0y</label></div><div class="col-sm-3"><p class="input-group"><input type="text" readonly="" id="inputToDate" ng-change="checkFromToDate()" ng-model="inputToDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" datepicker-options="options" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open(false)"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div style="text-align: center !important;"><button type="button" title="Xem nh\u1EADt k\xFD!" ng-click="getLogs()" class="btn btn-success btn-with-icon save-profile"><i class="ion-search"></i>Xem nh\u1EADt k\xFD</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;">#</td><th st-sort="MaLoaiThongDiep">Lo\u1EA1i th\xF4ng \u0111i\u1EC7p</th><th st-sort="SenderCode">N\u01A1i g\u1EEDi</th><th st-sort="ReceiverCode">N\u01A1i nh\u1EADn</th><td>Ng\xE0y g\u1EEDi</td><td>TCTN</td><td class="text-center">File chi ti\u1EBFt</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td>{{item.No}}</td><td>{{item.MaLoaiThongDiep}}</td><td>{{item.SenderCode}}</td><td>{{item.ReceiverCode}}</td><td>{{item.DateLog}}</td><td>{{item.TCTN}}</td><td class="text-center"><a ng-show="item.FileXML != \'\'" ng-disabled="OpenFile" href="" ng-click="GetFileXML(item.FileXML)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/QD1450/Message109/Message109.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-controller="Message109Ctrl as mainCtrl"><div class="form-horizontal" style="text-align: center !important;"><div class="form-group" ng-show="isShow"><div class="col-sm-2" style="text-align: right;"><label for="inputEnterprise" class="control-label">\u0110\u01A1n v\u1ECB</label></div><div class="col-sm-8" ng-controller="SelectEnterprisePageCtrl as EnterpriseCtrl"><ui-select ng-model="Enterprise.selected" ng-change="changeOrganization(Enterprise.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.enterpriseNameVN}}</ui-select-match><ui-select-choices repeat="Enterprise in Enterprises | filter: $select.search"><span ng-bind-html="Enterprise.enterpriseNameVN | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="registerInvoice()"><i class="ion-plus-round"></i>\u0110\u0103ng k\xFD</button></div><div class="horizontal-scroll"><div class="form-group"><div class="col-sm-5 form-group select-page-size-wrap"><label>S\u1ED1 d\xF2ng hi\u1EC3n th\u1ECB</label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [10,20,30,40,50]"></select></div></div><table st-table="displayedCollection" st-safe-src="mainCtrl.rowCollection" class="table table-striped"><thead><tr class="sortable"><td style="text-align: center;"></td><th st-sort="taxCode">M\xE3 s\u1ED1 thu\u1EBF</th><th st-sort="companyName">T\xEAn \u0111\u01A1n v\u1ECB</th><th st-sort="address">\u0110\u1ECBa ch\u1EC9</th><th st-sort="typeOfMessage">Lo\u1EA1i th\xF4ng \u0111i\u1EC7p</th><td>T\xECnh tr\u1EA1ng</td><td>Ng\xE0y nh\u1EADn</td><td>Nh\u1EADn KQ</td><td class="text-center">File chi ti\u1EBFt</td></tr></thead><tbody><tr ng-repeat="item in displayedCollection"><td class="text-center"><div ng-if="item.MaTinhTrang != \'DUYET\'"><a title="Ch\u1EC9nh s\u1EEDa th\xF4ng tin" class="btn btn-primary btn-xs" href="" ng-click="editRegisterInvoice(item.LTD109Id)"><span class="glyphicon glyphicon-pencil"></span></a></div></td><td>{{item.TaxCode}}</td><td>{{item.enterpriseNameVN}}</td><td>{{item.addressVN}}</td><td>{{item.TypeOfMessage}}</td><td>{{item.TenTinhTrang}}</td><td>{{item.DateCreated}}</td><td class="text-center"><div ng-if="(item.MaTinhTrang == \'CHOKETQUA\' || item.MaTinhTrang == \'DATIEPNHAN\')"><a href="" title="Nh\u1EADn k\u1EBFt qu\u1EA3 ph\u1EA3n h\u1ED3i t\u1EEB C\u01A1 quan Thu\u1EBF" ng-click="GetResultFromTCT(item.MaThongDiep, item.MaTinhTrang)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-import"></span></a></div></td><td class="text-center"><a ng-show="item.FileXML != \'\'" ng-disabled="OpenFile" href="" ng-click="GetFileXML(item.FileXML)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-eye-open"></span></a></td></tr></tbody><tfoot><tr><td colspan="100" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/QD1450/Message109/RegisterInvoice109.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="form-horizontal"><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxCode" class="control-label">M\xE3 s\u1ED1 thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" readonly="" class="form-control" ng-model="inputTaxCode" id="inputTaxCode" placeholder="M\xE3 s\u1ED1 thu\u1EBF"></div><div class="col-sm-1" style="text-align: right;"><label for="inputBusinessNameVN" class="control-label">T\xEAn \u0111\u01A1n v\u1ECB (<b style="color:red;">*</b>)</label></div><div class="col-sm-6"><input type="text" readonly="" class="form-control" ng-model="inputBusinessNameVN" id="inputBusinessNameVN" placeholder="T\xEAn \u0111\u01A1n v\u1ECB"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputTaxAuthority" class="control-label" id="inputTaxAuthority">C\u01A1 quan Thu\u1EBF (<b style="color:red;">*</b>)</label></div><div class="col-sm-3" ng-controller="SelectTaxAuthorityPageCtrl as ctrlSelect"><ui-select focus-on="SetFocus" ng-model="TaxAuthority.selected" ng-change="selectChanged(TaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="TaxAuthority in TaxAuthorities | filter: $select.search"><span ng-bind-html="TaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-1" style="text-align: right;"><label for="inputChildTaxAuthorityChild" class="control-label">Chi c\u1EE5c (<b style="color:red;">*</b>)</label></div><div class="col-sm-6"><ui-select focus-on="SetFocus" ng-model="ChildTaxAuthority.selected" ng-change="selectChangedChild(ChildTaxAuthority.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.taxAuthorityName}}</ui-select-match><ui-select-choices repeat="ChildTaxAuthority in ChildTaxAuthorities | filter: $select.search"><span ng-bind-html="ChildTaxAuthority.taxAuthorityName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputContactPerson" class="control-label">Ng\u01B0\u1EDDi li\xEAn h\u1EC7 (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputContactPerson" id="inputContactPerson" placeholder="Ng\u01B0\u1EDDi li\xEAn h\u1EC7"></div><div class="col-sm-1" style="text-align: right;"><label for="inputEmail" class="control-label">Email (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><input type="text" class="form-control" ng-model="inputEmail" id="inputEmail" placeholder="Email"></div><div class="col-sm-1" style="text-align: right;"><label for="inputPhone" class="control-label">\u0110. Tho\u1EA1i (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><input type="text" class="form-control" ng-model="inputPhone" id="inputPhone" placeholder="\u0110i\u1EC7n tho\u1EA1i"></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputHThucDKy" class="control-label">H\xECnh th\u1EE9c \u0111\u0103ng k\xFD (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><ui-select focus-on="SetFocus" ng-model="HThucDKy.selected" ng-change="changeHThucDKy(HThucDKy.selected)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="L\u1EF1a ch\u1ECDn">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="HThucDKy in HThucDKys | filter: $select.search"><span ng-bind-html="HThucDKy.Name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2" style="text-align: right;"><label for="" class="control-label">\u0110\u1ED1i t\u01B0\u1EE3ng ph\xE1t h\xE0nh ch\u1EE9ng t\u1EEB \u0111i\u1EC7n t\u1EED (<b style="color:red;">*</b>)</label></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="TCCNPHanh" ng-model="TCCNPHanh"> <span style="font-weight: 500;">T\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n ph\xE1t h\xE0nh</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CQTPHanh" ng-model="CQTPHanh"> <span style="font-weight: 500;">C\u01A1 quan thu\u1EBF ph\xE1t h\xE0nh</span></label></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputPThuc" class="control-label">P. Th\u1EE9c chuy\u1EC3n DL CT\u0110T(<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CDLQCCQT" ng-model="CDLQCCQT"> <span style="font-weight: 500;">Tr\xEAn C\u1ED5ng th\xF4ng tin \u0111i\u1EC7n t\u1EED c\u1EE7a c\u01A1 quan thu\u1EBF</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CDLQTCTN" ng-model="CDLQTCTN"> <span style="font-weight: 500;">Chuy\u1EC3n d\u1EEF li\u1EC7u qua TCTN</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CDLQTCTNUT" ng-model="CDLQTCTNUT"> <span style="font-weight: 500;">Chuy\u1EC3n d\u1EEF li\u1EC7u qua TCTN \u0111\u01B0\u1EE3c \u1EE7y th\xE1c</span></label></div></div></div><div class="form-group"><div class="col-sm-2" style="text-align: right;"><label for="inputLHDSDung" class="control-label">Lo\u1EA1i CT s\u1EED d\u1EE5ng (<b style="color:red;">*</b>)</label></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CTTNCNhan" ng-model="CTTNCNhan"> <span style="font-weight: 500;">Ch\u1EE9ng t\u1EEB \u0111i\u1EC7n t\u1EED kh\u1EA5u tr\u1EEB thu\u1EBF thu nh\u1EADp c\xE1 nh\xE2n</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="CTKTTTMDTu" ng-model="CTKTTTMDTu"> <span style="font-weight: 500;">Ch\u1EE9ng t\u1EEB kh\u1EA5u tr\u1EEB thu\u1EBF th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="BLTPLPKIn" ng-model="BLTPLPKIn"> <span style="font-weight: 500;">Bi\xEAn lai thu thu\u1EBF, ph\xED, l\u1EC7 ph\xED kh\xF4ng in s\u1EB5n m\u1EC7nh gi\xE1</span></label></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="BLTPLPIn" ng-model="BLTPLPIn"> <span style="font-weight: 500;">Bi\xEAn lai thu thu\u1EBF, ph\xED, l\u1EC7 ph\xED in s\u1EB5n m\u1EC7nh gi\xE1</span></label></div></div><div class="col-sm-3"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="BLTPLPhi" ng-model="BLTPLPhi"> <span style="font-weight: 500;">Bi\xEAn lai thu thu\u1EBF, ph\xED, l\u1EC7 ph\xED</span></label></div></div></div></div><div class="row"><div class="col-sm-11" style="text-align: center !important;"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-show="isSave" ng-click="save()"><i class="ion-android-checkmark-circle"></i>L\u01B0u th\xF4ng tin</button> <button type="button" ng-show="isAlerted" class="btn btn-warning btn-with-icon save-profile" ng-click="sendCQT()"><i class="ion-forward"></i>N\u1ED9p t\u1EDD khai</button> <button type="button" class="btn btn-danger btn-with-icon save-profile" ui-sref="main.ND70.Message109"><i class="ion-reply"></i>Tr\u1EDF v\u1EC1</button></div></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');}]);